
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree61d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree61d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eumjn", function(module, exports) {
$parcel$export(module.exports, "Fragment", () => $a8c52ca0fff03671$export$ffb0004e005737fa, (v) => $a8c52ca0fff03671$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $a8c52ca0fff03671$export$34b9dba7ce09269b, (v) => $a8c52ca0fff03671$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $a8c52ca0fff03671$export$25062201e9e25d76, (v) => $a8c52ca0fff03671$export$25062201e9e25d76 = v);
/** @license React v16.14.0
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $a8c52ca0fff03671$export$ffb0004e005737fa;
var $a8c52ca0fff03671$export$34b9dba7ce09269b;
var $a8c52ca0fff03671$export$25062201e9e25d76;
'use strict';

var $5FkrB = parcelRequire("5FkrB");
var $a8c52ca0fff03671$var$g = 60103;
$a8c52ca0fff03671$export$ffb0004e005737fa = 60107;
if ("function" === typeof Symbol && Symbol.for) {
    var $a8c52ca0fff03671$var$h = Symbol.for;
    $a8c52ca0fff03671$var$g = $a8c52ca0fff03671$var$h("react.element");
    $a8c52ca0fff03671$export$ffb0004e005737fa = $a8c52ca0fff03671$var$h("react.fragment");
}
var $a8c52ca0fff03671$var$m = $5FkrB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $a8c52ca0fff03671$var$n = Object.prototype.hasOwnProperty, $a8c52ca0fff03671$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $a8c52ca0fff03671$var$q(c, a, k) {
    var b, d = {}, e = null, l = null;
    void 0 !== k && (e = "" + k);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (l = a.ref);
    for(b in a)$a8c52ca0fff03671$var$n.call(a, b) && !$a8c52ca0fff03671$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $a8c52ca0fff03671$var$g,
        type: c,
        key: e,
        ref: l,
        props: d,
        _owner: $a8c52ca0fff03671$var$m.current
    };
}
$a8c52ca0fff03671$export$34b9dba7ce09269b = $a8c52ca0fff03671$var$q;
$a8c52ca0fff03671$export$25062201e9e25d76 = $a8c52ca0fff03671$var$q;

});
parcelRegister("5FkrB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("abbvA"));

});
parcelRegister("abbvA", function(module, exports) {
$parcel$export(module.exports, "Children", () => $7693dbd047ade921$export$dca3b0875bd9a954, (v) => $7693dbd047ade921$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $7693dbd047ade921$export$16fa2f45be04daa8, (v) => $7693dbd047ade921$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $7693dbd047ade921$export$ffb0004e005737fa, (v) => $7693dbd047ade921$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $7693dbd047ade921$export$e2c29f18771995cb, (v) => $7693dbd047ade921$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $7693dbd047ade921$export$221d75b3f55bb0bd, (v) => $7693dbd047ade921$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $7693dbd047ade921$export$5f8d39834fd61797, (v) => $7693dbd047ade921$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $7693dbd047ade921$export$74bf444e3cd11ea5, (v) => $7693dbd047ade921$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $7693dbd047ade921$export$ae55be85d98224ed, (v) => $7693dbd047ade921$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $7693dbd047ade921$export$e530037191fcd5d7, (v) => $7693dbd047ade921$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $7693dbd047ade921$export$fd42f52fd3ae1109, (v) => $7693dbd047ade921$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $7693dbd047ade921$export$c8a8987d4410bf2d, (v) => $7693dbd047ade921$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $7693dbd047ade921$export$d38cd72104c1f0e9, (v) => $7693dbd047ade921$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $7693dbd047ade921$export$7d1e3a5e95ceca43, (v) => $7693dbd047ade921$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $7693dbd047ade921$export$257a8862b851cb5b, (v) => $7693dbd047ade921$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $7693dbd047ade921$export$a8257692ac88316c, (v) => $7693dbd047ade921$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $7693dbd047ade921$export$488013bae63b21da, (v) => $7693dbd047ade921$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $7693dbd047ade921$export$7c73462e0d25e514, (v) => $7693dbd047ade921$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "useCallback", () => $7693dbd047ade921$export$35808ee640e87ca7, (v) => $7693dbd047ade921$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $7693dbd047ade921$export$fae74005e78b1a27, (v) => $7693dbd047ade921$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $7693dbd047ade921$export$dc8fbce3eb94dc1e, (v) => $7693dbd047ade921$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useEffect", () => $7693dbd047ade921$export$6d9c69b0de29b591, (v) => $7693dbd047ade921$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $7693dbd047ade921$export$d5a552a76deda3c2, (v) => $7693dbd047ade921$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $7693dbd047ade921$export$e5c5a5f917a5871c, (v) => $7693dbd047ade921$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $7693dbd047ade921$export$1538c33de8887b59, (v) => $7693dbd047ade921$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $7693dbd047ade921$export$13e3392192263954, (v) => $7693dbd047ade921$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $7693dbd047ade921$export$b8f5890fc79d6aca, (v) => $7693dbd047ade921$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $7693dbd047ade921$export$60241385465d0a34, (v) => $7693dbd047ade921$export$60241385465d0a34 = v);
$parcel$export(module.exports, "version", () => $7693dbd047ade921$export$83d89fbfd8236492, (v) => $7693dbd047ade921$export$83d89fbfd8236492 = v);
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $7693dbd047ade921$export$dca3b0875bd9a954;
var $7693dbd047ade921$export$16fa2f45be04daa8;
var $7693dbd047ade921$export$ffb0004e005737fa;
var $7693dbd047ade921$export$e2c29f18771995cb;
var $7693dbd047ade921$export$221d75b3f55bb0bd;
var $7693dbd047ade921$export$5f8d39834fd61797;
var $7693dbd047ade921$export$74bf444e3cd11ea5;
var $7693dbd047ade921$export$ae55be85d98224ed;
var $7693dbd047ade921$export$e530037191fcd5d7;
var $7693dbd047ade921$export$fd42f52fd3ae1109;
var $7693dbd047ade921$export$c8a8987d4410bf2d;
var $7693dbd047ade921$export$d38cd72104c1f0e9;
var $7693dbd047ade921$export$7d1e3a5e95ceca43;
var $7693dbd047ade921$export$257a8862b851cb5b;
var $7693dbd047ade921$export$a8257692ac88316c;
var $7693dbd047ade921$export$488013bae63b21da;
var $7693dbd047ade921$export$7c73462e0d25e514;
var $7693dbd047ade921$export$35808ee640e87ca7;
var $7693dbd047ade921$export$fae74005e78b1a27;
var $7693dbd047ade921$export$dc8fbce3eb94dc1e;
var $7693dbd047ade921$export$6d9c69b0de29b591;
var $7693dbd047ade921$export$d5a552a76deda3c2;
var $7693dbd047ade921$export$e5c5a5f917a5871c;
var $7693dbd047ade921$export$1538c33de8887b59;
var $7693dbd047ade921$export$13e3392192263954;
var $7693dbd047ade921$export$b8f5890fc79d6aca;
var $7693dbd047ade921$export$60241385465d0a34;
var $7693dbd047ade921$export$83d89fbfd8236492;
'use strict';

var $38COw = parcelRequire("38COw");
var $7693dbd047ade921$var$n = "function" === typeof Symbol && Symbol.for, $7693dbd047ade921$var$p = $7693dbd047ade921$var$n ? Symbol.for("react.element") : 60103, $7693dbd047ade921$var$q = $7693dbd047ade921$var$n ? Symbol.for("react.portal") : 60106, $7693dbd047ade921$var$r = $7693dbd047ade921$var$n ? Symbol.for("react.fragment") : 60107, $7693dbd047ade921$var$t = $7693dbd047ade921$var$n ? Symbol.for("react.strict_mode") : 60108, $7693dbd047ade921$var$u = $7693dbd047ade921$var$n ? Symbol.for("react.profiler") : 60114, $7693dbd047ade921$var$v = $7693dbd047ade921$var$n ? Symbol.for("react.provider") : 60109, $7693dbd047ade921$var$w = $7693dbd047ade921$var$n ? Symbol.for("react.context") : 60110, $7693dbd047ade921$var$x = $7693dbd047ade921$var$n ? Symbol.for("react.forward_ref") : 60112, $7693dbd047ade921$var$y = $7693dbd047ade921$var$n ? Symbol.for("react.suspense") : 60113, $7693dbd047ade921$var$z = $7693dbd047ade921$var$n ? Symbol.for("react.memo") : 60115, $7693dbd047ade921$var$A = $7693dbd047ade921$var$n ? Symbol.for("react.lazy") : 60116, $7693dbd047ade921$var$B = "function" === typeof Symbol && Symbol.iterator;
function $7693dbd047ade921$var$C(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $7693dbd047ade921$var$D = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $7693dbd047ade921$var$E = {};
function $7693dbd047ade921$var$F(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $7693dbd047ade921$var$E;
    this.updater = c || $7693dbd047ade921$var$D;
}
$7693dbd047ade921$var$F.prototype.isReactComponent = {};
$7693dbd047ade921$var$F.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error($7693dbd047ade921$var$C(85));
    this.updater.enqueueSetState(this, a, b, "setState");
};
$7693dbd047ade921$var$F.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $7693dbd047ade921$var$G() {}
$7693dbd047ade921$var$G.prototype = $7693dbd047ade921$var$F.prototype;
function $7693dbd047ade921$var$H(a, b, c) {
    this.props = a;
    this.context = b;
    this.refs = $7693dbd047ade921$var$E;
    this.updater = c || $7693dbd047ade921$var$D;
}
var $7693dbd047ade921$var$I = $7693dbd047ade921$var$H.prototype = new $7693dbd047ade921$var$G;
$7693dbd047ade921$var$I.constructor = $7693dbd047ade921$var$H;
$38COw($7693dbd047ade921$var$I, $7693dbd047ade921$var$F.prototype);
$7693dbd047ade921$var$I.isPureReactComponent = !0;
var $7693dbd047ade921$var$J = {
    current: null
}, $7693dbd047ade921$var$K = Object.prototype.hasOwnProperty, $7693dbd047ade921$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $7693dbd047ade921$var$M(a, b, c) {
    var e, d = {}, g = null, k = null;
    if (null != b) for(e in void 0 !== b.ref && (k = b.ref), void 0 !== b.key && (g = "" + b.key), b)$7693dbd047ade921$var$K.call(b, e) && !$7693dbd047ade921$var$L.hasOwnProperty(e) && (d[e] = b[e]);
    var f = arguments.length - 2;
    if (1 === f) d.children = c;
    else if (1 < f) {
        for(var h = Array(f), m = 0; m < f; m++)h[m] = arguments[m + 2];
        d.children = h;
    }
    if (a && a.defaultProps) for(e in f = a.defaultProps, f)void 0 === d[e] && (d[e] = f[e]);
    return {
        $$typeof: $7693dbd047ade921$var$p,
        type: a,
        key: g,
        ref: k,
        props: d,
        _owner: $7693dbd047ade921$var$J.current
    };
}
function $7693dbd047ade921$var$N(a, b) {
    return {
        $$typeof: $7693dbd047ade921$var$p,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $7693dbd047ade921$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $7693dbd047ade921$var$p;
}
function $7693dbd047ade921$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + ("" + a).replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $7693dbd047ade921$var$P = /\/+/g, $7693dbd047ade921$var$Q = [];
function $7693dbd047ade921$var$R(a, b, c, e) {
    if ($7693dbd047ade921$var$Q.length) {
        var d = $7693dbd047ade921$var$Q.pop();
        d.result = a;
        d.keyPrefix = b;
        d.func = c;
        d.context = e;
        d.count = 0;
        return d;
    }
    return {
        result: a,
        keyPrefix: b,
        func: c,
        context: e,
        count: 0
    };
}
function $7693dbd047ade921$var$S(a) {
    a.result = null;
    a.keyPrefix = null;
    a.func = null;
    a.context = null;
    a.count = 0;
    10 > $7693dbd047ade921$var$Q.length && $7693dbd047ade921$var$Q.push(a);
}
function $7693dbd047ade921$var$T(a, b, c, e) {
    var d = typeof a;
    if ("undefined" === d || "boolean" === d) a = null;
    var g = !1;
    if (null === a) g = !0;
    else switch(d){
        case "string":
        case "number":
            g = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $7693dbd047ade921$var$p:
                case $7693dbd047ade921$var$q:
                    g = !0;
            }
    }
    if (g) return c(e, a, "" === b ? "." + $7693dbd047ade921$var$U(a, 0) : b), 1;
    g = 0;
    b = "" === b ? "." : b + ":";
    if (Array.isArray(a)) for(var k = 0; k < a.length; k++){
        d = a[k];
        var f = b + $7693dbd047ade921$var$U(d, k);
        g += $7693dbd047ade921$var$T(d, f, c, e);
    }
    else if (null === a || "object" !== typeof a ? f = null : (f = $7693dbd047ade921$var$B && a[$7693dbd047ade921$var$B] || a["@@iterator"], f = "function" === typeof f ? f : null), "function" === typeof f) for(a = f.call(a), k = 0; !(d = a.next()).done;)d = d.value, f = b + $7693dbd047ade921$var$U(d, k++), g += $7693dbd047ade921$var$T(d, f, c, e);
    else if ("object" === d) throw c = "" + a, Error($7693dbd047ade921$var$C(31, "[object Object]" === c ? "object with keys {" + Object.keys(a).join(", ") + "}" : c, ""));
    return g;
}
function $7693dbd047ade921$var$V(a, b, c) {
    return null == a ? 0 : $7693dbd047ade921$var$T(a, "", b, c);
}
function $7693dbd047ade921$var$U(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $7693dbd047ade921$var$escape(a.key) : b.toString(36);
}
function $7693dbd047ade921$var$W(a, b) {
    a.func.call(a.context, b, a.count++);
}
function $7693dbd047ade921$var$aa(a, b, c) {
    var e = a.result, d = a.keyPrefix;
    a = a.func.call(a.context, b, a.count++);
    Array.isArray(a) ? $7693dbd047ade921$var$X(a, e, c, function(a) {
        return a;
    }) : null != a && ($7693dbd047ade921$var$O(a) && (a = $7693dbd047ade921$var$N(a, d + (!a.key || b && b.key === a.key ? "" : ("" + a.key).replace($7693dbd047ade921$var$P, "$&/") + "/") + c)), e.push(a));
}
function $7693dbd047ade921$var$X(a, b, c, e, d) {
    var g = "";
    null != c && (g = ("" + c).replace($7693dbd047ade921$var$P, "$&/") + "/");
    b = $7693dbd047ade921$var$R(b, g, e, d);
    $7693dbd047ade921$var$V(a, $7693dbd047ade921$var$aa, b);
    $7693dbd047ade921$var$S(b);
}
var $7693dbd047ade921$var$Y = {
    current: null
};
function $7693dbd047ade921$var$Z() {
    var a = $7693dbd047ade921$var$Y.current;
    if (null === a) throw Error($7693dbd047ade921$var$C(321));
    return a;
}
var $7693dbd047ade921$var$ba = {
    ReactCurrentDispatcher: $7693dbd047ade921$var$Y,
    ReactCurrentBatchConfig: {
        suspense: null
    },
    ReactCurrentOwner: $7693dbd047ade921$var$J,
    IsSomeRendererActing: {
        current: !1
    },
    assign: $38COw
};
$7693dbd047ade921$export$dca3b0875bd9a954 = {
    map: function(a, b, c) {
        if (null == a) return a;
        var e = [];
        $7693dbd047ade921$var$X(a, e, null, b, c);
        return e;
    },
    forEach: function(a, b, c) {
        if (null == a) return a;
        b = $7693dbd047ade921$var$R(null, null, b, c);
        $7693dbd047ade921$var$V(a, $7693dbd047ade921$var$W, b);
        $7693dbd047ade921$var$S(b);
    },
    count: function(a) {
        return $7693dbd047ade921$var$V(a, function() {
            return null;
        }, null);
    },
    toArray: function(a) {
        var b = [];
        $7693dbd047ade921$var$X(a, b, null, function(a) {
            return a;
        });
        return b;
    },
    only: function(a) {
        if (!$7693dbd047ade921$var$O(a)) throw Error($7693dbd047ade921$var$C(143));
        return a;
    }
};
$7693dbd047ade921$export$16fa2f45be04daa8 = $7693dbd047ade921$var$F;
$7693dbd047ade921$export$ffb0004e005737fa = $7693dbd047ade921$var$r;
$7693dbd047ade921$export$e2c29f18771995cb = $7693dbd047ade921$var$u;
$7693dbd047ade921$export$221d75b3f55bb0bd = $7693dbd047ade921$var$H;
$7693dbd047ade921$export$5f8d39834fd61797 = $7693dbd047ade921$var$t;
$7693dbd047ade921$export$74bf444e3cd11ea5 = $7693dbd047ade921$var$y;
$7693dbd047ade921$export$ae55be85d98224ed = $7693dbd047ade921$var$ba;
$7693dbd047ade921$export$e530037191fcd5d7 = function(a, b, c) {
    if (null === a || void 0 === a) throw Error($7693dbd047ade921$var$C(267, a));
    var e = $38COw({}, a.props), d = a.key, g = a.ref, k = a._owner;
    if (null != b) {
        void 0 !== b.ref && (g = b.ref, k = $7693dbd047ade921$var$J.current);
        void 0 !== b.key && (d = "" + b.key);
        if (a.type && a.type.defaultProps) var f = a.type.defaultProps;
        for(h in b)$7693dbd047ade921$var$K.call(b, h) && !$7693dbd047ade921$var$L.hasOwnProperty(h) && (e[h] = void 0 === b[h] && void 0 !== f ? f[h] : b[h]);
    }
    var h = arguments.length - 2;
    if (1 === h) e.children = c;
    else if (1 < h) {
        f = Array(h);
        for(var m = 0; m < h; m++)f[m] = arguments[m + 2];
        e.children = f;
    }
    return {
        $$typeof: $7693dbd047ade921$var$p,
        type: a.type,
        key: d,
        ref: g,
        props: e,
        _owner: k
    };
};
$7693dbd047ade921$export$fd42f52fd3ae1109 = function(a, b) {
    void 0 === b && (b = null);
    a = {
        $$typeof: $7693dbd047ade921$var$w,
        _calculateChangedBits: b,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    a.Provider = {
        $$typeof: $7693dbd047ade921$var$v,
        _context: a
    };
    return a.Consumer = a;
};
$7693dbd047ade921$export$c8a8987d4410bf2d = $7693dbd047ade921$var$M;
$7693dbd047ade921$export$d38cd72104c1f0e9 = function(a) {
    var b = $7693dbd047ade921$var$M.bind(null, a);
    b.type = a;
    return b;
};
$7693dbd047ade921$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$7693dbd047ade921$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $7693dbd047ade921$var$x,
        render: a
    };
};
$7693dbd047ade921$export$a8257692ac88316c = $7693dbd047ade921$var$O;
$7693dbd047ade921$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $7693dbd047ade921$var$A,
        _ctor: a,
        _status: -1,
        _result: null
    };
};
$7693dbd047ade921$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $7693dbd047ade921$var$z,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$7693dbd047ade921$export$35808ee640e87ca7 = function(a, b) {
    return $7693dbd047ade921$var$Z().useCallback(a, b);
};
$7693dbd047ade921$export$fae74005e78b1a27 = function(a, b) {
    return $7693dbd047ade921$var$Z().useContext(a, b);
};
$7693dbd047ade921$export$dc8fbce3eb94dc1e = function() {};
$7693dbd047ade921$export$6d9c69b0de29b591 = function(a, b) {
    return $7693dbd047ade921$var$Z().useEffect(a, b);
};
$7693dbd047ade921$export$d5a552a76deda3c2 = function(a, b, c) {
    return $7693dbd047ade921$var$Z().useImperativeHandle(a, b, c);
};
$7693dbd047ade921$export$e5c5a5f917a5871c = function(a, b) {
    return $7693dbd047ade921$var$Z().useLayoutEffect(a, b);
};
$7693dbd047ade921$export$1538c33de8887b59 = function(a, b) {
    return $7693dbd047ade921$var$Z().useMemo(a, b);
};
$7693dbd047ade921$export$13e3392192263954 = function(a, b, c) {
    return $7693dbd047ade921$var$Z().useReducer(a, b, c);
};
$7693dbd047ade921$export$b8f5890fc79d6aca = function(a) {
    return $7693dbd047ade921$var$Z().useRef(a);
};
$7693dbd047ade921$export$60241385465d0a34 = function(a) {
    return $7693dbd047ade921$var$Z().useState(a);
};
$7693dbd047ade921$export$83d89fbfd8236492 = "16.14.0";

});
parcelRegister("38COw", function(module, exports) {
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/ 'use strict';
/* eslint-disable no-unused-vars */ var $24903a153fb4606a$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $24903a153fb4606a$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $24903a153fb4606a$var$propIsEnumerable = Object.prototype.propertyIsEnumerable;
function $24903a153fb4606a$var$toObject(val) {
    if (val === null || val === undefined) throw new TypeError('Object.assign cannot be called with null or undefined');
    return Object(val);
}
function $24903a153fb4606a$var$shouldUseNative() {
    try {
        if (!Object.assign) return false;
        // Detect buggy property enumeration order in older V8 versions.
        // https://bugs.chromium.org/p/v8/issues/detail?id=4118
        var test1 = new String('abc'); // eslint-disable-line no-new-wrappers
        test1[5] = 'de';
        if (Object.getOwnPropertyNames(test1)[0] === '5') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test2 = {};
        for(var i = 0; i < 10; i++)test2['_' + String.fromCharCode(i)] = i;
        var order2 = Object.getOwnPropertyNames(test2).map(function(n) {
            return test2[n];
        });
        if (order2.join('') !== '0123456789') return false;
        // https://bugs.chromium.org/p/v8/issues/detail?id=3056
        var test3 = {};
        'abcdefghijklmnopqrst'.split('').forEach(function(letter) {
            test3[letter] = letter;
        });
        if (Object.keys(Object.assign({}, test3)).join('') !== 'abcdefghijklmnopqrst') return false;
        return true;
    } catch (err) {
        // We don't expect any of the above to throw, but better to be safe.
        return false;
    }
}
module.exports = $24903a153fb4606a$var$shouldUseNative() ? Object.assign : function(target, source) {
    var from;
    var to = $24903a153fb4606a$var$toObject(target);
    var symbols;
    for(var s = 1; s < arguments.length; s++){
        from = Object(arguments[s]);
        for(var key in from)if ($24903a153fb4606a$var$hasOwnProperty.call(from, key)) to[key] = from[key];
        if ($24903a153fb4606a$var$getOwnPropertySymbols) {
            symbols = $24903a153fb4606a$var$getOwnPropertySymbols(from);
            for(var i = 0; i < symbols.length; i++)if ($24903a153fb4606a$var$propIsEnumerable.call(from, symbols[i])) to[symbols[i]] = from[symbols[i]];
        }
    }
    return to;
};

});




parcelRegister("dBSRM", function(module, exports) {
$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);

var $b8WCc = parcelRequire("b8WCc");

var $3ZMUU = parcelRequire("3ZMUU");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $b8WCc.isBrowserBundle)() && Object.prototype.toString.call(typeof $3ZMUU !== 'undefined' ? $3ZMUU : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("b8WCc", function(module, exports) {
$parcel$export(module.exports, "isBrowserBundle", () => $81cde8cb5e9c669f$export$2928c40372e623c0);
$parcel$export(module.exports, "getSDKSource", () => $81cde8cb5e9c669f$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $81cde8cb5e9c669f$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $81cde8cb5e9c669f$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("3ZMUU", function(module, exports) {
// shim for using process in browser
var $2e8d0374c7e0ead2$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $2e8d0374c7e0ead2$var$cachedSetTimeout;
var $2e8d0374c7e0ead2$var$cachedClearTimeout;
function $2e8d0374c7e0ead2$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $2e8d0374c7e0ead2$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        else $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = $2e8d0374c7e0ead2$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        else $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    } catch (e) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = $2e8d0374c7e0ead2$var$defaultClearTimeout;
    }
})();
function $2e8d0374c7e0ead2$var$runTimeout(fun) {
    if ($2e8d0374c7e0ead2$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedSetTimeout === $2e8d0374c7e0ead2$var$defaultSetTimout || !$2e8d0374c7e0ead2$var$cachedSetTimeout) && setTimeout) {
        $2e8d0374c7e0ead2$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $2e8d0374c7e0ead2$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $2e8d0374c7e0ead2$var$runClearTimeout(marker) {
    if ($2e8d0374c7e0ead2$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($2e8d0374c7e0ead2$var$cachedClearTimeout === $2e8d0374c7e0ead2$var$defaultClearTimeout || !$2e8d0374c7e0ead2$var$cachedClearTimeout) && clearTimeout) {
        $2e8d0374c7e0ead2$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $2e8d0374c7e0ead2$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $2e8d0374c7e0ead2$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $2e8d0374c7e0ead2$var$queue = [];
var $2e8d0374c7e0ead2$var$draining = false;
var $2e8d0374c7e0ead2$var$currentQueue;
var $2e8d0374c7e0ead2$var$queueIndex = -1;
function $2e8d0374c7e0ead2$var$cleanUpNextTick() {
    if (!$2e8d0374c7e0ead2$var$draining || !$2e8d0374c7e0ead2$var$currentQueue) return;
    $2e8d0374c7e0ead2$var$draining = false;
    if ($2e8d0374c7e0ead2$var$currentQueue.length) $2e8d0374c7e0ead2$var$queue = $2e8d0374c7e0ead2$var$currentQueue.concat($2e8d0374c7e0ead2$var$queue);
    else $2e8d0374c7e0ead2$var$queueIndex = -1;
    if ($2e8d0374c7e0ead2$var$queue.length) $2e8d0374c7e0ead2$var$drainQueue();
}
function $2e8d0374c7e0ead2$var$drainQueue() {
    if ($2e8d0374c7e0ead2$var$draining) return;
    var timeout = $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$cleanUpNextTick);
    $2e8d0374c7e0ead2$var$draining = true;
    var len = $2e8d0374c7e0ead2$var$queue.length;
    while(len){
        $2e8d0374c7e0ead2$var$currentQueue = $2e8d0374c7e0ead2$var$queue;
        $2e8d0374c7e0ead2$var$queue = [];
        while(++$2e8d0374c7e0ead2$var$queueIndex < len)if ($2e8d0374c7e0ead2$var$currentQueue) $2e8d0374c7e0ead2$var$currentQueue[$2e8d0374c7e0ead2$var$queueIndex].run();
        $2e8d0374c7e0ead2$var$queueIndex = -1;
        len = $2e8d0374c7e0ead2$var$queue.length;
    }
    $2e8d0374c7e0ead2$var$currentQueue = null;
    $2e8d0374c7e0ead2$var$draining = false;
    $2e8d0374c7e0ead2$var$runClearTimeout(timeout);
}
$2e8d0374c7e0ead2$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $2e8d0374c7e0ead2$var$queue.push(new $2e8d0374c7e0ead2$var$Item(fun, args));
    if ($2e8d0374c7e0ead2$var$queue.length === 1 && !$2e8d0374c7e0ead2$var$draining) $2e8d0374c7e0ead2$var$runTimeout($2e8d0374c7e0ead2$var$drainQueue);
};
// v8 likes predictible objects
function $2e8d0374c7e0ead2$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$2e8d0374c7e0ead2$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$2e8d0374c7e0ead2$var$process.title = 'browser';
$2e8d0374c7e0ead2$var$process.browser = true;
$2e8d0374c7e0ead2$var$process.env = {};
$2e8d0374c7e0ead2$var$process.argv = [];
$2e8d0374c7e0ead2$var$process.version = ''; // empty string to avoid regexp issues
$2e8d0374c7e0ead2$var$process.versions = {};
function $2e8d0374c7e0ead2$var$noop() {}
$2e8d0374c7e0ead2$var$process.on = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.addListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.once = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.off = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.removeAllListeners = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.emit = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.prependOnceListener = $2e8d0374c7e0ead2$var$noop;
$2e8d0374c7e0ead2$var$process.listeners = function(name) {
    return [];
};
$2e8d0374c7e0ead2$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$2e8d0374c7e0ead2$var$process.cwd = function() {
    return '/';
};
$2e8d0374c7e0ead2$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$2e8d0374c7e0ead2$var$process.umask = function() {
    return 0;
};

});


parcelRegister("hLm8s", function(module, exports) {
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 'use strict';

var $5FkrB = parcelRequire("5FkrB");

var $38COw = parcelRequire("38COw");

var $3hvsM = parcelRequire("3hvsM");
function u(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
if (!$5FkrB) throw Error(u(227));
function ba(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var da = !1, ea = null, fa = !1, ha = null, ia = {
    onError: function(a) {
        da = !0;
        ea = a;
    }
};
function ja(a, b, c, d, e, f, g, h, k) {
    da = !1;
    ea = null;
    ba.apply(ia, arguments);
}
function ka(a, b, c, d, e, f, g, h, k) {
    ja.apply(this, arguments);
    if (da) {
        if (da) {
            var l = ea;
            da = !1;
            ea = null;
        } else throw Error(u(198));
        fa || (fa = !0, ha = l);
    }
}
var la = null, ma = null, na = null;
function oa(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = na(c);
    ka(d, b, void 0, a);
    a.currentTarget = null;
}
var pa = null, qa = {};
function ra() {
    if (pa) for(var a in qa){
        var b = qa[a], c = pa.indexOf(a);
        if (!(-1 < c)) throw Error(u(96, a));
        if (!sa[c]) {
            if (!b.extractEvents) throw Error(u(97, a));
            sa[c] = b;
            c = b.eventTypes;
            for(var d in c){
                var e = void 0;
                var f = c[d], g = b, h = d;
                if (ta.hasOwnProperty(h)) throw Error(u(99, h));
                ta[h] = f;
                var k = f.phasedRegistrationNames;
                if (k) {
                    for(e in k)k.hasOwnProperty(e) && ua(k[e], g, h);
                    e = !0;
                } else f.registrationName ? (ua(f.registrationName, g, h), e = !0) : e = !1;
                if (!e) throw Error(u(98, d, a));
            }
        }
    }
}
function ua(a, b, c) {
    if (va[a]) throw Error(u(100, a));
    va[a] = b;
    wa[a] = b.eventTypes[c].dependencies;
}
var sa = [], ta = {}, va = {}, wa = {};
function xa(a) {
    var b = !1, c;
    for(c in a)if (a.hasOwnProperty(c)) {
        var d = a[c];
        if (!qa.hasOwnProperty(c) || qa[c] !== d) {
            if (qa[c]) throw Error(u(102, c));
            qa[c] = d;
            b = !0;
        }
    }
    b && ra();
}
var ya = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), za = null, Aa = null, Ba = null;
function Ca(a) {
    if (a = ma(a)) {
        if ("function" !== typeof za) throw Error(u(280));
        var b = a.stateNode;
        b && (b = la(b), za(a.stateNode, a.type, b));
    }
}
function Da(a) {
    Aa ? Ba ? Ba.push(a) : Ba = [
        a
    ] : Aa = a;
}
function Ea() {
    if (Aa) {
        var a = Aa, b = Ba;
        Ba = Aa = null;
        Ca(a);
        if (b) for(a = 0; a < b.length; a++)Ca(b[a]);
    }
}
function Fa(a, b) {
    return a(b);
}
function Ga(a, b, c, d, e) {
    return a(b, c, d, e);
}
function Ha() {}
var Ia = Fa, Ja = !1, Ka = !1;
function La() {
    if (null !== Aa || null !== Ba) Ha(), Ea();
}
function Ma(a, b, c) {
    if (Ka) return a(b, c);
    Ka = !0;
    try {
        return Ia(a, b, c);
    } finally{
        Ka = !1, La();
    }
}
var Na = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, Oa = Object.prototype.hasOwnProperty, Pa = {}, Qa = {};
function Ra(a) {
    if (Oa.call(Qa, a)) return !0;
    if (Oa.call(Pa, a)) return !1;
    if (Na.test(a)) return Qa[a] = !0;
    Pa[a] = !0;
    return !1;
}
function Sa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function Ta(a, b, c, d) {
    if (null === b || "undefined" === typeof b || Sa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function v(a, b, c, d, e, f) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
}
var C = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    C[a] = new v(a, 0, !1, a, null, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    C[b] = new v(b, 1, !1, a[1], null, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a.toLowerCase(), null, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    C[a] = new v(a, 2, !1, a, null, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    C[a] = new v(a, 3, !1, a.toLowerCase(), null, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    C[a] = new v(a, 3, !0, a, null, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    C[a] = new v(a, 4, !1, a, null, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    C[a] = new v(a, 6, !1, a, null, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    C[a] = new v(a, 5, !1, a.toLowerCase(), null, !1);
});
var Ua = /[\-:]([a-z])/g;
function Va(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, null, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace(Ua, Va);
    C[b] = new v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !1);
});
C.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    C[a] = new v(a, 1, !1, a.toLowerCase(), null, !0);
});
var Wa = $5FkrB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
Wa.hasOwnProperty("ReactCurrentDispatcher") || (Wa.ReactCurrentDispatcher = {
    current: null
});
Wa.hasOwnProperty("ReactCurrentBatchConfig") || (Wa.ReactCurrentBatchConfig = {
    suspense: null
});
function Xa(a, b, c, d) {
    var e = C.hasOwnProperty(b) ? C[b] : null;
    var f = null !== e ? 0 === e.type : d ? !1 : !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1] ? !1 : !0;
    f || (Ta(b, c, e, d) && (c = null), d || null === e ? Ra(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c))));
}
var Ya = /^(.*)[\\\/]/, E = "function" === typeof Symbol && Symbol.for, Za = E ? Symbol.for("react.element") : 60103, $a = E ? Symbol.for("react.portal") : 60106, ab = E ? Symbol.for("react.fragment") : 60107, bb = E ? Symbol.for("react.strict_mode") : 60108, cb = E ? Symbol.for("react.profiler") : 60114, db = E ? Symbol.for("react.provider") : 60109, eb = E ? Symbol.for("react.context") : 60110, fb = E ? Symbol.for("react.concurrent_mode") : 60111, gb = E ? Symbol.for("react.forward_ref") : 60112, hb = E ? Symbol.for("react.suspense") : 60113, ib = E ? Symbol.for("react.suspense_list") : 60120, jb = E ? Symbol.for("react.memo") : 60115, kb = E ? Symbol.for("react.lazy") : 60116, lb = E ? Symbol.for("react.block") : 60121, mb = "function" === typeof Symbol && Symbol.iterator;
function nb(a) {
    if (null === a || "object" !== typeof a) return null;
    a = mb && a[mb] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
function ob(a) {
    if (-1 === a._status) {
        a._status = 0;
        var b = a._ctor;
        b = b();
        a._result = b;
        b.then(function(b) {
            0 === a._status && (b = b.default, a._status = 1, a._result = b);
        }, function(b) {
            0 === a._status && (a._status = 2, a._result = b);
        });
    }
}
function pb(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case ab:
            return "Fragment";
        case $a:
            return "Portal";
        case cb:
            return "Profiler";
        case bb:
            return "StrictMode";
        case hb:
            return "Suspense";
        case ib:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case eb:
            return "Context.Consumer";
        case db:
            return "Context.Provider";
        case gb:
            var b = a.render;
            b = b.displayName || b.name || "";
            return a.displayName || ("" !== b ? "ForwardRef(" + b + ")" : "ForwardRef");
        case jb:
            return pb(a.type);
        case lb:
            return pb(a.render);
        case kb:
            if (a = 1 === a._status ? a._result : null) return pb(a);
    }
    return null;
}
function qb(a) {
    var b = "";
    do {
        a: switch(a.tag){
            case 3:
            case 4:
            case 6:
            case 7:
            case 10:
            case 9:
                var c = "";
                break a;
            default:
                var d = a._debugOwner, e = a._debugSource, f = pb(a.type);
                c = null;
                d && (c = pb(d.type));
                d = f;
                f = "";
                e ? f = " (at " + e.fileName.replace(Ya, "") + ":" + e.lineNumber + ")" : c && (f = " (created by " + c + ")");
                c = "\n    in " + (d || "Unknown") + f;
        }
        b += c;
        a = a.return;
    }while (a);
    return b;
}
function rb(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "object":
        case "string":
        case "undefined":
            return a;
        default:
            return "";
    }
}
function sb(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function tb(a) {
    var b = sb(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function xb(a) {
    a._valueTracker || (a._valueTracker = tb(a));
}
function yb(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = sb(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function zb(a, b) {
    var c = b.checked;
    return $38COw({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function Ab(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = rb(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function Bb(a, b) {
    b = b.checked;
    null != b && Xa(a, "checked", b, !1);
}
function Cb(a, b) {
    Bb(a, b);
    var c = rb(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? Db(a, b.type, c) : b.hasOwnProperty("defaultValue") && Db(a, b.type, rb(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function Eb(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function Db(a, b, c) {
    if ("number" !== b || a.ownerDocument.activeElement !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
function Fb(a) {
    var b = "";
    $5FkrB.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function Gb(a, b) {
    a = $38COw({
        children: void 0
    }, b);
    if (b = Fb(b.children)) a.children = b;
    return a;
}
function Hb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + rb(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function Ib(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error(u(91));
    return $38COw({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function Jb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error(u(92));
            if (Array.isArray(c)) {
                if (!(1 >= c.length)) throw Error(u(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: rb(c)
    };
}
function Kb(a, b) {
    var c = rb(b.value), d = rb(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function Lb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
var Mb = {
    html: "http://www.w3.org/1999/xhtml",
    mathml: "http://www.w3.org/1998/Math/MathML",
    svg: "http://www.w3.org/2000/svg"
};
function Nb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function Ob(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? Nb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var Pb, Qb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if (a.namespaceURI !== Mb.svg || "innerHTML" in a) a.innerHTML = b;
    else {
        Pb = Pb || document.createElement("div");
        Pb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = Pb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function Rb(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
function Sb(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var Tb = {
    animationend: Sb("Animation", "AnimationEnd"),
    animationiteration: Sb("Animation", "AnimationIteration"),
    animationstart: Sb("Animation", "AnimationStart"),
    transitionend: Sb("Transition", "TransitionEnd")
}, Ub = {}, Vb = {};
ya && (Vb = document.createElement("div").style, "AnimationEvent" in window || (delete Tb.animationend.animation, delete Tb.animationiteration.animation, delete Tb.animationstart.animation), "TransitionEvent" in window || delete Tb.transitionend.transition);
function Wb(a) {
    if (Ub[a]) return Ub[a];
    if (!Tb[a]) return a;
    var b = Tb[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in Vb) return Ub[a] = b[c];
    return a;
}
var Xb = Wb("animationend"), Yb = Wb("animationiteration"), Zb = Wb("animationstart"), $b = Wb("transitionend"), ac = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), bc = new ("function" === typeof WeakMap ? WeakMap : Map);
function cc(a) {
    var b = bc.get(a);
    void 0 === b && (b = new Map, bc.set(a, b));
    return b;
}
function dc(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.effectTag & 1026) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function ec(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function fc(a) {
    if (dc(a) !== a) throw Error(u(188));
}
function gc(a) {
    var b = a.alternate;
    if (!b) {
        b = dc(a);
        if (null === b) throw Error(u(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return fc(e), a;
                if (f === d) return fc(e), b;
                f = f.sibling;
            }
            throw Error(u(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error(u(189));
            }
        }
        if (c.alternate !== d) throw Error(u(190));
    }
    if (3 !== c.tag) throw Error(u(188));
    return c.stateNode.current === c ? a : b;
}
function hc(a) {
    a = gc(a);
    if (!a) return null;
    for(var b = a;;){
        if (5 === b.tag || 6 === b.tag) return b;
        if (b.child) b.child.return = b, b = b.child;
        else {
            if (b === a) break;
            for(; !b.sibling;){
                if (!b.return || b.return === a) return null;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return null;
}
function ic(a, b) {
    if (null == b) throw Error(u(30));
    if (null == a) return b;
    if (Array.isArray(a)) {
        if (Array.isArray(b)) return a.push.apply(a, b), a;
        a.push(b);
        return a;
    }
    return Array.isArray(b) ? [
        a
    ].concat(b) : [
        a,
        b
    ];
}
function jc(a, b, c) {
    Array.isArray(a) ? a.forEach(b, c) : a && b.call(c, a);
}
var kc = null;
function lc(a) {
    if (a) {
        var b = a._dispatchListeners, c = a._dispatchInstances;
        if (Array.isArray(b)) for(var d = 0; d < b.length && !a.isPropagationStopped(); d++)oa(a, b[d], c[d]);
        else b && oa(a, b, c);
        a._dispatchListeners = null;
        a._dispatchInstances = null;
        a.isPersistent() || a.constructor.release(a);
    }
}
function mc(a) {
    null !== a && (kc = ic(kc, a));
    a = kc;
    kc = null;
    if (a) {
        jc(a, lc);
        if (kc) throw Error(u(95));
        if (fa) throw a = ha, fa = !1, ha = null, a;
    }
}
function nc(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
function oc(a) {
    if (!ya) return !1;
    a = "on" + a;
    var b = a in document;
    b || (b = document.createElement("div"), b.setAttribute(a, "return;"), b = "function" === typeof b[a]);
    return b;
}
var pc = [];
function qc(a) {
    a.topLevelType = null;
    a.nativeEvent = null;
    a.targetInst = null;
    a.ancestors.length = 0;
    10 > pc.length && pc.push(a);
}
function rc(a, b, c, d) {
    if (pc.length) {
        var e = pc.pop();
        e.topLevelType = a;
        e.eventSystemFlags = d;
        e.nativeEvent = b;
        e.targetInst = c;
        return e;
    }
    return {
        topLevelType: a,
        eventSystemFlags: d,
        nativeEvent: b,
        targetInst: c,
        ancestors: []
    };
}
function sc(a) {
    var b = a.targetInst, c = b;
    do {
        if (!c) {
            a.ancestors.push(c);
            break;
        }
        var d = c;
        if (3 === d.tag) d = d.stateNode.containerInfo;
        else {
            for(; d.return;)d = d.return;
            d = 3 !== d.tag ? null : d.stateNode.containerInfo;
        }
        if (!d) break;
        b = c.tag;
        5 !== b && 6 !== b || a.ancestors.push(c);
        c = tc(d);
    }while (c);
    for(c = 0; c < a.ancestors.length; c++){
        b = a.ancestors[c];
        var e = nc(a.nativeEvent);
        d = a.topLevelType;
        var f = a.nativeEvent, g = a.eventSystemFlags;
        0 === c && (g |= 64);
        for(var h = null, k = 0; k < sa.length; k++){
            var l = sa[k];
            l && (l = l.extractEvents(d, b, f, e, g)) && (h = ic(h, l));
        }
        mc(h);
    }
}
function uc(a, b, c) {
    if (!c.has(a)) {
        switch(a){
            case "scroll":
                vc(b, "scroll", !0);
                break;
            case "focus":
            case "blur":
                vc(b, "focus", !0);
                vc(b, "blur", !0);
                c.set("blur", null);
                c.set("focus", null);
                break;
            case "cancel":
            case "close":
                oc(a) && vc(b, a, !0);
                break;
            case "invalid":
            case "submit":
            case "reset":
                break;
            default:
                -1 === ac.indexOf(a) && F(a, b);
        }
        c.set(a, null);
    }
}
var wc, xc, yc, zc = !1, Ac = [], Bc = null, Cc = null, Dc = null, Ec = new Map, Fc = new Map, Gc = [], Hc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "), Ic = "focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a, b) {
    var c = cc(b);
    Hc.forEach(function(a) {
        uc(a, b, c);
    });
    Ic.forEach(function(a) {
        uc(a, b, c);
    });
}
function Kc(a, b, c, d, e) {
    return {
        blockedOn: a,
        topLevelType: b,
        eventSystemFlags: c | 32,
        nativeEvent: e,
        container: d
    };
}
function Lc(a, b) {
    switch(a){
        case "focus":
        case "blur":
            Bc = null;
            break;
        case "dragenter":
        case "dragleave":
            Cc = null;
            break;
        case "mouseover":
        case "mouseout":
            Dc = null;
            break;
        case "pointerover":
        case "pointerout":
            Ec.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            Fc.delete(b.pointerId);
    }
}
function Mc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = Kc(b, c, d, e, f), null !== b && (b = Nc(b), null !== b && xc(b)), a;
    a.eventSystemFlags |= d;
    return a;
}
function Oc(a, b, c, d, e) {
    switch(b){
        case "focus":
            return Bc = Mc(Bc, a, b, c, d, e), !0;
        case "dragenter":
            return Cc = Mc(Cc, a, b, c, d, e), !0;
        case "mouseover":
            return Dc = Mc(Dc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            Ec.set(f, Mc(Ec.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, Fc.set(f, Mc(Fc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function Pc(a) {
    var b = tc(a.target);
    if (null !== b) {
        var c = dc(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = ec(c), null !== b) {
                    a.blockedOn = b;
                    $3hvsM.unstable_runWithPriority(a.priority, function() {
                        yc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.hydrate) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function Qc(a) {
    if (null !== a.blockedOn) return !1;
    var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
    if (null !== b) {
        var c = Nc(b);
        null !== c && xc(c);
        a.blockedOn = b;
        return !1;
    }
    return !0;
}
function Sc(a, b, c) {
    Qc(a) && c.delete(b);
}
function Tc() {
    for(zc = !1; 0 < Ac.length;){
        var a = Ac[0];
        if (null !== a.blockedOn) {
            a = Nc(a.blockedOn);
            null !== a && wc(a);
            break;
        }
        var b = Rc(a.topLevelType, a.eventSystemFlags, a.container, a.nativeEvent);
        null !== b ? a.blockedOn = b : Ac.shift();
    }
    null !== Bc && Qc(Bc) && (Bc = null);
    null !== Cc && Qc(Cc) && (Cc = null);
    null !== Dc && Qc(Dc) && (Dc = null);
    Ec.forEach(Sc);
    Fc.forEach(Sc);
}
function Uc(a, b) {
    a.blockedOn === b && (a.blockedOn = null, zc || (zc = !0, $3hvsM.unstable_scheduleCallback($3hvsM.unstable_NormalPriority, Tc)));
}
function Vc(a) {
    function b(b) {
        return Uc(b, a);
    }
    if (0 < Ac.length) {
        Uc(Ac[0], a);
        for(var c = 1; c < Ac.length; c++){
            var d = Ac[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== Bc && Uc(Bc, a);
    null !== Cc && Uc(Cc, a);
    null !== Dc && Uc(Dc, a);
    Ec.forEach(b);
    Fc.forEach(b);
    for(c = 0; c < Gc.length; c++)d = Gc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < Gc.length && (c = Gc[0], null === c.blockedOn);)Pc(c), null === c.blockedOn && Gc.shift();
}
var Wc = {}, Yc = new Map, Zc = new Map, $c = [
    "abort",
    "abort",
    Xb,
    "animationEnd",
    Yb,
    "animationIteration",
    Zb,
    "animationStart",
    "canplay",
    "canPlay",
    "canplaythrough",
    "canPlayThrough",
    "durationchange",
    "durationChange",
    "emptied",
    "emptied",
    "encrypted",
    "encrypted",
    "ended",
    "ended",
    "error",
    "error",
    "gotpointercapture",
    "gotPointerCapture",
    "load",
    "load",
    "loadeddata",
    "loadedData",
    "loadedmetadata",
    "loadedMetadata",
    "loadstart",
    "loadStart",
    "lostpointercapture",
    "lostPointerCapture",
    "playing",
    "playing",
    "progress",
    "progress",
    "seeking",
    "seeking",
    "stalled",
    "stalled",
    "suspend",
    "suspend",
    "timeupdate",
    "timeUpdate",
    $b,
    "transitionEnd",
    "waiting",
    "waiting"
];
function ad(a, b) {
    for(var c = 0; c < a.length; c += 2){
        var d = a[c], e = a[c + 1], f = "on" + (e[0].toUpperCase() + e.slice(1));
        f = {
            phasedRegistrationNames: {
                bubbled: f,
                captured: f + "Capture"
            },
            dependencies: [
                d
            ],
            eventPriority: b
        };
        Zc.set(d, b);
        Yc.set(d, f);
        Wc[e] = f;
    }
}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "), 0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "), 1);
ad($c, 2);
for(var bd = "change selectionchange textInput compositionstart compositionend compositionupdate".split(" "), cd = 0; cd < bd.length; cd++)Zc.set(bd[cd], 0);
var dd = $3hvsM.unstable_UserBlockingPriority, ed = $3hvsM.unstable_runWithPriority, fd = !0;
function F(a, b) {
    vc(b, a, !1);
}
function vc(a, b, c) {
    var d = Zc.get(b);
    switch(void 0 === d ? 2 : d){
        case 0:
            d = gd.bind(null, b, 1, a);
            break;
        case 1:
            d = hd.bind(null, b, 1, a);
            break;
        default:
            d = id.bind(null, b, 1, a);
    }
    c ? a.addEventListener(b, d, !0) : a.addEventListener(b, d, !1);
}
function gd(a, b, c, d) {
    Ja || Ha();
    var e = id, f = Ja;
    Ja = !0;
    try {
        Ga(e, a, b, c, d);
    } finally{
        (Ja = f) || La();
    }
}
function hd(a, b, c, d) {
    ed(dd, id.bind(null, a, b, c, d));
}
function id(a, b, c, d) {
    if (fd) {
        if (0 < Ac.length && -1 < Hc.indexOf(a)) a = Kc(null, a, b, c, d), Ac.push(a);
        else {
            var e = Rc(a, b, c, d);
            if (null === e) Lc(a, d);
            else if (-1 < Hc.indexOf(a)) a = Kc(e, a, b, c, d), Ac.push(a);
            else if (!Oc(e, a, b, c, d)) {
                Lc(a, d);
                a = rc(a, d, null, b);
                try {
                    Ma(sc, a);
                } finally{
                    qc(a);
                }
            }
        }
    }
}
function Rc(a, b, c, d) {
    c = nc(d);
    c = tc(c);
    if (null !== c) {
        var e = dc(c);
        if (null === e) c = null;
        else {
            var f = e.tag;
            if (13 === f) {
                c = ec(e);
                if (null !== c) return c;
                c = null;
            } else if (3 === f) {
                if (e.stateNode.hydrate) return 3 === e.tag ? e.stateNode.containerInfo : null;
                c = null;
            } else e !== c && (c = null);
        }
    }
    a = rc(a, d, c, b);
    try {
        Ma(sc, a);
    } finally{
        qc(a);
    }
    return null;
}
var jd = {
    animationIterationCount: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, kd = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys(jd).forEach(function(a) {
    kd.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        jd[b] = jd[a];
    });
});
function ld(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || jd.hasOwnProperty(a) && jd[a] ? ("" + b).trim() : b + "px";
}
function md(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = ld(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var nd = $38COw({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function od(a, b) {
    if (b) {
        if (nd[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error(u(137, a, ""));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error(u(60));
            if (!("object" === typeof b.dangerouslySetInnerHTML && "__html" in b.dangerouslySetInnerHTML)) throw Error(u(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error(u(62, ""));
    }
}
function pd(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var qd = Mb.html;
function rd(a, b) {
    a = 9 === a.nodeType || 11 === a.nodeType ? a : a.ownerDocument;
    var c = cc(a);
    b = wa[b];
    for(var d = 0; d < b.length; d++)uc(b[d], a, c);
}
function sd() {}
function td(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function ud(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function vd(a, b) {
    var c = ud(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = ud(c);
    }
}
function wd(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? wd(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function xd() {
    for(var a = window, b = td(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = td(a.document);
    }
    return b;
}
function yd(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
var zd = "$", Ad = "/$", Bd = "$?", Cd = "$!", Dd = null, Ed = null;
function Fd(a, b) {
    switch(a){
        case "button":
        case "input":
        case "select":
        case "textarea":
            return !!b.autoFocus;
    }
    return !1;
}
function Gd(a, b) {
    return "textarea" === a || "option" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var Hd = "function" === typeof setTimeout ? setTimeout : void 0, Id = "function" === typeof clearTimeout ? clearTimeout : void 0;
function Jd(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
    }
    return a;
}
function Kd(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if (c === zd || c === Cd || c === Bd) {
                if (0 === b) return a;
                b--;
            } else c === Ad && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var Ld = Math.random().toString(36).slice(2), Md = "__reactInternalInstance$" + Ld, Nd = "__reactEventHandlers$" + Ld, Od = "__reactContainere$" + Ld;
function tc(a) {
    var b = a[Md];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[Od] || c[Md]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = Kd(a); null !== a;){
                if (c = a[Md]) return c;
                a = Kd(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function Nc(a) {
    a = a[Md] || a[Od];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function Pd(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error(u(33));
}
function Qd(a) {
    return a[Nd] || null;
}
function Rd(a) {
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function Sd(a, b) {
    var c = a.stateNode;
    if (!c) return null;
    var d = la(c);
    if (!d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error(u(231, b, typeof c));
    return c;
}
function Td(a, b, c) {
    if (b = Sd(a, c.dispatchConfig.phasedRegistrationNames[b])) c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a);
}
function Ud(a) {
    if (a && a.dispatchConfig.phasedRegistrationNames) {
        for(var b = a._targetInst, c = []; b;)c.push(b), b = Rd(b);
        for(b = c.length; 0 < b--;)Td(c[b], "captured", a);
        for(b = 0; b < c.length; b++)Td(c[b], "bubbled", a);
    }
}
function Vd(a, b, c) {
    a && c && c.dispatchConfig.registrationName && (b = Sd(a, c.dispatchConfig.registrationName)) && (c._dispatchListeners = ic(c._dispatchListeners, b), c._dispatchInstances = ic(c._dispatchInstances, a));
}
function Wd(a) {
    a && a.dispatchConfig.registrationName && Vd(a._targetInst, null, a);
}
function Xd(a) {
    jc(a, Ud);
}
var Yd = null, Zd = null, $d = null;
function ae() {
    if ($d) return $d;
    var a, b = Zd, c = b.length, d, e = "value" in Yd ? Yd.value : Yd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $d = e.slice(a, 1 < d ? 1 - d : void 0);
}
function be() {
    return !0;
}
function ce() {
    return !1;
}
function G(a, b, c, d) {
    this.dispatchConfig = a;
    this._targetInst = b;
    this.nativeEvent = c;
    a = this.constructor.Interface;
    for(var e in a)a.hasOwnProperty(e) && ((b = a[e]) ? this[e] = b(c) : "target" === e ? this.target = d : this[e] = c[e]);
    this.isDefaultPrevented = (null != c.defaultPrevented ? c.defaultPrevented : !1 === c.returnValue) ? be : ce;
    this.isPropagationStopped = ce;
    return this;
}
$38COw(G.prototype, {
    preventDefault: function() {
        this.defaultPrevented = !0;
        var a = this.nativeEvent;
        a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = be);
    },
    stopPropagation: function() {
        var a = this.nativeEvent;
        a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = be);
    },
    persist: function() {
        this.isPersistent = be;
    },
    isPersistent: ce,
    destructor: function() {
        var a = this.constructor.Interface, b;
        for(b in a)this[b] = null;
        this.nativeEvent = this._targetInst = this.dispatchConfig = null;
        this.isPropagationStopped = this.isDefaultPrevented = ce;
        this._dispatchInstances = this._dispatchListeners = null;
    }
});
G.Interface = {
    type: null,
    target: null,
    currentTarget: function() {
        return null;
    },
    eventPhase: null,
    bubbles: null,
    cancelable: null,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: null,
    isTrusted: null
};
G.extend = function(a) {
    function b() {}
    function c() {
        return d.apply(this, arguments);
    }
    var d = this;
    b.prototype = d.prototype;
    var e = new b;
    $38COw(e, c.prototype);
    c.prototype = e;
    c.prototype.constructor = c;
    c.Interface = $38COw({}, d.Interface, a);
    c.extend = d.extend;
    de(c);
    return c;
};
de(G);
function ee(a, b, c, d) {
    if (this.eventPool.length) {
        var e = this.eventPool.pop();
        this.call(e, a, b, c, d);
        return e;
    }
    return new this(a, b, c, d);
}
function fe(a) {
    if (!(a instanceof this)) throw Error(u(279));
    a.destructor();
    10 > this.eventPool.length && this.eventPool.push(a);
}
function de(a) {
    a.eventPool = [];
    a.getPooled = ee;
    a.release = fe;
}
var ge = G.extend({
    data: null
}), he = G.extend({
    data: null
}), ie = [
    9,
    13,
    27,
    32
], je = ya && "CompositionEvent" in window, ke = null;
ya && "documentMode" in document && (ke = document.documentMode);
var le = ya && "TextEvent" in window && !ke, me = ya && (!je || ke && 8 < ke && 11 >= ke), ne = String.fromCharCode(32), oe = {
    beforeInput: {
        phasedRegistrationNames: {
            bubbled: "onBeforeInput",
            captured: "onBeforeInputCapture"
        },
        dependencies: [
            "compositionend",
            "keypress",
            "textInput",
            "paste"
        ]
    },
    compositionEnd: {
        phasedRegistrationNames: {
            bubbled: "onCompositionEnd",
            captured: "onCompositionEndCapture"
        },
        dependencies: "blur compositionend keydown keypress keyup mousedown".split(" ")
    },
    compositionStart: {
        phasedRegistrationNames: {
            bubbled: "onCompositionStart",
            captured: "onCompositionStartCapture"
        },
        dependencies: "blur compositionstart keydown keypress keyup mousedown".split(" ")
    },
    compositionUpdate: {
        phasedRegistrationNames: {
            bubbled: "onCompositionUpdate",
            captured: "onCompositionUpdateCapture"
        },
        dependencies: "blur compositionupdate keydown keypress keyup mousedown".split(" ")
    }
}, pe = !1;
function qe(a, b) {
    switch(a){
        case "keyup":
            return -1 !== ie.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "blur":
            return !0;
        default:
            return !1;
    }
}
function re(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var se = !1;
function te(a, b) {
    switch(a){
        case "compositionend":
            return re(b);
        case "keypress":
            if (32 !== b.which) return null;
            pe = !0;
            return ne;
        case "textInput":
            return a = b.data, a === ne && pe ? null : a;
        default:
            return null;
    }
}
function ue(a, b) {
    if (se) return "compositionend" === a || !je && qe(a, b) ? (a = ae(), $d = Zd = Yd = null, se = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return me && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var ve = {
    eventTypes: oe,
    extractEvents: function(a, b, c, d) {
        var e;
        if (je) b: {
            switch(a){
                case "compositionstart":
                    var f = oe.compositionStart;
                    break b;
                case "compositionend":
                    f = oe.compositionEnd;
                    break b;
                case "compositionupdate":
                    f = oe.compositionUpdate;
                    break b;
            }
            f = void 0;
        }
        else se ? qe(a, c) && (f = oe.compositionEnd) : "keydown" === a && 229 === c.keyCode && (f = oe.compositionStart);
        f ? (me && "ko" !== c.locale && (se || f !== oe.compositionStart ? f === oe.compositionEnd && se && (e = ae()) : (Yd = d, Zd = "value" in Yd ? Yd.value : Yd.textContent, se = !0)), f = ge.getPooled(f, b, c, d), e ? f.data = e : (e = re(c), null !== e && (f.data = e)), Xd(f), e = f) : e = null;
        (a = le ? te(a, c) : ue(a, c)) ? (b = he.getPooled(oe.beforeInput, b, c, d), b.data = a, Xd(b)) : b = null;
        return null === e ? b : null === b ? e : [
            e,
            b
        ];
    }
}, we = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function xe(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!we[a.type] : "textarea" === b ? !0 : !1;
}
var ye = {
    change: {
        phasedRegistrationNames: {
            bubbled: "onChange",
            captured: "onChangeCapture"
        },
        dependencies: "blur change click focus input keydown keyup selectionchange".split(" ")
    }
};
function ze(a, b, c) {
    a = G.getPooled(ye.change, a, b, c);
    a.type = "change";
    Da(c);
    Xd(a);
    return a;
}
var Ae = null, Be = null;
function Ce(a) {
    mc(a);
}
function De(a) {
    var b = Pd(a);
    if (yb(b)) return a;
}
function Ee(a, b) {
    if ("change" === a) return b;
}
var Fe = !1;
ya && (Fe = oc("input") && (!document.documentMode || 9 < document.documentMode));
function Ge() {
    Ae && (Ae.detachEvent("onpropertychange", He), Be = Ae = null);
}
function He(a) {
    if ("value" === a.propertyName && De(Be)) {
        if (a = ze(Be, a, nc(a)), Ja) mc(a);
        else {
            Ja = !0;
            try {
                Fa(Ce, a);
            } finally{
                Ja = !1, La();
            }
        }
    }
}
function Ie(a, b, c) {
    "focus" === a ? (Ge(), Ae = b, Be = c, Ae.attachEvent("onpropertychange", He)) : "blur" === a && Ge();
}
function Je(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return De(Be);
}
function Ke(a, b) {
    if ("click" === a) return De(b);
}
function Le(a, b) {
    if ("input" === a || "change" === a) return De(b);
}
var Me = {
    eventTypes: ye,
    _isInputEventSupported: Fe,
    extractEvents: function(a, b, c, d) {
        var e = b ? Pd(b) : window, f = e.nodeName && e.nodeName.toLowerCase();
        if ("select" === f || "input" === f && "file" === e.type) var g = Ee;
        else if (xe(e)) {
            if (Fe) g = Le;
            else {
                g = Je;
                var h = Ie;
            }
        } else (f = e.nodeName) && "input" === f.toLowerCase() && ("checkbox" === e.type || "radio" === e.type) && (g = Ke);
        if (g && (g = g(a, b))) return ze(g, c, d);
        h && h(a, e, b);
        "blur" === a && (a = e._wrapperState) && a.controlled && "number" === e.type && Db(e, "number", e.value);
    }
}, Ne = G.extend({
    view: null,
    detail: null
}), Oe = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function Pe(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = Oe[a]) ? !!b[a] : !1;
}
function Qe() {
    return Pe;
}
var Re = 0, Se = 0, Te = !1, Ue = !1, Ve = Ne.extend({
    screenX: null,
    screenY: null,
    clientX: null,
    clientY: null,
    pageX: null,
    pageY: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    getModifierState: Qe,
    button: null,
    buttons: null,
    relatedTarget: function(a) {
        return a.relatedTarget || (a.fromElement === a.srcElement ? a.toElement : a.fromElement);
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        var b = Re;
        Re = a.screenX;
        return Te ? "mousemove" === a.type ? a.screenX - b : 0 : (Te = !0, 0);
    },
    movementY: function(a) {
        if ("movementY" in a) return a.movementY;
        var b = Se;
        Se = a.screenY;
        return Ue ? "mousemove" === a.type ? a.screenY - b : 0 : (Ue = !0, 0);
    }
}), We = Ve.extend({
    pointerId: null,
    width: null,
    height: null,
    pressure: null,
    tangentialPressure: null,
    tiltX: null,
    tiltY: null,
    twist: null,
    pointerType: null,
    isPrimary: null
}), Xe = {
    mouseEnter: {
        registrationName: "onMouseEnter",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    mouseLeave: {
        registrationName: "onMouseLeave",
        dependencies: [
            "mouseout",
            "mouseover"
        ]
    },
    pointerEnter: {
        registrationName: "onPointerEnter",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    },
    pointerLeave: {
        registrationName: "onPointerLeave",
        dependencies: [
            "pointerout",
            "pointerover"
        ]
    }
}, Ye = {
    eventTypes: Xe,
    extractEvents: function(a, b, c, d, e) {
        var f = "mouseover" === a || "pointerover" === a, g = "mouseout" === a || "pointerout" === a;
        if (f && 0 === (e & 32) && (c.relatedTarget || c.fromElement) || !g && !f) return null;
        f = d.window === d ? d : (f = d.ownerDocument) ? f.defaultView || f.parentWindow : window;
        if (g) {
            if (g = b, b = (b = c.relatedTarget || c.toElement) ? tc(b) : null, null !== b) {
                var h = dc(b);
                if (b !== h || 5 !== b.tag && 6 !== b.tag) b = null;
            }
        } else g = null;
        if (g === b) return null;
        if ("mouseout" === a || "mouseover" === a) {
            var k = Ve;
            var l = Xe.mouseLeave;
            var m = Xe.mouseEnter;
            var p = "mouse";
        } else if ("pointerout" === a || "pointerover" === a) k = We, l = Xe.pointerLeave, m = Xe.pointerEnter, p = "pointer";
        a = null == g ? f : Pd(g);
        f = null == b ? f : Pd(b);
        l = k.getPooled(l, g, c, d);
        l.type = p + "leave";
        l.target = a;
        l.relatedTarget = f;
        c = k.getPooled(m, b, c, d);
        c.type = p + "enter";
        c.target = f;
        c.relatedTarget = a;
        d = g;
        p = b;
        if (d && p) a: {
            k = d;
            m = p;
            g = 0;
            for(a = k; a; a = Rd(a))g++;
            a = 0;
            for(b = m; b; b = Rd(b))a++;
            for(; 0 < g - a;)k = Rd(k), g--;
            for(; 0 < a - g;)m = Rd(m), a--;
            for(; g--;){
                if (k === m || k === m.alternate) break a;
                k = Rd(k);
                m = Rd(m);
            }
            k = null;
        }
        else k = null;
        m = k;
        for(k = []; d && d !== m;){
            g = d.alternate;
            if (null !== g && g === m) break;
            k.push(d);
            d = Rd(d);
        }
        for(d = []; p && p !== m;){
            g = p.alternate;
            if (null !== g && g === m) break;
            d.push(p);
            p = Rd(p);
        }
        for(p = 0; p < k.length; p++)Vd(k[p], "bubbled", l);
        for(p = d.length; 0 < p--;)Vd(d[p], "captured", c);
        return 0 === (e & 64) ? [
            l
        ] : [
            l,
            c
        ];
    }
};
function Ze(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $e = "function" === typeof Object.is ? Object.is : Ze, af = Object.prototype.hasOwnProperty;
function bf(a, b) {
    if ($e(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++)if (!af.call(b, c[d]) || !$e(a[c[d]], b[c[d]])) return !1;
    return !0;
}
var cf = ya && "documentMode" in document && 11 >= document.documentMode, df = {
    select: {
        phasedRegistrationNames: {
            bubbled: "onSelect",
            captured: "onSelectCapture"
        },
        dependencies: "blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")
    }
}, ef = null, ff = null, gf = null, hf = !1;
function jf(a, b) {
    var c = b.window === b ? b.document : 9 === b.nodeType ? b : b.ownerDocument;
    if (hf || null == ef || ef !== td(c)) return null;
    c = ef;
    "selectionStart" in c && yd(c) ? c = {
        start: c.selectionStart,
        end: c.selectionEnd
    } : (c = (c.ownerDocument && c.ownerDocument.defaultView || window).getSelection(), c = {
        anchorNode: c.anchorNode,
        anchorOffset: c.anchorOffset,
        focusNode: c.focusNode,
        focusOffset: c.focusOffset
    });
    return gf && bf(gf, c) ? null : (gf = c, a = G.getPooled(df.select, ff, a, b), a.type = "select", a.target = ef, Xd(a), a);
}
var kf = {
    eventTypes: df,
    extractEvents: function(a, b, c, d, e, f) {
        e = f || (d.window === d ? d.document : 9 === d.nodeType ? d : d.ownerDocument);
        if (!(f = !e)) {
            a: {
                e = cc(e);
                f = wa.onSelect;
                for(var g = 0; g < f.length; g++)if (!e.has(f[g])) {
                    e = !1;
                    break a;
                }
                e = !0;
            }
            f = !e;
        }
        if (f) return null;
        e = b ? Pd(b) : window;
        switch(a){
            case "focus":
                if (xe(e) || "true" === e.contentEditable) ef = e, ff = b, gf = null;
                break;
            case "blur":
                gf = ff = ef = null;
                break;
            case "mousedown":
                hf = !0;
                break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
                return hf = !1, jf(c, d);
            case "selectionchange":
                if (cf) break;
            case "keydown":
            case "keyup":
                return jf(c, d);
        }
        return null;
    }
}, lf = G.extend({
    animationName: null,
    elapsedTime: null,
    pseudoElement: null
}), mf = G.extend({
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), nf = Ne.extend({
    relatedTarget: null
});
function of(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
var pf = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, qf = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, rf = Ne.extend({
    key: function(a) {
        if (a.key) {
            var b = pf[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = of(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? qf[a.keyCode] || "Unidentified" : "";
    },
    location: null,
    ctrlKey: null,
    shiftKey: null,
    altKey: null,
    metaKey: null,
    repeat: null,
    locale: null,
    getModifierState: Qe,
    charCode: function(a) {
        return "keypress" === a.type ? of(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? of(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), sf = Ve.extend({
    dataTransfer: null
}), tf = Ne.extend({
    touches: null,
    targetTouches: null,
    changedTouches: null,
    altKey: null,
    metaKey: null,
    ctrlKey: null,
    shiftKey: null,
    getModifierState: Qe
}), uf = G.extend({
    propertyName: null,
    elapsedTime: null,
    pseudoElement: null
}), vf = Ve.extend({
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: null,
    deltaMode: null
}), wf = {
    eventTypes: Wc,
    extractEvents: function(a, b, c, d) {
        var e = Yc.get(a);
        if (!e) return null;
        switch(a){
            case "keypress":
                if (0 === of(c)) return null;
            case "keydown":
            case "keyup":
                a = rf;
                break;
            case "blur":
            case "focus":
                a = nf;
                break;
            case "click":
                if (2 === c.button) return null;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
                a = Ve;
                break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
                a = sf;
                break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
                a = tf;
                break;
            case Xb:
            case Yb:
            case Zb:
                a = lf;
                break;
            case $b:
                a = uf;
                break;
            case "scroll":
                a = Ne;
                break;
            case "wheel":
                a = vf;
                break;
            case "copy":
            case "cut":
            case "paste":
                a = mf;
                break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
                a = We;
                break;
            default:
                a = G;
        }
        b = a.getPooled(e, b, c, d);
        Xd(b);
        return b;
    }
};
if (pa) throw Error(u(101));
pa = Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
ra();
var xf = Nc;
la = Qd;
ma = xf;
na = Pd;
xa({
    SimpleEventPlugin: wf,
    EnterLeaveEventPlugin: Ye,
    ChangeEventPlugin: Me,
    SelectEventPlugin: kf,
    BeforeInputEventPlugin: ve
});
var yf = [], zf = -1;
function H(a) {
    0 > zf || (a.current = yf[zf], yf[zf] = null, zf--);
}
function I(a, b) {
    zf++;
    yf[zf] = a.current;
    a.current = b;
}
var Af = {}, J = {
    current: Af
}, K = {
    current: !1
}, Bf = Af;
function Cf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return Af;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function L(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function Df() {
    H(K);
    H(J);
}
function Ef(a, b, c) {
    if (J.current !== Af) throw Error(u(168));
    I(J, b);
    I(K, c);
}
function Ff(a, b, c) {
    var d = a.stateNode;
    a = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in a)) throw Error(u(108, pb(b) || "Unknown", e));
    return $38COw({}, c, {}, d);
}
function Gf(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || Af;
    Bf = J.current;
    I(J, a);
    I(K, K.current);
    return !0;
}
function Hf(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error(u(169));
    c ? (a = Ff(a, b, Bf), d.__reactInternalMemoizedMergedChildContext = a, H(K), H(J), I(J, a)) : H(K);
    I(K, c);
}
var If = $3hvsM.unstable_runWithPriority, Jf = $3hvsM.unstable_scheduleCallback, Kf = $3hvsM.unstable_cancelCallback, Lf = $3hvsM.unstable_requestPaint, Mf = $3hvsM.unstable_now, Nf = $3hvsM.unstable_getCurrentPriorityLevel, Of = $3hvsM.unstable_ImmediatePriority, Pf = $3hvsM.unstable_UserBlockingPriority, Qf = $3hvsM.unstable_NormalPriority, Rf = $3hvsM.unstable_LowPriority, Sf = $3hvsM.unstable_IdlePriority, Tf = {}, Uf = $3hvsM.unstable_shouldYield, Vf = void 0 !== Lf ? Lf : function() {}, Wf = null, Xf = null, Yf = !1, Zf = Mf(), $f = 1E4 > Zf ? Mf : function() {
    return Mf() - Zf;
};
function ag() {
    switch(Nf()){
        case Of:
            return 99;
        case Pf:
            return 98;
        case Qf:
            return 97;
        case Rf:
            return 96;
        case Sf:
            return 95;
        default:
            throw Error(u(332));
    }
}
function bg(a) {
    switch(a){
        case 99:
            return Of;
        case 98:
            return Pf;
        case 97:
            return Qf;
        case 96:
            return Rf;
        case 95:
            return Sf;
        default:
            throw Error(u(332));
    }
}
function cg(a, b) {
    a = bg(a);
    return If(a, b);
}
function dg(a, b, c) {
    a = bg(a);
    return Jf(a, b, c);
}
function eg(a) {
    null === Wf ? (Wf = [
        a
    ], Xf = Jf(Of, fg)) : Wf.push(a);
    return Tf;
}
function gg() {
    if (null !== Xf) {
        var a = Xf;
        Xf = null;
        Kf(a);
    }
    fg();
}
function fg() {
    if (!Yf && null !== Wf) {
        Yf = !0;
        var a = 0;
        try {
            var b = Wf;
            cg(99, function() {
                for(; a < b.length; a++){
                    var c = b[a];
                    do c = c(!0);
                    while (null !== c);
                }
            });
            Wf = null;
        } catch (c) {
            throw null !== Wf && (Wf = Wf.slice(a + 1)), Jf(Of, gg), c;
        } finally{
            Yf = !1;
        }
    }
}
function hg(a, b, c) {
    c /= 10;
    return 1073741821 - (((1073741821 - a + b / 10) / c | 0) + 1) * c;
}
function ig(a, b) {
    if (a && a.defaultProps) {
        b = $38COw({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
    }
    return b;
}
var jg = {
    current: null
}, kg = null, lg = null, mg = null;
function ng() {
    mg = lg = kg = null;
}
function og(a) {
    var b = jg.current;
    H(jg);
    a.type._context._currentValue = b;
}
function pg(a, b) {
    for(; null !== a;){
        var c = a.alternate;
        if (a.childExpirationTime < b) a.childExpirationTime = b, null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        else if (null !== c && c.childExpirationTime < b) c.childExpirationTime = b;
        else break;
        a = a.return;
    }
}
function qg(a, b) {
    kg = a;
    mg = lg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (a.expirationTime >= b && (rg = !0), a.firstContext = null);
}
function sg(a, b) {
    if (mg !== a && !1 !== b && 0 !== b) {
        if ("number" !== typeof b || 1073741823 === b) mg = a, b = 1073741823;
        b = {
            context: a,
            observedBits: b,
            next: null
        };
        if (null === lg) {
            if (null === kg) throw Error(u(308));
            lg = b;
            kg.dependencies = {
                expirationTime: 0,
                firstContext: b,
                responders: null
            };
        } else lg = lg.next = b;
    }
    return a._currentValue;
}
var tg = !1;
function ug(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        baseQueue: null,
        shared: {
            pending: null
        },
        effects: null
    };
}
function vg(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        baseQueue: a.baseQueue,
        shared: a.shared,
        effects: a.effects
    });
}
function wg(a, b) {
    a = {
        expirationTime: a,
        suspenseConfig: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
    return a.next = a;
}
function xg(a, b) {
    a = a.updateQueue;
    if (null !== a) {
        a = a.shared;
        var c = a.pending;
        null === c ? b.next = b : (b.next = c.next, c.next = b);
        a.pending = b;
    }
}
function yg(a, b) {
    var c = a.alternate;
    null !== c && vg(c, a);
    a = a.updateQueue;
    c = a.baseQueue;
    null === c ? (a.baseQueue = b.next = b, b.next = b) : (b.next = c.next, c.next = b);
}
function zg(a, b, c, d) {
    var e = a.updateQueue;
    tg = !1;
    var f = e.baseQueue, g = e.shared.pending;
    if (null !== g) {
        if (null !== f) {
            var h = f.next;
            f.next = g.next;
            g.next = h;
        }
        f = g;
        e.shared.pending = null;
        h = a.alternate;
        null !== h && (h = h.updateQueue, null !== h && (h.baseQueue = g));
    }
    if (null !== f) {
        h = f.next;
        var k = e.baseState, l = 0, m = null, p = null, x = null;
        if (null !== h) {
            var z = h;
            do {
                g = z.expirationTime;
                if (g < d) {
                    var ca = {
                        expirationTime: z.expirationTime,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    };
                    null === x ? (p = x = ca, m = k) : x = x.next = ca;
                    g > l && (l = g);
                } else {
                    null !== x && (x = x.next = {
                        expirationTime: 1073741823,
                        suspenseConfig: z.suspenseConfig,
                        tag: z.tag,
                        payload: z.payload,
                        callback: z.callback,
                        next: null
                    });
                    Ag(g, z.suspenseConfig);
                    a: {
                        var D = a, t = z;
                        g = b;
                        ca = c;
                        switch(t.tag){
                            case 1:
                                D = t.payload;
                                if ("function" === typeof D) {
                                    k = D.call(ca, k, g);
                                    break a;
                                }
                                k = D;
                                break a;
                            case 3:
                                D.effectTag = D.effectTag & -4097 | 64;
                            case 0:
                                D = t.payload;
                                g = "function" === typeof D ? D.call(ca, k, g) : D;
                                if (null === g || void 0 === g) break a;
                                k = $38COw({}, k, g);
                                break a;
                            case 2:
                                tg = !0;
                        }
                    }
                    null !== z.callback && (a.effectTag |= 32, g = e.effects, null === g ? e.effects = [
                        z
                    ] : g.push(z));
                }
                z = z.next;
                if (null === z || z === h) {
                    if (g = e.shared.pending, null === g) break;
                    else z = f.next = g.next, g.next = h, e.baseQueue = f = g, e.shared.pending = null;
                }
            }while (1);
        }
        null === x ? m = k : x.next = p;
        e.baseState = m;
        e.baseQueue = x;
        Bg(l);
        a.expirationTime = l;
        a.memoizedState = k;
    }
}
function Cg(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = e;
            e = c;
            if ("function" !== typeof d) throw Error(u(191, d));
            d.call(e);
        }
    }
}
var Dg = Wa.ReactCurrentBatchConfig, Eg = (new $5FkrB.Component).refs;
function Fg(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $38COw({}, b, c);
    a.memoizedState = c;
    0 === a.expirationTime && (a.updateQueue.baseState = c);
}
var Jg = {
    isMounted: function(a) {
        return (a = a._reactInternalFiber) ? dc(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternalFiber;
        var d = Gg(), e = Dg.suspense;
        d = Hg(d, a, e);
        e = wg(d, e);
        e.tag = 1;
        e.payload = b;
        void 0 !== c && null !== c && (e.callback = c);
        xg(a, e);
        Ig(a, d);
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternalFiber;
        var c = Gg(), d = Dg.suspense;
        c = Hg(c, a, d);
        d = wg(c, d);
        d.tag = 2;
        void 0 !== b && null !== b && (d.callback = b);
        xg(a, d);
        Ig(a, c);
    }
};
function Kg(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !bf(c, d) || !bf(e, f) : !0;
}
function Lg(a, b, c) {
    var d = !1, e = Af;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = sg(f) : (e = L(b) ? Bf : J.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? Cf(a, e) : Af);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = Jg;
    a.stateNode = b;
    b._reactInternalFiber = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function Mg(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && Jg.enqueueReplaceState(b, b.state, null);
}
function Ng(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = Eg;
    ug(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = sg(f) : (f = L(b) ? Bf : J.current, e.context = Cf(a, f));
    zg(a, c, e, d);
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && (Fg(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && Jg.enqueueReplaceState(e, e.state, null), zg(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.effectTag |= 4);
}
var Og = Array.isArray;
function Pg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error(u(309));
                var d = c.stateNode;
            }
            if (!d) throw Error(u(147, a));
            var e = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === e) return b.ref;
            b = function(a) {
                var b = d.refs;
                b === Eg && (b = d.refs = {});
                null === a ? delete b[e] : b[e] = a;
            };
            b._stringRef = e;
            return b;
        }
        if ("string" !== typeof a) throw Error(u(284));
        if (!c._owner) throw Error(u(290, a));
    }
    return a;
}
function Qg(a, b) {
    if ("textarea" !== a.type) throw Error(u(31, "[object Object]" === Object.prototype.toString.call(b) ? "object with keys {" + Object.keys(b).join(", ") + "}" : b, ""));
}
function Rg(a) {
    function b(b, c) {
        if (a) {
            var d = b.lastEffect;
            null !== d ? (d.nextEffect = c, b.lastEffect = c) : b.firstEffect = b.lastEffect = c;
            c.nextEffect = null;
            c.effectTag = 8;
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = Sg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.effectTag = 2, c) : d;
        b.effectTag = 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.effectTag = 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = Tg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        if (null !== b && b.elementType === c.type) return d = e(b, c.props), d.ref = Pg(a, b, c), d.return = a, d;
        d = Ug(c.type, c.key, c.props, null, a.mode, d);
        d.ref = Pg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = Vg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = Wg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function p(a, b, c) {
        if ("string" === typeof b || "number" === typeof b) return b = Tg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case Za:
                    return c = Ug(b.type, b.key, b.props, null, a.mode, c), c.ref = Pg(a, null, b), c.return = a, c;
                case $a:
                    return b = Vg(b, a.mode, c), b.return = a, b;
            }
            if (Og(b) || nb(b)) return b = Wg(b, a.mode, c, null), b.return = a, b;
            Qg(a, b);
        }
        return null;
    }
    function x(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case Za:
                    return c.key === e ? c.type === ab ? m(a, b, c.props.children, d, e) : k(a, b, c, d) : null;
                case $a:
                    return c.key === e ? l(a, b, c, d) : null;
            }
            if (Og(c) || nb(c)) return null !== e ? null : m(a, b, c, d, null);
            Qg(a, c);
        }
        return null;
    }
    function z(a, b, c, d, e) {
        if ("string" === typeof d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case Za:
                    return a = a.get(null === d.key ? c : d.key) || null, d.type === ab ? m(b, a, d.props.children, e, d.key) : k(b, a, d, e);
                case $a:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
            }
            if (Og(d) || nb(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            Qg(b, d);
        }
        return null;
    }
    function ca(e, g, h, k) {
        for(var l = null, t = null, m = g, y = g = 0, A = null; null !== m && y < h.length; y++){
            m.index > y ? (A = m, m = null) : A = m.sibling;
            var q = x(e, m, h[y], k);
            if (null === q) {
                null === m && (m = A);
                break;
            }
            a && m && null === q.alternate && b(e, m);
            g = f(q, g, y);
            null === t ? l = q : t.sibling = q;
            t = q;
            m = A;
        }
        if (y === h.length) return c(e, m), l;
        if (null === m) {
            for(; y < h.length; y++)m = p(e, h[y], k), null !== m && (g = f(m, g, y), null === t ? l = m : t.sibling = m, t = m);
            return l;
        }
        for(m = d(e, m); y < h.length; y++)A = z(m, e, y, h[y], k), null !== A && (a && null !== A.alternate && m.delete(null === A.key ? y : A.key), g = f(A, g, y), null === t ? l = A : t.sibling = A, t = A);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        return l;
    }
    function D(e, g, h, l) {
        var k = nb(h);
        if ("function" !== typeof k) throw Error(u(150));
        h = k.call(h);
        if (null == h) throw Error(u(151));
        for(var m = k = null, t = g, y = g = 0, A = null, q = h.next(); null !== t && !q.done; y++, q = h.next()){
            t.index > y ? (A = t, t = null) : A = t.sibling;
            var D = x(e, t, q.value, l);
            if (null === D) {
                null === t && (t = A);
                break;
            }
            a && t && null === D.alternate && b(e, t);
            g = f(D, g, y);
            null === m ? k = D : m.sibling = D;
            m = D;
            t = A;
        }
        if (q.done) return c(e, t), k;
        if (null === t) {
            for(; !q.done; y++, q = h.next())q = p(e, q.value, l), null !== q && (g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
            return k;
        }
        for(t = d(e, t); !q.done; y++, q = h.next())q = z(t, e, y, q.value, l), null !== q && (a && null !== q.alternate && t.delete(null === q.key ? y : q.key), g = f(q, g, y), null === m ? k = q : m.sibling = q, m = q);
        a && t.forEach(function(a) {
            return b(e, a);
        });
        return k;
    }
    return function(a, d, f, h) {
        var k = "object" === typeof f && null !== f && f.type === ab && null === f.key;
        k && (f = f.props.children);
        var l = "object" === typeof f && null !== f;
        if (l) switch(f.$$typeof){
            case Za:
                a: {
                    l = f.key;
                    for(k = d; null !== k;){
                        if (k.key === l) {
                            switch(k.tag){
                                case 7:
                                    if (f.type === ab) {
                                        c(a, k.sibling);
                                        d = e(k, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                    break;
                                default:
                                    if (k.elementType === f.type) {
                                        c(a, k.sibling);
                                        d = e(k, f.props);
                                        d.ref = Pg(a, k, f);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                            }
                            c(a, k);
                            break;
                        } else b(a, k);
                        k = k.sibling;
                    }
                    f.type === ab ? (d = Wg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = Ug(f.type, f.key, f.props, null, a.mode, h), h.ref = Pg(a, d, f), h.return = a, a = h);
                }
                return g(a);
            case $a:
                a: {
                    for(k = f.key; null !== d;){
                        if (d.key === k) {
                            if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                c(a, d.sibling);
                                d = e(d, f.children || []);
                                d.return = a;
                                a = d;
                                break a;
                            } else {
                                c(a, d);
                                break;
                            }
                        } else b(a, d);
                        d = d.sibling;
                    }
                    d = Vg(f, a.mode, h);
                    d.return = a;
                    a = d;
                }
                return g(a);
        }
        if ("string" === typeof f || "number" === typeof f) return f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = Tg(f, a.mode, h), d.return = a, a = d), g(a);
        if (Og(f)) return ca(a, d, f, h);
        if (nb(f)) return D(a, d, f, h);
        l && Qg(a, f);
        if ("undefined" === typeof f && !k) switch(a.tag){
            case 1:
            case 0:
                throw a = a.type, Error(u(152, a.displayName || a.name || "Component"));
        }
        return c(a, d);
    };
}
var Xg = Rg(!0), Yg = Rg(!1), Zg = {}, $g = {
    current: Zg
}, ah = {
    current: Zg
}, bh = {
    current: Zg
};
function ch(a) {
    if (a === Zg) throw Error(u(174));
    return a;
}
function dh(a, b) {
    I(bh, b);
    I(ah, a);
    I($g, Zg);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : Ob(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = Ob(b, a);
    }
    H($g);
    I($g, b);
}
function eh() {
    H($g);
    H(ah);
    H(bh);
}
function fh(a) {
    ch(bh.current);
    var b = ch($g.current);
    var c = Ob(b, a.type);
    b !== c && (I(ah, a), I($g, c));
}
function gh(a) {
    ah.current === a && (H($g), H(ah));
}
var M = {
    current: 0
};
function hh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || c.data === Bd || c.data === Cd)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.effectTag & 64)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
function ih(a, b) {
    return {
        responder: a,
        props: b
    };
}
var jh = Wa.ReactCurrentDispatcher, kh = Wa.ReactCurrentBatchConfig, lh = 0, N = null, O = null, P = null, mh = !1;
function Q() {
    throw Error(u(321));
}
function nh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$e(a[c], b[c])) return !1;
    return !0;
}
function oh(a, b, c, d, e, f) {
    lh = f;
    N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.expirationTime = 0;
    jh.current = null === a || null === a.memoizedState ? ph : qh;
    a = c(d, e);
    if (b.expirationTime === lh) {
        f = 0;
        do {
            b.expirationTime = 0;
            if (!(25 > f)) throw Error(u(301));
            f += 1;
            P = O = null;
            b.updateQueue = null;
            jh.current = rh;
            a = c(d, e);
        }while (b.expirationTime === lh);
    }
    jh.current = sh;
    b = null !== O && null !== O.next;
    lh = 0;
    P = O = N = null;
    mh = !1;
    if (b) throw Error(u(300));
    return a;
}
function th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === P ? N.memoizedState = P = a : P = P.next = a;
    return P;
}
function uh() {
    if (null === O) {
        var a = N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = O.next;
    var b = null === P ? N.memoizedState : P.next;
    if (null !== b) P = b, O = a;
    else {
        if (null === a) throw Error(u(310));
        O = a;
        a = {
            memoizedState: O.memoizedState,
            baseState: O.baseState,
            baseQueue: O.baseQueue,
            queue: O.queue,
            next: null
        };
        null === P ? N.memoizedState = P = a : P = P.next = a;
    }
    return P;
}
function vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function wh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        e = e.next;
        d = d.baseState;
        var h = g = f = null, k = e;
        do {
            var l = k.expirationTime;
            if (l < lh) {
                var m = {
                    expirationTime: k.expirationTime,
                    suspenseConfig: k.suspenseConfig,
                    action: k.action,
                    eagerReducer: k.eagerReducer,
                    eagerState: k.eagerState,
                    next: null
                };
                null === h ? (g = h = m, f = d) : h = h.next = m;
                l > N.expirationTime && (N.expirationTime = l, Bg(l));
            } else null !== h && (h = h.next = {
                expirationTime: 1073741823,
                suspenseConfig: k.suspenseConfig,
                action: k.action,
                eagerReducer: k.eagerReducer,
                eagerState: k.eagerState,
                next: null
            }), Ag(l, k.suspenseConfig), d = k.eagerReducer === a ? k.eagerState : a(d, k.action);
            k = k.next;
        }while (null !== k && k !== e);
        null === h ? f = d : h.next = g;
        $e(d, b.memoizedState) || (rg = !0);
        b.memoizedState = d;
        b.baseState = f;
        b.baseQueue = h;
        c.lastRenderedState = d;
    }
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function xh(a) {
    var b = uh(), c = b.queue;
    if (null === c) throw Error(u(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $e(f, b.memoizedState) || (rg = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function yh(a) {
    var b = th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = b.queue = {
        pending: null,
        dispatch: null,
        lastRenderedReducer: vh,
        lastRenderedState: a
    };
    a = a.dispatch = zh.bind(null, N, a);
    return [
        b.memoizedState,
        a
    ];
}
function Ah(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = N.updateQueue;
    null === b ? (b = {
        lastEffect: null
    }, N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function Bh() {
    return uh().memoizedState;
}
function Ch(a, b, c, d) {
    var e = th();
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, void 0, void 0 === d ? null : d);
}
function Dh(a, b, c, d) {
    var e = uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== O) {
        var g = O.memoizedState;
        f = g.destroy;
        if (null !== d && nh(d, g.deps)) {
            Ah(b, c, f, d);
            return;
        }
    }
    N.effectTag |= a;
    e.memoizedState = Ah(1 | b, c, f, d);
}
function Eh(a, b) {
    return Ch(516, 4, a, b);
}
function Fh(a, b) {
    return Dh(516, 4, a, b);
}
function Gh(a, b) {
    return Dh(4, 2, a, b);
}
function Hh(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function Ih(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return Dh(4, 2, Hh.bind(null, b, a), c);
}
function Jh() {}
function Kh(a, b) {
    th().memoizedState = [
        a,
        void 0 === b ? null : b
    ];
    return a;
}
function Lh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Mh(a, b) {
    var c = uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && nh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function Nh(a, b, c) {
    var d = ag();
    cg(98 > d ? 98 : d, function() {
        a(!0);
    });
    cg(97 < d ? 97 : d, function() {
        var d = kh.suspense;
        kh.suspense = void 0 === b ? null : b;
        try {
            a(!1), c();
        } finally{
            kh.suspense = d;
        }
    });
}
function zh(a, b, c) {
    var d = Gg(), e = Dg.suspense;
    d = Hg(d, a, e);
    e = {
        expirationTime: d,
        suspenseConfig: e,
        action: c,
        eagerReducer: null,
        eagerState: null,
        next: null
    };
    var f = b.pending;
    null === f ? e.next = e : (e.next = f.next, f.next = e);
    b.pending = e;
    f = a.alternate;
    if (a === N || null !== f && f === N) mh = !0, e.expirationTime = lh, N.expirationTime = lh;
    else {
        if (0 === a.expirationTime && (null === f || 0 === f.expirationTime) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.eagerReducer = f;
            e.eagerState = h;
            if ($e(h, g)) return;
        } catch (k) {} finally{}
        Ig(a, d);
    }
}
var sh = {
    readContext: sg,
    useCallback: Q,
    useContext: Q,
    useEffect: Q,
    useImperativeHandle: Q,
    useLayoutEffect: Q,
    useMemo: Q,
    useReducer: Q,
    useRef: Q,
    useState: Q,
    useDebugValue: Q,
    useResponder: Q,
    useDeferredValue: Q,
    useTransition: Q
}, ph = {
    readContext: sg,
    useCallback: Kh,
    useContext: sg,
    useEffect: Eh,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return Ch(4, 2, Hh.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return Ch(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = d.queue = {
            pending: null,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        a = a.dispatch = zh.bind(null, N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: yh,
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = yh(a), d = c[0], e = c[1];
        Eh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = yh(!1), c = b[0];
        b = b[1];
        return [
            Kh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, qh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: wh,
    useRef: Bh,
    useState: function() {
        return wh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = wh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = wh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, rh = {
    readContext: sg,
    useCallback: Lh,
    useContext: sg,
    useEffect: Fh,
    useImperativeHandle: Ih,
    useLayoutEffect: Gh,
    useMemo: Mh,
    useReducer: xh,
    useRef: Bh,
    useState: function() {
        return xh(vh);
    },
    useDebugValue: Jh,
    useResponder: ih,
    useDeferredValue: function(a, b) {
        var c = xh(vh), d = c[0], e = c[1];
        Fh(function() {
            var c = kh.suspense;
            kh.suspense = void 0 === b ? null : b;
            try {
                e(a);
            } finally{
                kh.suspense = c;
            }
        }, [
            a,
            b
        ]);
        return d;
    },
    useTransition: function(a) {
        var b = xh(vh), c = b[0];
        b = b[1];
        return [
            Lh(Nh.bind(null, b, a), [
                b,
                a
            ]),
            c
        ];
    }
}, Oh = null, Ph = null, Qh = !1;
function Rh(a, b) {
    var c = Sh(5, null, null, 0);
    c.elementType = "DELETED";
    c.type = "DELETED";
    c.stateNode = b;
    c.return = a;
    c.effectTag = 8;
    null !== a.lastEffect ? (a.lastEffect.nextEffect = c, a.lastEffect = c) : a.firstEffect = a.lastEffect = c;
}
function Th(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, !0) : !1;
        case 13:
            return !1;
        default:
            return !1;
    }
}
function Uh(a) {
    if (Qh) {
        var b = Ph;
        if (b) {
            var c = b;
            if (!Th(a, b)) {
                b = Jd(c.nextSibling);
                if (!b || !Th(a, b)) {
                    a.effectTag = a.effectTag & -1025 | 2;
                    Qh = !1;
                    Oh = a;
                    return;
                }
                Rh(Oh, c);
            }
            Oh = a;
            Ph = Jd(b.firstChild);
        } else a.effectTag = a.effectTag & -1025 | 2, Qh = !1, Oh = a;
    }
}
function Vh(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    Oh = a;
}
function Wh(a) {
    if (a !== Oh) return !1;
    if (!Qh) return Vh(a), Qh = !0, !1;
    var b = a.type;
    if (5 !== a.tag || "head" !== b && "body" !== b && !Gd(b, a.memoizedProps)) for(b = Ph; b;)Rh(a, b), b = Jd(b.nextSibling);
    Vh(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error(u(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if (c === Ad) {
                        if (0 === b) {
                            Ph = Jd(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else c !== zd && c !== Cd && c !== Bd || b++;
                }
                a = a.nextSibling;
            }
            Ph = null;
        }
    } else Ph = Oh ? Jd(a.stateNode.nextSibling) : null;
    return !0;
}
function Xh() {
    Ph = Oh = null;
    Qh = !1;
}
var Yh = Wa.ReactCurrentOwner, rg = !1;
function R(a, b, c, d) {
    b.child = null === a ? Yg(b, null, c, d) : Xg(b, a.child, c, d);
}
function Zh(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    qg(b, e);
    d = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, d, e);
    return b.child;
}
function ai(a, b, c, d, e, f) {
    if (null === a) {
        var g = c.type;
        if ("function" === typeof g && !bi(g) && void 0 === g.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = g, ci(a, b, g, d, e, f);
        a = Ug(c.type, null, d, null, b.mode, f);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    g = a.child;
    if (e < f && (e = g.memoizedProps, c = c.compare, c = null !== c ? c : bf, c(e, d) && a.ref === b.ref)) return $h(a, b, f);
    b.effectTag |= 1;
    a = Sg(g, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function ci(a, b, c, d, e, f) {
    return null !== a && bf(a.memoizedProps, d) && a.ref === b.ref && (rg = !1, e < f) ? (b.expirationTime = a.expirationTime, $h(a, b, f)) : di(a, b, c, d, f);
}
function ei(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.effectTag |= 128;
}
function di(a, b, c, d, e) {
    var f = L(c) ? Bf : J.current;
    f = Cf(b, f);
    qg(b, e);
    c = oh(a, b, c, d, f, e);
    if (null !== a && !rg) return b.updateQueue = a.updateQueue, b.effectTag &= -517, a.expirationTime <= e && (a.expirationTime = 0), $h(a, b, e);
    b.effectTag |= 1;
    R(a, b, c, e);
    return b.child;
}
function fi(a, b, c, d, e) {
    if (L(c)) {
        var f = !0;
        Gf(b);
    } else f = !1;
    qg(b, e);
    if (null === b.stateNode) null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), Lg(b, c, d), Ng(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l));
        var m = c.getDerivedStateFromProps, p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        p || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l);
        tg = !1;
        var x = b.memoizedState;
        g.state = x;
        zg(b, d, g, e);
        k = b.memoizedState;
        h !== d || x !== k || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), k = b.memoizedState), (h = tg || Kg(b, c, h, d, x, k, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.effectTag |= 4)) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.effectTag |= 4), d = !1);
    } else g = b.stateNode, vg(a, b), h = b.memoizedProps, g.props = b.type === b.elementType ? h : ig(b.type, h), k = g.context, l = c.contextType, "object" === typeof l && null !== l ? l = sg(l) : (l = L(c) ? Bf : J.current, l = Cf(b, l)), m = c.getDerivedStateFromProps, (p = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && Mg(b, g, d, l), tg = !1, k = b.memoizedState, g.state = k, zg(b, d, g, e), x = b.memoizedState, h !== d || k !== x || K.current || tg ? ("function" === typeof m && (Fg(b, c, m, d), x = b.memoizedState), (m = tg || Kg(b, c, h, d, k, x, l)) ? (p || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, x, l), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, x, l)), "function" === typeof g.componentDidUpdate && (b.effectTag |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.effectTag |= 256)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), b.memoizedProps = d, b.memoizedState = x), g.props = d, g.state = x, g.context = l, d = m) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && k === a.memoizedState || (b.effectTag |= 256), d = !1);
    return gi(a, b, c, d, f, e);
}
function gi(a, b, c, d, e, f) {
    ei(a, b);
    var g = 0 !== (b.effectTag & 64);
    if (!d && !g) return e && Hf(b, c, !1), $h(a, b, f);
    d = b.stateNode;
    Yh.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.effectTag |= 1;
    null !== a && g ? (b.child = Xg(b, a.child, null, f), b.child = Xg(b, null, h, f)) : R(a, b, h, f);
    b.memoizedState = d.state;
    e && Hf(b, c, !0);
    return b.child;
}
function hi(a) {
    var b = a.stateNode;
    b.pendingContext ? Ef(a, b.pendingContext, b.pendingContext !== b.context) : b.context && Ef(a, b.context, !1);
    dh(a, b.containerInfo);
}
var ii = {
    dehydrated: null,
    retryTime: 0
};
function ji(a, b, c) {
    var d = b.mode, e = b.pendingProps, f = M.current, g = !1, h;
    (h = 0 !== (b.effectTag & 64)) || (h = 0 !== (f & 2) && (null === a || null !== a.memoizedState));
    h ? (g = !0, b.effectTag &= -65) : null !== a && null === a.memoizedState || void 0 === e.fallback || !0 === e.unstable_avoidThisFallback || (f |= 1);
    I(M, f & 1);
    if (null === a) {
        void 0 !== e.fallback && Uh(b);
        if (g) {
            g = e.fallback;
            e = Wg(null, d, 0, null);
            e.return = b;
            if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
            c = Wg(g, d, c, null);
            c.return = b;
            e.sibling = c;
            b.memoizedState = ii;
            b.child = e;
            return c;
        }
        d = e.children;
        b.memoizedState = null;
        return b.child = Yg(b, null, d, c);
    }
    if (null !== a.memoizedState) {
        a = a.child;
        d = a.sibling;
        if (g) {
            e = e.fallback;
            c = Sg(a, a.pendingProps);
            c.return = b;
            if (0 === (b.mode & 2) && (g = null !== b.memoizedState ? b.child.child : b.child, g !== a.child)) for(c.child = g; null !== g;)g.return = c, g = g.sibling;
            d = Sg(d, e);
            d.return = b;
            c.sibling = d;
            c.childExpirationTime = 0;
            b.memoizedState = ii;
            b.child = c;
            return d;
        }
        c = Xg(b, a.child, e.children, c);
        b.memoizedState = null;
        return b.child = c;
    }
    a = a.child;
    if (g) {
        g = e.fallback;
        e = Wg(null, d, 0, null);
        e.return = b;
        e.child = a;
        null !== a && (a.return = e);
        if (0 === (b.mode & 2)) for(a = null !== b.memoizedState ? b.child.child : b.child, e.child = a; null !== a;)a.return = e, a = a.sibling;
        c = Wg(g, d, c, null);
        c.return = b;
        e.sibling = c;
        c.effectTag |= 2;
        e.childExpirationTime = 0;
        b.memoizedState = ii;
        b.child = e;
        return c;
    }
    b.memoizedState = null;
    return b.child = Xg(b, a, e.children, c);
}
function ki(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    pg(a.return, b);
}
function li(a, b, c, d, e, f) {
    var g = a.memoizedState;
    null === g ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailExpiration: 0,
        tailMode: e,
        lastEffect: f
    } : (g.isBackwards = b, g.rendering = null, g.renderingStartTime = 0, g.last = d, g.tail = c, g.tailExpiration = 0, g.tailMode = e, g.lastEffect = f);
}
function mi(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    R(a, b, d.children, c);
    d = M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.effectTag |= 64;
    else {
        if (null !== a && 0 !== (a.effectTag & 64)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && ki(a, c);
            else if (19 === a.tag) ki(a, c);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    I(M, d);
    if (0 === (b.mode & 2)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === hh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            li(b, !1, e, c, f, b.lastEffect);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === hh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            li(b, !0, c, null, f, b.lastEffect);
            break;
        case "together":
            li(b, !1, null, null, void 0, b.lastEffect);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $h(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    var d = b.expirationTime;
    0 !== d && Bg(d);
    if (b.childExpirationTime < c) return null;
    if (null !== a && b.child !== a.child) throw Error(u(153));
    if (null !== b.child) {
        a = b.child;
        c = Sg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = Sg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
var ni, oi, pi, qi;
ni = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
oi = function() {};
pi = function(a, b, c, d, e) {
    var f = a.memoizedProps;
    if (f !== d) {
        var g = b.stateNode;
        ch($g.current);
        a = null;
        switch(c){
            case "input":
                f = zb(g, f);
                d = zb(g, d);
                a = [];
                break;
            case "option":
                f = Gb(g, f);
                d = Gb(g, d);
                a = [];
                break;
            case "select":
                f = $38COw({}, f, {
                    value: void 0
                });
                d = $38COw({}, d, {
                    value: void 0
                });
                a = [];
                break;
            case "textarea":
                f = Ib(g, f);
                d = Ib(g, d);
                a = [];
                break;
            default:
                "function" !== typeof f.onClick && "function" === typeof d.onClick && (g.onclick = sd);
        }
        od(c, d);
        var h, k;
        c = null;
        for(h in f)if (!d.hasOwnProperty(h) && f.hasOwnProperty(h) && null != f[h]) {
            if ("style" === h) for(k in g = f[h], g)g.hasOwnProperty(k) && (c || (c = {}), c[k] = "");
            else "dangerouslySetInnerHTML" !== h && "children" !== h && "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && "autoFocus" !== h && (va.hasOwnProperty(h) ? a || (a = []) : (a = a || []).push(h, null));
        }
        for(h in d){
            var l = d[h];
            g = null != f ? f[h] : void 0;
            if (d.hasOwnProperty(h) && l !== g && (null != l || null != g)) {
                if ("style" === h) {
                    if (g) {
                        for(k in g)!g.hasOwnProperty(k) || l && l.hasOwnProperty(k) || (c || (c = {}), c[k] = "");
                        for(k in l)l.hasOwnProperty(k) && g[k] !== l[k] && (c || (c = {}), c[k] = l[k]);
                    } else c || (a || (a = []), a.push(h, c)), c = l;
                } else "dangerouslySetInnerHTML" === h ? (l = l ? l.__html : void 0, g = g ? g.__html : void 0, null != l && g !== l && (a = a || []).push(h, l)) : "children" === h ? g === l || "string" !== typeof l && "number" !== typeof l || (a = a || []).push(h, "" + l) : "suppressContentEditableWarning" !== h && "suppressHydrationWarning" !== h && (va.hasOwnProperty(h) ? (null != l && rd(e, h), a || g === l || (a = [])) : (a = a || []).push(h, l));
            }
        }
        c && (a = a || []).push("style", c);
        e = a;
        if (b.updateQueue = e) b.effectTag |= 4;
    }
};
qi = function(a, b, c, d) {
    c !== d && (b.effectTag |= 4);
};
function ri(a, b) {
    switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function si(a, b, c) {
    var d = b.pendingProps;
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return null;
        case 1:
            return L(b.type) && Df(), null;
        case 3:
            return eh(), H(K), H(J), c = b.stateNode, c.pendingContext && (c.context = c.pendingContext, c.pendingContext = null), null !== a && null !== a.child || !Wh(b) || (b.effectTag |= 4), oi(b), null;
        case 5:
            gh(b);
            c = ch(bh.current);
            var e = b.type;
            if (null !== a && null != b.stateNode) pi(a, b, e, d, c), a.ref !== b.ref && (b.effectTag |= 128);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error(u(166));
                    return null;
                }
                a = ch($g.current);
                if (Wh(b)) {
                    d = b.stateNode;
                    e = b.type;
                    var f = b.memoizedProps;
                    d[Md] = b;
                    d[Nd] = f;
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(a = 0; a < ac.length; a++)F(ac[a], d);
                            break;
                        case "source":
                            F("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", d);
                            F("load", d);
                            break;
                        case "form":
                            F("reset", d);
                            F("submit", d);
                            break;
                        case "details":
                            F("toggle", d);
                            break;
                        case "input":
                            Ab(d, f);
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            F("invalid", d);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(d, f), F("invalid", d), rd(c, "onChange");
                    }
                    od(e, f);
                    a = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (a = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (a = [
                            "children",
                            "" + h
                        ]) : va.hasOwnProperty(g) && null != h && rd(c, g);
                    }
                    switch(e){
                        case "input":
                            xb(d);
                            Eb(d, f, !0);
                            break;
                        case "textarea":
                            xb(d);
                            Lb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = sd);
                    }
                    c = a;
                    b.updateQueue = c;
                    null !== c && (b.effectTag |= 4);
                } else {
                    g = 9 === c.nodeType ? c : c.ownerDocument;
                    a === qd && (a = Nb(e));
                    a === qd ? "script" === e ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(e, {
                        is: d.is
                    }) : (a = g.createElement(e), "select" === e && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, e);
                    a[Md] = b;
                    a[Nd] = d;
                    ni(a, b, !1, !1);
                    b.stateNode = a;
                    g = pd(e, d);
                    switch(e){
                        case "iframe":
                        case "object":
                        case "embed":
                            F("load", a);
                            h = d;
                            break;
                        case "video":
                        case "audio":
                            for(h = 0; h < ac.length; h++)F(ac[h], a);
                            h = d;
                            break;
                        case "source":
                            F("error", a);
                            h = d;
                            break;
                        case "img":
                        case "image":
                        case "link":
                            F("error", a);
                            F("load", a);
                            h = d;
                            break;
                        case "form":
                            F("reset", a);
                            F("submit", a);
                            h = d;
                            break;
                        case "details":
                            F("toggle", a);
                            h = d;
                            break;
                        case "input":
                            Ab(a, d);
                            h = zb(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "option":
                            h = Gb(a, d);
                            break;
                        case "select":
                            a._wrapperState = {
                                wasMultiple: !!d.multiple
                            };
                            h = $38COw({}, d, {
                                value: void 0
                            });
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        case "textarea":
                            Jb(a, d);
                            h = Ib(a, d);
                            F("invalid", a);
                            rd(c, "onChange");
                            break;
                        default:
                            h = d;
                    }
                    od(e, h);
                    var k = h;
                    for(f in k)if (k.hasOwnProperty(f)) {
                        var l = k[f];
                        "style" === f ? md(a, l) : "dangerouslySetInnerHTML" === f ? (l = l ? l.__html : void 0, null != l && Qb(a, l)) : "children" === f ? "string" === typeof l ? ("textarea" !== e || "" !== l) && Rb(a, l) : "number" === typeof l && Rb(a, "" + l) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && (va.hasOwnProperty(f) ? null != l && rd(c, f) : null != l && Xa(a, f, l, g));
                    }
                    switch(e){
                        case "input":
                            xb(a);
                            Eb(a, d, !1);
                            break;
                        case "textarea":
                            xb(a);
                            Lb(a);
                            break;
                        case "option":
                            null != d.value && a.setAttribute("value", "" + rb(d.value));
                            break;
                        case "select":
                            a.multiple = !!d.multiple;
                            c = d.value;
                            null != c ? Hb(a, !!d.multiple, c, !1) : null != d.defaultValue && Hb(a, !!d.multiple, d.defaultValue, !0);
                            break;
                        default:
                            "function" === typeof h.onClick && (a.onclick = sd);
                    }
                    Fd(e, d) && (b.effectTag |= 4);
                }
                null !== b.ref && (b.effectTag |= 128);
            }
            return null;
        case 6:
            if (a && null != b.stateNode) qi(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error(u(166));
                c = ch(bh.current);
                ch($g.current);
                Wh(b) ? (c = b.stateNode, d = b.memoizedProps, c[Md] = b, c.nodeValue !== d && (b.effectTag |= 4)) : (c = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), c[Md] = b, b.stateNode = c);
            }
            return null;
        case 13:
            H(M);
            d = b.memoizedState;
            if (0 !== (b.effectTag & 64)) return b.expirationTime = c, b;
            c = null !== d;
            d = !1;
            null === a ? void 0 !== b.memoizedProps.fallback && Wh(b) : (e = a.memoizedState, d = null !== e, c || null === e || (e = a.child.sibling, null !== e && (f = b.firstEffect, null !== f ? (b.firstEffect = e, e.nextEffect = f) : (b.firstEffect = b.lastEffect = e, e.nextEffect = null), e.effectTag = 8)));
            if (c && !d && 0 !== (b.mode & 2)) {
                if (null === a && !0 !== b.memoizedProps.unstable_avoidThisFallback || 0 !== (M.current & 1)) S === ti && (S = ui);
                else {
                    if (S === ti || S === ui) S = vi;
                    0 !== wi && null !== T && (xi(T, U), yi(T, wi));
                }
            }
            if (c || d) b.effectTag |= 4;
            return null;
        case 4:
            return eh(), oi(b), null;
        case 10:
            return og(b), null;
        case 17:
            return L(b.type) && Df(), null;
        case 19:
            H(M);
            d = b.memoizedState;
            if (null === d) return null;
            e = 0 !== (b.effectTag & 64);
            f = d.rendering;
            if (null === f) {
                if (e) ri(d, !1);
                else {
                    if (S !== ti || null !== a && 0 !== (a.effectTag & 64)) for(f = b.child; null !== f;){
                        a = hh(f);
                        if (null !== a) {
                            b.effectTag |= 64;
                            ri(d, !1);
                            e = a.updateQueue;
                            null !== e && (b.updateQueue = e, b.effectTag |= 4);
                            null === d.lastEffect && (b.firstEffect = null);
                            b.lastEffect = d.lastEffect;
                            for(d = b.child; null !== d;)e = d, f = c, e.effectTag &= 2, e.nextEffect = null, e.firstEffect = null, e.lastEffect = null, a = e.alternate, null === a ? (e.childExpirationTime = 0, e.expirationTime = f, e.child = null, e.memoizedProps = null, e.memoizedState = null, e.updateQueue = null, e.dependencies = null) : (e.childExpirationTime = a.childExpirationTime, e.expirationTime = a.expirationTime, e.child = a.child, e.memoizedProps = a.memoizedProps, e.memoizedState = a.memoizedState, e.updateQueue = a.updateQueue, f = a.dependencies, e.dependencies = null === f ? null : {
                                expirationTime: f.expirationTime,
                                firstContext: f.firstContext,
                                responders: f.responders
                            }), d = d.sibling;
                            I(M, M.current & 1 | 2);
                            return b.child;
                        }
                        f = f.sibling;
                    }
                }
            } else {
                if (!e) {
                    if (a = hh(f), null !== a) {
                        if (b.effectTag |= 64, e = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.effectTag |= 4), ri(d, !0), null === d.tail && "hidden" === d.tailMode && !f.alternate) return b = b.lastEffect = d.lastEffect, null !== b && (b.nextEffect = null), null;
                    } else 2 * $f() - d.renderingStartTime > d.tailExpiration && 1 < c && (b.effectTag |= 64, e = !0, ri(d, !1), b.expirationTime = b.childExpirationTime = c - 1);
                }
                d.isBackwards ? (f.sibling = b.child, b.child = f) : (c = d.last, null !== c ? c.sibling = f : b.child = f, d.last = f);
            }
            return null !== d.tail ? (0 === d.tailExpiration && (d.tailExpiration = $f() + 500), c = d.tail, d.rendering = c, d.tail = c.sibling, d.lastEffect = b.lastEffect, d.renderingStartTime = $f(), c.sibling = null, b = M.current, I(M, e ? b & 1 | 2 : b & 1), c) : null;
    }
    throw Error(u(156, b.tag));
}
function zi(a) {
    switch(a.tag){
        case 1:
            L(a.type) && Df();
            var b = a.effectTag;
            return b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 3:
            eh();
            H(K);
            H(J);
            b = a.effectTag;
            if (0 !== (b & 64)) throw Error(u(285));
            a.effectTag = b & -4097 | 64;
            return a;
        case 5:
            return gh(a), null;
        case 13:
            return H(M), b = a.effectTag, b & 4096 ? (a.effectTag = b & -4097 | 64, a) : null;
        case 19:
            return H(M), null;
        case 4:
            return eh(), null;
        case 10:
            return og(a), null;
        default:
            return null;
    }
}
function Ai(a, b) {
    return {
        value: a,
        source: b,
        stack: qb(b)
    };
}
var Bi = "function" === typeof WeakSet ? WeakSet : Set;
function Ci(a, b) {
    var c = b.source, d = b.stack;
    null === d && null !== c && (d = qb(c));
    null !== c && pb(c.type);
    b = b.value;
    null !== a && 1 === a.tag && pb(a.type);
    try {
        console.error(b);
    } catch (e) {
        setTimeout(function() {
            throw e;
        });
    }
}
function Di(a, b) {
    try {
        b.props = a.memoizedProps, b.state = a.memoizedState, b.componentWillUnmount();
    } catch (c) {
        Ei(a, c);
    }
}
function Fi(a) {
    var b = a.ref;
    if (null !== b) {
        if ("function" === typeof b) try {
            b(null);
        } catch (c) {
            Ei(a, c);
        }
        else b.current = null;
    }
}
function Gi(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            return;
        case 1:
            if (b.effectTag & 256 && null !== a) {
                var c = a.memoizedProps, d = a.memoizedState;
                a = b.stateNode;
                b = a.getSnapshotBeforeUpdate(b.elementType === b.type ? c : ig(b.type, c), d);
                a.__reactInternalSnapshotBeforeUpdate = b;
            }
            return;
        case 3:
        case 5:
        case 6:
        case 4:
        case 17:
            return;
    }
    throw Error(u(163));
}
function Hi(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.destroy;
                c.destroy = void 0;
                void 0 !== d && d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ii(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function Ji(a, b, c) {
    switch(c.tag){
        case 0:
        case 11:
        case 15:
        case 22:
            Ii(3, c);
            return;
        case 1:
            a = c.stateNode;
            if (c.effectTag & 4) {
                if (null === b) a.componentDidMount();
                else {
                    var d = c.elementType === c.type ? b.memoizedProps : ig(c.type, b.memoizedProps);
                    a.componentDidUpdate(d, b.memoizedState, a.__reactInternalSnapshotBeforeUpdate);
                }
            }
            b = c.updateQueue;
            null !== b && Cg(c, b, a);
            return;
        case 3:
            b = c.updateQueue;
            if (null !== b) {
                a = null;
                if (null !== c.child) switch(c.child.tag){
                    case 5:
                        a = c.child.stateNode;
                        break;
                    case 1:
                        a = c.child.stateNode;
                }
                Cg(c, b, a);
            }
            return;
        case 5:
            a = c.stateNode;
            null === b && c.effectTag & 4 && Fd(c.type, c.memoizedProps) && a.focus();
            return;
        case 6:
            return;
        case 4:
            return;
        case 12:
            return;
        case 13:
            null === c.memoizedState && (c = c.alternate, null !== c && (c = c.memoizedState, null !== c && (c = c.dehydrated, null !== c && Vc(c))));
            return;
        case 19:
        case 17:
        case 20:
        case 21:
            return;
    }
    throw Error(u(163));
}
function Ki(a, b, c) {
    "function" === typeof Li && Li(b);
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            a = b.updateQueue;
            if (null !== a && (a = a.lastEffect, null !== a)) {
                var d = a.next;
                cg(97 < c ? 97 : c, function() {
                    var a = d;
                    do {
                        var c = a.destroy;
                        if (void 0 !== c) {
                            var g = b;
                            try {
                                c();
                            } catch (h) {
                                Ei(g, h);
                            }
                        }
                        a = a.next;
                    }while (a !== d);
                });
            }
            break;
        case 1:
            Fi(b);
            c = b.stateNode;
            "function" === typeof c.componentWillUnmount && Di(b, c);
            break;
        case 5:
            Fi(b);
            break;
        case 4:
            Mi(a, b, c);
    }
}
function Ni(a) {
    var b = a.alternate;
    a.return = null;
    a.child = null;
    a.memoizedState = null;
    a.updateQueue = null;
    a.dependencies = null;
    a.alternate = null;
    a.firstEffect = null;
    a.lastEffect = null;
    a.pendingProps = null;
    a.memoizedProps = null;
    a.stateNode = null;
    null !== b && Ni(b);
}
function Oi(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function Pi(a) {
    a: {
        for(var b = a.return; null !== b;){
            if (Oi(b)) {
                var c = b;
                break a;
            }
            b = b.return;
        }
        throw Error(u(160));
    }
    b = c.stateNode;
    switch(c.tag){
        case 5:
            var d = !1;
            break;
        case 3:
            b = b.containerInfo;
            d = !0;
            break;
        case 4:
            b = b.containerInfo;
            d = !0;
            break;
        default:
            throw Error(u(161));
    }
    c.effectTag & 16 && (Rb(b, ""), c.effectTag &= -17);
    a: b: for(c = a;;){
        for(; null === c.sibling;){
            if (null === c.return || Oi(c.return)) {
                c = null;
                break a;
            }
            c = c.return;
        }
        c.sibling.return = c.return;
        for(c = c.sibling; 5 !== c.tag && 6 !== c.tag && 18 !== c.tag;){
            if (c.effectTag & 2) continue b;
            if (null === c.child || 4 === c.tag) continue b;
            else c.child.return = c, c = c.child;
        }
        if (!(c.effectTag & 2)) {
            c = c.stateNode;
            break a;
        }
    }
    d ? Qi(a, c, b) : Ri(a, c, b);
}
function Qi(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = sd));
    else if (4 !== d && (a = a.child, null !== a)) for(Qi(a, b, c), a = a.sibling; null !== a;)Qi(a, b, c), a = a.sibling;
}
function Ri(a, b, c) {
    var d = a.tag, e = 5 === d || 6 === d;
    if (e) a = e ? a.stateNode : a.stateNode.instance, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for(Ri(a, b, c), a = a.sibling; null !== a;)Ri(a, b, c), a = a.sibling;
}
function Mi(a, b, c) {
    for(var d = b, e = !1, f, g;;){
        if (!e) {
            e = d.return;
            a: for(;;){
                if (null === e) throw Error(u(160));
                f = e.stateNode;
                switch(e.tag){
                    case 5:
                        g = !1;
                        break a;
                    case 3:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                    case 4:
                        f = f.containerInfo;
                        g = !0;
                        break a;
                }
                e = e.return;
            }
            e = !0;
        }
        if (5 === d.tag || 6 === d.tag) {
            a: for(var h = a, k = d, l = c, m = k;;)if (Ki(h, m, l), null !== m.child && 4 !== m.tag) m.child.return = m, m = m.child;
            else {
                if (m === k) break a;
                for(; null === m.sibling;){
                    if (null === m.return || m.return === k) break a;
                    m = m.return;
                }
                m.sibling.return = m.return;
                m = m.sibling;
            }
            g ? (h = f, k = d.stateNode, 8 === h.nodeType ? h.parentNode.removeChild(k) : h.removeChild(k)) : f.removeChild(d.stateNode);
        } else if (4 === d.tag) {
            if (null !== d.child) {
                f = d.stateNode.containerInfo;
                g = !0;
                d.child.return = d;
                d = d.child;
                continue;
            }
        } else if (Ki(a, d, c), null !== d.child) {
            d.child.return = d;
            d = d.child;
            continue;
        }
        if (d === b) break;
        for(; null === d.sibling;){
            if (null === d.return || d.return === b) return;
            d = d.return;
            4 === d.tag && (e = !1);
        }
        d.sibling.return = d.return;
        d = d.sibling;
    }
}
function Si(a, b) {
    switch(b.tag){
        case 0:
        case 11:
        case 14:
        case 15:
        case 22:
            Hi(3, b);
            return;
        case 1:
            return;
        case 5:
            var c = b.stateNode;
            if (null != c) {
                var d = b.memoizedProps, e = null !== a ? a.memoizedProps : d;
                a = b.type;
                var f = b.updateQueue;
                b.updateQueue = null;
                if (null !== f) {
                    c[Nd] = d;
                    "input" === a && "radio" === d.type && null != d.name && Bb(c, d);
                    pd(a, e);
                    b = pd(a, d);
                    for(e = 0; e < f.length; e += 2){
                        var g = f[e], h = f[e + 1];
                        "style" === g ? md(c, h) : "dangerouslySetInnerHTML" === g ? Qb(c, h) : "children" === g ? Rb(c, h) : Xa(c, g, h, b);
                    }
                    switch(a){
                        case "input":
                            Cb(c, d);
                            break;
                        case "textarea":
                            Kb(c, d);
                            break;
                        case "select":
                            b = c._wrapperState.wasMultiple, c._wrapperState.wasMultiple = !!d.multiple, a = d.value, null != a ? Hb(c, !!d.multiple, a, !1) : b !== !!d.multiple && (null != d.defaultValue ? Hb(c, !!d.multiple, d.defaultValue, !0) : Hb(c, !!d.multiple, d.multiple ? [] : "", !1));
                    }
                }
            }
            return;
        case 6:
            if (null === b.stateNode) throw Error(u(162));
            b.stateNode.nodeValue = b.memoizedProps;
            return;
        case 3:
            b = b.stateNode;
            b.hydrate && (b.hydrate = !1, Vc(b.containerInfo));
            return;
        case 12:
            return;
        case 13:
            c = b;
            null === b.memoizedState ? d = !1 : (d = !0, c = b.child, Ti = $f());
            if (null !== c) a: for(a = c;;){
                if (5 === a.tag) f = a.stateNode, d ? (f = f.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (f = a.stateNode, e = a.memoizedProps.style, e = void 0 !== e && null !== e && e.hasOwnProperty("display") ? e.display : null, f.style.display = ld("display", e));
                else if (6 === a.tag) a.stateNode.nodeValue = d ? "" : a.memoizedProps;
                else if (13 === a.tag && null !== a.memoizedState && null === a.memoizedState.dehydrated) {
                    f = a.child.sibling;
                    f.return = a;
                    a = f;
                    continue;
                } else if (null !== a.child) {
                    a.child.return = a;
                    a = a.child;
                    continue;
                }
                if (a === c) break;
                for(; null === a.sibling;){
                    if (null === a.return || a.return === c) break a;
                    a = a.return;
                }
                a.sibling.return = a.return;
                a = a.sibling;
            }
            Ui(b);
            return;
        case 19:
            Ui(b);
            return;
        case 17:
            return;
    }
    throw Error(u(163));
}
function Ui(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new Bi);
        b.forEach(function(b) {
            var d = Vi.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
var Wi = "function" === typeof WeakMap ? WeakMap : Map;
function Xi(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        Yi || (Yi = !0, Zi = d);
        Ci(a, b);
    };
    return c;
}
function $i(a, b, c) {
    c = wg(c, null);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            Ci(a, b);
            return d(e);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        "function" !== typeof d && (null === aj ? aj = new Set([
            this
        ]) : aj.add(this), Ci(a, b));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
var bj = Math.ceil, cj = Wa.ReactCurrentDispatcher, dj = Wa.ReactCurrentOwner, V = 0, ej = 8, fj = 16, gj = 32, ti = 0, hj = 1, ij = 2, ui = 3, vi = 4, jj = 5, W = V, T = null, X = null, U = 0, S = ti, kj = null, lj = 1073741823, mj = 1073741823, nj = null, wi = 0, oj = !1, Ti = 0, pj = 500, Y = null, Yi = !1, Zi = null, aj = null, qj = !1, rj = null, sj = 90, tj = null, uj = 0, vj = null, wj = 0;
function Gg() {
    return (W & (fj | gj)) !== V ? 1073741821 - ($f() / 10 | 0) : 0 !== wj ? wj : wj = 1073741821 - ($f() / 10 | 0);
}
function Hg(a, b, c) {
    b = b.mode;
    if (0 === (b & 2)) return 1073741823;
    var d = ag();
    if (0 === (b & 4)) return 99 === d ? 1073741823 : 1073741822;
    if ((W & fj) !== V) return U;
    if (null !== c) a = hg(a, c.timeoutMs | 0 || 5E3, 250);
    else switch(d){
        case 99:
            a = 1073741823;
            break;
        case 98:
            a = hg(a, 150, 100);
            break;
        case 97:
        case 96:
            a = hg(a, 5E3, 250);
            break;
        case 95:
            a = 2;
            break;
        default:
            throw Error(u(326));
    }
    null !== T && a === U && --a;
    return a;
}
function Ig(a, b) {
    if (50 < uj) throw uj = 0, vj = null, Error(u(185));
    a = xj(a, b);
    if (null !== a) {
        var c = ag();
        1073741823 === b ? (W & ej) !== V && (W & (fj | gj)) === V ? yj(a) : (Z(a), W === V && gg()) : Z(a);
        (W & 4) === V || 98 !== c && 99 !== c || (null === tj ? tj = new Map([
            [
                a,
                b
            ]
        ]) : (c = tj.get(a), (void 0 === c || c > b) && tj.set(a, b)));
    }
}
function xj(a, b) {
    a.expirationTime < b && (a.expirationTime = b);
    var c = a.alternate;
    null !== c && c.expirationTime < b && (c.expirationTime = b);
    var d = a.return, e = null;
    if (null === d && 3 === a.tag) e = a.stateNode;
    else for(; null !== d;){
        c = d.alternate;
        d.childExpirationTime < b && (d.childExpirationTime = b);
        null !== c && c.childExpirationTime < b && (c.childExpirationTime = b);
        if (null === d.return && 3 === d.tag) {
            e = d.stateNode;
            break;
        }
        d = d.return;
    }
    null !== e && (T === e && (Bg(b), S === vi && xi(e, U)), yi(e, b));
    return e;
}
function zj(a) {
    var b = a.lastExpiredTime;
    if (0 !== b) return b;
    b = a.firstPendingTime;
    if (!Aj(a, b)) return b;
    var c = a.lastPingedTime;
    a = a.nextKnownPendingLevel;
    a = c > a ? c : a;
    return 2 >= a && b !== a ? 0 : a;
}
function Z(a) {
    if (0 !== a.lastExpiredTime) a.callbackExpirationTime = 1073741823, a.callbackPriority = 99, a.callbackNode = eg(yj.bind(null, a));
    else {
        var b = zj(a), c = a.callbackNode;
        if (0 === b) null !== c && (a.callbackNode = null, a.callbackExpirationTime = 0, a.callbackPriority = 90);
        else {
            var d = Gg();
            1073741823 === b ? d = 99 : 1 === b || 2 === b ? d = 95 : (d = 10 * (1073741821 - b) - 10 * (1073741821 - d), d = 0 >= d ? 99 : 250 >= d ? 98 : 5250 >= d ? 97 : 95);
            if (null !== c) {
                var e = a.callbackPriority;
                if (a.callbackExpirationTime === b && e >= d) return;
                c !== Tf && Kf(c);
            }
            a.callbackExpirationTime = b;
            a.callbackPriority = d;
            b = 1073741823 === b ? eg(yj.bind(null, a)) : dg(d, Bj.bind(null, a), {
                timeout: 10 * (1073741821 - b) - $f()
            });
            a.callbackNode = b;
        }
    }
}
function Bj(a, b) {
    wj = 0;
    if (b) return b = Gg(), Cj(a, b), Z(a), null;
    var c = zj(a);
    if (0 !== c) {
        b = a.callbackNode;
        if ((W & (fj | gj)) !== V) throw Error(u(327));
        Dj();
        a === T && c === U || Ej(a, c);
        if (null !== X) {
            var d = W;
            W |= fj;
            var e = Fj();
            for(;;)try {
                Gj();
                break;
            } catch (h) {
                Hj(a, h);
            }
            ng();
            W = d;
            cj.current = e;
            if (S === hj) throw b = kj, Ej(a, c), xi(a, c), Z(a), b;
            if (null === X) switch(e = a.finishedWork = a.current.alternate, a.finishedExpirationTime = c, d = S, T = null, d){
                case ti:
                case hj:
                    throw Error(u(345));
                case ij:
                    Cj(a, 2 < c ? 2 : c);
                    break;
                case ui:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (1073741823 === lj && (e = Ti + pj - $f(), 10 < e)) {
                        if (oj) {
                            var f = a.lastPingedTime;
                            if (0 === f || f >= c) {
                                a.lastPingedTime = c;
                                Ej(a, c);
                                break;
                            }
                        }
                        f = zj(a);
                        if (0 !== f && f !== c) break;
                        if (0 !== d && d !== c) {
                            a.lastPingedTime = d;
                            break;
                        }
                        a.timeoutHandle = Hd(Jj.bind(null, a), e);
                        break;
                    }
                    Jj(a);
                    break;
                case vi:
                    xi(a, c);
                    d = a.lastSuspendedTime;
                    c === d && (a.nextKnownPendingLevel = Ij(e));
                    if (oj && (e = a.lastPingedTime, 0 === e || e >= c)) {
                        a.lastPingedTime = c;
                        Ej(a, c);
                        break;
                    }
                    e = zj(a);
                    if (0 !== e && e !== c) break;
                    if (0 !== d && d !== c) {
                        a.lastPingedTime = d;
                        break;
                    }
                    1073741823 !== mj ? d = 10 * (1073741821 - mj) - $f() : 1073741823 === lj ? d = 0 : (d = 10 * (1073741821 - lj) - 5E3, e = $f(), c = 10 * (1073741821 - c) - e, d = e - d, 0 > d && (d = 0), d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * bj(d / 1960)) - d, c < d && (d = c));
                    if (10 < d) {
                        a.timeoutHandle = Hd(Jj.bind(null, a), d);
                        break;
                    }
                    Jj(a);
                    break;
                case jj:
                    if (1073741823 !== lj && null !== nj) {
                        f = lj;
                        var g = nj;
                        d = g.busyMinDurationMs | 0;
                        0 >= d ? d = 0 : (e = g.busyDelayMs | 0, f = $f() - (10 * (1073741821 - f) - (g.timeoutMs | 0 || 5E3)), d = f <= e ? 0 : e + d - f);
                        if (10 < d) {
                            xi(a, c);
                            a.timeoutHandle = Hd(Jj.bind(null, a), d);
                            break;
                        }
                    }
                    Jj(a);
                    break;
                default:
                    throw Error(u(329));
            }
            Z(a);
            if (a.callbackNode === b) return Bj.bind(null, a);
        }
    }
    return null;
}
function yj(a) {
    var b = a.lastExpiredTime;
    b = 0 !== b ? b : 1073741823;
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    Dj();
    a === T && b === U || Ej(a, b);
    if (null !== X) {
        var c = W;
        W |= fj;
        var d = Fj();
        for(;;)try {
            Kj();
            break;
        } catch (e) {
            Hj(a, e);
        }
        ng();
        W = c;
        cj.current = d;
        if (S === hj) throw c = kj, Ej(a, b), xi(a, b), Z(a), c;
        if (null !== X) throw Error(u(261));
        a.finishedWork = a.current.alternate;
        a.finishedExpirationTime = b;
        T = null;
        Jj(a);
        Z(a);
    }
    return null;
}
function Lj() {
    if (null !== tj) {
        var a = tj;
        tj = null;
        a.forEach(function(a, c) {
            Cj(c, a);
            Z(c);
        });
        gg();
    }
}
function Mj(a, b) {
    var c = W;
    W |= 1;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Nj(a, b) {
    var c = W;
    W &= -2;
    W |= ej;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
}
function Ej(a, b) {
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, Id(c));
    if (null !== X) for(c = X.return; null !== c;){
        var d = c;
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && Df();
                break;
            case 3:
                eh();
                H(K);
                H(J);
                break;
            case 5:
                gh(d);
                break;
            case 4:
                eh();
                break;
            case 13:
                H(M);
                break;
            case 19:
                H(M);
                break;
            case 10:
                og(d);
        }
        c = c.return;
    }
    T = a;
    X = Sg(a.current, null);
    U = b;
    S = ti;
    kj = null;
    mj = lj = 1073741823;
    nj = null;
    wi = 0;
    oj = !1;
}
function Hj(a, b) {
    do {
        try {
            ng();
            jh.current = sh;
            if (mh) for(var c = N.memoizedState; null !== c;){
                var d = c.queue;
                null !== d && (d.pending = null);
                c = c.next;
            }
            lh = 0;
            P = O = N = null;
            mh = !1;
            if (null === X || null === X.return) return S = hj, kj = b, X = null;
            a: {
                var e = a, f = X.return, g = X, h = b;
                b = U;
                g.effectTag |= 2048;
                g.firstEffect = g.lastEffect = null;
                if (null !== h && "object" === typeof h && "function" === typeof h.then) {
                    var k = h;
                    if (0 === (g.mode & 2)) {
                        var l = g.alternate;
                        l ? (g.updateQueue = l.updateQueue, g.memoizedState = l.memoizedState, g.expirationTime = l.expirationTime) : (g.updateQueue = null, g.memoizedState = null);
                    }
                    var m = 0 !== (M.current & 1), p = f;
                    do {
                        var x;
                        if (x = 13 === p.tag) {
                            var z = p.memoizedState;
                            if (null !== z) x = null !== z.dehydrated ? !0 : !1;
                            else {
                                var ca = p.memoizedProps;
                                x = void 0 === ca.fallback ? !1 : !0 !== ca.unstable_avoidThisFallback ? !0 : m ? !1 : !0;
                            }
                        }
                        if (x) {
                            var D = p.updateQueue;
                            if (null === D) {
                                var t = new Set;
                                t.add(k);
                                p.updateQueue = t;
                            } else D.add(k);
                            if (0 === (p.mode & 2)) {
                                p.effectTag |= 64;
                                g.effectTag &= -2981;
                                if (1 === g.tag) {
                                    if (null === g.alternate) g.tag = 17;
                                    else {
                                        var y = wg(1073741823, null);
                                        y.tag = 2;
                                        xg(g, y);
                                    }
                                }
                                g.expirationTime = 1073741823;
                                break a;
                            }
                            h = void 0;
                            g = b;
                            var A = e.pingCache;
                            null === A ? (A = e.pingCache = new Wi, h = new Set, A.set(k, h)) : (h = A.get(k), void 0 === h && (h = new Set, A.set(k, h)));
                            if (!h.has(g)) {
                                h.add(g);
                                var q = Oj.bind(null, e, k, g);
                                k.then(q, q);
                            }
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            break a;
                        }
                        p = p.return;
                    }while (null !== p);
                    h = Error((pb(g.type) || "A React component") + " suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display." + qb(g));
                }
                S !== jj && (S = ij);
                h = Ai(h, g);
                p = f;
                do {
                    switch(p.tag){
                        case 3:
                            k = h;
                            p.effectTag |= 4096;
                            p.expirationTime = b;
                            var B = Xi(p, k, b);
                            yg(p, B);
                            break a;
                        case 1:
                            k = h;
                            var w = p.type, ub = p.stateNode;
                            if (0 === (p.effectTag & 64) && ("function" === typeof w.getDerivedStateFromError || null !== ub && "function" === typeof ub.componentDidCatch && (null === aj || !aj.has(ub)))) {
                                p.effectTag |= 4096;
                                p.expirationTime = b;
                                var vb = $i(p, k, b);
                                yg(p, vb);
                                break a;
                            }
                    }
                    p = p.return;
                }while (null !== p);
            }
            X = Pj(X);
        } catch (Xc) {
            b = Xc;
            continue;
        }
        break;
    }while (1);
}
function Fj() {
    var a = cj.current;
    cj.current = sh;
    return null === a ? sh : a;
}
function Ag(a, b) {
    a < lj && 2 < a && (lj = a);
    null !== b && a < mj && 2 < a && (mj = a, nj = b);
}
function Bg(a) {
    a > wi && (wi = a);
}
function Kj() {
    for(; null !== X;)X = Qj(X);
}
function Gj() {
    for(; null !== X && !Uf();)X = Qj(X);
}
function Qj(a) {
    var b = Rj(a.alternate, a, U);
    a.memoizedProps = a.pendingProps;
    null === b && (b = Pj(a));
    dj.current = null;
    return b;
}
function Pj(a) {
    X = a;
    do {
        var b = X.alternate;
        a = X.return;
        if (0 === (X.effectTag & 2048)) {
            b = si(b, X, U);
            if (1 === U || 1 !== X.childExpirationTime) {
                for(var c = 0, d = X.child; null !== d;){
                    var e = d.expirationTime, f = d.childExpirationTime;
                    e > c && (c = e);
                    f > c && (c = f);
                    d = d.sibling;
                }
                X.childExpirationTime = c;
            }
            if (null !== b) return b;
            null !== a && 0 === (a.effectTag & 2048) && (null === a.firstEffect && (a.firstEffect = X.firstEffect), null !== X.lastEffect && (null !== a.lastEffect && (a.lastEffect.nextEffect = X.firstEffect), a.lastEffect = X.lastEffect), 1 < X.effectTag && (null !== a.lastEffect ? a.lastEffect.nextEffect = X : a.firstEffect = X, a.lastEffect = X));
        } else {
            b = zi(X);
            if (null !== b) return b.effectTag &= 2047, b;
            null !== a && (a.firstEffect = a.lastEffect = null, a.effectTag |= 2048);
        }
        b = X.sibling;
        if (null !== b) return b;
        X = a;
    }while (null !== X);
    S === ti && (S = jj);
    return null;
}
function Ij(a) {
    var b = a.expirationTime;
    a = a.childExpirationTime;
    return b > a ? b : a;
}
function Jj(a) {
    var b = ag();
    cg(99, Sj.bind(null, a, b));
    return null;
}
function Sj(a, b) {
    do Dj();
    while (null !== rj);
    if ((W & (fj | gj)) !== V) throw Error(u(327));
    var c = a.finishedWork, d = a.finishedExpirationTime;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedExpirationTime = 0;
    if (c === a.current) throw Error(u(177));
    a.callbackNode = null;
    a.callbackExpirationTime = 0;
    a.callbackPriority = 90;
    a.nextKnownPendingLevel = 0;
    var e = Ij(c);
    a.firstPendingTime = e;
    d <= a.lastSuspendedTime ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : d <= a.firstSuspendedTime && (a.firstSuspendedTime = d - 1);
    d <= a.lastPingedTime && (a.lastPingedTime = 0);
    d <= a.lastExpiredTime && (a.lastExpiredTime = 0);
    a === T && (X = T = null, U = 0);
    1 < c.effectTag ? null !== c.lastEffect ? (c.lastEffect.nextEffect = c, e = c.firstEffect) : e = c : e = c.firstEffect;
    if (null !== e) {
        var f = W;
        W |= gj;
        dj.current = null;
        Dd = fd;
        var g = xd();
        if (yd(g)) {
            if ("selectionStart" in g) var h = {
                start: g.selectionStart,
                end: g.selectionEnd
            };
            else a: {
                h = (h = g.ownerDocument) && h.defaultView || window;
                var k = h.getSelection && h.getSelection();
                if (k && 0 !== k.rangeCount) {
                    h = k.anchorNode;
                    var l = k.anchorOffset, m = k.focusNode;
                    k = k.focusOffset;
                    try {
                        h.nodeType, m.nodeType;
                    } catch (wb) {
                        h = null;
                        break a;
                    }
                    var p = 0, x = -1, z = -1, ca = 0, D = 0, t = g, y = null;
                    b: for(;;){
                        for(var A;;){
                            t !== h || 0 !== l && 3 !== t.nodeType || (x = p + l);
                            t !== m || 0 !== k && 3 !== t.nodeType || (z = p + k);
                            3 === t.nodeType && (p += t.nodeValue.length);
                            if (null === (A = t.firstChild)) break;
                            y = t;
                            t = A;
                        }
                        for(;;){
                            if (t === g) break b;
                            y === h && ++ca === l && (x = p);
                            y === m && ++D === k && (z = p);
                            if (null !== (A = t.nextSibling)) break;
                            t = y;
                            y = t.parentNode;
                        }
                        t = A;
                    }
                    h = -1 === x || -1 === z ? null : {
                        start: x,
                        end: z
                    };
                } else h = null;
            }
            h = h || {
                start: 0,
                end: 0
            };
        } else h = null;
        Ed = {
            activeElementDetached: null,
            focusedElem: g,
            selectionRange: h
        };
        fd = !1;
        Y = e;
        do try {
            Tj();
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = e;
        do try {
            for(g = a, h = b; null !== Y;){
                var q = Y.effectTag;
                q & 16 && Rb(Y.stateNode, "");
                if (q & 128) {
                    var B = Y.alternate;
                    if (null !== B) {
                        var w = B.ref;
                        null !== w && ("function" === typeof w ? w(null) : w.current = null);
                    }
                }
                switch(q & 1038){
                    case 2:
                        Pi(Y);
                        Y.effectTag &= -3;
                        break;
                    case 6:
                        Pi(Y);
                        Y.effectTag &= -3;
                        Si(Y.alternate, Y);
                        break;
                    case 1024:
                        Y.effectTag &= -1025;
                        break;
                    case 1028:
                        Y.effectTag &= -1025;
                        Si(Y.alternate, Y);
                        break;
                    case 4:
                        Si(Y.alternate, Y);
                        break;
                    case 8:
                        l = Y, Mi(g, l, h), Ni(l);
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        w = Ed;
        B = xd();
        q = w.focusedElem;
        h = w.selectionRange;
        if (B !== q && q && q.ownerDocument && wd(q.ownerDocument.documentElement, q)) {
            null !== h && yd(q) && (B = h.start, w = h.end, void 0 === w && (w = B), "selectionStart" in q ? (q.selectionStart = B, q.selectionEnd = Math.min(w, q.value.length)) : (w = (B = q.ownerDocument || document) && B.defaultView || window, w.getSelection && (w = w.getSelection(), l = q.textContent.length, g = Math.min(h.start, l), h = void 0 === h.end ? g : Math.min(h.end, l), !w.extend && g > h && (l = h, h = g, g = l), l = vd(q, g), m = vd(q, h), l && m && (1 !== w.rangeCount || w.anchorNode !== l.node || w.anchorOffset !== l.offset || w.focusNode !== m.node || w.focusOffset !== m.offset) && (B = B.createRange(), B.setStart(l.node, l.offset), w.removeAllRanges(), g > h ? (w.addRange(B), w.extend(m.node, m.offset)) : (B.setEnd(m.node, m.offset), w.addRange(B))))));
            B = [];
            for(w = q; w = w.parentNode;)1 === w.nodeType && B.push({
                element: w,
                left: w.scrollLeft,
                top: w.scrollTop
            });
            "function" === typeof q.focus && q.focus();
            for(q = 0; q < B.length; q++)w = B[q], w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
        }
        fd = !!Dd;
        Ed = Dd = null;
        a.current = c;
        Y = e;
        do try {
            for(q = a; null !== Y;){
                var ub = Y.effectTag;
                ub & 36 && Ji(q, Y.alternate, Y);
                if (ub & 128) {
                    B = void 0;
                    var vb = Y.ref;
                    if (null !== vb) {
                        var Xc = Y.stateNode;
                        switch(Y.tag){
                            case 5:
                                B = Xc;
                                break;
                            default:
                                B = Xc;
                        }
                        "function" === typeof vb ? vb(B) : vb.current = B;
                    }
                }
                Y = Y.nextEffect;
            }
        } catch (wb) {
            if (null === Y) throw Error(u(330));
            Ei(Y, wb);
            Y = Y.nextEffect;
        }
        while (null !== Y);
        Y = null;
        Vf();
        W = f;
    } else a.current = c;
    if (qj) qj = !1, rj = a, sj = b;
    else for(Y = e; null !== Y;)b = Y.nextEffect, Y.nextEffect = null, Y = b;
    b = a.firstPendingTime;
    0 === b && (aj = null);
    1073741823 === b ? a === vj ? uj++ : (uj = 0, vj = a) : uj = 0;
    "function" === typeof Uj && Uj(c.stateNode, d);
    Z(a);
    if (Yi) throw Yi = !1, a = Zi, Zi = null, a;
    if ((W & ej) !== V) return null;
    gg();
    return null;
}
function Tj() {
    for(; null !== Y;){
        var a = Y.effectTag;
        0 !== (a & 256) && Gi(Y.alternate, Y);
        0 === (a & 512) || qj || (qj = !0, dg(97, function() {
            Dj();
            return null;
        }));
        Y = Y.nextEffect;
    }
}
function Dj() {
    if (90 !== sj) {
        var a = 97 < sj ? 97 : sj;
        sj = 90;
        return cg(a, Vj);
    }
}
function Vj() {
    if (null === rj) return !1;
    var a = rj;
    rj = null;
    if ((W & (fj | gj)) !== V) throw Error(u(331));
    var b = W;
    W |= gj;
    for(a = a.current.firstEffect; null !== a;){
        try {
            var c = a;
            if (0 !== (c.effectTag & 512)) switch(c.tag){
                case 0:
                case 11:
                case 15:
                case 22:
                    Hi(5, c), Ii(5, c);
            }
        } catch (d) {
            if (null === a) throw Error(u(330));
            Ei(a, d);
        }
        c = a.nextEffect;
        a.nextEffect = null;
        a = c;
    }
    W = b;
    gg();
    return !0;
}
function Wj(a, b, c) {
    b = Ai(c, b);
    b = Xi(a, b, 1073741823);
    xg(a, b);
    a = xj(a, 1073741823);
    null !== a && Z(a);
}
function Ei(a, b) {
    if (3 === a.tag) Wj(a, a, b);
    else for(var c = a.return; null !== c;){
        if (3 === c.tag) {
            Wj(c, a, b);
            break;
        } else if (1 === c.tag) {
            var d = c.stateNode;
            if ("function" === typeof c.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === aj || !aj.has(d))) {
                a = Ai(b, a);
                a = $i(c, a, 1073741823);
                xg(c, a);
                c = xj(c, 1073741823);
                null !== c && Z(c);
                break;
            }
        }
        c = c.return;
    }
}
function Oj(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    T === a && U === c ? S === vi || S === ui && 1073741823 === lj && $f() - Ti < pj ? Ej(a, U) : oj = !0 : Aj(a, c) && (b = a.lastPingedTime, 0 !== b && b < c || (a.lastPingedTime = c, Z(a)));
}
function Vi(a, b) {
    var c = a.stateNode;
    null !== c && c.delete(b);
    b = 0;
    0 === b && (b = Gg(), b = Hg(b, a, null));
    a = xj(a, b);
    null !== a && Z(a);
}
var Rj;
Rj = function(a, b, c) {
    var d = b.expirationTime;
    if (null !== a) {
        var e = b.pendingProps;
        if (a.memoizedProps !== e || K.current) rg = !0;
        else {
            if (d < c) {
                rg = !1;
                switch(b.tag){
                    case 3:
                        hi(b);
                        Xh();
                        break;
                    case 5:
                        fh(b);
                        if (b.mode & 4 && 1 !== c && e.hidden) return b.expirationTime = b.childExpirationTime = 1, null;
                        break;
                    case 1:
                        L(b.type) && Gf(b);
                        break;
                    case 4:
                        dh(b, b.stateNode.containerInfo);
                        break;
                    case 10:
                        d = b.memoizedProps.value;
                        e = b.type._context;
                        I(jg, e._currentValue);
                        e._currentValue = d;
                        break;
                    case 13:
                        if (null !== b.memoizedState) {
                            d = b.child.childExpirationTime;
                            if (0 !== d && d >= c) return ji(a, b, c);
                            I(M, M.current & 1);
                            b = $h(a, b, c);
                            return null !== b ? b.sibling : null;
                        }
                        I(M, M.current & 1);
                        break;
                    case 19:
                        d = b.childExpirationTime >= c;
                        if (0 !== (a.effectTag & 64)) {
                            if (d) return mi(a, b, c);
                            b.effectTag |= 64;
                        }
                        e = b.memoizedState;
                        null !== e && (e.rendering = null, e.tail = null);
                        I(M, M.current);
                        if (!d) return null;
                }
                return $h(a, b, c);
            }
            rg = !1;
        }
    } else rg = !1;
    b.expirationTime = 0;
    switch(b.tag){
        case 2:
            d = b.type;
            null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
            a = b.pendingProps;
            e = Cf(b, J.current);
            qg(b, c);
            e = oh(null, b, d, a, e, c);
            b.effectTag |= 1;
            if ("object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof) {
                b.tag = 1;
                b.memoizedState = null;
                b.updateQueue = null;
                if (L(d)) {
                    var f = !0;
                    Gf(b);
                } else f = !1;
                b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null;
                ug(b);
                var g = d.getDerivedStateFromProps;
                "function" === typeof g && Fg(b, d, g, a);
                e.updater = Jg;
                b.stateNode = e;
                e._reactInternalFiber = b;
                Ng(b, d, a, c);
                b = gi(null, b, d, !0, f, c);
            } else b.tag = 0, R(null, b, e, c), b = b.child;
            return b;
        case 16:
            a: {
                e = b.elementType;
                null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2);
                a = b.pendingProps;
                ob(e);
                if (1 !== e._status) throw e._result;
                e = e._result;
                b.type = e;
                f = b.tag = Xj(e);
                a = ig(e, a);
                switch(f){
                    case 0:
                        b = di(null, b, e, a, c);
                        break a;
                    case 1:
                        b = fi(null, b, e, a, c);
                        break a;
                    case 11:
                        b = Zh(null, b, e, a, c);
                        break a;
                    case 14:
                        b = ai(null, b, e, ig(e.type, a), d, c);
                        break a;
                }
                throw Error(u(306, e, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), di(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), fi(a, b, d, e, c);
        case 3:
            hi(b);
            d = b.updateQueue;
            if (null === a || null === d) throw Error(u(282));
            d = b.pendingProps;
            e = b.memoizedState;
            e = null !== e ? e.element : null;
            vg(a, b);
            zg(b, d, null, c);
            d = b.memoizedState.element;
            if (d === e) Xh(), b = $h(a, b, c);
            else {
                if (e = b.stateNode.hydrate) Ph = Jd(b.stateNode.containerInfo.firstChild), Oh = b, e = Qh = !0;
                if (e) for(c = Yg(b, null, d, c), b.child = c; c;)c.effectTag = c.effectTag & -3 | 1024, c = c.sibling;
                else R(a, b, d, c), Xh();
                b = b.child;
            }
            return b;
        case 5:
            return fh(b), null === a && Uh(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, Gd(d, e) ? g = null : null !== f && Gd(d, f) && (b.effectTag |= 16), ei(a, b), b.mode & 4 && 1 !== c && e.hidden ? (b.expirationTime = b.childExpirationTime = 1, b = null) : (R(a, b, g, c), b = b.child), b;
        case 6:
            return null === a && Uh(b), null;
        case 13:
            return ji(a, b, c);
        case 4:
            return dh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = Xg(b, null, d, c) : R(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), Zh(a, b, d, e, c);
        case 7:
            return R(a, b, b.pendingProps, c), b.child;
        case 8:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return R(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                g = b.memoizedProps;
                f = e.value;
                var h = b.type._context;
                I(jg, h._currentValue);
                h._currentValue = f;
                if (null !== g) {
                    if (h = g.value, f = $e(h, f) ? 0 : ("function" === typeof d._calculateChangedBits ? d._calculateChangedBits(h, f) : 1073741823) | 0, 0 === f) {
                        if (g.children === e.children && !K.current) {
                            b = $h(a, b, c);
                            break a;
                        }
                    } else for(h = b.child, null !== h && (h.return = b); null !== h;){
                        var k = h.dependencies;
                        if (null !== k) {
                            g = h.child;
                            for(var l = k.firstContext; null !== l;){
                                if (l.context === d && 0 !== (l.observedBits & f)) {
                                    1 === h.tag && (l = wg(c, null), l.tag = 2, xg(h, l));
                                    h.expirationTime < c && (h.expirationTime = c);
                                    l = h.alternate;
                                    null !== l && l.expirationTime < c && (l.expirationTime = c);
                                    pg(h.return, c);
                                    k.expirationTime < c && (k.expirationTime = c);
                                    break;
                                }
                                l = l.next;
                            }
                        } else g = 10 === h.tag ? h.type === b.type ? null : h.child : h.child;
                        if (null !== g) g.return = h;
                        else for(g = h; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            h = g.sibling;
                            if (null !== h) {
                                h.return = g.return;
                                g = h;
                                break;
                            }
                            g = g.return;
                        }
                        h = g;
                    }
                }
                R(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, f = b.pendingProps, d = f.children, qg(b, c), e = sg(e, f.unstable_observedBits), d = d(e), b.effectTag |= 1, R(a, b, d, c), b.child;
        case 14:
            return e = b.type, f = ig(e, b.pendingProps), f = ig(e.type, f), ai(a, b, e, f, d, c);
        case 15:
            return ci(a, b, b.type, b.pendingProps, d, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : ig(d, e), null !== a && (a.alternate = null, b.alternate = null, b.effectTag |= 2), b.tag = 1, L(d) ? (a = !0, Gf(b)) : a = !1, qg(b, c), Lg(b, d, e), Ng(b, d, e, c), gi(null, b, d, !0, a, c);
        case 19:
            return mi(a, b, c);
    }
    throw Error(u(156, b.tag));
};
var Uj = null, Li = null;
function Yj(a) {
    if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return !1;
    var b = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (b.isDisabled || !b.supportsFiber) return !0;
    try {
        var c = b.inject(a);
        Uj = function(a) {
            try {
                b.onCommitFiberRoot(c, a, void 0, 64 === (a.current.effectTag & 64));
            } catch (e) {}
        };
        Li = function(a) {
            try {
                b.onCommitFiberUnmount(c, a);
            } catch (e) {}
        };
    } catch (d) {}
    return !0;
}
function Zj(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.effectTag = 0;
    this.lastEffect = this.firstEffect = this.nextEffect = null;
    this.childExpirationTime = this.expirationTime = 0;
    this.alternate = null;
}
function Sh(a, b, c, d) {
    return new Zj(a, b, c, d);
}
function bi(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function Xj(a) {
    if ("function" === typeof a) return bi(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === gb) return 11;
        if (a === jb) return 14;
    }
    return 2;
}
function Sg(a, b) {
    var c = a.alternate;
    null === c ? (c = Sh(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.effectTag = 0, c.nextEffect = null, c.firstEffect = null, c.lastEffect = null);
    c.childExpirationTime = a.childExpirationTime;
    c.expirationTime = a.expirationTime;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        expirationTime: b.expirationTime,
        firstContext: b.firstContext,
        responders: b.responders
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function Ug(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) bi(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case ab:
            return Wg(c.children, e, f, b);
        case fb:
            g = 8;
            e |= 7;
            break;
        case bb:
            g = 8;
            e |= 1;
            break;
        case cb:
            return a = Sh(12, c, b, e | 8), a.elementType = cb, a.type = cb, a.expirationTime = f, a;
        case hb:
            return a = Sh(13, c, b, e), a.type = hb, a.elementType = hb, a.expirationTime = f, a;
        case ib:
            return a = Sh(19, c, b, e), a.elementType = ib, a.expirationTime = f, a;
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case db:
                    g = 10;
                    break a;
                case eb:
                    g = 9;
                    break a;
                case gb:
                    g = 11;
                    break a;
                case jb:
                    g = 14;
                    break a;
                case kb:
                    g = 16;
                    d = null;
                    break a;
                case lb:
                    g = 22;
                    break a;
            }
            throw Error(u(130, null == a ? a : typeof a, ""));
    }
    b = Sh(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.expirationTime = f;
    return b;
}
function Wg(a, b, c, d) {
    a = Sh(7, a, d, b);
    a.expirationTime = c;
    return a;
}
function Tg(a, b, c) {
    a = Sh(6, a, null, b);
    a.expirationTime = c;
    return a;
}
function Vg(a, b, c) {
    b = Sh(4, null !== a.children ? a.children : [], a.key, b);
    b.expirationTime = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function ak(a, b, c) {
    this.tag = b;
    this.current = null;
    this.containerInfo = a;
    this.pingCache = this.pendingChildren = null;
    this.finishedExpirationTime = 0;
    this.finishedWork = null;
    this.timeoutHandle = -1;
    this.pendingContext = this.context = null;
    this.hydrate = c;
    this.callbackNode = null;
    this.callbackPriority = 90;
    this.lastExpiredTime = this.lastPingedTime = this.nextKnownPendingLevel = this.lastSuspendedTime = this.firstSuspendedTime = this.firstPendingTime = 0;
}
function Aj(a, b) {
    var c = a.firstSuspendedTime;
    a = a.lastSuspendedTime;
    return 0 !== c && c >= b && a <= b;
}
function xi(a, b) {
    var c = a.firstSuspendedTime, d = a.lastSuspendedTime;
    c < b && (a.firstSuspendedTime = b);
    if (d > b || 0 === c) a.lastSuspendedTime = b;
    b <= a.lastPingedTime && (a.lastPingedTime = 0);
    b <= a.lastExpiredTime && (a.lastExpiredTime = 0);
}
function yi(a, b) {
    b > a.firstPendingTime && (a.firstPendingTime = b);
    var c = a.firstSuspendedTime;
    0 !== c && (b >= c ? a.firstSuspendedTime = a.lastSuspendedTime = a.nextKnownPendingLevel = 0 : b >= a.lastSuspendedTime && (a.lastSuspendedTime = b + 1), b > a.nextKnownPendingLevel && (a.nextKnownPendingLevel = b));
}
function Cj(a, b) {
    var c = a.lastExpiredTime;
    if (0 === c || c > b) a.lastExpiredTime = b;
}
function bk(a, b, c, d) {
    var e = b.current, f = Gg(), g = Dg.suspense;
    f = Hg(f, e, g);
    a: if (c) {
        c = c._reactInternalFiber;
        b: {
            if (dc(c) !== c || 1 !== c.tag) throw Error(u(170));
            var h = c;
            do {
                switch(h.tag){
                    case 3:
                        h = h.stateNode.context;
                        break b;
                    case 1:
                        if (L(h.type)) {
                            h = h.stateNode.__reactInternalMemoizedMergedChildContext;
                            break b;
                        }
                }
                h = h.return;
            }while (null !== h);
            throw Error(u(171));
        }
        if (1 === c.tag) {
            var k = c.type;
            if (L(k)) {
                c = Ff(c, k, h);
                break a;
            }
        }
        c = h;
    } else c = Af;
    null === b.context ? b.context = c : b.pendingContext = c;
    b = wg(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    xg(e, b);
    Ig(e, f);
    return f;
}
function ck(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function dk(a, b) {
    a = a.memoizedState;
    null !== a && null !== a.dehydrated && a.retryTime < b && (a.retryTime = b);
}
function ek(a, b) {
    dk(a, b);
    (a = a.alternate) && dk(a, b);
}
function fk(a, b, c) {
    c = null != c && !0 === c.hydrate;
    var d = new ak(a, b, c), e = Sh(3, null, null, 2 === b ? 7 : 1 === b ? 3 : 0);
    d.current = e;
    e.stateNode = d;
    ug(e);
    a[Od] = d.current;
    c && 0 !== b && Jc(a, 9 === a.nodeType ? a : a.ownerDocument);
    this._internalRoot = d;
}
fk.prototype.render = function(a) {
    bk(a, this._internalRoot, null, null);
};
fk.prototype.unmount = function() {
    var a = this._internalRoot, b = a.containerInfo;
    bk(null, a, null, function() {
        b[Od] = null;
    });
};
function gk(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function hk(a, b) {
    b || (b = a ? 9 === a.nodeType ? a.documentElement : a.firstChild : null, b = !(!b || 1 !== b.nodeType || !b.hasAttribute("data-reactroot")));
    if (!b) for(var c; c = a.lastChild;)a.removeChild(c);
    return new fk(a, 0, b ? {
        hydrate: !0
    } : void 0);
}
function ik(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f._internalRoot;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = ck(g);
                h.call(a);
            };
        }
        bk(b, g, a, e);
    } else {
        f = c._reactRootContainer = hk(c, d);
        g = f._internalRoot;
        if ("function" === typeof e) {
            var k = e;
            e = function() {
                var a = ck(g);
                k.call(a);
            };
        }
        Nj(function() {
            bk(b, g, a, e);
        });
    }
    return ck(g);
}
function jk(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
wc = function(a) {
    if (13 === a.tag) {
        var b = hg(Gg(), 150, 100);
        Ig(a, b);
        ek(a, b);
    }
};
xc = function(a) {
    13 === a.tag && (Ig(a, 3), ek(a, 3));
};
yc = function(a) {
    if (13 === a.tag) {
        var b = Gg();
        b = Hg(b, a, null);
        Ig(a, b);
        ek(a, b);
    }
};
za = function(a, b, c) {
    switch(b){
        case "input":
            Cb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = Qd(d);
                        if (!e) throw Error(u(90));
                        yb(d);
                        Cb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            Kb(a, c);
            break;
        case "select":
            b = c.value, null != b && Hb(a, !!c.multiple, b, !1);
    }
};
Fa = Mj;
Ga = function(a, b, c, d, e) {
    var f = W;
    W |= 4;
    try {
        return cg(98, a.bind(null, b, c, d, e));
    } finally{
        W = f, W === V && gg();
    }
};
Ha = function() {
    (W & (1 | fj | gj)) === V && (Lj(), Dj());
};
Ia = function(a, b) {
    var c = W;
    W |= 2;
    try {
        return a(b);
    } finally{
        W = c, W === V && gg();
    }
};
function kk(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!gk(b)) throw Error(u(200));
    return jk(a, b, null, c);
}
var lk = {
    Events: [
        Nc,
        Pd,
        Qd,
        xa,
        ta,
        Xd,
        function(a) {
            jc(a, Wd);
        },
        Da,
        Ea,
        id,
        mc,
        Dj,
        {
            current: !1
        }
    ]
};
(function(a) {
    var b = a.findFiberByHostInstance;
    return Yj($38COw({}, a, {
        overrideHookState: null,
        overrideProps: null,
        setSuspenseHandler: null,
        scheduleUpdate: null,
        currentDispatcherRef: Wa.ReactCurrentDispatcher,
        findHostInstanceByFiber: function(a) {
            a = hc(a);
            return null === a ? null : a.stateNode;
        },
        findFiberByHostInstance: function(a) {
            return b ? b(a) : null;
        },
        findHostInstancesForRefresh: null,
        scheduleRefresh: null,
        scheduleRoot: null,
        setRefreshHandler: null,
        getCurrentFiber: null
    }));
})({
    findFiberByHostInstance: tc,
    bundleType: 0,
    version: "16.14.0",
    rendererPackageName: "react-dom"
});
exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = lk;
exports.createPortal = kk;
exports.findDOMNode = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternalFiber;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error(u(188));
        throw Error(u(268, Object.keys(a)));
    }
    a = hc(b);
    a = null === a ? null : a.stateNode;
    return a;
};
exports.flushSync = function(a, b) {
    if ((W & (fj | gj)) !== V) throw Error(u(187));
    var c = W;
    W |= 1;
    try {
        return cg(99, a.bind(null, b));
    } finally{
        W = c, gg();
    }
};
exports.hydrate = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !0, c);
};
exports.render = function(a, b, c) {
    if (!gk(b)) throw Error(u(200));
    return ik(null, a, b, !1, c);
};
exports.unmountComponentAtNode = function(a) {
    if (!gk(a)) throw Error(u(40));
    return a._reactRootContainer ? (Nj(function() {
        ik(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[Od] = null;
        });
    }), !0) : !1;
};
exports.unstable_batchedUpdates = Mj;
exports.unstable_createPortal = function(a, b) {
    return kk(a, b, 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null);
};
exports.unstable_renderSubtreeIntoContainer = function(a, b, c, d) {
    if (!gk(c)) throw Error(u(200));
    if (null == a || void 0 === a._reactInternalFiber) throw Error(u(38));
    return ik(a, b, c, !1, d);
};
exports.version = "16.14.0";

});
parcelRegister("3hvsM", function(module, exports) {
'use strict';

module.exports = (parcelRequire("4bJqP"));

});
parcelRegister("4bJqP", function(module, exports) {
$parcel$export(module.exports, "unstable_now", () => $30cb6e4b156fa063$export$c4744153514ff05d, (v) => $30cb6e4b156fa063$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $30cb6e4b156fa063$export$d66a1c1c77bd778b, (v) => $30cb6e4b156fa063$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $30cb6e4b156fa063$export$3e506c1ccc9cc1a7, (v) => $30cb6e4b156fa063$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $30cb6e4b156fa063$export$e26fe2ed2fa76875, (v) => $30cb6e4b156fa063$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $30cb6e4b156fa063$export$502329bbf4b505b1, (v) => $30cb6e4b156fa063$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $30cb6e4b156fa063$export$6e3807111c4874c4, (v) => $30cb6e4b156fa063$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $30cb6e4b156fa063$export$c27134553091fb3a, (v) => $30cb6e4b156fa063$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $30cb6e4b156fa063$export$33ee1acdc04fd2a2, (v) => $30cb6e4b156fa063$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $30cb6e4b156fa063$export$b00a404bbd5edef2, (v) => $30cb6e4b156fa063$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $30cb6e4b156fa063$export$8352ce38b91d0c62, (v) => $30cb6e4b156fa063$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $30cb6e4b156fa063$export$d3dfb8e4810cb555, (v) => $30cb6e4b156fa063$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $30cb6e4b156fa063$export$839f9183b0465a69, (v) => $30cb6e4b156fa063$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $30cb6e4b156fa063$export$72fdf0e06517287b, (v) => $30cb6e4b156fa063$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $30cb6e4b156fa063$export$4b844e58a3e414b4, (v) => $30cb6e4b156fa063$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $30cb6e4b156fa063$export$816d2913ae6b83b1, (v) => $30cb6e4b156fa063$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $30cb6e4b156fa063$export$61bcfe829111a1d0, (v) => $30cb6e4b156fa063$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $30cb6e4b156fa063$export$7ee8c9beb337bc3f, (v) => $30cb6e4b156fa063$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $30cb6e4b156fa063$export$b5836b71941fa3ed, (v) => $30cb6e4b156fa063$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $30cb6e4b156fa063$export$cf845f2c119da08a, (v) => $30cb6e4b156fa063$export$cf845f2c119da08a = v);
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $30cb6e4b156fa063$export$c4744153514ff05d;
var $30cb6e4b156fa063$export$d66a1c1c77bd778b;
var $30cb6e4b156fa063$export$3e506c1ccc9cc1a7;
var $30cb6e4b156fa063$export$e26fe2ed2fa76875;
var $30cb6e4b156fa063$export$502329bbf4b505b1;
var $30cb6e4b156fa063$export$6e3807111c4874c4;
var $30cb6e4b156fa063$export$c27134553091fb3a;
var $30cb6e4b156fa063$export$33ee1acdc04fd2a2;
var $30cb6e4b156fa063$export$b00a404bbd5edef2;
var $30cb6e4b156fa063$export$8352ce38b91d0c62;
var $30cb6e4b156fa063$export$d3dfb8e4810cb555;
var $30cb6e4b156fa063$export$839f9183b0465a69;
var $30cb6e4b156fa063$export$72fdf0e06517287b;
var $30cb6e4b156fa063$export$4b844e58a3e414b4;
var $30cb6e4b156fa063$export$816d2913ae6b83b1;
var $30cb6e4b156fa063$export$61bcfe829111a1d0;
var $30cb6e4b156fa063$export$7ee8c9beb337bc3f;
var $30cb6e4b156fa063$export$b5836b71941fa3ed;
var $30cb6e4b156fa063$export$cf845f2c119da08a;
'use strict';
var $30cb6e4b156fa063$var$f, $30cb6e4b156fa063$var$g, $30cb6e4b156fa063$var$h, $30cb6e4b156fa063$var$k, $30cb6e4b156fa063$var$l;
if ("undefined" === typeof window || "function" !== typeof MessageChannel) {
    var $30cb6e4b156fa063$var$p = null, $30cb6e4b156fa063$var$q = null, $30cb6e4b156fa063$var$t = function() {
        if (null !== $30cb6e4b156fa063$var$p) try {
            var a = $30cb6e4b156fa063$export$c4744153514ff05d();
            $30cb6e4b156fa063$var$p(!0, a);
            $30cb6e4b156fa063$var$p = null;
        } catch (b) {
            throw setTimeout($30cb6e4b156fa063$var$t, 0), b;
        }
    }, $30cb6e4b156fa063$var$u = Date.now();
    $30cb6e4b156fa063$export$c4744153514ff05d = function() {
        return Date.now() - $30cb6e4b156fa063$var$u;
    };
    $30cb6e4b156fa063$var$f = function(a) {
        null !== $30cb6e4b156fa063$var$p ? setTimeout($30cb6e4b156fa063$var$f, 0, a) : ($30cb6e4b156fa063$var$p = a, setTimeout($30cb6e4b156fa063$var$t, 0));
    };
    $30cb6e4b156fa063$var$g = function(a, b) {
        $30cb6e4b156fa063$var$q = setTimeout(a, b);
    };
    $30cb6e4b156fa063$var$h = function() {
        clearTimeout($30cb6e4b156fa063$var$q);
    };
    $30cb6e4b156fa063$var$k = function() {
        return !1;
    };
    $30cb6e4b156fa063$var$l = $30cb6e4b156fa063$export$d66a1c1c77bd778b = function() {};
} else {
    var $30cb6e4b156fa063$var$w = window.performance, $30cb6e4b156fa063$var$x = window.Date, $30cb6e4b156fa063$var$y = window.setTimeout, $30cb6e4b156fa063$var$z = window.clearTimeout;
    if ("undefined" !== typeof console) {
        var $30cb6e4b156fa063$var$A = window.cancelAnimationFrame;
        "function" !== typeof window.requestAnimationFrame && console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
        "function" !== typeof $30cb6e4b156fa063$var$A && console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");
    }
    if ("object" === typeof $30cb6e4b156fa063$var$w && "function" === typeof $30cb6e4b156fa063$var$w.now) $30cb6e4b156fa063$export$c4744153514ff05d = function() {
        return $30cb6e4b156fa063$var$w.now();
    };
    else {
        var $30cb6e4b156fa063$var$B = $30cb6e4b156fa063$var$x.now();
        $30cb6e4b156fa063$export$c4744153514ff05d = function() {
            return $30cb6e4b156fa063$var$x.now() - $30cb6e4b156fa063$var$B;
        };
    }
    var $30cb6e4b156fa063$var$C = !1, $30cb6e4b156fa063$var$D = null, $30cb6e4b156fa063$var$E = -1, $30cb6e4b156fa063$var$F = 5, $30cb6e4b156fa063$var$G = 0;
    $30cb6e4b156fa063$var$k = function() {
        return $30cb6e4b156fa063$export$c4744153514ff05d() >= $30cb6e4b156fa063$var$G;
    };
    $30cb6e4b156fa063$var$l = function() {};
    $30cb6e4b156fa063$export$d66a1c1c77bd778b = function(a) {
        0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported") : $30cb6e4b156fa063$var$F = 0 < a ? Math.floor(1E3 / a) : 5;
    };
    var $30cb6e4b156fa063$var$H = new MessageChannel, $30cb6e4b156fa063$var$I = $30cb6e4b156fa063$var$H.port2;
    $30cb6e4b156fa063$var$H.port1.onmessage = function() {
        if (null !== $30cb6e4b156fa063$var$D) {
            var a = $30cb6e4b156fa063$export$c4744153514ff05d();
            $30cb6e4b156fa063$var$G = a + $30cb6e4b156fa063$var$F;
            try {
                $30cb6e4b156fa063$var$D(!0, a) ? $30cb6e4b156fa063$var$I.postMessage(null) : ($30cb6e4b156fa063$var$C = !1, $30cb6e4b156fa063$var$D = null);
            } catch (b) {
                throw $30cb6e4b156fa063$var$I.postMessage(null), b;
            }
        } else $30cb6e4b156fa063$var$C = !1;
    };
    $30cb6e4b156fa063$var$f = function(a) {
        $30cb6e4b156fa063$var$D = a;
        $30cb6e4b156fa063$var$C || ($30cb6e4b156fa063$var$C = !0, $30cb6e4b156fa063$var$I.postMessage(null));
    };
    $30cb6e4b156fa063$var$g = function(a, b) {
        $30cb6e4b156fa063$var$E = $30cb6e4b156fa063$var$y(function() {
            a($30cb6e4b156fa063$export$c4744153514ff05d());
        }, b);
    };
    $30cb6e4b156fa063$var$h = function() {
        $30cb6e4b156fa063$var$z($30cb6e4b156fa063$var$E);
        $30cb6e4b156fa063$var$E = -1;
    };
}
function $30cb6e4b156fa063$var$J(a, b) {
    var c = a.length;
    a.push(b);
    a: for(;;){
        var d = c - 1 >>> 1, e = a[d];
        if (void 0 !== e && 0 < $30cb6e4b156fa063$var$K(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $30cb6e4b156fa063$var$L(a) {
    a = a[0];
    return void 0 === a ? null : a;
}
function $30cb6e4b156fa063$var$M(a) {
    var b = a[0];
    if (void 0 !== b) {
        var c = a.pop();
        if (c !== b) {
            a[0] = c;
            a: for(var d = 0, e = a.length; d < e;){
                var m = 2 * (d + 1) - 1, n = a[m], v = m + 1, r = a[v];
                if (void 0 !== n && 0 > $30cb6e4b156fa063$var$K(n, c)) void 0 !== r && 0 > $30cb6e4b156fa063$var$K(r, n) ? (a[d] = r, a[v] = c, d = v) : (a[d] = n, a[m] = c, d = m);
                else if (void 0 !== r && 0 > $30cb6e4b156fa063$var$K(r, c)) a[d] = r, a[v] = c, d = v;
                else break a;
            }
        }
        return b;
    }
    return null;
}
function $30cb6e4b156fa063$var$K(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
var $30cb6e4b156fa063$var$N = [], $30cb6e4b156fa063$var$O = [], $30cb6e4b156fa063$var$P = 1, $30cb6e4b156fa063$var$Q = null, $30cb6e4b156fa063$var$R = 3, $30cb6e4b156fa063$var$S = !1, $30cb6e4b156fa063$var$T = !1, $30cb6e4b156fa063$var$U = !1;
function $30cb6e4b156fa063$var$V(a) {
    for(var b = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$O); null !== b;){
        if (null === b.callback) $30cb6e4b156fa063$var$M($30cb6e4b156fa063$var$O);
        else if (b.startTime <= a) $30cb6e4b156fa063$var$M($30cb6e4b156fa063$var$O), b.sortIndex = b.expirationTime, $30cb6e4b156fa063$var$J($30cb6e4b156fa063$var$N, b);
        else break;
        b = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$O);
    }
}
function $30cb6e4b156fa063$var$W(a) {
    $30cb6e4b156fa063$var$U = !1;
    $30cb6e4b156fa063$var$V(a);
    if (!$30cb6e4b156fa063$var$T) {
        if (null !== $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N)) $30cb6e4b156fa063$var$T = !0, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$X);
        else {
            var b = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$O);
            null !== b && $30cb6e4b156fa063$var$g($30cb6e4b156fa063$var$W, b.startTime - a);
        }
    }
}
function $30cb6e4b156fa063$var$X(a, b) {
    $30cb6e4b156fa063$var$T = !1;
    $30cb6e4b156fa063$var$U && ($30cb6e4b156fa063$var$U = !1, $30cb6e4b156fa063$var$h());
    $30cb6e4b156fa063$var$S = !0;
    var c = $30cb6e4b156fa063$var$R;
    try {
        $30cb6e4b156fa063$var$V(b);
        for($30cb6e4b156fa063$var$Q = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N); null !== $30cb6e4b156fa063$var$Q && (!($30cb6e4b156fa063$var$Q.expirationTime > b) || a && !$30cb6e4b156fa063$var$k());){
            var d = $30cb6e4b156fa063$var$Q.callback;
            if (null !== d) {
                $30cb6e4b156fa063$var$Q.callback = null;
                $30cb6e4b156fa063$var$R = $30cb6e4b156fa063$var$Q.priorityLevel;
                var e = d($30cb6e4b156fa063$var$Q.expirationTime <= b);
                b = $30cb6e4b156fa063$export$c4744153514ff05d();
                "function" === typeof e ? $30cb6e4b156fa063$var$Q.callback = e : $30cb6e4b156fa063$var$Q === $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N) && $30cb6e4b156fa063$var$M($30cb6e4b156fa063$var$N);
                $30cb6e4b156fa063$var$V(b);
            } else $30cb6e4b156fa063$var$M($30cb6e4b156fa063$var$N);
            $30cb6e4b156fa063$var$Q = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N);
        }
        if (null !== $30cb6e4b156fa063$var$Q) var m = !0;
        else {
            var n = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$O);
            null !== n && $30cb6e4b156fa063$var$g($30cb6e4b156fa063$var$W, n.startTime - b);
            m = !1;
        }
        return m;
    } finally{
        $30cb6e4b156fa063$var$Q = null, $30cb6e4b156fa063$var$R = c, $30cb6e4b156fa063$var$S = !1;
    }
}
function $30cb6e4b156fa063$var$Y(a) {
    switch(a){
        case 1:
            return -1;
        case 2:
            return 250;
        case 5:
            return 1073741823;
        case 4:
            return 1E4;
        default:
            return 5E3;
    }
}
var $30cb6e4b156fa063$var$Z = $30cb6e4b156fa063$var$l;
$30cb6e4b156fa063$export$3e506c1ccc9cc1a7 = 5;
$30cb6e4b156fa063$export$e26fe2ed2fa76875 = 1;
$30cb6e4b156fa063$export$502329bbf4b505b1 = 4;
$30cb6e4b156fa063$export$6e3807111c4874c4 = 3;
$30cb6e4b156fa063$export$c27134553091fb3a = null;
$30cb6e4b156fa063$export$33ee1acdc04fd2a2 = 2;
$30cb6e4b156fa063$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$30cb6e4b156fa063$export$8352ce38b91d0c62 = function() {
    $30cb6e4b156fa063$var$T || $30cb6e4b156fa063$var$S || ($30cb6e4b156fa063$var$T = !0, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$X));
};
$30cb6e4b156fa063$export$d3dfb8e4810cb555 = function() {
    return $30cb6e4b156fa063$var$R;
};
$30cb6e4b156fa063$export$839f9183b0465a69 = function() {
    return $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N);
};
$30cb6e4b156fa063$export$72fdf0e06517287b = function(a) {
    switch($30cb6e4b156fa063$var$R){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $30cb6e4b156fa063$var$R;
    }
    var c = $30cb6e4b156fa063$var$R;
    $30cb6e4b156fa063$var$R = b;
    try {
        return a();
    } finally{
        $30cb6e4b156fa063$var$R = c;
    }
};
$30cb6e4b156fa063$export$4b844e58a3e414b4 = function() {};
$30cb6e4b156fa063$export$816d2913ae6b83b1 = $30cb6e4b156fa063$var$Z;
$30cb6e4b156fa063$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $30cb6e4b156fa063$var$R;
    $30cb6e4b156fa063$var$R = a;
    try {
        return b();
    } finally{
        $30cb6e4b156fa063$var$R = c;
    }
};
$30cb6e4b156fa063$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $30cb6e4b156fa063$export$c4744153514ff05d();
    if ("object" === typeof c && null !== c) {
        var e = c.delay;
        e = "number" === typeof e && 0 < e ? d + e : d;
        c = "number" === typeof c.timeout ? c.timeout : $30cb6e4b156fa063$var$Y(a);
    } else c = $30cb6e4b156fa063$var$Y(a), e = d;
    c = e + c;
    a = {
        id: $30cb6e4b156fa063$var$P++,
        callback: b,
        priorityLevel: a,
        startTime: e,
        expirationTime: c,
        sortIndex: -1
    };
    e > d ? (a.sortIndex = e, $30cb6e4b156fa063$var$J($30cb6e4b156fa063$var$O, a), null === $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N) && a === $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$O) && ($30cb6e4b156fa063$var$U ? $30cb6e4b156fa063$var$h() : $30cb6e4b156fa063$var$U = !0, $30cb6e4b156fa063$var$g($30cb6e4b156fa063$var$W, e - d))) : (a.sortIndex = c, $30cb6e4b156fa063$var$J($30cb6e4b156fa063$var$N, a), $30cb6e4b156fa063$var$T || $30cb6e4b156fa063$var$S || ($30cb6e4b156fa063$var$T = !0, $30cb6e4b156fa063$var$f($30cb6e4b156fa063$var$X)));
    return a;
};
$30cb6e4b156fa063$export$b5836b71941fa3ed = function() {
    var a = $30cb6e4b156fa063$export$c4744153514ff05d();
    $30cb6e4b156fa063$var$V(a);
    var b = $30cb6e4b156fa063$var$L($30cb6e4b156fa063$var$N);
    return b !== $30cb6e4b156fa063$var$Q && null !== $30cb6e4b156fa063$var$Q && null !== b && null !== b.callback && b.startTime <= a && b.expirationTime < $30cb6e4b156fa063$var$Q.expirationTime || $30cb6e4b156fa063$var$k();
};
$30cb6e4b156fa063$export$cf845f2c119da08a = function(a) {
    var b = $30cb6e4b156fa063$var$R;
    return function() {
        var c = $30cb6e4b156fa063$var$R;
        $30cb6e4b156fa063$var$R = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $30cb6e4b156fa063$var$R = c;
        }
    };
};

});



parcelRegister("da6Nf", function(module, exports) {
$parcel$export(module.exports, "useSyncExternalStore", () => $99517a87e702896d$export$306c0aa65ff9ec16, (v) => $99517a87e702896d$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $99517a87e702896d$export$306c0aa65ff9ec16;
'use strict';

var $5FkrB = parcelRequire("5FkrB");
function $99517a87e702896d$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $99517a87e702896d$var$k = "function" === typeof Object.is ? Object.is : $99517a87e702896d$var$h, $99517a87e702896d$var$l = $5FkrB.useState, $99517a87e702896d$var$m = $5FkrB.useEffect, $99517a87e702896d$var$n = $5FkrB.useLayoutEffect, $99517a87e702896d$var$p = $5FkrB.useDebugValue;
function $99517a87e702896d$var$q(a, b) {
    var d = b(), f = $99517a87e702896d$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $99517a87e702896d$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $99517a87e702896d$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $99517a87e702896d$var$m(function() {
        $99517a87e702896d$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $99517a87e702896d$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $99517a87e702896d$var$p(d);
    return d;
}
function $99517a87e702896d$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$99517a87e702896d$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $99517a87e702896d$var$t(a, b) {
    return b();
}
var $99517a87e702896d$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $99517a87e702896d$var$t : $99517a87e702896d$var$q;
$99517a87e702896d$export$306c0aa65ff9ec16 = void 0 !== $5FkrB.useSyncExternalStore ? $5FkrB.useSyncExternalStore : $99517a87e702896d$var$u;

});

parcelRegister("6u0Zy", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $7XPdg = parcelRequire("7XPdg");
function $4b8650625e933407$var$emptyFunction() {}
function $4b8650625e933407$var$emptyFunctionWithReset() {}
$4b8650625e933407$var$emptyFunctionWithReset.resetWarningCache = $4b8650625e933407$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $7XPdg) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $4b8650625e933407$var$emptyFunctionWithReset,
        resetWarningCache: $4b8650625e933407$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("7XPdg", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $5cc5c4e4ae50b046$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $5cc5c4e4ae50b046$var$ReactPropTypesSecret;

});


parcelRegister("3gsre", function(module, exports) {
$parcel$export(module.exports, "AsyncMode", () => $2608ecfb9154a3b7$export$2b8d127b894957b9, (v) => $2608ecfb9154a3b7$export$2b8d127b894957b9 = v);
$parcel$export(module.exports, "ConcurrentMode", () => $2608ecfb9154a3b7$export$cea3a54a6425200c, (v) => $2608ecfb9154a3b7$export$cea3a54a6425200c = v);
$parcel$export(module.exports, "ContextConsumer", () => $2608ecfb9154a3b7$export$a7c73072b1a182ae, (v) => $2608ecfb9154a3b7$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $2608ecfb9154a3b7$export$9f27bc3417b4524d, (v) => $2608ecfb9154a3b7$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $2608ecfb9154a3b7$export$db77ccec0bb4ccac, (v) => $2608ecfb9154a3b7$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $2608ecfb9154a3b7$export$8392c0c9d3dcbd35, (v) => $2608ecfb9154a3b7$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $2608ecfb9154a3b7$export$ffb0004e005737fa, (v) => $2608ecfb9154a3b7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $2608ecfb9154a3b7$export$b624eff549462981, (v) => $2608ecfb9154a3b7$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $2608ecfb9154a3b7$export$7897aa7841a5380c, (v) => $2608ecfb9154a3b7$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $2608ecfb9154a3b7$export$602eac185826482c, (v) => $2608ecfb9154a3b7$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $2608ecfb9154a3b7$export$e2c29f18771995cb, (v) => $2608ecfb9154a3b7$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $2608ecfb9154a3b7$export$5f8d39834fd61797, (v) => $2608ecfb9154a3b7$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $2608ecfb9154a3b7$export$74bf444e3cd11ea5, (v) => $2608ecfb9154a3b7$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $2608ecfb9154a3b7$export$92387174baf9b227, (v) => $2608ecfb9154a3b7$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $2608ecfb9154a3b7$export$ec112efeb987d9c6, (v) => $2608ecfb9154a3b7$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $2608ecfb9154a3b7$export$b706b080d889d2c9, (v) => $2608ecfb9154a3b7$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $2608ecfb9154a3b7$export$5be5a87408f70ddc, (v) => $2608ecfb9154a3b7$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $2608ecfb9154a3b7$export$45a5e7f76e0caa8d, (v) => $2608ecfb9154a3b7$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $2608ecfb9154a3b7$export$455c2e768291efa6, (v) => $2608ecfb9154a3b7$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $2608ecfb9154a3b7$export$9522e17588c12572, (v) => $2608ecfb9154a3b7$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $2608ecfb9154a3b7$export$2110ac352bb060b9, (v) => $2608ecfb9154a3b7$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $2608ecfb9154a3b7$export$56885ab8b9c456ab, (v) => $2608ecfb9154a3b7$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $2608ecfb9154a3b7$export$d927fcb6adf8f9de, (v) => $2608ecfb9154a3b7$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $2608ecfb9154a3b7$export$b82d16f27459e05a, (v) => $2608ecfb9154a3b7$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $2608ecfb9154a3b7$export$522c17b4f5e123e8, (v) => $2608ecfb9154a3b7$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $2608ecfb9154a3b7$export$1aabd8a0274ecfd6, (v) => $2608ecfb9154a3b7$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $2608ecfb9154a3b7$export$9b621391a187a31a, (v) => $2608ecfb9154a3b7$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $2608ecfb9154a3b7$export$f5bbd400c2f4426f, (v) => $2608ecfb9154a3b7$export$f5bbd400c2f4426f = v);
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $2608ecfb9154a3b7$export$2b8d127b894957b9;
var $2608ecfb9154a3b7$export$cea3a54a6425200c;
var $2608ecfb9154a3b7$export$a7c73072b1a182ae;
var $2608ecfb9154a3b7$export$9f27bc3417b4524d;
var $2608ecfb9154a3b7$export$db77ccec0bb4ccac;
var $2608ecfb9154a3b7$export$8392c0c9d3dcbd35;
var $2608ecfb9154a3b7$export$ffb0004e005737fa;
var $2608ecfb9154a3b7$export$b624eff549462981;
var $2608ecfb9154a3b7$export$7897aa7841a5380c;
var $2608ecfb9154a3b7$export$602eac185826482c;
var $2608ecfb9154a3b7$export$e2c29f18771995cb;
var $2608ecfb9154a3b7$export$5f8d39834fd61797;
var $2608ecfb9154a3b7$export$74bf444e3cd11ea5;
var $2608ecfb9154a3b7$export$92387174baf9b227;
var $2608ecfb9154a3b7$export$ec112efeb987d9c6;
var $2608ecfb9154a3b7$export$b706b080d889d2c9;
var $2608ecfb9154a3b7$export$5be5a87408f70ddc;
var $2608ecfb9154a3b7$export$45a5e7f76e0caa8d;
var $2608ecfb9154a3b7$export$455c2e768291efa6;
var $2608ecfb9154a3b7$export$9522e17588c12572;
var $2608ecfb9154a3b7$export$2110ac352bb060b9;
var $2608ecfb9154a3b7$export$56885ab8b9c456ab;
var $2608ecfb9154a3b7$export$d927fcb6adf8f9de;
var $2608ecfb9154a3b7$export$b82d16f27459e05a;
var $2608ecfb9154a3b7$export$522c17b4f5e123e8;
var $2608ecfb9154a3b7$export$1aabd8a0274ecfd6;
var $2608ecfb9154a3b7$export$9b621391a187a31a;
var $2608ecfb9154a3b7$export$f5bbd400c2f4426f;
'use strict';
var $2608ecfb9154a3b7$var$b = "function" === typeof Symbol && Symbol.for, $2608ecfb9154a3b7$var$c = $2608ecfb9154a3b7$var$b ? Symbol.for("react.element") : 60103, $2608ecfb9154a3b7$var$d = $2608ecfb9154a3b7$var$b ? Symbol.for("react.portal") : 60106, $2608ecfb9154a3b7$var$e = $2608ecfb9154a3b7$var$b ? Symbol.for("react.fragment") : 60107, $2608ecfb9154a3b7$var$f = $2608ecfb9154a3b7$var$b ? Symbol.for("react.strict_mode") : 60108, $2608ecfb9154a3b7$var$g = $2608ecfb9154a3b7$var$b ? Symbol.for("react.profiler") : 60114, $2608ecfb9154a3b7$var$h = $2608ecfb9154a3b7$var$b ? Symbol.for("react.provider") : 60109, $2608ecfb9154a3b7$var$k = $2608ecfb9154a3b7$var$b ? Symbol.for("react.context") : 60110, $2608ecfb9154a3b7$var$l = $2608ecfb9154a3b7$var$b ? Symbol.for("react.async_mode") : 60111, $2608ecfb9154a3b7$var$m = $2608ecfb9154a3b7$var$b ? Symbol.for("react.concurrent_mode") : 60111, $2608ecfb9154a3b7$var$n = $2608ecfb9154a3b7$var$b ? Symbol.for("react.forward_ref") : 60112, $2608ecfb9154a3b7$var$p = $2608ecfb9154a3b7$var$b ? Symbol.for("react.suspense") : 60113, $2608ecfb9154a3b7$var$q = $2608ecfb9154a3b7$var$b ? Symbol.for("react.suspense_list") : 60120, $2608ecfb9154a3b7$var$r = $2608ecfb9154a3b7$var$b ? Symbol.for("react.memo") : 60115, $2608ecfb9154a3b7$var$t = $2608ecfb9154a3b7$var$b ? Symbol.for("react.lazy") : 60116, $2608ecfb9154a3b7$var$v = $2608ecfb9154a3b7$var$b ? Symbol.for("react.block") : 60121, $2608ecfb9154a3b7$var$w = $2608ecfb9154a3b7$var$b ? Symbol.for("react.fundamental") : 60117, $2608ecfb9154a3b7$var$x = $2608ecfb9154a3b7$var$b ? Symbol.for("react.responder") : 60118, $2608ecfb9154a3b7$var$y = $2608ecfb9154a3b7$var$b ? Symbol.for("react.scope") : 60119;
function $2608ecfb9154a3b7$var$z(a) {
    if ("object" === typeof a && null !== a) {
        var u = a.$$typeof;
        switch(u){
            case $2608ecfb9154a3b7$var$c:
                switch(a = a.type, a){
                    case $2608ecfb9154a3b7$var$l:
                    case $2608ecfb9154a3b7$var$m:
                    case $2608ecfb9154a3b7$var$e:
                    case $2608ecfb9154a3b7$var$g:
                    case $2608ecfb9154a3b7$var$f:
                    case $2608ecfb9154a3b7$var$p:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $2608ecfb9154a3b7$var$k:
                            case $2608ecfb9154a3b7$var$n:
                            case $2608ecfb9154a3b7$var$t:
                            case $2608ecfb9154a3b7$var$r:
                            case $2608ecfb9154a3b7$var$h:
                                return a;
                            default:
                                return u;
                        }
                }
            case $2608ecfb9154a3b7$var$d:
                return u;
        }
    }
}
function $2608ecfb9154a3b7$var$A(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$m;
}
$2608ecfb9154a3b7$export$2b8d127b894957b9 = $2608ecfb9154a3b7$var$l;
$2608ecfb9154a3b7$export$cea3a54a6425200c = $2608ecfb9154a3b7$var$m;
$2608ecfb9154a3b7$export$a7c73072b1a182ae = $2608ecfb9154a3b7$var$k;
$2608ecfb9154a3b7$export$9f27bc3417b4524d = $2608ecfb9154a3b7$var$h;
$2608ecfb9154a3b7$export$db77ccec0bb4ccac = $2608ecfb9154a3b7$var$c;
$2608ecfb9154a3b7$export$8392c0c9d3dcbd35 = $2608ecfb9154a3b7$var$n;
$2608ecfb9154a3b7$export$ffb0004e005737fa = $2608ecfb9154a3b7$var$e;
$2608ecfb9154a3b7$export$b624eff549462981 = $2608ecfb9154a3b7$var$t;
$2608ecfb9154a3b7$export$7897aa7841a5380c = $2608ecfb9154a3b7$var$r;
$2608ecfb9154a3b7$export$602eac185826482c = $2608ecfb9154a3b7$var$d;
$2608ecfb9154a3b7$export$e2c29f18771995cb = $2608ecfb9154a3b7$var$g;
$2608ecfb9154a3b7$export$5f8d39834fd61797 = $2608ecfb9154a3b7$var$f;
$2608ecfb9154a3b7$export$74bf444e3cd11ea5 = $2608ecfb9154a3b7$var$p;
$2608ecfb9154a3b7$export$92387174baf9b227 = function(a) {
    return $2608ecfb9154a3b7$var$A(a) || $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$l;
};
$2608ecfb9154a3b7$export$ec112efeb987d9c6 = $2608ecfb9154a3b7$var$A;
$2608ecfb9154a3b7$export$b706b080d889d2c9 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$k;
};
$2608ecfb9154a3b7$export$5be5a87408f70ddc = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$h;
};
$2608ecfb9154a3b7$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $2608ecfb9154a3b7$var$c;
};
$2608ecfb9154a3b7$export$455c2e768291efa6 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$n;
};
$2608ecfb9154a3b7$export$9522e17588c12572 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$e;
};
$2608ecfb9154a3b7$export$2110ac352bb060b9 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$t;
};
$2608ecfb9154a3b7$export$56885ab8b9c456ab = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$r;
};
$2608ecfb9154a3b7$export$d927fcb6adf8f9de = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$d;
};
$2608ecfb9154a3b7$export$b82d16f27459e05a = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$g;
};
$2608ecfb9154a3b7$export$522c17b4f5e123e8 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$f;
};
$2608ecfb9154a3b7$export$1aabd8a0274ecfd6 = function(a) {
    return $2608ecfb9154a3b7$var$z(a) === $2608ecfb9154a3b7$var$p;
};
$2608ecfb9154a3b7$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $2608ecfb9154a3b7$var$e || a === $2608ecfb9154a3b7$var$m || a === $2608ecfb9154a3b7$var$g || a === $2608ecfb9154a3b7$var$f || a === $2608ecfb9154a3b7$var$p || a === $2608ecfb9154a3b7$var$q || "object" === typeof a && null !== a && (a.$$typeof === $2608ecfb9154a3b7$var$t || a.$$typeof === $2608ecfb9154a3b7$var$r || a.$$typeof === $2608ecfb9154a3b7$var$h || a.$$typeof === $2608ecfb9154a3b7$var$k || a.$$typeof === $2608ecfb9154a3b7$var$n || a.$$typeof === $2608ecfb9154a3b7$var$w || a.$$typeof === $2608ecfb9154a3b7$var$x || a.$$typeof === $2608ecfb9154a3b7$var$y || a.$$typeof === $2608ecfb9154a3b7$var$v);
};
$2608ecfb9154a3b7$export$f5bbd400c2f4426f = $2608ecfb9154a3b7$var$z;

});

var $faf30355a80342e4$exports = {};
'use strict';

$faf30355a80342e4$exports = (parcelRequire("eumjn"));


parcelRequire("5FkrB");
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1d4627fd04ff26b2$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/** Internal global with common properties and Sentry extensions  */ /** Get's the global object for the current JavaScript runtime */ const $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1 = globalThis;
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $3d53d2e16cab3c2d$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}


/** Prefix for logging strings */ const $117c8f31aa65bddd$var$PREFIX = 'Sentry Logger ';
const $117c8f31aa65bddd$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $117c8f31aa65bddd$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $117c8f31aa65bddd$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1))) return callback();
    const console = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($117c8f31aa65bddd$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $117c8f31aa65bddd$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $117c8f31aa65bddd$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $1d4627fd04ff26b2$export$16a28057038b10ef) $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $117c8f31aa65bddd$export$cda52e2a8927a2ca(()=>{
                (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).console[name](`${$117c8f31aa65bddd$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $117c8f31aa65bddd$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $117c8f31aa65bddd$export$af88d00dbe7f521 = $117c8f31aa65bddd$var$makeLogger();


const $81b681a083912fb6$var$STACKTRACE_FRAME_LIMIT = 50;
const $81b681a083912fb6$export$27c7e15d453fc0ac = '?';
// Used to sanitize webpack (error: *) wrapped stack errors
const $81b681a083912fb6$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $81b681a083912fb6$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $81b681a083912fb6$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirstLines = 0, framesToPop = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirstLines; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $81b681a083912fb6$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($81b681a083912fb6$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $81b681a083912fb6$var$STACKTRACE_FRAME_LIMIT + framesToPop) break;
        }
        return $81b681a083912fb6$export$c55c24c0eeba0205(frames.slice(framesToPop));
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $81b681a083912fb6$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $81b681a083912fb6$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $81b681a083912fb6$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($81b681a083912fb6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($81b681a083912fb6$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $81b681a083912fb6$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || $81b681a083912fb6$export$27c7e15d453fc0ac
        }));
}
const $81b681a083912fb6$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $81b681a083912fb6$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $81b681a083912fb6$var$defaultFunctionName;
        return fn.name || $81b681a083912fb6$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $81b681a083912fb6$var$defaultFunctionName;
    }
}


// We keep the handlers globally
const $fb3c91b0664aac42$var$handlers = {};
const $fb3c91b0664aac42$var$instrumented = {};
/** Add a handler function. */ function $fb3c91b0664aac42$export$a4e09611e30da72e(type, handler) {
    $fb3c91b0664aac42$var$handlers[type] = $fb3c91b0664aac42$var$handlers[type] || [];
    $fb3c91b0664aac42$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $fb3c91b0664aac42$export$b17eab759a1cb5fe() {
    Object.keys($fb3c91b0664aac42$var$handlers).forEach((key)=>{
        $fb3c91b0664aac42$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $fb3c91b0664aac42$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$fb3c91b0664aac42$var$instrumented[type]) {
        instrumentFn();
        $fb3c91b0664aac42$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $fb3c91b0664aac42$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $fb3c91b0664aac42$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $1d4627fd04ff26b2$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $81b681a083912fb6$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}

// eslint-disable-next-line @typescript-eslint/unbound-method
const $626eb84a64d84c41$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$e6127cc7fe7395c3(wat) {
    switch($626eb84a64d84c41$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $626eb84a64d84c41$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$var$isBuiltin(wat, className) {
    return $626eb84a64d84c41$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$9f9636d330b71954(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$ef9e2056653f0c8e(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$12e869b2a583f783(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$844ec244b1367d54(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$c3825b437cbdea5c(wat) {
    return wat === null || $626eb84a64d84c41$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$53b83ca8eaab0383(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $626eb84a64d84c41$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $626eb84a64d84c41$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$49841c62b9eff15(wat) {
    return $626eb84a64d84c41$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $626eb84a64d84c41$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$bc2894c7158efbac(wat) {
    return $626eb84a64d84c41$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $626eb84a64d84c41$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}



const $b076601639d1314e$var$WINDOW = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
const $b076601639d1314e$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b076601639d1314e$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $b076601639d1314e$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $b076601639d1314e$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $b076601639d1314e$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($b076601639d1314e$var$WINDOW.HTMLElement) // If using the component name annotation plugin, this value may be available on the DOM node
    {
        if (elem instanceof HTMLElement && elem.dataset) {
            if (elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
            if (elem.dataset['sentryElement']) return elem.dataset['sentryElement'];
        }
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        className = elem.className;
        if (className && (0, $626eb84a64d84c41$export$844ec244b1367d54)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $b076601639d1314e$export$1cfafeee2987818b() {
    try {
        return $b076601639d1314e$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $b076601639d1314e$export$c660c1f3ab49225c(selector) {
    if ($b076601639d1314e$var$WINDOW.document && $b076601639d1314e$var$WINDOW.document.querySelector) return $b076601639d1314e$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` or `data-sentry-element` attribute with `data-sentry-component` taking
 * precendence. This attribute is added at build-time by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $b076601639d1314e$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$b076601639d1314e$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement) {
            if (currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
            if (currentElem.dataset['sentryElement']) return currentElem.dataset['sentryElement'];
        }
        currentElem = currentElem.parentNode;
    }
    return null;
}






/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $6c98f0cd61ae7fe0$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $6c98f0cd61ae7fe0$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6c98f0cd61ae7fe0$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $626eb84a64d84c41$export$7916fad0ebc23f48)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $6c98f0cd61ae7fe0$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $626eb84a64d84c41$export$844ec244b1367d54)(value)) return false;
    if ((0, $626eb84a64d84c41$export$49841c62b9eff15)(pattern)) return pattern.test(value);
    if ((0, $626eb84a64d84c41$export$844ec244b1367d54)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$6c98f0cd61ae7fe0$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}


/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $68dbcfd11e00a6d4$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $68dbcfd11e00a6d4$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $68dbcfd11e00a6d4$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $1d4627fd04ff26b2$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $68dbcfd11e00a6d4$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $68dbcfd11e00a6d4$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $68dbcfd11e00a6d4$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $68dbcfd11e00a6d4$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $68dbcfd11e00a6d4$export$62ff257738bf57f5(value) {
    if ((0, $626eb84a64d84c41$export$e6127cc7fe7395c3)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$68dbcfd11e00a6d4$var$getOwnProperties(value)
    };
    else if ((0, $626eb84a64d84c41$export$9671ea99bd126ace)(value)) {
        const newObj = {
            type: value.type,
            target: $68dbcfd11e00a6d4$var$serializeEventTarget(value.target),
            currentTarget: $68dbcfd11e00a6d4$var$serializeEventTarget(value.currentTarget),
            ...$68dbcfd11e00a6d4$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $626eb84a64d84c41$export$49034edbe6b62415)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $68dbcfd11e00a6d4$var$serializeEventTarget(target) {
    try {
        return (0, $626eb84a64d84c41$export$45a5e7f76e0caa8d)(target) ? (0, $b076601639d1314e$export$5647df6b7814ac86)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $68dbcfd11e00a6d4$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $68dbcfd11e00a6d4$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($68dbcfd11e00a6d4$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $6c98f0cd61ae7fe0$export$6a506b36fdea397d)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $6c98f0cd61ae7fe0$export$6a506b36fdea397d)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $68dbcfd11e00a6d4$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $68dbcfd11e00a6d4$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $68dbcfd11e00a6d4$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($68dbcfd11e00a6d4$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $68dbcfd11e00a6d4$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($68dbcfd11e00a6d4$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $68dbcfd11e00a6d4$var$isPojo(input) {
    if (!(0, $626eb84a64d84c41$export$53b83ca8eaab0383)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $68dbcfd11e00a6d4$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $626eb84a64d84c41$export$c3825b437cbdea5c)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}


// Based on https://github.com/angular/angular.js/pull/13945/files
// The MIT License
const $da51cf14c9500606$var$WINDOW = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $da51cf14c9500606$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $da51cf14c9500606$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $da51cf14c9500606$var$WINDOW && !!$da51cf14c9500606$var$WINDOW.history.pushState && !!$da51cf14c9500606$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}



const $2e0ad70334800584$export$56d8a8a25bd48b81 = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);


let $81fb4056224c2de0$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $81fb4056224c2de0$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $81fb4056224c2de0$var$instrumentHistory);
}
function $81fb4056224c2de0$var$instrumentHistory() {
    if (!(0, $da51cf14c9500606$export$67fc34576016d6ec)()) return;
    const oldOnPopState = (0, $2e0ad70334800584$export$56d8a8a25bd48b81).onpopstate;
    (0, $2e0ad70334800584$export$56d8a8a25bd48b81).onpopstate = function(...args) {
        const to = (0, $2e0ad70334800584$export$56d8a8a25bd48b81).location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $81fb4056224c2de0$var$lastHref;
        $81fb4056224c2de0$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $fb3c91b0664aac42$export$b18c893e424d3127)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $81fb4056224c2de0$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $81fb4056224c2de0$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $fb3c91b0664aac42$export$b18c893e424d3127)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $2e0ad70334800584$export$56d8a8a25bd48b81).history, 'pushState', historyReplacementFunction);
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $2e0ad70334800584$export$56d8a8a25bd48b81).history, 'replaceState', historyReplacementFunction);
}




const $e464efef87fcab6d$export$9ca9946bd449ac06 = 'baggage';
const $e464efef87fcab6d$export$6e69537d67fa20f = 'sentry-';
const $e464efef87fcab6d$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $e464efef87fcab6d$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $e464efef87fcab6d$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    const baggageObject = $e464efef87fcab6d$export$397de414d189db00(baggageHeader);
    if (!baggageObject) return undefined;
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($e464efef87fcab6d$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($e464efef87fcab6d$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $e464efef87fcab6d$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$e464efef87fcab6d$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $e464efef87fcab6d$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Take a baggage header and parse it into an object.
 */ function $e464efef87fcab6d$export$397de414d189db00(baggageHeader) {
    if (!baggageHeader || !(0, $626eb84a64d84c41$export$844ec244b1367d54)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    return baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $e464efef87fcab6d$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    return $e464efef87fcab6d$var$baggageHeaderToObject(baggageHeader);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $e464efef87fcab6d$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $e464efef87fcab6d$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $e464efef87fcab6d$export$bdd844ddb2def819) {
            (0, $1d4627fd04ff26b2$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}





/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $523c16f3b9d02706$export$19f53698e68b2496() {
    const gbl = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $523c16f3b9d02706$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $523c16f3b9d02706$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $523c16f3b9d02706$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $523c16f3b9d02706$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $523c16f3b9d02706$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $523c16f3b9d02706$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $523c16f3b9d02706$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $523c16f3b9d02706$export$d364f2020ab30578(input) {
    const match = input.match($523c16f3b9d02706$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $523c16f3b9d02706$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $6c98f0cd61ae7fe0$export$4215662d762d6f9d)(line, 0));
    frame.context_line = (0, $6c98f0cd61ae7fe0$export$4215662d762d6f9d)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $6c98f0cd61ae7fe0$export$4215662d762d6f9d)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $523c16f3b9d02706$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $523c16f3b9d02706$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}


// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $2d400f23bf5d035c$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $2d400f23bf5d035c$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($2d400f23bf5d035c$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create a propagation context from incoming headers or
 * creates a minimal new one if the headers are undefined.
 */ function $2d400f23bf5d035c$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $2d400f23bf5d035c$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $e464efef87fcab6d$export$5b96ee2c8421f107)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
        spanId: (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16)
    };
    else return {
        traceId: traceId || (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
        parentSpanId: parentSpanId || (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16),
        spanId: (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $2d400f23bf5d035c$export$f35d907436da45cf(traceId = (0, $523c16f3b9d02706$export$19f53698e68b2496)(), spanId = (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}


const $8f221861fb4a2bd8$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $8f221861fb4a2bd8$export$7740643b9eeaf0c4() {
    return Date.now() / $8f221861fb4a2bd8$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $8f221861fb4a2bd8$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) return $8f221861fb4a2bd8$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $8f221861fb4a2bd8$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $8f221861fb4a2bd8$export$ee52dced521e3e18 = $8f221861fb4a2bd8$var$createUnixTimestampInSecondsFunc();
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $8f221861fb4a2bd8$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $8f221861fb4a2bd8$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
    if (!performance || !performance.now) {
        $8f221861fb4a2bd8$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $8f221861fb4a2bd8$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $8f221861fb4a2bd8$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $8f221861fb4a2bd8$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();



/**
 * An object that contains a hub and maintains a scope stack.
 * @hidden
 */ /**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $ee9f51b9ad47d1ec$export$19eade501500c6c1() {
    // This ensures a Sentry carrier exists
    $ee9f51b9ad47d1ec$export$c8bfa33e4e8ae492((0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1));
    return 0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1;
}
/** Will either get the existing sentry carrier, or create a new one. */ function $ee9f51b9ad47d1ec$export$c8bfa33e4e8ae492(carrier) {
    if (!carrier.__SENTRY__) carrier.__SENTRY__ = {
        extensions: {}
    };
    return carrier.__SENTRY__;
}






/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $e5d156d85c4b77f8$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
    const session = {
        sid: (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$e5d156d85c4b77f8$var$sessionToJSON(session)
    };
    if (context) $e5d156d85c4b77f8$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $e5d156d85c4b77f8$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $523c16f3b9d02706$export$19f53698e68b2496)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $e5d156d85c4b77f8$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $e5d156d85c4b77f8$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $e5d156d85c4b77f8$var$sessionToJSON(session) {
    return (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}



const $155d912cac8f959f$var$SCOPE_SPAN_FIELD = '_sentrySpan';
/**
 * Set the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $155d912cac8f959f$export$3f25fa50c18e20ca(scope, span) {
    if (span) (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(scope, $155d912cac8f959f$var$SCOPE_SPAN_FIELD, span);
    else // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
    delete scope[$155d912cac8f959f$var$SCOPE_SPAN_FIELD];
}
/**
 * Get the active span for a given scope.
 * NOTE: This should NOT be used directly, but is only used internally by the trace methods.
 */ function $155d912cac8f959f$export$91f063ebb8eff307(scope) {
    return scope[$155d912cac8f959f$var$SCOPE_SPAN_FIELD];
}


/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $fa9a88ae27530aed$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information.
 */ class $fa9a88ae27530aed$var$ScopeClass {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called during event processing. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ /** Contains the last event id of a captured event.  */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $fa9a88ae27530aed$var$generatePropagationContext();
    }
    /**
   * @inheritDoc
   */ clone() {
        const newScope = new $fa9a88ae27530aed$var$ScopeClass();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        newScope._lastEventId = this._lastEventId;
        (0, $155d912cac8f959f$export$3f25fa50c18e20ca)(newScope, (0, $155d912cac8f959f$export$91f063ebb8eff307)(this));
        return newScope;
    }
    /**
   * @inheritDoc
   */ setClient(client) {
        this._client = client;
    }
    /**
   * @inheritDoc
   */ setLastEventId(lastEventId) {
        this._lastEventId = lastEventId;
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this._client;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            username: undefined
        };
        if (this._session) (0, $e5d156d85c4b77f8$export$531818e825e774db)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        const [scopeInstance, requestSession] = scopeToMerge instanceof $fa9a88ae27530aed$export$775b6bb06e53a214 ? [
            scopeToMerge.getScopeData(),
            scopeToMerge.getRequestSession()
        ] : (0, $626eb84a64d84c41$export$53b83ca8eaab0383)(scopeToMerge) ? [
            captureContext,
            captureContext.requestSession
        ] : [];
        const { tags: tags, extra: extra, user: user, contexts: contexts, level: level, fingerprint: fingerprint = [], propagationContext: propagationContext } = scopeInstance || {};
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._extra = {
            ...this._extra,
            ...extra
        };
        this._contexts = {
            ...this._contexts,
            ...contexts
        };
        if (user && Object.keys(user).length) this._user = user;
        if (level) this._level = level;
        if (fingerprint.length) this._fingerprint = fingerprint;
        if (propagationContext) this._propagationContext = propagationContext;
        if (requestSession) this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        // client is not cleared here on purpose!
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._session = undefined;
        (0, $155d912cac8f959f$export$3f25fa50c18e20ca)(this, undefined);
        this._attachments = [];
        this._propagationContext = $fa9a88ae27530aed$var$generatePropagationContext();
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $fa9a88ae27530aed$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $8f221861fb4a2bd8$export$7740643b9eeaf0c4)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        return {
            breadcrumbs: this._breadcrumbs,
            attachments: this._attachments,
            contexts: this._contexts,
            tags: this._tags,
            extra: this._extra,
            user: this._user,
            level: this._level,
            fingerprint: this._fingerprint || [],
            eventProcessors: this._eventProcessors,
            propagationContext: this._propagationContext,
            sdkProcessingMetadata: this._sdkProcessingMetadata,
            transactionName: this._transactionName,
            span: (0, $155d912cac8f959f$export$91f063ebb8eff307)(this)
        };
    }
    /**
   * @inheritDoc
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        if (!this._client) {
            (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
// NOTE: By exporting this here as const & type, instead of doing `export class`,
// We can get the correct class when importing from `@sentry/core`, but the original type (from `@sentry/types`)
// This is helpful for interop, e.g. when doing `import type { Scope } from '@sentry/node';` (which re-exports this)
/**
 * Holds additional event information.
 */ const $fa9a88ae27530aed$export$775b6bb06e53a214 = $fa9a88ae27530aed$var$ScopeClass;
/**
 * Holds additional event information.
 */ function $fa9a88ae27530aed$var$generatePropagationContext() {
    return {
        traceId: (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
        spanId: (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16)
    };
}


/** Get the default current scope. */ function $56575ef97078c1b4$export$6f1b9191db9c4d5() {
    return (0, $3d53d2e16cab3c2d$export$7e223ec222791509)('defaultCurrentScope', ()=>new (0, $fa9a88ae27530aed$export$775b6bb06e53a214)());
}
/** Get the default isolation scope. */ function $56575ef97078c1b4$export$de9862929b76bf57() {
    return (0, $3d53d2e16cab3c2d$export$7e223ec222791509)('defaultIsolationScope', ()=>new (0, $fa9a88ae27530aed$export$775b6bb06e53a214)());
}




/**
 * This is an object that holds a stack of scopes.
 */ class $dcaf9720596c4bb7$export$d36ec451f120cfba {
    constructor(scope, isolationScope){
        let assignedScope;
        if (!scope) assignedScope = new (0, $fa9a88ae27530aed$export$775b6bb06e53a214)();
        else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) assignedIsolationScope = new (0, $fa9a88ae27530aed$export$775b6bb06e53a214)();
        else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Fork a scope for the stack.
   */ withScope(callback) {
        const scope = this._pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            this._popScope();
            throw e;
        }
        if ((0, $626eb84a64d84c41$export$f5b060c2914b97c8)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            this._popScope();
            return res;
        }, (e)=>{
            this._popScope();
            throw e;
        });
        this._popScope();
        return maybePromiseResult;
    }
    /**
   * Get the client of the stack.
   */ getClient() {
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   */ getScope() {
        return this.getStackTop().scope;
    }
    /**
   * Get the isolation scope for the stack.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * Push a scope to the stack.
   */ _pushScope() {
        // We want to clone the content of prev scope
        const scope = this.getScope().clone();
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * Pop a scope from the stack.
   */ _popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
}
/**
 * Get the global async context stack.
 * This will be removed during the v8 cycle and is only here to make migration easier.
 */ function $dcaf9720596c4bb7$var$getAsyncContextStack() {
    const registry = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    // For now we continue to keep this as `hub` on the ACS,
    // as e.g. the Loader Script relies on this.
    // Eventually we may change this if/when we update the loader to not require this field anymore
    // Related, we also write to `hub` in {@link ./../sdk.ts registerClientOnGlobalHub}
    const sentry = (0, $ee9f51b9ad47d1ec$export$c8bfa33e4e8ae492)(registry);
    if (sentry.hub) return sentry.hub;
    sentry.hub = new $dcaf9720596c4bb7$export$d36ec451f120cfba((0, $56575ef97078c1b4$export$6f1b9191db9c4d5)(), (0, $56575ef97078c1b4$export$de9862929b76bf57)());
    return sentry.hub;
}
function $dcaf9720596c4bb7$var$withScope(callback) {
    return $dcaf9720596c4bb7$var$getAsyncContextStack().withScope(callback);
}
function $dcaf9720596c4bb7$var$withSetScope(scope, callback) {
    const hub = $dcaf9720596c4bb7$var$getAsyncContextStack();
    return hub.withScope(()=>{
        hub.getStackTop().scope = scope;
        return callback(scope);
    });
}
function $dcaf9720596c4bb7$var$withIsolationScope(callback) {
    return $dcaf9720596c4bb7$var$getAsyncContextStack().withScope(()=>{
        return callback($dcaf9720596c4bb7$var$getAsyncContextStack().getIsolationScope());
    });
}
/**
 * Get the stack-based async context strategy.
 */ function $dcaf9720596c4bb7$export$329d4d4d54e42710() {
    return {
        withIsolationScope: $dcaf9720596c4bb7$var$withIsolationScope,
        withScope: $dcaf9720596c4bb7$var$withScope,
        withSetScope: $dcaf9720596c4bb7$var$withSetScope,
        withSetIsolationScope: (_isolationScope, callback)=>{
            return $dcaf9720596c4bb7$var$withIsolationScope(callback);
        },
        getCurrentScope: ()=>$dcaf9720596c4bb7$var$getAsyncContextStack().getScope(),
        getIsolationScope: ()=>$dcaf9720596c4bb7$var$getAsyncContextStack().getIsolationScope()
    };
}


/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $0d44489bfe738172$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    const sentry = (0, $ee9f51b9ad47d1ec$export$c8bfa33e4e8ae492)(registry);
    sentry.acs = strategy;
}
/**
 * Get the current async context strategy.
 * If none has been setup, the default will be used.
 */ function $0d44489bfe738172$export$f639b0c2752203be(carrier) {
    const sentry = (0, $ee9f51b9ad47d1ec$export$c8bfa33e4e8ae492)(carrier);
    if (sentry.acs) return sentry.acs;
    // Otherwise, use the default one (stack)
    return (0, $dcaf9720596c4bb7$export$329d4d4d54e42710)();
}







/**
 * Get the currently active scope.
 */ function $971e6b058109b0a9$export$c7be4b0125a10cba() {
    const carrier = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    const acs = (0, $0d44489bfe738172$export$f639b0c2752203be)(carrier);
    return acs.getCurrentScope();
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context.
 */ function $971e6b058109b0a9$export$68f3af03034c9e90() {
    const carrier = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    const acs = (0, $0d44489bfe738172$export$f639b0c2752203be)(carrier);
    return acs.getIsolationScope();
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $971e6b058109b0a9$export$aa55d5ab8e05984f() {
    return (0, $3d53d2e16cab3c2d$export$7e223ec222791509)('globalScope', ()=>new (0, $fa9a88ae27530aed$export$775b6bb06e53a214)());
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $971e6b058109b0a9$export$ec58d9285c204497(...rest) {
    const carrier = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    const acs = (0, $0d44489bfe738172$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) return acs.withScope(callback);
        return acs.withSetScope(scope, callback);
    }
    return acs.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 */ /**
 * Either creates a new active isolation scope, or sets the given isolation scope as active scope in the given callback.
 */ function $971e6b058109b0a9$export$9a4fed82c350c2bd(...rest) {
    const carrier = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    const acs = (0, $0d44489bfe738172$export$f639b0c2752203be)(carrier);
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [isolationScope, callback] = rest;
        if (!isolationScope) return acs.withIsolationScope(callback);
        return acs.withSetIsolationScope(isolationScope, callback);
    }
    return acs.withIsolationScope(rest[0]);
}
/**
 * Get the currently active client.
 */ function $971e6b058109b0a9$export$6bb76d6eba7e258c() {
    return $971e6b058109b0a9$export$c7be4b0125a10cba().getClient();
}



/**
 * key: bucketKey
 * value: [exportKey, MetricSummary]
 */ let $89d715ec8e052d40$var$SPAN_METRIC_SUMMARY;
function $89d715ec8e052d40$var$getMetricStorageForSpan(span) {
    return $89d715ec8e052d40$var$SPAN_METRIC_SUMMARY ? $89d715ec8e052d40$var$SPAN_METRIC_SUMMARY.get(span) : undefined;
}
/**
 * Fetches the metric summary if it exists for the passed span
 */ function $89d715ec8e052d40$export$2e7205e45c58797d(span) {
    const storage = $89d715ec8e052d40$var$getMetricStorageForSpan(span);
    if (!storage) return undefined;
    const output = {};
    for (const [, [exportKey, summary]] of storage){
        if (!output[exportKey]) output[exportKey] = [];
        output[exportKey].push((0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)(summary));
    }
    return output;
}
/**
 * Updates the metric summary on a span.
 */ function $89d715ec8e052d40$export$102c7b059b14a4a(span, metricType, sanitizedName, value, unit, tags, bucketKey) {
    const storage = $89d715ec8e052d40$var$getMetricStorageForSpan(span) || new Map();
    const exportKey = `${metricType}:${sanitizedName}@${unit}`;
    const bucketItem = storage.get(bucketKey);
    if (bucketItem) {
        const [, summary] = bucketItem;
        storage.set(bucketKey, [
            exportKey,
            {
                min: Math.min(summary.min, value),
                max: Math.max(summary.max, value),
                count: summary.count += 1,
                sum: summary.sum += value,
                tags: summary.tags
            }
        ]);
    } else storage.set(bucketKey, [
        exportKey,
        {
            min: value,
            max: value,
            count: 1,
            sum: value,
            tags: tags
        }
    ]);
    if (!$89d715ec8e052d40$var$SPAN_METRIC_SUMMARY) $89d715ec8e052d40$var$SPAN_METRIC_SUMMARY = new WeakMap();
    $89d715ec8e052d40$var$SPAN_METRIC_SUMMARY.set(span, storage);
}


/**
 * Use this attribute to represent the source of a span.
 * Should be one of: custom, url, route, view, component, task, unknown
 *
 */ const $6dba76bc75a85eae$export$d7a7d984b0791405 = 'sentry.source';
/**
 * Use this attribute to represent the sample rate used for a span.
 */ const $6dba76bc75a85eae$export$ccfe0a40627cc34b = 'sentry.sample_rate';
/**
 * Use this attribute to represent the operation of a span.
 */ const $6dba76bc75a85eae$export$1a413bd9a88fdb09 = 'sentry.op';
/**
 * Use this attribute to represent the origin of a span.
 */ const $6dba76bc75a85eae$export$cca8dd30f57f805e = 'sentry.origin';
/** The reason why an idle span finished. */ const $6dba76bc75a85eae$export$ba73f34502b7a3b3 = 'sentry.idle_span_finish_reason';
/** The unit of a measurement, which may be stored as a TimedEvent. */ const $6dba76bc75a85eae$export$f5f95cff026507b5 = 'sentry.measurement_unit';
/** The value of a measurement, which may be stored as a TimedEvent. */ const $6dba76bc75a85eae$export$69cd5c610c7bb96a = 'sentry.measurement_value';
/**
 * The id of the profile that this span occured in.
 */ const $6dba76bc75a85eae$export$1efec95406bbe327 = 'sentry.profile_id';
const $6dba76bc75a85eae$export$fea48ba9f4550879 = 'sentry.exclusive_time';
const $6dba76bc75a85eae$export$b016f89ac1066ec = 'cache.hit';
const $6dba76bc75a85eae$export$3110e4c3f4386399 = 'cache.key';
const $6dba76bc75a85eae$export$86be76deee227ff2 = 'cache.item_size';


const $f285b1ffba08f8b7$export$136e25984ba4a383 = 0;
const $f285b1ffba08f8b7$export$58f7963109c806fc = 1;
const $f285b1ffba08f8b7$export$f966a0446ece71e = 2;
/**
 * Converts a HTTP status code into a sentry status with a message.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ // https://develop.sentry.dev/sdk/event-payloads/span/
function $f285b1ffba08f8b7$export$5fd4dc48a2131589(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return {
        code: $f285b1ffba08f8b7$export$58f7963109c806fc
    };
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'unauthenticated'
            };
        case 403:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'permission_denied'
            };
        case 404:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'not_found'
            };
        case 409:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'already_exists'
            };
        case 413:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'failed_precondition'
            };
        case 429:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'resource_exhausted'
            };
        case 499:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'cancelled'
            };
        default:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'invalid_argument'
            };
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'unimplemented'
            };
        case 503:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'unavailable'
            };
        case 504:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'deadline_exceeded'
            };
        default:
            return {
                code: $f285b1ffba08f8b7$export$f966a0446ece71e,
                message: 'internal_error'
            };
    }
    return {
        code: $f285b1ffba08f8b7$export$f966a0446ece71e,
        message: 'unknown_error'
    };
}
/**
 * Sets the Http status attributes on the current span based on the http code.
 * Additionally, the span's status is updated, depending on the http code.
 */ function $f285b1ffba08f8b7$export$2ad6630ec8164254(span, httpStatus) {
    span.setAttribute('http.response.status_code', httpStatus);
    const spanStatus = $f285b1ffba08f8b7$export$5fd4dc48a2131589(httpStatus);
    if (spanStatus.message !== 'unknown_error') span.setStatus(spanStatus);
}



// These are aligned with OpenTelemetry trace flags
const $03e63b69c89faacb$export$208d5b368507fb8b = 0x0;
const $03e63b69c89faacb$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 * By default, this will only include trace_id, span_id & parent_span_id.
 * If `includeAllData` is true, it will also include data, op, status & origin.
 */ function $03e63b69c89faacb$export$4c3967a8a2f6bbd6(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, origin: origin } = $03e63b69c89faacb$export$92d8c23565496537(span);
    return (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id,
        data: data,
        op: op,
        status: status,
        origin: origin
    });
}
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in a non-transaction event.
 */ function $03e63b69c89faacb$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { parent_span_id: parent_span_id } = $03e63b69c89faacb$export$92d8c23565496537(span);
    return (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
        parent_span_id: parent_span_id,
        span_id: span_id,
        trace_id: trace_id
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $03e63b69c89faacb$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $03e63b69c89faacb$export$5caecac1caaf3a71(span);
    return (0, $2d400f23bf5d035c$export$f35d907436da45cf)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $03e63b69c89faacb$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $03e63b69c89faacb$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $03e63b69c89faacb$var$ensureTimestampInSeconds(input.getTime());
    return (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $03e63b69c89faacb$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 */ // Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
// This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
// And `spanToJSON` needs the Span class from `span.ts` to check here.
function $03e63b69c89faacb$export$92d8c23565496537(span) {
    if ($03e63b69c89faacb$var$spanIsSentrySpan(span)) return span.getSpanJSON();
    try {
        const { spanId: span_id, traceId: trace_id } = span.spanContext();
        // Handle a span from @opentelemetry/sdk-base-trace's `Span` class
        if ($03e63b69c89faacb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span)) {
            const { attributes: attributes, startTime: startTime, name: name, endTime: endTime, parentSpanId: parentSpanId, status: status } = span;
            return (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
                span_id: span_id,
                trace_id: trace_id,
                data: attributes,
                description: name,
                parent_span_id: parentSpanId,
                start_timestamp: $03e63b69c89faacb$export$3f7581298f56c6d7(startTime),
                // This is [0,0] by default in OTEL, in which case we want to interpret this as no end time
                timestamp: $03e63b69c89faacb$export$3f7581298f56c6d7(endTime) || undefined,
                status: $03e63b69c89faacb$export$e238a77ea3a8cd66(status),
                op: attributes[0, $6dba76bc75a85eae$export$1a413bd9a88fdb09],
                origin: attributes[0, $6dba76bc75a85eae$export$cca8dd30f57f805e],
                _metrics_summary: (0, $89d715ec8e052d40$export$2e7205e45c58797d)(span)
            });
        }
        // Finally, at least we have `spanContext()`....
        return {
            span_id: span_id,
            trace_id: trace_id
        };
    } catch (e) {
        return {};
    }
}
function $03e63b69c89faacb$var$spanIsOpenTelemetrySdkTraceBaseSpan(span) {
    const castSpan = span;
    return !!castSpan.attributes && !!castSpan.startTime && !!castSpan.name && !!castSpan.endTime && !!castSpan.status;
}
/** Exported only for tests. */ /**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $03e63b69c89faacb$var$spanIsSentrySpan(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $03e63b69c89faacb$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    return traceFlags === $03e63b69c89faacb$export$eb571cd9b5d98de8;
}
/** Get the status message to use for a JSON representation of a span. */ function $03e63b69c89faacb$export$e238a77ea3a8cd66(status) {
    if (!status || status.code === (0, $f285b1ffba08f8b7$export$136e25984ba4a383)) return undefined;
    if (status.code === (0, $f285b1ffba08f8b7$export$58f7963109c806fc)) return 'ok';
    return status.message || 'unknown_error';
}
const $03e63b69c89faacb$var$CHILD_SPANS_FIELD = '_sentryChildSpans';
const $03e63b69c89faacb$var$ROOT_SPAN_FIELD = '_sentryRootSpan';
/**
 * Adds an opaque child span reference to a span.
 */ function $03e63b69c89faacb$export$81397d924722cc65(span, childSpan) {
    // We store the root span reference on the child span
    // We need this for `getRootSpan()` to work
    const rootSpan = span[$03e63b69c89faacb$var$ROOT_SPAN_FIELD] || span;
    (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(childSpan, $03e63b69c89faacb$var$ROOT_SPAN_FIELD, rootSpan);
    // We store a list of child spans on the parent span
    // We need this for `getSpanDescendants()` to work
    if (span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD] && span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD].size < 1000) span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD].add(childSpan);
    else (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(span, $03e63b69c89faacb$var$CHILD_SPANS_FIELD, new Set([
        childSpan
    ]));
}
/** This is only used internally by Idle Spans. */ function $03e63b69c89faacb$export$c2a0c9438bb89d91(span, childSpan) {
    if (span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD]) span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD].delete(childSpan);
}
/**
 * Returns an array of the given span and all of its descendants.
 */ function $03e63b69c89faacb$export$340c5c8a13ffc680(span) {
    const resultSet = new Set();
    function addSpanChildren(span) {
        // This exit condition is required to not infinitely loop in case of a circular dependency.
        if (resultSet.has(span)) return;
        else if ($03e63b69c89faacb$export$5caecac1caaf3a71(span)) {
            resultSet.add(span);
            const childSpans = span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD] ? Array.from(span[$03e63b69c89faacb$var$CHILD_SPANS_FIELD]) : [];
            for (const childSpan of childSpans)addSpanChildren(childSpan);
        }
    }
    addSpanChildren(span);
    return Array.from(resultSet);
}
/**
 * Returns the root span of a given span.
 */ function $03e63b69c89faacb$export$c4c6a79b1260ca1b(span) {
    return span[$03e63b69c89faacb$var$ROOT_SPAN_FIELD] || span;
}
/**
 * Returns the currently active span.
 */ function $03e63b69c89faacb$export$1be426a8e585c83e() {
    const carrier = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    const acs = (0, $0d44489bfe738172$export$f639b0c2752203be)(carrier);
    if (acs.getActiveSpan) return acs.getActiveSpan();
    return (0, $155d912cac8f959f$export$91f063ebb8eff307)((0, $971e6b058109b0a9$export$c7be4b0125a10cba)());
}
/**
 * Updates the metric summary on the currently active span
 */ function $03e63b69c89faacb$export$aefd1a302602f922(metricType, sanitizedName, value, unit, tags, bucketKey) {
    const span = $03e63b69c89faacb$export$1be426a8e585c83e();
    if (span) (0, $89d715ec8e052d40$export$102c7b059b14a4a)(span, metricType, sanitizedName, value, unit, tags, bucketKey);
}



/**
 * Adds a measurement to the current active transaction.
 */ function $7d79723997600996$export$7cc31b475d33a706(name, value, unit) {
    const activeSpan = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) rootSpan.addEvent(name, {
        [(0, $6dba76bc75a85eae$export$69cd5c610c7bb96a)]: value,
        [(0, $6dba76bc75a85eae$export$f5f95cff026507b5)]: unit
    });
}
/**
 * Convert timed events to measurements.
 */ function $7d79723997600996$export$487db6fcdf36893e(events) {
    if (!events || events.length === 0) return undefined;
    const measurements = {};
    events.forEach((event)=>{
        const attributes = event.attributes || {};
        const unit = attributes[0, $6dba76bc75a85eae$export$f5f95cff026507b5];
        const value = attributes[0, $6dba76bc75a85eae$export$69cd5c610c7bb96a];
        if (typeof unit === 'string' && typeof value === 'number') measurements[event.name] = {
            value: value,
            unit: unit
        };
    });
    return measurements;
}







/**
 * Wrap a callback function with error handling.
 * If an error is thrown, it will be passed to the `onError` callback and re-thrown.
 *
 * If the return value of the function is a promise, it will be handled with `maybeHandlePromiseRejection`.
 *
 * If an `onFinally` callback is provided, this will be called when the callback has finished
 * - so if it returns a promise, once the promise resolved/rejected,
 * else once the callback has finished executing.
 * The `onFinally` callback will _always_ be called, no matter if an error was thrown or not.
 */ function $ae1f57293d65042b$export$18ce21a8b7efd7e9(fn, onError, // eslint-disable-next-line @typescript-eslint/no-empty-function
onFinally = ()=>{}) {
    let maybePromiseResult;
    try {
        maybePromiseResult = fn();
    } catch (e) {
        onError(e);
        onFinally();
        throw e;
    }
    return $ae1f57293d65042b$var$maybeHandlePromiseRejection(maybePromiseResult, onError, onFinally);
}
/**
 * Maybe handle a promise rejection.
 * This expects to be given a value that _may_ be a promise, or any other value.
 * If it is a promise, and it rejects, it will call the `onError` callback.
 * Other than this, it will generally return the given value as-is.
 */ function $ae1f57293d65042b$var$maybeHandlePromiseRejection(value, onError, onFinally) {
    if ((0, $626eb84a64d84c41$export$f5b060c2914b97c8)(value)) // @ts-expect-error - the isThenable check returns the "wrong" type here
    return value.then((res)=>{
        onFinally();
        return res;
    }, (e)=>{
        onError(e);
        onFinally();
        throw e;
    });
    onFinally();
    return value;
}



// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $f6a9d6f8ff505d4a$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const options = maybeOptions || $f6a9d6f8ff505d4a$var$getClientOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}
function $f6a9d6f8ff505d4a$var$getClientOptions() {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    return client && client.getOptions();
}





const $350ccf6f22fb6637$export$849dbeeeda01ae98 = 'production';





/**
 * If you change this value, also update the terser plugin config to
 * avoid minification of the object property!
 */ const $2ef70689737a8a61$var$FROZEN_DSC_FIELD = '_frozenDsc';
/**
 * Freeze the given DSC on the given span.
 */ function $2ef70689737a8a61$export$7398c93e763ca9fd(span, dsc) {
    const spanWithMaybeDsc = span;
    (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(spanWithMaybeDsc, $2ef70689737a8a61$var$FROZEN_DSC_FIELD, dsc);
}
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $2ef70689737a8a61$export$366bad00d6815eed(trace_id, client) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    const dsc = (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
        environment: options.environment || (0, $350ccf6f22fb6637$export$849dbeeeda01ae98),
        release: options.release,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $2ef70689737a8a61$export$a117f995597e25df(span) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (!client) return {};
    const dsc = $2ef70689737a8a61$export$366bad00d6815eed((0, $03e63b69c89faacb$export$92d8c23565496537)(span).trace_id || '', client);
    const rootSpan = (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(span);
    if (!rootSpan) return dsc;
    const frozenDsc = rootSpan[$2ef70689737a8a61$var$FROZEN_DSC_FIELD];
    if (frozenDsc) return frozenDsc;
    const jsonSpan = (0, $03e63b69c89faacb$export$92d8c23565496537)(rootSpan);
    const attributes = jsonSpan.data || {};
    const maybeSampleRate = attributes[0, $6dba76bc75a85eae$export$ccfe0a40627cc34b];
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const source = attributes[0, $6dba76bc75a85eae$export$d7a7d984b0791405];
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $03e63b69c89faacb$export$5caecac1caaf3a71)(rootSpan));
    client.emit('createDsc', dsc);
    return dsc;
}
/**
 * Convert a Span to a baggage header.
 */ function $2ef70689737a8a61$export$95cf936fdacaff7b(span) {
    const dsc = $2ef70689737a8a61$export$a117f995597e25df(span);
    return (0, $e464efef87fcab6d$export$56766feef403f365)(dsc);
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $506311a3b441d72b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;



/**
 * Print a log message for a started span.
 */ function $14647b340ab79e08$export$2f3d84e767c9592b(span) {
    if (!(0, $506311a3b441d72b$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >', parent_span_id: parentSpanId } = (0, $03e63b69c89faacb$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const sampled = (0, $03e63b69c89faacb$export$5caecac1caaf3a71)(span);
    const rootSpan = (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const header = `[Tracing] Starting ${sampled ? 'sampled' : 'unsampled'} ${isRootSpan ? 'root ' : ''}span`;
    const infoParts = [
        `op: ${op}`,
        `name: ${description}`,
        `ID: ${spanId}`
    ];
    if (parentSpanId) infoParts.push(`parent ID: ${parentSpanId}`);
    if (!isRootSpan) {
        const { op: op, description: description } = (0, $03e63b69c89faacb$export$92d8c23565496537)(rootSpan);
        infoParts.push(`root ID: ${rootSpan.spanContext().spanId}`);
        if (op) infoParts.push(`root op: ${op}`);
        if (description) infoParts.push(`root description: ${description}`);
    }
    (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`${header}
  ${infoParts.join('\n  ')}`);
}
/**
 * Print a log message for an ended span.
 */ function $14647b340ab79e08$export$b77c830667a4d630(span) {
    if (!(0, $506311a3b441d72b$export$16a28057038b10ef)) return;
    const { description: description = '< unknown name >', op: op = '< unknown op >' } = (0, $03e63b69c89faacb$export$92d8c23565496537)(span);
    const { spanId: spanId } = span.spanContext();
    const rootSpan = (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(span);
    const isRootSpan = rootSpan === span;
    const msg = `[Tracing] Finishing "${op}" ${isRootSpan ? 'root ' : ''}span "${description}" with ID ${spanId}`;
    (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(msg);
}







/**
 * Parse a sample rate from a given value.
 * This will either return a boolean or number sample rate, if the sample rate is valid (between 0 and 1).
 * If a string is passed, we try to convert it to a number.
 *
 * Any invalid sample rate will return `undefined`.
 */ function $0bb8cfda553273b7$export$a5bd2d81656d9546(sampleRate) {
    if (typeof sampleRate === 'boolean') return Number(sampleRate);
    const rate = typeof sampleRate === 'string' ? parseFloat(sampleRate) : sampleRate;
    if (typeof rate !== 'number' || isNaN(rate) || rate < 0 || rate > 1) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(sampleRate)} of type ${JSON.stringify(typeof sampleRate)}.`);
        return undefined;
    }
    return rate;
}


/**
 * Makes a sampling decision for the given options.
 *
 * Called every time a root span is created. Only root spans which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 */ function $531e420a481f39e5$export$5f833db634b217bb(options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)(options)) return [
        false
    ];
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') sampleRate = options.tracesSampler(samplingContext);
    else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') sampleRate = options.tracesSampleRate;
    else // When `enableTracing === true`, we use a sample rate of 100%
    sampleRate = 1;
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get.
    // (The only valid values are booleans or numbers between 0 and 1.)
    const parsedSampleRate = (0, $0bb8cfda553273b7$export$a5bd2d81656d9546)(sampleRate);
    if (parsedSampleRate === undefined) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        return [
            false
        ];
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!parsedSampleRate) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        return [
            false,
            parsedSampleRate
        ];
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    const shouldSample = Math.random() < parsedSampleRate;
    // if we're not going to keep it, we're done
    if (!shouldSample) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return [
            false,
            parsedSampleRate
        ];
    }
    return [
        true,
        parsedSampleRate
    ];
}




/**
 * A Sentry Span that is non-recording, meaning it will not be sent to Sentry.
 */ class $f2c4b4b1de41c7b2$export$d6636b700b76c516 {
    constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16);
    }
    /** @inheritdoc */ spanContext() {
        return {
            spanId: this._spanId,
            traceId: this._traceId,
            traceFlags: (0, $03e63b69c89faacb$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ // eslint-disable-next-line @typescript-eslint/no-empty-function
    end(_timestamp) {}
    /** @inheritdoc */ setAttribute(_key, _value) {
        return this;
    }
    /** @inheritdoc */ setAttributes(_values) {
        return this;
    }
    /** @inheritdoc */ setStatus(_status) {
        return this;
    }
    /** @inheritdoc */ updateName(_name) {
        return this;
    }
    /** @inheritdoc */ isRecording() {
        return false;
    }
    /** @inheritdoc */ addEvent(_name, _attributesOrStartTime, _startTime) {
        return this;
    }
}







/** Regular expression used to parse a Dsn. */ const $465df9040833ef74$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $465df9040833ef74$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $465df9040833ef74$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $465df9040833ef74$export$b892860177f70a30(str) {
    const match = $465df9040833ef74$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $117c8f31aa65bddd$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $465df9040833ef74$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $465df9040833ef74$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $465df9040833ef74$var$validateDsn(dsn) {
    if (!(0, $1d4627fd04ff26b2$export$16a28057038b10ef)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$465df9040833ef74$var$isValidProtocol(protocol)) {
        (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $465df9040833ef74$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $465df9040833ef74$export$b892860177f70a30(from) : $465df9040833ef74$var$dsnFromComponents(from);
    if (!components || !$465df9040833ef74$var$validateDsn(components)) return undefined;
    return components;
}



/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $4a3ed4eafd8f719a$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}




/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8bc2e4fa750aec36$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $8bc2e4fa750aec36$var$visit('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $8bc2e4fa750aec36$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $8bc2e4fa750aec36$export$a3295358bff77e(object, depth);
    if ($8bc2e4fa750aec36$var$jsonSize(normalized) > maxSize) return $8bc2e4fa750aec36$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $8bc2e4fa750aec36$var$visit(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $4a3ed4eafd8f719a$export$8115b0b78e956ab3)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !Number.isNaN(value)) return value;
    const stringified = $8bc2e4fa750aec36$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $8bc2e4fa750aec36$var$visit('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $68dbcfd11e00a6d4$export$62ff257738bf57f5)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $8bc2e4fa750aec36$var$visit(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $8bc2e4fa750aec36$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $626eb84a64d84c41$export$7916fad0ebc23f48)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $626eb84a64d84c41$export$bc2894c7158efbac)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $81b681a083912fb6$export$aad197c7121a6651)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $8bc2e4fa750aec36$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $8bc2e4fa750aec36$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $8bc2e4fa750aec36$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8bc2e4fa750aec36$var$jsonSize(value) {
    return $8bc2e4fa750aec36$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $8bc2e4fa750aec36$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $70b99f77072cf559$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $70b99f77072cf559$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $70b99f77072cf559$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $70b99f77072cf559$export$604a45d95a155e2b(envelope, types) {
    return $70b99f77072cf559$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8 array.
 */ function $70b99f77072cf559$var$encodeUTF8(input) {
    return (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill ? (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).__SENTRY__.encodePolyfill(input) : new TextEncoder().encode(input);
}
/**
 * Decode a UTF8 array to string.
 */ function $70b99f77072cf559$var$decodeUTF8(input) {
    return (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).__SENTRY__ && (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill ? (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).__SENTRY__.decodePolyfill(input) : new TextDecoder().decode(input);
}
/**
 * Serializes an envelope.
 */ function $70b99f77072cf559$export$32f9b428425aac85(envelope) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $70b99f77072cf559$var$encodeUTF8(parts),
            next
        ];
        else parts.push(typeof next === 'string' ? $70b99f77072cf559$var$encodeUTF8(next) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $8bc2e4fa750aec36$export$a3295358bff77e)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $70b99f77072cf559$var$concatBuffers(parts);
}
function $70b99f77072cf559$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $70b99f77072cf559$export$3338d0c7b6e17a2b(env) {
    let buffer = typeof env === 'string' ? $70b99f77072cf559$var$encodeUTF8(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse($70b99f77072cf559$var$decodeUTF8(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates envelope item for a single span
 */ function $70b99f77072cf559$export$655cf139bc8b8afd(spanJson) {
    const spanHeaders = {
        type: 'span'
    };
    return [
        spanHeaders,
        spanJson
    ];
}
/**
 * Creates attachment envelope items
 */ function $70b99f77072cf559$export$d8fc80952cc31fa4(attachment) {
    const buffer = typeof attachment.data === 'string' ? $70b99f77072cf559$var$encodeUTF8(attachment.data) : attachment.data;
    return [
        (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $70b99f77072cf559$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $70b99f77072cf559$export$b11169581eeaf237(type) {
    return $70b99f77072cf559$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $70b99f77072cf559$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $70b99f77072cf559$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $465df9040833ef74$export$44d472fbb931a776)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
                ...dynamicSamplingContext
            })
        }
    };
}




/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $1e089ca26d9e0910$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $1e089ca26d9e0910$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $70b99f77072cf559$export$d369f3b2758f6743)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $465df9040833ef74$export$44d472fbb931a776)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $70b99f77072cf559$export$f93f7f385160c44e)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $1e089ca26d9e0910$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $70b99f77072cf559$export$d369f3b2758f6743)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $1e089ca26d9e0910$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $70b99f77072cf559$export$92b6093782fe661b)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $70b99f77072cf559$export$f93f7f385160c44e)(envelopeHeaders, [
        eventItem
    ]);
}
/**
 * Create envelope from Span item.
 *
 * Takes an optional client and runs spans through `beforeSendSpan` if available.
 */ function $1e089ca26d9e0910$export$19a0081d4b39d77(spans, client) {
    function dscHasRequiredProps(dsc) {
        return !!dsc.trace_id && !!dsc.public_key;
    }
    // For the moment we'll obtain the DSC from the first span in the array
    // This might need to be changed if we permit sending multiple spans from
    // different segments in one envelope
    const dsc = (0, $2ef70689737a8a61$export$a117f995597e25df)(spans[0]);
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    const headers = {
        sent_at: new Date().toISOString(),
        ...dscHasRequiredProps(dsc) && {
            trace: dsc
        },
        ...!!tunnel && dsn && {
            dsn: (0, $465df9040833ef74$export$44d472fbb931a776)(dsn)
        }
    };
    const beforeSendSpan = client && client.getOptions().beforeSendSpan;
    const convertToSpanJSON = beforeSendSpan ? (span)=>beforeSendSpan((0, $03e63b69c89faacb$export$92d8c23565496537)(span)) : (span)=>(0, $03e63b69c89faacb$export$92d8c23565496537)(span);
    const items = [];
    for (const span of spans){
        const spanJson = convertToSpanJSON(span);
        if (spanJson) items.push((0, $70b99f77072cf559$export$655cf139bc8b8afd)(spanJson));
    }
    return (0, $70b99f77072cf559$export$f93f7f385160c44e)(headers, items);
}









const $acb880fa3a122151$var$SCOPE_ON_START_SPAN_FIELD = '_sentryScope';
const $acb880fa3a122151$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD = '_sentryIsolationScope';
/** Store the scope & isolation scope for a span, which can the be used when it is finished. */ function $acb880fa3a122151$export$cddb4027e3b0dd66(span, scope, isolationScope) {
    if (span) {
        (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(span, $acb880fa3a122151$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD, isolationScope);
        (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(span, $acb880fa3a122151$var$SCOPE_ON_START_SPAN_FIELD, scope);
    }
}
/**
 * Grabs the scope and isolation scope off a span that were active when the span was started.
 */ function $acb880fa3a122151$export$c08fbc656a245d03(span) {
    return {
        scope: span[$acb880fa3a122151$var$SCOPE_ON_START_SPAN_FIELD],
        isolationScope: span[$acb880fa3a122151$var$ISOLATION_SCOPE_ON_START_SPAN_FIELD]
    };
}


/**
 * Span contains all data about a span
 */ class $18fb4106cd325d32$export$a92149b045260d9f {
    /** Epoch timestamp in seconds when the span started. */ /** Epoch timestamp in seconds when the span ended. */ /** Internal keeper of the status */ /** The timed events added to this span. */ /** if true, treat span as a standalone span (not part of a transaction) */ /**
   * You should never call the constructor manually, always use `Sentry.startSpan()`
   * or other span methods.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext = {}){
        this._traceId = spanContext.traceId || (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        this._spanId = spanContext.spanId || (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16);
        this._startTime = spanContext.startTimestamp || (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
        this._attributes = {};
        this.setAttributes({
            [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'manual',
            [(0, $6dba76bc75a85eae$export$1a413bd9a88fdb09)]: spanContext.op,
            ...spanContext.attributes
        });
        this._name = spanContext.name;
        if (spanContext.parentSpanId) this._parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this._sampled = spanContext.sampled;
        if (spanContext.endTimestamp) this._endTime = spanContext.endTimestamp;
        this._events = [];
        this._isStandaloneSpan = spanContext.isStandalone;
        // If the span is already ended, ensure we finalize the span immediately
        if (this._endTime) this._onSpanEnded();
    }
    /** @inheritdoc */ spanContext() {
        const { _spanId: spanId, _traceId: traceId, _sampled: sampled } = this;
        return {
            spanId: spanId,
            traceId: traceId,
            traceFlags: sampled ? (0, $03e63b69c89faacb$export$eb571cd9b5d98de8) : (0, $03e63b69c89faacb$export$208d5b368507fb8b)
        };
    }
    /** @inheritdoc */ setAttribute(key, value) {
        if (value === undefined) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._attributes[key];
        else this._attributes[key] = value;
    }
    /** @inheritdoc */ setAttributes(attributes) {
        Object.keys(attributes).forEach((key)=>this.setAttribute(key, attributes[key]));
    }
    /**
   * This should generally not be used,
   * but we need it for browser tracing where we want to adjust the start time afterwards.
   * USE THIS WITH CAUTION!
   *
   * @hidden
   * @internal
   */ updateStartTime(timeInput) {
        this._startTime = (0, $03e63b69c89faacb$export$3f7581298f56c6d7)(timeInput);
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this._status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ updateName(name) {
        this._name = name;
        return this;
    }
    /** @inheritdoc */ end(endTimestamp) {
        // If already ended, skip
        if (this._endTime) return;
        this._endTime = (0, $03e63b69c89faacb$export$3f7581298f56c6d7)(endTimestamp);
        (0, $14647b340ab79e08$export$b77c830667a4d630)(this);
        this._onSpanEnded();
    }
    /**
   * Get JSON representation of this span.
   *
   * @hidden
   * @internal This method is purely for internal purposes and should not be used outside
   * of SDK code. If you need to get a JSON representation of a span,
   * use `spanToJSON(span)` instead.
   */ getSpanJSON() {
        return (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
            data: this._attributes,
            description: this._name,
            op: this._attributes[0, $6dba76bc75a85eae$export$1a413bd9a88fdb09],
            parent_span_id: this._parentSpanId,
            span_id: this._spanId,
            start_timestamp: this._startTime,
            status: (0, $03e63b69c89faacb$export$e238a77ea3a8cd66)(this._status),
            timestamp: this._endTime,
            trace_id: this._traceId,
            origin: this._attributes[0, $6dba76bc75a85eae$export$cca8dd30f57f805e],
            _metrics_summary: (0, $89d715ec8e052d40$export$2e7205e45c58797d)(this),
            profile_id: this._attributes[0, $6dba76bc75a85eae$export$1efec95406bbe327],
            exclusive_time: this._attributes[0, $6dba76bc75a85eae$export$fea48ba9f4550879],
            measurements: (0, $7d79723997600996$export$487db6fcdf36893e)(this._events),
            is_segment: this._isStandaloneSpan && (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(this) === this || undefined,
            segment_id: this._isStandaloneSpan ? (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(this).spanContext().spanId : undefined
        });
    }
    /** @inheritdoc */ isRecording() {
        return !this._endTime && !!this._sampled;
    }
    /**
   * @inheritdoc
   */ addEvent(name, attributesOrStartTime, startTime) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Adding an event to span:', name);
        const time = $18fb4106cd325d32$var$isSpanTimeInput(attributesOrStartTime) ? attributesOrStartTime : startTime || (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
        const attributes = $18fb4106cd325d32$var$isSpanTimeInput(attributesOrStartTime) ? {} : attributesOrStartTime || {};
        const event = {
            name: name,
            time: (0, $03e63b69c89faacb$export$3f7581298f56c6d7)(time),
            attributes: attributes
        };
        this._events.push(event);
        return this;
    }
    /**
   * This method should generally not be used,
   * but for now we need a way to publicly check if the `_isStandaloneSpan` flag is set.
   * USE THIS WITH CAUTION!
   * @internal
   * @hidden
   * @experimental
   */ isStandaloneSpan() {
        return !!this._isStandaloneSpan;
    }
    /** Emit `spanEnd` when the span is ended. */ _onSpanEnded() {
        const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
        if (client) client.emit('spanEnd', this);
        // A segment span is basically the root span of a local span tree.
        // So for now, this is either what we previously refer to as the root span,
        // or a standalone span.
        const isSegmentSpan = this._isStandaloneSpan || this === (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(this);
        if (!isSegmentSpan) return;
        // if this is a standalone span, we send it immediately
        if (this._isStandaloneSpan) {
            $18fb4106cd325d32$var$sendSpanEnvelope((0, $1e089ca26d9e0910$export$19a0081d4b39d77)([
                this
            ], client));
            return;
        }
        const transactionEvent = this._convertSpanToTransaction();
        if (transactionEvent) {
            const scope = (0, $acb880fa3a122151$export$c08fbc656a245d03)(this).scope || (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
            scope.captureEvent(transactionEvent);
        }
    }
    /**
   * Finish the transaction & prepare the event to send to Sentry.
   */ _convertSpanToTransaction() {
        // We can only convert finished spans
        if (!$18fb4106cd325d32$var$isFullFinishedSpan((0, $03e63b69c89faacb$export$92d8c23565496537)(this))) return undefined;
        if (!this._name) {
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this._name = '<unlabeled transaction>';
        }
        const { scope: capturedSpanScope, isolationScope: capturedSpanIsolationScope } = (0, $acb880fa3a122151$export$c08fbc656a245d03)(this);
        const scope = capturedSpanScope || (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
        const client = scope.getClient() || (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
        if (this._sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        // The transaction span itself as well as any potential standalone spans should be filtered out
        const finishedSpans = (0, $03e63b69c89faacb$export$340c5c8a13ffc680)(this).filter((span)=>span !== this && !$18fb4106cd325d32$var$isStandaloneSpan(span));
        const spans = finishedSpans.map((span)=>(0, $03e63b69c89faacb$export$92d8c23565496537)(span)).filter($18fb4106cd325d32$var$isFullFinishedSpan);
        const source = this._attributes[0, $6dba76bc75a85eae$export$d7a7d984b0791405];
        const transaction = {
            contexts: {
                trace: (0, $03e63b69c89faacb$export$4c3967a8a2f6bbd6)(this)
            },
            spans: spans,
            start_timestamp: this._startTime,
            timestamp: this._endTime,
            transaction: this._name,
            type: 'transaction',
            sdkProcessingMetadata: {
                capturedSpanScope: capturedSpanScope,
                capturedSpanIsolationScope: capturedSpanIsolationScope,
                ...(0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
                    dynamicSamplingContext: (0, $2ef70689737a8a61$export$a117f995597e25df)(this)
                })
            },
            _metrics_summary: (0, $89d715ec8e052d40$export$2e7205e45c58797d)(this),
            ...source && {
                transaction_info: {
                    source: source
                }
            }
        };
        const measurements = (0, $7d79723997600996$export$487db6fcdf36893e)(this._events);
        const hasMeasurements = measurements && Object.keys(measurements).length;
        if (hasMeasurements) {
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding measurements to transaction', JSON.stringify(measurements, undefined, 2));
            transaction.measurements = measurements;
        }
        return transaction;
    }
}
function $18fb4106cd325d32$var$isSpanTimeInput(value) {
    return value && typeof value === 'number' || value instanceof Date || Array.isArray(value);
}
// We want to filter out any incomplete SpanJSON objects
function $18fb4106cd325d32$var$isFullFinishedSpan(input) {
    return !!input.start_timestamp && !!input.timestamp && !!input.span_id && !!input.trace_id;
}
/** `SentrySpan`s can be sent as a standalone span rather than belonging to a transaction */ function $18fb4106cd325d32$var$isStandaloneSpan(span) {
    return span instanceof $18fb4106cd325d32$export$a92149b045260d9f && span.isStandaloneSpan();
}
/**
 * Sends a `SpanEnvelope`.
 *
 * Note: If the envelope's spans are dropped, e.g. via `beforeSendSpan`,
 * the envelope will not be sent either.
 */ function $18fb4106cd325d32$var$sendSpanEnvelope(envelope) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (!client) return;
    const spanItems = envelope[1];
    if (!spanItems || spanItems.length === 0) {
        client.recordDroppedEvent('before_send', 'span');
        return;
    }
    const transport = client.getTransport();
    if (transport) transport.send(envelope).then(null, (reason)=>{
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('Error while sending span:', reason);
    });
}




const $5b8e5c42bcba91ae$var$SUPPRESS_TRACING_KEY = '__SENTRY_SUPPRESS_TRACING__';
/**
 * Wraps a function with a transaction/span and finishes the span after the function is done.
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * If you want to create a span that is not set as active, use {@link startInactiveSpan}.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $5b8e5c42bcba91ae$export$a1bd95187356f372(context, callback) {
    const acs = $5b8e5c42bcba91ae$var$getAcs();
    if (acs.startSpan) return acs.startSpan(context, callback);
    const spanContext = $5b8e5c42bcba91ae$var$normalizeContext(context);
    return (0, $971e6b058109b0a9$export$ec58d9285c204497)(context.scope, (scope)=>{
        const parentSpan = $5b8e5c42bcba91ae$var$getParentSpan(scope);
        const shouldSkipSpan = context.onlyIfParent && !parentSpan;
        const activeSpan = shouldSkipSpan ? new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)() : $5b8e5c42bcba91ae$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanContext: spanContext,
            forceTransaction: context.forceTransaction,
            scope: scope
        });
        (0, $155d912cac8f959f$export$3f25fa50c18e20ca)(scope, activeSpan);
        return (0, $ae1f57293d65042b$export$18ce21a8b7efd7e9)(()=>callback(activeSpan), ()=>{
            // Only update the span status if it hasn't been changed yet, and the span is not yet finished
            const { status: status } = (0, $03e63b69c89faacb$export$92d8c23565496537)(activeSpan);
            if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
                message: 'internal_error'
            });
        }, ()=>activeSpan.end());
    });
}
/**
 * Similar to `Sentry.startSpan`. Wraps a function with a transaction/span, but does not finish the span
 * after the function is done automatically. You'll have to call `span.end()` manually.
 *
 * The created span is the active span and will be used as parent by other spans created inside the function
 * and can be accessed via `Sentry.getActiveSpan()`, as long as the function is executed while the scope is active.
 *
 * You'll always get a span passed to the callback,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $5b8e5c42bcba91ae$export$c10292ad04b92aea(context, callback) {
    const acs = $5b8e5c42bcba91ae$var$getAcs();
    if (acs.startSpanManual) return acs.startSpanManual(context, callback);
    const spanContext = $5b8e5c42bcba91ae$var$normalizeContext(context);
    return (0, $971e6b058109b0a9$export$ec58d9285c204497)(context.scope, (scope)=>{
        const parentSpan = $5b8e5c42bcba91ae$var$getParentSpan(scope);
        const shouldSkipSpan = context.onlyIfParent && !parentSpan;
        const activeSpan = shouldSkipSpan ? new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)() : $5b8e5c42bcba91ae$var$createChildOrRootSpan({
            parentSpan: parentSpan,
            spanContext: spanContext,
            forceTransaction: context.forceTransaction,
            scope: scope
        });
        (0, $155d912cac8f959f$export$3f25fa50c18e20ca)(scope, activeSpan);
        function finishAndSetSpan() {
            activeSpan.end();
        }
        return (0, $ae1f57293d65042b$export$18ce21a8b7efd7e9)(()=>callback(activeSpan, finishAndSetSpan), ()=>{
            // Only update the span status if it hasn't been changed yet, and the span is not yet finished
            const { status: status } = (0, $03e63b69c89faacb$export$92d8c23565496537)(activeSpan);
            if (activeSpan.isRecording() && (!status || status === 'ok')) activeSpan.setStatus({
                code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
                message: 'internal_error'
            });
        });
    });
}
/**
 * Creates a span. This span is not set as active, so will not get automatic instrumentation spans
 * as children or be able to be accessed via `Sentry.getActiveSpan()`.
 *
 * If you want to create a span that is set as active, use {@link startSpan}.
 *
 * This function will always return a span,
 * it may just be a non-recording span if the span is not sampled or if tracing is disabled.
 */ function $5b8e5c42bcba91ae$export$63dbba021a6b4047(context) {
    const acs = $5b8e5c42bcba91ae$var$getAcs();
    if (acs.startInactiveSpan) return acs.startInactiveSpan(context);
    const spanContext = $5b8e5c42bcba91ae$var$normalizeContext(context);
    const scope = context.scope || (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const parentSpan = $5b8e5c42bcba91ae$var$getParentSpan(scope);
    const shouldSkipSpan = context.onlyIfParent && !parentSpan;
    if (shouldSkipSpan) return new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)();
    return $5b8e5c42bcba91ae$var$createChildOrRootSpan({
        parentSpan: parentSpan,
        spanContext: spanContext,
        forceTransaction: context.forceTransaction,
        scope: scope
    });
}
/**
 * Continue a trace from `sentry-trace` and `baggage` values.
 * These values can be obtained from incoming request headers, or in the browser from `<meta name="sentry-trace">`
 * and `<meta name="baggage">` HTML tags.
 *
 * Spans started with `startSpan`, `startSpanManual` and `startInactiveSpan`, within the callback will automatically
 * be attached to the incoming trace.
 */ const $5b8e5c42bcba91ae$export$d2ee9b39b25437b3 = ({ sentryTrace: sentryTrace, baggage: baggage }, callback)=>{
    return (0, $971e6b058109b0a9$export$ec58d9285c204497)((scope)=>{
        const propagationContext = (0, $2d400f23bf5d035c$export$261f383d16a93e39)(sentryTrace, baggage);
        scope.setPropagationContext(propagationContext);
        return callback();
    });
};
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback. Can be
 * passed `null` to start an entirely new span tree.
 *
 * @param span Spans started in the context of the provided callback will be children of this span. If `null` is passed,
 * spans started within the callback will not be attached to a parent span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $5b8e5c42bcba91ae$export$e57ac09b143d92a2(span, callback) {
    const acs = $5b8e5c42bcba91ae$var$getAcs();
    if (acs.withActiveSpan) return acs.withActiveSpan(span, callback);
    return (0, $971e6b058109b0a9$export$ec58d9285c204497)((scope)=>{
        (0, $155d912cac8f959f$export$3f25fa50c18e20ca)(scope, span || undefined);
        return callback(scope);
    });
}
/** Suppress tracing in the given callback, ensuring no spans are generated inside of it. */ function $5b8e5c42bcba91ae$export$869298f9835abc68(callback) {
    const acs = $5b8e5c42bcba91ae$var$getAcs();
    if (acs.suppressTracing) return acs.suppressTracing(callback);
    return (0, $971e6b058109b0a9$export$ec58d9285c204497)((scope)=>{
        scope.setSDKProcessingMetadata({
            [$5b8e5c42bcba91ae$var$SUPPRESS_TRACING_KEY]: true
        });
        return callback();
    });
}
function $5b8e5c42bcba91ae$var$createChildOrRootSpan({ parentSpan: parentSpan, spanContext: spanContext, forceTransaction: forceTransaction, scope: scope }) {
    if (!(0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)()) return new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)();
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    let span;
    if (parentSpan && !forceTransaction) {
        span = $5b8e5c42bcba91ae$var$_startChildSpan(parentSpan, scope, spanContext);
        (0, $03e63b69c89faacb$export$81397d924722cc65)(parentSpan, span);
    } else if (parentSpan) {
        // If we forced a transaction but have a parent span, make sure to continue from the parent span, not the scope
        const dsc = (0, $2ef70689737a8a61$export$a117f995597e25df)(parentSpan);
        const { traceId: traceId, spanId: parentSpanId } = parentSpan.spanContext();
        const parentSampled = (0, $03e63b69c89faacb$export$5caecac1caaf3a71)(parentSpan);
        span = $5b8e5c42bcba91ae$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanContext
        }, scope, parentSampled);
        (0, $2ef70689737a8a61$export$7398c93e763ca9fd)(span, dsc);
    } else {
        const { traceId: traceId, dsc: dsc, parentSpanId: parentSpanId, sampled: parentSampled } = {
            ...isolationScope.getPropagationContext(),
            ...scope.getPropagationContext()
        };
        span = $5b8e5c42bcba91ae$var$_startRootSpan({
            traceId: traceId,
            parentSpanId: parentSpanId,
            ...spanContext
        }, scope, parentSampled);
        if (dsc) (0, $2ef70689737a8a61$export$7398c93e763ca9fd)(span, dsc);
    }
    (0, $14647b340ab79e08$export$2f3d84e767c9592b)(span);
    (0, $acb880fa3a122151$export$cddb4027e3b0dd66)(span, scope, isolationScope);
    return span;
}
/**
 * This converts StartSpanOptions to SentrySpanArguments.
 * For the most part (for now) we accept the same options,
 * but some of them need to be transformed.
 *
 * Eventually the StartSpanOptions will be more aligned with OpenTelemetry.
 */ function $5b8e5c42bcba91ae$var$normalizeContext(context) {
    const exp = context.experimental || {};
    const initialCtx = {
        isStandalone: exp.standalone,
        ...context
    };
    if (context.startTime) {
        const ctx = {
            ...initialCtx
        };
        ctx.startTimestamp = (0, $03e63b69c89faacb$export$3f7581298f56c6d7)(context.startTime);
        delete ctx.startTime;
        return ctx;
    }
    return initialCtx;
}
function $5b8e5c42bcba91ae$var$getAcs() {
    const carrier = (0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)();
    return (0, $0d44489bfe738172$export$f639b0c2752203be)(carrier);
}
function $5b8e5c42bcba91ae$var$_startRootSpan(spanArguments, scope, parentSampled) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {};
    const { name: name = '', attributes: attributes } = spanArguments;
    const [sampled, sampleRate] = scope.getScopeData().sdkProcessingMetadata[$5b8e5c42bcba91ae$var$SUPPRESS_TRACING_KEY] ? [
        false
    ] : (0, $531e420a481f39e5$export$5f833db634b217bb)(options, {
        name: name,
        parentSampled: parentSampled,
        attributes: attributes,
        transactionContext: {
            name: name,
            parentSampled: parentSampled
        }
    });
    const rootSpan = new (0, $18fb4106cd325d32$export$a92149b045260d9f)({
        ...spanArguments,
        attributes: {
            [(0, $6dba76bc75a85eae$export$d7a7d984b0791405)]: 'custom',
            ...spanArguments.attributes
        },
        sampled: sampled
    });
    if (sampleRate !== undefined) rootSpan.setAttribute((0, $6dba76bc75a85eae$export$ccfe0a40627cc34b), sampleRate);
    if (client) client.emit('spanStart', rootSpan);
    return rootSpan;
}
/**
 * Creates a new `Span` while setting the current `Span.id` as `parentSpanId`.
 * This inherits the sampling decision from the parent span.
 */ function $5b8e5c42bcba91ae$var$_startChildSpan(parentSpan, scope, spanArguments) {
    const { spanId: spanId, traceId: traceId } = parentSpan.spanContext();
    const sampled = scope.getScopeData().sdkProcessingMetadata[$5b8e5c42bcba91ae$var$SUPPRESS_TRACING_KEY] ? false : (0, $03e63b69c89faacb$export$5caecac1caaf3a71)(parentSpan);
    const childSpan = sampled ? new (0, $18fb4106cd325d32$export$a92149b045260d9f)({
        ...spanArguments,
        parentSpanId: spanId,
        traceId: traceId,
        sampled: sampled
    }) : new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)({
        traceId: traceId
    });
    (0, $03e63b69c89faacb$export$81397d924722cc65)(parentSpan, childSpan);
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (client) {
        client.emit('spanStart', childSpan);
        // If it has an endTimestamp, it's already ended
        if (spanArguments.endTimestamp) client.emit('spanEnd', childSpan);
    }
    return childSpan;
}
function $5b8e5c42bcba91ae$var$getParentSpan(scope) {
    const span = (0, $155d912cac8f959f$export$91f063ebb8eff307)(scope);
    if (!span) return undefined;
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const options = client ? client.getOptions() : {};
    if (options.parentSpanIsAlwaysRootSpan) return (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(span);
    return span;
}


/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $cdc4578f23641df3$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $cdc4578f23641df3$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $cdc4578f23641df3$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span name
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $cdc4578f23641df3$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}


/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ca7f643c89d76419$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;





const $59bb5452c9e08c91$var$getRating = (value, thresholds)=>{
    if (value > thresholds[1]) return 'poor';
    if (value > thresholds[0]) return 'needs-improvement';
    return 'good';
};
const $59bb5452c9e08c91$export$17679dccdd551979 = (callback, metric, thresholds, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    metric.rating = $59bb5452c9e08c91$var$getRating(metric.value, thresholds);
                    callback(metric);
                }
            }
        }
    };
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $11de7ca04609cdd9$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $344f84f1ce7414d4$export$6431553786c94949 = ()=>{
    return (0, $2e0ad70334800584$export$56d8a8a25bd48b81).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $f4f1882e07ed378c$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $344f84f1ce7414d4$export$6431553786c94949)();
    return navEntry && navEntry.activationStart || 0;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $1f7715287b915188$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $344f84f1ce7414d4$export$6431553786c94949)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.prerendering || (0, $f4f1882e07ed378c$export$d3e828b3c7b5b845)() > 0) navigationType = 'prerender';
        else if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.wasDiscarded) navigationType = 'restore';
        else if (navEntry.type) navigationType = navEntry.type.replace(/_/g, '-');
    }
    // Use `entries` type specific for the metric.
    const entries = [];
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: entries,
        id: (0, $11de7ca04609cdd9$export$407ea409d1f3b539)(),
        navigationType: navigationType
    };
};


/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $bc25e09948af204b$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                // Delay by a microtask to workaround a bug in Safari where the
                // callback is invoked immediately, rather than in a separate task.
                // See: https://github.com/GoogleChrome/web-vitals/issues/277
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                Promise.resolve().then(()=>{
                    callback(list.getEntries());
                });
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $4b8cb11954cbab40$export$91ec2be6fdd8f1b4 = (cb)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') cb(event);
    };
    if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document) {
        addEventListener('visibilitychange', onHiddenOrPageHide, true);
        // Some browsers have buggy implementations of visibilitychange,
        // so we use pagehide in addition, just to be safe.
        addEventListener('pagehide', onHiddenOrPageHide, true);
    }
};


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $fe09696b64168e31$export$b841d51e31c12bab = (cb)=>{
    let called = false;
    return (arg)=>{
        if (!called) {
            cb(arg);
            called = true;
        }
    };
};





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $e165ffcb1f952e84$var$firstHiddenTime = -1;
const $e165ffcb1f952e84$var$initHiddenTime = ()=>{
    // If the document is hidden when this code runs, assume it was always
    // hidden and the page was loaded in the background, with the one exception
    // that visibility state is always 'hidden' during prerendering, so we have
    // to ignore that case until prerendering finishes (see: `prerenderingchange`
    // event logic below).
    $e165ffcb1f952e84$var$firstHiddenTime = (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && !(0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.prerendering ? 0 : Infinity;
};
const $e165ffcb1f952e84$var$onVisibilityUpdate = (event)=>{
    // If the document is 'hidden' and no previous hidden timestamp has been
    // set, update it based on the current event data.
    if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.visibilityState === 'hidden' && $e165ffcb1f952e84$var$firstHiddenTime > -1) {
        // If the event is a 'visibilitychange' event, it means the page was
        // visible prior to this change, so the event timestamp is the first
        // hidden time.
        // However, if the event is not a 'visibilitychange' event, then it must
        // be a 'prerenderingchange' event, and the fact that the document is
        // still 'hidden' from the above check means the tab was activated
        // in a background state and so has always been hidden.
        $e165ffcb1f952e84$var$firstHiddenTime = event.type === 'visibilitychange' ? event.timeStamp : 0;
        // Remove all listeners now that a `firstHiddenTime` value has been set.
        removeEventListener('visibilitychange', $e165ffcb1f952e84$var$onVisibilityUpdate, true);
        removeEventListener('prerenderingchange', $e165ffcb1f952e84$var$onVisibilityUpdate, true);
    }
};
const $e165ffcb1f952e84$var$addChangeListeners = ()=>{
    addEventListener('visibilitychange', $e165ffcb1f952e84$var$onVisibilityUpdate, true);
    // IMPORTANT: when a page is prerendering, its `visibilityState` is
    // 'hidden', so in order to account for cases where this module checks for
    // visibility during prerendering, an additional check after prerendering
    // completes is also required.
    addEventListener('prerenderingchange', $e165ffcb1f952e84$var$onVisibilityUpdate, true);
};
const $e165ffcb1f952e84$export$443f86b2c77012c4 = ()=>{
    if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && $e165ffcb1f952e84$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $e165ffcb1f952e84$var$initHiddenTime();
        $e165ffcb1f952e84$var$addChangeListeners();
    }
    return {
        get firstHiddenTime () {
            return $e165ffcb1f952e84$var$firstHiddenTime;
        }
    };
};





/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $e3c30342b060159c$export$8bdb38a5671b594e = (callback)=>{
    if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.prerendering) addEventListener('prerenderingchange', ()=>callback(), true);
    else callback();
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FCP. See https://web.dev/articles/fcp#what_is_a_good_fcp_score */ const $7fee05b67121828f$export$e610c735b5510cec = [
    1800,
    3000
];
/**
 * Calculates the [FCP](https://web.dev/articles/fcp) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `paint` performance entry used to determine the value. The reported
 * value is a `DOMHighResTimeStamp`.
 */ const $7fee05b67121828f$export$fe3c86b74e15d5de = (onReport, opts = {})=>{
    (0, $e3c30342b060159c$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $e165ffcb1f952e84$export$443f86b2c77012c4)();
        const metric = (0, $1f7715287b915188$export$3c29b44508a0612b)('FCP');
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.name === 'first-contentful-paint') {
                    po.disconnect();
                    // Only report if the page wasn't hidden prior to the first paint.
                    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                        // The activationStart reference is used because FCP should be
                        // relative to page activation rather than navigation start if the
                        // page was prerendered. But in cases where `activationStart` occurs
                        // after the FCP, this time should be clamped at 0.
                        metric.value = Math.max(entry.startTime - (0, $f4f1882e07ed378c$export$d3e828b3c7b5b845)(), 0);
                        metric.entries.push(entry);
                        report(true);
                    }
                }
            });
        };
        const po = (0, $bc25e09948af204b$export$d1203567a167490e)('paint', handleEntries);
        if (po) report = (0, $59bb5452c9e08c91$export$17679dccdd551979)(onReport, metric, $7fee05b67121828f$export$e610c735b5510cec, opts.reportAllChanges);
    });
};


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for CLS. See https://web.dev/articles/cls#what_is_a_good_cls_score */ const $e3886690cecf5023$export$3f20d8e089ac35b2 = [
    0.1,
    0.25
];
/**
 * Calculates the [CLS](https://web.dev/articles/cls) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/articles/cls#layout_shift_score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $e3886690cecf5023$export$a7873055838e5ad8 = (onReport, opts = {})=>{
    // Start monitoring FCP so we can only report CLS if FCP is also reported.
    // Note: this is done to match the current behavior of CrUX.
    (0, $7fee05b67121828f$export$fe3c86b74e15d5de)((0, $fe09696b64168e31$export$b841d51e31c12bab)(()=>{
        const metric = (0, $1f7715287b915188$export$3c29b44508a0612b)('CLS', 0);
        let report;
        let sessionValue = 0;
        let sessionEntries = [];
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                // Only count layout shifts without recent user input.
                if (!entry.hadRecentInput) {
                    const firstSessionEntry = sessionEntries[0];
                    const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                    // If the entry occurred less than 1 second after the previous entry
                    // and less than 5 seconds after the first entry in the session,
                    // include the entry in the current session. Otherwise, start a new
                    // session.
                    if (sessionValue && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                        sessionValue += entry.value;
                        sessionEntries.push(entry);
                    } else {
                        sessionValue = entry.value;
                        sessionEntries = [
                            entry
                        ];
                    }
                }
            });
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                report();
            }
        };
        const po = (0, $bc25e09948af204b$export$d1203567a167490e)('layout-shift', handleEntries);
        if (po) {
            report = (0, $59bb5452c9e08c91$export$17679dccdd551979)(onReport, metric, $e3886690cecf5023$export$3f20d8e089ac35b2, opts.reportAllChanges);
            (0, $4b8cb11954cbab40$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                report(true);
            });
            // Queue a task to report (if nothing else triggers a report first).
            // This allows CLS to be reported as soon as FCP fires when
            // `reportAllChanges` is true.
            setTimeout(report, 0);
        }
    }));
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for FID. See https://web.dev/articles/fid#what_is_a_good_fid_score */ const $15d4ff1dbc756eaa$export$8f7f3c48ca6fbe34 = [
    100,
    300
];
/**
 * Calculates the [FID](https://web.dev/articles/fid) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $15d4ff1dbc756eaa$export$39705a25c49af873 = (onReport, opts = {})=>{
    (0, $e3c30342b060159c$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $e165ffcb1f952e84$export$443f86b2c77012c4)();
        const metric = (0, $1f7715287b915188$export$3c29b44508a0612b)('FID');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntry = (entry)=>{
            // Only report if the page wasn't hidden prior to the first input.
            if (entry.startTime < visibilityWatcher.firstHiddenTime) {
                metric.value = entry.processingStart - entry.startTime;
                metric.entries.push(entry);
                report(true);
            }
        };
        const handleEntries = (entries)=>{
            entries.forEach(handleEntry);
        };
        const po = (0, $bc25e09948af204b$export$d1203567a167490e)('first-input', handleEntries);
        report = (0, $59bb5452c9e08c91$export$17679dccdd551979)(onReport, metric, $15d4ff1dbc756eaa$export$8f7f3c48ca6fbe34, opts.reportAllChanges);
        if (po) (0, $4b8cb11954cbab40$export$91ec2be6fdd8f1b4)((0, $fe09696b64168e31$export$b841d51e31c12bab)(()=>{
            handleEntries(po.takeRecords());
            po.disconnect();
        }));
    });
};








let $720b40bf16ce8d61$var$interactionCountEstimate = 0;
let $720b40bf16ce8d61$var$minKnownInteractionId = Infinity;
let $720b40bf16ce8d61$var$maxKnownInteractionId = 0;
const $720b40bf16ce8d61$var$updateEstimate = (entries)=>{
    entries.forEach((e)=>{
        if (e.interactionId) {
            $720b40bf16ce8d61$var$minKnownInteractionId = Math.min($720b40bf16ce8d61$var$minKnownInteractionId, e.interactionId);
            $720b40bf16ce8d61$var$maxKnownInteractionId = Math.max($720b40bf16ce8d61$var$maxKnownInteractionId, e.interactionId);
            $720b40bf16ce8d61$var$interactionCountEstimate = $720b40bf16ce8d61$var$maxKnownInteractionId ? ($720b40bf16ce8d61$var$maxKnownInteractionId - $720b40bf16ce8d61$var$minKnownInteractionId) / 7 + 1 : 0;
        }
    });
};
let $720b40bf16ce8d61$var$po;
/**
 * Returns the `interactionCount` value using the native API (if available)
 * or the polyfill estimate in this module.
 */ const $720b40bf16ce8d61$export$8a962f2683a476d1 = ()=>{
    return $720b40bf16ce8d61$var$po ? $720b40bf16ce8d61$var$interactionCountEstimate : performance.interactionCount || 0;
};
/**
 * Feature detects native support or initializes the polyfill if needed.
 */ const $720b40bf16ce8d61$export$67d90cda6b78a2eb = ()=>{
    if ('interactionCount' in performance || $720b40bf16ce8d61$var$po) return;
    $720b40bf16ce8d61$var$po = (0, $bc25e09948af204b$export$d1203567a167490e)('event', $720b40bf16ce8d61$var$updateEstimate, {
        type: 'event',
        buffered: true,
        durationThreshold: 0
    });
};



/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for INP. See https://web.dev/articles/inp#what_is_a_good_inp_score */ const $2a746a195844a45a$export$7f4cb060ded9173c = [
    200,
    500
];
// Used to store the interaction count after a bfcache restore, since p98
// interaction latencies should only consider the current navigation.
const $2a746a195844a45a$var$prevInteractionCount = 0;
/**
 * Returns the interaction count since the last bfcache restore (or for the
 * full page lifecycle if there were no bfcache restores).
 */ const $2a746a195844a45a$var$getInteractionCountForNavigation = ()=>{
    return (0, $720b40bf16ce8d61$export$8a962f2683a476d1)() - $2a746a195844a45a$var$prevInteractionCount;
};
// To prevent unnecessary memory usage on pages with lots of interactions,
// store at most 10 of the longest interactions to consider as INP candidates.
const $2a746a195844a45a$var$MAX_INTERACTIONS_TO_CONSIDER = 10;
// A list of longest interactions on the page (by latency) sorted so the
// longest one is first. The list is as most MAX_INTERACTIONS_TO_CONSIDER long.
const $2a746a195844a45a$var$longestInteractionList = [];
// A mapping of longest interactions by their interaction ID.
// This is used for faster lookup.
const $2a746a195844a45a$var$longestInteractionMap = {};
/**
 * Takes a performance entry and adds it to the list of worst interactions
 * if its duration is long enough to make it among the worst. If the
 * entry is part of an existing interaction, it is merged and the latency
 * and entries list is updated as needed.
 */ const $2a746a195844a45a$var$processEntry = (entry)=>{
    // The least-long of the 10 longest interactions.
    const minLongestInteraction = $2a746a195844a45a$var$longestInteractionList[$2a746a195844a45a$var$longestInteractionList.length - 1];
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const existingInteraction = $2a746a195844a45a$var$longestInteractionMap[entry.interactionId];
    // Only process the entry if it's possibly one of the ten longest,
    // or if it's part of an existing interaction.
    if (existingInteraction || $2a746a195844a45a$var$longestInteractionList.length < $2a746a195844a45a$var$MAX_INTERACTIONS_TO_CONSIDER || entry.duration > minLongestInteraction.latency) {
        // If the interaction already exists, update it. Otherwise create one.
        if (existingInteraction) {
            existingInteraction.entries.push(entry);
            existingInteraction.latency = Math.max(existingInteraction.latency, entry.duration);
        } else {
            const interaction = {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                id: entry.interactionId,
                latency: entry.duration,
                entries: [
                    entry
                ]
            };
            $2a746a195844a45a$var$longestInteractionMap[interaction.id] = interaction;
            $2a746a195844a45a$var$longestInteractionList.push(interaction);
        }
        // Sort the entries by latency (descending) and keep only the top ten.
        $2a746a195844a45a$var$longestInteractionList.sort((a, b)=>b.latency - a.latency);
        $2a746a195844a45a$var$longestInteractionList.splice($2a746a195844a45a$var$MAX_INTERACTIONS_TO_CONSIDER).forEach((i)=>{
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete $2a746a195844a45a$var$longestInteractionMap[i.id];
        });
    }
};
/**
 * Returns the estimated p98 longest interaction based on the stored
 * interaction candidates and the interaction count for the current page.
 */ const $2a746a195844a45a$var$estimateP98LongestInteraction = ()=>{
    const candidateInteractionIndex = Math.min($2a746a195844a45a$var$longestInteractionList.length - 1, Math.floor($2a746a195844a45a$var$getInteractionCountForNavigation() / 50));
    return $2a746a195844a45a$var$longestInteractionList[candidateInteractionIndex];
};
/**
 * Calculates the [INP](https://web.dev/articles/inp) value for the current
 * page and calls the `callback` function once the value is ready, along with
 * the `event` performance entries reported for that interaction. The reported
 * value is a `DOMHighResTimeStamp`.
 *
 * A custom `durationThreshold` configuration option can optionally be passed to
 * control what `event-timing` entries are considered for INP reporting. The
 * default threshold is `40`, which means INP scores of less than 40 are
 * reported as 0. Note that this will not affect your 75th percentile INP value
 * unless that value is also less than 40 (well below the recommended
 * [good](https://web.dev/articles/inp#what_is_a_good_inp_score) threshold).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** INP should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $2a746a195844a45a$export$7df4b36ecaed99e1 = (onReport, opts = {})=>{
    (0, $e3c30342b060159c$export$8bdb38a5671b594e)(()=>{
        // TODO(philipwalton): remove once the polyfill is no longer needed.
        (0, $720b40bf16ce8d61$export$67d90cda6b78a2eb)();
        const metric = (0, $1f7715287b915188$export$3c29b44508a0612b)('INP');
        // eslint-disable-next-line prefer-const
        let report;
        const handleEntries = (entries)=>{
            entries.forEach((entry)=>{
                if (entry.interactionId) $2a746a195844a45a$var$processEntry(entry);
                // Entries of type `first-input` don't currently have an `interactionId`,
                // so to consider them in INP we have to first check that an existing
                // entry doesn't match the `duration` and `startTime`.
                // Note that this logic assumes that `event` entries are dispatched
                // before `first-input` entries. This is true in Chrome (the only browser
                // that currently supports INP).
                // TODO(philipwalton): remove once crbug.com/1325826 is fixed.
                if (entry.entryType === 'first-input') {
                    const noMatchingEntry = !$2a746a195844a45a$var$longestInteractionList.some((interaction)=>{
                        return interaction.entries.some((prevEntry)=>{
                            return entry.duration === prevEntry.duration && entry.startTime === prevEntry.startTime;
                        });
                    });
                    if (noMatchingEntry) $2a746a195844a45a$var$processEntry(entry);
                }
            });
            const inp = $2a746a195844a45a$var$estimateP98LongestInteraction();
            if (inp && inp.latency !== metric.value) {
                metric.value = inp.latency;
                metric.entries = inp.entries;
                report();
            }
        };
        const po = (0, $bc25e09948af204b$export$d1203567a167490e)('event', handleEntries, {
            // Event Timing entries have their durations rounded to the nearest 8ms,
            // so a duration of 40ms would be any event that spans 2.5 or more frames
            // at 60Hz. This threshold is chosen to strike a balance between usefulness
            // and performance. Running this callback for any interaction that spans
            // just one or two frames is likely not worth the insight that could be
            // gained.
            durationThreshold: opts.durationThreshold != null ? opts.durationThreshold : 40
        });
        report = (0, $59bb5452c9e08c91$export$17679dccdd551979)(onReport, metric, $2a746a195844a45a$export$7f4cb060ded9173c, opts.reportAllChanges);
        if (po) {
            // If browser supports interactionId (and so supports INP), also
            // observe entries of type `first-input`. This is useful in cases
            // where the first interaction is less than the `durationThreshold`.
            if ('PerformanceEventTiming' in (0, $2e0ad70334800584$export$56d8a8a25bd48b81) && 'interactionId' in PerformanceEventTiming.prototype) po.observe({
                type: 'first-input',
                buffered: true
            });
            (0, $4b8cb11954cbab40$export$91ec2be6fdd8f1b4)(()=>{
                handleEntries(po.takeRecords());
                // If the interaction count shows that there were interactions but
                // none were captured by the PerformanceObserver, report a latency of 0.
                if (metric.value < 0 && $2a746a195844a45a$var$getInteractionCountForNavigation() > 0) {
                    metric.value = 0;
                    metric.entries = [];
                }
                report(true);
            });
        }
    });
};











/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for LCP. See https://web.dev/articles/lcp#what_is_a_good_lcp_score */ const $bbbab3df902a993e$export$948521ca5b0e1b17 = [
    2500,
    4000
];
const $bbbab3df902a993e$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/articles/lcp) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called any time a new `largest-contentful-paint`
 * performance entry is dispatched, or once the final value of the metric has
 * been determined.
 */ const $bbbab3df902a993e$export$947b1626ab8d5632 = (onReport, opts = {})=>{
    (0, $e3c30342b060159c$export$8bdb38a5671b594e)(()=>{
        const visibilityWatcher = (0, $e165ffcb1f952e84$export$443f86b2c77012c4)();
        const metric = (0, $1f7715287b915188$export$3c29b44508a0612b)('LCP');
        let report;
        const handleEntries = (entries)=>{
            const lastEntry = entries[entries.length - 1];
            if (lastEntry) // Only report if the page wasn't hidden prior to LCP.
            {
                if (lastEntry.startTime < visibilityWatcher.firstHiddenTime) {
                    // The startTime attribute returns the value of the renderTime if it is
                    // not 0, and the value of the loadTime otherwise. The activationStart
                    // reference is used because LCP should be relative to page activation
                    // rather than navigation start if the page was prerendered. But in cases
                    // where `activationStart` occurs after the LCP, this time should be
                    // clamped at 0.
                    metric.value = Math.max(lastEntry.startTime - (0, $f4f1882e07ed378c$export$d3e828b3c7b5b845)(), 0);
                    metric.entries = [
                        lastEntry
                    ];
                    report();
                }
            }
        };
        const po = (0, $bc25e09948af204b$export$d1203567a167490e)('largest-contentful-paint', handleEntries);
        if (po) {
            report = (0, $59bb5452c9e08c91$export$17679dccdd551979)(onReport, metric, $bbbab3df902a993e$export$948521ca5b0e1b17, opts.reportAllChanges);
            const stopListening = (0, $fe09696b64168e31$export$b841d51e31c12bab)(()=>{
                if (!$bbbab3df902a993e$var$reportedMetricIDs[metric.id]) {
                    handleEntries(po.takeRecords());
                    po.disconnect();
                    $bbbab3df902a993e$var$reportedMetricIDs[metric.id] = true;
                    report(true);
                }
            });
            // Stop listening after input. Note: while scrolling is an input that
            // stops LCP observation, it's unreliable since it can be programmatically
            // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
            [
                'keydown',
                'click'
            ].forEach((type)=>{
                if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document) // Wrap in a setTimeout so the callback is run in a separate task
                // to avoid extending the keyboard/click handler to reduce INP impact
                // https://github.com/GoogleChrome/web-vitals/issues/383
                addEventListener(type, ()=>setTimeout(stopListening, 0), true);
            });
            (0, $4b8cb11954cbab40$export$91ec2be6fdd8f1b4)(stopListening);
        }
    });
};









/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Thresholds for TTFB. See https://web.dev/articles/ttfb#what_is_a_good_ttfb_score */ const $1b3468bf2c44964c$export$65c59ea8064668fc = [
    800,
    1800
];
/**
 * Runs in the next task after the page is done loading and/or prerendering.
 * @param callback
 */ const $1b3468bf2c44964c$var$whenReady = (callback)=>{
    if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.prerendering) (0, $e3c30342b060159c$export$8bdb38a5671b594e)(()=>$1b3468bf2c44964c$var$whenReady(callback));
    else if ((0, $2e0ad70334800584$export$56d8a8a25bd48b81).document && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.readyState !== 'complete') addEventListener('load', ()=>$1b3468bf2c44964c$var$whenReady(callback), true);
    else // Queue a task so the callback runs after `loadEventEnd`.
    setTimeout(callback, 0);
};
/**
 * Calculates the [TTFB](https://web.dev/articles/ttfb) value for the
 * current page and calls the `callback` function once the page has loaded,
 * along with the relevant `navigation` performance entry used to determine the
 * value. The reported value is a `DOMHighResTimeStamp`.
 *
 * Note, this function waits until after the page is loaded to call `callback`
 * in order to ensure all properties of the `navigation` entry are populated.
 * This is useful if you want to report on other metrics exposed by the
 * [Navigation Timing API](https://w3c.github.io/navigation-timing/). For
 * example, the TTFB metric starts from the page's [time
 * origin](https://www.w3.org/TR/hr-time-2/#sec-time-origin), which means it
 * includes time spent on DNS lookup, connection negotiation, network latency,
 * and server processing time.
 */ const $1b3468bf2c44964c$export$33a01e6c5f2c7e33 = (onReport, opts = {})=>{
    const metric = (0, $1f7715287b915188$export$3c29b44508a0612b)('TTFB');
    const report = (0, $59bb5452c9e08c91$export$17679dccdd551979)(onReport, metric, $1b3468bf2c44964c$export$65c59ea8064668fc, opts.reportAllChanges);
    $1b3468bf2c44964c$var$whenReady(()=>{
        const navEntry = (0, $344f84f1ce7414d4$export$6431553786c94949)();
        if (navEntry) {
            const responseStart = navEntry.responseStart;
            // In some cases no value is reported by the browser (for
            // privacy/security reasons), and in other cases (bugs) the value is
            // negative or is larger than the current page time. Ignore these cases:
            // https://github.com/GoogleChrome/web-vitals/issues/137
            // https://github.com/GoogleChrome/web-vitals/issues/162
            // https://github.com/GoogleChrome/web-vitals/issues/275
            if (responseStart <= 0 || responseStart > performance.now()) return;
            // The activationStart reference is used because TTFB should be
            // relative to page activation rather than navigation start if the
            // page was prerendered. But in cases where `activationStart` occurs
            // after the first byte is received, this time should be clamped at 0.
            metric.value = Math.max(responseStart - (0, $f4f1882e07ed378c$export$d3e828b3c7b5b845)(), 0);
            metric.entries = [
                navEntry
            ];
            report(true);
        }
    });
};


const $4deab877b1f61f68$var$handlers = {};
const $4deab877b1f61f68$var$instrumented = {};
let $4deab877b1f61f68$var$_previousCls;
let $4deab877b1f61f68$var$_previousFid;
let $4deab877b1f61f68$var$_previousLcp;
let $4deab877b1f61f68$var$_previousTtfb;
let $4deab877b1f61f68$var$_previousInp;
/**
 * Add a callback that will be triggered when a CLS metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for CLS when the cleanup callback is called.
 * This will lead to the CLS being finalized and frozen.
 */ function $4deab877b1f61f68$export$861b82818b37ba5b(callback, stopOnCallback = false) {
    return $4deab877b1f61f68$var$addMetricObserver('cls', callback, $4deab877b1f61f68$var$instrumentCls, $4deab877b1f61f68$var$_previousCls, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a LCP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 *
 * Pass `stopOnCallback = true` to stop listening for LCP when the cleanup callback is called.
 * This will lead to the LCP being finalized and frozen.
 */ function $4deab877b1f61f68$export$3fd4b53331200102(callback, stopOnCallback = false) {
    return $4deab877b1f61f68$var$addMetricObserver('lcp', callback, $4deab877b1f61f68$var$instrumentLcp, $4deab877b1f61f68$var$_previousLcp, stopOnCallback);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4deab877b1f61f68$export$2707d7471c0b918f(callback) {
    return $4deab877b1f61f68$var$addMetricObserver('fid', callback, $4deab877b1f61f68$var$instrumentFid, $4deab877b1f61f68$var$_previousFid);
}
/**
 * Add a callback that will be triggered when a FID metric is available.
 */ function $4deab877b1f61f68$export$699d9529c099a797(callback) {
    return $4deab877b1f61f68$var$addMetricObserver('ttfb', callback, $4deab877b1f61f68$var$instrumentTtfb, $4deab877b1f61f68$var$_previousTtfb);
}
/**
 * Add a callback that will be triggered when a INP metric is available.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4deab877b1f61f68$export$da3b76aa2022cbd7(callback) {
    return $4deab877b1f61f68$var$addMetricObserver('inp', callback, $4deab877b1f61f68$var$instrumentInp, $4deab877b1f61f68$var$_previousInp);
}
/**
 * Add a callback that will be triggered when a performance observer is triggered,
 * and receives the entries of the observer.
 * Returns a cleanup callback which can be called to remove the instrumentation handler.
 */ function $4deab877b1f61f68$export$69816c1a049f8db6(type, callback) {
    $4deab877b1f61f68$var$addHandler(type, callback);
    if (!$4deab877b1f61f68$var$instrumented[type]) {
        $4deab877b1f61f68$var$instrumentPerformanceObserver(type);
        $4deab877b1f61f68$var$instrumented[type] = true;
    }
    return $4deab877b1f61f68$var$getCleanupCallback(type, callback);
}
/** Trigger all handlers of a given type. */ function $4deab877b1f61f68$var$triggerHandlers(type, data) {
    const typeHandlers = $4deab877b1f61f68$var$handlers[type];
    if (!typeHandlers || !typeHandlers.length) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $81b681a083912fb6$export$aad197c7121a6651)(handler)}\nError:`, e);
    }
}
function $4deab877b1f61f68$var$instrumentCls() {
    return (0, $e3886690cecf5023$export$a7873055838e5ad8)((metric)=>{
        $4deab877b1f61f68$var$triggerHandlers('cls', {
            metric: metric
        });
        $4deab877b1f61f68$var$_previousCls = metric;
    }, // We want the callback to be called whenever the CLS value updates.
    // By default, the callback is only called when the tab goes to the background.
    {
        reportAllChanges: true
    });
}
function $4deab877b1f61f68$var$instrumentFid() {
    return (0, $15d4ff1dbc756eaa$export$39705a25c49af873)((metric)=>{
        $4deab877b1f61f68$var$triggerHandlers('fid', {
            metric: metric
        });
        $4deab877b1f61f68$var$_previousFid = metric;
    });
}
function $4deab877b1f61f68$var$instrumentLcp() {
    return (0, $bbbab3df902a993e$export$947b1626ab8d5632)((metric)=>{
        $4deab877b1f61f68$var$triggerHandlers('lcp', {
            metric: metric
        });
        $4deab877b1f61f68$var$_previousLcp = metric;
    });
}
function $4deab877b1f61f68$var$instrumentTtfb() {
    return (0, $1b3468bf2c44964c$export$33a01e6c5f2c7e33)((metric)=>{
        $4deab877b1f61f68$var$triggerHandlers('ttfb', {
            metric: metric
        });
        $4deab877b1f61f68$var$_previousTtfb = metric;
    });
}
function $4deab877b1f61f68$var$instrumentInp() {
    return (0, $2a746a195844a45a$export$7df4b36ecaed99e1)((metric)=>{
        $4deab877b1f61f68$var$triggerHandlers('inp', {
            metric: metric
        });
        $4deab877b1f61f68$var$_previousInp = metric;
    });
}
function $4deab877b1f61f68$var$addMetricObserver(type, callback, instrumentFn, previousValue, stopOnCallback = false) {
    $4deab877b1f61f68$var$addHandler(type, callback);
    let stopListening;
    if (!$4deab877b1f61f68$var$instrumented[type]) {
        stopListening = instrumentFn();
        $4deab877b1f61f68$var$instrumented[type] = true;
    }
    if (previousValue) callback({
        metric: previousValue
    });
    return $4deab877b1f61f68$var$getCleanupCallback(type, callback, stopOnCallback ? stopListening : undefined);
}
function $4deab877b1f61f68$var$instrumentPerformanceObserver(type) {
    const options = {};
    // Special per-type options we want to use
    if (type === 'event') options.durationThreshold = 0;
    (0, $bc25e09948af204b$export$d1203567a167490e)(type, (entries)=>{
        $4deab877b1f61f68$var$triggerHandlers(type, {
            entries: entries
        });
    }, options);
}
function $4deab877b1f61f68$var$addHandler(type, handler) {
    $4deab877b1f61f68$var$handlers[type] = $4deab877b1f61f68$var$handlers[type] || [];
    $4deab877b1f61f68$var$handlers[type].push(handler);
}
// Get a callback which can be called to remove the instrumentation handler
function $4deab877b1f61f68$var$getCleanupCallback(type, callback, stopListening) {
    return ()=>{
        if (stopListening) stopListening();
        const typeHandlers = $4deab877b1f61f68$var$handlers[type];
        if (!typeHandlers) return;
        const index = typeHandlers.indexOf(callback);
        if (index !== -1) typeHandlers.splice(index, 1);
    };
}




/**
 * Checks if a given value is a valid measurement value.
 */ function $53dda5868a4fe0b2$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $53dda5868a4fe0b2$export$7567a67bdb69a23d(parentSpan, startTimeInSeconds, endTime, { ...ctx }) {
    const parentStartTime = (0, $03e63b69c89faacb$export$92d8c23565496537)(parentSpan).start_timestamp;
    if (parentStartTime && parentStartTime > startTimeInSeconds) // We can only do this for SentrySpans...
    {
        if (typeof parentSpan.updateStartTime === 'function') parentSpan.updateStartTime(startTimeInSeconds);
    }
    // The return value only exists for tests
    return (0, $5b8e5c42bcba91ae$export$e57ac09b143d92a2)(parentSpan, ()=>{
        const span = (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)({
            startTime: startTimeInSeconds,
            ...ctx
        });
        if (span) span.end(endTime);
        return span;
    });
}
/** Get the browser performance API. */ function $53dda5868a4fe0b2$export$f72a13c439a30cab() {
    // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
    return (0, $2e0ad70334800584$export$56d8a8a25bd48b81) && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).addEventListener && (0, $2e0ad70334800584$export$56d8a8a25bd48b81).performance;
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $53dda5868a4fe0b2$export$b4785dbd4a81b33f(time) {
    return time / 1000;
}




/* eslint-disable max-lines */ const $63120a631dceb004$var$MAX_INT_AS_BYTES = 2147483647;
let $63120a631dceb004$var$_performanceCursor = 0;
let $63120a631dceb004$var$_measurements = {};
let $63120a631dceb004$var$_lcpEntry;
let $63120a631dceb004$var$_clsEntry;
/**
 * Start tracking web vitals.
 * The callback returned by this function can be used to stop tracking & ensure all measurements are final & captured.
 *
 * @returns A function that forces web vitals collection
 */ function $63120a631dceb004$export$7c69f0412d101b88() {
    const performance = (0, $53dda5868a4fe0b2$export$f72a13c439a30cab)();
    if (performance && (0, $8f221861fb4a2bd8$export$baf075a948ffc0bf)) {
        // @ts-expect-error we want to make sure all of these are available, even if TS is sure they are
        if (performance.mark) (0, $2e0ad70334800584$export$56d8a8a25bd48b81).performance.mark('sentry-tracing-init');
        const fidCallback = $63120a631dceb004$var$_trackFID();
        const clsCallback = $63120a631dceb004$var$_trackCLS();
        const lcpCallback = $63120a631dceb004$var$_trackLCP();
        const ttfbCallback = $63120a631dceb004$var$_trackTtfb();
        return ()=>{
            fidCallback();
            clsCallback();
            lcpCallback();
            ttfbCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $63120a631dceb004$export$f396d19077034ad2() {
    (0, $4deab877b1f61f68$export$69816c1a049f8db6)('longtask', ({ entries: entries })=>{
        for (const entry of entries){
            if (!(0, $03e63b69c89faacb$export$1be426a8e585c83e)()) return;
            const startTime = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) + entry.startTime);
            const duration = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.duration);
            const span = (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)({
                name: 'Main UI thread blocked',
                op: 'ui.long-task',
                startTime: startTime,
                attributes: {
                    [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
            if (span) span.end(startTime + duration);
        }
    });
}
/**
 * Start tracking interaction events.
 */ function $63120a631dceb004$export$e27543e0976315e4() {
    (0, $4deab877b1f61f68$export$69816c1a049f8db6)('event', ({ entries: entries })=>{
        for (const entry of entries){
            if (!(0, $03e63b69c89faacb$export$1be426a8e585c83e)()) return;
            if (entry.name === 'click') {
                const startTime = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) + entry.startTime);
                const duration = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.duration);
                const spanOptions = {
                    name: (0, $b076601639d1314e$export$5647df6b7814ac86)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    startTime: startTime,
                    attributes: {
                        [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                    }
                };
                const componentName = (0, $b076601639d1314e$export$26727cfcc4d7e0fc)(entry.target);
                if (componentName) spanOptions.attributes['ui.component_name'] = componentName;
                const span = (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)(spanOptions);
                if (span) span.end(startTime + duration);
            }
        }
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $63120a631dceb004$var$_trackCLS() {
    return (0, $4deab877b1f61f68$export$861b82818b37ba5b)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding CLS');
        $63120a631dceb004$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $63120a631dceb004$var$_clsEntry = entry;
    }, true);
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $63120a631dceb004$var$_trackLCP() {
    return (0, $4deab877b1f61f68$export$3fd4b53331200102)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding LCP');
        $63120a631dceb004$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $63120a631dceb004$var$_lcpEntry = entry;
    }, true);
}
/** Starts tracking the First Input Delay on the current page. */ function $63120a631dceb004$var$_trackFID() {
    return (0, $4deab877b1f61f68$export$2707d7471c0b918f)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        const timeOrigin = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf));
        const startTime = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.startTime);
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding FID');
        $63120a631dceb004$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $63120a631dceb004$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
function $63120a631dceb004$var$_trackTtfb() {
    return (0, $4deab877b1f61f68$export$699d9529c099a797)(({ metric: metric })=>{
        const entry = metric.entries[metric.entries.length - 1];
        if (!entry) return;
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding TTFB');
        $63120a631dceb004$var$_measurements['ttfb'] = {
            value: metric.value,
            unit: 'millisecond'
        };
    });
}
/** Add performance related spans to a transaction */ function $63120a631dceb004$export$5f8fa6b3467a7443(span) {
    const performance = (0, $53dda5868a4fe0b2$export$f72a13c439a30cab)();
    if (!performance || !(0, $2e0ad70334800584$export$56d8a8a25bd48b81).performance.getEntries || !(0, $8f221861fb4a2bd8$export$baf075a948ffc0bf)) // Gatekeeper if performance API not available
    return;
    (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf));
    const performanceEntries = performance.getEntries();
    const { op: op, start_timestamp: transactionStartTime } = (0, $03e63b69c89faacb$export$92d8c23565496537)(span);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($63120a631dceb004$var$_performanceCursor).forEach((entry)=>{
        const startTime = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.startTime);
        const duration = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.duration);
        if (op === 'navigation' && transactionStartTime && timeOrigin + startTime < transactionStartTime) return;
        switch(entry.entryType){
            case 'navigation':
                $63120a631dceb004$var$_addNavigationSpans(span, entry, timeOrigin);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $63120a631dceb004$export$bc93b84e4d45912d(span, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $e165ffcb1f952e84$export$443f86b2c77012c4)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding FP');
                        $63120a631dceb004$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding FCP');
                        $63120a631dceb004$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                $63120a631dceb004$export$c82fe1a70634f317(span, entry, entry.name, startTime, duration, timeOrigin);
                break;
        }
    });
    $63120a631dceb004$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $63120a631dceb004$var$_trackNavigator(span);
    // Measurements are only available for pageload transactions
    if (op === 'pageload') {
        $63120a631dceb004$var$_addTtfbRequestTimeToMeasurements($63120a631dceb004$var$_measurements);
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$63120a631dceb004$var$_measurements[name] || !transactionStartTime || timeOrigin >= transactionStartTime) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the span span data, so these web vitals will need
            // to be adjusted to be relative to span.startTimestamp.
            const oldValue = $63120a631dceb004$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transactionStartTime) * 1000);
            const delta = normalizedValue - oldValue;
            (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $63120a631dceb004$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $63120a631dceb004$var$_measurements['mark.fid'];
        if (fidMark && $63120a631dceb004$var$_measurements['fid']) {
            // create span for FID
            (0, $53dda5868a4fe0b2$export$7567a67bdb69a23d)(span, fidMark.value, fidMark.value + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)($63120a631dceb004$var$_measurements['fid'].value), {
                name: 'first input delay',
                op: 'ui.action',
                attributes: {
                    [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
                }
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $63120a631dceb004$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $63120a631dceb004$var$_measurements)) delete $63120a631dceb004$var$_measurements.cls;
        Object.keys($63120a631dceb004$var$_measurements).forEach((measurementName)=>{
            (0, $7d79723997600996$export$7cc31b475d33a706)(measurementName, $63120a631dceb004$var$_measurements[measurementName].value, $63120a631dceb004$var$_measurements[measurementName].unit);
        });
        $63120a631dceb004$var$_tagMetricInfo(span);
    }
    $63120a631dceb004$var$_lcpEntry = undefined;
    $63120a631dceb004$var$_clsEntry = undefined;
    $63120a631dceb004$var$_measurements = {};
}
/** Create measure related spans */ function $63120a631dceb004$export$bc93b84e4d45912d(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $53dda5868a4fe0b2$export$7567a67bdb69a23d)(span, measureStartTimestamp, measureEndTimestamp, {
        name: entry.name,
        op: entry.entryType,
        attributes: {
            [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
        }
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $63120a631dceb004$var$_addNavigationSpans(span, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $63120a631dceb004$var$_addPerformanceNavigationTiming(span, entry, event, timeOrigin);
    });
    $63120a631dceb004$var$_addPerformanceNavigationTiming(span, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $63120a631dceb004$var$_addPerformanceNavigationTiming(span, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $63120a631dceb004$var$_addPerformanceNavigationTiming(span, entry, 'domainLookup', timeOrigin, 'DNS');
    $63120a631dceb004$var$_addRequest(span, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $63120a631dceb004$var$_addPerformanceNavigationTiming(span, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, name, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $53dda5868a4fe0b2$export$7567a67bdb69a23d)(span, timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(start), timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(end), {
        op: 'browser',
        name: name || event,
        attributes: {
            [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
        }
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $63120a631dceb004$var$_addRequest(span, entry, timeOrigin) {
    if (entry.responseEnd) {
        // It is possible that we are collecting these metrics when the page hasn't finished loading yet, for example when the HTML slowly streams in.
        // In this case, ie. when the document request hasn't finished yet, `entry.responseEnd` will be 0.
        // In order not to produce faulty spans, where the end timestamp is before the start timestamp, we will only collect
        // these spans when the responseEnd value is available. The backend (Relay) would drop the entire span if it contained faulty spans.
        (0, $53dda5868a4fe0b2$export$7567a67bdb69a23d)(span, timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.requestStart), timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.responseEnd), {
            op: 'browser',
            name: 'request',
            attributes: {
                [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
        (0, $53dda5868a4fe0b2$export$7567a67bdb69a23d)(span, timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.responseStart), timeOrigin + (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(entry.responseEnd), {
            op: 'browser',
            name: 'response',
            attributes: {
                [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.ui.browser.metrics'
            }
        });
    }
}
/** Create resource-related spans */ function $63120a631dceb004$export$c82fe1a70634f317(span, entry, resourceUrl, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    const parsedUrl = (0, $cdc4578f23641df3$export$7a5253c0f62e0150)(resourceUrl);
    const attributes = {
        [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.resource.browser.metrics'
    };
    $63120a631dceb004$var$setResourceEntrySizeData(attributes, entry, 'transferSize', 'http.response_transfer_size');
    $63120a631dceb004$var$setResourceEntrySizeData(attributes, entry, 'encodedBodySize', 'http.response_content_length');
    $63120a631dceb004$var$setResourceEntrySizeData(attributes, entry, 'decodedBodySize', 'http.decoded_response_content_length');
    if ('renderBlockingStatus' in entry) attributes['resource.render_blocking_status'] = entry.renderBlockingStatus;
    if (parsedUrl.protocol) attributes['url.scheme'] = parsedUrl.protocol.split(':').pop(); // the protocol returned by parseUrl includes a :, but OTEL spec does not, so we remove it.
    if (parsedUrl.host) attributes['server.address'] = parsedUrl.host;
    attributes['url.same_origin'] = resourceUrl.includes((0, $2e0ad70334800584$export$56d8a8a25bd48b81).location.origin);
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $53dda5868a4fe0b2$export$7567a67bdb69a23d)(span, startTimestamp, endTimestamp, {
        name: resourceUrl.replace((0, $2e0ad70334800584$export$56d8a8a25bd48b81).location.origin, ''),
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        attributes: attributes
    });
}
/**
 * Capture the information of the user agent.
 */ function $63120a631dceb004$var$_trackNavigator(span) {
    const navigator = (0, $2e0ad70334800584$export$56d8a8a25bd48b81).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) span.setAttribute('effectiveConnectionType', connection.effectiveType);
        if (connection.type) span.setAttribute('connectionType', connection.type);
        if ((0, $53dda5868a4fe0b2$export$27169ccae1b439e3)(connection.rtt)) $63120a631dceb004$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $53dda5868a4fe0b2$export$27169ccae1b439e3)(navigator.deviceMemory)) span.setAttribute('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $53dda5868a4fe0b2$export$27169ccae1b439e3)(navigator.hardwareConcurrency)) span.setAttribute('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to span to allow debugging */ function $63120a631dceb004$var$_tagMetricInfo(span) {
    if ($63120a631dceb004$var$_lcpEntry) {
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($63120a631dceb004$var$_lcpEntry.element) span.setAttribute('lcp.element', (0, $b076601639d1314e$export$5647df6b7814ac86)($63120a631dceb004$var$_lcpEntry.element));
        if ($63120a631dceb004$var$_lcpEntry.id) span.setAttribute('lcp.id', $63120a631dceb004$var$_lcpEntry.id);
        if ($63120a631dceb004$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        span.setAttribute('lcp.url', $63120a631dceb004$var$_lcpEntry.url.trim().slice(0, 200));
        span.setAttribute('lcp.size', $63120a631dceb004$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($63120a631dceb004$var$_clsEntry && $63120a631dceb004$var$_clsEntry.sources) {
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding CLS Data');
        $63120a631dceb004$var$_clsEntry.sources.forEach((source, index)=>span.setAttribute(`cls.source.${index + 1}`, (0, $b076601639d1314e$export$5647df6b7814ac86)(source.node)));
    }
}
function $63120a631dceb004$var$setResourceEntrySizeData(attributes, entry, key, dataKey) {
    const entryVal = entry[key];
    if (entryVal != null && entryVal < $63120a631dceb004$var$MAX_INT_AS_BYTES) attributes[dataKey] = entryVal;
}
/**
 * Add ttfb request time information to measurements.
 *
 * ttfb information is added via vendored web vitals library.
 */ function $63120a631dceb004$var$_addTtfbRequestTimeToMeasurements(_measurements) {
    const navEntry = (0, $344f84f1ce7414d4$export$6431553786c94949)();
    if (!navEntry) return;
    const { responseStart: responseStart, requestStart: requestStart } = navEntry;
    if (requestStart <= responseStart) {
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Measurements] Adding TTFB Request Time');
        _measurements['ttfb.requestTime'] = {
            value: responseStart - requestStart,
            unit: 'millisecond'
        };
    }
}

/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $66fe232ec5ceea1a$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}





/**
 * Start tracking INP webvital events.
 */ function $a4dca2da4a8e6254$export$f17d06681a4744a3() {
    const performance = (0, $53dda5868a4fe0b2$export$f72a13c439a30cab)();
    if (performance && (0, $8f221861fb4a2bd8$export$baf075a948ffc0bf)) {
        const inpCallback = $a4dca2da4a8e6254$var$_trackINP();
        return ()=>{
            inpCallback();
        };
    }
    return ()=>undefined;
}
const $a4dca2da4a8e6254$var$INP_ENTRY_MAP = {
    click: 'click',
    pointerdown: 'click',
    pointerup: 'click',
    mousedown: 'click',
    mouseup: 'click',
    touchstart: 'click',
    touchend: 'click',
    mouseover: 'hover',
    mouseout: 'hover',
    mouseenter: 'hover',
    mouseleave: 'hover',
    pointerover: 'hover',
    pointerout: 'hover',
    pointerenter: 'hover',
    pointerleave: 'hover',
    dragstart: 'drag',
    dragend: 'drag',
    drag: 'drag',
    dragenter: 'drag',
    dragleave: 'drag',
    dragover: 'drag',
    drop: 'drag',
    keydown: 'press',
    keyup: 'press',
    keypress: 'press',
    input: 'press'
};
/** Starts tracking the Interaction to Next Paint on the current page. */ function $a4dca2da4a8e6254$var$_trackINP() {
    return (0, $4deab877b1f61f68$export$da3b76aa2022cbd7)(({ metric: metric })=>{
        const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
        if (!client || metric.value == undefined) return;
        const entry = metric.entries.find((entry)=>entry.duration === metric.value && $a4dca2da4a8e6254$var$INP_ENTRY_MAP[entry.name]);
        if (!entry) return;
        const interactionType = $a4dca2da4a8e6254$var$INP_ENTRY_MAP[entry.name];
        const options = client.getOptions();
        /** Build the INP span, create an envelope from the span, and then send the envelope */ const startTime = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) + entry.startTime);
        const duration = (0, $53dda5868a4fe0b2$export$b4785dbd4a81b33f)(metric.value);
        const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
        const activeSpan = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
        const rootSpan = activeSpan ? (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(activeSpan) : undefined;
        const routeName = rootSpan ? (0, $03e63b69c89faacb$export$92d8c23565496537)(rootSpan).description : undefined;
        const user = scope.getUser();
        // We need to get the replay, user, and activeTransaction from the current scope
        // so that we can associate replay id, profile id, and a user display to the span
        const replay = client.getIntegrationByName('Replay');
        const replayId = replay && replay.getReplayId();
        const userDisplay = user !== undefined ? user.email || user.id || user.ip_address : undefined;
        const profileId = (0, $66fe232ec5ceea1a$export$3cc482e6b02f32f7)([
            scope,
            'access',
            (_)=>_.getScopeData,
            'call',
            (_2)=>_2(),
            'access',
            (_3)=>_3.contexts,
            'optionalAccess',
            (_4)=>_4.profile,
            'optionalAccess',
            (_5)=>_5.profile_id
        ]);
        const name = (0, $b076601639d1314e$export$5647df6b7814ac86)(entry.target);
        const attributes = (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
            release: options.release,
            environment: options.environment,
            transaction: routeName,
            [(0, $6dba76bc75a85eae$export$fea48ba9f4550879)]: metric.value,
            user: userDisplay || undefined,
            profile_id: profileId || undefined,
            replay_id: replayId || undefined
        });
        const span = (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)({
            name: name,
            op: `ui.interaction.${interactionType}`,
            attributes: attributes,
            startTime: startTime,
            experimental: {
                standalone: true
            }
        });
        span.addEvent('inp', {
            [(0, $6dba76bc75a85eae$export$f5f95cff026507b5)]: 'millisecond',
            [(0, $6dba76bc75a85eae$export$69cd5c610c7bb96a)]: metric.value
        });
        span.end(startTime + duration);
    });
}




let $7550a53811741197$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7550a53811741197$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $7550a53811741197$var$instrumentError);
}
function $7550a53811741197$var$instrumentError() {
    $7550a53811741197$var$_oldOnErrorHandler = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).onerror;
    (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $fb3c91b0664aac42$export$b18c893e424d3127)('error', handlerData);
        if ($7550a53811741197$var$_oldOnErrorHandler && !$7550a53811741197$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $7550a53811741197$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).onerror.__SENTRY_INSTRUMENTED__ = true;
}



let $db3b8791cf660c9e$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $db3b8791cf660c9e$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $db3b8791cf660c9e$var$instrumentUnhandledRejection);
}
function $db3b8791cf660c9e$var$instrumentUnhandledRejection() {
    $db3b8791cf660c9e$var$_oldOnUnhandledRejectionHandler = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).onunhandledrejection;
    (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $fb3c91b0664aac42$export$b18c893e424d3127)('unhandledrejection', handlerData);
        if ($db3b8791cf660c9e$var$_oldOnUnhandledRejectionHandler && !$db3b8791cf660c9e$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $db3b8791cf660c9e$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}





let $468f4d4bc2365d55$var$errorsInstrumented = false;
/**
 * Ensure that global errors automatically set the active span status.
 */ function $468f4d4bc2365d55$export$b0914730ee1f6c80() {
    if ($468f4d4bc2365d55$var$errorsInstrumented) return;
    $468f4d4bc2365d55$var$errorsInstrumented = true;
    (0, $7550a53811741197$export$55b5c3ba2194f0c6)($468f4d4bc2365d55$var$errorCallback);
    (0, $db3b8791cf660c9e$export$8bf4fc6858821a4e)($468f4d4bc2365d55$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active root span as failed
 */ function $468f4d4bc2365d55$var$errorCallback() {
    const activeSpan = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const rootSpan = activeSpan && (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(activeSpan);
    if (rootSpan) {
        const message = 'internal_error';
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Root span: ${message} -> Global error occured`);
        rootSpan.setStatus({
            code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
            message: message
        });
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$468f4d4bc2365d55$var$errorCallback.tag = 'sentry_tracingErrorCallback';











const $e214634349264c97$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    childSpanTimeout: 15000
};
const $e214634349264c97$var$FINISH_REASON_HEARTBEAT_FAILED = 'heartbeatFailed';
const $e214634349264c97$var$FINISH_REASON_IDLE_TIMEOUT = 'idleTimeout';
const $e214634349264c97$var$FINISH_REASON_FINAL_TIMEOUT = 'finalTimeout';
const $e214634349264c97$var$FINISH_REASON_EXTERNAL_FINISH = 'externalFinish';
/**
 * An idle span is a span that automatically finishes. It does this by tracking child spans as activities.
 * An idle span is always the active span.
 */ function $e214634349264c97$export$901bffd97bd52797(startSpanOptions, options = {}) {
    // Activities store a list of active spans
    const activities = new Map();
    // We should not use heartbeat if we finished a span
    let _finished = false;
    // Timer that tracks idleTimeout
    let _idleTimeoutID;
    // The reason why the span was finished
    let _finishReason = $e214634349264c97$var$FINISH_REASON_EXTERNAL_FINISH;
    let _autoFinishAllowed = !options.disableAutoFinish;
    const { idleTimeout: idleTimeout = $e214634349264c97$export$809a2b7987fd5306.idleTimeout, finalTimeout: finalTimeout = $e214634349264c97$export$809a2b7987fd5306.finalTimeout, childSpanTimeout: childSpanTimeout = $e214634349264c97$export$809a2b7987fd5306.childSpanTimeout, beforeSpanEnd: beforeSpanEnd } = options;
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (!client || !(0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)()) return new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)();
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const previousActiveSpan = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const span = $e214634349264c97$var$_startIdleSpan(startSpanOptions);
    function _endSpan(timestamp = (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)()) {
        // Ensure we end with the last span timestamp, if possible
        const spans = (0, $03e63b69c89faacb$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        // If we have no spans, we just end, nothing else to do here
        if (!spans.length) {
            span.end(timestamp);
            return;
        }
        const childEndTimestamps = spans.map((span)=>(0, $03e63b69c89faacb$export$92d8c23565496537)(span).timestamp).filter((timestamp)=>!!timestamp);
        const latestSpanEndTimestamp = childEndTimestamps.length ? Math.max(...childEndTimestamps) : undefined;
        const spanEndTimestamp = (0, $03e63b69c89faacb$export$3f7581298f56c6d7)(timestamp);
        // In reality this should always exist here, but type-wise it may be undefined...
        const spanStartTimestamp = (0, $03e63b69c89faacb$export$92d8c23565496537)(span).start_timestamp;
        // The final endTimestamp should:
        // * Never be before the span start timestamp
        // * Be the latestSpanEndTimestamp, if there is one, and it is smaller than the passed span end timestamp
        // * Otherwise be the passed end timestamp
        // Final timestamp can never be after finalTimeout
        const endTimestamp = Math.min(spanStartTimestamp ? spanStartTimestamp + finalTimeout / 1000 : Infinity, Math.max(spanStartTimestamp || -Infinity, Math.min(spanEndTimestamp, latestSpanEndTimestamp || Infinity)));
        span.end(endTimestamp);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   */ function _cancelIdleTimeout() {
        if (_idleTimeoutID) {
            clearTimeout(_idleTimeoutID);
            _idleTimeoutID = undefined;
        }
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ function _restartIdleTimeout(endTimestamp) {
        _cancelIdleTimeout();
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && activities.size === 0 && _autoFinishAllowed) {
                _finishReason = $e214634349264c97$var$FINISH_REASON_IDLE_TIMEOUT;
                _endSpan(endTimestamp);
            }
        }, idleTimeout);
    }
    /**
   * Restarts child span timeout, if there is none running it will start one.
   */ function _restartChildSpanTimeout(endTimestamp) {
        _idleTimeoutID = setTimeout(()=>{
            if (!_finished && _autoFinishAllowed) {
                _finishReason = $e214634349264c97$var$FINISH_REASON_HEARTBEAT_FAILED;
                _endSpan(endTimestamp);
            }
        }, childSpanTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ function _pushActivity(spanId) {
        _cancelIdleTimeout();
        activities.set(spanId, true);
        const endTimestamp = (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
        // We need to add the timeout here to have the real endtimestamp of the idle span
        // Remember timestampInSeconds is in seconds, timeout is in ms
        _restartChildSpanTimeout(endTimestamp + childSpanTimeout / 1000);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ function _popActivity(spanId) {
        if (activities.has(spanId)) activities.delete(spanId);
        if (activities.size === 0) {
            const endTimestamp = (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
            // We need to add the timeout here to have the real endtimestamp of the idle span
            // Remember timestampInSeconds is in seconds, timeout is in ms
            _restartIdleTimeout(endTimestamp + idleTimeout / 1000);
        }
    }
    function onIdleSpanEnded() {
        _finished = true;
        activities.clear();
        if (beforeSpanEnd) beforeSpanEnd(span);
        (0, $155d912cac8f959f$export$3f25fa50c18e20ca)(scope, previousActiveSpan);
        const spanJSON = (0, $03e63b69c89faacb$export$92d8c23565496537)(span);
        const { timestamp: endTimestamp, start_timestamp: startTimestamp } = spanJSON;
        // This should never happen, but to make TS happy...
        if (!endTimestamp || !startTimestamp) return;
        const attributes = spanJSON.data || {};
        if (!attributes[0, $6dba76bc75a85eae$export$ba73f34502b7a3b3]) span.setAttribute((0, $6dba76bc75a85eae$export$ba73f34502b7a3b3), _finishReason);
        (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Idle span "${spanJSON.op}" finished`);
        const childSpans = (0, $03e63b69c89faacb$export$340c5c8a13ffc680)(span).filter((child)=>child !== span);
        let discardedSpans = 0;
        childSpans.forEach((childSpan)=>{
            // We cancel all pending spans with status "cancelled" to indicate the idle span was finished early
            if (childSpan.isRecording()) {
                childSpan.setStatus({
                    code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
                    message: 'cancelled'
                });
                childSpan.end(endTimestamp);
                (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Cancelling span since span ended early', JSON.stringify(childSpan, undefined, 2));
            }
            const childSpanJSON = (0, $03e63b69c89faacb$export$92d8c23565496537)(childSpan);
            const { timestamp: childEndTimestamp = 0, start_timestamp: childStartTimestamp = 0 } = childSpanJSON;
            const spanStartedBeforeIdleSpanEnd = childStartTimestamp <= endTimestamp;
            // Add a delta with idle timeout so that we prevent false positives
            const timeoutWithMarginOfError = (finalTimeout + idleTimeout) / 1000;
            const spanEndedBeforeFinalTimeout = childEndTimestamp - childStartTimestamp < timeoutWithMarginOfError;
            if (0, $506311a3b441d72b$export$16a28057038b10ef) {
                const stringifiedSpan = JSON.stringify(childSpan, undefined, 2);
                if (!spanStartedBeforeIdleSpanEnd) (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Discarding span since it happened after idle span was finished', stringifiedSpan);
                else if (!spanEndedBeforeFinalTimeout) (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Discarding span since it finished after idle span final timeout', stringifiedSpan);
            }
            if (!spanEndedBeforeFinalTimeout || !spanStartedBeforeIdleSpanEnd) {
                (0, $03e63b69c89faacb$export$c2a0c9438bb89d91)(span, childSpan);
                discardedSpans++;
            }
        });
        if (discardedSpans > 0) span.setAttribute('sentry.idle_span_discarded_spans', discardedSpans);
    }
    client.on('spanStart', (startedSpan)=>{
        // If we already finished the idle span,
        // or if this is the idle span itself being started,
        // or if the started span has already been closed,
        // we don't care about it for activity
        if (_finished || startedSpan === span || !!(0, $03e63b69c89faacb$export$92d8c23565496537)(startedSpan).timestamp) return;
        const allSpans = (0, $03e63b69c89faacb$export$340c5c8a13ffc680)(span);
        // If the span that was just started is a child of the idle span, we should track it
        if (allSpans.includes(startedSpan)) _pushActivity(startedSpan.spanContext().spanId);
    });
    client.on('spanEnd', (endedSpan)=>{
        if (_finished) return;
        _popActivity(endedSpan.spanContext().spanId);
        if (endedSpan === span) onIdleSpanEnded();
    });
    client.on('idleSpanEnableAutoFinish', (spanToAllowAutoFinish)=>{
        if (spanToAllowAutoFinish === span) {
            _autoFinishAllowed = true;
            _restartIdleTimeout();
            if (activities.size) _restartChildSpanTimeout();
        }
    });
    // We only start the initial idle timeout if we are not delaying the auto finish
    if (!options.disableAutoFinish) _restartIdleTimeout();
    setTimeout(()=>{
        if (!_finished) {
            span.setStatus({
                code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
                message: 'deadline_exceeded'
            });
            _finishReason = $e214634349264c97$var$FINISH_REASON_FINAL_TIMEOUT;
            _endSpan();
        }
    }, finalTimeout);
    return span;
}
function $e214634349264c97$var$_startIdleSpan(options) {
    const span = (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)(options);
    (0, $155d912cac8f959f$export$3f25fa50c18e20ca)((0, $971e6b058109b0a9$export$c7be4b0125a10cba)(), span);
    (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Tracing] Started span is an idle span');
    return span;
}



/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $022a7c71c0c5d1e4$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;











/* eslint-disable @typescript-eslint/explicit-function-return-type */ /* eslint-disable @typescript-eslint/no-explicit-any */ /** SyncPromise internal states */ var $82b0c6d0fe80f282$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($82b0c6d0fe80f282$var$States || ($82b0c6d0fe80f282$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $82b0c6d0fe80f282$export$1fda8aa4d135f8aa(value) {
    return new $82b0c6d0fe80f282$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $82b0c6d0fe80f282$export$78e43115b553f358(reason) {
    return new $82b0c6d0fe80f282$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $82b0c6d0fe80f282$export$6f292d4960313241 {
    constructor(executor){
        $82b0c6d0fe80f282$export$6f292d4960313241.prototype.__init.call(this);
        $82b0c6d0fe80f282$export$6f292d4960313241.prototype.__init2.call(this);
        $82b0c6d0fe80f282$export$6f292d4960313241.prototype.__init3.call(this);
        $82b0c6d0fe80f282$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $82b0c6d0fe80f282$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $82b0c6d0fe80f282$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $82b0c6d0fe80f282$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($82b0c6d0fe80f282$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($82b0c6d0fe80f282$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $82b0c6d0fe80f282$var$States.PENDING) return;
            if ((0, $626eb84a64d84c41$export$f5b060c2914b97c8)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $82b0c6d0fe80f282$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $82b0c6d0fe80f282$var$States.RESOLVED) handler[1](this._value);
                if (this._state === $82b0c6d0fe80f282$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}



/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $4b1adc543cc61d41$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $82b0c6d0fe80f282$export$6f292d4960313241)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $506311a3b441d72b$export$16a28057038b10ef) && processor.id && result === null && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $626eb84a64d84c41$export$f5b060c2914b97c8)(result)) result.then((final)=>$4b1adc543cc61d41$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $4b1adc543cc61d41$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}






/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $b97aa954e6193d69$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $b97aa954e6193d69$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $b97aa954e6193d69$var$applySpanToEvent(event, span);
    $b97aa954e6193d69$var$applyFingerprintToEvent(event, fingerprint);
    $b97aa954e6193d69$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $b97aa954e6193d69$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $b97aa954e6193d69$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: transactionName, span: span } = mergeData;
    $b97aa954e6193d69$export$b1a120a2871faa46(data, 'extra', extra);
    $b97aa954e6193d69$export$b1a120a2871faa46(data, 'tags', tags);
    $b97aa954e6193d69$export$b1a120a2871faa46(data, 'user', user);
    $b97aa954e6193d69$export$b1a120a2871faa46(data, 'contexts', contexts);
    $b97aa954e6193d69$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $b97aa954e6193d69$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $b97aa954e6193d69$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: transactionName } = data;
    const cleanedExtra = (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    // transaction events get their `transaction` from the root span name
    if (transactionName && event.type !== 'transaction') event.transaction = transactionName;
}
function $b97aa954e6193d69$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $b97aa954e6193d69$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $b97aa954e6193d69$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $03e63b69c89faacb$export$46c6fbd1d265ebf0)(span),
        ...event.contexts
    };
    event.sdkProcessingMetadata = {
        dynamicSamplingContext: (0, $2ef70689737a8a61$export$a117f995597e25df)(span),
        ...event.sdkProcessingMetadata
    };
    const rootSpan = (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(span);
    const transactionName = (0, $03e63b69c89faacb$export$92d8c23565496537)(rootSpan).description;
    if (transactionName && !event.transaction && event.type === 'transaction') event.transaction = transactionName;
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $b97aa954e6193d69$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $523c16f3b9d02706$export$3131421a7d01b4fb)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}


/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $713290f45d0c41ce$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
        timestamp: event.timestamp || (0, $8f221861fb4a2bd8$export$7740643b9eeaf0c4)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $713290f45d0c41ce$var$applyClientOptions(prepared, options);
    $713290f45d0c41ce$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $713290f45d0c41ce$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $713290f45d0c41ce$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $523c16f3b9d02706$export$c69a9a0313b03bb1)(prepared, hint.mechanism);
    const clientEventProcessors = client ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $971e6b058109b0a9$export$aa55d5ab8e05984f)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $b97aa954e6193d69$export$25ac7e259a513db4)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $b97aa954e6193d69$export$25ac7e259a513db4)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $b97aa954e6193d69$export$43988bc651a80216)(prepared, data);
    const eventProcessors = [
        ...clientEventProcessors,
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $4b1adc543cc61d41$export$bf2a096c3e883e79)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $713290f45d0c41ce$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $713290f45d0c41ce$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $713290f45d0c41ce$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $350ccf6f22fb6637$export$849dbeeeda01ae98);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $6c98f0cd61ae7fe0$export$6a506b36fdea397d)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $6c98f0cd61ae7fe0$export$6a506b36fdea397d)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $6c98f0cd61ae7fe0$export$6a506b36fdea397d)(request.url, maxValueLength);
}
const $713290f45d0c41ce$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $713290f45d0c41ce$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $713290f45d0c41ce$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $713290f45d0c41ce$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $713290f45d0c41ce$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $713290f45d0c41ce$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $713290f45d0c41ce$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $8bc2e4fa750aec36$export$a3295358bff77e)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $8bc2e4fa750aec36$export$a3295358bff77e)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $8bc2e4fa750aec36$export$a3295358bff77e)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $8bc2e4fa750aec36$export$a3295358bff77e)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $8bc2e4fa750aec36$export$a3295358bff77e)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        return {
            ...span,
            ...span.data && {
                data: (0, $8bc2e4fa750aec36$export$a3295358bff77e)(span.data, depth, maxBreadth)
            }
        };
    });
    return normalized;
}
function $713290f45d0c41ce$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $fa9a88ae27530aed$export$775b6bb06e53a214)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $713290f45d0c41ce$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($713290f45d0c41ce$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($713290f45d0c41ce$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $713290f45d0c41ce$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $fa9a88ae27530aed$export$775b6bb06e53a214) || typeof hint === 'function';
}
const $713290f45d0c41ce$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $713290f45d0c41ce$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$713290f45d0c41ce$var$captureContextKeys.includes(key));
}


/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $6e2d7e6efd34a5e4$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    return (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().captureException(exception, (0, $713290f45d0c41ce$export$76b5f966996d1653)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $6e2d7e6efd34a5e4$export$45654777c133ae80(message, captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    return (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $6e2d7e6efd34a5e4$export$1462b974fdcf6ba2(event, hint) {
    return (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().captureEvent(event, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $6e2d7e6efd34a5e4$export$2f04de43fe27971a(name, context) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ function $6e2d7e6efd34a5e4$export$bb4922da0dd51b92(extras) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ function $6e2d7e6efd34a5e4$export$8e8e7789d42ed61d(key, extra) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ function $6e2d7e6efd34a5e4$export$74a8fb34822092e6(tags) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ function $6e2d7e6efd34a5e4$export$a37d07ee78eb4569(key, value) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ function $6e2d7e6efd34a5e4$export$8b6bb3dd62a01be2(user) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setUser(user);
}
/**
 * The last error event id of the isolation scope.
 *
 * Warning: This function really returns the last recorded error event id on the current
 * isolation scope. If you call this function after handling a certain error and another error
 * is captured in between, the last one is returned instead of the one you might expect.
 * Also, ids of events that were never sent to Sentry (for example because
 * they were dropped in `beforeSend`) could be returned.
 *
 * @returns The last event id of the isolation scope.
 */ function $6e2d7e6efd34a5e4$export$5d4e9fd7fac8e617() {
    return (0, $971e6b058109b0a9$export$68f3af03034c9e90)().lastEventId();
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $6e2d7e6efd34a5e4$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (!client) (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $523c16f3b9d02706$export$19f53698e68b2496)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $6e2d7e6efd34a5e4$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $6e2d7e6efd34a5e4$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)();
    function finishCheckIn(status) {
        $6e2d7e6efd34a5e4$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() - now
        });
    }
    return (0, $971e6b058109b0a9$export$9a4fed82c350c2bd)(()=>{
        let maybePromiseResult;
        try {
            maybePromiseResult = callback();
        } catch (e) {
            finishCheckIn('error');
            throw e;
        }
        if ((0, $626eb84a64d84c41$export$f5b060c2914b97c8)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
            finishCheckIn('ok');
        }, ()=>{
            finishCheckIn('error');
        });
        else finishCheckIn('ok');
        return maybePromiseResult;
    });
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $6e2d7e6efd34a5e4$export$4909b86c8034bf73(timeout) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (client) return client.flush(timeout);
    (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $6e2d7e6efd34a5e4$export$8360e631d277ea4d(timeout) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (client) return client.close(timeout);
    (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $6e2d7e6efd34a5e4$export$3f95c6f800b78024() {
    return !!(0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
}
/** If the SDK is initialized & enabled. */ function $6e2d7e6efd34a5e4$export$3b029eb57ac4d562() {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    return !!client && client.getOptions().enabled !== false && !!client.getTransport();
}
/**
 * Add an event processor.
 * This will be added to the current isolation scope, ensuring any event that is processed in the current execution
 * context will have the processor applied.
 */ function $6e2d7e6efd34a5e4$export$9aac0b9f77928fbf(callback) {
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().addEventProcessor(callback);
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $6e2d7e6efd34a5e4$export$c0d84948cecf78d8(context) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    const currentScope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const { release: release, environment: environment = (0, $350ccf6f22fb6637$export$849dbeeeda01ae98) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).navigator || {};
    const session = (0, $e5d156d85c4b77f8$export$14a186326edbb264)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $e5d156d85c4b77f8$export$531818e825e774db)(currentSession, {
        status: 'exited'
    });
    $6e2d7e6efd34a5e4$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $6e2d7e6efd34a5e4$export$17a5be43989a0bc1() {
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    const currentScope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $e5d156d85c4b77f8$export$56521d9ba90f62ee)(session);
    $6e2d7e6efd34a5e4$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $6e2d7e6efd34a5e4$var$_sendSessionUpdate() {
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    const currentScope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $6e2d7e6efd34a5e4$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $6e2d7e6efd34a5e4$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $6e2d7e6efd34a5e4$var$_sendSessionUpdate();
}



const $d77304d140466795$export$56d8a8a25bd48b81 = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
let $d77304d140466795$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $d77304d140466795$export$b79738ab10c590b2() {
    return $d77304d140466795$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $d77304d140466795$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $d77304d140466795$var$ignoreOnError++;
    setTimeout(()=>{
        $d77304d140466795$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $d77304d140466795$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $68dbcfd11e00a6d4$export$e6cc1e135e2092e5)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$d77304d140466795$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $d77304d140466795$export$1265a142ff5ba165();
            (0, $971e6b058109b0a9$export$ec58d9285c204497)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $523c16f3b9d02706$export$f26508487bf83ee7)(event, undefined, undefined);
                        (0, $523c16f3b9d02706$export$c69a9a0313b03bb1)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $6e2d7e6efd34a5e4$export$f5282963edea4a68)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $68dbcfd11e00a6d4$export$5c1499e2e5d010ae)(sentryWrapped, fn);
    (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}






/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $4af94d17c221f1a5$export$6f18f55521af71a1() {
    if ((0, $d77304d140466795$export$56d8a8a25bd48b81) && (0, $d77304d140466795$export$56d8a8a25bd48b81).document) (0, $d77304d140466795$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
        const activeSpan = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
        if (!activeSpan) return;
        const rootSpan = (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(activeSpan);
        if ((0, $d77304d140466795$export$56d8a8a25bd48b81).document.hidden && rootSpan) {
            const cancelledStatus = 'cancelled';
            const { op: op, status: status } = (0, $03e63b69c89faacb$export$92d8c23565496537)(rootSpan);
            if (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Transaction: ${cancelledStatus} -> since tab moved to the background, op: ${op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!status) rootSpan.setStatus({
                code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
                message: cancelledStatus
            });
            rootSpan.setAttribute('sentry.cancellation_reason', 'document.hidden');
            rootSpan.end();
        }
    });
    else (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}




const $13a4c7cbade0edcd$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $13a4c7cbade0edcd$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $13a4c7cbade0edcd$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $13a4c7cbade0edcd$export$c67d533bf77cbf54() {
    if (!(0, $2e0ad70334800584$export$56d8a8a25bd48b81).XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() * 1000;
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $626eb84a64d84c41$export$844ec244b1367d54)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $13a4c7cbade0edcd$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$13a4c7cbade0edcd$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$13a4c7cbade0edcd$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        endTimestamp: (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() * 1000,
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $fb3c91b0664aac42$export$b18c893e424d3127)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$13a4c7cbade0edcd$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $626eb84a64d84c41$export$844ec244b1367d54)(header) && (0, $626eb84a64d84c41$export$844ec244b1367d54)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$13a4c7cbade0edcd$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                startTimestamp: (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() * 1000,
                xhr: this
            };
            (0, $fb3c91b0664aac42$export$b18c893e424d3127)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $13a4c7cbade0edcd$var$parseUrl(url) {
    if ((0, $626eb84a64d84c41$export$844ec244b1367d54)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}













/**
 * Create and track fetch request spans for usage in combination with `addFetchInstrumentationHandler`.
 *
 * @returns Span if a span was created, otherwise void.
 */ function $6416608ba8047163$export$6d73c62358c655be(handlerData, shouldCreateSpan, shouldAttachHeaders, spans, spanOrigin = 'auto.http.browser') {
    if (!handlerData.fetchData) return undefined;
    const shouldCreateSpanResult = (0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)() && shouldCreateSpan(handlerData.fetchData.url);
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            $6416608ba8047163$var$endSpan(span, handlerData);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const { method: method, url: url } = handlerData.fetchData;
    const fullUrl = $6416608ba8047163$var$getFullURL(url);
    const host = fullUrl ? (0, $cdc4578f23641df3$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)({
        name: `${method} ${url}`,
        attributes: {
            url: url,
            type: 'fetch',
            'http.method': method,
            'http.url': fullUrl,
            'server.address': host,
            [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: spanOrigin,
            [(0, $6dba76bc75a85eae$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)();
    handlerData.fetchData.__span = span.spanContext().spanId;
    spans[span.spanContext().spanId] = span;
    if (shouldAttachHeaders(handlerData.fetchData.url) && client) {
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        options.headers = $6416608ba8047163$export$6717acf674206871(request, client, scope, options, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
        // we do not want to use the span as base for the trace headers,
        // which means that the headers will be generated from the scope and the sampling decision is deferred
        (0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    }
    return span;
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $6416608ba8047163$export$6717acf674206871(request, client, scope, options, span) {
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span ? (0, $03e63b69c89faacb$export$7e9f8ae9e4a328ab)(span) : (0, $2d400f23bf5d035c$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $e464efef87fcab6d$export$56766feef403f365)(dsc || (span ? (0, $2ef70689737a8a61$export$a117f995597e25df)(span) : (0, $2ef70689737a8a61$export$366bad00d6815eed)(traceId, client)));
    const headers = options.headers || (typeof Request !== 'undefined' && (0, $626eb84a64d84c41$export$49034edbe6b62415)(request, Request) ? request.headers : undefined);
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $626eb84a64d84c41$export$49034edbe6b62415)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $e464efef87fcab6d$export$9ca9946bd449ac06), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $e464efef87fcab6d$export$9ca9946bd449ac06),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
function $6416608ba8047163$var$getFullURL(url) {
    try {
        const parsed = new URL(url);
        return parsed.href;
    } catch (e) {
        return undefined;
    }
}
function $6416608ba8047163$var$endSpan(span, handlerData) {
    if (handlerData.response) {
        (0, $f285b1ffba08f8b7$export$2ad6630ec8164254)(span, handlerData.response.status);
        const contentLength = handlerData.response && handlerData.response.headers && handlerData.response.headers.get('content-length');
        if (contentLength) {
            const contentLengthNum = parseInt(contentLength);
            if (contentLengthNum > 0) span.setAttribute('http.response_content_length', contentLengthNum);
        }
    } else if (handlerData.error) span.setStatus({
        code: (0, $f285b1ffba08f8b7$export$f966a0446ece71e),
        message: 'internal_error'
    });
    span.end();
}






const $5cfa7c881be62025$var$WINDOW = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $5cfa7c881be62025$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $5cfa7c881be62025$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $5cfa7c881be62025$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $5cfa7c881be62025$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $5cfa7c881be62025$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNative checks if the given function is a native implementation
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5cfa7c881be62025$export$d5f608b368e73f38(func) {
    return func && /^function\s+\w+\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $5cfa7c881be62025$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$5cfa7c881be62025$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($5cfa7c881be62025$export$d5f608b368e73f38($5cfa7c881be62025$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $5cfa7c881be62025$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $5cfa7c881be62025$export$d5f608b368e73f38(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $1d4627fd04ff26b2$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $5cfa7c881be62025$export$531055a6c684a70a() {
    return 'ReportingObserver' in $5cfa7c881be62025$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $5cfa7c881be62025$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$5cfa7c881be62025$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}





/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $c1946177a63e182a$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $c1946177a63e182a$var$instrumentFetch);
}
function $c1946177a63e182a$var$instrumentFetch() {
    if (!(0, $5cfa7c881be62025$export$c82d238e23c40b21)()) return;
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $c1946177a63e182a$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() * 1000
            };
            (0, $fb3c91b0664aac42$export$b18c893e424d3127)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() * 1000,
                    response: response
                };
                (0, $fb3c91b0664aac42$export$b18c893e424d3127)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: (0, $8f221861fb4a2bd8$export$ee52dced521e3e18)() * 1000,
                    error: error
                };
                (0, $fb3c91b0664aac42$export$b18c893e424d3127)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $c1946177a63e182a$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $c1946177a63e182a$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($c1946177a63e182a$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $c1946177a63e182a$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $c1946177a63e182a$var$getUrlFromResource(url),
            method: $c1946177a63e182a$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $c1946177a63e182a$var$getUrlFromResource(arg),
        method: $c1946177a63e182a$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}



/** Options for Request Instrumentation */ const $b3c3143ff373ca41$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    enableHTTPTimings: true
};
/** Registers span creators for xhr and fetch requests  */ function $b3c3143ff373ca41$export$864489cb3478db3e(_options) {
    const { traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, tracePropagationTargets: tracePropagationTargets } = {
        traceFetch: $b3c3143ff373ca41$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $b3c3143ff373ca41$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    const shouldAttachHeadersWithTargets = (url)=>$b3c3143ff373ca41$export$c260386ab3f0b3dd(url, tracePropagationTargets);
    const spans = {};
    if (traceFetch) (0, $c1946177a63e182a$export$f75d3c772c923df0)((handlerData)=>{
        const createdSpan = (0, $6416608ba8047163$export$6d73c62358c655be)(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        // We cannot use `window.location` in the generic fetch instrumentation,
        // but we need it for reliable `server.address` attribute.
        // so we extend this in here
        if (createdSpan) {
            const fullUrl = $b3c3143ff373ca41$var$getFullURL(handlerData.fetchData.url);
            const host = fullUrl ? (0, $cdc4578f23641df3$export$7a5253c0f62e0150)(fullUrl).host : undefined;
            createdSpan.setAttributes({
                'http.url': fullUrl,
                'server.address': host
            });
        }
        if (enableHTTPTimings && createdSpan) $b3c3143ff373ca41$var$addHTTPTimings(createdSpan);
    });
    if (traceXHR) (0, $13a4c7cbade0edcd$export$26ace48dd54c9aea)((handlerData)=>{
        const createdSpan = $b3c3143ff373ca41$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
        if (enableHTTPTimings && createdSpan) $b3c3143ff373ca41$var$addHTTPTimings(createdSpan);
    });
}
function $b3c3143ff373ca41$var$isPerformanceResourceTiming(entry) {
    return entry.entryType === 'resource' && 'initiatorType' in entry && typeof entry.nextHopProtocol === 'string' && (entry.initiatorType === 'fetch' || entry.initiatorType === 'xmlhttprequest');
}
/**
 * Creates a temporary observer to listen to the next fetch/xhr resourcing timings,
 * so that when timings hit their per-browser limit they don't need to be removed.
 *
 * @param span A span that has yet to be finished, must contain `url` on data.
 */ function $b3c3143ff373ca41$var$addHTTPTimings(span) {
    const { url: url } = (0, $03e63b69c89faacb$export$92d8c23565496537)(span).data || {};
    if (!url || typeof url !== 'string') return;
    const cleanup = (0, $4deab877b1f61f68$export$69816c1a049f8db6)('resource', ({ entries: entries })=>{
        entries.forEach((entry)=>{
            if ($b3c3143ff373ca41$var$isPerformanceResourceTiming(entry) && entry.name.endsWith(url)) {
                const spanData = $b3c3143ff373ca41$var$resourceTimingEntryToSpanData(entry);
                spanData.forEach((data)=>span.setAttribute(...data));
                // In the next tick, clean this handler up
                // We have to wait here because otherwise this cleans itself up before it is fully done
                setTimeout(cleanup);
            }
        });
    });
}
/**
 * Converts ALPN protocol ids to name and version.
 *
 * (https://www.iana.org/assignments/tls-extensiontype-values/tls-extensiontype-values.xhtml#alpn-protocol-ids)
 * @param nextHopProtocol PerformanceResourceTiming.nextHopProtocol
 */ function $b3c3143ff373ca41$export$57c6f824442f9fe1(nextHopProtocol) {
    let name = 'unknown';
    let version = 'unknown';
    let _name = '';
    for (const char of nextHopProtocol){
        // http/1.1 etc.
        if (char === '/') {
            [name, version] = nextHopProtocol.split('/');
            break;
        }
        // h2, h3 etc.
        if (!isNaN(Number(char))) {
            name = _name === 'h' ? 'http' : _name;
            version = nextHopProtocol.split(_name)[1];
            break;
        }
        _name += char;
    }
    if (_name === nextHopProtocol) // webrtc, ftp, etc.
    name = _name;
    return {
        name: name,
        version: version
    };
}
function $b3c3143ff373ca41$var$getAbsoluteTime(time = 0) {
    return (((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) || performance.timeOrigin) + time) / 1000;
}
function $b3c3143ff373ca41$var$resourceTimingEntryToSpanData(resourceTiming) {
    const { name: name, version: version } = $b3c3143ff373ca41$export$57c6f824442f9fe1(resourceTiming.nextHopProtocol);
    const timingSpanData = [];
    timingSpanData.push([
        'network.protocol.version',
        version
    ], [
        'network.protocol.name',
        name
    ]);
    if (!(0, $8f221861fb4a2bd8$export$baf075a948ffc0bf)) return timingSpanData;
    return [
        ...timingSpanData,
        [
            'http.request.redirect_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.redirectStart)
        ],
        [
            'http.request.fetch_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.fetchStart)
        ],
        [
            'http.request.domain_lookup_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.domainLookupStart)
        ],
        [
            'http.request.domain_lookup_end',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.domainLookupEnd)
        ],
        [
            'http.request.connect_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.connectStart)
        ],
        [
            'http.request.secure_connection_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.secureConnectionStart)
        ],
        [
            'http.request.connection_end',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.connectEnd)
        ],
        [
            'http.request.request_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.requestStart)
        ],
        [
            'http.request.response_start',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.responseStart)
        ],
        [
            'http.request.response_end',
            $b3c3143ff373ca41$var$getAbsoluteTime(resourceTiming.responseEnd)
        ]
    ];
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * We only export this function for testing purposes.
 */ function $b3c3143ff373ca41$export$c260386ab3f0b3dd(targetUrl, tracePropagationTargets) {
    // window.location.href not being defined is an edge case in the browser but we need to handle it.
    // Potentially dangerous situations where it may not be defined: Browser Extensions, Web Workers, patching of the location obj
    const href = (0, $d77304d140466795$export$56d8a8a25bd48b81).location && (0, $d77304d140466795$export$56d8a8a25bd48b81).location.href;
    if (!href) {
        // If there is no window.location.origin, we default to only attaching tracing headers to relative requests, i.e. ones that start with `/`
        // BIG DISCLAIMER: Users can call URLs with a double slash (fetch("//example.com/api")), this is a shorthand for "send to the same protocol",
        // so we need a to exclude those requests, because they might be cross origin.
        const isRelativeSameOriginRequest = !!targetUrl.match(/^\/(?!\/)/);
        if (!tracePropagationTargets) return isRelativeSameOriginRequest;
        else return (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(targetUrl, tracePropagationTargets);
    } else {
        let resolvedUrl;
        let currentOrigin;
        // URL parsing may fail, we default to not attaching trace headers in that case.
        try {
            resolvedUrl = new URL(targetUrl, href);
            currentOrigin = new URL(href).origin;
        } catch (e) {
            return false;
        }
        const isSameOriginRequest = resolvedUrl.origin === currentOrigin;
        if (!tracePropagationTargets) return isSameOriginRequest;
        else return (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(resolvedUrl.toString(), tracePropagationTargets) || isSameOriginRequest && (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(resolvedUrl.pathname, tracePropagationTargets);
    }
}
/**
 * Create and track xhr request spans
 *
 * @returns Span if a span was created, otherwise void.
 */ function $b3c3143ff373ca41$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    const xhr = handlerData.xhr;
    const sentryXhrData = xhr && xhr[0, $13a4c7cbade0edcd$export$55b6bb1e45c6cf59];
    if (!xhr || xhr.__sentry_own_request__ || !sentryXhrData) return undefined;
    const shouldCreateSpanResult = (0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)() && shouldCreateSpan(sentryXhrData.url);
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp && shouldCreateSpanResult) {
        const spanId = xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span && sentryXhrData.status_code !== undefined) {
            (0, $f285b1ffba08f8b7$export$2ad6630ec8164254)(span, sentryXhrData.status_code);
            span.end();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return undefined;
    }
    const fullUrl = $b3c3143ff373ca41$var$getFullURL(sentryXhrData.url);
    const host = fullUrl ? (0, $cdc4578f23641df3$export$7a5253c0f62e0150)(fullUrl).host : undefined;
    const hasParent = !!(0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const span = shouldCreateSpanResult && hasParent ? (0, $5b8e5c42bcba91ae$export$63dbba021a6b4047)({
        name: `${sentryXhrData.method} ${sentryXhrData.url}`,
        attributes: {
            type: 'xhr',
            'http.method': sentryXhrData.method,
            'http.url': fullUrl,
            url: sentryXhrData.url,
            'server.address': host,
            [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.http.browser',
            [(0, $6dba76bc75a85eae$export$1a413bd9a88fdb09)]: 'http.client'
        }
    }) : new (0, $f2c4b4b1de41c7b2$export$d6636b700b76c516)();
    xhr.__sentry_xhr_span_id__ = span.spanContext().spanId;
    spans[xhr.__sentry_xhr_span_id__] = span;
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (xhr.setRequestHeader && shouldAttachHeaders(sentryXhrData.url) && client) $b3c3143ff373ca41$var$addTracingHeadersToXhrRequest(xhr, client, // If performance is disabled (TWP) or there's no active root span (pageload/navigation/interaction),
    // we do not want to use the span as base for the trace headers,
    // which means that the headers will be generated from the scope and the sampling decision is deferred
    (0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)() && hasParent ? span : undefined);
    return span;
}
function $b3c3143ff373ca41$var$addTracingHeadersToXhrRequest(xhr, client, span) {
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    const { traceId: traceId, spanId: spanId, sampled: sampled, dsc: dsc } = {
        ...isolationScope.getPropagationContext(),
        ...scope.getPropagationContext()
    };
    const sentryTraceHeader = span && (0, $f6a9d6f8ff505d4a$export$5008da00b1b6dee6)() ? (0, $03e63b69c89faacb$export$7e9f8ae9e4a328ab)(span) : (0, $2d400f23bf5d035c$export$f35d907436da45cf)(traceId, spanId, sampled);
    const sentryBaggageHeader = (0, $e464efef87fcab6d$export$56766feef403f365)(dsc || (span ? (0, $2ef70689737a8a61$export$a117f995597e25df)(span) : (0, $2ef70689737a8a61$export$366bad00d6815eed)(traceId, client)));
    $b3c3143ff373ca41$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader);
}
function $b3c3143ff373ca41$var$setHeaderOnXhr(xhr, sentryTraceHeader, sentryBaggageHeader) {
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
        // We can therefore simply set a baggage header without checking what was there before
        // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        xhr.setRequestHeader((0, $e464efef87fcab6d$export$9ca9946bd449ac06), sentryBaggageHeader);
    } catch (_) {
    // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
    }
}
function $b3c3143ff373ca41$var$getFullURL(url) {
    try {
        // By adding a base URL to new URL(), this will also work for relative urls
        // If `url` is a full URL, the base URL is ignored anyhow
        const parsed = new URL(url, (0, $d77304d140466795$export$56d8a8a25bd48b81).location.origin);
        return parsed.href;
    } catch (e2) {
        return undefined;
    }
}


/* eslint-disable max-lines */ const $390327a76f6922be$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $390327a76f6922be$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $e214634349264c97$export$809a2b7987fd5306),
    instrumentNavigation: true,
    instrumentPageLoad: true,
    markBackgroundSpan: true,
    enableLongTask: true,
    enableInp: true,
    _experiments: {},
    ...(0, $b3c3143ff373ca41$export$cc17fb3c0bc95cd7)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library.
 *
 * We explicitly export the proper type here, as this has to be extended in some cases.
 */ const $390327a76f6922be$export$b4109253475213e9 = (_options = {})=>{
    (0, $468f4d4bc2365d55$export$b0914730ee1f6c80)();
    const { enableInp: enableInp, enableLongTask: enableLongTask, _experiments: { enableInteractions: enableInteractions }, beforeStartSpan: beforeStartSpan, idleTimeout: idleTimeout, finalTimeout: finalTimeout, childSpanTimeout: childSpanTimeout, markBackgroundSpan: markBackgroundSpan, traceFetch: traceFetch, traceXHR: traceXHR, shouldCreateSpanForRequest: shouldCreateSpanForRequest, enableHTTPTimings: enableHTTPTimings, instrumentPageLoad: instrumentPageLoad, instrumentNavigation: instrumentNavigation } = {
        ...$390327a76f6922be$var$DEFAULT_BROWSER_TRACING_OPTIONS,
        ..._options
    };
    const _collectWebVitals = (0, $63120a631dceb004$export$7c69f0412d101b88)();
    if (enableInp) (0, $a4dca2da4a8e6254$export$f17d06681a4744a3)();
    if (enableLongTask) (0, $63120a631dceb004$export$f396d19077034ad2)();
    if (enableInteractions) (0, $63120a631dceb004$export$e27543e0976315e4)();
    const latestRoute = {
        name: undefined,
        source: undefined
    };
    /** Create routing idle transaction. */ function _createRouteSpan(client, startSpanOptions) {
        const isPageloadTransaction = startSpanOptions.op === 'pageload';
        const finalStartSpanOptions = beforeStartSpan ? beforeStartSpan(startSpanOptions) : startSpanOptions;
        const attributes = finalStartSpanOptions.attributes || {};
        // If `finalStartSpanOptions.name` is different than `startSpanOptions.name`
        // it is because `beforeStartSpan` set a custom name. Therefore we set the source to 'custom'.
        if (startSpanOptions.name !== finalStartSpanOptions.name) {
            attributes[0, $6dba76bc75a85eae$export$d7a7d984b0791405] = 'custom';
            finalStartSpanOptions.attributes = attributes;
        }
        latestRoute.name = finalStartSpanOptions.name;
        latestRoute.source = attributes[0, $6dba76bc75a85eae$export$d7a7d984b0791405];
        const idleSpan = (0, $e214634349264c97$export$901bffd97bd52797)(finalStartSpanOptions, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout,
            // should wait for finish signal if it's a pageload transaction
            disableAutoFinish: isPageloadTransaction,
            beforeSpanEnd: (span)=>{
                _collectWebVitals();
                (0, $63120a631dceb004$export$5f8fa6b3467a7443)(span);
            }
        });
        function emitFinish() {
            if ([
                'interactive',
                'complete'
            ].includes((0, $d77304d140466795$export$56d8a8a25bd48b81).document.readyState)) client.emit('idleSpanEnableAutoFinish', idleSpan);
        }
        if (isPageloadTransaction && (0, $d77304d140466795$export$56d8a8a25bd48b81).document) {
            (0, $d77304d140466795$export$56d8a8a25bd48b81).document.addEventListener('readystatechange', ()=>{
                emitFinish();
            });
            emitFinish();
        }
        return idleSpan;
    }
    return {
        name: $390327a76f6922be$export$bbd2089f30bd3708,
        afterAllSetup (client) {
            let activeSpan;
            let startingUrl = (0, $d77304d140466795$export$56d8a8a25bd48b81).location && (0, $d77304d140466795$export$56d8a8a25bd48b81).location.href;
            client.on('startNavigationSpan', (startSpanOptions)=>{
                if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan) {
                    (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $03e63b69c89faacb$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                activeSpan = _createRouteSpan(client, {
                    op: 'navigation',
                    ...startSpanOptions
                });
            });
            client.on('startPageLoadSpan', (startSpanOptions, traceOptions = {})=>{
                if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
                if (activeSpan) {
                    (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`[Tracing] Finishing current root span with op: ${(0, $03e63b69c89faacb$export$92d8c23565496537)(activeSpan).op}`);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeSpan.end();
                }
                const sentryTrace = traceOptions.sentryTrace || $390327a76f6922be$export$f147b32b03c9cf11('sentry-trace');
                const baggage = traceOptions.baggage || $390327a76f6922be$export$f147b32b03c9cf11('baggage');
                const propagationContext = (0, $2d400f23bf5d035c$export$261f383d16a93e39)(sentryTrace, baggage);
                (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().setPropagationContext(propagationContext);
                activeSpan = _createRouteSpan(client, {
                    op: 'pageload',
                    ...startSpanOptions
                });
            });
            // A trace should to stay the consistent over the entire time span of one route.
            // Therefore, when the initial pageload or navigation root span ends, we update the
            // scope's propagation context to keep span-specific attributes like the `sampled` decision and
            // the dynamic sampling context valid, even after the root span has ended.
            // This ensures that the trace data is consistent for the entire duration of the route.
            client.on('spanEnd', (span)=>{
                const op = (0, $03e63b69c89faacb$export$92d8c23565496537)(span).op;
                if (span !== (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(span) || op !== 'navigation' && op !== 'pageload') return;
                const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
                const oldPropagationContext = scope.getPropagationContext();
                scope.setPropagationContext({
                    ...oldPropagationContext,
                    sampled: oldPropagationContext.sampled !== undefined ? oldPropagationContext.sampled : (0, $03e63b69c89faacb$export$5caecac1caaf3a71)(span),
                    dsc: oldPropagationContext.dsc || (0, $2ef70689737a8a61$export$a117f995597e25df)(span)
                });
            });
            if ((0, $d77304d140466795$export$56d8a8a25bd48b81).location) {
                if (instrumentPageLoad) $390327a76f6922be$export$aa44a07f82af519f(client, {
                    name: (0, $d77304d140466795$export$56d8a8a25bd48b81).location.pathname,
                    // pageload should always start at timeOrigin (and needs to be in s, not ms)
                    startTime: (0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) ? (0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) / 1000 : undefined,
                    attributes: {
                        [(0, $6dba76bc75a85eae$export$d7a7d984b0791405)]: 'url',
                        [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.pageload.browser'
                    }
                });
                if (instrumentNavigation) (0, $81fb4056224c2de0$export$3f18c56c58114e75)(({ to: to, from: from })=>{
                    /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                        startingUrl = undefined;
                        return;
                    }
                    if (from !== to) {
                        startingUrl = undefined;
                        $390327a76f6922be$export$7d159749bd9969ad(client, {
                            name: (0, $d77304d140466795$export$56d8a8a25bd48b81).location.pathname,
                            attributes: {
                                [(0, $6dba76bc75a85eae$export$d7a7d984b0791405)]: 'url',
                                [(0, $6dba76bc75a85eae$export$cca8dd30f57f805e)]: 'auto.navigation.browser'
                            }
                        });
                    }
                });
            }
            if (markBackgroundSpan) (0, $4af94d17c221f1a5$export$6f18f55521af71a1)();
            if (enableInteractions) $390327a76f6922be$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute);
            (0, $b3c3143ff373ca41$export$864489cb3478db3e)({
                traceFetch: traceFetch,
                traceXHR: traceXHR,
                tracePropagationTargets: client.getOptions().tracePropagationTargets,
                shouldCreateSpanForRequest: shouldCreateSpanForRequest,
                enableHTTPTimings: enableHTTPTimings
            });
        }
    };
};
/**
 * Manually start a page load span.
 * This will only do something if a browser tracing integration integration has been setup.
 *
 * If you provide a custom `traceOptions` object, it will be used to continue the trace
 * instead of the default behavior, which is to look it up on the <meta> tags.
 */ function $390327a76f6922be$export$aa44a07f82af519f(client, spanOptions, traceOptions) {
    client.emit('startPageLoadSpan', spanOptions, traceOptions);
    (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const op = span && (0, $03e63b69c89faacb$export$92d8c23565496537)(span).op;
    return op === 'pageload' ? span : undefined;
}
/**
 * Manually start a navigation span.
 * This will only do something if a browser tracing integration has been setup.
 */ function $390327a76f6922be$export$7d159749bd9969ad(client, spanOptions) {
    (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().setPropagationContext($390327a76f6922be$var$generatePropagationContext());
    (0, $971e6b058109b0a9$export$68f3af03034c9e90)().setPropagationContext($390327a76f6922be$var$generatePropagationContext());
    client.emit('startNavigationSpan', spanOptions);
    (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().setTransactionName(spanOptions.name);
    const span = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
    const op = span && (0, $03e63b69c89faacb$export$92d8c23565496537)(span).op;
    return op === 'navigation' ? span : undefined;
}
/** Returns the value of a meta tag */ function $390327a76f6922be$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $b076601639d1314e$export$c660c1f3ab49225c)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : undefined;
}
/** Start listener for interaction transactions */ function $390327a76f6922be$var$registerInteractionListener(idleTimeout, finalTimeout, childSpanTimeout, latestRoute) {
    let inflightInteractionSpan;
    const registerInteractionTransaction = ()=>{
        const op = 'ui.action.click';
        const activeSpan = (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
        const rootSpan = activeSpan && (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(activeSpan);
        if (rootSpan) {
            const currentRootSpanOp = (0, $03e63b69c89faacb$export$92d8c23565496537)(rootSpan).op;
            if ([
                'navigation',
                'pageload'
            ].includes(currentRootSpanOp)) {
                (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} span because a pageload or navigation span is in progress.`);
                return undefined;
            }
        }
        if (inflightInteractionSpan) {
            inflightInteractionSpan.setAttribute((0, $6dba76bc75a85eae$export$ba73f34502b7a3b3), 'interactionInterrupted');
            inflightInteractionSpan.end();
            inflightInteractionSpan = undefined;
        }
        if (!latestRoute.name) {
            (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
            return undefined;
        }
        inflightInteractionSpan = (0, $e214634349264c97$export$901bffd97bd52797)({
            name: latestRoute.name,
            op: op,
            attributes: {
                [(0, $6dba76bc75a85eae$export$d7a7d984b0791405)]: latestRoute.source || 'url'
            }
        }, {
            idleTimeout: idleTimeout,
            finalTimeout: finalTimeout,
            childSpanTimeout: childSpanTimeout
        });
    };
    if ((0, $d77304d140466795$export$56d8a8a25bd48b81).document) addEventListener('click', registerInteractionTransaction, {
        once: false,
        capture: true
    });
}
function $390327a76f6922be$var$generatePropagationContext() {
    return {
        traceId: (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
        spanId: (0, $523c16f3b9d02706$export$19f53698e68b2496)().substring(16)
    };
}





const $aee3a253844bd334$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $aee3a253844bd334$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $aee3a253844bd334$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $523c16f3b9d02706$export$3131421a7d01b4fb)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $aee3a253844bd334$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $aee3a253844bd334$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $aee3a253844bd334$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $aee3a253844bd334$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $aee3a253844bd334$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $aee3a253844bd334$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($aee3a253844bd334$export$b14a8888f80a0b3e.indexOf(integration.name) === -1 && typeof integration.setupOnce === 'function') {
        integration.setupOnce();
        $aee3a253844bd334$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $aee3a253844bd334$export$2d8f5188773bcddd(integration) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (!client) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $aee3a253844bd334$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $aee3a253844bd334$export$2323046b9414659f(fn) {
    return fn;
}



const $0ed0e5fb0e89d4b5$var$INTEGRATION_NAME = 'Dedupe';
const $0ed0e5fb0e89d4b5$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $0ed0e5fb0e89d4b5$var$INTEGRATION_NAME,
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($0ed0e5fb0e89d4b5$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
/**
 * Deduplication filter.
 */ const $0ed0e5fb0e89d4b5$export$6d39aa44cd0c7567 = (0, $aee3a253844bd334$export$2323046b9414659f)($0ed0e5fb0e89d4b5$var$_dedupeIntegration);
/** only exported for tests. */ function $0ed0e5fb0e89d4b5$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($0ed0e5fb0e89d4b5$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($0ed0e5fb0e89d4b5$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $0ed0e5fb0e89d4b5$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$0ed0e5fb0e89d4b5$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0ed0e5fb0e89d4b5$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $0ed0e5fb0e89d4b5$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $0ed0e5fb0e89d4b5$var$_getExceptionFromEvent(previousEvent);
    const currentException = $0ed0e5fb0e89d4b5$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$0ed0e5fb0e89d4b5$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$0ed0e5fb0e89d4b5$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $0ed0e5fb0e89d4b5$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $0ed0e5fb0e89d4b5$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $0ed0e5fb0e89d4b5$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $0ed0e5fb0e89d4b5$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $0ed0e5fb0e89d4b5$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $0ed0e5fb0e89d4b5$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}




let $ed19db1e0527512d$var$originalFunctionToString;
const $ed19db1e0527512d$var$INTEGRATION_NAME = 'FunctionToString';
const $ed19db1e0527512d$var$SETUP_CLIENTS = new WeakMap();
const $ed19db1e0527512d$var$_functionToStringIntegration = ()=>{
    return {
        name: $ed19db1e0527512d$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $ed19db1e0527512d$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $68dbcfd11e00a6d4$export$e6cc1e135e2092e5)(this);
                    const context = $ed19db1e0527512d$var$SETUP_CLIENTS.has((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)()) && originalFunction !== undefined ? originalFunction : this;
                    return $ed19db1e0527512d$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $ed19db1e0527512d$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $ed19db1e0527512d$export$7918117e9202e4fb = (0, $aee3a253844bd334$export$2323046b9414659f)($ed19db1e0527512d$var$_functionToStringIntegration);


const $959e07742905ebeb$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $959e07742905ebeb$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $959e07742905ebeb$var$_getIngestEndpoint(dsn) {
    return `${$959e07742905ebeb$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $959e07742905ebeb$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $68dbcfd11e00a6d4$export$9ef804feabbcbaf1)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $959e07742905ebeb$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $959e07742905ebeb$export$9964600bfe84e6a3(dsn, tunnel, sdkInfo) {
    return tunnel ? tunnel : `${$959e07742905ebeb$var$_getIngestEndpoint(dsn)}?${$959e07742905ebeb$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $959e07742905ebeb$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $465df9040833ef74$export$128827c3562ec0cb)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$959e07742905ebeb$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $465df9040833ef74$export$44d472fbb931a776)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}




// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $40df1ce1eb5ab4a4$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
/** Options for the InboundFilters integration */ const $40df1ce1eb5ab4a4$var$INTEGRATION_NAME = 'InboundFilters';
const $40df1ce1eb5ab4a4$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $40df1ce1eb5ab4a4$var$INTEGRATION_NAME,
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $40df1ce1eb5ab4a4$var$_mergeOptions(options, clientOptions);
            return $40df1ce1eb5ab4a4$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $40df1ce1eb5ab4a4$export$cb3c5c2ceb9818ba = (0, $aee3a253844bd334$export$2323046b9414659f)($40df1ce1eb5ab4a4$var$_inboundFiltersIntegration);
function $40df1ce1eb5ab4a4$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $40df1ce1eb5ab4a4$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || []
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $40df1ce1eb5ab4a4$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $40df1ce1eb5ab4a4$var$_isSentryError(event)) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $523c16f3b9d02706$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($40df1ce1eb5ab4a4$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $523c16f3b9d02706$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($40df1ce1eb5ab4a4$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $523c16f3b9d02706$export$4157119e2b157127)(event)}`);
        return true;
    }
    if ($40df1ce1eb5ab4a4$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $523c16f3b9d02706$export$4157119e2b157127)(event)}.\nUrl: ${$40df1ce1eb5ab4a4$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$40df1ce1eb5ab4a4$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $523c16f3b9d02706$export$4157119e2b157127)(event)}.\nUrl: ${$40df1ce1eb5ab4a4$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $40df1ce1eb5ab4a4$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $40df1ce1eb5ab4a4$var$_getPossibleEventMessages(event).some((message)=>(0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(message, ignoreErrors));
}
function $40df1ce1eb5ab4a4$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(name, ignoreTransactions) : false;
}
function $40df1ce1eb5ab4a4$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $40df1ce1eb5ab4a4$var$_getEventFilterUrl(event);
    return !url ? false : (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(url, denyUrls);
}
function $40df1ce1eb5ab4a4$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $40df1ce1eb5ab4a4$var$_getEventFilterUrl(event);
    return !url ? true : (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(url, allowUrls);
}
function $40df1ce1eb5ab4a4$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    return possibleMessages;
}
function $40df1ce1eb5ab4a4$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $40df1ce1eb5ab4a4$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $40df1ce1eb5ab4a4$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $40df1ce1eb5ab4a4$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(`Cannot extract url for event ${(0, $523c16f3b9d02706$export$4157119e2b157127)(event)}`);
        return null;
    }
}





/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $2da25d0c226965dc$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $506311a3b441d72b$export$16a28057038b10ef) (0, $117c8f31aa65bddd$export$af88d00dbe7f521).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $117c8f31aa65bddd$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $2da25d0c226965dc$export$ecb76f41d43c0e43(client);
    client.init();
}
/**
 * Make the given client the current client.
 */ function $2da25d0c226965dc$export$ecb76f41d43c0e43(client) {
    (0, $971e6b058109b0a9$export$c7be4b0125a10cba)().setClient(client);
    $2da25d0c226965dc$var$registerClientOnGlobalHub(client);
}
/**
 * Unfortunately, we still have to manually bind the client to the "hub" property set on the global
 * Sentry carrier object. This is because certain scripts (e.g. our loader script) obtain
 * the client via `window.__SENTRY__.hub.getClient()`.
 *
 * @see {@link ./asyncContext/stackStrategy.ts getAsyncContextStack}
 */ function $2da25d0c226965dc$var$registerClientOnGlobalHub(client) {
    const sentryGlobal = (0, $ee9f51b9ad47d1ec$export$c8bfa33e4e8ae492)((0, $ee9f51b9ad47d1ec$export$19eade501500c6c1)());
    if (sentryGlobal.hub && typeof sentryGlobal.hub.getStackTop === 'function') sentryGlobal.hub.getStackTop().client = client;
}




const $5d462813e11b010a$export$31499a9cd224b78c = '8.4.0';


/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $ae243f53bcfe9459$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $5d462813e11b010a$export$31499a9cd224b78c)
            })),
        version: (0, $5d462813e11b010a$export$31499a9cd224b78c)
    };
    options._metadata = metadata;
}

/** An error emitted by Sentry SDKs and related utilities. */ class $dada51e7b2168637$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}











const $545b62ffd46e436a$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $545b62ffd46e436a$export$4f22f74eddb7716a {
    /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $465df9040833ef74$export$128827c3562ec0cb)(options.dsn);
        else (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $959e07742905ebeb$export$9964600bfe84e6a3)(this._dsn, options.tunnel, options._metadata ? options._metadata.sdk : undefined);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    captureException(exception, hint, scope) {
        const eventId = (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if ((0, $523c16f3b9d02706$export$6de4ffac6a2f1098)(exception)) {
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log($545b62ffd46e436a$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        this._process(this.eventFromException(exception, hintWithEventId).then((event)=>this._captureEvent(event, hintWithEventId, scope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, level, hint, currentScope) {
        const hintWithEventId = {
            event_id: (0, $523c16f3b9d02706$export$19f53698e68b2496)(),
            ...hint
        };
        const eventMessage = (0, $626eb84a64d84c41$export$dbcbffa59149b824)(message) ? message : String(message);
        const promisedEvent = (0, $626eb84a64d84c41$export$c3825b437cbdea5c)(message) ? this.eventFromMessage(eventMessage, level, hintWithEventId) : this.eventFromException(message, hintWithEventId);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hintWithEventId, currentScope)));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, currentScope) {
        const eventId = (0, $523c16f3b9d02706$export$19f53698e68b2496)();
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $523c16f3b9d02706$export$6de4ffac6a2f1098)(hint.originalException)) {
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log($545b62ffd46e436a$var$ALREADY_SEEN_ERROR);
            return eventId;
        }
        const hintWithEventId = {
            event_id: eventId,
            ...hint
        };
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hintWithEventId, capturedSpanScope || currentScope));
        return hintWithEventId.event_id;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $e5d156d85c4b77f8$export$531818e825e774db)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            this.emit('flush');
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            this.emit('close');
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $aee3a253844bd334$export$e7390a03b70a6f2f)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $aee3a253844bd334$export$35abcfd71227c6ca)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $1e089ca26d9e0910$export$c31057337a18010f)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $70b99f77072cf559$export$d650323442802f6f)(env, (0, $70b99f77072cf559$export$d8fc80952cc31fa4)(attachment));
        const promise = this.sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $1e089ca26d9e0910$export$124b03c077baa2f3)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, _event) {
        // Note: we use `event` in replay, where we overwrite this hook.
        if (this._options.sendClientReports) {
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`Adding outcome: "${key}"`);
            // The following works because undefined + 1 === NaN and NaN is falsy
            this._outcomes[key] = this._outcomes[key] + 1 || 1;
        }
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /**
   * @inheritdoc
   */ sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('Error while sending event:', reason);
            return reason;
        });
        (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('Transport disabled');
        return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)({});
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $aee3a253844bd334$export$51abed9797baa598)(this, integrations);
        (0, $aee3a253844bd334$export$35abcfd71227c6ca)(this, integrations);
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $e5d156d85c4b77f8$export$531818e825e774db)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $82b0c6d0fe80f282$export$6f292d4960313241)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, currentScope, isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        if (!event.type) isolationScope.setLastEventId(event.event_id || hint.event_id);
        return (0, $713290f45d0c41ce$export$2d67fb380bd11267)(options, event, hint, currentScope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...currentScope ? currentScope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    }),
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $2ef70689737a8a61$export$366bad00d6815eed)(trace_id, this);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $506311a3b441d72b$export$16a28057038b10ef) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(sentryError.message);
                else (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param currentScope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, currentScope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $545b62ffd46e436a$var$isTransactionEvent(event);
        const isError = $545b62ffd46e436a$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        const parsedSampleRate = typeof sampleRate === 'undefined' ? undefined : (0, $0bb8cfda553273b7$export$a5bd2d81656d9546)(sampleRate);
        if (isError && typeof parsedSampleRate === 'number' && Math.random() > parsedSampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $82b0c6d0fe80f282$export$78e43115b553f358)(new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, currentScope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $545b62ffd46e436a$var$processBeforeSend(options, prepared, hint);
            return $545b62ffd46e436a$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                throw new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = currentScope && currentScope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $dada51e7b2168637$export$5949942ba2a7c0e2)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $545b62ffd46e436a$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $626eb84a64d84c41$export$f5b060c2914b97c8)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $626eb84a64d84c41$export$53b83ca8eaab0383)(event) && event !== null) throw new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $626eb84a64d84c41$export$53b83ca8eaab0383)(beforeSendResult) && beforeSendResult !== null) throw new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $545b62ffd46e436a$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction, beforeSendSpan: beforeSendSpan } = options;
    if ($545b62ffd46e436a$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($545b62ffd46e436a$var$isTransactionEvent(event)) {
        if (event.spans && beforeSendSpan) {
            const processedSpans = [];
            for (const span of event.spans){
                const processedSpan = beforeSendSpan(span);
                if (processedSpan) processedSpans.push(processedSpan);
            }
            event.spans = processedSpans;
        }
        if (beforeSendTransaction) return beforeSendTransaction(event, hint);
    }
    return event;
}
function $545b62ffd46e436a$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $545b62ffd46e436a$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}




/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $9af9573e0ba8bc4b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $8f221861fb4a2bd8$export$7740643b9eeaf0c4)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $70b99f77072cf559$export$f93f7f385160c44e)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}


var $b8WCc = parcelRequire("b8WCc");



/**
 * This function creates an exception from a JavaScript Error
 */ function $09e4832cb98fb9cd$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $09e4832cb98fb9cd$var$parseStackFrames(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $09e4832cb98fb9cd$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
function $09e4832cb98fb9cd$var$eventFromPlainObject(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    // If we can, we extract an exception from the object properties
    const errorFromProp = $09e4832cb98fb9cd$var$getErrorPropertyFromObject(exception);
    const extra = {
        __serialized__: (0, $8bc2e4fa750aec36$export$23fbbb20bed71033)(exception, normalizeDepth)
    };
    if (errorFromProp) return {
        exception: {
            values: [
                $09e4832cb98fb9cd$export$a6c2d27607295951(stackParser, errorFromProp)
            ]
        },
        extra: extra
    };
    const event = {
        exception: {
            values: [
                {
                    type: (0, $626eb84a64d84c41$export$9671ea99bd126ace)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $09e4832cb98fb9cd$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: extra
    };
    if (syntheticException) {
        const frames = $09e4832cb98fb9cd$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
function $09e4832cb98fb9cd$var$eventFromError(stackParser, ex) {
    return {
        exception: {
            values: [
                $09e4832cb98fb9cd$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $09e4832cb98fb9cd$var$parseStackFrames(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const skipLines = $09e4832cb98fb9cd$var$getSkipFirstStackStringLines(ex);
    const framesToPop = $09e4832cb98fb9cd$var$getPopFirstTopFrames(ex);
    try {
        return stackParser(stacktrace, skipLines, framesToPop);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $09e4832cb98fb9cd$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
/**
 * Certain known React errors contain links that would be falsely
 * parsed as frames. This function check for these errors and
 * returns number of the stack string lines to skip.
 */ function $09e4832cb98fb9cd$var$getSkipFirstStackStringLines(ex) {
    if (ex && $09e4832cb98fb9cd$var$reactMinifiedRegexp.test(ex.message)) return 1;
    return 0;
}
/**
 * If error has `framesToPop` property, it means that the
 * creator tells us the first x frames will be useless
 * and should be discarded. Typically error from wrapper function
 * which don't point to the actual location in the developer's code.
 *
 * Example: https://github.com/zertosh/invariant/blob/master/invariant.js#L46
 */ function $09e4832cb98fb9cd$var$getPopFirstTopFrames(ex) {
    if (typeof ex.framesToPop === 'number') return ex.framesToPop;
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $09e4832cb98fb9cd$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $09e4832cb98fb9cd$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $09e4832cb98fb9cd$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $523c16f3b9d02706$export$c69a9a0313b03bb1)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $09e4832cb98fb9cd$export$5425b53185d13d6c(stackParser, message, level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $09e4832cb98fb9cd$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)(event);
}
/**
 * @hidden
 */ function $09e4832cb98fb9cd$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $626eb84a64d84c41$export$9f9636d330b71954)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $09e4832cb98fb9cd$var$eventFromError(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $626eb84a64d84c41$export$ef9e2056653f0c8e)(exception) || (0, $626eb84a64d84c41$export$12e869b2a583f783)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $09e4832cb98fb9cd$var$eventFromError(stackParser, exception);
        else {
            const name = domException.name || ((0, $626eb84a64d84c41$export$ef9e2056653f0c8e)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $09e4832cb98fb9cd$var$eventFromString(stackParser, message, syntheticException, attachStacktrace);
            (0, $523c16f3b9d02706$export$f26508487bf83ee7)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $626eb84a64d84c41$export$e6127cc7fe7395c3)(exception)) // we have a real Error object, do nothing
    return $09e4832cb98fb9cd$var$eventFromError(stackParser, exception);
    if ((0, $626eb84a64d84c41$export$53b83ca8eaab0383)(exception) || (0, $626eb84a64d84c41$export$9671ea99bd126ace)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $09e4832cb98fb9cd$var$eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $523c16f3b9d02706$export$c69a9a0313b03bb1)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $09e4832cb98fb9cd$var$eventFromString(stackParser, exception, syntheticException, attachStacktrace);
    (0, $523c16f3b9d02706$export$f26508487bf83ee7)(event, `${exception}`, undefined);
    (0, $523c16f3b9d02706$export$c69a9a0313b03bb1)(event, {
        synthetic: true
    });
    return event;
}
function $09e4832cb98fb9cd$var$eventFromString(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $09e4832cb98fb9cd$var$parseStackFrames(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $626eb84a64d84c41$export$dbcbffa59149b824)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $09e4832cb98fb9cd$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $68dbcfd11e00a6d4$export$b0244d5063c0b61b)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $626eb84a64d84c41$export$9f9636d330b71954)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $626eb84a64d84c41$export$9671ea99bd126ace)(exception)) {
        const className = $09e4832cb98fb9cd$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $09e4832cb98fb9cd$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}
/** If a plain object has a property that is an `Error`, return this error. */ function $09e4832cb98fb9cd$var$getErrorPropertyFromObject(obj) {
    for(const prop in obj)if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        const value = obj[prop];
        if (value instanceof Error) return value;
    }
    return undefined;
}




/**
 * Creates an envelope from a user feedback.
 */ function $4311c21366c467cd$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $465df9040833ef74$export$44d472fbb931a776)(dsn)
        }
    };
    const item = $4311c21366c467cd$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $70b99f77072cf559$export$f93f7f385160c44e)(headers, [
        item
    ]);
}
function $4311c21366c467cd$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}


/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $53ab05e71f1546f1$export$1df9218a526d318d extends (0, $545b62ffd46e436a$export$4f22f74eddb7716a) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const opts = {
            // We default this to true, as it is the safer scenario
            parentSpanIsAlwaysRootSpan: true,
            ...options
        };
        const sdkSource = (0, $d77304d140466795$export$56d8a8a25bd48b81).SENTRY_SDK_SOURCE || (0, $b8WCc.getSDKSource)();
        (0, $ae243f53bcfe9459$export$b9f95b027256052c)(opts, 'browser', [
            'browser'
        ], sdkSource);
        super(opts);
        if (opts.sendClientReports && (0, $d77304d140466795$export$56d8a8a25bd48b81).document) (0, $d77304d140466795$export$56d8a8a25bd48b81).document.addEventListener('visibilitychange', ()=>{
            if ((0, $d77304d140466795$export$56d8a8a25bd48b81).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $09e4832cb98fb9cd$export$ea3ec7e569b823fc)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, level = 'info', hint) {
        return (0, $09e4832cb98fb9cd$export$5425b53185d13d6c)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   *
   * @deprecated Use `captureFeedback` instead.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $4311c21366c467cd$export$24a4dfcb686ee5bf)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('Sending outcomes:', outcomes);
        const envelope = (0, $9af9573e0ba8bc4b$export$f3b9ed77c03eeb00)(outcomes, this._options.tunnel && (0, $465df9040833ef74$export$44d472fbb931a776)(this._dsn));
        // sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.sendEnvelope(envelope);
    }
}






const $dc558f47bd2b2099$var$DEBOUNCE_DURATION = 1000;
let $dc558f47bd2b2099$var$debounceTimerID;
let $dc558f47bd2b2099$var$lastCapturedEventType;
let $dc558f47bd2b2099$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $dc558f47bd2b2099$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $dc558f47bd2b2099$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $dc558f47bd2b2099$export$3014bbf0af0e1d4a() {
    if (!(0, $2e0ad70334800584$export$56d8a8a25bd48b81).document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $fb3c91b0664aac42$export$b18c893e424d3127).bind(null, 'dom');
    const globalDOMEventHandler = $dc558f47bd2b2099$var$makeDOMEventHandler(triggerDOMHandler, true);
    (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.addEventListener('click', globalDOMEventHandler, false);
    (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
        const proto = (0, $2e0ad70334800584$export$56d8a8a25bd48b81)[target] && (0, $2e0ad70334800584$export$56d8a8a25bd48b81)[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $dc558f47bd2b2099$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $dc558f47bd2b2099$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $dc558f47bd2b2099$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $dc558f47bd2b2099$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $dc558f47bd2b2099$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $dc558f47bd2b2099$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $dc558f47bd2b2099$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($dc558f47bd2b2099$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $68dbcfd11e00a6d4$export$e73679ffaf56810e)(target, '_sentryId', (0, $523c16f3b9d02706$export$19f53698e68b2496)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$dc558f47bd2b2099$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $dc558f47bd2b2099$var$lastCapturedEventType = event.type;
            $dc558f47bd2b2099$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($dc558f47bd2b2099$var$debounceTimerID);
        $dc558f47bd2b2099$var$debounceTimerID = (0, $2e0ad70334800584$export$56d8a8a25bd48b81).setTimeout(()=>{
            $dc558f47bd2b2099$var$lastCapturedEventTargetId = undefined;
            $dc558f47bd2b2099$var$lastCapturedEventType = undefined;
        }, $dc558f47bd2b2099$var$DEBOUNCE_DURATION);
    };
}
function $dc558f47bd2b2099$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}




/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $648b3b5e93c10281$var$DEFAULT_BREADCRUMBS = 100;
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 */ function $648b3b5e93c10281$export$efda9a273d7a036d(breadcrumb, hint) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const isolationScope = (0, $971e6b058109b0a9$export$68f3af03034c9e90)();
    if (!client) return;
    const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $648b3b5e93c10281$var$DEFAULT_BREADCRUMBS } = client.getOptions();
    if (maxBreadcrumbs <= 0) return;
    const timestamp = (0, $8f221861fb4a2bd8$export$7740643b9eeaf0c4)();
    const mergedBreadcrumb = {
        timestamp: timestamp,
        ...breadcrumb
    };
    const finalBreadcrumb = beforeBreadcrumb ? (0, $117c8f31aa65bddd$export$cda52e2a8927a2ca)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
    if (finalBreadcrumb === null) return;
    if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
    isolationScope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
}






/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $ca8ae5f6e520bd9f$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $fb3c91b0664aac42$export$a4e09611e30da72e)(type, handler);
    (0, $fb3c91b0664aac42$export$e18d6c5462c01368)(type, $ca8ae5f6e520bd9f$var$instrumentConsole);
}
function $ca8ae5f6e520bd9f$var$instrumentConsole() {
    if (!('console' in (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1))) return;
    (0, $117c8f31aa65bddd$export$2a2b1d2252a69ecb).forEach(function(level) {
        if (!(level in (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).console)) return;
        (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).console, level, function(originalConsoleMethod) {
            (0, $117c8f31aa65bddd$export$77c4ce905194557b)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $fb3c91b0664aac42$export$b18c893e424d3127)('console', handlerData);
                const log = (0, $117c8f31aa65bddd$export$77c4ce905194557b)[level];
                log && log.apply((0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).console, args);
            };
        });
    });
}

// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $edd483f6e1ec83f5$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $edd483f6e1ec83f5$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $edd483f6e1ec83f5$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}




/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $2d9e66b17b884fa3$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $2d9e66b17b884fa3$var$INTEGRATION_NAME = 'Breadcrumbs';
const $2d9e66b17b884fa3$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $2d9e66b17b884fa3$var$INTEGRATION_NAME,
        setup (client) {
            if (_options.console) (0, $ca8ae5f6e520bd9f$export$1d6e0d073f9e6723)($2d9e66b17b884fa3$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $dc558f47bd2b2099$export$5aeffd3db2cf9df7)($2d9e66b17b884fa3$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $13a4c7cbade0edcd$export$26ace48dd54c9aea)($2d9e66b17b884fa3$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $c1946177a63e182a$export$f75d3c772c923df0)($2d9e66b17b884fa3$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $81fb4056224c2de0$export$3f18c56c58114e75)($2d9e66b17b884fa3$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry) client.on('beforeSendEvent', $2d9e66b17b884fa3$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $2d9e66b17b884fa3$export$c079d904b326663a = (0, $aee3a253844bd334$export$2323046b9414659f)($2d9e66b17b884fa3$var$_breadcrumbsIntegration);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $2d9e66b17b884fa3$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
        (0, $648b3b5e93c10281$export$efda9a273d7a036d)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $523c16f3b9d02706$export$4157119e2b157127)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $2d9e66b17b884fa3$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $2d9e66b17b884fa3$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`\`dom.maxStringLength\` cannot exceed ${$2d9e66b17b884fa3$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$2d9e66b17b884fa3$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $2d9e66b17b884fa3$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $2d9e66b17b884fa3$var$_isEvent(event) ? event.target : event;
            target = (0, $b076601639d1314e$export$5647df6b7814ac86)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $b076601639d1314e$export$26727cfcc4d7e0fc)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $648b3b5e93c10281$export$efda9a273d7a036d)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $2d9e66b17b884fa3$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $edd483f6e1ec83f5$export$d771ef054122c30a)(handlerData.level),
            message: (0, $6c98f0cd61ae7fe0$export$465e9d514283d4fd)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $6c98f0cd61ae7fe0$export$465e9d514283d4fd)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $648b3b5e93c10281$export$efda9a273d7a036d)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $2d9e66b17b884fa3$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $13a4c7cbade0edcd$export$55b6bb1e45c6cf59];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $648b3b5e93c10281$export$efda9a273d7a036d)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $2d9e66b17b884fa3$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $648b3b5e93c10281$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $648b3b5e93c10281$export$efda9a273d7a036d)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $2d9e66b17b884fa3$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $cdc4578f23641df3$export$7a5253c0f62e0150)((0, $d77304d140466795$export$56d8a8a25bd48b81).location.href);
        let parsedFrom = from ? (0, $cdc4578f23641df3$export$7a5253c0f62e0150)(from) : undefined;
        const parsedTo = (0, $cdc4578f23641df3$export$7a5253c0f62e0150)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $648b3b5e93c10281$export$efda9a273d7a036d)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $2d9e66b17b884fa3$var$_isEvent(event) {
    return !!event && !!event.target;
}





const $2a5b226aa61fade5$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $2a5b226aa61fade5$var$INTEGRATION_NAME = 'BrowserApiErrors';
const $2a5b226aa61fade5$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $2a5b226aa61fade5$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $d77304d140466795$export$56d8a8a25bd48b81), 'setTimeout', $2a5b226aa61fade5$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $d77304d140466795$export$56d8a8a25bd48b81), 'setInterval', $2a5b226aa61fade5$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)((0, $d77304d140466795$export$56d8a8a25bd48b81), 'requestAnimationFrame', $2a5b226aa61fade5$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $d77304d140466795$export$56d8a8a25bd48b81)) (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(XMLHttpRequest.prototype, 'send', $2a5b226aa61fade5$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $2a5b226aa61fade5$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($2a5b226aa61fade5$var$_wrapEventTarget);
            }
        }
    };
};
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 */ const $2a5b226aa61fade5$export$59bfe9f1c76150e = (0, $aee3a253844bd334$export$2323046b9414659f)($2a5b226aa61fade5$var$_browserApiErrorsIntegration);
function $2a5b226aa61fade5$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $d77304d140466795$export$4997ffc0176396a6)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $81b681a083912fb6$export$aad197c7121a6651)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2a5b226aa61fade5$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $d77304d140466795$export$4997ffc0176396a6)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $81b681a083912fb6$export$aad197c7121a6651)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $2a5b226aa61fade5$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $81b681a083912fb6$export$aad197c7121a6651)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before BrowserApiErrors, get the name of original function
                const originalFunction = (0, $68dbcfd11e00a6d4$export$e6cc1e135e2092e5)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $81b681a083912fb6$export$aad197c7121a6651)(originalFunction);
                // Otherwise wrap directly
                return (0, $d77304d140466795$export$4997ffc0176396a6)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $2a5b226aa61fade5$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $d77304d140466795$export$56d8a8a25bd48b81);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $d77304d140466795$export$4997ffc0176396a6)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $81b681a083912fb6$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $d77304d140466795$export$4997ffc0176396a6)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $81b681a083912fb6$export$aad197c7121a6651)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}







const $12992736a5b27478$var$INTEGRATION_NAME = 'GlobalHandlers';
const $12992736a5b27478$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $12992736a5b27478$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $12992736a5b27478$var$_installGlobalOnErrorHandler(client);
                $12992736a5b27478$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $12992736a5b27478$var$_installGlobalOnUnhandledRejectionHandler(client);
                $12992736a5b27478$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $12992736a5b27478$export$66acc70e8cf2b71a = (0, $aee3a253844bd334$export$2323046b9414659f)($12992736a5b27478$var$_globalHandlersIntegration);
function $12992736a5b27478$var$_installGlobalOnErrorHandler(client) {
    (0, $7550a53811741197$export$55b5c3ba2194f0c6)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $12992736a5b27478$var$getOptions();
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client || (0, $d77304d140466795$export$b79738ab10c590b2)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = $12992736a5b27478$var$_enhanceEventWithInitialFrame((0, $09e4832cb98fb9cd$export$9dd56ed1ef0c3420)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $6e2d7e6efd34a5e4$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $12992736a5b27478$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $db3b8791cf660c9e$export$8bf4fc6858821a4e)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $12992736a5b27478$var$getOptions();
        if ((0, $971e6b058109b0a9$export$6bb76d6eba7e258c)() !== client || (0, $d77304d140466795$export$b79738ab10c590b2)()) return;
        const error = $12992736a5b27478$var$_getUnhandledRejectionError(e);
        const event = (0, $626eb84a64d84c41$export$c3825b437cbdea5c)(error) ? $12992736a5b27478$var$_eventFromRejectionWithPrimitive(error) : (0, $09e4832cb98fb9cd$export$9dd56ed1ef0c3420)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $6e2d7e6efd34a5e4$export$1462b974fdcf6ba2)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $12992736a5b27478$var$_getUnhandledRejectionError(error) {
    if ((0, $626eb84a64d84c41$export$c3825b437cbdea5c)(error)) return error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in error) return error.reason;
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        if ('detail' in error && 'reason' in error.detail) return error.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $12992736a5b27478$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $12992736a5b27478$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $626eb84a64d84c41$export$844ec244b1367d54)(url) && url.length > 0 ? url : (0, $b076601639d1314e$export$1cfafeee2987818b)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: (0, $81b681a083912fb6$export$27c7e15d453fc0ac),
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $12992736a5b27478$var$globalHandlerLog(type) {
    (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log(`Global Handler attached: ${type}`);
}
function $12992736a5b27478$var$getOptions() {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}




/**
 * Collects information about HTTP request headers and
 * attaches them to the event.
 */ const $811787aba47463b8$export$1378794447170364 = (0, $aee3a253844bd334$export$2323046b9414659f)(()=>{
    return {
        name: 'HttpContext',
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $d77304d140466795$export$56d8a8a25bd48b81).navigator && !(0, $d77304d140466795$export$56d8a8a25bd48b81).location && !(0, $d77304d140466795$export$56d8a8a25bd48b81).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $d77304d140466795$export$56d8a8a25bd48b81).location && (0, $d77304d140466795$export$56d8a8a25bd48b81).location.href;
            const { referrer: referrer } = (0, $d77304d140466795$export$56d8a8a25bd48b81).document || {};
            const { userAgent: userAgent } = (0, $d77304d140466795$export$56d8a8a25bd48b81).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
});





/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $e7515a7674c626fb$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $626eb84a64d84c41$export$49034edbe6b62415)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $e7515a7674c626fb$var$truncateAggregateExceptions($e7515a7674c626fb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $e7515a7674c626fb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $626eb84a64d84c41$export$49034edbe6b62415)(error[key], Error)) {
        $e7515a7674c626fb$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $e7515a7674c626fb$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $e7515a7674c626fb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $626eb84a64d84c41$export$49034edbe6b62415)(childError, Error)) {
            $e7515a7674c626fb$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $e7515a7674c626fb$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $e7515a7674c626fb$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $e7515a7674c626fb$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $e7515a7674c626fb$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $e7515a7674c626fb$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $6c98f0cd61ae7fe0$export$6a506b36fdea397d)(exception.value, maxValueLength);
        return exception;
    });
}



const $87a63c3cb8501c4d$var$DEFAULT_KEY = 'cause';
const $87a63c3cb8501c4d$var$DEFAULT_LIMIT = 5;
const $87a63c3cb8501c4d$var$INTEGRATION_NAME = 'LinkedErrors';
const $87a63c3cb8501c4d$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $87a63c3cb8501c4d$var$DEFAULT_LIMIT;
    const key = options.key || $87a63c3cb8501c4d$var$DEFAULT_KEY;
    return {
        name: $87a63c3cb8501c4d$var$INTEGRATION_NAME,
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $e7515a7674c626fb$export$b91c38ed7d8ae9b2)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $09e4832cb98fb9cd$export$a6c2d27607295951), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
/**
 * Aggregrate linked errors in an event.
 */ const $87a63c3cb8501c4d$export$ebabb00eb7f3a395 = (0, $aee3a253844bd334$export$2323046b9414659f)($87a63c3cb8501c4d$var$_linkedErrorsIntegration);



const $73e39b4aefc69ec5$var$OPERA10_PRIORITY = 10;
const $73e39b4aefc69ec5$var$OPERA11_PRIORITY = 20;
const $73e39b4aefc69ec5$var$CHROME_PRIORITY = 30;
const $73e39b4aefc69ec5$var$WINJS_PRIORITY = 40;
const $73e39b4aefc69ec5$var$GECKO_PRIORITY = 50;
function $73e39b4aefc69ec5$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func === '<anonymous>' ? (0, $81b681a083912fb6$export$27c7e15d453fc0ac) : func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $73e39b4aefc69ec5$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $73e39b4aefc69ec5$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $73e39b4aefc69ec5$var$chromeStackParserFn = (line)=>{
    const parts = $73e39b4aefc69ec5$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $73e39b4aefc69ec5$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $73e39b4aefc69ec5$var$extractSafariExtensionDetails(parts[1] || (0, $81b681a083912fb6$export$27c7e15d453fc0ac), parts[2]);
        return $73e39b4aefc69ec5$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $73e39b4aefc69ec5$export$263a749fff749872 = [
    $73e39b4aefc69ec5$var$CHROME_PRIORITY,
    $73e39b4aefc69ec5$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $73e39b4aefc69ec5$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $73e39b4aefc69ec5$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $73e39b4aefc69ec5$var$gecko = (line)=>{
    const parts = $73e39b4aefc69ec5$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $73e39b4aefc69ec5$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || (0, $81b681a083912fb6$export$27c7e15d453fc0ac);
        [func, filename] = $73e39b4aefc69ec5$var$extractSafariExtensionDetails(func, filename);
        return $73e39b4aefc69ec5$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $73e39b4aefc69ec5$export$cdba47a5dd2804d = [
    $73e39b4aefc69ec5$var$GECKO_PRIORITY,
    $73e39b4aefc69ec5$var$gecko
];
const $73e39b4aefc69ec5$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $73e39b4aefc69ec5$var$winjs = (line)=>{
    const parts = $73e39b4aefc69ec5$var$winjsRegex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[2], parts[1] || (0, $81b681a083912fb6$export$27c7e15d453fc0ac), +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $73e39b4aefc69ec5$export$179460296da408e8 = [
    $73e39b4aefc69ec5$var$WINJS_PRIORITY,
    $73e39b4aefc69ec5$var$winjs
];
const $73e39b4aefc69ec5$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $73e39b4aefc69ec5$var$opera10 = (line)=>{
    const parts = $73e39b4aefc69ec5$var$opera10Regex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[2], parts[3] || (0, $81b681a083912fb6$export$27c7e15d453fc0ac), +parts[1]) : undefined;
};
const $73e39b4aefc69ec5$export$f892b52c880ffc7a = [
    $73e39b4aefc69ec5$var$OPERA10_PRIORITY,
    $73e39b4aefc69ec5$var$opera10
];
const $73e39b4aefc69ec5$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $73e39b4aefc69ec5$var$opera11 = (line)=>{
    const parts = $73e39b4aefc69ec5$var$opera11Regex.exec(line);
    return parts ? $73e39b4aefc69ec5$var$createFrame(parts[5], parts[3] || parts[4] || (0, $81b681a083912fb6$export$27c7e15d453fc0ac), +parts[1], +parts[2]) : undefined;
};
const $73e39b4aefc69ec5$export$af11af13f09fb0dc = [
    $73e39b4aefc69ec5$var$OPERA11_PRIORITY,
    $73e39b4aefc69ec5$var$opera11
];
const $73e39b4aefc69ec5$export$7197c0fe6554c079 = [
    $73e39b4aefc69ec5$export$263a749fff749872,
    $73e39b4aefc69ec5$export$cdba47a5dd2804d
];
const $73e39b4aefc69ec5$export$2b2b997d81bf3907 = (0, $81b681a083912fb6$export$a5739666fb2d03d4)(...$73e39b4aefc69ec5$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $73e39b4aefc69ec5$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : (0, $81b681a083912fb6$export$27c7e15d453fc0ac),
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};





/**
 * We generally want to use window.fetch / window.setTimeout.
 * However, in some cases this may be wrapped (e.g. by Zone.js for Angular),
 * so we try to get an unpatched version of this from a sandboxed iframe.
 */ const $933990856d6cef5c$var$cachedImplementations = {};
/**
 * Get the native implementation of a browser function.
 *
 * This can be used to ensure we get an unwrapped version of a function, in cases where a wrapped function can lead to problems.
 *
 * The following methods can be retrieved:
 * - `setTimeout`: This can be wrapped by e.g. Angular, causing change detection to be triggered.
 * - `fetch`: This can be wrapped by e.g. ad-blockers, causing an infinite loop when a request is blocked.
 */ function $933990856d6cef5c$export$e464f4a514ac28a8(name) {
    const cached = $933990856d6cef5c$var$cachedImplementations[name];
    if (cached) return cached;
    let impl = (0, $2e0ad70334800584$export$56d8a8a25bd48b81)[name];
    // Fast path to avoid DOM I/O
    if ((0, $5cfa7c881be62025$export$d5f608b368e73f38)(impl)) return $933990856d6cef5c$var$cachedImplementations[name] = impl.bind((0, $2e0ad70334800584$export$56d8a8a25bd48b81));
    const document = (0, $2e0ad70334800584$export$56d8a8a25bd48b81).document;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document.head.removeChild(sandbox);
    } catch (e) {
        // Could not create sandbox iframe, just use window.xxx
        (0, $ca7f643c89d76419$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Could not create sandbox iframe for ${name} check, bailing to window.${name}: `, e);
    }
    // Sanity check: This _should_ not happen, but if it does, we just skip caching...
    // This can happen e.g. in tests where fetch may not be available in the env, or similar.
    if (!impl) return impl;
    return $933990856d6cef5c$var$cachedImplementations[name] = impl.bind((0, $2e0ad70334800584$export$56d8a8a25bd48b81));
}
/** Clear a cached implementation. */ function $933990856d6cef5c$export$8aa36702e8c8978(name) {
    $933990856d6cef5c$var$cachedImplementations[name] = undefined;
}
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $933990856d6cef5c$export$e7aa7bc5c1b3cfb3(...rest) {
    return $933990856d6cef5c$export$e464f4a514ac28a8('fetch')(...rest);
}
/**
 * Get an unwrapped `setTimeout` method.
 * This ensures that even if e.g. Angular wraps `setTimeout`, we get the native implementation,
 * avoiding triggering change detection.
 */ function $933990856d6cef5c$export$831dc9f2ab0a617b(...rest) {
    return $933990856d6cef5c$export$e464f4a514ac28a8('setTimeout')(...rest);
}


// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $a8a4c0c2698a0fad$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $a8a4c0c2698a0fad$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $a8a4c0c2698a0fad$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $a8a4c0c2698a0fad$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $a8a4c0c2698a0fad$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $a8a4c0c2698a0fad$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $a8a4c0c2698a0fad$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $8ac12939fa13e8f5$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $82b0c6d0fe80f282$export$78e43115b553f358)(new (0, $dada51e7b2168637$export$5949942ba2a7c0e2)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $82b0c6d0fe80f282$export$6f292d4960313241)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}



const $ae2e092254e7dd66$export$e515cf6dfd2f98b8 = 64;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $ae2e092254e7dd66$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $8ac12939fa13e8f5$export$85a4f67f852183e6)(options.bufferSize || $ae2e092254e7dd66$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $70b99f77072cf559$export$c56c55acf0136fd3)(envelope, (item, type)=>{
            const dataCategory = (0, $70b99f77072cf559$export$b11169581eeaf237)(type);
            if ((0, $a8a4c0c2698a0fad$export$6c91fec22056810a)(rateLimits, dataCategory)) {
                const event = $ae2e092254e7dd66$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)({});
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $70b99f77072cf559$export$f93f7f385160c44e)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $70b99f77072cf559$export$c56c55acf0136fd3)(filteredEnvelope, (item, type)=>{
                const event = $ae2e092254e7dd66$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $70b99f77072cf559$export$b11169581eeaf237)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $70b99f77072cf559$export$32f9b428425aac85)(filteredEnvelope)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $a8a4c0c2698a0fad$export$699aff705e0d49d4)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $dada51e7b2168637$export$5949942ba2a7c0e2)) {
                (0, $506311a3b441d72b$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)({});
            } else throw error;
        });
    }
    return {
        send: send,
        flush: flush
    };
}
function $ae2e092254e7dd66$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}



/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $839b900621c46fa5$export$b2311068c46d7cc8(options, nativeFetch = (0, $933990856d6cef5c$export$e464f4a514ac28a8)('fetch')) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        if (!nativeFetch) {
            (0, $933990856d6cef5c$export$8aa36702e8c8978)('fetch');
            return (0, $82b0c6d0fe80f282$export$78e43115b553f358)('No fetch implementation available');
        }
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $933990856d6cef5c$export$8aa36702e8c8978)('fetch');
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $82b0c6d0fe80f282$export$78e43115b553f358)(e);
        }
    }
    return (0, $ae2e092254e7dd66$export$d09f50d9ab7f7b69)(options, makeRequest);
}


/** Get the default integrations for the browser SDK. */ function $4433681b335e918c$export$5783b2920b1d62b9(_options) {
    /**
   * Note: Please make sure this stays in sync with Angular SDK, which re-exports
   * `getDefaultIntegrations` but with an adjusted set of integrations.
   */ return [
        (0, $40df1ce1eb5ab4a4$export$cb3c5c2ceb9818ba)(),
        (0, $ed19db1e0527512d$export$7918117e9202e4fb)(),
        (0, $2a5b226aa61fade5$export$59bfe9f1c76150e)(),
        (0, $2d9e66b17b884fa3$export$c079d904b326663a)(),
        (0, $12992736a5b27478$export$66acc70e8cf2b71a)(),
        (0, $87a63c3cb8501c4d$export$ebabb00eb7f3a395)(),
        (0, $0ed0e5fb0e89d4b5$export$6d39aa44cd0c7567)(),
        (0, $811787aba47463b8$export$1378794447170364)()
    ];
}
function $4433681b335e918c$var$applyDefaultOptions(optionsArg = {}) {
    const defaultOptions = {
        defaultIntegrations: $4433681b335e918c$export$5783b2920b1d62b9(),
        release: typeof __SENTRY_RELEASE__ === 'string' // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
         ? __SENTRY_RELEASE__ : (0, $d77304d140466795$export$56d8a8a25bd48b81).SENTRY_RELEASE && (0, $d77304d140466795$export$56d8a8a25bd48b81).SENTRY_RELEASE.id // This supports the variable that sentry-webpack-plugin injects
         ? (0, $d77304d140466795$export$56d8a8a25bd48b81).SENTRY_RELEASE.id : undefined,
        autoSessionTracking: true,
        sendClientReports: true
    };
    return {
        ...defaultOptions,
        ...optionsArg
    };
}
function $4433681b335e918c$var$shouldShowBrowserExtensionError() {
    const windowWithMaybeChrome = (0, $d77304d140466795$export$56d8a8a25bd48b81);
    const isInsideChromeExtension = windowWithMaybeChrome && windowWithMaybeChrome.chrome && windowWithMaybeChrome.chrome.runtime && windowWithMaybeChrome.chrome.runtime.id;
    const windowWithMaybeBrowser = (0, $d77304d140466795$export$56d8a8a25bd48b81);
    const isInsideBrowserExtension = windowWithMaybeBrowser && windowWithMaybeBrowser.browser && windowWithMaybeBrowser.browser.runtime && windowWithMaybeBrowser.browser.runtime.id;
    return !!isInsideBrowserExtension || !!isInsideChromeExtension;
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $4433681b335e918c$export$2cd8252107eb640b(browserOptions = {}) {
    const options = $4433681b335e918c$var$applyDefaultOptions(browserOptions);
    if ($4433681b335e918c$var$shouldShowBrowserExtensionError()) {
        (0, $117c8f31aa65bddd$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.error('[Sentry] You cannot run Sentry this way in a browser extension, check: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/');
        });
        return;
    }
    if (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) {
        if (!(0, $5cfa7c881be62025$export$edf3cb81fd7d2a3e)()) (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('No Fetch API detected. The Sentry SDK requires a Fetch API compatible environment to send events. Please add a Fetch API polyfill.');
    }
    const clientOptions = {
        ...options,
        stackParser: (0, $81b681a083912fb6$export$1d5cf88b347146d4)(options.stackParser || (0, $73e39b4aefc69ec5$export$2b2b997d81bf3907)),
        integrations: (0, $aee3a253844bd334$export$68bc4c01ab8ae766)(options),
        transport: options.transport || (0, $839b900621c46fa5$export$b2311068c46d7cc8)
    };
    (0, $2da25d0c226965dc$export$5333c3f1c58d9bc1)((0, $53ab05e71f1546f1$export$1df9218a526d318d), clientOptions);
    if (options.autoSessionTracking) $4433681b335e918c$var$startSessionTracking();
}
/**
 * All properties the report dialog supports
 */ /**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */ function $4433681b335e918c$export$3a8fd680da42627b(options = {}) {
    // doesn't work without a document (React Native)
    if (!(0, $d77304d140466795$export$56d8a8a25bd48b81).document) {
        (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('Global document not defined in showReportDialog call');
        return;
    }
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const client = scope.getClient();
    const dsn = client && client.getDsn();
    if (!dsn) {
        (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) {
        const eventId = (0, $6e2d7e6efd34a5e4$export$5d4e9fd7fac8e617)();
        if (eventId) options.eventId = eventId;
    }
    const script = (0, $d77304d140466795$export$56d8a8a25bd48b81).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $959e07742905ebeb$export$671c7ed8e40a7a57)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $d77304d140466795$export$56d8a8a25bd48b81).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $d77304d140466795$export$56d8a8a25bd48b81).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $d77304d140466795$export$56d8a8a25bd48b81).document.head || (0, $d77304d140466795$export$56d8a8a25bd48b81).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('Not injecting report dialog. No injection point found in HTML');
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4433681b335e918c$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $4433681b335e918c$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $4433681b335e918c$var$startSessionTracking() {
    if (typeof (0, $d77304d140466795$export$56d8a8a25bd48b81).document === 'undefined') {
        (0, $022a7c71c0c5d1e4$export$16a28057038b10ef) && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $6e2d7e6efd34a5e4$export$c0d84948cecf78d8)({
        ignoreDuration: true
    });
    (0, $6e2d7e6efd34a5e4$export$667e7b4d445d566b)();
    // We want to create a session for every navigation as well
    (0, $81fb4056224c2de0$export$3f18c56c58114e75)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $6e2d7e6efd34a5e4$export$c0d84948cecf78d8)({
                ignoreDuration: true
            });
            (0, $6e2d7e6efd34a5e4$export$667e7b4d445d566b)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 *
 * @deprecated Use `captureFeedback` instead.
 */ function $4433681b335e918c$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (client) // eslint-disable-next-line deprecation/deprecation
    client.captureUserFeedback(feedback);
}



/**
 * Inits the React SDK
 */ function $72c0e238230eba33$export$2cd8252107eb640b(options) {
    const opts = {
        ...options
    };
    (0, $ae243f53bcfe9459$export$b9f95b027256052c)(opts, 'react');
    (0, $4433681b335e918c$export$2cd8252107eb640b)(opts);
}

// https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
//
// The MIT License (MIT)
//
// Copyright (c) 2012-2018 various contributors (see AUTHORS)
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ function $25a605f9795290da$export$8db64e83cc1a933c(lhs, rhsFn) {
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    return lhs != null ? lhs : rhsFn();
}


var $dBSRM = parcelRequire("dBSRM");

/**
 * Returns true if we are in the browser.
 */ function $44c797189ebd809c$export$4e09c449d6c407f7() {
    // eslint-disable-next-line no-restricted-globals
    return typeof window !== 'undefined' && (!(0, $dBSRM.isNodeEnv)() || $44c797189ebd809c$var$isElectronNodeRenderer());
}
// Electron renderers with nodeIntegration enabled are detected as Node.js so we specifically test for them
function $44c797189ebd809c$var$isElectronNodeRenderer() {
    return(// eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).process !== undefined && (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1).process.type === 'renderer');
}


/**
 * Checks whether given url points to Sentry server
 *
 * @param url url to verify
 */ function $efa14c387d4ff555$export$d92e61f5600202af(url, client) {
    const dsn = client && client.getDsn();
    const tunnel = client && client.getOptions().tunnel;
    return $efa14c387d4ff555$var$checkDsn(url, dsn) || $efa14c387d4ff555$var$checkTunnel(url, tunnel);
}
function $efa14c387d4ff555$var$checkTunnel(url, tunnel) {
    if (!tunnel) return false;
    return $efa14c387d4ff555$var$removeTrailingSlash(url) === $efa14c387d4ff555$var$removeTrailingSlash(tunnel);
}
function $efa14c387d4ff555$var$checkDsn(url, dsn) {
    return dsn ? url.includes(dsn.host) : false;
}
function $efa14c387d4ff555$var$removeTrailingSlash(str) {
    return str[str.length - 1] === '/' ? str.slice(0, -1) : str;
}



// exporting a separate copy of `WINDOW` rather than exporting the one from `@sentry/browser`
// prevents the browser package from being bundled in the CDN bundle, and avoids a
// circular dependency between the browser and replay packages should `@sentry/browser` import
// from `@sentry/replay` in the future
const $ca970ce8cf2750a2$var$WINDOW = (0, $3d53d2e16cab3c2d$export$f1a6cdb1459e81d1);
const $ca970ce8cf2750a2$var$REPLAY_SESSION_KEY = 'sentryReplaySession';
const $ca970ce8cf2750a2$var$REPLAY_EVENT_NAME = 'replay_event';
const $ca970ce8cf2750a2$var$UNABLE_TO_SEND_REPLAY = 'Unable to send Replay';
// The idle limit for a session after which recording is paused.
const $ca970ce8cf2750a2$var$SESSION_IDLE_PAUSE_DURATION = 300000; // 5 minutes in ms
// The idle limit for a session after which the session expires.
const $ca970ce8cf2750a2$var$SESSION_IDLE_EXPIRE_DURATION = 900000; // 15 minutes in ms
/** Default flush delays */ const $ca970ce8cf2750a2$var$DEFAULT_FLUSH_MIN_DELAY = 5000;
// XXX: Temp fix for our debounce logic where `maxWait` would never occur if it
// was the same as `wait`
const $ca970ce8cf2750a2$var$DEFAULT_FLUSH_MAX_DELAY = 5500;
/* How long to wait for error checkouts */ const $ca970ce8cf2750a2$var$BUFFER_CHECKOUT_TIME = 60000;
const $ca970ce8cf2750a2$var$RETRY_BASE_INTERVAL = 5000;
const $ca970ce8cf2750a2$var$RETRY_MAX_COUNT = 3;
/* The max (uncompressed) size in bytes of a network body. Any body larger than this will be truncated. */ const $ca970ce8cf2750a2$var$NETWORK_BODY_MAX_SIZE = 150000;
/* The max size of a single console arg that is captured. Any arg larger than this will be truncated. */ const $ca970ce8cf2750a2$var$CONSOLE_ARG_MAX_SIZE = 5000;
/* Min. time to wait before we consider something a slow click. */ const $ca970ce8cf2750a2$var$SLOW_CLICK_THRESHOLD = 3000;
/* For scroll actions after a click, we only look for a very short time period to detect programmatic scrolling. */ const $ca970ce8cf2750a2$var$SLOW_CLICK_SCROLL_TIMEOUT = 300;
/** When encountering a total segment size exceeding this size, stop the replay (as we cannot properly ingest it). */ const $ca970ce8cf2750a2$var$REPLAY_MAX_EVENT_BUFFER_SIZE = 20000000; // ~20MB
/** Replays must be min. 5s long before we send them. */ const $ca970ce8cf2750a2$var$MIN_REPLAY_DURATION = 4999;
/* The max. allowed value that the minReplayDuration can be set to. */ const $ca970ce8cf2750a2$var$MIN_REPLAY_DURATION_LIMIT = 15000;
/** The max. length of a replay. */ const $ca970ce8cf2750a2$var$MAX_REPLAY_DURATION = 3600000; // 60 minutes in ms;
function $ca970ce8cf2750a2$var$_nullishCoalesce$1(lhs, rhsFn) {
    if (lhs != null) return lhs;
    else return rhsFn();
}
function $ca970ce8cf2750a2$var$_optionalChain$5(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
var $ca970ce8cf2750a2$var$NodeType$1;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($ca970ce8cf2750a2$var$NodeType$1 || ($ca970ce8cf2750a2$var$NodeType$1 = {}));
function $ca970ce8cf2750a2$var$isElement$1(n) {
    return n.nodeType === n.ELEMENT_NODE;
}
function $ca970ce8cf2750a2$var$isShadowRoot(n) {
    const host = $ca970ce8cf2750a2$var$_optionalChain$5([
        n,
        'optionalAccess',
        (_)=>_.host
    ]);
    return Boolean($ca970ce8cf2750a2$var$_optionalChain$5([
        host,
        'optionalAccess',
        (_2)=>_2.shadowRoot
    ]) === n);
}
function $ca970ce8cf2750a2$var$isNativeShadowDom(shadowRoot) {
    return Object.prototype.toString.call(shadowRoot) === '[object ShadowRoot]';
}
function $ca970ce8cf2750a2$var$fixBrowserCompatibilityIssuesInCSS(cssText) {
    if (cssText.includes(' background-clip: text;') && !cssText.includes(' -webkit-background-clip: text;')) cssText = cssText.replace(' background-clip: text;', ' -webkit-background-clip: text; background-clip: text;');
    return cssText;
}
function $ca970ce8cf2750a2$var$escapeImportStatement(rule) {
    const { cssText: cssText } = rule;
    if (cssText.split('"').length < 3) return cssText;
    const statement = [
        '@import',
        `url(${JSON.stringify(rule.href)})`
    ];
    if (rule.layerName === '') statement.push(`layer`);
    else if (rule.layerName) statement.push(`layer(${rule.layerName})`);
    if (rule.supportsText) statement.push(`supports(${rule.supportsText})`);
    if (rule.media.length) statement.push(rule.media.mediaText);
    return statement.join(' ') + ';';
}
function $ca970ce8cf2750a2$var$stringifyStylesheet(s) {
    try {
        const rules = s.rules || s.cssRules;
        return rules ? $ca970ce8cf2750a2$var$fixBrowserCompatibilityIssuesInCSS(Array.from(rules, $ca970ce8cf2750a2$var$stringifyRule).join('')) : null;
    } catch (error) {
        return null;
    }
}
function $ca970ce8cf2750a2$var$stringifyRule(rule) {
    let importStringified;
    if ($ca970ce8cf2750a2$var$isCSSImportRule(rule)) try {
        importStringified = $ca970ce8cf2750a2$var$stringifyStylesheet(rule.styleSheet) || $ca970ce8cf2750a2$var$escapeImportStatement(rule);
    } catch (error) {}
    else if ($ca970ce8cf2750a2$var$isCSSStyleRule(rule) && rule.selectorText.includes(':')) return $ca970ce8cf2750a2$var$fixSafariColons(rule.cssText);
    return importStringified || rule.cssText;
}
function $ca970ce8cf2750a2$var$fixSafariColons(cssStringified) {
    const regex = /(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm;
    return cssStringified.replace(regex, '$1\\$2');
}
function $ca970ce8cf2750a2$var$isCSSImportRule(rule) {
    return 'styleSheet' in rule;
}
function $ca970ce8cf2750a2$var$isCSSStyleRule(rule) {
    return 'selectorText' in rule;
}
class $ca970ce8cf2750a2$var$Mirror {
    constructor(){
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
    getId(n) {
        if (!n) return -1;
        const id = $ca970ce8cf2750a2$var$_optionalChain$5([
            this,
            'access',
            (_3)=>_3.getMeta,
            'call',
            (_4)=>_4(n),
            'optionalAccess',
            (_5)=>_5.id
        ]);
        return $ca970ce8cf2750a2$var$_nullishCoalesce$1(id, ()=>-1);
    }
    getNode(id) {
        return this.idNodeMap.get(id) || null;
    }
    getIds() {
        return Array.from(this.idNodeMap.keys());
    }
    getMeta(n) {
        return this.nodeMetaMap.get(n) || null;
    }
    removeNodeFromMap(n) {
        const id = this.getId(n);
        this.idNodeMap.delete(id);
        if (n.childNodes) n.childNodes.forEach((childNode)=>this.removeNodeFromMap(childNode));
    }
    has(id) {
        return this.idNodeMap.has(id);
    }
    hasNode(node) {
        return this.nodeMetaMap.has(node);
    }
    add(n, meta) {
        const id = meta.id;
        this.idNodeMap.set(id, n);
        this.nodeMetaMap.set(n, meta);
    }
    replace(id, n) {
        const oldNode = this.getNode(id);
        if (oldNode) {
            const meta = this.nodeMetaMap.get(oldNode);
            if (meta) this.nodeMetaMap.set(n, meta);
        }
        this.idNodeMap.set(id, n);
    }
    reset() {
        this.idNodeMap = new Map();
        this.nodeMetaMap = new WeakMap();
    }
}
function $ca970ce8cf2750a2$var$createMirror() {
    return new $ca970ce8cf2750a2$var$Mirror();
}
function $ca970ce8cf2750a2$var$shouldMaskInput({ maskInputOptions: maskInputOptions, tagName: tagName, type: type }) {
    if (tagName === 'OPTION') tagName = 'SELECT';
    return Boolean(maskInputOptions[tagName.toLowerCase()] || type && maskInputOptions[type] || type === 'password' || tagName === 'INPUT' && !type && maskInputOptions['text']);
}
function $ca970ce8cf2750a2$var$maskInputValue({ isMasked: isMasked, element: element, value: value, maskInputFn: maskInputFn }) {
    let text = value || '';
    if (!isMasked) return text;
    if (maskInputFn) text = maskInputFn(text, element);
    return '*'.repeat(text.length);
}
function $ca970ce8cf2750a2$var$toLowerCase(str) {
    return str.toLowerCase();
}
function $ca970ce8cf2750a2$var$toUpperCase(str) {
    return str.toUpperCase();
}
const $ca970ce8cf2750a2$var$ORIGINAL_ATTRIBUTE_NAME = '__rrweb_original__';
function $ca970ce8cf2750a2$var$is2DCanvasBlank(canvas) {
    const ctx = canvas.getContext('2d');
    if (!ctx) return true;
    const chunkSize = 50;
    for(let x = 0; x < canvas.width; x += chunkSize)for(let y = 0; y < canvas.height; y += chunkSize){
        const getImageData = ctx.getImageData;
        const originalGetImageData = $ca970ce8cf2750a2$var$ORIGINAL_ATTRIBUTE_NAME in getImageData ? getImageData[$ca970ce8cf2750a2$var$ORIGINAL_ATTRIBUTE_NAME] : getImageData;
        const pixelBuffer = new Uint32Array(originalGetImageData.call(ctx, x, y, Math.min(chunkSize, canvas.width - x), Math.min(chunkSize, canvas.height - y)).data.buffer);
        if (pixelBuffer.some((pixel)=>pixel !== 0)) return false;
    }
    return true;
}
function $ca970ce8cf2750a2$var$getInputType(element) {
    const type = element.type;
    return element.hasAttribute('data-rr-is-password') ? 'password' : type ? $ca970ce8cf2750a2$var$toLowerCase(type) : null;
}
function $ca970ce8cf2750a2$var$getInputValue(el, tagName, type) {
    if (tagName === 'INPUT' && (type === 'radio' || type === 'checkbox')) return el.getAttribute('value') || '';
    return el.value;
}
let $ca970ce8cf2750a2$var$_id = 1;
const $ca970ce8cf2750a2$var$tagNameRegex = new RegExp('[^a-z0-9-_:]');
const $ca970ce8cf2750a2$var$IGNORED_NODE = -2;
function $ca970ce8cf2750a2$var$genId() {
    return $ca970ce8cf2750a2$var$_id++;
}
function $ca970ce8cf2750a2$var$getValidTagName(element) {
    if (element instanceof HTMLFormElement) return 'form';
    const processedTagName = $ca970ce8cf2750a2$var$toLowerCase(element.tagName);
    if ($ca970ce8cf2750a2$var$tagNameRegex.test(processedTagName)) return 'div';
    return processedTagName;
}
function $ca970ce8cf2750a2$var$extractOrigin(url) {
    let origin = '';
    if (url.indexOf('//') > -1) origin = url.split('/').slice(0, 3).join('/');
    else origin = url.split('/')[0];
    origin = origin.split('?')[0];
    return origin;
}
let $ca970ce8cf2750a2$var$canvasService;
let $ca970ce8cf2750a2$var$canvasCtx;
const $ca970ce8cf2750a2$var$URL_IN_CSS_REF = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm;
const $ca970ce8cf2750a2$var$URL_PROTOCOL_MATCH = /^(?:[a-z+]+:)?\/\//i;
const $ca970ce8cf2750a2$var$URL_WWW_MATCH = /^www\..*/i;
const $ca970ce8cf2750a2$var$DATA_URI = /^(data:)([^,]*),(.*)/i;
function $ca970ce8cf2750a2$var$absoluteToStylesheet(cssText, href) {
    return (cssText || '').replace($ca970ce8cf2750a2$var$URL_IN_CSS_REF, (origin, quote1, path1, quote2, path2, path3)=>{
        const filePath = path1 || path2 || path3;
        const maybeQuote = quote1 || quote2 || '';
        if (!filePath) return origin;
        if ($ca970ce8cf2750a2$var$URL_PROTOCOL_MATCH.test(filePath) || $ca970ce8cf2750a2$var$URL_WWW_MATCH.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if ($ca970ce8cf2750a2$var$DATA_URI.test(filePath)) return `url(${maybeQuote}${filePath}${maybeQuote})`;
        if (filePath[0] === '/') return `url(${maybeQuote}${$ca970ce8cf2750a2$var$extractOrigin(href) + filePath}${maybeQuote})`;
        const stack = href.split('/');
        const parts = filePath.split('/');
        stack.pop();
        for (const part of parts){
            if (part === '.') continue;
            else if (part === '..') stack.pop();
            else stack.push(part);
        }
        return `url(${maybeQuote}${stack.join('/')}${maybeQuote})`;
    });
}
const $ca970ce8cf2750a2$var$SRCSET_NOT_SPACES = /^[^ \t\n\r\u000c]+/;
const $ca970ce8cf2750a2$var$SRCSET_COMMAS_OR_SPACES = /^[, \t\n\r\u000c]+/;
function $ca970ce8cf2750a2$var$getAbsoluteSrcsetString(doc, attributeValue) {
    if (attributeValue.trim() === '') return attributeValue;
    let pos = 0;
    function collectCharacters(regEx) {
        let chars;
        const match = regEx.exec(attributeValue.substring(pos));
        if (match) {
            chars = match[0];
            pos += chars.length;
            return chars;
        }
        return '';
    }
    const output = [];
    while(true){
        collectCharacters($ca970ce8cf2750a2$var$SRCSET_COMMAS_OR_SPACES);
        if (pos >= attributeValue.length) break;
        let url = collectCharacters($ca970ce8cf2750a2$var$SRCSET_NOT_SPACES);
        if (url.slice(-1) === ',') {
            url = $ca970ce8cf2750a2$var$absoluteToDoc(doc, url.substring(0, url.length - 1));
            output.push(url);
        } else {
            let descriptorsStr = '';
            url = $ca970ce8cf2750a2$var$absoluteToDoc(doc, url);
            let inParens = false;
            while(true){
                const c = attributeValue.charAt(pos);
                if (c === '') {
                    output.push((url + descriptorsStr).trim());
                    break;
                } else if (!inParens) {
                    if (c === ',') {
                        pos += 1;
                        output.push((url + descriptorsStr).trim());
                        break;
                    } else if (c === '(') inParens = true;
                } else if (c === ')') inParens = false;
                descriptorsStr += c;
                pos += 1;
            }
        }
    }
    return output.join(', ');
}
function $ca970ce8cf2750a2$var$absoluteToDoc(doc, attributeValue) {
    if (!attributeValue || attributeValue.trim() === '') return attributeValue;
    const a = doc.createElement('a');
    a.href = attributeValue;
    return a.href;
}
function $ca970ce8cf2750a2$var$isSVGElement(el) {
    return Boolean(el.tagName === 'svg' || el.ownerSVGElement);
}
function $ca970ce8cf2750a2$var$getHref() {
    const a = document.createElement('a');
    a.href = '';
    return a.href;
}
function $ca970ce8cf2750a2$var$transformAttribute(doc, tagName, name, value, element, maskAttributeFn) {
    if (!value) return value;
    if (name === 'src' || name === 'href' && !(tagName === 'use' && value[0] === '#')) return $ca970ce8cf2750a2$var$absoluteToDoc(doc, value);
    else if (name === 'xlink:href' && value[0] !== '#') return $ca970ce8cf2750a2$var$absoluteToDoc(doc, value);
    else if (name === 'background' && (tagName === 'table' || tagName === 'td' || tagName === 'th')) return $ca970ce8cf2750a2$var$absoluteToDoc(doc, value);
    else if (name === 'srcset') return $ca970ce8cf2750a2$var$getAbsoluteSrcsetString(doc, value);
    else if (name === 'style') return $ca970ce8cf2750a2$var$absoluteToStylesheet(value, $ca970ce8cf2750a2$var$getHref());
    else if (tagName === 'object' && name === 'data') return $ca970ce8cf2750a2$var$absoluteToDoc(doc, value);
    if (typeof maskAttributeFn === 'function') return maskAttributeFn(name, value, element);
    return value;
}
function $ca970ce8cf2750a2$var$ignoreAttribute(tagName, name, _value) {
    return (tagName === 'video' || tagName === 'audio') && name === 'autoplay';
}
function $ca970ce8cf2750a2$var$_isBlockedElement(element, blockClass, blockSelector, unblockSelector) {
    try {
        if (unblockSelector && element.matches(unblockSelector)) return false;
        if (typeof blockClass === 'string') {
            if (element.classList.contains(blockClass)) return true;
        } else for(let eIndex = element.classList.length; eIndex--;){
            const className = element.classList[eIndex];
            if (blockClass.test(className)) return true;
        }
        if (blockSelector) return element.matches(blockSelector);
    } catch (e) {}
    return false;
}
function $ca970ce8cf2750a2$var$elementClassMatchesRegex(el, regex) {
    for(let eIndex = el.classList.length; eIndex--;){
        const className = el.classList[eIndex];
        if (regex.test(className)) return true;
    }
    return false;
}
function $ca970ce8cf2750a2$var$distanceToMatch(node, matchPredicate, limit = Infinity, distance = 0) {
    if (!node) return -1;
    if (node.nodeType !== node.ELEMENT_NODE) return -1;
    if (distance > limit) return -1;
    if (matchPredicate(node)) return distance;
    return $ca970ce8cf2750a2$var$distanceToMatch(node.parentNode, matchPredicate, limit, distance + 1);
}
function $ca970ce8cf2750a2$var$createMatchPredicate(className, selector) {
    return (node)=>{
        const el = node;
        if (el === null) return false;
        try {
            if (className) {
                if (typeof className === 'string') {
                    if (el.matches(`.${className}`)) return true;
                } else if ($ca970ce8cf2750a2$var$elementClassMatchesRegex(el, className)) return true;
            }
            if (selector && el.matches(selector)) return true;
            return false;
        } catch (e2) {
            return false;
        }
    };
}
function $ca970ce8cf2750a2$var$needMaskingText(node, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText) {
    try {
        const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
        if (el === null) return false;
        if (el.tagName === 'INPUT') {
            const autocomplete = el.getAttribute('autocomplete');
            const disallowedAutocompleteValues = [
                'current-password',
                'new-password',
                'cc-number',
                'cc-exp',
                'cc-exp-month',
                'cc-exp-year',
                'cc-csc'
            ];
            if (disallowedAutocompleteValues.includes(autocomplete)) return true;
        }
        let maskDistance = -1;
        let unmaskDistance = -1;
        if (maskAllText) {
            unmaskDistance = $ca970ce8cf2750a2$var$distanceToMatch(el, $ca970ce8cf2750a2$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector));
            if (unmaskDistance < 0) return true;
            maskDistance = $ca970ce8cf2750a2$var$distanceToMatch(el, $ca970ce8cf2750a2$var$createMatchPredicate(maskTextClass, maskTextSelector), unmaskDistance >= 0 ? unmaskDistance : Infinity);
        } else {
            maskDistance = $ca970ce8cf2750a2$var$distanceToMatch(el, $ca970ce8cf2750a2$var$createMatchPredicate(maskTextClass, maskTextSelector));
            if (maskDistance < 0) return false;
            unmaskDistance = $ca970ce8cf2750a2$var$distanceToMatch(el, $ca970ce8cf2750a2$var$createMatchPredicate(unmaskTextClass, unmaskTextSelector), maskDistance >= 0 ? maskDistance : Infinity);
        }
        return maskDistance >= 0 ? unmaskDistance >= 0 ? maskDistance <= unmaskDistance : true : unmaskDistance >= 0 ? false : !!maskAllText;
    } catch (e) {}
    return !!maskAllText;
}
function $ca970ce8cf2750a2$var$onceIframeLoaded(iframeEl, listener, iframeLoadTimeout) {
    const win = iframeEl.contentWindow;
    if (!win) return;
    let fired = false;
    let readyState;
    try {
        readyState = win.document.readyState;
    } catch (error) {
        return;
    }
    if (readyState !== 'complete') {
        const timer = setTimeout(()=>{
            if (!fired) {
                listener();
                fired = true;
            }
        }, iframeLoadTimeout);
        iframeEl.addEventListener('load', ()=>{
            clearTimeout(timer);
            fired = true;
            listener();
        });
        return;
    }
    const blankUrl = 'about:blank';
    if (win.location.href !== blankUrl || iframeEl.src === blankUrl || iframeEl.src === '') {
        setTimeout(listener, 0);
        return iframeEl.addEventListener('load', listener);
    }
    iframeEl.addEventListener('load', listener);
}
function $ca970ce8cf2750a2$var$onceStylesheetLoaded(link, listener, styleSheetLoadTimeout) {
    let fired = false;
    let styleSheetLoaded;
    try {
        styleSheetLoaded = link.sheet;
    } catch (error) {
        return;
    }
    if (styleSheetLoaded) return;
    const timer = setTimeout(()=>{
        if (!fired) {
            listener();
            fired = true;
        }
    }, styleSheetLoadTimeout);
    link.addEventListener('load', ()=>{
        clearTimeout(timer);
        fired = true;
        listener();
    });
}
function $ca970ce8cf2750a2$var$serializeNode(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskAttributeFn: maskAttributeFn, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskTextFn: maskTextFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false } = options;
    const rootId = $ca970ce8cf2750a2$var$getRootId(doc, mirror);
    switch(n.nodeType){
        case n.DOCUMENT_NODE:
            if (n.compatMode !== 'CSS1Compat') return {
                type: $ca970ce8cf2750a2$var$NodeType$1.Document,
                childNodes: [],
                compatMode: n.compatMode
            };
            else return {
                type: $ca970ce8cf2750a2$var$NodeType$1.Document,
                childNodes: []
            };
        case n.DOCUMENT_TYPE_NODE:
            return {
                type: $ca970ce8cf2750a2$var$NodeType$1.DocumentType,
                name: n.name,
                publicId: n.publicId,
                systemId: n.systemId,
                rootId: rootId
            };
        case n.ELEMENT_NODE:
            return $ca970ce8cf2750a2$var$serializeElementNode(n, {
                doc: doc,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                inlineStylesheet: inlineStylesheet,
                maskAttributeFn: maskAttributeFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                keepIframeSrcFn: keepIframeSrcFn,
                newlyAddedElement: newlyAddedElement,
                rootId: rootId,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector
            });
        case n.TEXT_NODE:
            return $ca970ce8cf2750a2$var$serializeTextNode(n, {
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskTextFn: maskTextFn,
                maskInputOptions: maskInputOptions,
                maskInputFn: maskInputFn,
                rootId: rootId
            });
        case n.CDATA_SECTION_NODE:
            return {
                type: $ca970ce8cf2750a2$var$NodeType$1.CDATA,
                textContent: '',
                rootId: rootId
            };
        case n.COMMENT_NODE:
            return {
                type: $ca970ce8cf2750a2$var$NodeType$1.Comment,
                textContent: n.textContent || '',
                rootId: rootId
            };
        default:
            return false;
    }
}
function $ca970ce8cf2750a2$var$getRootId(doc, mirror) {
    if (!mirror.hasNode(doc)) return undefined;
    const docId = mirror.getId(doc);
    return docId === 1 ? undefined : docId;
}
function $ca970ce8cf2750a2$var$serializeTextNode(n, options) {
    const { maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, maskTextFn: maskTextFn, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, rootId: rootId } = options;
    const parentTagName = n.parentNode && n.parentNode.tagName;
    let textContent = n.textContent;
    const isStyle = parentTagName === 'STYLE' ? true : undefined;
    const isScript = parentTagName === 'SCRIPT' ? true : undefined;
    const isTextarea = parentTagName === 'TEXTAREA' ? true : undefined;
    if (isStyle && textContent) {
        try {
            if (n.nextSibling || n.previousSibling) ;
            else if ($ca970ce8cf2750a2$var$_optionalChain$5([
                n,
                'access',
                (_6)=>_6.parentNode,
                'access',
                (_7)=>_7.sheet,
                'optionalAccess',
                (_8)=>_8.cssRules
            ])) textContent = $ca970ce8cf2750a2$var$stringifyStylesheet(n.parentNode.sheet);
        } catch (err) {
            console.warn(`Cannot get CSS styles from text's parentNode. Error: ${err}`, n);
        }
        textContent = $ca970ce8cf2750a2$var$absoluteToStylesheet(textContent, $ca970ce8cf2750a2$var$getHref());
    }
    if (isScript) textContent = 'SCRIPT_PLACEHOLDER';
    const forceMask = $ca970ce8cf2750a2$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, maskAllText);
    if (!isStyle && !isScript && !isTextarea && textContent && forceMask) textContent = maskTextFn ? maskTextFn(textContent, n.parentElement) : textContent.replace(/[\S]/g, '*');
    if (isTextarea && textContent && (maskInputOptions.textarea || forceMask)) textContent = maskInputFn ? maskInputFn(textContent, n.parentNode) : textContent.replace(/[\S]/g, '*');
    if (parentTagName === 'OPTION' && textContent) {
        const isInputMasked = $ca970ce8cf2750a2$var$shouldMaskInput({
            type: null,
            tagName: parentTagName,
            maskInputOptions: maskInputOptions
        });
        textContent = $ca970ce8cf2750a2$var$maskInputValue({
            isMasked: $ca970ce8cf2750a2$var$needMaskingText(n, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked),
            element: n,
            value: textContent,
            maskInputFn: maskInputFn
        });
    }
    return {
        type: $ca970ce8cf2750a2$var$NodeType$1.Text,
        textContent: textContent || '',
        isStyle: isStyle,
        rootId: rootId
    };
}
function $ca970ce8cf2750a2$var$serializeElementNode(n, options) {
    const { doc: doc, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, inlineStylesheet: inlineStylesheet, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages, recordCanvas: recordCanvas, keepIframeSrcFn: keepIframeSrcFn, newlyAddedElement: newlyAddedElement = false, rootId: rootId, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector } = options;
    const needBlock = $ca970ce8cf2750a2$var$_isBlockedElement(n, blockClass, blockSelector, unblockSelector);
    const tagName = $ca970ce8cf2750a2$var$getValidTagName(n);
    let attributes = {};
    const len = n.attributes.length;
    for(let i = 0; i < len; i++){
        const attr = n.attributes[i];
        if (attr.name && !$ca970ce8cf2750a2$var$ignoreAttribute(tagName, attr.name, attr.value)) attributes[attr.name] = $ca970ce8cf2750a2$var$transformAttribute(doc, tagName, $ca970ce8cf2750a2$var$toLowerCase(attr.name), attr.value, n, maskAttributeFn);
    }
    if (tagName === 'link' && inlineStylesheet) {
        const stylesheet = Array.from(doc.styleSheets).find((s)=>{
            return s.href === n.href;
        });
        let cssText = null;
        if (stylesheet) cssText = $ca970ce8cf2750a2$var$stringifyStylesheet(stylesheet);
        if (cssText) {
            delete attributes.rel;
            delete attributes.href;
            attributes._cssText = $ca970ce8cf2750a2$var$absoluteToStylesheet(cssText, stylesheet.href);
        }
    }
    if (tagName === 'style' && n.sheet && !(n.innerText || n.textContent || '').trim().length) {
        const cssText = $ca970ce8cf2750a2$var$stringifyStylesheet(n.sheet);
        if (cssText) attributes._cssText = $ca970ce8cf2750a2$var$absoluteToStylesheet(cssText, $ca970ce8cf2750a2$var$getHref());
    }
    if (tagName === 'input' || tagName === 'textarea' || tagName === 'select' || tagName === 'option') {
        const el = n;
        const type = $ca970ce8cf2750a2$var$getInputType(el);
        const value = $ca970ce8cf2750a2$var$getInputValue(el, $ca970ce8cf2750a2$var$toUpperCase(tagName), type);
        const checked = el.checked;
        if (type !== 'submit' && type !== 'button' && value) {
            const forceMask = $ca970ce8cf2750a2$var$needMaskingText(el, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, $ca970ce8cf2750a2$var$shouldMaskInput({
                type: type,
                tagName: $ca970ce8cf2750a2$var$toUpperCase(tagName),
                maskInputOptions: maskInputOptions
            }));
            attributes.value = $ca970ce8cf2750a2$var$maskInputValue({
                isMasked: forceMask,
                element: el,
                value: value,
                maskInputFn: maskInputFn
            });
        }
        if (checked) attributes.checked = checked;
    }
    if (tagName === 'option') {
        if (n.selected && !maskInputOptions['select']) attributes.selected = true;
        else delete attributes.selected;
    }
    if (tagName === 'canvas' && recordCanvas) {
        if (n.__context === '2d') {
            if (!$ca970ce8cf2750a2$var$is2DCanvasBlank(n)) attributes.rr_dataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
        } else if (!('__context' in n)) {
            const canvasDataURL = n.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            const blankCanvas = document.createElement('canvas');
            blankCanvas.width = n.width;
            blankCanvas.height = n.height;
            const blankCanvasDataURL = blankCanvas.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            if (canvasDataURL !== blankCanvasDataURL) attributes.rr_dataURL = canvasDataURL;
        }
    }
    if (tagName === 'img' && inlineImages) {
        if (!$ca970ce8cf2750a2$var$canvasService) {
            $ca970ce8cf2750a2$var$canvasService = doc.createElement('canvas');
            $ca970ce8cf2750a2$var$canvasCtx = $ca970ce8cf2750a2$var$canvasService.getContext('2d');
        }
        const image = n;
        const oldValue = image.crossOrigin;
        image.crossOrigin = 'anonymous';
        const recordInlineImage = ()=>{
            image.removeEventListener('load', recordInlineImage);
            try {
                $ca970ce8cf2750a2$var$canvasService.width = image.naturalWidth;
                $ca970ce8cf2750a2$var$canvasService.height = image.naturalHeight;
                $ca970ce8cf2750a2$var$canvasCtx.drawImage(image, 0, 0);
                attributes.rr_dataURL = $ca970ce8cf2750a2$var$canvasService.toDataURL(dataURLOptions.type, dataURLOptions.quality);
            } catch (err) {
                console.warn(`Cannot inline img src=${image.currentSrc}! Error: ${err}`);
            }
            oldValue ? attributes.crossOrigin = oldValue : image.removeAttribute('crossorigin');
        };
        if (image.complete && image.naturalWidth !== 0) recordInlineImage();
        else image.addEventListener('load', recordInlineImage);
    }
    if (tagName === 'audio' || tagName === 'video') {
        attributes.rr_mediaState = n.paused ? 'paused' : 'played';
        attributes.rr_mediaCurrentTime = n.currentTime;
    }
    if (!newlyAddedElement) {
        if (n.scrollLeft) attributes.rr_scrollLeft = n.scrollLeft;
        if (n.scrollTop) attributes.rr_scrollTop = n.scrollTop;
    }
    if (needBlock) {
        const { width: width, height: height } = n.getBoundingClientRect();
        attributes = {
            class: attributes.class,
            rr_width: `${width}px`,
            rr_height: `${height}px`
        };
    }
    if (tagName === 'iframe' && !keepIframeSrcFn(attributes.src)) {
        if (!n.contentDocument) attributes.rr_src = attributes.src;
        delete attributes.src;
    }
    let isCustomElement;
    try {
        if (customElements.get(tagName)) isCustomElement = true;
    } catch (e) {}
    return {
        type: $ca970ce8cf2750a2$var$NodeType$1.Element,
        tagName: tagName,
        attributes: attributes,
        childNodes: [],
        isSVG: $ca970ce8cf2750a2$var$isSVGElement(n) || undefined,
        needBlock: needBlock,
        rootId: rootId,
        isCustom: isCustomElement
    };
}
function $ca970ce8cf2750a2$var$lowerIfExists(maybeAttr) {
    if (maybeAttr === undefined || maybeAttr === null) return '';
    else return maybeAttr.toLowerCase();
}
function $ca970ce8cf2750a2$var$slimDOMExcluded(sn, slimDOMOptions) {
    if (slimDOMOptions.comment && sn.type === $ca970ce8cf2750a2$var$NodeType$1.Comment) return true;
    else if (sn.type === $ca970ce8cf2750a2$var$NodeType$1.Element) {
        if (slimDOMOptions.script && (sn.tagName === 'script' || sn.tagName === 'link' && (sn.attributes.rel === 'preload' || sn.attributes.rel === 'modulepreload') && sn.attributes.as === 'script' || sn.tagName === 'link' && sn.attributes.rel === 'prefetch' && typeof sn.attributes.href === 'string' && sn.attributes.href.endsWith('.js'))) return true;
        else if (slimDOMOptions.headFavicon && (sn.tagName === 'link' && sn.attributes.rel === 'shortcut icon' || sn.tagName === 'meta' && ($ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name).match(/^msapplication-tile(image|color)$/) || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'application-name' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.rel) === 'icon' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.rel) === 'apple-touch-icon' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.rel) === 'shortcut icon'))) return true;
        else if (sn.tagName === 'meta') {
            if (slimDOMOptions.headMetaDescKeywords && $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name).match(/^description|keywords$/)) return true;
            else if (slimDOMOptions.headMetaSocial && ($ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.property).match(/^(og|twitter|fb):/) || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name).match(/^(og|twitter):/) || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'pinterest')) return true;
            else if (slimDOMOptions.headMetaRobots && ($ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'robots' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'googlebot' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'bingbot')) return true;
            else if (slimDOMOptions.headMetaHttpEquiv && sn.attributes['http-equiv'] !== undefined) return true;
            else if (slimDOMOptions.headMetaAuthorship && ($ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'author' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'generator' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'framework' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'publisher' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'progid' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.property).match(/^article:/) || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.property).match(/^product:/))) return true;
            else if (slimDOMOptions.headMetaVerification && ($ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'google-site-verification' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'yandex-verification' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'csrf-token' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'p:domain_verify' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'verify-v1' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'verification' || $ca970ce8cf2750a2$var$lowerIfExists(sn.attributes.name) === 'shopify-checkout-api-token')) return true;
        }
    }
    return false;
}
function $ca970ce8cf2750a2$var$serializeNodeWithId(n, options) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, maskAllText: maskAllText, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector, skipChild: skipChild = false, inlineStylesheet: inlineStylesheet = true, maskInputOptions: maskInputOptions = {}, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOMOptions: slimDOMOptions, dataURLOptions: dataURLOptions = {}, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout = 5000, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout = 5000, keepIframeSrcFn: keepIframeSrcFn = ()=>false, newlyAddedElement: newlyAddedElement = false } = options;
    let { preserveWhiteSpace: preserveWhiteSpace = true } = options;
    const _serializedNode = $ca970ce8cf2750a2$var$serializeNode(n, {
        doc: doc,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        maskAllText: maskAllText,
        unblockSelector: unblockSelector,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: newlyAddedElement
    });
    if (!_serializedNode) {
        console.warn(n, 'not serialized');
        return null;
    }
    let id;
    if (mirror.hasNode(n)) id = mirror.getId(n);
    else if ($ca970ce8cf2750a2$var$slimDOMExcluded(_serializedNode, slimDOMOptions) || !preserveWhiteSpace && _serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Text && !_serializedNode.isStyle && !_serializedNode.textContent.replace(/^\s+|\s+$/gm, '').length) id = $ca970ce8cf2750a2$var$IGNORED_NODE;
    else id = $ca970ce8cf2750a2$var$genId();
    const serializedNode = Object.assign(_serializedNode, {
        id: id
    });
    mirror.add(n, serializedNode);
    if (id === $ca970ce8cf2750a2$var$IGNORED_NODE) return null;
    if (onSerialize) onSerialize(n);
    let recordChild = !skipChild;
    if (serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Element) {
        recordChild = recordChild && !serializedNode.needBlock;
        delete serializedNode.needBlock;
        const shadowRoot = n.shadowRoot;
        if (shadowRoot && $ca970ce8cf2750a2$var$isNativeShadowDom(shadowRoot)) serializedNode.isShadowHost = true;
    }
    if ((serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Document || serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Element) && recordChild) {
        if (slimDOMOptions.headWhitespace && serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Element && serializedNode.tagName === 'head') preserveWhiteSpace = false;
        const bypassOptions = {
            doc: doc,
            mirror: mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            maskAllText: maskAllText,
            unblockSelector: unblockSelector,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            skipChild: skipChild,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            slimDOMOptions: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            inlineImages: inlineImages,
            recordCanvas: recordCanvas,
            preserveWhiteSpace: preserveWhiteSpace,
            onSerialize: onSerialize,
            onIframeLoad: onIframeLoad,
            iframeLoadTimeout: iframeLoadTimeout,
            onStylesheetLoad: onStylesheetLoad,
            stylesheetLoadTimeout: stylesheetLoadTimeout,
            keepIframeSrcFn: keepIframeSrcFn
        };
        for (const childN of Array.from(n.childNodes)){
            const serializedChildNode = $ca970ce8cf2750a2$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) serializedNode.childNodes.push(serializedChildNode);
        }
        if ($ca970ce8cf2750a2$var$isElement$1(n) && n.shadowRoot) for (const childN of Array.from(n.shadowRoot.childNodes)){
            const serializedChildNode = $ca970ce8cf2750a2$var$serializeNodeWithId(childN, bypassOptions);
            if (serializedChildNode) {
                $ca970ce8cf2750a2$var$isNativeShadowDom(n.shadowRoot) && (serializedChildNode.isShadow = true);
                serializedNode.childNodes.push(serializedChildNode);
            }
        }
    }
    if (n.parentNode && $ca970ce8cf2750a2$var$isShadowRoot(n.parentNode) && $ca970ce8cf2750a2$var$isNativeShadowDom(n.parentNode)) serializedNode.isShadow = true;
    if (serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Element && serializedNode.tagName === 'iframe') $ca970ce8cf2750a2$var$onceIframeLoaded(n, ()=>{
        const iframeDoc = n.contentDocument;
        if (iframeDoc && onIframeLoad) {
            const serializedIframeNode = $ca970ce8cf2750a2$var$serializeNodeWithId(iframeDoc, {
                doc: iframeDoc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedIframeNode) onIframeLoad(n, serializedIframeNode);
        }
    }, iframeLoadTimeout);
    if (serializedNode.type === $ca970ce8cf2750a2$var$NodeType$1.Element && serializedNode.tagName === 'link' && serializedNode.attributes.rel === 'stylesheet') $ca970ce8cf2750a2$var$onceStylesheetLoaded(n, ()=>{
        if (onStylesheetLoad) {
            const serializedLinkNode = $ca970ce8cf2750a2$var$serializeNodeWithId(n, {
                doc: doc,
                mirror: mirror,
                blockClass: blockClass,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                skipChild: false,
                inlineStylesheet: inlineStylesheet,
                maskInputOptions: maskInputOptions,
                maskAttributeFn: maskAttributeFn,
                maskTextFn: maskTextFn,
                maskInputFn: maskInputFn,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                inlineImages: inlineImages,
                recordCanvas: recordCanvas,
                preserveWhiteSpace: preserveWhiteSpace,
                onSerialize: onSerialize,
                onIframeLoad: onIframeLoad,
                iframeLoadTimeout: iframeLoadTimeout,
                onStylesheetLoad: onStylesheetLoad,
                stylesheetLoadTimeout: stylesheetLoadTimeout,
                keepIframeSrcFn: keepIframeSrcFn
            });
            if (serializedLinkNode) onStylesheetLoad(n, serializedLinkNode);
        }
    }, stylesheetLoadTimeout);
    return serializedNode;
}
function $ca970ce8cf2750a2$var$snapshot(n, options) {
    const { mirror: mirror = new $ca970ce8cf2750a2$var$Mirror(), blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, inlineImages: inlineImages = false, recordCanvas: recordCanvas = false, maskAllInputs: maskAllInputs = false, maskAttributeFn: maskAttributeFn, maskTextFn: maskTextFn, maskInputFn: maskInputFn, slimDOM: slimDOM = false, dataURLOptions: dataURLOptions, preserveWhiteSpace: preserveWhiteSpace, onSerialize: onSerialize, onIframeLoad: onIframeLoad, iframeLoadTimeout: iframeLoadTimeout, onStylesheetLoad: onStylesheetLoad, stylesheetLoadTimeout: stylesheetLoadTimeout, keepIframeSrcFn: keepIframeSrcFn = ()=>false } = options || {};
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true
    } : maskAllInputs === false ? {} : maskAllInputs;
    const slimDOMOptions = slimDOM === true || slimDOM === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaDescKeywords: slimDOM === 'all',
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaAuthorship: true,
        headMetaVerification: true
    } : slimDOM === false ? {} : slimDOM;
    return $ca970ce8cf2750a2$var$serializeNodeWithId(n, {
        doc: n,
        mirror: mirror,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maskAllText: maskAllText,
        maskTextClass: maskTextClass,
        unmaskTextClass: unmaskTextClass,
        maskTextSelector: maskTextSelector,
        unmaskTextSelector: unmaskTextSelector,
        skipChild: false,
        inlineStylesheet: inlineStylesheet,
        maskInputOptions: maskInputOptions,
        maskAttributeFn: maskAttributeFn,
        maskTextFn: maskTextFn,
        maskInputFn: maskInputFn,
        slimDOMOptions: slimDOMOptions,
        dataURLOptions: dataURLOptions,
        inlineImages: inlineImages,
        recordCanvas: recordCanvas,
        preserveWhiteSpace: preserveWhiteSpace,
        onSerialize: onSerialize,
        onIframeLoad: onIframeLoad,
        iframeLoadTimeout: iframeLoadTimeout,
        onStylesheetLoad: onStylesheetLoad,
        stylesheetLoadTimeout: stylesheetLoadTimeout,
        keepIframeSrcFn: keepIframeSrcFn,
        newlyAddedElement: false
    });
}
function $ca970ce8cf2750a2$var$_optionalChain$4(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $ca970ce8cf2750a2$var$on(type, fn, target = document) {
    const options = {
        capture: true,
        passive: true
    };
    target.addEventListener(type, fn, options);
    return ()=>target.removeEventListener(type, fn, options);
}
const $ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING = "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.";
let $ca970ce8cf2750a2$var$_mirror = {
    map: {},
    getId () {
        console.error($ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return -1;
    },
    getNode () {
        console.error($ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return null;
    },
    removeNodeFromMap () {
        console.error($ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING);
    },
    has () {
        console.error($ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return false;
    },
    reset () {
        console.error($ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING);
    }
};
if (typeof window !== 'undefined' && window.Proxy && window.Reflect) $ca970ce8cf2750a2$var$_mirror = new Proxy($ca970ce8cf2750a2$var$_mirror, {
    get (target, prop, receiver) {
        if (prop === 'map') console.error($ca970ce8cf2750a2$var$DEPARTED_MIRROR_ACCESS_WARNING);
        return Reflect.get(target, prop, receiver);
    }
});
function $ca970ce8cf2750a2$var$throttle$1(func, wait, options = {}) {
    let timeout = null;
    let previous = 0;
    return function(...args) {
        const now = Date.now();
        if (!previous && options.leading === false) previous = now;
        const remaining = wait - (now - previous);
        const context = this;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                $ca970ce8cf2750a2$var$clearTimeout$1(timeout);
                timeout = null;
            }
            previous = now;
            func.apply(context, args);
        } else if (!timeout && options.trailing !== false) timeout = $ca970ce8cf2750a2$var$setTimeout$1(()=>{
            previous = options.leading === false ? 0 : Date.now();
            timeout = null;
            func.apply(context, args);
        }, remaining);
    };
}
function $ca970ce8cf2750a2$var$hookSetter(target, key, d, isRevoked, win = window) {
    const original = win.Object.getOwnPropertyDescriptor(target, key);
    win.Object.defineProperty(target, key, isRevoked ? d : {
        set (value) {
            $ca970ce8cf2750a2$var$setTimeout$1(()=>{
                d.set.call(this, value);
            }, 0);
            if (original && original.set) original.set.call(this, value);
        }
    });
    return ()=>$ca970ce8cf2750a2$var$hookSetter(target, key, original || {}, true);
}
function $ca970ce8cf2750a2$var$patch(source, name, replacement) {
    try {
        if (!(name in source)) return ()=>{};
        const original = source[name];
        const wrapped = replacement(original);
        if (typeof wrapped === 'function') {
            wrapped.prototype = wrapped.prototype || {};
            Object.defineProperties(wrapped, {
                __rrweb_original__: {
                    enumerable: false,
                    value: original
                }
            });
        }
        source[name] = wrapped;
        return ()=>{
            source[name] = original;
        };
    } catch (e2) {
        return ()=>{};
    }
}
let $ca970ce8cf2750a2$var$nowTimestamp = Date.now;
if (!/[1-9][0-9]{12}/.test(Date.now().toString())) $ca970ce8cf2750a2$var$nowTimestamp = ()=>new Date().getTime();
function $ca970ce8cf2750a2$var$getWindowScroll(win) {
    const doc = win.document;
    return {
        left: doc.scrollingElement ? doc.scrollingElement.scrollLeft : win.pageXOffset !== undefined ? win.pageXOffset : $ca970ce8cf2750a2$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_)=>_.documentElement,
            'access',
            (_2)=>_2.scrollLeft
        ]) || $ca970ce8cf2750a2$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_3)=>_3.body,
            'optionalAccess',
            (_4)=>_4.parentElement,
            'optionalAccess',
            (_5)=>_5.scrollLeft
        ]) || $ca970ce8cf2750a2$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_6)=>_6.body,
            'optionalAccess',
            (_7)=>_7.scrollLeft
        ]) || 0,
        top: doc.scrollingElement ? doc.scrollingElement.scrollTop : win.pageYOffset !== undefined ? win.pageYOffset : $ca970ce8cf2750a2$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_8)=>_8.documentElement,
            'access',
            (_9)=>_9.scrollTop
        ]) || $ca970ce8cf2750a2$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_10)=>_10.body,
            'optionalAccess',
            (_11)=>_11.parentElement,
            'optionalAccess',
            (_12)=>_12.scrollTop
        ]) || $ca970ce8cf2750a2$var$_optionalChain$4([
            doc,
            'optionalAccess',
            (_13)=>_13.body,
            'optionalAccess',
            (_14)=>_14.scrollTop
        ]) || 0
    };
}
function $ca970ce8cf2750a2$var$getWindowHeight() {
    return window.innerHeight || document.documentElement && document.documentElement.clientHeight || document.body && document.body.clientHeight;
}
function $ca970ce8cf2750a2$var$getWindowWidth() {
    return window.innerWidth || document.documentElement && document.documentElement.clientWidth || document.body && document.body.clientWidth;
}
function $ca970ce8cf2750a2$var$closestElementOfNode(node) {
    if (!node) return null;
    const el = node.nodeType === node.ELEMENT_NODE ? node : node.parentElement;
    return el;
}
function $ca970ce8cf2750a2$var$isBlocked(node, blockClass, blockSelector, unblockSelector, checkAncestors) {
    if (!node) return false;
    const el = $ca970ce8cf2750a2$var$closestElementOfNode(node);
    if (!el) return false;
    const blockedPredicate = $ca970ce8cf2750a2$var$createMatchPredicate(blockClass, blockSelector);
    if (!checkAncestors) {
        const isUnblocked = unblockSelector && el.matches(unblockSelector);
        return blockedPredicate(el) && !isUnblocked;
    }
    const blockDistance = $ca970ce8cf2750a2$var$distanceToMatch(el, blockedPredicate);
    let unblockDistance = -1;
    if (blockDistance < 0) return false;
    if (unblockSelector) unblockDistance = $ca970ce8cf2750a2$var$distanceToMatch(el, $ca970ce8cf2750a2$var$createMatchPredicate(null, unblockSelector));
    if (blockDistance > -1 && unblockDistance < 0) return true;
    return blockDistance < unblockDistance;
}
function $ca970ce8cf2750a2$var$isSerialized(n, mirror) {
    return mirror.getId(n) !== -1;
}
function $ca970ce8cf2750a2$var$isIgnored(n, mirror) {
    return mirror.getId(n) === $ca970ce8cf2750a2$var$IGNORED_NODE;
}
function $ca970ce8cf2750a2$var$isAncestorRemoved(target, mirror) {
    if ($ca970ce8cf2750a2$var$isShadowRoot(target)) return false;
    const id = mirror.getId(target);
    if (!mirror.has(id)) return true;
    if (target.parentNode && target.parentNode.nodeType === target.DOCUMENT_NODE) return false;
    if (!target.parentNode) return true;
    return $ca970ce8cf2750a2$var$isAncestorRemoved(target.parentNode, mirror);
}
function $ca970ce8cf2750a2$var$legacy_isTouchEvent(event) {
    return Boolean(event.changedTouches);
}
function $ca970ce8cf2750a2$var$polyfill(win = window) {
    if ('NodeList' in win && !win.NodeList.prototype.forEach) win.NodeList.prototype.forEach = Array.prototype.forEach;
    if ('DOMTokenList' in win && !win.DOMTokenList.prototype.forEach) win.DOMTokenList.prototype.forEach = Array.prototype.forEach;
    if (!Node.prototype.contains) Node.prototype.contains = (...args)=>{
        let node = args[0];
        if (!(0 in args)) throw new TypeError('1 argument is required');
        do {
            if (this === node) return true;
        }while (node = node && node.parentNode);
        return false;
    };
}
function $ca970ce8cf2750a2$var$isSerializedIframe(n, mirror) {
    return Boolean(n.nodeName === 'IFRAME' && mirror.getMeta(n));
}
function $ca970ce8cf2750a2$var$isSerializedStylesheet(n, mirror) {
    return Boolean(n.nodeName === 'LINK' && n.nodeType === n.ELEMENT_NODE && n.getAttribute && n.getAttribute('rel') === 'stylesheet' && mirror.getMeta(n));
}
function $ca970ce8cf2750a2$var$hasShadowRoot(n) {
    return Boolean($ca970ce8cf2750a2$var$_optionalChain$4([
        n,
        'optionalAccess',
        (_18)=>_18.shadowRoot
    ]));
}
class $ca970ce8cf2750a2$var$StyleSheetMirror {
    constructor(){
        this.id = 1;
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
    }
    getId(stylesheet) {
        return (0, $25a605f9795290da$export$8db64e83cc1a933c)(this.styleIDMap.get(stylesheet), ()=>-1);
    }
    has(stylesheet) {
        return this.styleIDMap.has(stylesheet);
    }
    add(stylesheet, id) {
        if (this.has(stylesheet)) return this.getId(stylesheet);
        let newId;
        if (id === undefined) newId = this.id++;
        else newId = id;
        this.styleIDMap.set(stylesheet, newId);
        this.idStyleMap.set(newId, stylesheet);
        return newId;
    }
    getStyle(id) {
        return this.idStyleMap.get(id) || null;
    }
    reset() {
        this.styleIDMap = new WeakMap();
        this.idStyleMap = new Map();
        this.id = 1;
    }
    generateId() {
        return this.id++;
    }
}
function $ca970ce8cf2750a2$var$getShadowHost(n) {
    let shadowHost = null;
    if ($ca970ce8cf2750a2$var$_optionalChain$4([
        n,
        'access',
        (_19)=>_19.getRootNode,
        'optionalCall',
        (_20)=>_20(),
        'optionalAccess',
        (_21)=>_21.nodeType
    ]) === Node.DOCUMENT_FRAGMENT_NODE && n.getRootNode().host) shadowHost = n.getRootNode().host;
    return shadowHost;
}
function $ca970ce8cf2750a2$var$getRootShadowHost(n) {
    let rootShadowHost = n;
    let shadowHost;
    while(shadowHost = $ca970ce8cf2750a2$var$getShadowHost(rootShadowHost))rootShadowHost = shadowHost;
    return rootShadowHost;
}
function $ca970ce8cf2750a2$var$shadowHostInDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    const shadowHost = $ca970ce8cf2750a2$var$getRootShadowHost(n);
    return doc.contains(shadowHost);
}
function $ca970ce8cf2750a2$var$inDom(n) {
    const doc = n.ownerDocument;
    if (!doc) return false;
    return doc.contains(n) || $ca970ce8cf2750a2$var$shadowHostInDom(n);
}
const $ca970ce8cf2750a2$var$cachedImplementations = {};
function $ca970ce8cf2750a2$var$getImplementation(name) {
    const cached = $ca970ce8cf2750a2$var$cachedImplementations[name];
    if (cached) return cached;
    const document1 = window.document;
    let impl = window[name];
    if (document1 && typeof document1.createElement === 'function') try {
        const sandbox = document1.createElement('iframe');
        sandbox.hidden = true;
        document1.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow[name]) impl = contentWindow[name];
        document1.head.removeChild(sandbox);
    } catch (e) {}
    return $ca970ce8cf2750a2$var$cachedImplementations[name] = impl.bind(window);
}
function $ca970ce8cf2750a2$var$onRequestAnimationFrame(...rest) {
    return $ca970ce8cf2750a2$var$getImplementation('requestAnimationFrame')(...rest);
}
function $ca970ce8cf2750a2$var$setTimeout$1(...rest) {
    return $ca970ce8cf2750a2$var$getImplementation('setTimeout')(...rest);
}
function $ca970ce8cf2750a2$var$clearTimeout$1(...rest) {
    return $ca970ce8cf2750a2$var$getImplementation('clearTimeout')(...rest);
}
var $ca970ce8cf2750a2$var$EventType = /* @__PURE__ */ ((EventType2)=>{
    EventType2[EventType2["DomContentLoaded"] = 0] = "DomContentLoaded";
    EventType2[EventType2["Load"] = 1] = "Load";
    EventType2[EventType2["FullSnapshot"] = 2] = "FullSnapshot";
    EventType2[EventType2["IncrementalSnapshot"] = 3] = "IncrementalSnapshot";
    EventType2[EventType2["Meta"] = 4] = "Meta";
    EventType2[EventType2["Custom"] = 5] = "Custom";
    EventType2[EventType2["Plugin"] = 6] = "Plugin";
    return EventType2;
})($ca970ce8cf2750a2$var$EventType || {});
var $ca970ce8cf2750a2$var$IncrementalSource = /* @__PURE__ */ ((IncrementalSource2)=>{
    IncrementalSource2[IncrementalSource2["Mutation"] = 0] = "Mutation";
    IncrementalSource2[IncrementalSource2["MouseMove"] = 1] = "MouseMove";
    IncrementalSource2[IncrementalSource2["MouseInteraction"] = 2] = "MouseInteraction";
    IncrementalSource2[IncrementalSource2["Scroll"] = 3] = "Scroll";
    IncrementalSource2[IncrementalSource2["ViewportResize"] = 4] = "ViewportResize";
    IncrementalSource2[IncrementalSource2["Input"] = 5] = "Input";
    IncrementalSource2[IncrementalSource2["TouchMove"] = 6] = "TouchMove";
    IncrementalSource2[IncrementalSource2["MediaInteraction"] = 7] = "MediaInteraction";
    IncrementalSource2[IncrementalSource2["StyleSheetRule"] = 8] = "StyleSheetRule";
    IncrementalSource2[IncrementalSource2["CanvasMutation"] = 9] = "CanvasMutation";
    IncrementalSource2[IncrementalSource2["Font"] = 10] = "Font";
    IncrementalSource2[IncrementalSource2["Log"] = 11] = "Log";
    IncrementalSource2[IncrementalSource2["Drag"] = 12] = "Drag";
    IncrementalSource2[IncrementalSource2["StyleDeclaration"] = 13] = "StyleDeclaration";
    IncrementalSource2[IncrementalSource2["Selection"] = 14] = "Selection";
    IncrementalSource2[IncrementalSource2["AdoptedStyleSheet"] = 15] = "AdoptedStyleSheet";
    IncrementalSource2[IncrementalSource2["CustomElement"] = 16] = "CustomElement";
    return IncrementalSource2;
})($ca970ce8cf2750a2$var$IncrementalSource || {});
var $ca970ce8cf2750a2$var$MouseInteractions = /* @__PURE__ */ ((MouseInteractions2)=>{
    MouseInteractions2[MouseInteractions2["MouseUp"] = 0] = "MouseUp";
    MouseInteractions2[MouseInteractions2["MouseDown"] = 1] = "MouseDown";
    MouseInteractions2[MouseInteractions2["Click"] = 2] = "Click";
    MouseInteractions2[MouseInteractions2["ContextMenu"] = 3] = "ContextMenu";
    MouseInteractions2[MouseInteractions2["DblClick"] = 4] = "DblClick";
    MouseInteractions2[MouseInteractions2["Focus"] = 5] = "Focus";
    MouseInteractions2[MouseInteractions2["Blur"] = 6] = "Blur";
    MouseInteractions2[MouseInteractions2["TouchStart"] = 7] = "TouchStart";
    MouseInteractions2[MouseInteractions2["TouchMove_Departed"] = 8] = "TouchMove_Departed";
    MouseInteractions2[MouseInteractions2["TouchEnd"] = 9] = "TouchEnd";
    MouseInteractions2[MouseInteractions2["TouchCancel"] = 10] = "TouchCancel";
    return MouseInteractions2;
})($ca970ce8cf2750a2$var$MouseInteractions || {});
var $ca970ce8cf2750a2$var$PointerTypes = /* @__PURE__ */ ((PointerTypes2)=>{
    PointerTypes2[PointerTypes2["Mouse"] = 0] = "Mouse";
    PointerTypes2[PointerTypes2["Pen"] = 1] = "Pen";
    PointerTypes2[PointerTypes2["Touch"] = 2] = "Touch";
    return PointerTypes2;
})($ca970ce8cf2750a2$var$PointerTypes || {});
function $ca970ce8cf2750a2$var$_optionalChain$3(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
function $ca970ce8cf2750a2$var$isNodeInLinkedList(n) {
    return '__ln' in n;
}
class $ca970ce8cf2750a2$var$DoubleLinkedList {
    constructor(){
        this.length = 0;
        this.head = null;
        this.tail = null;
    }
    get(position) {
        if (position >= this.length) throw new Error('Position outside of list range');
        let current = this.head;
        for(let index = 0; index < position; index++)current = $ca970ce8cf2750a2$var$_optionalChain$3([
            current,
            'optionalAccess',
            (_)=>_.next
        ]) || null;
        return current;
    }
    addNode(n) {
        const node = {
            value: n,
            previous: null,
            next: null
        };
        n.__ln = node;
        if (n.previousSibling && $ca970ce8cf2750a2$var$isNodeInLinkedList(n.previousSibling)) {
            const current = n.previousSibling.__ln.next;
            node.next = current;
            node.previous = n.previousSibling.__ln;
            n.previousSibling.__ln.next = node;
            if (current) current.previous = node;
        } else if (n.nextSibling && $ca970ce8cf2750a2$var$isNodeInLinkedList(n.nextSibling) && n.nextSibling.__ln.previous) {
            const current = n.nextSibling.__ln.previous;
            node.previous = current;
            node.next = n.nextSibling.__ln;
            n.nextSibling.__ln.previous = node;
            if (current) current.next = node;
        } else {
            if (this.head) this.head.previous = node;
            node.next = this.head;
            this.head = node;
        }
        if (node.next === null) this.tail = node;
        this.length++;
    }
    removeNode(n) {
        const current = n.__ln;
        if (!this.head) return;
        if (!current.previous) {
            this.head = current.next;
            if (this.head) this.head.previous = null;
            else this.tail = null;
        } else {
            current.previous.next = current.next;
            if (current.next) current.next.previous = current.previous;
            else this.tail = current.previous;
        }
        if (n.__ln) delete n.__ln;
        this.length--;
    }
}
const $ca970ce8cf2750a2$var$moveKey = (id, parentId)=>`${id}@${parentId}`;
class $ca970ce8cf2750a2$var$MutationBuffer {
    constructor(){
        this.frozen = false;
        this.locked = false;
        this.texts = [];
        this.attributes = [];
        this.attributeMap = new WeakMap();
        this.removes = [];
        this.mapRemoves = [];
        this.movedMap = {};
        this.addedSet = new Set();
        this.movedSet = new Set();
        this.droppedSet = new Set();
        this.processMutations = (mutations)=>{
            mutations.forEach(this.processMutation);
            this.emit();
        };
        this.emit = ()=>{
            if (this.frozen || this.locked) return;
            const adds = [];
            const addedIds = new Set();
            const addList = new $ca970ce8cf2750a2$var$DoubleLinkedList();
            const getNextId = (n)=>{
                let ns = n;
                let nextId = $ca970ce8cf2750a2$var$IGNORED_NODE;
                while(nextId === $ca970ce8cf2750a2$var$IGNORED_NODE){
                    ns = ns && ns.nextSibling;
                    nextId = ns && this.mirror.getId(ns);
                }
                return nextId;
            };
            const pushAdd = (n)=>{
                if (!n.parentNode || !$ca970ce8cf2750a2$var$inDom(n)) return;
                const parentId = $ca970ce8cf2750a2$var$isShadowRoot(n.parentNode) ? this.mirror.getId($ca970ce8cf2750a2$var$getShadowHost(n)) : this.mirror.getId(n.parentNode);
                const nextId = getNextId(n);
                if (parentId === -1 || nextId === -1) return addList.addNode(n);
                const sn = $ca970ce8cf2750a2$var$serializeNodeWithId(n, {
                    doc: this.doc,
                    mirror: this.mirror,
                    blockClass: this.blockClass,
                    blockSelector: this.blockSelector,
                    maskAllText: this.maskAllText,
                    unblockSelector: this.unblockSelector,
                    maskTextClass: this.maskTextClass,
                    unmaskTextClass: this.unmaskTextClass,
                    maskTextSelector: this.maskTextSelector,
                    unmaskTextSelector: this.unmaskTextSelector,
                    skipChild: true,
                    newlyAddedElement: true,
                    inlineStylesheet: this.inlineStylesheet,
                    maskInputOptions: this.maskInputOptions,
                    maskAttributeFn: this.maskAttributeFn,
                    maskTextFn: this.maskTextFn,
                    maskInputFn: this.maskInputFn,
                    slimDOMOptions: this.slimDOMOptions,
                    dataURLOptions: this.dataURLOptions,
                    recordCanvas: this.recordCanvas,
                    inlineImages: this.inlineImages,
                    onSerialize: (currentN)=>{
                        if ($ca970ce8cf2750a2$var$isSerializedIframe(currentN, this.mirror)) this.iframeManager.addIframe(currentN);
                        if ($ca970ce8cf2750a2$var$isSerializedStylesheet(currentN, this.mirror)) this.stylesheetManager.trackLinkElement(currentN);
                        if ($ca970ce8cf2750a2$var$hasShadowRoot(n)) this.shadowDomManager.addShadowRoot(n.shadowRoot, this.doc);
                    },
                    onIframeLoad: (iframe, childSn)=>{
                        this.iframeManager.attachIframe(iframe, childSn);
                        this.shadowDomManager.observeAttachShadow(iframe);
                    },
                    onStylesheetLoad: (link, childSn)=>{
                        this.stylesheetManager.attachLinkElement(link, childSn);
                    }
                });
                if (sn) {
                    adds.push({
                        parentId: parentId,
                        nextId: nextId,
                        node: sn
                    });
                    addedIds.add(sn.id);
                }
            };
            while(this.mapRemoves.length)this.mirror.removeNodeFromMap(this.mapRemoves.shift());
            for (const n of this.movedSet){
                if ($ca970ce8cf2750a2$var$isParentRemoved(this.removes, n, this.mirror) && !this.movedSet.has(n.parentNode)) continue;
                pushAdd(n);
            }
            for (const n of this.addedSet){
                if (!$ca970ce8cf2750a2$var$isAncestorInSet(this.droppedSet, n) && !$ca970ce8cf2750a2$var$isParentRemoved(this.removes, n, this.mirror)) pushAdd(n);
                else if ($ca970ce8cf2750a2$var$isAncestorInSet(this.movedSet, n)) pushAdd(n);
                else this.droppedSet.add(n);
            }
            let candidate = null;
            while(addList.length){
                let node = null;
                if (candidate) {
                    const parentId = this.mirror.getId(candidate.value.parentNode);
                    const nextId = getNextId(candidate.value);
                    if (parentId !== -1 && nextId !== -1) node = candidate;
                }
                if (!node) {
                    let tailNode = addList.tail;
                    while(tailNode){
                        const _node = tailNode;
                        tailNode = tailNode.previous;
                        if (_node) {
                            const parentId = this.mirror.getId(_node.value.parentNode);
                            const nextId = getNextId(_node.value);
                            if (nextId === -1) continue;
                            else if (parentId !== -1) {
                                node = _node;
                                break;
                            } else {
                                const unhandledNode = _node.value;
                                if (unhandledNode.parentNode && unhandledNode.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                                    const shadowHost = unhandledNode.parentNode.host;
                                    const parentId = this.mirror.getId(shadowHost);
                                    if (parentId !== -1) {
                                        node = _node;
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
                if (!node) {
                    while(addList.head)addList.removeNode(addList.head.value);
                    break;
                }
                candidate = node.previous;
                addList.removeNode(node.value);
                pushAdd(node.value);
            }
            const payload = {
                texts: this.texts.map((text)=>({
                        id: this.mirror.getId(text.node),
                        value: text.value
                    })).filter((text)=>!addedIds.has(text.id)).filter((text)=>this.mirror.has(text.id)),
                attributes: this.attributes.map((attribute)=>{
                    const { attributes: attributes } = attribute;
                    if (typeof attributes.style === 'string') {
                        const diffAsStr = JSON.stringify(attribute.styleDiff);
                        const unchangedAsStr = JSON.stringify(attribute._unchangedStyles);
                        if (diffAsStr.length < attributes.style.length) {
                            if ((diffAsStr + unchangedAsStr).split('var(').length === attributes.style.split('var(').length) attributes.style = attribute.styleDiff;
                        }
                    }
                    return {
                        id: this.mirror.getId(attribute.node),
                        attributes: attributes
                    };
                }).filter((attribute)=>!addedIds.has(attribute.id)).filter((attribute)=>this.mirror.has(attribute.id)),
                removes: this.removes,
                adds: adds
            };
            if (!payload.texts.length && !payload.attributes.length && !payload.removes.length && !payload.adds.length) return;
            this.texts = [];
            this.attributes = [];
            this.attributeMap = new WeakMap();
            this.removes = [];
            this.addedSet = new Set();
            this.movedSet = new Set();
            this.droppedSet = new Set();
            this.movedMap = {};
            this.mutationCb(payload);
        };
        this.processMutation = (m)=>{
            if ($ca970ce8cf2750a2$var$isIgnored(m.target, this.mirror)) return;
            switch(m.type){
                case 'characterData':
                    {
                        const value = m.target.textContent;
                        if (!$ca970ce8cf2750a2$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) && value !== m.oldValue) this.texts.push({
                            value: $ca970ce8cf2750a2$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, this.maskAllText) && value ? this.maskTextFn ? this.maskTextFn(value, $ca970ce8cf2750a2$var$closestElementOfNode(m.target)) : value.replace(/[\S]/g, '*') : value,
                            node: m.target
                        });
                        break;
                    }
                case 'attributes':
                    {
                        const target = m.target;
                        let attributeName = m.attributeName;
                        let value = m.target.getAttribute(attributeName);
                        if (attributeName === 'value') {
                            const type = $ca970ce8cf2750a2$var$getInputType(target);
                            const tagName = target.tagName;
                            value = $ca970ce8cf2750a2$var$getInputValue(target, tagName, type);
                            const isInputMasked = $ca970ce8cf2750a2$var$shouldMaskInput({
                                maskInputOptions: this.maskInputOptions,
                                tagName: tagName,
                                type: type
                            });
                            const forceMask = $ca970ce8cf2750a2$var$needMaskingText(m.target, this.maskTextClass, this.maskTextSelector, this.unmaskTextClass, this.unmaskTextSelector, isInputMasked);
                            value = $ca970ce8cf2750a2$var$maskInputValue({
                                isMasked: forceMask,
                                element: target,
                                value: value,
                                maskInputFn: this.maskInputFn
                            });
                        }
                        if ($ca970ce8cf2750a2$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || value === m.oldValue) return;
                        let item = this.attributeMap.get(m.target);
                        if (target.tagName === 'IFRAME' && attributeName === 'src' && !this.keepIframeSrcFn(value)) {
                            if (!target.contentDocument) attributeName = 'rr_src';
                            else return;
                        }
                        if (!item) {
                            item = {
                                node: m.target,
                                attributes: {},
                                styleDiff: {},
                                _unchangedStyles: {}
                            };
                            this.attributes.push(item);
                            this.attributeMap.set(m.target, item);
                        }
                        if (attributeName === 'type' && target.tagName === 'INPUT' && (m.oldValue || '').toLowerCase() === 'password') target.setAttribute('data-rr-is-password', 'true');
                        if (!$ca970ce8cf2750a2$var$ignoreAttribute(target.tagName, attributeName)) {
                            item.attributes[attributeName] = $ca970ce8cf2750a2$var$transformAttribute(this.doc, $ca970ce8cf2750a2$var$toLowerCase(target.tagName), $ca970ce8cf2750a2$var$toLowerCase(attributeName), value, target, this.maskAttributeFn);
                            if (attributeName === 'style') {
                                if (!this.unattachedDoc) try {
                                    this.unattachedDoc = document.implementation.createHTMLDocument();
                                } catch (e) {
                                    this.unattachedDoc = this.doc;
                                }
                                const old = this.unattachedDoc.createElement('span');
                                if (m.oldValue) old.setAttribute('style', m.oldValue);
                                for (const pname of Array.from(target.style)){
                                    const newValue = target.style.getPropertyValue(pname);
                                    const newPriority = target.style.getPropertyPriority(pname);
                                    if (newValue !== old.style.getPropertyValue(pname) || newPriority !== old.style.getPropertyPriority(pname)) {
                                        if (newPriority === '') item.styleDiff[pname] = newValue;
                                        else item.styleDiff[pname] = [
                                            newValue,
                                            newPriority
                                        ];
                                    } else item._unchangedStyles[pname] = [
                                        newValue,
                                        newPriority
                                    ];
                                }
                                for (const pname of Array.from(old.style))if (target.style.getPropertyValue(pname) === '') item.styleDiff[pname] = false;
                            }
                        }
                        break;
                    }
                case 'childList':
                    if ($ca970ce8cf2750a2$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, true)) return;
                    m.addedNodes.forEach((n)=>this.genAdds(n, m.target));
                    m.removedNodes.forEach((n)=>{
                        const nodeId = this.mirror.getId(n);
                        const parentId = $ca970ce8cf2750a2$var$isShadowRoot(m.target) ? this.mirror.getId(m.target.host) : this.mirror.getId(m.target);
                        if ($ca970ce8cf2750a2$var$isBlocked(m.target, this.blockClass, this.blockSelector, this.unblockSelector, false) || $ca970ce8cf2750a2$var$isIgnored(n, this.mirror) || !$ca970ce8cf2750a2$var$isSerialized(n, this.mirror)) return;
                        if (this.addedSet.has(n)) {
                            $ca970ce8cf2750a2$var$deepDelete(this.addedSet, n);
                            this.droppedSet.add(n);
                        } else if (this.addedSet.has(m.target) && nodeId === -1) ;
                        else if ($ca970ce8cf2750a2$var$isAncestorRemoved(m.target, this.mirror)) ;
                        else if (this.movedSet.has(n) && this.movedMap[$ca970ce8cf2750a2$var$moveKey(nodeId, parentId)]) $ca970ce8cf2750a2$var$deepDelete(this.movedSet, n);
                        else this.removes.push({
                            parentId: parentId,
                            id: nodeId,
                            isShadow: $ca970ce8cf2750a2$var$isShadowRoot(m.target) && $ca970ce8cf2750a2$var$isNativeShadowDom(m.target) ? true : undefined
                        });
                        this.mapRemoves.push(n);
                    });
                    break;
            }
        };
        this.genAdds = (n, target)=>{
            if (this.processedNodeManager.inOtherBuffer(n, this)) return;
            if (this.addedSet.has(n) || this.movedSet.has(n)) return;
            if (this.mirror.hasNode(n)) {
                if ($ca970ce8cf2750a2$var$isIgnored(n, this.mirror)) return;
                this.movedSet.add(n);
                let targetId = null;
                if (target && this.mirror.hasNode(target)) targetId = this.mirror.getId(target);
                if (targetId && targetId !== -1) this.movedMap[$ca970ce8cf2750a2$var$moveKey(this.mirror.getId(n), targetId)] = true;
            } else {
                this.addedSet.add(n);
                this.droppedSet.delete(n);
            }
            if (!$ca970ce8cf2750a2$var$isBlocked(n, this.blockClass, this.blockSelector, this.unblockSelector, false)) {
                n.childNodes.forEach((childN)=>this.genAdds(childN));
                if ($ca970ce8cf2750a2$var$hasShadowRoot(n)) n.shadowRoot.childNodes.forEach((childN)=>{
                    this.processedNodeManager.add(childN, this);
                    this.genAdds(childN, n);
                });
            }
        };
    }
    init(options) {
        [
            'mutationCb',
            'blockClass',
            'blockSelector',
            'unblockSelector',
            'maskAllText',
            'maskTextClass',
            'unmaskTextClass',
            'maskTextSelector',
            'unmaskTextSelector',
            'inlineStylesheet',
            'maskInputOptions',
            'maskAttributeFn',
            'maskTextFn',
            'maskInputFn',
            'keepIframeSrcFn',
            'recordCanvas',
            'inlineImages',
            'slimDOMOptions',
            'dataURLOptions',
            'doc',
            'mirror',
            'iframeManager',
            'stylesheetManager',
            'shadowDomManager',
            'canvasManager',
            'processedNodeManager'
        ].forEach((key)=>{
            this[key] = options[key];
        });
    }
    freeze() {
        this.frozen = true;
        this.canvasManager.freeze();
    }
    unfreeze() {
        this.frozen = false;
        this.canvasManager.unfreeze();
        this.emit();
    }
    isFrozen() {
        return this.frozen;
    }
    lock() {
        this.locked = true;
        this.canvasManager.lock();
    }
    unlock() {
        this.locked = false;
        this.canvasManager.unlock();
        this.emit();
    }
    reset() {
        this.shadowDomManager.reset();
        this.canvasManager.reset();
    }
}
function $ca970ce8cf2750a2$var$deepDelete(addsSet, n) {
    addsSet.delete(n);
    n.childNodes.forEach((childN)=>$ca970ce8cf2750a2$var$deepDelete(addsSet, childN));
}
function $ca970ce8cf2750a2$var$isParentRemoved(removes, n, mirror) {
    if (removes.length === 0) return false;
    return $ca970ce8cf2750a2$var$_isParentRemoved(removes, n, mirror);
}
function $ca970ce8cf2750a2$var$_isParentRemoved(removes, n, mirror) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    const parentId = mirror.getId(parentNode);
    if (removes.some((r)=>r.id === parentId)) return true;
    return $ca970ce8cf2750a2$var$_isParentRemoved(removes, parentNode, mirror);
}
function $ca970ce8cf2750a2$var$isAncestorInSet(set, n) {
    if (set.size === 0) return false;
    return $ca970ce8cf2750a2$var$_isAncestorInSet(set, n);
}
function $ca970ce8cf2750a2$var$_isAncestorInSet(set, n) {
    const { parentNode: parentNode } = n;
    if (!parentNode) return false;
    if (set.has(parentNode)) return true;
    return $ca970ce8cf2750a2$var$_isAncestorInSet(set, parentNode);
}
let $ca970ce8cf2750a2$var$errorHandler;
function $ca970ce8cf2750a2$var$registerErrorHandler(handler) {
    $ca970ce8cf2750a2$var$errorHandler = handler;
}
function $ca970ce8cf2750a2$var$unregisterErrorHandler() {
    $ca970ce8cf2750a2$var$errorHandler = undefined;
}
const $ca970ce8cf2750a2$var$callbackWrapper = (cb)=>{
    if (!$ca970ce8cf2750a2$var$errorHandler) return cb;
    const rrwebWrapped = (...rest)=>{
        try {
            return cb(...rest);
        } catch (error) {
            if ($ca970ce8cf2750a2$var$errorHandler && $ca970ce8cf2750a2$var$errorHandler(error) === true) return ()=>{};
            throw error;
        }
    };
    return rrwebWrapped;
};
function $ca970ce8cf2750a2$var$_optionalChain$2(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
const $ca970ce8cf2750a2$var$mutationBuffers = [];
function $ca970ce8cf2750a2$var$getEventTarget(event) {
    try {
        if ('composedPath' in event) {
            const path = event.composedPath();
            if (path.length) return path[0];
        } else if ('path' in event && event.path.length) return event.path[0];
    } catch (e2) {}
    return event && event.target;
}
function $ca970ce8cf2750a2$var$initMutationObserver(options, rootEl) {
    const mutationBuffer = new $ca970ce8cf2750a2$var$MutationBuffer();
    $ca970ce8cf2750a2$var$mutationBuffers.push(mutationBuffer);
    mutationBuffer.init(options);
    let mutationObserverCtor = window.MutationObserver || window.__rrMutationObserver;
    const angularZoneSymbol = $ca970ce8cf2750a2$var$_optionalChain$2([
        window,
        'optionalAccess',
        (_)=>_.Zone,
        'optionalAccess',
        (_2)=>_2.__symbol__,
        'optionalCall',
        (_3)=>_3('MutationObserver')
    ]);
    if (angularZoneSymbol && window[angularZoneSymbol]) mutationObserverCtor = window[angularZoneSymbol];
    const observer = new mutationObserverCtor($ca970ce8cf2750a2$var$callbackWrapper((mutations)=>{
        if (options.onMutation && options.onMutation(mutations) === false) return;
        mutationBuffer.processMutations.bind(mutationBuffer)(mutations);
    }));
    observer.observe(rootEl, {
        attributes: true,
        attributeOldValue: true,
        characterData: true,
        characterDataOldValue: true,
        childList: true,
        subtree: true
    });
    return observer;
}
function $ca970ce8cf2750a2$var$initMoveObserver({ mousemoveCb: mousemoveCb, sampling: sampling, doc: doc, mirror: mirror }) {
    if (sampling.mousemove === false) return ()=>{};
    const threshold = typeof sampling.mousemove === 'number' ? sampling.mousemove : 50;
    const callbackThreshold = typeof sampling.mousemoveCallback === 'number' ? sampling.mousemoveCallback : 500;
    let positions = [];
    let timeBaseline;
    const wrappedCb = $ca970ce8cf2750a2$var$throttle$1($ca970ce8cf2750a2$var$callbackWrapper((source)=>{
        const totalOffset = Date.now() - timeBaseline;
        mousemoveCb(positions.map((p)=>{
            p.timeOffset -= totalOffset;
            return p;
        }), source);
        positions = [];
        timeBaseline = null;
    }), callbackThreshold);
    const updatePosition = $ca970ce8cf2750a2$var$callbackWrapper($ca970ce8cf2750a2$var$throttle$1($ca970ce8cf2750a2$var$callbackWrapper((evt)=>{
        const target = $ca970ce8cf2750a2$var$getEventTarget(evt);
        const { clientX: clientX, clientY: clientY } = $ca970ce8cf2750a2$var$legacy_isTouchEvent(evt) ? evt.changedTouches[0] : evt;
        if (!timeBaseline) timeBaseline = $ca970ce8cf2750a2$var$nowTimestamp();
        positions.push({
            x: clientX,
            y: clientY,
            id: mirror.getId(target),
            timeOffset: $ca970ce8cf2750a2$var$nowTimestamp() - timeBaseline
        });
        wrappedCb(typeof DragEvent !== 'undefined' && evt instanceof DragEvent ? $ca970ce8cf2750a2$var$IncrementalSource.Drag : evt instanceof MouseEvent ? $ca970ce8cf2750a2$var$IncrementalSource.MouseMove : $ca970ce8cf2750a2$var$IncrementalSource.TouchMove);
    }), threshold, {
        trailing: false
    }));
    const handlers = [
        $ca970ce8cf2750a2$var$on('mousemove', updatePosition, doc),
        $ca970ce8cf2750a2$var$on('touchmove', updatePosition, doc),
        $ca970ce8cf2750a2$var$on('drag', updatePosition, doc)
    ];
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca970ce8cf2750a2$var$initMouseInteractionObserver({ mouseInteractionCb: mouseInteractionCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    if (sampling.mouseInteraction === false) return ()=>{};
    const disableMap = sampling.mouseInteraction === true || sampling.mouseInteraction === undefined ? {} : sampling.mouseInteraction;
    const handlers = [];
    let currentPointerType = null;
    const getHandler = (eventKey)=>{
        return (event)=>{
            const target = $ca970ce8cf2750a2$var$getEventTarget(event);
            if ($ca970ce8cf2750a2$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            let pointerType = null;
            let thisEventKey = eventKey;
            if ('pointerType' in event) {
                switch(event.pointerType){
                    case 'mouse':
                        pointerType = $ca970ce8cf2750a2$var$PointerTypes.Mouse;
                        break;
                    case 'touch':
                        pointerType = $ca970ce8cf2750a2$var$PointerTypes.Touch;
                        break;
                    case 'pen':
                        pointerType = $ca970ce8cf2750a2$var$PointerTypes.Pen;
                        break;
                }
                if (pointerType === $ca970ce8cf2750a2$var$PointerTypes.Touch) {
                    if ($ca970ce8cf2750a2$var$MouseInteractions[eventKey] === $ca970ce8cf2750a2$var$MouseInteractions.MouseDown) thisEventKey = 'TouchStart';
                    else if ($ca970ce8cf2750a2$var$MouseInteractions[eventKey] === $ca970ce8cf2750a2$var$MouseInteractions.MouseUp) thisEventKey = 'TouchEnd';
                } else $ca970ce8cf2750a2$var$PointerTypes.Pen;
            } else if ($ca970ce8cf2750a2$var$legacy_isTouchEvent(event)) pointerType = $ca970ce8cf2750a2$var$PointerTypes.Touch;
            if (pointerType !== null) {
                currentPointerType = pointerType;
                if (thisEventKey.startsWith('Touch') && pointerType === $ca970ce8cf2750a2$var$PointerTypes.Touch || thisEventKey.startsWith('Mouse') && pointerType === $ca970ce8cf2750a2$var$PointerTypes.Mouse) pointerType = null;
            } else if ($ca970ce8cf2750a2$var$MouseInteractions[eventKey] === $ca970ce8cf2750a2$var$MouseInteractions.Click) {
                pointerType = currentPointerType;
                currentPointerType = null;
            }
            const e = $ca970ce8cf2750a2$var$legacy_isTouchEvent(event) ? event.changedTouches[0] : event;
            if (!e) return;
            const id = mirror.getId(target);
            const { clientX: clientX, clientY: clientY } = e;
            $ca970ce8cf2750a2$var$callbackWrapper(mouseInteractionCb)({
                type: $ca970ce8cf2750a2$var$MouseInteractions[thisEventKey],
                id: id,
                x: clientX,
                y: clientY,
                ...pointerType !== null && {
                    pointerType: pointerType
                }
            });
        };
    };
    Object.keys($ca970ce8cf2750a2$var$MouseInteractions).filter((key)=>Number.isNaN(Number(key)) && !key.endsWith('_Departed') && disableMap[key] !== false).forEach((eventKey)=>{
        let eventName = $ca970ce8cf2750a2$var$toLowerCase(eventKey);
        const handler = getHandler(eventKey);
        if (window.PointerEvent) switch($ca970ce8cf2750a2$var$MouseInteractions[eventKey]){
            case $ca970ce8cf2750a2$var$MouseInteractions.MouseDown:
            case $ca970ce8cf2750a2$var$MouseInteractions.MouseUp:
                eventName = eventName.replace('mouse', 'pointer');
                break;
            case $ca970ce8cf2750a2$var$MouseInteractions.TouchStart:
            case $ca970ce8cf2750a2$var$MouseInteractions.TouchEnd:
                return;
        }
        handlers.push($ca970ce8cf2750a2$var$on(eventName, handler, doc));
    });
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca970ce8cf2750a2$var$initScrollObserver({ scrollCb: scrollCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, sampling: sampling }) {
    const updatePosition = $ca970ce8cf2750a2$var$callbackWrapper($ca970ce8cf2750a2$var$throttle$1($ca970ce8cf2750a2$var$callbackWrapper((evt)=>{
        const target = $ca970ce8cf2750a2$var$getEventTarget(evt);
        if (!target || $ca970ce8cf2750a2$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const id = mirror.getId(target);
        if (target === doc && doc.defaultView) {
            const scrollLeftTop = $ca970ce8cf2750a2$var$getWindowScroll(doc.defaultView);
            scrollCb({
                id: id,
                x: scrollLeftTop.left,
                y: scrollLeftTop.top
            });
        } else scrollCb({
            id: id,
            x: target.scrollLeft,
            y: target.scrollTop
        });
    }), sampling.scroll || 100));
    return $ca970ce8cf2750a2$var$on('scroll', updatePosition, doc);
}
function $ca970ce8cf2750a2$var$initViewportResizeObserver({ viewportResizeCb: viewportResizeCb }, { win: win }) {
    let lastH = -1;
    let lastW = -1;
    const updateDimension = $ca970ce8cf2750a2$var$callbackWrapper($ca970ce8cf2750a2$var$throttle$1($ca970ce8cf2750a2$var$callbackWrapper(()=>{
        const height = $ca970ce8cf2750a2$var$getWindowHeight();
        const width = $ca970ce8cf2750a2$var$getWindowWidth();
        if (lastH !== height || lastW !== width) {
            viewportResizeCb({
                width: Number(width),
                height: Number(height)
            });
            lastH = height;
            lastW = width;
        }
    }), 200));
    return $ca970ce8cf2750a2$var$on('resize', updateDimension, win);
}
const $ca970ce8cf2750a2$var$INPUT_TAGS = [
    'INPUT',
    'TEXTAREA',
    'SELECT'
];
const $ca970ce8cf2750a2$var$lastInputValueMap = new WeakMap();
function $ca970ce8cf2750a2$var$initInputObserver({ inputCb: inputCb, doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, ignoreClass: ignoreClass, ignoreSelector: ignoreSelector, maskInputOptions: maskInputOptions, maskInputFn: maskInputFn, sampling: sampling, userTriggeredOnInput: userTriggeredOnInput, maskTextClass: maskTextClass, unmaskTextClass: unmaskTextClass, maskTextSelector: maskTextSelector, unmaskTextSelector: unmaskTextSelector }) {
    function eventHandler(event) {
        let target = $ca970ce8cf2750a2$var$getEventTarget(event);
        const userTriggered = event.isTrusted;
        const tagName = target && $ca970ce8cf2750a2$var$toUpperCase(target.tagName);
        if (tagName === 'OPTION') target = target.parentElement;
        if (!target || !tagName || $ca970ce8cf2750a2$var$INPUT_TAGS.indexOf(tagName) < 0 || $ca970ce8cf2750a2$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
        const el = target;
        if (el.classList.contains(ignoreClass) || ignoreSelector && el.matches(ignoreSelector)) return;
        const type = $ca970ce8cf2750a2$var$getInputType(target);
        let text = $ca970ce8cf2750a2$var$getInputValue(el, tagName, type);
        let isChecked = false;
        const isInputMasked = $ca970ce8cf2750a2$var$shouldMaskInput({
            maskInputOptions: maskInputOptions,
            tagName: tagName,
            type: type
        });
        const forceMask = $ca970ce8cf2750a2$var$needMaskingText(target, maskTextClass, maskTextSelector, unmaskTextClass, unmaskTextSelector, isInputMasked);
        if (type === 'radio' || type === 'checkbox') isChecked = target.checked;
        text = $ca970ce8cf2750a2$var$maskInputValue({
            isMasked: forceMask,
            element: target,
            value: text,
            maskInputFn: maskInputFn
        });
        cbWithDedup(target, userTriggeredOnInput ? {
            text: text,
            isChecked: isChecked,
            userTriggered: userTriggered
        } : {
            text: text,
            isChecked: isChecked
        });
        const name = target.name;
        if (type === 'radio' && name && isChecked) doc.querySelectorAll(`input[type="radio"][name="${name}"]`).forEach((el)=>{
            if (el !== target) {
                const text = $ca970ce8cf2750a2$var$maskInputValue({
                    isMasked: forceMask,
                    element: el,
                    value: $ca970ce8cf2750a2$var$getInputValue(el, tagName, type),
                    maskInputFn: maskInputFn
                });
                cbWithDedup(el, userTriggeredOnInput ? {
                    text: text,
                    isChecked: !isChecked,
                    userTriggered: false
                } : {
                    text: text,
                    isChecked: !isChecked
                });
            }
        });
    }
    function cbWithDedup(target, v) {
        const lastInputValue = $ca970ce8cf2750a2$var$lastInputValueMap.get(target);
        if (!lastInputValue || lastInputValue.text !== v.text || lastInputValue.isChecked !== v.isChecked) {
            $ca970ce8cf2750a2$var$lastInputValueMap.set(target, v);
            const id = mirror.getId(target);
            $ca970ce8cf2750a2$var$callbackWrapper(inputCb)({
                ...v,
                id: id
            });
        }
    }
    const events = sampling.input === 'last' ? [
        'change'
    ] : [
        'input',
        'change'
    ];
    const handlers = events.map((eventName)=>$ca970ce8cf2750a2$var$on(eventName, $ca970ce8cf2750a2$var$callbackWrapper(eventHandler), doc));
    const currentWindow = doc.defaultView;
    if (!currentWindow) return ()=>{
        handlers.forEach((h)=>h());
    };
    const propertyDescriptor = currentWindow.Object.getOwnPropertyDescriptor(currentWindow.HTMLInputElement.prototype, 'value');
    const hookProperties = [
        [
            currentWindow.HTMLInputElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLInputElement.prototype,
            'checked'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLTextAreaElement.prototype,
            'value'
        ],
        [
            currentWindow.HTMLSelectElement.prototype,
            'selectedIndex'
        ],
        [
            currentWindow.HTMLOptionElement.prototype,
            'selected'
        ]
    ];
    if (propertyDescriptor && propertyDescriptor.set) handlers.push(...hookProperties.map((p)=>$ca970ce8cf2750a2$var$hookSetter(p[0], p[1], {
            set () {
                $ca970ce8cf2750a2$var$callbackWrapper(eventHandler)({
                    target: this,
                    isTrusted: false
                });
            }
        }, false, currentWindow)));
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca970ce8cf2750a2$var$getNestedCSSRulePositions(rule) {
    const positions = [];
    function recurse(childRule, pos) {
        if ($ca970ce8cf2750a2$var$hasNestedCSSRule('CSSGroupingRule') && childRule.parentRule instanceof CSSGroupingRule || $ca970ce8cf2750a2$var$hasNestedCSSRule('CSSMediaRule') && childRule.parentRule instanceof CSSMediaRule || $ca970ce8cf2750a2$var$hasNestedCSSRule('CSSSupportsRule') && childRule.parentRule instanceof CSSSupportsRule || $ca970ce8cf2750a2$var$hasNestedCSSRule('CSSConditionRule') && childRule.parentRule instanceof CSSConditionRule) {
            const rules = Array.from(childRule.parentRule.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        } else if (childRule.parentStyleSheet) {
            const rules = Array.from(childRule.parentStyleSheet.cssRules);
            const index = rules.indexOf(childRule);
            pos.unshift(index);
        }
        return pos;
    }
    return recurse(rule, positions);
}
function $ca970ce8cf2750a2$var$getIdAndStyleId(sheet, mirror, styleMirror) {
    let id, styleId;
    if (!sheet) return {};
    if (sheet.ownerNode) id = mirror.getId(sheet.ownerNode);
    else styleId = styleMirror.getId(sheet);
    return {
        styleId: styleId,
        id: id
    };
}
function $ca970ce8cf2750a2$var$initStyleSheetObserver({ styleSheetRuleCb: styleSheetRuleCb, mirror: mirror, stylesheetManager: stylesheetManager }, { win: win }) {
    if (!win.CSSStyleSheet || !win.CSSStyleSheet.prototype) return ()=>{};
    const insertRule = win.CSSStyleSheet.prototype.insertRule;
    win.CSSStyleSheet.prototype.insertRule = new Proxy(insertRule, {
        apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [rule, index] = argumentsList;
            const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                adds: [
                    {
                        rule: rule,
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const deleteRule = win.CSSStyleSheet.prototype.deleteRule;
    win.CSSStyleSheet.prototype.deleteRule = new Proxy(deleteRule, {
        apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [index] = argumentsList;
            const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                id: id,
                styleId: styleId,
                removes: [
                    {
                        index: index
                    }
                ]
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    let replace;
    if (win.CSSStyleSheet.prototype.replace) {
        replace = win.CSSStyleSheet.prototype.replace;
        win.CSSStyleSheet.prototype.replace = new Proxy(replace, {
            apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replace: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    let replaceSync;
    if (win.CSSStyleSheet.prototype.replaceSync) {
        replaceSync = win.CSSStyleSheet.prototype.replaceSync;
        win.CSSStyleSheet.prototype.replaceSync = new Proxy(replaceSync, {
            apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [text] = argumentsList;
                const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId(thisArg, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    replaceSync: text
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    }
    const supportedNestedCSSRuleTypes = {};
    if ($ca970ce8cf2750a2$var$canMonkeyPatchNestedCSSRule('CSSGroupingRule')) supportedNestedCSSRuleTypes.CSSGroupingRule = win.CSSGroupingRule;
    else {
        if ($ca970ce8cf2750a2$var$canMonkeyPatchNestedCSSRule('CSSMediaRule')) supportedNestedCSSRuleTypes.CSSMediaRule = win.CSSMediaRule;
        if ($ca970ce8cf2750a2$var$canMonkeyPatchNestedCSSRule('CSSConditionRule')) supportedNestedCSSRuleTypes.CSSConditionRule = win.CSSConditionRule;
        if ($ca970ce8cf2750a2$var$canMonkeyPatchNestedCSSRule('CSSSupportsRule')) supportedNestedCSSRuleTypes.CSSSupportsRule = win.CSSSupportsRule;
    }
    const unmodifiedFunctions = {};
    Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
        unmodifiedFunctions[typeKey] = {
            insertRule: type.prototype.insertRule,
            deleteRule: type.prototype.deleteRule
        };
        type.prototype.insertRule = new Proxy(unmodifiedFunctions[typeKey].insertRule, {
            apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [rule, index] = argumentsList;
                const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    adds: [
                        {
                            rule: rule,
                            index: [
                                ...$ca970ce8cf2750a2$var$getNestedCSSRulePositions(thisArg),
                                index || 0
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
        type.prototype.deleteRule = new Proxy(unmodifiedFunctions[typeKey].deleteRule, {
            apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
                const [index] = argumentsList;
                const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId(thisArg.parentStyleSheet, mirror, stylesheetManager.styleMirror);
                if (id && id !== -1 || styleId && styleId !== -1) styleSheetRuleCb({
                    id: id,
                    styleId: styleId,
                    removes: [
                        {
                            index: [
                                ...$ca970ce8cf2750a2$var$getNestedCSSRulePositions(thisArg),
                                index
                            ]
                        }
                    ]
                });
                return target.apply(thisArg, argumentsList);
            })
        });
    });
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        win.CSSStyleSheet.prototype.insertRule = insertRule;
        win.CSSStyleSheet.prototype.deleteRule = deleteRule;
        replace && (win.CSSStyleSheet.prototype.replace = replace);
        replaceSync && (win.CSSStyleSheet.prototype.replaceSync = replaceSync);
        Object.entries(supportedNestedCSSRuleTypes).forEach(([typeKey, type])=>{
            type.prototype.insertRule = unmodifiedFunctions[typeKey].insertRule;
            type.prototype.deleteRule = unmodifiedFunctions[typeKey].deleteRule;
        });
    });
}
function $ca970ce8cf2750a2$var$initAdoptedStyleSheetObserver({ mirror: mirror, stylesheetManager: stylesheetManager }, host) {
    let hostId = null;
    if (host.nodeName === '#document') hostId = mirror.getId(host);
    else hostId = mirror.getId(host.host);
    const patchTarget = host.nodeName === '#document' ? $ca970ce8cf2750a2$var$_optionalChain$2([
        host,
        'access',
        (_4)=>_4.defaultView,
        'optionalAccess',
        (_5)=>_5.Document
    ]) : $ca970ce8cf2750a2$var$_optionalChain$2([
        host,
        'access',
        (_6)=>_6.ownerDocument,
        'optionalAccess',
        (_7)=>_7.defaultView,
        'optionalAccess',
        (_8)=>_8.ShadowRoot
    ]);
    const originalPropertyDescriptor = $ca970ce8cf2750a2$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_9)=>_9.prototype
    ]) ? Object.getOwnPropertyDescriptor($ca970ce8cf2750a2$var$_optionalChain$2([
        patchTarget,
        'optionalAccess',
        (_10)=>_10.prototype
    ]), 'adoptedStyleSheets') : undefined;
    if (hostId === null || hostId === -1 || !patchTarget || !originalPropertyDescriptor) return ()=>{};
    Object.defineProperty(host, 'adoptedStyleSheets', {
        configurable: originalPropertyDescriptor.configurable,
        enumerable: originalPropertyDescriptor.enumerable,
        get () {
            return $ca970ce8cf2750a2$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_11)=>_11.get,
                'optionalAccess',
                (_12)=>_12.call,
                'call',
                (_13)=>_13(this)
            ]);
        },
        set (sheets) {
            const result = $ca970ce8cf2750a2$var$_optionalChain$2([
                originalPropertyDescriptor,
                'access',
                (_14)=>_14.set,
                'optionalAccess',
                (_15)=>_15.call,
                'call',
                (_16)=>_16(this, sheets)
            ]);
            if (hostId !== null && hostId !== -1) try {
                stylesheetManager.adoptStyleSheets(sheets, hostId);
            } catch (e) {}
            return result;
        }
    });
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        Object.defineProperty(host, 'adoptedStyleSheets', {
            configurable: originalPropertyDescriptor.configurable,
            enumerable: originalPropertyDescriptor.enumerable,
            get: originalPropertyDescriptor.get,
            set: originalPropertyDescriptor.set
        });
    });
}
function $ca970ce8cf2750a2$var$initStyleDeclarationObserver({ styleDeclarationCb: styleDeclarationCb, mirror: mirror, ignoreCSSAttributes: ignoreCSSAttributes, stylesheetManager: stylesheetManager }, { win: win }) {
    const setProperty = win.CSSStyleDeclaration.prototype.setProperty;
    win.CSSStyleDeclaration.prototype.setProperty = new Proxy(setProperty, {
        apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property, value, priority] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return setProperty.apply(thisArg, [
                property,
                value,
                priority
            ]);
            const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId($ca970ce8cf2750a2$var$_optionalChain$2([
                thisArg,
                'access',
                (_17)=>_17.parentRule,
                'optionalAccess',
                (_18)=>_18.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                set: {
                    property: property,
                    value: value,
                    priority: priority
                },
                index: $ca970ce8cf2750a2$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    const removeProperty = win.CSSStyleDeclaration.prototype.removeProperty;
    win.CSSStyleDeclaration.prototype.removeProperty = new Proxy(removeProperty, {
        apply: $ca970ce8cf2750a2$var$callbackWrapper((target, thisArg, argumentsList)=>{
            const [property] = argumentsList;
            if (ignoreCSSAttributes.has(property)) return removeProperty.apply(thisArg, [
                property
            ]);
            const { id: id, styleId: styleId } = $ca970ce8cf2750a2$var$getIdAndStyleId($ca970ce8cf2750a2$var$_optionalChain$2([
                thisArg,
                'access',
                (_19)=>_19.parentRule,
                'optionalAccess',
                (_20)=>_20.parentStyleSheet
            ]), mirror, stylesheetManager.styleMirror);
            if (id && id !== -1 || styleId && styleId !== -1) styleDeclarationCb({
                id: id,
                styleId: styleId,
                remove: {
                    property: property
                },
                index: $ca970ce8cf2750a2$var$getNestedCSSRulePositions(thisArg.parentRule)
            });
            return target.apply(thisArg, argumentsList);
        })
    });
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        win.CSSStyleDeclaration.prototype.setProperty = setProperty;
        win.CSSStyleDeclaration.prototype.removeProperty = removeProperty;
    });
}
function $ca970ce8cf2750a2$var$initMediaInteractionObserver({ mediaInteractionCb: mediaInteractionCb, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, mirror: mirror, sampling: sampling, doc: doc }) {
    const handler = $ca970ce8cf2750a2$var$callbackWrapper((type)=>$ca970ce8cf2750a2$var$throttle$1($ca970ce8cf2750a2$var$callbackWrapper((event)=>{
            const target = $ca970ce8cf2750a2$var$getEventTarget(event);
            if (!target || $ca970ce8cf2750a2$var$isBlocked(target, blockClass, blockSelector, unblockSelector, true)) return;
            const { currentTime: currentTime, volume: volume, muted: muted, playbackRate: playbackRate } = target;
            mediaInteractionCb({
                type: type,
                id: mirror.getId(target),
                currentTime: currentTime,
                volume: volume,
                muted: muted,
                playbackRate: playbackRate
            });
        }), sampling.media || 500));
    const handlers = [
        $ca970ce8cf2750a2$var$on('play', handler(0), doc),
        $ca970ce8cf2750a2$var$on('pause', handler(1), doc),
        $ca970ce8cf2750a2$var$on('seeked', handler(2), doc),
        $ca970ce8cf2750a2$var$on('volumechange', handler(3), doc),
        $ca970ce8cf2750a2$var$on('ratechange', handler(4), doc)
    ];
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca970ce8cf2750a2$var$initFontObserver({ fontCb: fontCb, doc: doc }) {
    const win = doc.defaultView;
    if (!win) return ()=>{};
    const handlers = [];
    const fontMap = new WeakMap();
    const originalFontFace = win.FontFace;
    win.FontFace = function FontFace(family, source, descriptors) {
        const fontFace = new originalFontFace(family, source, descriptors);
        fontMap.set(fontFace, {
            family: family,
            buffer: typeof source !== 'string',
            descriptors: descriptors,
            fontSource: typeof source === 'string' ? source : JSON.stringify(Array.from(new Uint8Array(source)))
        });
        return fontFace;
    };
    const restoreHandler = $ca970ce8cf2750a2$var$patch(doc.fonts, 'add', function(original) {
        return function(fontFace) {
            $ca970ce8cf2750a2$var$setTimeout$1($ca970ce8cf2750a2$var$callbackWrapper(()=>{
                const p = fontMap.get(fontFace);
                if (p) {
                    fontCb(p);
                    fontMap.delete(fontFace);
                }
            }), 0);
            return original.apply(this, [
                fontFace
            ]);
        };
    });
    handlers.push(()=>{
        win.FontFace = originalFontFace;
    });
    handlers.push(restoreHandler);
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        handlers.forEach((h)=>h());
    });
}
function $ca970ce8cf2750a2$var$initSelectionObserver(param) {
    const { doc: doc, mirror: mirror, blockClass: blockClass, blockSelector: blockSelector, unblockSelector: unblockSelector, selectionCb: selectionCb } = param;
    let collapsed = true;
    const updateSelection = $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        const selection = doc.getSelection();
        if (!selection || collapsed && $ca970ce8cf2750a2$var$_optionalChain$2([
            selection,
            'optionalAccess',
            (_21)=>_21.isCollapsed
        ])) return;
        collapsed = selection.isCollapsed || false;
        const ranges = [];
        const count = selection.rangeCount || 0;
        for(let i = 0; i < count; i++){
            const range = selection.getRangeAt(i);
            const { startContainer: startContainer, startOffset: startOffset, endContainer: endContainer, endOffset: endOffset } = range;
            const blocked = $ca970ce8cf2750a2$var$isBlocked(startContainer, blockClass, blockSelector, unblockSelector, true) || $ca970ce8cf2750a2$var$isBlocked(endContainer, blockClass, blockSelector, unblockSelector, true);
            if (blocked) continue;
            ranges.push({
                start: mirror.getId(startContainer),
                startOffset: startOffset,
                end: mirror.getId(endContainer),
                endOffset: endOffset
            });
        }
        selectionCb({
            ranges: ranges
        });
    });
    updateSelection();
    return $ca970ce8cf2750a2$var$on('selectionchange', updateSelection);
}
function $ca970ce8cf2750a2$var$initCustomElementObserver({ doc: doc, customElementCb: customElementCb }) {
    const win = doc.defaultView;
    if (!win || !win.customElements) return ()=>{};
    const restoreHandler = $ca970ce8cf2750a2$var$patch(win.customElements, 'define', function(original) {
        return function(name, constructor, options) {
            try {
                customElementCb({
                    define: {
                        name: name
                    }
                });
            } catch (e) {}
            return original.apply(this, [
                name,
                constructor,
                options
            ]);
        };
    });
    return restoreHandler;
}
function $ca970ce8cf2750a2$var$initObservers(o, _hooks = {}) {
    const currentWindow = o.doc.defaultView;
    if (!currentWindow) return ()=>{};
    const mutationObserver = $ca970ce8cf2750a2$var$initMutationObserver(o, o.doc);
    const mousemoveHandler = $ca970ce8cf2750a2$var$initMoveObserver(o);
    const mouseInteractionHandler = $ca970ce8cf2750a2$var$initMouseInteractionObserver(o);
    const scrollHandler = $ca970ce8cf2750a2$var$initScrollObserver(o);
    const viewportResizeHandler = $ca970ce8cf2750a2$var$initViewportResizeObserver(o, {
        win: currentWindow
    });
    const inputHandler = $ca970ce8cf2750a2$var$initInputObserver(o);
    const mediaInteractionHandler = $ca970ce8cf2750a2$var$initMediaInteractionObserver(o);
    const styleSheetObserver = $ca970ce8cf2750a2$var$initStyleSheetObserver(o, {
        win: currentWindow
    });
    const adoptedStyleSheetObserver = $ca970ce8cf2750a2$var$initAdoptedStyleSheetObserver(o, o.doc);
    const styleDeclarationObserver = $ca970ce8cf2750a2$var$initStyleDeclarationObserver(o, {
        win: currentWindow
    });
    const fontObserver = o.collectFonts ? $ca970ce8cf2750a2$var$initFontObserver(o) : ()=>{};
    const selectionObserver = $ca970ce8cf2750a2$var$initSelectionObserver(o);
    const customElementObserver = $ca970ce8cf2750a2$var$initCustomElementObserver(o);
    const pluginHandlers = [];
    for (const plugin of o.plugins)pluginHandlers.push(plugin.observer(plugin.callback, currentWindow, plugin.options));
    return $ca970ce8cf2750a2$var$callbackWrapper(()=>{
        $ca970ce8cf2750a2$var$mutationBuffers.forEach((b)=>b.reset());
        mutationObserver.disconnect();
        mousemoveHandler();
        mouseInteractionHandler();
        scrollHandler();
        viewportResizeHandler();
        inputHandler();
        mediaInteractionHandler();
        styleSheetObserver();
        adoptedStyleSheetObserver();
        styleDeclarationObserver();
        fontObserver();
        selectionObserver();
        customElementObserver();
        pluginHandlers.forEach((h)=>h());
    });
}
function $ca970ce8cf2750a2$var$hasNestedCSSRule(prop) {
    return typeof window[prop] !== 'undefined';
}
function $ca970ce8cf2750a2$var$canMonkeyPatchNestedCSSRule(prop) {
    return Boolean(typeof window[prop] !== 'undefined' && window[prop].prototype && 'insertRule' in window[prop].prototype && 'deleteRule' in window[prop].prototype);
}
class $ca970ce8cf2750a2$var$CrossOriginIframeMirror {
    constructor(generateIdFn){
        this.generateIdFn = generateIdFn;
        this.iframeIdToRemoteIdMap = new WeakMap();
        this.iframeRemoteIdToIdMap = new WeakMap();
    }
    getId(iframe, remoteId, idToRemoteMap, remoteToIdMap) {
        const idToRemoteIdMap = idToRemoteMap || this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = remoteToIdMap || this.getRemoteIdToIdMap(iframe);
        let id = idToRemoteIdMap.get(remoteId);
        if (!id) {
            id = this.generateIdFn();
            idToRemoteIdMap.set(remoteId, id);
            remoteIdToIdMap.set(id, remoteId);
        }
        return id;
    }
    getIds(iframe, remoteId) {
        const idToRemoteIdMap = this.getIdToRemoteIdMap(iframe);
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return remoteId.map((id)=>this.getId(iframe, id, idToRemoteIdMap, remoteIdToIdMap));
    }
    getRemoteId(iframe, id, map) {
        const remoteIdToIdMap = map || this.getRemoteIdToIdMap(iframe);
        if (typeof id !== 'number') return id;
        const remoteId = remoteIdToIdMap.get(id);
        if (!remoteId) return -1;
        return remoteId;
    }
    getRemoteIds(iframe, ids) {
        const remoteIdToIdMap = this.getRemoteIdToIdMap(iframe);
        return ids.map((id)=>this.getRemoteId(iframe, id, remoteIdToIdMap));
    }
    reset(iframe) {
        if (!iframe) {
            this.iframeIdToRemoteIdMap = new WeakMap();
            this.iframeRemoteIdToIdMap = new WeakMap();
            return;
        }
        this.iframeIdToRemoteIdMap.delete(iframe);
        this.iframeRemoteIdToIdMap.delete(iframe);
    }
    getIdToRemoteIdMap(iframe) {
        let idToRemoteIdMap = this.iframeIdToRemoteIdMap.get(iframe);
        if (!idToRemoteIdMap) {
            idToRemoteIdMap = new Map();
            this.iframeIdToRemoteIdMap.set(iframe, idToRemoteIdMap);
        }
        return idToRemoteIdMap;
    }
    getRemoteIdToIdMap(iframe) {
        let remoteIdToIdMap = this.iframeRemoteIdToIdMap.get(iframe);
        if (!remoteIdToIdMap) {
            remoteIdToIdMap = new Map();
            this.iframeRemoteIdToIdMap.set(iframe, remoteIdToIdMap);
        }
        return remoteIdToIdMap;
    }
}
function $ca970ce8cf2750a2$var$_optionalChain$1(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) return undefined;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}
class $ca970ce8cf2750a2$var$IframeManagerNoop {
    constructor(){
        this.crossOriginIframeMirror = new $ca970ce8cf2750a2$var$CrossOriginIframeMirror($ca970ce8cf2750a2$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
}
class $ca970ce8cf2750a2$var$IframeManager {
    constructor(options){
        this.iframes = new WeakMap();
        this.crossOriginIframeMap = new WeakMap();
        this.crossOriginIframeMirror = new $ca970ce8cf2750a2$var$CrossOriginIframeMirror($ca970ce8cf2750a2$var$genId);
        this.crossOriginIframeRootIdMap = new WeakMap();
        this.mutationCb = options.mutationCb;
        this.wrappedEmit = options.wrappedEmit;
        this.stylesheetManager = options.stylesheetManager;
        this.recordCrossOriginIframes = options.recordCrossOriginIframes;
        this.crossOriginIframeStyleMirror = new $ca970ce8cf2750a2$var$CrossOriginIframeMirror(this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror));
        this.mirror = options.mirror;
        if (this.recordCrossOriginIframes) window.addEventListener('message', this.handleMessage.bind(this));
    }
    addIframe(iframeEl) {
        this.iframes.set(iframeEl, true);
        if (iframeEl.contentWindow) this.crossOriginIframeMap.set(iframeEl.contentWindow, iframeEl);
    }
    addLoadListener(cb) {
        this.loadListener = cb;
    }
    attachIframe(iframeEl, childSn) {
        this.mutationCb({
            adds: [
                {
                    parentId: this.mirror.getId(iframeEl),
                    nextId: null,
                    node: childSn
                }
            ],
            removes: [],
            texts: [],
            attributes: [],
            isAttachIframe: true
        });
        $ca970ce8cf2750a2$var$_optionalChain$1([
            this,
            'access',
            (_)=>_.loadListener,
            'optionalCall',
            (_2)=>_2(iframeEl)
        ]);
        if (iframeEl.contentDocument && iframeEl.contentDocument.adoptedStyleSheets && iframeEl.contentDocument.adoptedStyleSheets.length > 0) this.stylesheetManager.adoptStyleSheets(iframeEl.contentDocument.adoptedStyleSheets, this.mirror.getId(iframeEl.contentDocument));
    }
    handleMessage(message) {
        const crossOriginMessageEvent = message;
        if (crossOriginMessageEvent.data.type !== 'rrweb' || crossOriginMessageEvent.origin !== crossOriginMessageEvent.data.origin) return;
        const iframeSourceWindow = message.source;
        if (!iframeSourceWindow) return;
        const iframeEl = this.crossOriginIframeMap.get(message.source);
        if (!iframeEl) return;
        const transformedEvent = this.transformCrossOriginEvent(iframeEl, crossOriginMessageEvent.data.event);
        if (transformedEvent) this.wrappedEmit(transformedEvent, crossOriginMessageEvent.data.isCheckout);
    }
    transformCrossOriginEvent(iframeEl, e) {
        switch(e.type){
            case $ca970ce8cf2750a2$var$EventType.FullSnapshot:
                {
                    this.crossOriginIframeMirror.reset(iframeEl);
                    this.crossOriginIframeStyleMirror.reset(iframeEl);
                    this.replaceIdOnNode(e.data.node, iframeEl);
                    const rootId = e.data.node.id;
                    this.crossOriginIframeRootIdMap.set(iframeEl, rootId);
                    this.patchRootIdOnNode(e.data.node, rootId);
                    return {
                        timestamp: e.timestamp,
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.Mutation,
                            adds: [
                                {
                                    parentId: this.mirror.getId(iframeEl),
                                    nextId: null,
                                    node: e.data.node
                                }
                            ],
                            removes: [],
                            texts: [],
                            attributes: [],
                            isAttachIframe: true
                        }
                    };
                }
            case $ca970ce8cf2750a2$var$EventType.Meta:
            case $ca970ce8cf2750a2$var$EventType.Load:
            case $ca970ce8cf2750a2$var$EventType.DomContentLoaded:
                return false;
            case $ca970ce8cf2750a2$var$EventType.Plugin:
                return e;
            case $ca970ce8cf2750a2$var$EventType.Custom:
                this.replaceIds(e.data.payload, iframeEl, [
                    'id',
                    'parentId',
                    'previousId',
                    'nextId'
                ]);
                return e;
            case $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot:
                switch(e.data.source){
                    case $ca970ce8cf2750a2$var$IncrementalSource.Mutation:
                        e.data.adds.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'nextId',
                                'previousId'
                            ]);
                            this.replaceIdOnNode(n.node, iframeEl);
                            const rootId = this.crossOriginIframeRootIdMap.get(iframeEl);
                            rootId && this.patchRootIdOnNode(n.node, rootId);
                        });
                        e.data.removes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'parentId',
                                'id'
                            ]);
                        });
                        e.data.attributes.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        e.data.texts.forEach((n)=>{
                            this.replaceIds(n, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $ca970ce8cf2750a2$var$IncrementalSource.Drag:
                    case $ca970ce8cf2750a2$var$IncrementalSource.TouchMove:
                    case $ca970ce8cf2750a2$var$IncrementalSource.MouseMove:
                        e.data.positions.forEach((p)=>{
                            this.replaceIds(p, iframeEl, [
                                'id'
                            ]);
                        });
                        return e;
                    case $ca970ce8cf2750a2$var$IncrementalSource.ViewportResize:
                        return false;
                    case $ca970ce8cf2750a2$var$IncrementalSource.MediaInteraction:
                    case $ca970ce8cf2750a2$var$IncrementalSource.MouseInteraction:
                    case $ca970ce8cf2750a2$var$IncrementalSource.Scroll:
                    case $ca970ce8cf2750a2$var$IncrementalSource.CanvasMutation:
                    case $ca970ce8cf2750a2$var$IncrementalSource.Input:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        return e;
                    case $ca970ce8cf2750a2$var$IncrementalSource.StyleSheetRule:
                    case $ca970ce8cf2750a2$var$IncrementalSource.StyleDeclaration:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleId'
                        ]);
                        return e;
                    case $ca970ce8cf2750a2$var$IncrementalSource.Font:
                        return e;
                    case $ca970ce8cf2750a2$var$IncrementalSource.Selection:
                        e.data.ranges.forEach((range)=>{
                            this.replaceIds(range, iframeEl, [
                                'start',
                                'end'
                            ]);
                        });
                        return e;
                    case $ca970ce8cf2750a2$var$IncrementalSource.AdoptedStyleSheet:
                        this.replaceIds(e.data, iframeEl, [
                            'id'
                        ]);
                        this.replaceStyleIds(e.data, iframeEl, [
                            'styleIds'
                        ]);
                        $ca970ce8cf2750a2$var$_optionalChain$1([
                            e,
                            'access',
                            (_3)=>_3.data,
                            'access',
                            (_4)=>_4.styles,
                            'optionalAccess',
                            (_5)=>_5.forEach,
                            'call',
                            (_6)=>_6((style)=>{
                                    this.replaceStyleIds(style, iframeEl, [
                                        'styleId'
                                    ]);
                                })
                        ]);
                        return e;
                }
        }
        return false;
    }
    replace(iframeMirror, obj, iframeEl, keys) {
        for (const key of keys){
            if (!Array.isArray(obj[key]) && typeof obj[key] !== 'number') continue;
            if (Array.isArray(obj[key])) obj[key] = iframeMirror.getIds(iframeEl, obj[key]);
            else obj[key] = iframeMirror.getId(iframeEl, obj[key]);
        }
        return obj;
    }
    replaceIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeMirror, obj, iframeEl, keys);
    }
    replaceStyleIds(obj, iframeEl, keys) {
        return this.replace(this.crossOriginIframeStyleMirror, obj, iframeEl, keys);
    }
    replaceIdOnNode(node, iframeEl) {
        this.replaceIds(node, iframeEl, [
            'id',
            'rootId'
        ]);
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.replaceIdOnNode(child, iframeEl);
        });
    }
    patchRootIdOnNode(node, rootId) {
        if (node.type !== $ca970ce8cf2750a2$var$NodeType$1.Document && !node.rootId) node.rootId = rootId;
        if ('childNodes' in node) node.childNodes.forEach((child)=>{
            this.patchRootIdOnNode(child, rootId);
        });
    }
}
class $ca970ce8cf2750a2$var$ShadowDomManagerNoop {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
}
class $ca970ce8cf2750a2$var$ShadowDomManager {
    constructor(options){
        this.shadowDoms = new WeakSet();
        this.restoreHandlers = [];
        this.mutationCb = options.mutationCb;
        this.scrollCb = options.scrollCb;
        this.bypassOptions = options.bypassOptions;
        this.mirror = options.mirror;
        this.init();
    }
    init() {
        this.reset();
        this.patchAttachShadow(Element, document);
    }
    addShadowRoot(shadowRoot, doc) {
        if (!$ca970ce8cf2750a2$var$isNativeShadowDom(shadowRoot)) return;
        if (this.shadowDoms.has(shadowRoot)) return;
        this.shadowDoms.add(shadowRoot);
        const observer = $ca970ce8cf2750a2$var$initMutationObserver({
            ...this.bypassOptions,
            doc: doc,
            mutationCb: this.mutationCb,
            mirror: this.mirror,
            shadowDomManager: this
        }, shadowRoot);
        this.restoreHandlers.push(()=>observer.disconnect());
        this.restoreHandlers.push($ca970ce8cf2750a2$var$initScrollObserver({
            ...this.bypassOptions,
            scrollCb: this.scrollCb,
            doc: shadowRoot,
            mirror: this.mirror
        }));
        $ca970ce8cf2750a2$var$setTimeout$1(()=>{
            if (shadowRoot.adoptedStyleSheets && shadowRoot.adoptedStyleSheets.length > 0) this.bypassOptions.stylesheetManager.adoptStyleSheets(shadowRoot.adoptedStyleSheets, this.mirror.getId(shadowRoot.host));
            this.restoreHandlers.push($ca970ce8cf2750a2$var$initAdoptedStyleSheetObserver({
                mirror: this.mirror,
                stylesheetManager: this.bypassOptions.stylesheetManager
            }, shadowRoot));
        }, 0);
    }
    observeAttachShadow(iframeElement) {
        if (!iframeElement.contentWindow || !iframeElement.contentDocument) return;
        this.patchAttachShadow(iframeElement.contentWindow.Element, iframeElement.contentDocument);
    }
    patchAttachShadow(element, doc) {
        const manager = this;
        this.restoreHandlers.push($ca970ce8cf2750a2$var$patch(element.prototype, 'attachShadow', function(original) {
            return function(option) {
                const shadowRoot = original.call(this, option);
                if (this.shadowRoot && $ca970ce8cf2750a2$var$inDom(this)) manager.addShadowRoot(this.shadowRoot, doc);
                return shadowRoot;
            };
        }));
    }
    reset() {
        this.restoreHandlers.forEach((handler)=>{
            try {
                handler();
            } catch (e) {}
        });
        this.restoreHandlers = [];
        this.shadowDoms = new WeakSet();
    }
}
class $ca970ce8cf2750a2$var$CanvasManagerNoop {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
}
class $ca970ce8cf2750a2$var$StylesheetManager {
    constructor(options){
        this.trackedLinkElements = new WeakSet();
        this.styleMirror = new $ca970ce8cf2750a2$var$StyleSheetMirror();
        this.mutationCb = options.mutationCb;
        this.adoptedStyleSheetCb = options.adoptedStyleSheetCb;
    }
    attachLinkElement(linkEl, childSn) {
        if ('_cssText' in childSn.attributes) this.mutationCb({
            adds: [],
            removes: [],
            texts: [],
            attributes: [
                {
                    id: childSn.id,
                    attributes: childSn.attributes
                }
            ]
        });
        this.trackLinkElement(linkEl);
    }
    trackLinkElement(linkEl) {
        if (this.trackedLinkElements.has(linkEl)) return;
        this.trackedLinkElements.add(linkEl);
        this.trackStylesheetInLinkElement(linkEl);
    }
    adoptStyleSheets(sheets, hostId) {
        if (sheets.length === 0) return;
        const adoptedStyleSheetData = {
            id: hostId,
            styleIds: []
        };
        const styles = [];
        for (const sheet of sheets){
            let styleId;
            if (!this.styleMirror.has(sheet)) {
                styleId = this.styleMirror.add(sheet);
                styles.push({
                    styleId: styleId,
                    rules: Array.from(sheet.rules || CSSRule, (r, index)=>({
                            rule: $ca970ce8cf2750a2$var$stringifyRule(r),
                            index: index
                        }))
                });
            } else styleId = this.styleMirror.getId(sheet);
            adoptedStyleSheetData.styleIds.push(styleId);
        }
        if (styles.length > 0) adoptedStyleSheetData.styles = styles;
        this.adoptedStyleSheetCb(adoptedStyleSheetData);
    }
    reset() {
        this.styleMirror.reset();
        this.trackedLinkElements = new WeakSet();
    }
    trackStylesheetInLinkElement(linkEl) {}
}
class $ca970ce8cf2750a2$var$ProcessedNodeManager {
    constructor(){
        this.nodeMap = new WeakMap();
        this.loop = true;
        this.periodicallyClear();
    }
    periodicallyClear() {
        $ca970ce8cf2750a2$var$onRequestAnimationFrame(()=>{
            this.clear();
            if (this.loop) this.periodicallyClear();
        });
    }
    inOtherBuffer(node, thisBuffer) {
        const buffers = this.nodeMap.get(node);
        return buffers && Array.from(buffers).some((buffer)=>buffer !== thisBuffer);
    }
    add(node, buffer) {
        this.nodeMap.set(node, (this.nodeMap.get(node) || new Set()).add(buffer));
    }
    clear() {
        this.nodeMap = new WeakMap();
    }
    destroy() {
        this.loop = false;
    }
}
let $ca970ce8cf2750a2$var$wrappedEmit;
let $ca970ce8cf2750a2$var$_takeFullSnapshot;
const $ca970ce8cf2750a2$var$mirror = $ca970ce8cf2750a2$var$createMirror();
function $ca970ce8cf2750a2$var$record(options = {}) {
    const { emit: emit, checkoutEveryNms: checkoutEveryNms, checkoutEveryNth: checkoutEveryNth, blockClass: blockClass = 'rr-block', blockSelector: blockSelector = null, unblockSelector: unblockSelector = null, ignoreClass: ignoreClass = 'rr-ignore', ignoreSelector: ignoreSelector = null, maskAllText: maskAllText = false, maskTextClass: maskTextClass = 'rr-mask', unmaskTextClass: unmaskTextClass = null, maskTextSelector: maskTextSelector = null, unmaskTextSelector: unmaskTextSelector = null, inlineStylesheet: inlineStylesheet = true, maskAllInputs: maskAllInputs, maskInputOptions: _maskInputOptions, slimDOMOptions: _slimDOMOptions, maskAttributeFn: maskAttributeFn, maskInputFn: maskInputFn, maskTextFn: maskTextFn, maxCanvasSize: maxCanvasSize = null, packFn: packFn, sampling: sampling = {}, dataURLOptions: dataURLOptions = {}, mousemoveWait: mousemoveWait, recordCanvas: recordCanvas = false, recordCrossOriginIframes: recordCrossOriginIframes = false, recordAfter: recordAfter = options.recordAfter === 'DOMContentLoaded' ? options.recordAfter : 'load', userTriggeredOnInput: userTriggeredOnInput = false, collectFonts: collectFonts = false, inlineImages: inlineImages = false, plugins: plugins, keepIframeSrcFn: keepIframeSrcFn = ()=>false, ignoreCSSAttributes: ignoreCSSAttributes = new Set([]), errorHandler: errorHandler, onMutation: onMutation, getCanvasManager: getCanvasManager } = options;
    $ca970ce8cf2750a2$var$registerErrorHandler(errorHandler);
    const inEmittingFrame = recordCrossOriginIframes ? window.parent === window : true;
    let passEmitsToParent = false;
    if (!inEmittingFrame) try {
        if (window.parent.document) passEmitsToParent = false;
    } catch (e) {
        passEmitsToParent = true;
    }
    if (inEmittingFrame && !emit) throw new Error('emit function is required');
    if (mousemoveWait !== undefined && sampling.mousemove === undefined) sampling.mousemove = mousemoveWait;
    $ca970ce8cf2750a2$var$mirror.reset();
    const maskInputOptions = maskAllInputs === true ? {
        color: true,
        date: true,
        'datetime-local': true,
        email: true,
        month: true,
        number: true,
        range: true,
        search: true,
        tel: true,
        text: true,
        time: true,
        url: true,
        week: true,
        textarea: true,
        select: true,
        radio: true,
        checkbox: true
    } : _maskInputOptions !== undefined ? _maskInputOptions : {};
    const slimDOMOptions = _slimDOMOptions === true || _slimDOMOptions === 'all' ? {
        script: true,
        comment: true,
        headFavicon: true,
        headWhitespace: true,
        headMetaSocial: true,
        headMetaRobots: true,
        headMetaHttpEquiv: true,
        headMetaVerification: true,
        headMetaAuthorship: _slimDOMOptions === 'all',
        headMetaDescKeywords: _slimDOMOptions === 'all'
    } : _slimDOMOptions ? _slimDOMOptions : {};
    $ca970ce8cf2750a2$var$polyfill();
    let lastFullSnapshotEvent;
    let incrementalSnapshotCount = 0;
    const eventProcessor = (e)=>{
        for (const plugin of plugins || [])if (plugin.eventProcessor) e = plugin.eventProcessor(e);
        if (packFn && !passEmitsToParent) e = packFn(e);
        return e;
    };
    $ca970ce8cf2750a2$var$wrappedEmit = (r, isCheckout)=>{
        const e = r;
        e.timestamp = $ca970ce8cf2750a2$var$nowTimestamp();
        if ((0, $66fe232ec5ceea1a$export$3cc482e6b02f32f7)([
            $ca970ce8cf2750a2$var$mutationBuffers,
            'access',
            (_)=>_[0],
            'optionalAccess',
            (_2)=>_2.isFrozen,
            'call',
            (_3)=>_3()
        ]) && e.type !== $ca970ce8cf2750a2$var$EventType.FullSnapshot && !(e.type === $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot && e.data.source === $ca970ce8cf2750a2$var$IncrementalSource.Mutation)) $ca970ce8cf2750a2$var$mutationBuffers.forEach((buf)=>buf.unfreeze());
        if (inEmittingFrame) (0, $66fe232ec5ceea1a$export$3cc482e6b02f32f7)([
            emit,
            'optionalCall',
            (_4)=>_4(eventProcessor(e), isCheckout)
        ]);
        else if (passEmitsToParent) {
            const message = {
                type: 'rrweb',
                event: eventProcessor(e),
                origin: window.location.origin,
                isCheckout: isCheckout
            };
            window.parent.postMessage(message, '*');
        }
        if (e.type === $ca970ce8cf2750a2$var$EventType.FullSnapshot) {
            lastFullSnapshotEvent = e;
            incrementalSnapshotCount = 0;
        } else if (e.type === $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot) {
            if (e.data.source === $ca970ce8cf2750a2$var$IncrementalSource.Mutation && e.data.isAttachIframe) return;
            incrementalSnapshotCount++;
            const exceedCount = checkoutEveryNth && incrementalSnapshotCount >= checkoutEveryNth;
            const exceedTime = checkoutEveryNms && lastFullSnapshotEvent && e.timestamp - lastFullSnapshotEvent.timestamp > checkoutEveryNms;
            if (exceedCount || exceedTime) takeFullSnapshot(true);
        }
    };
    const wrappedMutationEmit = (m)=>{
        $ca970ce8cf2750a2$var$wrappedEmit({
            type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
            data: {
                source: $ca970ce8cf2750a2$var$IncrementalSource.Mutation,
                ...m
            }
        });
    };
    const wrappedScrollEmit = (p)=>$ca970ce8cf2750a2$var$wrappedEmit({
            type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
            data: {
                source: $ca970ce8cf2750a2$var$IncrementalSource.Scroll,
                ...p
            }
        });
    const wrappedCanvasMutationEmit = (p)=>$ca970ce8cf2750a2$var$wrappedEmit({
            type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
            data: {
                source: $ca970ce8cf2750a2$var$IncrementalSource.CanvasMutation,
                ...p
            }
        });
    const wrappedAdoptedStyleSheetEmit = (a)=>$ca970ce8cf2750a2$var$wrappedEmit({
            type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
            data: {
                source: $ca970ce8cf2750a2$var$IncrementalSource.AdoptedStyleSheet,
                ...a
            }
        });
    const stylesheetManager = new $ca970ce8cf2750a2$var$StylesheetManager({
        mutationCb: wrappedMutationEmit,
        adoptedStyleSheetCb: wrappedAdoptedStyleSheetEmit
    });
    const iframeManager = typeof __RRWEB_EXCLUDE_IFRAME__ === 'boolean' && __RRWEB_EXCLUDE_IFRAME__ ? new $ca970ce8cf2750a2$var$IframeManagerNoop() : new $ca970ce8cf2750a2$var$IframeManager({
        mirror: $ca970ce8cf2750a2$var$mirror,
        mutationCb: wrappedMutationEmit,
        stylesheetManager: stylesheetManager,
        recordCrossOriginIframes: recordCrossOriginIframes,
        wrappedEmit: $ca970ce8cf2750a2$var$wrappedEmit
    });
    for (const plugin of plugins || [])if (plugin.getMirror) plugin.getMirror({
        nodeMirror: $ca970ce8cf2750a2$var$mirror,
        crossOriginIframeMirror: iframeManager.crossOriginIframeMirror,
        crossOriginIframeStyleMirror: iframeManager.crossOriginIframeStyleMirror
    });
    const processedNodeManager = new $ca970ce8cf2750a2$var$ProcessedNodeManager();
    const canvasManager = $ca970ce8cf2750a2$var$_getCanvasManager(getCanvasManager, {
        mirror: $ca970ce8cf2750a2$var$mirror,
        win: window,
        mutationCb: (p)=>$ca970ce8cf2750a2$var$wrappedEmit({
                type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                data: {
                    source: $ca970ce8cf2750a2$var$IncrementalSource.CanvasMutation,
                    ...p
                }
            }),
        recordCanvas: recordCanvas,
        blockClass: blockClass,
        blockSelector: blockSelector,
        unblockSelector: unblockSelector,
        maxCanvasSize: maxCanvasSize,
        sampling: sampling['canvas'],
        dataURLOptions: dataURLOptions,
        errorHandler: errorHandler
    });
    const shadowDomManager = typeof __RRWEB_EXCLUDE_SHADOW_DOM__ === 'boolean' && __RRWEB_EXCLUDE_SHADOW_DOM__ ? new $ca970ce8cf2750a2$var$ShadowDomManagerNoop() : new $ca970ce8cf2750a2$var$ShadowDomManager({
        mutationCb: wrappedMutationEmit,
        scrollCb: wrappedScrollEmit,
        bypassOptions: {
            onMutation: onMutation,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskInputOptions: maskInputOptions,
            dataURLOptions: dataURLOptions,
            maskAttributeFn: maskAttributeFn,
            maskTextFn: maskTextFn,
            maskInputFn: maskInputFn,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            sampling: sampling,
            slimDOMOptions: slimDOMOptions,
            iframeManager: iframeManager,
            stylesheetManager: stylesheetManager,
            canvasManager: canvasManager,
            keepIframeSrcFn: keepIframeSrcFn,
            processedNodeManager: processedNodeManager
        },
        mirror: $ca970ce8cf2750a2$var$mirror
    });
    const takeFullSnapshot = (isCheckout = false)=>{
        $ca970ce8cf2750a2$var$wrappedEmit({
            type: $ca970ce8cf2750a2$var$EventType.Meta,
            data: {
                href: window.location.href,
                width: $ca970ce8cf2750a2$var$getWindowWidth(),
                height: $ca970ce8cf2750a2$var$getWindowHeight()
            }
        }, isCheckout);
        stylesheetManager.reset();
        shadowDomManager.init();
        $ca970ce8cf2750a2$var$mutationBuffers.forEach((buf)=>buf.lock());
        const node = $ca970ce8cf2750a2$var$snapshot(document, {
            mirror: $ca970ce8cf2750a2$var$mirror,
            blockClass: blockClass,
            blockSelector: blockSelector,
            unblockSelector: unblockSelector,
            maskAllText: maskAllText,
            maskTextClass: maskTextClass,
            unmaskTextClass: unmaskTextClass,
            maskTextSelector: maskTextSelector,
            unmaskTextSelector: unmaskTextSelector,
            inlineStylesheet: inlineStylesheet,
            maskAllInputs: maskInputOptions,
            maskAttributeFn: maskAttributeFn,
            maskInputFn: maskInputFn,
            maskTextFn: maskTextFn,
            slimDOM: slimDOMOptions,
            dataURLOptions: dataURLOptions,
            recordCanvas: recordCanvas,
            inlineImages: inlineImages,
            onSerialize: (n)=>{
                if ($ca970ce8cf2750a2$var$isSerializedIframe(n, $ca970ce8cf2750a2$var$mirror)) iframeManager.addIframe(n);
                if ($ca970ce8cf2750a2$var$isSerializedStylesheet(n, $ca970ce8cf2750a2$var$mirror)) stylesheetManager.trackLinkElement(n);
                if ($ca970ce8cf2750a2$var$hasShadowRoot(n)) shadowDomManager.addShadowRoot(n.shadowRoot, document);
            },
            onIframeLoad: (iframe, childSn)=>{
                iframeManager.attachIframe(iframe, childSn);
                shadowDomManager.observeAttachShadow(iframe);
            },
            onStylesheetLoad: (linkEl, childSn)=>{
                stylesheetManager.attachLinkElement(linkEl, childSn);
            },
            keepIframeSrcFn: keepIframeSrcFn
        });
        if (!node) return console.warn('Failed to snapshot the document');
        $ca970ce8cf2750a2$var$wrappedEmit({
            type: $ca970ce8cf2750a2$var$EventType.FullSnapshot,
            data: {
                node: node,
                initialOffset: $ca970ce8cf2750a2$var$getWindowScroll(window)
            }
        });
        $ca970ce8cf2750a2$var$mutationBuffers.forEach((buf)=>buf.unlock());
        if (document.adoptedStyleSheets && document.adoptedStyleSheets.length > 0) stylesheetManager.adoptStyleSheets(document.adoptedStyleSheets, $ca970ce8cf2750a2$var$mirror.getId(document));
    };
    $ca970ce8cf2750a2$var$_takeFullSnapshot = takeFullSnapshot;
    try {
        const handlers = [];
        const observe = (doc)=>{
            return $ca970ce8cf2750a2$var$callbackWrapper($ca970ce8cf2750a2$var$initObservers)({
                onMutation: onMutation,
                mutationCb: wrappedMutationEmit,
                mousemoveCb: (positions, source)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: source,
                            positions: positions
                        }
                    }),
                mouseInteractionCb: (d)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.MouseInteraction,
                            ...d
                        }
                    }),
                scrollCb: wrappedScrollEmit,
                viewportResizeCb: (d)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.ViewportResize,
                            ...d
                        }
                    }),
                inputCb: (v)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.Input,
                            ...v
                        }
                    }),
                mediaInteractionCb: (p)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.MediaInteraction,
                            ...p
                        }
                    }),
                styleSheetRuleCb: (r)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.StyleSheetRule,
                            ...r
                        }
                    }),
                styleDeclarationCb: (r)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.StyleDeclaration,
                            ...r
                        }
                    }),
                canvasMutationCb: wrappedCanvasMutationEmit,
                fontCb: (p)=>$ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.Font,
                            ...p
                        }
                    }),
                selectionCb: (p)=>{
                    $ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.Selection,
                            ...p
                        }
                    });
                },
                customElementCb: (c)=>{
                    $ca970ce8cf2750a2$var$wrappedEmit({
                        type: $ca970ce8cf2750a2$var$EventType.IncrementalSnapshot,
                        data: {
                            source: $ca970ce8cf2750a2$var$IncrementalSource.CustomElement,
                            ...c
                        }
                    });
                },
                blockClass: blockClass,
                ignoreClass: ignoreClass,
                ignoreSelector: ignoreSelector,
                maskAllText: maskAllText,
                maskTextClass: maskTextClass,
                unmaskTextClass: unmaskTextClass,
                maskTextSelector: maskTextSelector,
                unmaskTextSelector: unmaskTextSelector,
                maskInputOptions: maskInputOptions,
                inlineStylesheet: inlineStylesheet,
                sampling: sampling,
                recordCanvas: recordCanvas,
                inlineImages: inlineImages,
                userTriggeredOnInput: userTriggeredOnInput,
                collectFonts: collectFonts,
                doc: doc,
                maskAttributeFn: maskAttributeFn,
                maskInputFn: maskInputFn,
                maskTextFn: maskTextFn,
                keepIframeSrcFn: keepIframeSrcFn,
                blockSelector: blockSelector,
                unblockSelector: unblockSelector,
                slimDOMOptions: slimDOMOptions,
                dataURLOptions: dataURLOptions,
                mirror: $ca970ce8cf2750a2$var$mirror,
                iframeManager: iframeManager,
                stylesheetManager: stylesheetManager,
                shadowDomManager: shadowDomManager,
                processedNodeManager: processedNodeManager,
                canvasManager: canvasManager,
                ignoreCSSAttributes: ignoreCSSAttributes,
                plugins: (0, $66fe232ec5ceea1a$export$3cc482e6b02f32f7)([
                    plugins,
                    'optionalAccess',
                    (_5)=>_5.filter,
                    'call',
                    (_6)=>_6((p)=>p.observer),
                    'optionalAccess',
                    (_7)=>_7.map,
                    'call',
                    (_8)=>_8((p)=>({
                                observer: p.observer,
                                options: p.options,
                                callback: (payload)=>$ca970ce8cf2750a2$var$wrappedEmit({
                                        type: $ca970ce8cf2750a2$var$EventType.Plugin,
                                        data: {
                                            plugin: p.name,
                                            payload: payload
                                        }
                                    })
                            }))
                ]) || []
            }, {});
        };
        iframeManager.addLoadListener((iframeEl)=>{
            try {
                handlers.push(observe(iframeEl.contentDocument));
            } catch (error) {
                console.warn(error);
            }
        });
        const init = ()=>{
            takeFullSnapshot();
            handlers.push(observe(document));
        };
        if (document.readyState === 'interactive' || document.readyState === 'complete') init();
        else {
            handlers.push($ca970ce8cf2750a2$var$on('DOMContentLoaded', ()=>{
                $ca970ce8cf2750a2$var$wrappedEmit({
                    type: $ca970ce8cf2750a2$var$EventType.DomContentLoaded,
                    data: {}
                });
                if (recordAfter === 'DOMContentLoaded') init();
            }));
            handlers.push($ca970ce8cf2750a2$var$on('load', ()=>{
                $ca970ce8cf2750a2$var$wrappedEmit({
                    type: $ca970ce8cf2750a2$var$EventType.Load,
                    data: {}
                });
                if (recordAfter === 'load') init();
            }, window));
        }
        return ()=>{
            handlers.forEach((h)=>h());
            processedNodeManager.destroy();
            $ca970ce8cf2750a2$var$_takeFullSnapshot = undefined;
            $ca970ce8cf2750a2$var$unregisterErrorHandler();
        };
    } catch (error) {
        console.warn(error);
    }
}
function $ca970ce8cf2750a2$var$takeFullSnapshot(isCheckout) {
    if (!$ca970ce8cf2750a2$var$_takeFullSnapshot) throw new Error('please take full snapshot after start recording');
    $ca970ce8cf2750a2$var$_takeFullSnapshot(isCheckout);
}
$ca970ce8cf2750a2$var$record.mirror = $ca970ce8cf2750a2$var$mirror;
$ca970ce8cf2750a2$var$record.takeFullSnapshot = $ca970ce8cf2750a2$var$takeFullSnapshot;
function $ca970ce8cf2750a2$var$_getCanvasManager(getCanvasManagerFn, options) {
    try {
        return getCanvasManagerFn ? getCanvasManagerFn(options) : new $ca970ce8cf2750a2$var$CanvasManagerNoop();
    } catch (e2) {
        console.warn('Unable to initialize CanvasManager');
        return new $ca970ce8cf2750a2$var$CanvasManagerNoop();
    }
}
const $ca970ce8cf2750a2$var$ReplayEventTypeIncrementalSnapshot = 3;
const $ca970ce8cf2750a2$var$ReplayEventTypeCustom = 5;
/**
 * Converts a timestamp to ms, if it was in s, or keeps it as ms.
 */ function $ca970ce8cf2750a2$var$timestampToMs(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp : timestamp * 1000;
}
/**
 * Converts a timestamp to s, if it was in ms, or keeps it as s.
 */ function $ca970ce8cf2750a2$var$timestampToS(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Add a breadcrumb event to replay.
 */ function $ca970ce8cf2750a2$var$addBreadcrumbEvent(replay, breadcrumb) {
    if (breadcrumb.category === 'sentry.transaction') return;
    if ([
        'ui.click',
        'ui.input'
    ].includes(breadcrumb.category)) replay.triggerUserActivity();
    else replay.checkAndHandleExpiredSession();
    replay.addUpdate(()=>{
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $ca970ce8cf2750a2$var$EventType.Custom,
            // TODO: We were converting from ms to seconds for breadcrumbs, spans,
            // but maybe we should just keep them as milliseconds
            timestamp: (breadcrumb.timestamp || 0) * 1000,
            data: {
                tag: 'breadcrumb',
                // normalize to max. 10 depth and 1_000 properties per object
                payload: (0, $8bc2e4fa750aec36$export$a3295358bff77e)(breadcrumb, 10, 1000)
            }
        });
        // Do not flush after console log messages
        return breadcrumb.category === 'console';
    });
}
const $ca970ce8cf2750a2$var$INTERACTIVE_SELECTOR = 'button,a';
/** Get the closest interactive parent element, or else return the given element. */ function $ca970ce8cf2750a2$var$getClosestInteractive(element) {
    const closestInteractive = element.closest($ca970ce8cf2750a2$var$INTERACTIVE_SELECTOR);
    return closestInteractive || element;
}
/**
 * For clicks, we check if the target is inside of a button or link
 * If so, we use this as the target instead
 * This is useful because if you click on the image in <button><img></button>,
 * The target will be the image, not the button, which we don't want here
 */ function $ca970ce8cf2750a2$var$getClickTargetNode(event) {
    const target = $ca970ce8cf2750a2$var$getTargetNode(event);
    if (!target || !(target instanceof Element)) return target;
    return $ca970ce8cf2750a2$var$getClosestInteractive(target);
}
/** Get the event target node. */ function $ca970ce8cf2750a2$var$getTargetNode(event) {
    if ($ca970ce8cf2750a2$var$isEventWithTarget(event)) return event.target;
    return event;
}
function $ca970ce8cf2750a2$var$isEventWithTarget(event) {
    return typeof event === 'object' && !!event && 'target' in event;
}
let $ca970ce8cf2750a2$var$handlers;
/**
 * Register a handler to be called when `window.open()` is called.
 * Returns a cleanup function.
 */ function $ca970ce8cf2750a2$var$onWindowOpen(cb) {
    // Ensure to only register this once
    if (!$ca970ce8cf2750a2$var$handlers) {
        $ca970ce8cf2750a2$var$handlers = [];
        $ca970ce8cf2750a2$var$monkeyPatchWindowOpen();
    }
    $ca970ce8cf2750a2$var$handlers.push(cb);
    return ()=>{
        const pos = $ca970ce8cf2750a2$var$handlers ? $ca970ce8cf2750a2$var$handlers.indexOf(cb) : -1;
        if (pos > -1) $ca970ce8cf2750a2$var$handlers.splice(pos, 1);
    };
}
function $ca970ce8cf2750a2$var$monkeyPatchWindowOpen() {
    (0, $68dbcfd11e00a6d4$export$9563e054e6f787fb)($ca970ce8cf2750a2$var$WINDOW, 'open', function(originalWindowOpen) {
        return function(...args) {
            if ($ca970ce8cf2750a2$var$handlers) try {
                $ca970ce8cf2750a2$var$handlers.forEach((handler)=>handler());
            } catch (e) {
            // ignore errors in here
            }
            return originalWindowOpen.apply($ca970ce8cf2750a2$var$WINDOW, args);
        };
    });
}
/** Handle a click. */ function $ca970ce8cf2750a2$var$handleClick(clickDetector, clickBreadcrumb, node) {
    clickDetector.handleClick(clickBreadcrumb, node);
}
/** A click detector class that can be used to detect slow or rage clicks on elements. */ class $ca970ce8cf2750a2$var$ClickDetector {
    // protected for testing
    constructor(replay, slowClickConfig, // Just for easier testing
    _addBreadcrumbEvent = $ca970ce8cf2750a2$var$addBreadcrumbEvent){
        this._lastMutation = 0;
        this._lastScroll = 0;
        this._clicks = [];
        // We want everything in s, but options are in ms
        this._timeout = slowClickConfig.timeout / 1000;
        this._threshold = slowClickConfig.threshold / 1000;
        this._scollTimeout = slowClickConfig.scrollTimeout / 1000;
        this._replay = replay;
        this._ignoreSelector = slowClickConfig.ignoreSelector;
        this._addBreadcrumbEvent = _addBreadcrumbEvent;
    }
    /** Register click detection handlers on mutation or scroll. */ addListeners() {
        const cleanupWindowOpen = $ca970ce8cf2750a2$var$onWindowOpen(()=>{
            // Treat window.open as mutation
            this._lastMutation = $ca970ce8cf2750a2$var$nowInSeconds();
        });
        this._teardown = ()=>{
            cleanupWindowOpen();
            this._clicks = [];
            this._lastMutation = 0;
            this._lastScroll = 0;
        };
    }
    /** Clean up listeners. */ removeListeners() {
        if (this._teardown) this._teardown();
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
    }
    /** @inheritDoc */ handleClick(breadcrumb, node) {
        if ($ca970ce8cf2750a2$var$ignoreElement(node, this._ignoreSelector) || !$ca970ce8cf2750a2$var$isClickBreadcrumb(breadcrumb)) return;
        const newClick = {
            timestamp: $ca970ce8cf2750a2$var$timestampToS(breadcrumb.timestamp),
            clickBreadcrumb: breadcrumb,
            // Set this to 0 so we know it originates from the click breadcrumb
            clickCount: 0,
            node: node
        };
        // If there was a click in the last 1s on the same element, ignore it - only keep a single reference per second
        if (this._clicks.some((click)=>click.node === newClick.node && Math.abs(click.timestamp - newClick.timestamp) < 1)) return;
        this._clicks.push(newClick);
        // If this is the first new click, set a timeout to check for multi clicks
        if (this._clicks.length === 1) this._scheduleCheckClicks();
    }
    /** @inheritDoc */ registerMutation(timestamp = Date.now()) {
        this._lastMutation = $ca970ce8cf2750a2$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerScroll(timestamp = Date.now()) {
        this._lastScroll = $ca970ce8cf2750a2$var$timestampToS(timestamp);
    }
    /** @inheritDoc */ registerClick(element) {
        const node = $ca970ce8cf2750a2$var$getClosestInteractive(element);
        this._handleMultiClick(node);
    }
    /** Count multiple clicks on elements. */ _handleMultiClick(node) {
        this._getClicks(node).forEach((click)=>{
            click.clickCount++;
        });
    }
    /** Get all pending clicks for a given node. */ _getClicks(node) {
        return this._clicks.filter((click)=>click.node === node);
    }
    /** Check the clicks that happened. */ _checkClicks() {
        const timedOutClicks = [];
        const now = $ca970ce8cf2750a2$var$nowInSeconds();
        this._clicks.forEach((click)=>{
            if (!click.mutationAfter && this._lastMutation) click.mutationAfter = click.timestamp <= this._lastMutation ? this._lastMutation - click.timestamp : undefined;
            if (!click.scrollAfter && this._lastScroll) click.scrollAfter = click.timestamp <= this._lastScroll ? this._lastScroll - click.timestamp : undefined;
            // All of these are in seconds!
            if (click.timestamp + this._timeout <= now) timedOutClicks.push(click);
        });
        // Remove "old" clicks
        for (const click of timedOutClicks){
            const pos = this._clicks.indexOf(click);
            if (pos > -1) {
                this._generateBreadcrumbs(click);
                this._clicks.splice(pos, 1);
            }
        }
        // Trigger new check, unless no clicks left
        if (this._clicks.length) this._scheduleCheckClicks();
    }
    /** Generate matching breadcrumb(s) for the click. */ _generateBreadcrumbs(click) {
        const replay = this._replay;
        const hadScroll = click.scrollAfter && click.scrollAfter <= this._scollTimeout;
        const hadMutation = click.mutationAfter && click.mutationAfter <= this._threshold;
        const isSlowClick = !hadScroll && !hadMutation;
        const { clickCount: clickCount, clickBreadcrumb: clickBreadcrumb } = click;
        // Slow click
        if (isSlowClick) {
            // If `mutationAfter` is set, it means a mutation happened after the threshold, but before the timeout
            // If not, it means we just timed out without scroll & mutation
            const timeAfterClickMs = Math.min(click.mutationAfter || this._timeout, this._timeout) * 1000;
            const endReason = timeAfterClickMs < this._timeout * 1000 ? 'mutation' : 'timeout';
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.slowClickDetected',
                data: {
                    ...clickBreadcrumb.data,
                    url: $ca970ce8cf2750a2$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    timeAfterClickMs: timeAfterClickMs,
                    endReason: endReason,
                    // If clickCount === 0, it means multiClick was not correctly captured here
                    // - we still want to send 1 in this case
                    clickCount: clickCount || 1
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
            return;
        }
        // Multi click
        if (clickCount > 1) {
            const breadcrumb = {
                type: 'default',
                message: clickBreadcrumb.message,
                timestamp: clickBreadcrumb.timestamp,
                category: 'ui.multiClick',
                data: {
                    ...clickBreadcrumb.data,
                    url: $ca970ce8cf2750a2$var$WINDOW.location.href,
                    route: replay.getCurrentRoute(),
                    clickCount: clickCount,
                    metric: true
                }
            };
            this._addBreadcrumbEvent(replay, breadcrumb);
        }
    }
    /** Schedule to check current clicks. */ _scheduleCheckClicks() {
        if (this._checkClickTimeout) clearTimeout(this._checkClickTimeout);
        this._checkClickTimeout = (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(()=>this._checkClicks(), 1000);
    }
}
const $ca970ce8cf2750a2$var$SLOW_CLICK_TAGS = [
    'A',
    'BUTTON',
    'INPUT'
];
/** exported for tests only */ function $ca970ce8cf2750a2$var$ignoreElement(node, ignoreSelector) {
    if (!$ca970ce8cf2750a2$var$SLOW_CLICK_TAGS.includes(node.tagName)) return true;
    // If <input> tag, we only want to consider input[type='submit'] & input[type='button']
    if (node.tagName === 'INPUT' && ![
        'submit',
        'button'
    ].includes(node.getAttribute('type') || '')) return true;
    // If <a> tag, detect special variants that may not lead to an action
    // If target !== _self, we may open the link somewhere else, which would lead to no action
    // Also, when downloading a file, we may not leave the page, but still not trigger an action
    if (node.tagName === 'A' && (node.hasAttribute('download') || node.hasAttribute('target') && node.getAttribute('target') !== '_self')) return true;
    if (ignoreSelector && node.matches(ignoreSelector)) return true;
    return false;
}
function $ca970ce8cf2750a2$var$isClickBreadcrumb(breadcrumb) {
    return !!(breadcrumb.data && typeof breadcrumb.data.nodeId === 'number' && breadcrumb.timestamp);
}
// This is good enough for us, and is easier to test/mock than `timestampInSeconds`
function $ca970ce8cf2750a2$var$nowInSeconds() {
    return Date.now() / 1000;
}
/** Update the click detector based on a recording event of rrweb. */ function $ca970ce8cf2750a2$var$updateClickDetectorForRecordingEvent(clickDetector, event) {
    try {
        // note: We only consider incremental snapshots here
        // This means that any full snapshot is ignored for mutation detection - the reason is that we simply cannot know if a mutation happened here.
        // E.g. think that we are buffering, an error happens and we take a full snapshot because we switched to session mode -
        // in this scenario, we would not know if a dead click happened because of the error, which is a key dead click scenario.
        // Instead, by ignoring full snapshots, we have the risk that we generate a false positive
        // (if a mutation _did_ happen but was "swallowed" by the full snapshot)
        // But this should be more unlikely as we'd generally capture the incremental snapshot right away
        if (!$ca970ce8cf2750a2$var$isIncrementalEvent(event)) return;
        const { source: source } = event.data;
        if (source === $ca970ce8cf2750a2$var$IncrementalSource.Mutation) clickDetector.registerMutation(event.timestamp);
        if (source === $ca970ce8cf2750a2$var$IncrementalSource.Scroll) clickDetector.registerScroll(event.timestamp);
        if ($ca970ce8cf2750a2$var$isIncrementalMouseInteraction(event)) {
            const { type: type, id: id } = event.data;
            const node = $ca970ce8cf2750a2$var$record.mirror.getNode(id);
            if (node instanceof HTMLElement && type === $ca970ce8cf2750a2$var$MouseInteractions.Click) clickDetector.registerClick(node);
        }
    } catch (e) {
    // ignore errors here, e.g. if accessing something that does not exist
    }
}
function $ca970ce8cf2750a2$var$isIncrementalEvent(event) {
    return event.type === $ca970ce8cf2750a2$var$ReplayEventTypeIncrementalSnapshot;
}
function $ca970ce8cf2750a2$var$isIncrementalMouseInteraction(event) {
    return event.data.source === $ca970ce8cf2750a2$var$IncrementalSource.MouseInteraction;
}
/**
 * Create a breadcrumb for a replay.
 */ function $ca970ce8cf2750a2$var$createBreadcrumb(breadcrumb) {
    return {
        timestamp: Date.now() / 1000,
        type: 'default',
        ...breadcrumb
    };
}
var $ca970ce8cf2750a2$var$NodeType;
(function(NodeType) {
    NodeType[NodeType["Document"] = 0] = "Document";
    NodeType[NodeType["DocumentType"] = 1] = "DocumentType";
    NodeType[NodeType["Element"] = 2] = "Element";
    NodeType[NodeType["Text"] = 3] = "Text";
    NodeType[NodeType["CDATA"] = 4] = "CDATA";
    NodeType[NodeType["Comment"] = 5] = "Comment";
})($ca970ce8cf2750a2$var$NodeType || ($ca970ce8cf2750a2$var$NodeType = {}));
// Note that these are the serialized attributes and not attributes directly on
// the DOM Node. Attributes we are interested in:
const $ca970ce8cf2750a2$var$ATTRIBUTES_TO_RECORD = new Set([
    'id',
    'class',
    'aria-label',
    'role',
    'name',
    'alt',
    'title',
    'data-test-id',
    'data-testid',
    'disabled',
    'aria-disabled',
    'data-sentry-component'
]);
/**
 * Inclusion list of attributes that we want to record from the DOM element
 */ function $ca970ce8cf2750a2$var$getAttributesToRecord(attributes) {
    const obj = {};
    if (!attributes['data-sentry-component'] && attributes['data-sentry-element']) attributes['data-sentry-component'] = attributes['data-sentry-element'];
    for(const key in attributes)if ($ca970ce8cf2750a2$var$ATTRIBUTES_TO_RECORD.has(key)) {
        let normalizedKey = key;
        if (key === 'data-testid' || key === 'data-test-id') normalizedKey = 'testId';
        obj[normalizedKey] = attributes[key];
    }
    return obj;
}
const $ca970ce8cf2750a2$var$handleDomListener = (replay)=>{
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $ca970ce8cf2750a2$var$handleDom(handlerData);
        if (!result) return;
        const isClick = handlerData.name === 'click';
        const event = isClick ? handlerData.event : undefined;
        // Ignore clicks if ctrl/alt/meta/shift keys are held down as they alter behavior of clicks (e.g. open in new tab)
        if (isClick && replay.clickDetector && event && event.target && !event.altKey && !event.metaKey && !event.ctrlKey && !event.shiftKey) $ca970ce8cf2750a2$var$handleClick(replay.clickDetector, result, $ca970ce8cf2750a2$var$getClickTargetNode(handlerData.event));
        $ca970ce8cf2750a2$var$addBreadcrumbEvent(replay, result);
    };
};
/** Get the base DOM breadcrumb. */ function $ca970ce8cf2750a2$var$getBaseDomBreadcrumb(target, message) {
    const nodeId = $ca970ce8cf2750a2$var$record.mirror.getId(target);
    const node = nodeId && $ca970ce8cf2750a2$var$record.mirror.getNode(nodeId);
    const meta = node && $ca970ce8cf2750a2$var$record.mirror.getMeta(node);
    const element = meta && $ca970ce8cf2750a2$var$isElement(meta) ? meta : null;
    return {
        message: message,
        data: element ? {
            nodeId: nodeId,
            node: {
                id: nodeId,
                tagName: element.tagName,
                textContent: Array.from(element.childNodes).map((node)=>node.type === $ca970ce8cf2750a2$var$NodeType.Text && node.textContent).filter(Boolean) // filter out empty values
                .map((text)=>text.trim()).join(''),
                attributes: $ca970ce8cf2750a2$var$getAttributesToRecord(element.attributes)
            }
        } : {}
    };
}
/**
 * An event handler to react to DOM events.
 * Exported for tests.
 */ function $ca970ce8cf2750a2$var$handleDom(handlerData) {
    const { target: target, message: message } = $ca970ce8cf2750a2$var$getDomTarget(handlerData);
    return $ca970ce8cf2750a2$var$createBreadcrumb({
        category: `ui.${handlerData.name}`,
        ...$ca970ce8cf2750a2$var$getBaseDomBreadcrumb(target, message)
    });
}
function $ca970ce8cf2750a2$var$getDomTarget(handlerData) {
    const isClick = handlerData.name === 'click';
    let message;
    let target = null;
    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
        target = isClick ? $ca970ce8cf2750a2$var$getClickTargetNode(handlerData.event) : $ca970ce8cf2750a2$var$getTargetNode(handlerData.event);
        message = (0, $b076601639d1314e$export$5647df6b7814ac86)(target, {
            maxStringLength: 200
        }) || '<unknown>';
    } catch (e) {
        message = '<unknown>';
    }
    return {
        target: target,
        message: message
    };
}
function $ca970ce8cf2750a2$var$isElement(node) {
    return node.type === $ca970ce8cf2750a2$var$NodeType.Element;
}
/** Handle keyboard events & create breadcrumbs. */ function $ca970ce8cf2750a2$var$handleKeyboardEvent(replay, event) {
    if (!replay.isEnabled()) return;
    // Update user activity, but do not restart recording as it can create
    // noisy/low-value replays (e.g. user comes back from idle, hits alt-tab, new
    // session with a single "keydown" breadcrumb is created)
    replay.updateUserActivity();
    const breadcrumb = $ca970ce8cf2750a2$var$getKeyboardBreadcrumb(event);
    if (!breadcrumb) return;
    $ca970ce8cf2750a2$var$addBreadcrumbEvent(replay, breadcrumb);
}
/** exported only for tests */ function $ca970ce8cf2750a2$var$getKeyboardBreadcrumb(event) {
    const { metaKey: metaKey, shiftKey: shiftKey, ctrlKey: ctrlKey, altKey: altKey, key: key, target: target } = event;
    // never capture for input fields
    if (!target || $ca970ce8cf2750a2$var$isInputElement(target) || !key) return null;
    // Note: We do not consider shift here, as that means "uppercase"
    const hasModifierKey = metaKey || ctrlKey || altKey;
    const isCharacterKey = key.length === 1; // other keys like Escape, Tab, etc have a longer length
    // Do not capture breadcrumb if only a word key is pressed
    // This could leak e.g. user input
    if (!hasModifierKey && isCharacterKey) return null;
    const message = (0, $b076601639d1314e$export$5647df6b7814ac86)(target, {
        maxStringLength: 200
    }) || '<unknown>';
    const baseBreadcrumb = $ca970ce8cf2750a2$var$getBaseDomBreadcrumb(target, message);
    return $ca970ce8cf2750a2$var$createBreadcrumb({
        category: 'ui.keyDown',
        message: message,
        data: {
            ...baseBreadcrumb.data,
            metaKey: metaKey,
            shiftKey: shiftKey,
            ctrlKey: ctrlKey,
            altKey: altKey,
            key: key
        }
    });
}
function $ca970ce8cf2750a2$var$isInputElement(target) {
    return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable;
}
// Map entryType -> function to normalize data for event
const $ca970ce8cf2750a2$var$ENTRY_TYPES = {
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    resource: $ca970ce8cf2750a2$var$createResourceEntry,
    paint: $ca970ce8cf2750a2$var$createPaintEntry,
    // @ts-expect-error TODO: entry type does not fit the create* functions entry type
    navigation: $ca970ce8cf2750a2$var$createNavigationEntry
};
/**
 * Create replay performance entries from the browser performance entries.
 */ function $ca970ce8cf2750a2$var$createPerformanceEntries(entries) {
    return entries.map($ca970ce8cf2750a2$var$createPerformanceEntry).filter(Boolean);
}
function $ca970ce8cf2750a2$var$createPerformanceEntry(entry) {
    if (!$ca970ce8cf2750a2$var$ENTRY_TYPES[entry.entryType]) return null;
    return $ca970ce8cf2750a2$var$ENTRY_TYPES[entry.entryType](entry);
}
function $ca970ce8cf2750a2$var$getAbsoluteTime(time) {
    // browserPerformanceTimeOrigin can be undefined if `performance` or
    // `performance.now` doesn't exist, but this is already checked by this integration
    return (((0, $8f221861fb4a2bd8$export$baf075a948ffc0bf) || $ca970ce8cf2750a2$var$WINDOW.performance.timeOrigin) + time) / 1000;
}
function $ca970ce8cf2750a2$var$createPaintEntry(entry) {
    const { duration: duration, entryType: entryType, name: name, startTime: startTime } = entry;
    const start = $ca970ce8cf2750a2$var$getAbsoluteTime(startTime);
    return {
        type: entryType,
        name: name,
        start: start,
        end: start + duration,
        data: undefined
    };
}
function $ca970ce8cf2750a2$var$createNavigationEntry(entry) {
    const { entryType: entryType, name: name, decodedBodySize: decodedBodySize, duration: duration, domComplete: domComplete, encodedBodySize: encodedBodySize, domContentLoadedEventStart: domContentLoadedEventStart, domContentLoadedEventEnd: domContentLoadedEventEnd, domInteractive: domInteractive, loadEventStart: loadEventStart, loadEventEnd: loadEventEnd, redirectCount: redirectCount, startTime: startTime, transferSize: transferSize, type: type } = entry;
    // Ignore entries with no duration, they do not seem to be useful and cause dupes
    if (duration === 0) return null;
    return {
        type: `${entryType}.${type}`,
        start: $ca970ce8cf2750a2$var$getAbsoluteTime(startTime),
        end: $ca970ce8cf2750a2$var$getAbsoluteTime(domComplete),
        name: name,
        data: {
            size: transferSize,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize,
            duration: duration,
            domInteractive: domInteractive,
            domContentLoadedEventStart: domContentLoadedEventStart,
            domContentLoadedEventEnd: domContentLoadedEventEnd,
            loadEventStart: loadEventStart,
            loadEventEnd: loadEventEnd,
            domComplete: domComplete,
            redirectCount: redirectCount
        }
    };
}
function $ca970ce8cf2750a2$var$createResourceEntry(entry) {
    const { entryType: entryType, initiatorType: initiatorType, name: name, responseEnd: responseEnd, startTime: startTime, decodedBodySize: decodedBodySize, encodedBodySize: encodedBodySize, responseStatus: responseStatus, transferSize: transferSize } = entry;
    // Core SDK handles these
    if ([
        'fetch',
        'xmlhttprequest'
    ].includes(initiatorType)) return null;
    return {
        type: `${entryType}.${initiatorType}`,
        start: $ca970ce8cf2750a2$var$getAbsoluteTime(startTime),
        end: $ca970ce8cf2750a2$var$getAbsoluteTime(responseEnd),
        name: name,
        data: {
            size: transferSize,
            statusCode: responseStatus,
            decodedBodySize: decodedBodySize,
            encodedBodySize: encodedBodySize
        }
    };
}
/**
 * Add a LCP event to the replay based on an LCP metric.
 */ function $ca970ce8cf2750a2$var$getLargestContentfulPaint(metric) {
    const entries = metric.entries;
    const lastEntry = entries[entries.length - 1];
    const element = lastEntry ? lastEntry.element : undefined;
    const value = metric.value;
    const end = $ca970ce8cf2750a2$var$getAbsoluteTime(value);
    const data = {
        type: 'largest-contentful-paint',
        name: 'largest-contentful-paint',
        start: end,
        end: end,
        data: {
            value: value,
            size: value,
            nodeId: element ? $ca970ce8cf2750a2$var$record.mirror.getId(element) : undefined
        }
    };
    return data;
}
/**
 * Sets up a PerformanceObserver to listen to all performance entry types.
 * Returns a callback to stop observing.
 */ function $ca970ce8cf2750a2$var$setupPerformanceObserver(replay) {
    function addPerformanceEntry(entry) {
        // It is possible for entries to come up multiple times
        if (!replay.performanceEntries.includes(entry)) replay.performanceEntries.push(entry);
    }
    function onEntries({ entries: entries }) {
        entries.forEach(addPerformanceEntry);
    }
    const clearCallbacks = [];
    [
        'navigation',
        'paint',
        'resource'
    ].forEach((type)=>{
        clearCallbacks.push((0, $4deab877b1f61f68$export$69816c1a049f8db6)(type, onEntries));
    });
    clearCallbacks.push((0, $4deab877b1f61f68$export$3fd4b53331200102)(({ metric: metric })=>{
        replay.replayPerformanceEntries.push($ca970ce8cf2750a2$var$getLargestContentfulPaint(metric));
    }));
    // A callback to cleanup all handlers
    return ()=>{
        clearCallbacks.forEach((clearCallback)=>clearCallback());
    };
}
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $ca970ce8cf2750a2$var$DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;
const $ca970ce8cf2750a2$var$r = `var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),a=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),s=function(t,e){for(var i=new n(31),a=0;a<31;++a)i[a]=e+=1<<t[a-1];var s=new r(i[30]);for(a=1;a<30;++a)for(var o=i[a];o<i[a+1];++o)s[o]=o-i[a]<<5|a;return{b:i,r:s}},o=s(e,2),f=o.b,h=o.r;f[28]=258,h[258]=28;for(var l=s(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,a=0,s=new n(r);a<i;++a)t[a]&&++s[t[a]-1];var o,f=new n(r);for(a=1;a<r;++a)f[a]=f[a-1]+s[a-1]<<1;if(e){o=new n(1<<r);var h=15-r;for(a=0;a<i;++a)if(t[a])for(var l=a<<4|t[a],c=r-t[a],v=f[t[a]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>h]=l}else for(o=new n(i),a=0;a<i;++a)t[a]&&(o[a]=u[f[t[a]-1]++]>>15-t[a]);return o},g=new t(288);for(c=0;c<144;++c)g[c]=8;for(c=144;c<256;++c)g[c]=9;for(c=256;c<280;++c)g[c]=7;for(c=280;c<288;++c)g[c]=8;var w=new t(32);for(c=0;c<32;++c)w[c]=5;var p=d(g,9,0),y=d(w,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==r||r<0)&&(r=0),(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},A=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},_=function(r,e){for(var i=[],a=0;a<r.length;++a)r[a]&&i.push({s:a,f:r[a]});var s=i.length,o=i.slice();if(!s)return{t:F,l:0};if(1==s){var f=new t(i[0].s+1);return f[i[0].s]=1,{t:f,l:1}}i.sort((function(t,n){return t.f-n.f})),i.push({s:-1,f:25001});var h=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:h.f+l.f,l:h,r:l};c!=s-1;)h=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:h.f+l.f,l:h,r:l};var d=o[0].s;for(a=1;a<s;++a)o[a].s>d&&(d=o[a].s);var g=new n(d+1),w=x(i[c-1],g,0);if(w>e){a=0;var p=0,y=w-e,m=1<<y;for(o.sort((function(t,n){return g[n.s]-g[t.s]||t.f-n.f}));a<s;++a){var b=o[a].s;if(!(g[b]>e))break;p+=m-(1<<w-g[b]),g[b]=e}for(p>>=y;p>0;){var M=o[a].s;g[M]<e?p-=1<<e-g[M]++-1:++a}for(;a>=0&&p;--a){var E=o[a].s;g[E]==e&&(--g[E],++p)}w=e}return{t:new t(g),l:w}},x=function(t,n,r){return-1==t.s?Math.max(x(t.l,n,r+1),x(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,a=t[0],s=1,o=function(t){e[i++]=t},f=1;f<=r;++f)if(t[f]==a&&f!=r)++s;else{if(!a&&s>2){for(;s>138;s-=138)o(32754);s>2&&(o(s>10?s-11<<5|28690:s-3<<5|12305),s=0)}else if(s>3){for(o(a),--s;s>6;s-=6)o(8304);s>2&&(o(s-3<<5|8208),s=0)}for(;s--;)o(a);s=1,a=t[f]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<e;++a)t[i+a+4]=r[a];return 8*(i+4+e)},C=function(t,r,s,o,f,h,l,u,c,v,m){z(r,m++,s),++f[256];for(var b=_(f,15),M=b.t,E=b.l,x=_(h,15),C=x.t,U=x.l,F=D(M),I=F.c,S=F.n,L=D(C),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=_(q,7),H=G.t,J=G.l,K=19;K>4&&!H[a[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(f,g)+T(h,w)+l,X=T(f,M)+T(h,C)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(C,U,0),R=C;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[a[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=p,P=g,Q=y,R=w;for(B=0;B<u;++B){var rt=o[B];if(rt>255){A(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;A(r,m,Q[et]),m+=R[et],et>3&&(A(r,m,rt>>5&8191),m+=i[et])}else A(r,m,N[rt]),m+=P[rt]}return A(r,m,N[256]),m+P[256]},U=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}},L=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,a=0|r.length,s=0;s!=a;){for(var o=Math.min(s+2655,a);s<o;++s)i+=e+=r[s];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},O=function(a,s,o,f,u){if(!u&&(u={l:1},s.dictionary)){var c=s.dictionary.subarray(-32768),v=new t(c.length+a.length);v.set(c),v.set(a,c.length),a=v,u.w=c.length}return function(a,s,o,f,u,c){var v=c.z||a.length,d=new t(f+v+5*(1+Math.ceil(v/7e3))+u),g=d.subarray(f,d.length-u),w=c.l,p=7&(c.r||0);if(s){p&&(g[0]=c.r>>3);for(var y=U[s-1],M=y>>13,E=8191&y,z=(1<<o)-1,A=c.p||new n(32768),_=c.h||new n(z+1),x=Math.ceil(o/3),D=2*x,T=function(t){return(a[t]^a[t+1]<<x^a[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=_[H];if(A[J]=K,_[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!w)){p=C(a,g,0,F,I,S,O,q,G,j-G,p),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(a[j+Q]==a[j+Q-W]){for(var $=0;$<Z&&a[j+$]==a[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-A[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=A[J])&32767}if(R){F[q++]=268435456|h[Q]<<18|l[R];var it=31&h[Q],at=31&l[R];O+=e[it]+i[at],++I[257+it],++S[at],B=j+Q,++L}else F[q++]=a[j],++I[a[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=a[j],++I[a[j]];p=C(a,g,w,F,I,S,O,q,G,j-G,p),w||(c.r=7&p|g[p/8|0]<<3,p-=7,c.h=_,c.p=A,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+w;j+=65535){var st=j+65535;st>=v&&(g[p/8|0]=w,st=v),p=k(g,p+1,a.subarray(j,st))}c.i=v}return b(d,0,f+m(p)+u)}(a,null==s.level?6:s.level,null==s.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(a.length)))):12+s.mem,o,f,u)},j=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},q=function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&j(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}},B=function(t){return 10+(t.filename?t.filename.length+1:0)},G=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(O(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var a=this.b.length-this.s.z;a&&(this.b.set(n.subarray(0,a),this.s.z),this.s.z=this.b.length,this.p(this.b,!1)),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(a),32768),this.s.z=n.length-a+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n}();var H=function(){function t(t,n){this.c=L(),this.v=1,G.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),G.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=O(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=L();i.p(n.dictionary),j(t,2,i.d())}}(r,this.o),this.v=0),n&&j(r,r.length-4,this.c.d()),this.ondata(r,n)},t}(),J="undefined"!=typeof TextEncoder&&new TextEncoder,K="undefined"!=typeof TextDecoder&&new TextDecoder;try{K.decode(F,{stream:!0})}catch(t){}var N=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(P(t),this.d=n||!1)},t}();function P(n,r){if(r){for(var e=new t(n.length),i=0;i<n.length;++i)e[i]=n.charCodeAt(i);return e}if(J)return J.encode(n);var a=n.length,s=new t(n.length+(n.length>>1)),o=0,f=function(t){s[o++]=t};for(i=0;i<a;++i){if(o+5>s.length){var h=new t(o+8+(a-i<<1));h.set(s),s=h}var l=n.charCodeAt(i);l<128||r?f(l):l<2048?(f(192|l>>6),f(128|63&l)):l>55295&&l<57344?(f(240|(l=65536+(1047552&l)|1023&n.charCodeAt(++i))>>18),f(128|l>>12&63),f(128|l>>6&63),f(128|63&l)):(f(224|l>>12),f(128|l>>6&63),f(128|63&l))}return b(s,0,o)}function Q(t){return function(t,n){n||(n={});var r=S(),e=t.length;r.p(t);var i=O(t,n,B(n),8),a=i.length;return q(i,n),j(i,a-8,r.d()),j(i,a-4,e),i}(P(t))}const R=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(let r=0,e=t.length;r<e;r++)n+=t[r].length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new H,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new N(((t,n)=>{this.deflate.push(t,n)})),this.stream.push("[")}},V={clear:()=>{R.clear()},addEvent:t=>R.addEvent(t),finish:()=>R.finish(),compress:t=>Q(t)};addEventListener("message",(function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in V&&"function"==typeof V[n])try{const t=V[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}})),postMessage({id:void 0,method:"init",success:!0,response:void 0});`;
function $ca970ce8cf2750a2$var$e() {
    const e = new Blob([
        $ca970ce8cf2750a2$var$r
    ]);
    return URL.createObjectURL(e);
}
/**
 * Log a message in debug mode, and add a breadcrumb when _experiment.traceInternals is enabled.
 */ function $ca970ce8cf2750a2$var$logInfo(message, shouldAddBreadcrumb) {
    if (!$ca970ce8cf2750a2$var$DEBUG_BUILD) return;
    (0, $117c8f31aa65bddd$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) $ca970ce8cf2750a2$var$addLogBreadcrumb(message);
}
/**
 * Log a message, and add a breadcrumb in the next tick.
 * This is necessary when the breadcrumb may be added before the replay is initialized.
 */ function $ca970ce8cf2750a2$var$logInfoNextTick(message, shouldAddBreadcrumb) {
    if (!$ca970ce8cf2750a2$var$DEBUG_BUILD) return;
    (0, $117c8f31aa65bddd$export$af88d00dbe7f521).info(message);
    if (shouldAddBreadcrumb) // Wait a tick here to avoid race conditions for some initial logs
    // which may be added before replay is initialized
    (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(()=>{
        $ca970ce8cf2750a2$var$addLogBreadcrumb(message);
    }, 0);
}
function $ca970ce8cf2750a2$var$addLogBreadcrumb(message) {
    (0, $648b3b5e93c10281$export$efda9a273d7a036d)({
        category: 'console',
        data: {
            logger: 'replay'
        },
        level: 'info',
        message: message
    }, {
        level: 'info'
    });
}
/** This error indicates that the event buffer size exceeded the limit.. */ class $ca970ce8cf2750a2$var$EventBufferSizeExceededError extends Error {
    constructor(){
        super(`Event buffer exceeded maximum size of ${$ca970ce8cf2750a2$var$REPLAY_MAX_EVENT_BUFFER_SIZE}.`);
    }
}
/**
 * A basic event buffer that does not do any compression.
 * Used as fallback if the compression worker cannot be loaded or is disabled.
 */ class $ca970ce8cf2750a2$var$EventBufferArray {
    /** All the events that are buffered to be sent. */ /** @inheritdoc */ constructor(){
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return this.events.length > 0;
    }
    /** @inheritdoc */ get type() {
        return 'sync';
    }
    /** @inheritdoc */ destroy() {
        this.events = [];
    }
    /** @inheritdoc */ async addEvent(event) {
        const eventSize = JSON.stringify(event).length;
        this._totalSize += eventSize;
        if (this._totalSize > $ca970ce8cf2750a2$var$REPLAY_MAX_EVENT_BUFFER_SIZE) throw new $ca970ce8cf2750a2$var$EventBufferSizeExceededError();
        this.events.push(event);
    }
    /** @inheritdoc */ finish() {
        return new Promise((resolve)=>{
            // Make a copy of the events array reference and immediately clear the
            // events member so that we do not lose new events while uploading
            // attachment.
            const eventsRet = this.events;
            this.clear();
            resolve(JSON.stringify(eventsRet));
        });
    }
    /** @inheritdoc */ clear() {
        this.events = [];
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        const timestamp = this.events.map((event)=>event.timestamp).sort()[0];
        if (!timestamp) return null;
        return $ca970ce8cf2750a2$var$timestampToMs(timestamp);
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $ca970ce8cf2750a2$var$WorkerHandler {
    constructor(worker){
        this._worker = worker;
        this._id = 0;
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        // Ensure we only check once
        if (this._ensureReadyPromise) return this._ensureReadyPromise;
        this._ensureReadyPromise = new Promise((resolve, reject)=>{
            this._worker.addEventListener('message', ({ data: data })=>{
                if (data.success) resolve();
                else reject();
            }, {
                once: true
            });
            this._worker.addEventListener('error', (error)=>{
                reject(error);
            }, {
                once: true
            });
        });
        return this._ensureReadyPromise;
    }
    /**
   * Destroy the worker.
   */ destroy() {
        $ca970ce8cf2750a2$var$logInfo('[Replay] Destroying compression worker');
        this._worker.terminate();
    }
    /**
   * Post message to worker and wait for response before resolving promise.
   */ postMessage(method, arg) {
        const id = this._getAndIncrementId();
        return new Promise((resolve, reject)=>{
            const listener = ({ data: data })=>{
                const response = data;
                if (response.method !== method) return;
                // There can be multiple listeners for a single method, the id ensures
                // that the response matches the caller.
                if (response.id !== id) return;
                // At this point, we'll always want to remove listener regardless of result status
                this._worker.removeEventListener('message', listener);
                if (!response.success) {
                    // TODO: Do some error handling, not sure what
                    $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay]', response.response);
                    reject(new Error('Error in compression worker'));
                    return;
                }
                resolve(response.response);
            };
            // Note: we can't use `once` option because it's possible it needs to
            // listen to multiple messages
            this._worker.addEventListener('message', listener);
            this._worker.postMessage({
                id: id,
                method: method,
                arg: arg
            });
        });
    }
    /** Get the current ID and increment it for the next call. */ _getAndIncrementId() {
        return this._id++;
    }
}
/**
 * Event buffer that uses a web worker to compress events.
 * Exported only for testing.
 */ class $ca970ce8cf2750a2$var$EventBufferCompressionWorker {
    /** @inheritdoc */ constructor(worker){
        this._worker = new $ca970ce8cf2750a2$var$WorkerHandler(worker);
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
    }
    /** @inheritdoc */ get hasEvents() {
        return !!this._earliestTimestamp;
    }
    /** @inheritdoc */ get type() {
        return 'worker';
    }
    /**
   * Ensure the worker is ready (or not).
   * This will either resolve when the worker is ready, or reject if an error occured.
   */ ensureReady() {
        return this._worker.ensureReady();
    }
    /**
   * Destroy the event buffer.
   */ destroy() {
        this._worker.destroy();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfuly received and processed by worker.
   */ addEvent(event) {
        const timestamp = $ca970ce8cf2750a2$var$timestampToMs(event.timestamp);
        if (!this._earliestTimestamp || timestamp < this._earliestTimestamp) this._earliestTimestamp = timestamp;
        const data = JSON.stringify(event);
        this._totalSize += data.length;
        if (this._totalSize > $ca970ce8cf2750a2$var$REPLAY_MAX_EVENT_BUFFER_SIZE) return Promise.reject(new $ca970ce8cf2750a2$var$EventBufferSizeExceededError());
        return this._sendEventToWorker(data);
    }
    /**
   * Finish the event buffer and return the compressed data.
   */ finish() {
        return this._finishRequest();
    }
    /** @inheritdoc */ clear() {
        this._earliestTimestamp = null;
        this._totalSize = 0;
        this.hasCheckout = false;
        // We do not wait on this, as we assume the order of messages is consistent for the worker
        this._worker.postMessage('clear').then(null, (e)=>{
            $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Sending "clear" message to worker failed', e);
        });
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._earliestTimestamp;
    }
    /**
   * Send the event to the worker.
   */ _sendEventToWorker(data) {
        return this._worker.postMessage('addEvent', data);
    }
    /**
   * Finish the request and return the compressed data from the worker.
   */ async _finishRequest() {
        const response = await this._worker.postMessage('finish');
        this._earliestTimestamp = null;
        this._totalSize = 0;
        return response;
    }
}
/**
 * This proxy will try to use the compression worker, and fall back to use the simple buffer if an error occurs there.
 * This can happen e.g. if the worker cannot be loaded.
 * Exported only for testing.
 */ class $ca970ce8cf2750a2$var$EventBufferProxy {
    constructor(worker){
        this._fallback = new $ca970ce8cf2750a2$var$EventBufferArray();
        this._compression = new $ca970ce8cf2750a2$var$EventBufferCompressionWorker(worker);
        this._used = this._fallback;
        this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded();
    }
    /** @inheritdoc */ get type() {
        return this._used.type;
    }
    /** @inheritDoc */ get hasEvents() {
        return this._used.hasEvents;
    }
    /** @inheritdoc */ get hasCheckout() {
        return this._used.hasCheckout;
    }
    /** @inheritdoc */ set hasCheckout(value) {
        this._used.hasCheckout = value;
    }
    /** @inheritDoc */ destroy() {
        this._fallback.destroy();
        this._compression.destroy();
    }
    /** @inheritdoc */ clear() {
        return this._used.clear();
    }
    /** @inheritdoc */ getEarliestTimestamp() {
        return this._used.getEarliestTimestamp();
    }
    /**
   * Add an event to the event buffer.
   *
   * Returns true if event was successfully added.
   */ addEvent(event) {
        return this._used.addEvent(event);
    }
    /** @inheritDoc */ async finish() {
        // Ensure the worker is loaded, so the sent event is compressed
        await this.ensureWorkerIsLoaded();
        return this._used.finish();
    }
    /** Ensure the worker has loaded. */ ensureWorkerIsLoaded() {
        return this._ensureWorkerIsLoadedPromise;
    }
    /** Actually check if the worker has been loaded. */ async _ensureWorkerIsLoaded() {
        try {
            await this._compression.ensureReady();
        } catch (error) {
            // If the worker fails to load, we fall back to the simple buffer.
            // Nothing more to do from our side here
            $ca970ce8cf2750a2$var$logInfo('[Replay] Failed to load the compression worker, falling back to simple buffer');
            return;
        }
        // Now we need to switch over the array buffer to the compression worker
        await this._switchToCompressionWorker();
    }
    /** Switch the used buffer to the compression worker. */ async _switchToCompressionWorker() {
        const { events: events, hasCheckout: hasCheckout } = this._fallback;
        const addEventPromises = [];
        for (const event of events)addEventPromises.push(this._compression.addEvent(event));
        this._compression.hasCheckout = hasCheckout;
        // We switch over to the new buffer immediately - any further events will be added
        // after the previously buffered ones
        this._used = this._compression;
        // Wait for original events to be re-added before resolving
        try {
            await Promise.all(addEventPromises);
        } catch (error) {
            $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to add events when switching buffers.', error);
        }
    }
}
/**
 * Create an event buffer for replays.
 */ function $ca970ce8cf2750a2$var$createEventBuffer({ useCompression: useCompression, workerUrl: customWorkerUrl }) {
    if (useCompression && // eslint-disable-next-line no-restricted-globals
    window.Worker) {
        const worker = $ca970ce8cf2750a2$var$_loadWorker(customWorkerUrl);
        if (worker) return worker;
    }
    $ca970ce8cf2750a2$var$logInfo('[Replay] Using simple buffer');
    return new $ca970ce8cf2750a2$var$EventBufferArray();
}
function $ca970ce8cf2750a2$var$_loadWorker(customWorkerUrl) {
    try {
        const workerUrl = customWorkerUrl || $ca970ce8cf2750a2$var$_getWorkerUrl();
        if (!workerUrl) return;
        $ca970ce8cf2750a2$var$logInfo(`[Replay] Using compression worker${customWorkerUrl ? ` from ${customWorkerUrl}` : ''}`);
        const worker = new Worker(workerUrl);
        return new $ca970ce8cf2750a2$var$EventBufferProxy(worker);
    } catch (error) {
        $ca970ce8cf2750a2$var$logInfo('[Replay] Failed to create compression worker');
    // Fall back to use simple event buffer array
    }
}
function $ca970ce8cf2750a2$var$_getWorkerUrl() {
    if (typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ === 'undefined' || !__SENTRY_EXCLUDE_REPLAY_WORKER__) return $ca970ce8cf2750a2$var$e();
    return '';
}
/** If sessionStorage is available. */ function $ca970ce8cf2750a2$var$hasSessionStorage() {
    try {
        // This can throw, e.g. when being accessed in a sandboxed iframe
        return 'sessionStorage' in $ca970ce8cf2750a2$var$WINDOW && !!$ca970ce8cf2750a2$var$WINDOW.sessionStorage;
    } catch (e) {
        return false;
    }
}
/**
 * Removes the session from Session Storage and unsets session in replay instance
 */ function $ca970ce8cf2750a2$var$clearSession(replay) {
    $ca970ce8cf2750a2$var$deleteSession();
    replay.session = undefined;
}
/**
 * Deletes a session from storage
 */ function $ca970ce8cf2750a2$var$deleteSession() {
    if (!$ca970ce8cf2750a2$var$hasSessionStorage()) return;
    try {
        $ca970ce8cf2750a2$var$WINDOW.sessionStorage.removeItem($ca970ce8cf2750a2$var$REPLAY_SESSION_KEY);
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Given a sample rate, returns true if replay should be sampled.
 *
 * 1.0 = 100% sampling
 * 0.0 = 0% sampling
 */ function $ca970ce8cf2750a2$var$isSampled(sampleRate) {
    if (sampleRate === undefined) return false;
    // Math.random() returns a number in range of 0 to 1 (inclusive of 0, but not 1)
    return Math.random() < sampleRate;
}
/**
 * Get a session with defaults & applied sampling.
 */ function $ca970ce8cf2750a2$var$makeSession(session) {
    const now = Date.now();
    const id = session.id || (0, $523c16f3b9d02706$export$19f53698e68b2496)();
    // Note that this means we cannot set a started/lastActivity of `0`, but this should not be relevant outside of tests.
    const started = session.started || now;
    const lastActivity = session.lastActivity || now;
    const segmentId = session.segmentId || 0;
    const sampled = session.sampled;
    const previousSessionId = session.previousSessionId;
    return {
        id: id,
        started: started,
        lastActivity: lastActivity,
        segmentId: segmentId,
        sampled: sampled,
        previousSessionId: previousSessionId
    };
}
/**
 * Save a session to session storage.
 */ function $ca970ce8cf2750a2$var$saveSession(session) {
    if (!$ca970ce8cf2750a2$var$hasSessionStorage()) return;
    try {
        $ca970ce8cf2750a2$var$WINDOW.sessionStorage.setItem($ca970ce8cf2750a2$var$REPLAY_SESSION_KEY, JSON.stringify(session));
    } catch (e) {
    // Ignore potential SecurityError exceptions
    }
}
/**
 * Get the sampled status for a session based on sample rates & current sampled status.
 */ function $ca970ce8cf2750a2$var$getSessionSampleType(sessionSampleRate, allowBuffering) {
    return $ca970ce8cf2750a2$var$isSampled(sessionSampleRate) ? 'session' : allowBuffering ? 'buffer' : false;
}
/**
 * Create a new session, which in its current implementation is a Sentry event
 * that all replays will be saved to as attachments. Currently, we only expect
 * one of these Sentry events per "replay session".
 */ function $ca970ce8cf2750a2$var$createSession({ sessionSampleRate: sessionSampleRate, allowBuffering: allowBuffering, stickySession: stickySession = false }, { previousSessionId: previousSessionId } = {}) {
    const sampled = $ca970ce8cf2750a2$var$getSessionSampleType(sessionSampleRate, allowBuffering);
    const session = $ca970ce8cf2750a2$var$makeSession({
        sampled: sampled,
        previousSessionId: previousSessionId
    });
    if (stickySession) $ca970ce8cf2750a2$var$saveSession(session);
    return session;
}
/**
 * Fetches a session from storage
 */ function $ca970ce8cf2750a2$var$fetchSession(traceInternals) {
    if (!$ca970ce8cf2750a2$var$hasSessionStorage()) return null;
    try {
        // This can throw if cookies are disabled
        const sessionStringFromStorage = $ca970ce8cf2750a2$var$WINDOW.sessionStorage.getItem($ca970ce8cf2750a2$var$REPLAY_SESSION_KEY);
        if (!sessionStringFromStorage) return null;
        const sessionObj = JSON.parse(sessionStringFromStorage);
        $ca970ce8cf2750a2$var$logInfoNextTick('[Replay] Loading existing session', traceInternals);
        return $ca970ce8cf2750a2$var$makeSession(sessionObj);
    } catch (e) {
        return null;
    }
}
/**
 * Given an initial timestamp and an expiry duration, checks to see if current
 * time should be considered as expired.
 */ function $ca970ce8cf2750a2$var$isExpired(initialTime, expiry, targetTime = +new Date()) {
    // Always expired if < 0
    if (initialTime === null || expiry === undefined || expiry < 0) return true;
    // Never expires if == 0
    if (expiry === 0) return false;
    return initialTime + expiry <= targetTime;
}
/**
 * Checks to see if session is expired
 */ function $ca970ce8cf2750a2$var$isSessionExpired(session, { maxReplayDuration: maxReplayDuration, sessionIdleExpire: sessionIdleExpire, targetTime: targetTime = Date.now() }) {
    return(// First, check that maximum session length has not been exceeded
    $ca970ce8cf2750a2$var$isExpired(session.started, maxReplayDuration, targetTime) || // check that the idle timeout has not been exceeded (i.e. user has
    // performed an action within the last `sessionIdleExpire` ms)
    $ca970ce8cf2750a2$var$isExpired(session.lastActivity, sessionIdleExpire, targetTime));
}
/** If the session should be refreshed or not. */ function $ca970ce8cf2750a2$var$shouldRefreshSession(session, { sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration }) {
    // If not expired, all good, just keep the session
    if (!$ca970ce8cf2750a2$var$isSessionExpired(session, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return false;
    // If we are buffering & haven't ever flushed yet, always continue
    if (session.sampled === 'buffer' && session.segmentId === 0) return false;
    return true;
}
/**
 * Get or create a session, when initializing the replay.
 * Returns a session that may be unsampled.
 */ function $ca970ce8cf2750a2$var$loadOrCreateSession({ traceInternals: traceInternals, sessionIdleExpire: sessionIdleExpire, maxReplayDuration: maxReplayDuration, previousSessionId: previousSessionId }, sessionOptions) {
    const existingSession = sessionOptions.stickySession && $ca970ce8cf2750a2$var$fetchSession(traceInternals);
    // No session exists yet, just create a new one
    if (!existingSession) {
        $ca970ce8cf2750a2$var$logInfoNextTick('[Replay] Creating new session', traceInternals);
        return $ca970ce8cf2750a2$var$createSession(sessionOptions, {
            previousSessionId: previousSessionId
        });
    }
    if (!$ca970ce8cf2750a2$var$shouldRefreshSession(existingSession, {
        sessionIdleExpire: sessionIdleExpire,
        maxReplayDuration: maxReplayDuration
    })) return existingSession;
    $ca970ce8cf2750a2$var$logInfoNextTick('[Replay] Session in sessionStorage is expired, creating new one...');
    return $ca970ce8cf2750a2$var$createSession(sessionOptions, {
        previousSessionId: existingSession.id
    });
}
function $ca970ce8cf2750a2$var$isCustomEvent(event) {
    return event.type === $ca970ce8cf2750a2$var$EventType.Custom;
}
/**
 * Add an event to the event buffer.
 * In contrast to `addEvent`, this does not return a promise & does not wait for the adding of the event to succeed/fail.
 * Instead this returns `true` if we tried to add the event, else false.
 * It returns `false` e.g. if we are paused, disabled, or out of the max replay duration.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $ca970ce8cf2750a2$var$addEventSync(replay, event, isCheckout) {
    if (!$ca970ce8cf2750a2$var$shouldAddEvent(replay, event)) return false;
    // This should never reject
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    $ca970ce8cf2750a2$var$_addEvent(replay, event, isCheckout);
    return true;
}
/**
 * Add an event to the event buffer.
 * Resolves to `null` if no event was added, else to `void`.
 *
 * `isCheckout` is true if this is either the very first event, or an event triggered by `checkoutEveryNms`.
 */ function $ca970ce8cf2750a2$var$addEvent(replay, event, isCheckout) {
    if (!$ca970ce8cf2750a2$var$shouldAddEvent(replay, event)) return Promise.resolve(null);
    return $ca970ce8cf2750a2$var$_addEvent(replay, event, isCheckout);
}
async function $ca970ce8cf2750a2$var$_addEvent(replay, event, isCheckout) {
    if (!replay.eventBuffer) return null;
    try {
        if (isCheckout && replay.recordingMode === 'buffer') replay.eventBuffer.clear();
        if (isCheckout) replay.eventBuffer.hasCheckout = true;
        const replayOptions = replay.getOptions();
        const eventAfterPossibleCallback = $ca970ce8cf2750a2$var$maybeApplyCallback(event, replayOptions.beforeAddRecordingEvent);
        if (!eventAfterPossibleCallback) return;
        return await replay.eventBuffer.addEvent(eventAfterPossibleCallback);
    } catch (error) {
        const reason = error && error instanceof $ca970ce8cf2750a2$var$EventBufferSizeExceededError ? 'addEventSizeExceeded' : 'addEvent';
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(error);
        await replay.stop({
            reason: reason
        });
        const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
        if (client) client.recordDroppedEvent('internal_sdk_error', 'replay');
    }
}
/** Exported only for tests. */ function $ca970ce8cf2750a2$var$shouldAddEvent(replay, event) {
    if (!replay.eventBuffer || replay.isPaused() || !replay.isEnabled()) return false;
    const timestampInMs = $ca970ce8cf2750a2$var$timestampToMs(event.timestamp);
    // Throw out events that happen more than 5 minutes ago. This can happen if
    // page has been left open and idle for a long period of time and user
    // comes back to trigger a new session. The performance entries rely on
    // `performance.timeOrigin`, which is when the page first opened.
    if (timestampInMs + replay.timeouts.sessionIdlePause < Date.now()) return false;
    // Throw out events that are +60min from the initial timestamp
    if (timestampInMs > replay.getContext().initialTimestamp + replay.getOptions().maxReplayDuration) {
        $ca970ce8cf2750a2$var$logInfo(`[Replay] Skipping event with timestamp ${timestampInMs} because it is after maxReplayDuration`, replay.getOptions()._experiments.traceInternals);
        return false;
    }
    return true;
}
function $ca970ce8cf2750a2$var$maybeApplyCallback(event, callback) {
    try {
        if (typeof callback === 'function' && $ca970ce8cf2750a2$var$isCustomEvent(event)) return callback(event);
    } catch (error) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay] An error occured in the `beforeAddRecordingEvent` callback, skipping the event...', error);
        return null;
    }
    return event;
}
/** If the event is an error event */ function $ca970ce8cf2750a2$var$isErrorEvent(event) {
    return !event.type;
}
/** If the event is a transaction event */ function $ca970ce8cf2750a2$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/** If the event is an replay event */ function $ca970ce8cf2750a2$var$isReplayEvent(event) {
    return event.type === 'replay_event';
}
/** If the event is a feedback event */ function $ca970ce8cf2750a2$var$isFeedbackEvent(event) {
    return event.type === 'feedback';
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $ca970ce8cf2750a2$var$handleAfterSendEvent(replay) {
    return (event, sendResponse)=>{
        if (!replay.isEnabled() || !$ca970ce8cf2750a2$var$isErrorEvent(event) && !$ca970ce8cf2750a2$var$isTransactionEvent(event)) return;
        const statusCode = sendResponse && sendResponse.statusCode;
        // We only want to do stuff on successful error sending, otherwise you get error replays without errors attached
        // If not using the base transport, we allow `undefined` response (as a custom transport may not implement this correctly yet)
        // If we do use the base transport, we skip if we encountered an non-OK status code
        if (!statusCode || statusCode < 200 || statusCode >= 300) return;
        if ($ca970ce8cf2750a2$var$isTransactionEvent(event)) {
            $ca970ce8cf2750a2$var$handleTransactionEvent(replay, event);
            return;
        }
        $ca970ce8cf2750a2$var$handleErrorEvent(replay, event);
    };
}
function $ca970ce8cf2750a2$var$handleTransactionEvent(replay, event) {
    const replayContext = replay.getContext();
    // Collect traceIds in _context regardless of `recordingMode`
    // In error mode, _context gets cleared on every checkout
    // We limit to max. 100 transactions linked
    if (event.contexts && event.contexts.trace && event.contexts.trace.trace_id && replayContext.traceIds.size < 100) replayContext.traceIds.add(event.contexts.trace.trace_id);
}
function $ca970ce8cf2750a2$var$handleErrorEvent(replay, event) {
    const replayContext = replay.getContext();
    // Add error to list of errorIds of replay. This is ok to do even if not
    // sampled because context will get reset at next checkout.
    // XXX: There is also a race condition where it's possible to capture an
    // error to Sentry before Replay SDK has loaded, but response returns after
    // it was loaded, and this gets called.
    // We limit to max. 100 errors linked
    if (event.event_id && replayContext.errorIds.size < 100) replayContext.errorIds.add(event.event_id);
    // If error event is tagged with replay id it means it was sampled (when in buffer mode)
    // Need to be very careful that this does not cause an infinite loop
    if (replay.recordingMode !== 'buffer' || !event.tags || !event.tags.replayId) return;
    const { beforeErrorSampling: beforeErrorSampling } = replay.getOptions();
    if (typeof beforeErrorSampling === 'function' && !beforeErrorSampling(event)) return;
    (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(()=>{
        // Capture current event buffer as new replay
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.sendBufferedReplayOrFlush();
    });
}
/**
 * Returns a listener to be added to `client.on('afterSendErrorEvent, listener)`.
 */ function $ca970ce8cf2750a2$var$handleBeforeSendEvent(replay) {
    return (event)=>{
        if (!replay.isEnabled() || !$ca970ce8cf2750a2$var$isErrorEvent(event)) return;
        $ca970ce8cf2750a2$var$handleHydrationError(replay, event);
    };
}
function $ca970ce8cf2750a2$var$handleHydrationError(replay, event) {
    const exceptionValue = event.exception && event.exception.values && event.exception.values[0].value;
    if (typeof exceptionValue !== 'string') return;
    if (// Only matches errors in production builds of react-dom
    // Example https://reactjs.org/docs/error-decoder.html?invariant=423
    exceptionValue.match(/reactjs\.org\/docs\/error-decoder\.html\?invariant=(418|419|422|423|425)/) || // Development builds of react-dom
    // Error 1: Hydration failed because the initial UI does not match what was rendered on the server.
    // Error 2: Text content does not match server-rendered HTML. Warning: Text content did not match.
    exceptionValue.match(/(does not match server-rendered HTML|Hydration failed because)/i)) {
        const breadcrumb = $ca970ce8cf2750a2$var$createBreadcrumb({
            category: 'replay.hydrate-error'
        });
        $ca970ce8cf2750a2$var$addBreadcrumbEvent(replay, breadcrumb);
    }
}
/**
 * Handle breadcrumbs that Sentry captures, and make sure to capture relevant breadcrumbs to Replay as well.
 */ function $ca970ce8cf2750a2$var$handleBreadcrumbs(replay) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    if (!client) return;
    client.on('beforeAddBreadcrumb', (breadcrumb)=>$ca970ce8cf2750a2$var$beforeAddBreadcrumb(replay, breadcrumb));
}
function $ca970ce8cf2750a2$var$beforeAddBreadcrumb(replay, breadcrumb) {
    if (!replay.isEnabled() || !$ca970ce8cf2750a2$var$isBreadcrumbWithCategory(breadcrumb)) return;
    const result = $ca970ce8cf2750a2$var$normalizeBreadcrumb(breadcrumb);
    if (result) $ca970ce8cf2750a2$var$addBreadcrumbEvent(replay, result);
}
/** Exported only for tests. */ function $ca970ce8cf2750a2$var$normalizeBreadcrumb(breadcrumb) {
    if (!$ca970ce8cf2750a2$var$isBreadcrumbWithCategory(breadcrumb) || [
        // fetch & xhr are handled separately,in handleNetworkBreadcrumbs
        'fetch',
        'xhr',
        // These two are breadcrumbs for emitted sentry events, we don't care about them
        'sentry.event',
        'sentry.transaction'
    ].includes(breadcrumb.category) || // We capture UI breadcrumbs separately
    breadcrumb.category.startsWith('ui.')) return null;
    if (breadcrumb.category === 'console') return $ca970ce8cf2750a2$var$normalizeConsoleBreadcrumb(breadcrumb);
    return $ca970ce8cf2750a2$var$createBreadcrumb(breadcrumb);
}
/** exported for tests only */ function $ca970ce8cf2750a2$var$normalizeConsoleBreadcrumb(breadcrumb) {
    const args = breadcrumb.data && breadcrumb.data.arguments;
    if (!Array.isArray(args) || args.length === 0) return $ca970ce8cf2750a2$var$createBreadcrumb(breadcrumb);
    let isTruncated = false;
    // Avoid giant args captures
    const normalizedArgs = args.map((arg)=>{
        if (!arg) return arg;
        if (typeof arg === 'string') {
            if (arg.length > $ca970ce8cf2750a2$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                return `${arg.slice(0, $ca970ce8cf2750a2$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return arg;
        }
        if (typeof arg === 'object') try {
            const normalizedArg = (0, $8bc2e4fa750aec36$export$a3295358bff77e)(arg, 7);
            const stringified = JSON.stringify(normalizedArg);
            if (stringified.length > $ca970ce8cf2750a2$var$CONSOLE_ARG_MAX_SIZE) {
                isTruncated = true;
                // We use the pretty printed JSON string here as a base
                return `${JSON.stringify(normalizedArg, null, 2).slice(0, $ca970ce8cf2750a2$var$CONSOLE_ARG_MAX_SIZE)}\u{2026}`;
            }
            return normalizedArg;
        } catch (e) {
        // fall back to default
        }
        return arg;
    });
    return $ca970ce8cf2750a2$var$createBreadcrumb({
        ...breadcrumb,
        data: {
            ...breadcrumb.data,
            arguments: normalizedArgs,
            ...isTruncated ? {
                _meta: {
                    warnings: [
                        'CONSOLE_ARG_TRUNCATED'
                    ]
                }
            } : {}
        }
    });
}
function $ca970ce8cf2750a2$var$isBreadcrumbWithCategory(breadcrumb) {
    return !!breadcrumb.category;
}
/**
 * Returns true if we think the given event is an error originating inside of rrweb.
 */ function $ca970ce8cf2750a2$var$isRrwebError(event, hint) {
    if (event.type || !event.exception || !event.exception.values || !event.exception.values.length) return false;
    // @ts-expect-error this may be set by rrweb when it finds errors
    if (hint.originalException && hint.originalException.__rrweb__) return true;
    return false;
}
/**
 * Add a feedback breadcrumb event to replay.
 */ function $ca970ce8cf2750a2$var$addFeedbackBreadcrumb(replay, event) {
    replay.triggerUserActivity();
    replay.addUpdate(()=>{
        if (!event.timestamp) // Ignore events that don't have timestamps (this shouldn't happen, more of a typing issue)
        // Return true here so that we don't flush
        return true;
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        replay.throttledAddEvent({
            type: $ca970ce8cf2750a2$var$EventType.Custom,
            timestamp: event.timestamp * 1000,
            data: {
                tag: 'breadcrumb',
                payload: {
                    timestamp: event.timestamp,
                    type: 'default',
                    category: 'sentry.feedback',
                    data: {
                        feedbackId: event.event_id
                    }
                }
            }
        });
        return false;
    });
}
/**
 * Determine if event should be sampled (only applies in buffer mode).
 * When an event is captured by `hanldleGlobalEvent`, when in buffer mode
 * we determine if we want to sample the error or not.
 */ function $ca970ce8cf2750a2$var$shouldSampleForBufferEvent(replay, event) {
    if (replay.recordingMode !== 'buffer') return false;
    // ignore this error because otherwise we could loop indefinitely with
    // trying to capture replay and failing
    if (event.message === $ca970ce8cf2750a2$var$UNABLE_TO_SEND_REPLAY) return false;
    // Require the event to be an error event & to have an exception
    if (!event.exception || event.type) return false;
    return $ca970ce8cf2750a2$var$isSampled(replay.getOptions().errorSampleRate);
}
/**
 * Returns a listener to be added to `addEventProcessor(listener)`.
 */ function $ca970ce8cf2750a2$var$handleGlobalEventListener(replay) {
    return Object.assign((event, hint)=>{
        // Do nothing if replay has been disabled
        if (!replay.isEnabled()) return event;
        if ($ca970ce8cf2750a2$var$isReplayEvent(event)) {
            // Replays have separate set of breadcrumbs, do not include breadcrumbs
            // from core SDK
            delete event.breadcrumbs;
            return event;
        }
        // We only want to handle errors, transactions, and feedbacks, nothing else
        if (!$ca970ce8cf2750a2$var$isErrorEvent(event) && !$ca970ce8cf2750a2$var$isTransactionEvent(event) && !$ca970ce8cf2750a2$var$isFeedbackEvent(event)) return event;
        // Ensure we do not add replay_id if the session is expired
        const isSessionActive = replay.checkAndHandleExpiredSession();
        if (!isSessionActive) return event;
        if ($ca970ce8cf2750a2$var$isFeedbackEvent(event)) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            event.contexts.feedback.replay_id = replay.getSessionId();
            // Add a replay breadcrumb for this piece of feedback
            $ca970ce8cf2750a2$var$addFeedbackBreadcrumb(replay, event);
            return event;
        }
        // Unless `captureExceptions` is enabled, we want to ignore errors coming from rrweb
        // As there can be a bunch of stuff going wrong in internals there, that we don't want to bubble up to users
        if ($ca970ce8cf2750a2$var$isRrwebError(event, hint) && !replay.getOptions()._experiments.captureExceptions) {
            $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).log('[Replay] Ignoring error from rrweb internals', event);
            return null;
        }
        // When in buffer mode, we decide to sample here.
        // Later, in `handleAfterSendEvent`, if the replayId is set, we know that we sampled
        // And convert the buffer session to a full session
        const isErrorEventSampled = $ca970ce8cf2750a2$var$shouldSampleForBufferEvent(replay, event);
        // Tag errors if it has been sampled in buffer mode, or if it is session mode
        // Only tag transactions if in session mode
        const shouldTagReplayId = isErrorEventSampled || replay.recordingMode === 'session';
        if (shouldTagReplayId) event.tags = {
            ...event.tags,
            replayId: replay.getSessionId()
        };
        return event;
    }, {
        id: 'Replay'
    });
}
/**
 * Create a "span" for each performance entry.
 */ function $ca970ce8cf2750a2$var$createPerformanceSpans(replay, entries) {
    return entries.map(({ type: type, start: start, end: end, name: name, data: data })=>{
        const response = replay.throttledAddEvent({
            type: $ca970ce8cf2750a2$var$EventType.Custom,
            timestamp: start,
            data: {
                tag: 'performanceSpan',
                payload: {
                    op: type,
                    description: name,
                    startTimestamp: start,
                    endTimestamp: end,
                    data: data
                }
            }
        });
        // If response is a string, it means its either THROTTLED or SKIPPED
        return typeof response === 'string' ? Promise.resolve(null) : response;
    });
}
function $ca970ce8cf2750a2$var$handleHistory(handlerData) {
    const { from: from, to: to } = handlerData;
    const now = Date.now() / 1000;
    return {
        type: 'navigation.push',
        start: now,
        end: now,
        name: to,
        data: {
            previous: from
        }
    };
}
/**
 * Returns a listener to be added to `addHistoryInstrumentationHandler(listener)`.
 */ function $ca970ce8cf2750a2$var$handleHistorySpanListener(replay) {
    return (handlerData)=>{
        if (!replay.isEnabled()) return;
        const result = $ca970ce8cf2750a2$var$handleHistory(handlerData);
        if (result === null) return;
        // Need to collect visited URLs
        replay.getContext().urls.push(result.name);
        replay.triggerUserActivity();
        replay.addUpdate(()=>{
            $ca970ce8cf2750a2$var$createPerformanceSpans(replay, [
                result
            ]);
            // Returning false to flush
            return false;
        });
    };
}
/**
 * Check whether a given request URL should be filtered out. This is so we
 * don't log Sentry ingest requests.
 */ function $ca970ce8cf2750a2$var$shouldFilterRequest(replay, url) {
    // If we enabled the `traceInternals` experiment, we want to trace everything
    if ($ca970ce8cf2750a2$var$DEBUG_BUILD && replay.getOptions()._experiments.traceInternals) return false;
    return (0, $efa14c387d4ff555$export$d92e61f5600202af)(url, (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)());
}
/** Add a performance entry breadcrumb */ function $ca970ce8cf2750a2$var$addNetworkBreadcrumb(replay, result) {
    if (!replay.isEnabled()) return;
    if (result === null) return;
    if ($ca970ce8cf2750a2$var$shouldFilterRequest(replay, result.name)) return;
    replay.addUpdate(()=>{
        $ca970ce8cf2750a2$var$createPerformanceSpans(replay, [
            result
        ]);
        // Returning true will cause `addUpdate` to not flush
        // We do not want network requests to cause a flush. This will prevent
        // recurring/polling requests from keeping the replay session alive.
        return true;
    });
}
/** Get the size of a body. */ function $ca970ce8cf2750a2$var$getBodySize(body) {
    if (!body) return undefined;
    const textEncoder = new TextEncoder();
    try {
        if (typeof body === 'string') return textEncoder.encode(body).length;
        if (body instanceof URLSearchParams) return textEncoder.encode(body.toString()).length;
        if (body instanceof FormData) {
            const formDataStr = $ca970ce8cf2750a2$var$_serializeFormData(body);
            return textEncoder.encode(formDataStr).length;
        }
        if (body instanceof Blob) return body.size;
        if (body instanceof ArrayBuffer) return body.byteLength;
    // Currently unhandled types: ArrayBufferView, ReadableStream
    } catch (e) {
    // just return undefined
    }
    return undefined;
}
/** Convert a Content-Length header to number/undefined.  */ function $ca970ce8cf2750a2$var$parseContentLengthHeader(header) {
    if (!header) return undefined;
    const size = parseInt(header, 10);
    return isNaN(size) ? undefined : size;
}
/** Get the string representation of a body. */ function $ca970ce8cf2750a2$var$getBodyString(body) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof URLSearchParams) return [
            body.toString()
        ];
        if (body instanceof FormData) return [
            $ca970ce8cf2750a2$var$_serializeFormData(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
/** Merge a warning into an existing network request/response. */ function $ca970ce8cf2750a2$var$mergeWarning(info, warning) {
    if (!info) return {
        headers: {},
        size: undefined,
        _meta: {
            warnings: [
                warning
            ]
        }
    };
    const newMeta = {
        ...info._meta
    };
    const existingWarnings = newMeta.warnings || [];
    newMeta.warnings = [
        ...existingWarnings,
        warning
    ];
    info._meta = newMeta;
    return info;
}
/** Convert ReplayNetworkRequestData to a PerformanceEntry. */ function $ca970ce8cf2750a2$var$makeNetworkReplayBreadcrumb(type, data) {
    if (!data) return null;
    const { startTimestamp: startTimestamp, endTimestamp: endTimestamp, url: url, method: method, statusCode: statusCode, request: request, response: response } = data;
    const result = {
        type: type,
        start: startTimestamp / 1000,
        end: endTimestamp / 1000,
        name: url,
        data: (0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)({
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        })
    };
    return result;
}
/** Build the request or response part of a replay network breadcrumb that was skipped. */ function $ca970ce8cf2750a2$var$buildSkippedNetworkRequestOrResponse(bodySize) {
    return {
        headers: {},
        size: bodySize,
        _meta: {
            warnings: [
                'URL_SKIPPED'
            ]
        }
    };
}
/** Build the request or response part of a replay network breadcrumb. */ function $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, bodySize, body) {
    if (!bodySize && Object.keys(headers).length === 0) return undefined;
    if (!bodySize) return {
        headers: headers
    };
    if (!body) return {
        headers: headers,
        size: bodySize
    };
    const info = {
        headers: headers,
        size: bodySize
    };
    const { body: normalizedBody, warnings: warnings } = $ca970ce8cf2750a2$var$normalizeNetworkBody(body);
    info.body = normalizedBody;
    if (warnings && warnings.length > 0) info._meta = {
        warnings: warnings
    };
    return info;
}
/** Filter a set of headers */ function $ca970ce8cf2750a2$var$getAllowedHeaders(headers, allowedHeaders) {
    return Object.keys(headers).reduce((filteredHeaders, key)=>{
        const normalizedKey = key.toLowerCase();
        // Avoid putting empty strings into the headers
        if (allowedHeaders.includes(normalizedKey) && headers[key]) filteredHeaders[normalizedKey] = headers[key];
        return filteredHeaders;
    }, {});
}
function $ca970ce8cf2750a2$var$_serializeFormData(formData) {
    // This is a bit simplified, but gives us a decent estimate
    // This converts e.g. { name: 'Anne Smith', age: 13 } to 'name=Anne+Smith&age=13'
    // @ts-expect-error passing FormData to URLSearchParams actually works
    return new URLSearchParams(formData).toString();
}
function $ca970ce8cf2750a2$var$normalizeNetworkBody(body) {
    if (!body || typeof body !== 'string') return {
        body: body
    };
    const exceedsSizeLimit = body.length > $ca970ce8cf2750a2$var$NETWORK_BODY_MAX_SIZE;
    const isProbablyJson = $ca970ce8cf2750a2$var$_strIsProbablyJson(body);
    if (exceedsSizeLimit) {
        const truncatedBody = body.slice(0, $ca970ce8cf2750a2$var$NETWORK_BODY_MAX_SIZE);
        if (isProbablyJson) return {
            body: truncatedBody,
            warnings: [
                'MAYBE_JSON_TRUNCATED'
            ]
        };
        return {
            body: `${truncatedBody}\u{2026}`,
            warnings: [
                'TEXT_TRUNCATED'
            ]
        };
    }
    if (isProbablyJson) try {
        const jsonBody = JSON.parse(body);
        return {
            body: jsonBody
        };
    } catch (e3) {
    // fall back to just send the body as string
    }
    return {
        body: body
    };
}
function $ca970ce8cf2750a2$var$_strIsProbablyJson(str) {
    const first = str[0];
    const last = str[str.length - 1];
    // Simple check: If this does not start & end with {} or [], it's not JSON
    return first === '[' && last === ']' || first === '{' && last === '}';
}
/** Match an URL against a list of strings/Regex. */ function $ca970ce8cf2750a2$var$urlMatches(url, urls) {
    const fullUrl = $ca970ce8cf2750a2$var$getFullUrl(url);
    return (0, $6c98f0cd61ae7fe0$export$a7a5ec66062ea5d)(fullUrl, urls);
}
/** exported for tests */ function $ca970ce8cf2750a2$var$getFullUrl(url, baseURI = $ca970ce8cf2750a2$var$WINDOW.document.baseURI) {
    // Short circuit for common cases:
    if (url.startsWith('http://') || url.startsWith('https://') || url.startsWith($ca970ce8cf2750a2$var$WINDOW.location.origin)) return url;
    const fixedUrl = new URL(url, baseURI);
    // If these do not match, we are not dealing with a relative URL, so just return it
    if (fixedUrl.origin !== new URL(baseURI).origin) return url;
    const fullUrl = fixedUrl.href;
    // Remove trailing slashes, if they don't match the original URL
    if (!url.endsWith('/') && fullUrl.endsWith('/')) return fullUrl.slice(0, -1);
    return fullUrl;
}
/**
 * Capture a fetch breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $ca970ce8cf2750a2$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = await $ca970ce8cf2750a2$var$_prepareFetchData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $ca970ce8cf2750a2$var$makeNetworkReplayBreadcrumb('resource.fetch', data);
        $ca970ce8cf2750a2$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay] Failed to capture fetch breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $ca970ce8cf2750a2$var$enrichFetchBreadcrumb(breadcrumb, hint) {
    const { input: input, response: response } = hint;
    const body = input ? $ca970ce8cf2750a2$var$_getFetchRequestArgBody(input) : undefined;
    const reqSize = $ca970ce8cf2750a2$var$getBodySize(body);
    const resSize = response ? $ca970ce8cf2750a2$var$parseContentLengthHeader(response.headers.get('content-length')) : undefined;
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
async function $ca970ce8cf2750a2$var$_prepareFetchData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    const captureDetails = $ca970ce8cf2750a2$var$urlMatches(url, options.networkDetailAllowUrls) && !$ca970ce8cf2750a2$var$urlMatches(url, options.networkDetailDenyUrls);
    const request = captureDetails ? $ca970ce8cf2750a2$var$_getRequestInfo(options, hint.input, requestBodySize) : $ca970ce8cf2750a2$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
    const response = await $ca970ce8cf2750a2$var$_getResponseInfo(captureDetails, options, hint.response, responseBodySize);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: request,
        response: response
    };
}
function $ca970ce8cf2750a2$var$_getRequestInfo({ networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders }, input, requestBodySize) {
    const headers = input ? $ca970ce8cf2750a2$var$getRequestHeaders(input, networkRequestHeaders) : {};
    if (!networkCaptureBodies) return $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, requestBodySize, undefined);
    // We only want to transmit string or string-like bodies
    const requestBody = $ca970ce8cf2750a2$var$_getFetchRequestArgBody(input);
    const [bodyStr, warning] = $ca970ce8cf2750a2$var$getBodyString(requestBody);
    const data = $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, requestBodySize, bodyStr);
    if (warning) return $ca970ce8cf2750a2$var$mergeWarning(data, warning);
    return data;
}
/** Exported only for tests. */ async function $ca970ce8cf2750a2$var$_getResponseInfo(captureDetails, { networkCaptureBodies: networkCaptureBodies, networkResponseHeaders: networkResponseHeaders }, response, responseBodySize) {
    if (!captureDetails && responseBodySize !== undefined) return $ca970ce8cf2750a2$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
    const headers = response ? $ca970ce8cf2750a2$var$getAllHeaders(response.headers, networkResponseHeaders) : {};
    if (!response || !networkCaptureBodies && responseBodySize !== undefined) return $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    const [bodyText, warning] = await $ca970ce8cf2750a2$var$_parseFetchResponseBody(response);
    const result = $ca970ce8cf2750a2$var$getResponseData(bodyText, {
        networkCaptureBodies: networkCaptureBodies,
        responseBodySize: responseBodySize,
        captureDetails: captureDetails,
        headers: headers
    });
    if (warning) return $ca970ce8cf2750a2$var$mergeWarning(result, warning);
    return result;
}
function $ca970ce8cf2750a2$var$getResponseData(bodyText, { networkCaptureBodies: networkCaptureBodies, responseBodySize: responseBodySize, captureDetails: captureDetails, headers: headers }) {
    try {
        const size = bodyText && bodyText.length && responseBodySize === undefined ? $ca970ce8cf2750a2$var$getBodySize(bodyText) : responseBodySize;
        if (!captureDetails) return $ca970ce8cf2750a2$var$buildSkippedNetworkRequestOrResponse(size);
        if (networkCaptureBodies) return $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, size, bodyText);
        return $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, size, undefined);
    } catch (error) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to serialize response body', error);
        // fallback
        return $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(headers, responseBodySize, undefined);
    }
}
async function $ca970ce8cf2750a2$var$_parseFetchResponseBody(response) {
    const res = $ca970ce8cf2750a2$var$_tryCloneResponse(response);
    if (!res) return [
        undefined,
        'BODY_PARSE_ERROR'
    ];
    try {
        const text = await $ca970ce8cf2750a2$var$_tryGetResponseText(res);
        return [
            text
        ];
    } catch (error) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to get text body from response', error);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
}
function $ca970ce8cf2750a2$var$_getFetchRequestArgBody(fetchArgs = []) {
    // We only support getting the body from the fetch options
    if (fetchArgs.length !== 2 || typeof fetchArgs[1] !== 'object') return undefined;
    return fetchArgs[1].body;
}
function $ca970ce8cf2750a2$var$getAllHeaders(headers, allowedHeaders) {
    const allHeaders = {};
    allowedHeaders.forEach((header)=>{
        if (headers.get(header)) allHeaders[header] = headers.get(header);
    });
    return allHeaders;
}
function $ca970ce8cf2750a2$var$getRequestHeaders(fetchArgs, allowedHeaders) {
    if (fetchArgs.length === 1 && typeof fetchArgs[0] !== 'string') return $ca970ce8cf2750a2$var$getHeadersFromOptions(fetchArgs[0], allowedHeaders);
    if (fetchArgs.length === 2) return $ca970ce8cf2750a2$var$getHeadersFromOptions(fetchArgs[1], allowedHeaders);
    return {};
}
function $ca970ce8cf2750a2$var$getHeadersFromOptions(input, allowedHeaders) {
    if (!input) return {};
    const headers = input.headers;
    if (!headers) return {};
    if (headers instanceof Headers) return $ca970ce8cf2750a2$var$getAllHeaders(headers, allowedHeaders);
    // We do not support this, as it is not really documented (anymore?)
    if (Array.isArray(headers)) return {};
    return $ca970ce8cf2750a2$var$getAllowedHeaders(headers, allowedHeaders);
}
function $ca970ce8cf2750a2$var$_tryCloneResponse(response) {
    try {
        // We have to clone this, as the body can only be read once
        return response.clone();
    } catch (error) {
        // this can throw if the response was already consumed before
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to clone response body', error);
    }
}
/**
 * Get the response body of a fetch request, or timeout after 500ms.
 * Fetch can return a streaming body, that may not resolve (or not for a long time).
 * If that happens, we rather abort after a short time than keep waiting for this.
 */ function $ca970ce8cf2750a2$var$_tryGetResponseText(response) {
    return new Promise((resolve, reject)=>{
        const timeout = (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(()=>reject(new Error('Timeout while trying to read response body')), 500);
        $ca970ce8cf2750a2$var$_getResponseText(response).then((txt)=>resolve(txt), (reason)=>reject(reason)).finally(()=>clearTimeout(timeout));
    });
}
async function $ca970ce8cf2750a2$var$_getResponseText(response) {
    // Force this to be a promise, just to be safe
    // eslint-disable-next-line no-return-await
    return await response.text();
}
/**
 * Capture an XHR breadcrumb to a replay.
 * This adds additional data (where approriate).
 */ async function $ca970ce8cf2750a2$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options) {
    try {
        const data = $ca970ce8cf2750a2$var$_prepareXhrData(breadcrumb, hint, options);
        // Create a replay performance entry from this breadcrumb
        const result = $ca970ce8cf2750a2$var$makeNetworkReplayBreadcrumb('resource.xhr', data);
        $ca970ce8cf2750a2$var$addNetworkBreadcrumb(options.replay, result);
    } catch (error) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay] Failed to capture xhr breadcrumb', error);
    }
}
/**
 * Enrich a breadcrumb with additional data.
 * This has to be sync & mutate the given breadcrumb,
 * as the breadcrumb is afterwards consumed by other handlers.
 */ function $ca970ce8cf2750a2$var$enrichXhrBreadcrumb(breadcrumb, hint) {
    const { xhr: xhr, input: input } = hint;
    if (!xhr) return;
    const reqSize = $ca970ce8cf2750a2$var$getBodySize(input);
    const resSize = xhr.getResponseHeader('content-length') ? $ca970ce8cf2750a2$var$parseContentLengthHeader(xhr.getResponseHeader('content-length')) : $ca970ce8cf2750a2$var$_getBodySize(xhr.response, xhr.responseType);
    if (reqSize !== undefined) breadcrumb.data.request_body_size = reqSize;
    if (resSize !== undefined) breadcrumb.data.response_body_size = resSize;
}
function $ca970ce8cf2750a2$var$_prepareXhrData(breadcrumb, hint, options) {
    const now = Date.now();
    const { startTimestamp: startTimestamp = now, endTimestamp: endTimestamp = now, input: input, xhr: xhr } = hint;
    const { url: url, method: method, status_code: statusCode = 0, request_body_size: requestBodySize, response_body_size: responseBodySize } = breadcrumb.data;
    if (!url) return null;
    if (!xhr || !$ca970ce8cf2750a2$var$urlMatches(url, options.networkDetailAllowUrls) || $ca970ce8cf2750a2$var$urlMatches(url, options.networkDetailDenyUrls)) {
        const request = $ca970ce8cf2750a2$var$buildSkippedNetworkRequestOrResponse(requestBodySize);
        const response = $ca970ce8cf2750a2$var$buildSkippedNetworkRequestOrResponse(responseBodySize);
        return {
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp,
            url: url,
            method: method,
            statusCode: statusCode,
            request: request,
            response: response
        };
    }
    const xhrInfo = xhr[0, $13a4c7cbade0edcd$export$55b6bb1e45c6cf59];
    const networkRequestHeaders = xhrInfo ? $ca970ce8cf2750a2$var$getAllowedHeaders(xhrInfo.request_headers, options.networkRequestHeaders) : {};
    const networkResponseHeaders = $ca970ce8cf2750a2$var$getAllowedHeaders($ca970ce8cf2750a2$var$getResponseHeaders(xhr), options.networkResponseHeaders);
    const [requestBody, requestWarning] = options.networkCaptureBodies ? $ca970ce8cf2750a2$var$getBodyString(input) : [
        undefined
    ];
    const [responseBody, responseWarning] = options.networkCaptureBodies ? $ca970ce8cf2750a2$var$_getXhrResponseBody(xhr) : [
        undefined
    ];
    const request = $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(networkRequestHeaders, requestBodySize, requestBody);
    const response = $ca970ce8cf2750a2$var$buildNetworkRequestOrResponse(networkResponseHeaders, responseBodySize, responseBody);
    return {
        startTimestamp: startTimestamp,
        endTimestamp: endTimestamp,
        url: url,
        method: method,
        statusCode: statusCode,
        request: requestWarning ? $ca970ce8cf2750a2$var$mergeWarning(request, requestWarning) : request,
        response: responseWarning ? $ca970ce8cf2750a2$var$mergeWarning(response, responseWarning) : response
    };
}
function $ca970ce8cf2750a2$var$getResponseHeaders(xhr) {
    const headers = xhr.getAllResponseHeaders();
    if (!headers) return {};
    return headers.split('\r\n').reduce((acc, line)=>{
        const [key, value] = line.split(': ');
        acc[key.toLowerCase()] = value;
        return acc;
    }, {});
}
function $ca970ce8cf2750a2$var$_getXhrResponseBody(xhr) {
    // We collect errors that happen, but only log them if we can't get any response body
    const errors = [];
    try {
        return [
            xhr.responseText
        ];
    } catch (e) {
        errors.push(e);
    }
    // Try to manually parse the response body, if responseText fails
    try {
        return $ca970ce8cf2750a2$var$_parseXhrResponse(xhr.response, xhr.responseType);
    } catch (e) {
        errors.push(e);
    }
    $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to get xhr response body', ...errors);
    return [
        undefined
    ];
}
/**
 * Get the string representation of the XHR response.
 * Based on MDN, these are the possible types of the response:
 * string
 * ArrayBuffer
 * Blob
 * Document
 * POJO
 *
 * Exported only for tests.
 */ function $ca970ce8cf2750a2$var$_parseXhrResponse(body, responseType) {
    try {
        if (typeof body === 'string') return [
            body
        ];
        if (body instanceof Document) return [
            body.body.outerHTML
        ];
        if (responseType === 'json' && body && typeof body === 'object') return [
            JSON.stringify(body)
        ];
        if (!body) return [
            undefined
        ];
    } catch (e2) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Failed to serialize body', body);
        return [
            undefined,
            'BODY_PARSE_ERROR'
        ];
    }
    $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).info('[Replay] Skipping network body because of body type', body);
    return [
        undefined,
        'UNPARSEABLE_BODY_TYPE'
    ];
}
function $ca970ce8cf2750a2$var$_getBodySize(body, responseType) {
    try {
        const bodyStr = responseType === 'json' && body && typeof body === 'object' ? JSON.stringify(body) : body;
        return $ca970ce8cf2750a2$var$getBodySize(bodyStr);
    } catch (e3) {
        return undefined;
    }
}
/**
 * This method does two things:
 * - It enriches the regular XHR/fetch breadcrumbs with request/response size data
 * - It captures the XHR/fetch breadcrumbs to the replay
 *   (enriching it with further data that is _not_ added to the regular breadcrumbs)
 */ function $ca970ce8cf2750a2$var$handleNetworkBreadcrumbs(replay) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    try {
        const { networkDetailAllowUrls: networkDetailAllowUrls, networkDetailDenyUrls: networkDetailDenyUrls, networkCaptureBodies: networkCaptureBodies, networkRequestHeaders: networkRequestHeaders, networkResponseHeaders: networkResponseHeaders } = replay.getOptions();
        const options = {
            replay: replay,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: networkRequestHeaders,
            networkResponseHeaders: networkResponseHeaders
        };
        if (client) client.on('beforeAddBreadcrumb', (breadcrumb, hint)=>$ca970ce8cf2750a2$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint));
    } catch (e2) {
    // Do nothing
    }
}
/** just exported for tests */ function $ca970ce8cf2750a2$var$beforeAddNetworkBreadcrumb(options, breadcrumb, hint) {
    if (!breadcrumb.data) return;
    try {
        if ($ca970ce8cf2750a2$var$_isXhrBreadcrumb(breadcrumb) && $ca970ce8cf2750a2$var$_isXhrHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $ca970ce8cf2750a2$var$enrichXhrBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $ca970ce8cf2750a2$var$captureXhrBreadcrumbToReplay(breadcrumb, hint, options);
        }
        if ($ca970ce8cf2750a2$var$_isFetchBreadcrumb(breadcrumb) && $ca970ce8cf2750a2$var$_isFetchHint(hint)) {
            // This has to be sync, as we need to ensure the breadcrumb is enriched in the same tick
            // Because the hook runs synchronously, and the breadcrumb is afterwards passed on
            // So any async mutations to it will not be reflected in the final breadcrumb
            $ca970ce8cf2750a2$var$enrichFetchBreadcrumb(breadcrumb, hint);
            // This call should not reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            $ca970ce8cf2750a2$var$captureFetchBreadcrumbToReplay(breadcrumb, hint, options);
        }
    } catch (e) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('Error when enriching network breadcrumb');
    }
}
function $ca970ce8cf2750a2$var$_isXhrBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'xhr';
}
function $ca970ce8cf2750a2$var$_isFetchBreadcrumb(breadcrumb) {
    return breadcrumb.category === 'fetch';
}
function $ca970ce8cf2750a2$var$_isXhrHint(hint) {
    return hint && hint.xhr;
}
function $ca970ce8cf2750a2$var$_isFetchHint(hint) {
    return hint && hint.response;
}
/**
 * Add global listeners that cannot be removed.
 */ function $ca970ce8cf2750a2$var$addGlobalListeners(replay) {
    // Listeners from core SDK //
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    (0, $dc558f47bd2b2099$export$5aeffd3db2cf9df7)($ca970ce8cf2750a2$var$handleDomListener(replay));
    (0, $81fb4056224c2de0$export$3f18c56c58114e75)($ca970ce8cf2750a2$var$handleHistorySpanListener(replay));
    $ca970ce8cf2750a2$var$handleBreadcrumbs(replay);
    $ca970ce8cf2750a2$var$handleNetworkBreadcrumbs(replay);
    // Tag all (non replay) events that get sent to Sentry with the current
    // replay ID so that we can reference them later in the UI
    const eventProcessor = $ca970ce8cf2750a2$var$handleGlobalEventListener(replay);
    (0, $6e2d7e6efd34a5e4$export$9aac0b9f77928fbf)(eventProcessor);
    // If a custom client has no hooks yet, we continue to use the "old" implementation
    if (client) {
        client.on('beforeSendEvent', $ca970ce8cf2750a2$var$handleBeforeSendEvent(replay));
        client.on('afterSendEvent', $ca970ce8cf2750a2$var$handleAfterSendEvent(replay));
        client.on('createDsc', (dsc)=>{
            const replayId = replay.getSessionId();
            // We do not want to set the DSC when in buffer mode, as that means the replay has not been sent (yet)
            if (replayId && replay.isEnabled() && replay.recordingMode === 'session') {
                // Ensure to check that the session is still active - it could have expired in the meanwhile
                const isSessionActive = replay.checkAndHandleExpiredSession();
                if (isSessionActive) dsc.replay_id = replayId;
            }
        });
        client.on('spanStart', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We may be missing the initial spanStart due to timing issues,
        // so we capture it on finish again.
        client.on('spanEnd', (span)=>{
            replay.lastActiveSpan = span;
        });
        // We want to flush replay
        client.on('beforeSendFeedback', (feedbackEvent, options)=>{
            const replayId = replay.getSessionId();
            if (options && options.includeReplay && replay.isEnabled() && replayId) // This should never reject
            {
                if (feedbackEvent.contexts && feedbackEvent.contexts.feedback) feedbackEvent.contexts.feedback.replay_id = replayId;
            }
        });
    }
}
/**
 * Create a "span" for the total amount of memory being used by JS objects
 * (including v8 internal objects).
 */ async function $ca970ce8cf2750a2$var$addMemoryEntry(replay) {
    // window.performance.memory is a non-standard API and doesn't work on all browsers, so we try-catch this
    try {
        return Promise.all($ca970ce8cf2750a2$var$createPerformanceSpans(replay, [
            // @ts-expect-error memory doesn't exist on type Performance as the API is non-standard (we check that it exists above)
            $ca970ce8cf2750a2$var$createMemoryEntry($ca970ce8cf2750a2$var$WINDOW.performance.memory)
        ]));
    } catch (error) {
        // Do nothing
        return [];
    }
}
function $ca970ce8cf2750a2$var$createMemoryEntry(memoryEntry) {
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = memoryEntry;
    // we don't want to use `getAbsoluteTime` because it adds the event time to the
    // time origin, so we get the current timestamp instead
    const time = Date.now() / 1000;
    return {
        type: 'memory',
        name: 'memory',
        start: time,
        end: time,
        data: {
            memory: {
                jsHeapSizeLimit: jsHeapSizeLimit,
                totalJSHeapSize: totalJSHeapSize,
                usedJSHeapSize: usedJSHeapSize
            }
        }
    };
}
/**
 * Heavily simplified debounce function based on lodash.debounce.
 *
 * This function takes a callback function (@param fun) and delays its invocation
 * by @param wait milliseconds. Optionally, a maxWait can be specified in @param options,
 * which ensures that the callback is invoked at least once after the specified max. wait time.
 *
 * @param func the function whose invocation is to be debounced
 * @param wait the minimum time until the function is invoked after it was called once
 * @param options the options object, which can contain the `maxWait` property
 *
 * @returns the debounced version of the function, which needs to be called at least once to start the
 *          debouncing process. Subsequent calls will reset the debouncing timer and, in case @paramfunc
 *          was already invoked in the meantime, return @param func's return value.
 *          The debounced function has two additional properties:
 *          - `flush`: Invokes the debounced function immediately and returns its return value
 *          - `cancel`: Cancels the debouncing process and resets the debouncing timer
 */ function $ca970ce8cf2750a2$var$debounce(func, wait, options) {
    let callbackReturnValue;
    let timerId;
    let maxTimerId;
    const maxWait = options && options.maxWait ? Math.max(options.maxWait, wait) : 0;
    function invokeFunc() {
        cancelTimers();
        callbackReturnValue = func();
        return callbackReturnValue;
    }
    function cancelTimers() {
        timerId !== undefined && clearTimeout(timerId);
        maxTimerId !== undefined && clearTimeout(maxTimerId);
        timerId = maxTimerId = undefined;
    }
    function flush() {
        if (timerId !== undefined || maxTimerId !== undefined) return invokeFunc();
        return callbackReturnValue;
    }
    function debounced() {
        if (timerId) clearTimeout(timerId);
        timerId = (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(invokeFunc, wait);
        if (maxWait && maxTimerId === undefined) maxTimerId = (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(invokeFunc, maxWait);
        return callbackReturnValue;
    }
    debounced.cancel = cancelTimers;
    debounced.flush = flush;
    return debounced;
}
/**
 * Handler for recording events.
 *
 * Adds to event buffer, and has varying flushing behaviors if the event was a checkout.
 */ function $ca970ce8cf2750a2$var$getHandleRecordingEmit(replay) {
    let hadFirstEvent = false;
    return (event, _isCheckout)=>{
        // If this is false, it means session is expired, create and a new session and wait for checkout
        if (!replay.checkAndHandleExpiredSession()) {
            $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).warn('[Replay] Received replay event after session expired.');
            return;
        }
        // `_isCheckout` is only set when the checkout is due to `checkoutEveryNms`
        // We also want to treat the first event as a checkout, so we handle this specifically here
        const isCheckout = _isCheckout || !hadFirstEvent;
        hadFirstEvent = true;
        if (replay.clickDetector) $ca970ce8cf2750a2$var$updateClickDetectorForRecordingEvent(replay.clickDetector, event);
        // The handler returns `true` if we do not want to trigger debounced flush, `false` if we want to debounce flush.
        replay.addUpdate(()=>{
            // The session is always started immediately on pageload/init, but for
            // error-only replays, it should reflect the most recent checkout
            // when an error occurs. Clear any state that happens before this current
            // checkout. This needs to happen before `addEvent()` which updates state
            // dependent on this reset.
            if (replay.recordingMode === 'buffer' && isCheckout) replay.setInitialState();
            // If the event is not added (e.g. due to being paused, disabled, or out of the max replay duration),
            // Skip all further steps
            if (!$ca970ce8cf2750a2$var$addEventSync(replay, event, isCheckout)) // Return true to skip scheduling a debounced flush
            return true;
            // Different behavior for full snapshots (type=2), ignore other event types
            // See https://github.com/rrweb-io/rrweb/blob/d8f9290ca496712aa1e7d472549480c4e7876594/packages/rrweb/src/types.ts#L16
            if (!isCheckout) return false;
            // Additionally, create a meta event that will capture certain SDK settings.
            // In order to handle buffer mode, this needs to either be done when we
            // receive checkout events or at flush time.
            //
            // `isCheckout` is always true, but want to be explicit that it should
            // only be added for checkouts
            $ca970ce8cf2750a2$var$addSettingsEvent(replay, isCheckout);
            // If there is a previousSessionId after a full snapshot occurs, then
            // the replay session was started due to session expiration. The new session
            // is started before triggering a new checkout and contains the id
            // of the previous session. Do not immediately flush in this case
            // to avoid capturing only the checkout and instead the replay will
            // be captured if they perform any follow-up actions.
            if (replay.session && replay.session.previousSessionId) return true;
            // When in buffer mode, make sure we adjust the session started date to the current earliest event of the buffer
            // this should usually be the timestamp of the checkout event, but to be safe...
            if (replay.recordingMode === 'buffer' && replay.session && replay.eventBuffer) {
                const earliestEvent = replay.eventBuffer.getEarliestTimestamp();
                if (earliestEvent) {
                    $ca970ce8cf2750a2$var$logInfo(`[Replay] Updating session start time to earliest event in buffer to ${new Date(earliestEvent)}`, replay.getOptions()._experiments.traceInternals);
                    replay.session.started = earliestEvent;
                    if (replay.getOptions().stickySession) $ca970ce8cf2750a2$var$saveSession(replay.session);
                }
            }
            if (replay.recordingMode === 'session') // If the full snapshot is due to an initial load, we will not have
            // a previous session ID. In this case, we want to buffer events
            // for a set amount of time before flushing. This can help avoid
            // capturing replays of users that immediately close the window.
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            replay.flush();
            return true;
        });
    };
}
/**
 * Exported for tests
 */ function $ca970ce8cf2750a2$var$createOptionsEvent(replay) {
    const options = replay.getOptions();
    return {
        type: $ca970ce8cf2750a2$var$EventType.Custom,
        timestamp: Date.now(),
        data: {
            tag: 'options',
            payload: {
                shouldRecordCanvas: replay.isRecordingCanvas(),
                sessionSampleRate: options.sessionSampleRate,
                errorSampleRate: options.errorSampleRate,
                useCompressionOption: options.useCompression,
                blockAllMedia: options.blockAllMedia,
                maskAllText: options.maskAllText,
                maskAllInputs: options.maskAllInputs,
                useCompression: replay.eventBuffer ? replay.eventBuffer.type === 'worker' : false,
                networkDetailHasUrls: options.networkDetailAllowUrls.length > 0,
                networkCaptureBodies: options.networkCaptureBodies,
                networkRequestHasHeaders: options.networkRequestHeaders.length > 0,
                networkResponseHasHeaders: options.networkResponseHeaders.length > 0
            }
        }
    };
}
/**
 * Add a "meta" event that contains a simplified view on current configuration
 * options. This should only be included on the first segment of a recording.
 */ function $ca970ce8cf2750a2$var$addSettingsEvent(replay, isCheckout) {
    // Only need to add this event when sending the first segment
    if (!isCheckout || !replay.session || replay.session.segmentId !== 0) return;
    $ca970ce8cf2750a2$var$addEventSync(replay, $ca970ce8cf2750a2$var$createOptionsEvent(replay), false);
}
/**
 * Create a replay envelope ready to be sent.
 * This includes both the replay event, as well as the recording data.
 */ function $ca970ce8cf2750a2$var$createReplayEnvelope(replayEvent, recordingData, dsn, tunnel) {
    return (0, $70b99f77072cf559$export$f93f7f385160c44e)((0, $70b99f77072cf559$export$92b6093782fe661b)(replayEvent, (0, $70b99f77072cf559$export$d369f3b2758f6743)(replayEvent), tunnel, dsn), [
        [
            {
                type: 'replay_event'
            },
            replayEvent
        ],
        [
            {
                type: 'replay_recording',
                // If string then we need to encode to UTF8, otherwise will have
                // wrong size. TextEncoder has similar browser support to
                // MutationObserver, although it does not accept IE11.
                length: typeof recordingData === 'string' ? new TextEncoder().encode(recordingData).length : recordingData.length
            },
            recordingData
        ]
    ]);
}
/**
 * Prepare the recording data ready to be sent.
 */ function $ca970ce8cf2750a2$var$prepareRecordingData({ recordingData: recordingData, headers: headers }) {
    let payloadWithSequence;
    // XXX: newline is needed to separate sequence id from events
    const replayHeaders = `${JSON.stringify(headers)}
`;
    if (typeof recordingData === 'string') payloadWithSequence = `${replayHeaders}${recordingData}`;
    else {
        const enc = new TextEncoder();
        // XXX: newline is needed to separate sequence id from events
        const sequence = enc.encode(replayHeaders);
        // Merge the two Uint8Arrays
        payloadWithSequence = new Uint8Array(sequence.length + recordingData.length);
        payloadWithSequence.set(sequence);
        payloadWithSequence.set(recordingData, sequence.length);
    }
    return payloadWithSequence;
}
/**
 * Prepare a replay event & enrich it with the SDK metadata.
 */ async function $ca970ce8cf2750a2$var$prepareReplayEvent({ client: client, scope: scope, replayId: event_id, event: event }) {
    const integrations = typeof client._integrations === 'object' && client._integrations !== null && !Array.isArray(client._integrations) ? Object.keys(client._integrations) : undefined;
    const eventHint = {
        event_id: event_id,
        integrations: integrations
    };
    client.emit('preprocessEvent', event, eventHint);
    const preparedEvent = await (0, $713290f45d0c41ce$export$2d67fb380bd11267)(client.getOptions(), event, eventHint, scope, client, (0, $971e6b058109b0a9$export$68f3af03034c9e90)());
    // If e.g. a global event processor returned null
    if (!preparedEvent) return null;
    // This normally happens in browser client "_prepareEvent"
    // but since we do not use this private method from the client, but rather the plain import
    // we need to do this manually.
    preparedEvent.platform = preparedEvent.platform || 'javascript';
    // extract the SDK name because `client._prepareEvent` doesn't add it to the event
    const metadata = client.getSdkMetadata();
    const { name: name, version: version } = metadata && metadata.sdk || {};
    preparedEvent.sdk = {
        ...preparedEvent.sdk,
        name: name || 'sentry.javascript.unknown',
        version: version || '0.0.0'
    };
    return preparedEvent;
}
/**
 * Send replay attachment using `fetch()`
 */ async function $ca970ce8cf2750a2$var$sendReplayRequest({ recordingData: recordingData, replayId: replayId, segmentId: segment_id, eventContext: eventContext, timestamp: timestamp, session: session }) {
    const preparedRecordingData = $ca970ce8cf2750a2$var$prepareRecordingData({
        recordingData: recordingData,
        headers: {
            segment_id: segment_id
        }
    });
    const { urls: urls, errorIds: errorIds, traceIds: traceIds, initialTimestamp: initialTimestamp } = eventContext;
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const scope = (0, $971e6b058109b0a9$export$c7be4b0125a10cba)();
    const transport = client && client.getTransport();
    const dsn = client && client.getDsn();
    if (!client || !transport || !dsn || !session.sampled) return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)({});
    const baseEvent = {
        type: $ca970ce8cf2750a2$var$REPLAY_EVENT_NAME,
        replay_start_timestamp: initialTimestamp / 1000,
        timestamp: timestamp / 1000,
        error_ids: errorIds,
        trace_ids: traceIds,
        urls: urls,
        replay_id: replayId,
        segment_id: segment_id,
        replay_type: session.sampled
    };
    const replayEvent = await $ca970ce8cf2750a2$var$prepareReplayEvent({
        scope: scope,
        client: client,
        replayId: replayId,
        event: baseEvent
    });
    if (!replayEvent) {
        // Taken from baseclient's `_processEvent` method, where this is handled for errors/transactions
        client.recordDroppedEvent('event_processor', 'replay', baseEvent);
        $ca970ce8cf2750a2$var$logInfo('An event processor returned `null`, will not send event.');
        return (0, $82b0c6d0fe80f282$export$1fda8aa4d135f8aa)({});
    }
    /*
  For reference, the fully built event looks something like this:
  {
      "type": "replay_event",
      "timestamp": 1670837008.634,
      "error_ids": [
          "errorId"
      ],
      "trace_ids": [
          "traceId"
      ],
      "urls": [
          "https://example.com"
      ],
      "replay_id": "eventId",
      "segment_id": 3,
      "replay_type": "error",
      "platform": "javascript",
      "event_id": "eventId",
      "environment": "production",
      "sdk": {
          "integrations": [
              "BrowserTracing",
              "Replay"
          ],
          "name": "sentry.javascript.browser",
          "version": "7.25.0"
      },
      "sdkProcessingMetadata": {},
      "contexts": {
      },
  }
  */ // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete replayEvent.sdkProcessingMetadata;
    const envelope = $ca970ce8cf2750a2$var$createReplayEnvelope(replayEvent, preparedRecordingData, dsn, client.getOptions().tunnel);
    let response;
    try {
        response = await transport.send(envelope);
    } catch (err) {
        const error = new Error($ca970ce8cf2750a2$var$UNABLE_TO_SEND_REPLAY);
        try {
            // In case browsers don't allow this property to be writable
            // @ts-expect-error This needs lib es2022 and newer
            error.cause = err;
        } catch (e) {
        // nothing to do
        }
        throw error;
    }
    // If the status code is invalid, we want to immediately stop & not retry
    if (typeof response.statusCode === 'number' && (response.statusCode < 200 || response.statusCode >= 300)) throw new $ca970ce8cf2750a2$var$TransportStatusCodeError(response.statusCode);
    const rateLimits = (0, $a8a4c0c2698a0fad$export$699aff705e0d49d4)({}, response);
    if ((0, $a8a4c0c2698a0fad$export$6c91fec22056810a)(rateLimits, 'replay')) throw new $ca970ce8cf2750a2$var$RateLimitError(rateLimits);
    return response;
}
/**
 * This error indicates that the transport returned an invalid status code.
 */ class $ca970ce8cf2750a2$var$TransportStatusCodeError extends Error {
    constructor(statusCode){
        super(`Transport returned status code ${statusCode}`);
    }
}
/**
 * This error indicates that we hit a rate limit API error.
 */ class $ca970ce8cf2750a2$var$RateLimitError extends Error {
    constructor(rateLimits){
        super('Rate limit hit');
        this.rateLimits = rateLimits;
    }
}
/**
 * Finalize and send the current replay event to Sentry
 */ async function $ca970ce8cf2750a2$var$sendReplay(replayData, retryConfig = {
    count: 0,
    interval: $ca970ce8cf2750a2$var$RETRY_BASE_INTERVAL
}) {
    const { recordingData: recordingData, options: options } = replayData;
    // short circuit if there's no events to upload (this shouldn't happen as _runFlush makes this check)
    if (!recordingData.length) return;
    try {
        await $ca970ce8cf2750a2$var$sendReplayRequest(replayData);
        return true;
    } catch (err) {
        if (err instanceof $ca970ce8cf2750a2$var$TransportStatusCodeError || err instanceof $ca970ce8cf2750a2$var$RateLimitError) throw err;
        // Capture error for every failed replay
        (0, $6e2d7e6efd34a5e4$export$2f04de43fe27971a)('Replays', {
            _retryCount: retryConfig.count
        });
        if ($ca970ce8cf2750a2$var$DEBUG_BUILD && options._experiments && options._experiments.captureExceptions) (0, $6e2d7e6efd34a5e4$export$f5282963edea4a68)(err);
        // If an error happened here, it's likely that uploading the attachment
        // failed, we'll can retry with the same events payload
        if (retryConfig.count >= $ca970ce8cf2750a2$var$RETRY_MAX_COUNT) {
            const error = new Error(`${$ca970ce8cf2750a2$var$UNABLE_TO_SEND_REPLAY} - max retries exceeded`);
            try {
                // In case browsers don't allow this property to be writable
                // @ts-expect-error This needs lib es2022 and newer
                error.cause = err;
            } catch (e) {
            // nothing to do
            }
            throw error;
        }
        // will retry in intervals of 5, 10, 30
        retryConfig.interval *= ++retryConfig.count;
        return new Promise((resolve, reject)=>{
            (0, $933990856d6cef5c$export$831dc9f2ab0a617b)(async ()=>{
                try {
                    await $ca970ce8cf2750a2$var$sendReplay(replayData, retryConfig);
                    resolve(true);
                } catch (err) {
                    reject(err);
                }
            }, retryConfig.interval);
        });
    }
}
const $ca970ce8cf2750a2$var$THROTTLED = '__THROTTLED';
const $ca970ce8cf2750a2$var$SKIPPED = '__SKIPPED';
/**
 * Create a throttled function off a given function.
 * When calling the throttled function, it will call the original function only
 * if it hasn't been called more than `maxCount` times in the last `durationSeconds`.
 *
 * Returns `THROTTLED` if throttled for the first time, after that `SKIPPED`,
 * or else the return value of the original function.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $ca970ce8cf2750a2$var$throttle(fn, maxCount, durationSeconds) {
    const counter = new Map();
    const _cleanup = (now)=>{
        const threshold = now - durationSeconds;
        counter.forEach((_value, key)=>{
            if (key < threshold) counter.delete(key);
        });
    };
    const _getTotalCount = ()=>{
        return [
            ...counter.values()
        ].reduce((a, b)=>a + b, 0);
    };
    let isThrottled = false;
    return (...rest)=>{
        // Date in second-precision, which we use as basis for the throttling
        const now = Math.floor(Date.now() / 1000);
        // First, make sure to delete any old entries
        _cleanup(now);
        // If already over limit, do nothing
        if (_getTotalCount() >= maxCount) {
            const wasThrottled = isThrottled;
            isThrottled = true;
            return wasThrottled ? $ca970ce8cf2750a2$var$SKIPPED : $ca970ce8cf2750a2$var$THROTTLED;
        }
        isThrottled = false;
        const count = counter.get(now) || 0;
        counter.set(now, count + 1);
        return fn(...rest);
    };
}
/* eslint-disable max-lines */ // TODO: We might want to split this file up
/**
 * The main replay container class, which holds all the state and methods for recording and sending replays.
 */ class $ca970ce8cf2750a2$var$ReplayContainer {
    /**
   * Recording can happen in one of three modes:
   *   - session: Record the whole session, sending it continuously
   *   - buffer: Always keep the last 60s of recording, requires:
   *     - having replaysOnErrorSampleRate > 0 to capture replay when an error occurs
   *     - or calling `flush()` to send the replay
   */ /**
   * The current or last active span.
   * This is only available when performance is enabled.
   */ /**
   * These are here so we can overwrite them in tests etc.
   * @hidden
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Timestamp of the last user activity. This lives across sessions.
   */ /**
   * Is the integration currently active?
   */ /**
   * Paused is a state where:
   * - DOM Recording is not listening at all
   * - Nothing will be added to event buffer (e.g. core SDK events)
   */ /**
   * Have we attached listeners to the core SDK?
   * Note we have to track this as there is no way to remove instrumentation handlers.
   */ /**
   * Function to stop recording
   */ /**
   * Internal use for canvas recording options
   */ constructor({ options: options, recordingOptions: recordingOptions }){
        $ca970ce8cf2750a2$var$ReplayContainer.prototype.__init.call(this);
        $ca970ce8cf2750a2$var$ReplayContainer.prototype.__init2.call(this);
        $ca970ce8cf2750a2$var$ReplayContainer.prototype.__init3.call(this);
        $ca970ce8cf2750a2$var$ReplayContainer.prototype.__init4.call(this);
        $ca970ce8cf2750a2$var$ReplayContainer.prototype.__init5.call(this);
        $ca970ce8cf2750a2$var$ReplayContainer.prototype.__init6.call(this);
        this.eventBuffer = null;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        this.recordingMode = 'session';
        this.timeouts = {
            sessionIdlePause: $ca970ce8cf2750a2$var$SESSION_IDLE_PAUSE_DURATION,
            sessionIdleExpire: $ca970ce8cf2750a2$var$SESSION_IDLE_EXPIRE_DURATION
        };
        this._lastActivity = Date.now();
        this._isEnabled = false;
        this._isPaused = false;
        this._hasInitializedCoreListeners = false;
        this._context = {
            errorIds: new Set(),
            traceIds: new Set(),
            urls: [],
            initialTimestamp: Date.now(),
            initialUrl: ''
        };
        this._recordingOptions = recordingOptions;
        this._options = options;
        this._debouncedFlush = $ca970ce8cf2750a2$var$debounce(()=>this._flush(), this._options.flushMinDelay, {
            maxWait: this._options.flushMaxDelay
        });
        this._throttledAddEvent = $ca970ce8cf2750a2$var$throttle((event, isCheckout)=>$ca970ce8cf2750a2$var$addEvent(this, event, isCheckout), // Max 300 events...
        300, // ... per 5s
        5);
        const { slowClickTimeout: slowClickTimeout, slowClickIgnoreSelectors: slowClickIgnoreSelectors } = this.getOptions();
        const slowClickConfig = slowClickTimeout ? {
            threshold: Math.min($ca970ce8cf2750a2$var$SLOW_CLICK_THRESHOLD, slowClickTimeout),
            timeout: slowClickTimeout,
            scrollTimeout: $ca970ce8cf2750a2$var$SLOW_CLICK_SCROLL_TIMEOUT,
            ignoreSelector: slowClickIgnoreSelectors ? slowClickIgnoreSelectors.join(',') : ''
        } : undefined;
        if (slowClickConfig) this.clickDetector = new $ca970ce8cf2750a2$var$ClickDetector(this, slowClickConfig);
    }
    /** Get the event context. */ getContext() {
        return this._context;
    }
    /** If recording is currently enabled. */ isEnabled() {
        return this._isEnabled;
    }
    /** If recording is currently paused. */ isPaused() {
        return this._isPaused;
    }
    /**
   * Determine if canvas recording is enabled
   */ isRecordingCanvas() {
        return Boolean(this._canvas);
    }
    /** Get the replay integration options. */ getOptions() {
        return this._options;
    }
    /**
   * Initializes the plugin based on sampling configuration. Should not be
   * called outside of constructor.
   */ initializeSampling(previousSessionId) {
        const { errorSampleRate: errorSampleRate, sessionSampleRate: sessionSampleRate } = this._options;
        // If neither sample rate is > 0, then do nothing - user will need to call one of
        // `start()` or `startBuffering` themselves.
        if (errorSampleRate <= 0 && sessionSampleRate <= 0) return;
        // Otherwise if there is _any_ sample rate set, try to load an existing
        // session, or create a new one.
        this._initializeSessionForSampling(previousSessionId);
        if (!this.session) {
            // This should not happen, something wrong has occurred
            this._handleException(new Error('Unable to initialize and create session'));
            return;
        }
        if (this.session.sampled === false) // This should only occur if `errorSampleRate` is 0 and was unsampled for
        // session-based replay. In this case there is nothing to do.
        return;
        // If segmentId > 0, it means we've previously already captured this session
        // In this case, we still want to continue in `session` recording mode
        this.recordingMode = this.session.sampled === 'buffer' && this.session.segmentId === 0 ? 'buffer' : 'session';
        $ca970ce8cf2750a2$var$logInfoNextTick(`[Replay] Starting replay in ${this.recordingMode} mode`, this._options._experiments.traceInternals);
        this._initializeRecording();
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * _performanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (this._isEnabled && this.recordingMode === 'session') throw new Error('Replay recording is already in progress');
        if (this._isEnabled && this.recordingMode === 'buffer') throw new Error('Replay buffering is in progress, call `flush()` to save the replay');
        $ca970ce8cf2750a2$var$logInfoNextTick('[Replay] Starting replay in session mode', this._options._experiments.traceInternals);
        // Required as user activity is initially set in
        // constructor, so if `start()` is called after
        // session idle expiration, a replay will not be
        // created due to an idle timeout.
        this._updateUserActivity();
        const session = $ca970ce8cf2750a2$var$loadOrCreateSession({
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            // This is intentional: create a new session-based replay when calling `start()`
            sessionSampleRate: 1,
            allowBuffering: false
        });
        this.session = session;
        this._initializeRecording();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, an error occurs.
   */ startBuffering() {
        if (this._isEnabled) throw new Error('Replay recording is already in progress');
        $ca970ce8cf2750a2$var$logInfoNextTick('[Replay] Starting replay in buffer mode', this._options._experiments.traceInternals);
        const session = $ca970ce8cf2750a2$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: 0,
            allowBuffering: true
        });
        this.session = session;
        this.recordingMode = 'buffer';
        this._initializeRecording();
    }
    /**
   * Start recording.
   *
   * Note that this will cause a new DOM checkout
   */ startRecording() {
        try {
            const canvasOptions = this._canvas;
            this._stopRecording = $ca970ce8cf2750a2$var$record({
                ...this._recordingOptions,
                // When running in error sampling mode, we need to overwrite `checkoutEveryNms`
                // Without this, it would record forever, until an error happens, which we don't want
                // instead, we'll always keep the last 60 seconds of replay before an error happened
                ...this.recordingMode === 'buffer' && {
                    checkoutEveryNms: $ca970ce8cf2750a2$var$BUFFER_CHECKOUT_TIME
                },
                emit: $ca970ce8cf2750a2$var$getHandleRecordingEmit(this),
                onMutation: this._onMutationHandler,
                ...canvasOptions ? {
                    recordCanvas: canvasOptions.recordCanvas,
                    getCanvasManager: canvasOptions.getCanvasManager,
                    sampling: canvasOptions.sampling,
                    dataURLOptions: canvasOptions.dataURLOptions
                } : {}
            });
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Stops the recording, if it was running.
   *
   * Returns true if it was previously stopped, or is now stopped,
   * otherwise false.
   */ stopRecording() {
        try {
            if (this._stopRecording) {
                this._stopRecording();
                this._stopRecording = undefined;
            }
            return true;
        } catch (err) {
            this._handleException(err);
            return false;
        }
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ async stop({ forceFlush: forceFlush = false, reason: reason } = {}) {
        if (!this._isEnabled) return;
        // We can't move `_isEnabled` after awaiting a flush, otherwise we can
        // enter into an infinite loop when `stop()` is called while flushing.
        this._isEnabled = false;
        try {
            $ca970ce8cf2750a2$var$logInfo(`[Replay] Stopping Replay${reason ? ` triggered by ${reason}` : ''}`, this._options._experiments.traceInternals);
            this._removeListeners();
            this.stopRecording();
            this._debouncedFlush.cancel();
            // See comment above re: `_isEnabled`, we "force" a flush, ignoring the
            // `_isEnabled` state of the plugin since it was disabled above.
            if (forceFlush) await this._flush({
                force: true
            });
            // After flush, destroy event buffer
            this.eventBuffer && this.eventBuffer.destroy();
            this.eventBuffer = null;
            // Clear session from session storage, note this means if a new session
            // is started after, it will not have `previousSessionId`
            $ca970ce8cf2750a2$var$clearSession(this);
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Pause some replay functionality. See comments for `_isPaused`.
   * This differs from stop as this only stops DOM recording, it is
   * not as thorough of a shutdown as `stop()`.
   */ pause() {
        if (this._isPaused) return;
        this._isPaused = true;
        this.stopRecording();
        $ca970ce8cf2750a2$var$logInfo('[Replay] Pausing replay', this._options._experiments.traceInternals);
    }
    /**
   * Resumes recording, see notes for `pause().
   *
   * Note that calling `startRecording()` here will cause a
   * new DOM checkout.`
   */ resume() {
        if (!this._isPaused || !this._checkSession()) return;
        this._isPaused = false;
        this.startRecording();
        $ca970ce8cf2750a2$var$logInfo('[Replay] Resuming replay', this._options._experiments.traceInternals);
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ async sendBufferedReplayOrFlush({ continueRecording: continueRecording = true } = {}) {
        if (this.recordingMode === 'session') return this.flushImmediate();
        const activityTime = Date.now();
        $ca970ce8cf2750a2$var$logInfo('[Replay] Converting buffer to session', this._options._experiments.traceInternals);
        // Allow flush to complete before resuming as a session recording, otherwise
        // the checkout from `startRecording` may be included in the payload.
        // Prefer to keep the error replay as a separate (and smaller) segment
        // than the session replay.
        await this.flushImmediate();
        const hasStoppedRecording = this.stopRecording();
        if (!continueRecording || !hasStoppedRecording) return;
        // To avoid race conditions where this is called multiple times, we check here again that we are still buffering
        if (this.recordingMode === 'session') return;
        // Re-start recording in session-mode
        this.recordingMode = 'session';
        // Once this session ends, we do not want to refresh it
        if (this.session) {
            this._updateUserActivity(activityTime);
            this._updateSessionActivity(activityTime);
            this._maybeSaveSession();
        }
        this.startRecording();
    }
    /**
   * We want to batch uploads of replay events. Save events only if
   * `<flushMinDelay>` milliseconds have elapsed since the last event
   * *OR* if `<flushMaxDelay>` milliseconds have elapsed.
   *
   * Accepts a callback to perform side-effects and returns true to stop batch
   * processing and hand back control to caller.
   */ addUpdate(cb) {
        // We need to always run `cb` (e.g. in the case of `this.recordingMode == 'buffer'`)
        const cbResult = cb();
        // If this option is turned on then we will only want to call `flush`
        // explicitly
        if (this.recordingMode === 'buffer') return;
        // If callback is true, we do not want to continue with flushing -- the
        // caller will need to handle it.
        if (cbResult === true) return;
        // addUpdate is called quite frequently - use _debouncedFlush so that it
        // respects the flush delays and does not flush immediately
        this._debouncedFlush();
    }
    /**
   * Updates the user activity timestamp and resumes recording. This should be
   * called in an event handler for a user action that we consider as the user
   * being "active" (e.g. a mouse click).
   */ triggerUserActivity() {
        this._updateUserActivity();
        // This case means that recording was once stopped due to inactivity.
        // Ensure that recording is resumed.
        if (!this._stopRecording) {
            // Create a new session, otherwise when the user action is flushed, it
            // will get rejected due to an expired session.
            if (!this._checkSession()) return;
            // Note: This will cause a new DOM checkout
            this.resume();
            return;
        }
        // Otherwise... recording was never suspended, continue as normalish
        this.checkAndHandleExpiredSession();
        this._updateSessionActivity();
    }
    /**
   * Updates the user activity timestamp *without* resuming
   * recording. Some user events (e.g. keydown) can be create
   * low-value replays that only contain the keypress as a
   * breadcrumb. Instead this would require other events to
   * create a new replay after a session has expired.
   */ updateUserActivity() {
        this._updateUserActivity();
        this._updateSessionActivity();
    }
    /**
   * Only flush if `this.recordingMode === 'session'`
   */ conditionalFlush() {
        if (this.recordingMode === 'buffer') return Promise.resolve();
        return this.flushImmediate();
    }
    /**
   * Flush using debounce flush
   */ flush() {
        return this._debouncedFlush();
    }
    /**
   * Always flush via `_debouncedFlush` so that we do not have flushes triggered
   * from calling both `flush` and `_debouncedFlush`. Otherwise, there could be
   * cases of mulitple flushes happening closely together.
   */ flushImmediate() {
        this._debouncedFlush();
        // `.flush` is provided by the debounced function, analogously to lodash.debounce
        return this._debouncedFlush.flush();
    }
    /**
   * Cancels queued up flushes.
   */ cancelFlush() {
        this._debouncedFlush.cancel();
    }
    /** Get the current sesion (=replay) ID */ getSessionId() {
        return this.session && this.session.id;
    }
    /**
   * Checks if recording should be stopped due to user inactivity. Otherwise
   * check if session is expired and create a new session if so. Triggers a new
   * full snapshot on new session.
   *
   * Returns true if session is not expired, false otherwise.
   * @hidden
   */ checkAndHandleExpiredSession() {
        // Prevent starting a new session if the last user activity is older than
        // SESSION_IDLE_PAUSE_DURATION. Otherwise non-user activity can trigger a new
        // session+recording. This creates noisy replays that do not have much
        // content in them.
        if (this._lastActivity && $ca970ce8cf2750a2$var$isExpired(this._lastActivity, this.timeouts.sessionIdlePause) && this.session && this.session.sampled === 'session') {
            // Pause recording only for session-based replays. Otherwise, resuming
            // will create a new replay and will conflict with users who only choose
            // to record error-based replays only. (e.g. the resumed replay will not
            // contain a reference to an error)
            this.pause();
            return;
        }
        // --- There is recent user activity --- //
        // This will create a new session if expired, based on expiry length
        if (!this._checkSession()) // Check session handles the refreshing itself
        return false;
        return true;
    }
    /**
   * Capture some initial state that can change throughout the lifespan of the
   * replay. This is required because otherwise they would be captured at the
   * first flush.
   */ setInitialState() {
        const urlPath = `${$ca970ce8cf2750a2$var$WINDOW.location.pathname}${$ca970ce8cf2750a2$var$WINDOW.location.hash}${$ca970ce8cf2750a2$var$WINDOW.location.search}`;
        const url = `${$ca970ce8cf2750a2$var$WINDOW.location.origin}${urlPath}`;
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        // Reset _context as well
        this._clearContext();
        this._context.initialUrl = url;
        this._context.initialTimestamp = Date.now();
        this._context.urls.push(url);
    }
    /**
   * Add a breadcrumb event, that may be throttled.
   * If it was throttled, we add a custom breadcrumb to indicate that.
   */ throttledAddEvent(event, isCheckout) {
        const res = this._throttledAddEvent(event, isCheckout);
        // If this is THROTTLED, it means we have throttled the event for the first time
        // In this case, we want to add a breadcrumb indicating that something was skipped
        if (res === $ca970ce8cf2750a2$var$THROTTLED) {
            const breadcrumb = $ca970ce8cf2750a2$var$createBreadcrumb({
                category: 'replay.throttled'
            });
            this.addUpdate(()=>{
                // Return `false` if the event _was_ added, as that means we schedule a flush
                return !$ca970ce8cf2750a2$var$addEventSync(this, {
                    type: $ca970ce8cf2750a2$var$ReplayEventTypeCustom,
                    timestamp: breadcrumb.timestamp || 0,
                    data: {
                        tag: 'breadcrumb',
                        payload: breadcrumb,
                        metric: true
                    }
                });
            });
        }
        return res;
    }
    /**
   * This will get the parametrized route name of the current page.
   * This is only available if performance is enabled, and if an instrumented router is used.
   */ getCurrentRoute() {
        const lastActiveSpan = this.lastActiveSpan || (0, $03e63b69c89faacb$export$1be426a8e585c83e)();
        const lastRootSpan = lastActiveSpan && (0, $03e63b69c89faacb$export$c4c6a79b1260ca1b)(lastActiveSpan);
        const attributes = lastRootSpan && (0, $03e63b69c89faacb$export$92d8c23565496537)(lastRootSpan).data || {};
        const source = attributes[0, $6dba76bc75a85eae$export$d7a7d984b0791405];
        if (!lastRootSpan || !source || ![
            'route',
            'custom'
        ].includes(source)) return undefined;
        return (0, $03e63b69c89faacb$export$92d8c23565496537)(lastRootSpan).description;
    }
    /**
   * Initialize and start all listeners to varying events (DOM,
   * Performance Observer, Recording, Sentry SDK, etc)
   */ _initializeRecording() {
        this.setInitialState();
        // this method is generally called on page load or manually - in both cases
        // we should treat it as an activity
        this._updateSessionActivity();
        this.eventBuffer = $ca970ce8cf2750a2$var$createEventBuffer({
            useCompression: this._options.useCompression,
            workerUrl: this._options.workerUrl
        });
        this._removeListeners();
        this._addListeners();
        // Need to set as enabled before we start recording, as `record()` can trigger a flush with a new checkout
        this._isEnabled = true;
        this._isPaused = false;
        this.startRecording();
    }
    /** A wrapper to conditionally capture exceptions. */ _handleException(error) {
        $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay]', error);
        if ($ca970ce8cf2750a2$var$DEBUG_BUILD && this._options._experiments && this._options._experiments.captureExceptions) (0, $6e2d7e6efd34a5e4$export$f5282963edea4a68)(error);
    }
    /**
   * Loads (or refreshes) the current session.
   */ _initializeSessionForSampling(previousSessionId) {
        // Whenever there is _any_ error sample rate, we always allow buffering
        // Because we decide on sampling when an error occurs, we need to buffer at all times if sampling for errors
        const allowBuffering = this._options.errorSampleRate > 0;
        const session = $ca970ce8cf2750a2$var$loadOrCreateSession({
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            traceInternals: this._options._experiments.traceInternals,
            previousSessionId: previousSessionId
        }, {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: allowBuffering
        });
        this.session = session;
    }
    /**
   * Checks and potentially refreshes the current session.
   * Returns false if session is not recorded.
   */ _checkSession() {
        // If there is no session yet, we do not want to refresh anything
        // This should generally not happen, but to be safe....
        if (!this.session) return false;
        const currentSession = this.session;
        if ($ca970ce8cf2750a2$var$shouldRefreshSession(currentSession, {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration
        })) {
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this._refreshSession(currentSession);
            return false;
        }
        return true;
    }
    /**
   * Refresh a session with a new one.
   * This stops the current session (without forcing a flush, as that would never work since we are expired),
   * and then does a new sampling based on the refreshed session.
   */ async _refreshSession(session) {
        if (!this._isEnabled) return;
        await this.stop({
            reason: 'refresh session'
        });
        this.initializeSampling(session.id);
    }
    /**
   * Adds listeners to record events for the replay
   */ _addListeners() {
        try {
            $ca970ce8cf2750a2$var$WINDOW.document.addEventListener('visibilitychange', this._handleVisibilityChange);
            $ca970ce8cf2750a2$var$WINDOW.addEventListener('blur', this._handleWindowBlur);
            $ca970ce8cf2750a2$var$WINDOW.addEventListener('focus', this._handleWindowFocus);
            $ca970ce8cf2750a2$var$WINDOW.addEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.addListeners();
            // There is no way to remove these listeners, so ensure they are only added once
            if (!this._hasInitializedCoreListeners) {
                $ca970ce8cf2750a2$var$addGlobalListeners(this);
                this._hasInitializedCoreListeners = true;
            }
        } catch (err) {
            this._handleException(err);
        }
        this._performanceCleanupCallback = $ca970ce8cf2750a2$var$setupPerformanceObserver(this);
    }
    /**
   * Cleans up listeners that were created in `_addListeners`
   */ _removeListeners() {
        try {
            $ca970ce8cf2750a2$var$WINDOW.document.removeEventListener('visibilitychange', this._handleVisibilityChange);
            $ca970ce8cf2750a2$var$WINDOW.removeEventListener('blur', this._handleWindowBlur);
            $ca970ce8cf2750a2$var$WINDOW.removeEventListener('focus', this._handleWindowFocus);
            $ca970ce8cf2750a2$var$WINDOW.removeEventListener('keydown', this._handleKeyboardEvent);
            if (this.clickDetector) this.clickDetector.removeListeners();
            if (this._performanceCleanupCallback) this._performanceCleanupCallback();
        } catch (err) {
            this._handleException(err);
        }
    }
    /**
   * Handle when visibility of the page content changes. Opening a new tab will
   * cause the state to change to hidden because of content of current page will
   * be hidden. Likewise, moving a different window to cover the contents of the
   * page will also trigger a change to a hidden state.
   */ __init() {
        this._handleVisibilityChange = ()=>{
            if ($ca970ce8cf2750a2$var$WINDOW.document.visibilityState === 'visible') this._doChangeToForegroundTasks();
            else this._doChangeToBackgroundTasks();
        };
    }
    /**
   * Handle when page is blurred
   */ __init2() {
        this._handleWindowBlur = ()=>{
            const breadcrumb = $ca970ce8cf2750a2$var$createBreadcrumb({
                category: 'ui.blur'
            });
            // Do not count blur as a user action -- it's part of the process of them
            // leaving the page
            this._doChangeToBackgroundTasks(breadcrumb);
        };
    }
    /**
   * Handle when page is focused
   */ __init3() {
        this._handleWindowFocus = ()=>{
            const breadcrumb = $ca970ce8cf2750a2$var$createBreadcrumb({
                category: 'ui.focus'
            });
            // Do not count focus as a user action -- instead wait until they focus and
            // interactive with page
            this._doChangeToForegroundTasks(breadcrumb);
        };
    }
    /** Ensure page remains active when a key is pressed. */ __init4() {
        this._handleKeyboardEvent = (event)=>{
            $ca970ce8cf2750a2$var$handleKeyboardEvent(this, event);
        };
    }
    /**
   * Tasks to run when we consider a page to be hidden (via blurring and/or visibility)
   */ _doChangeToBackgroundTasks(breadcrumb) {
        if (!this.session) return;
        const expired = $ca970ce8cf2750a2$var$isSessionExpired(this.session, {
            maxReplayDuration: this._options.maxReplayDuration,
            sessionIdleExpire: this.timeouts.sessionIdleExpire
        });
        if (expired) return;
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
        // Send replay when the page/tab becomes hidden. There is no reason to send
        // replay if it becomes visible, since no actions we care about were done
        // while it was hidden
        // This should never reject
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.conditionalFlush();
    }
    /**
   * Tasks to run when we consider a page to be visible (via focus and/or visibility)
   */ _doChangeToForegroundTasks(breadcrumb) {
        if (!this.session) return;
        const isSessionActive = this.checkAndHandleExpiredSession();
        if (!isSessionActive) {
            // If the user has come back to the page within SESSION_IDLE_PAUSE_DURATION
            // ms, we will re-use the existing session, otherwise create a new
            // session
            $ca970ce8cf2750a2$var$logInfo('[Replay] Document has become active, but session has expired');
            return;
        }
        if (breadcrumb) this._createCustomBreadcrumb(breadcrumb);
    }
    /**
   * Update user activity (across session lifespans)
   */ _updateUserActivity(_lastActivity = Date.now()) {
        this._lastActivity = _lastActivity;
    }
    /**
   * Updates the session's last activity timestamp
   */ _updateSessionActivity(_lastActivity = Date.now()) {
        if (this.session) {
            this.session.lastActivity = _lastActivity;
            this._maybeSaveSession();
        }
    }
    /**
   * Helper to create (and buffer) a replay breadcrumb from a core SDK breadcrumb
   */ _createCustomBreadcrumb(breadcrumb) {
        this.addUpdate(()=>{
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.throttledAddEvent({
                type: $ca970ce8cf2750a2$var$EventType.Custom,
                timestamp: breadcrumb.timestamp || 0,
                data: {
                    tag: 'breadcrumb',
                    payload: breadcrumb
                }
            });
        });
    }
    /**
   * Observed performance events are added to `this.performanceEntries`. These
   * are included in the replay event before it is finished and sent to Sentry.
   */ _addPerformanceEntries() {
        const performanceEntries = $ca970ce8cf2750a2$var$createPerformanceEntries(this.performanceEntries).concat(this.replayPerformanceEntries);
        this.performanceEntries = [];
        this.replayPerformanceEntries = [];
        return Promise.all($ca970ce8cf2750a2$var$createPerformanceSpans(this, performanceEntries));
    }
    /**
   * Clear _context
   */ _clearContext() {
        // XXX: `initialTimestamp` and `initialUrl` do not get cleared
        this._context.errorIds.clear();
        this._context.traceIds.clear();
        this._context.urls = [];
    }
    /** Update the initial timestamp based on the buffer content. */ _updateInitialTimestampFromEventBuffer() {
        const { session: session, eventBuffer: eventBuffer } = this;
        if (!session || !eventBuffer) return;
        // we only ever update this on the initial segment
        if (session.segmentId) return;
        const earliestEvent = eventBuffer.getEarliestTimestamp();
        if (earliestEvent && earliestEvent < this._context.initialTimestamp) this._context.initialTimestamp = earliestEvent;
    }
    /**
   * Return and clear _context
   */ _popEventContext() {
        const _context = {
            initialTimestamp: this._context.initialTimestamp,
            initialUrl: this._context.initialUrl,
            errorIds: Array.from(this._context.errorIds),
            traceIds: Array.from(this._context.traceIds),
            urls: this._context.urls
        };
        this._clearContext();
        return _context;
    }
    /**
   * Flushes replay event buffer to Sentry.
   *
   * Performance events are only added right before flushing - this is
   * due to the buffered performance observer events.
   *
   * Should never be called directly, only by `flush`
   */ async _runFlush() {
        const replayId = this.getSessionId();
        if (!this.session || !this.eventBuffer || !replayId) {
            $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay] No session or eventBuffer found to flush.');
            return;
        }
        await this._addPerformanceEntries();
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer || !this.eventBuffer.hasEvents) return;
        // Only attach memory event if eventBuffer is not empty
        await $ca970ce8cf2750a2$var$addMemoryEntry(this);
        // Check eventBuffer again, as it could have been stopped in the meanwhile
        if (!this.eventBuffer) return;
        // if this changed in the meanwhile, e.g. because the session was refreshed or similar, we abort here
        if (replayId !== this.getSessionId()) return;
        try {
            // This uses the data from the eventBuffer, so we need to call this before `finish()
            this._updateInitialTimestampFromEventBuffer();
            const timestamp = Date.now();
            // Check total duration again, to avoid sending outdated stuff
            // We leave 30s wiggle room to accomodate late flushing etc.
            // This _could_ happen when the browser is suspended during flushing, in which case we just want to stop
            if (timestamp - this._context.initialTimestamp > this._options.maxReplayDuration + 30000) throw new Error('Session is too long, not sending replay');
            const eventContext = this._popEventContext();
            // Always increment segmentId regardless of outcome of sending replay
            const segmentId = this.session.segmentId++;
            this._maybeSaveSession();
            // Note this empties the event buffer regardless of outcome of sending replay
            const recordingData = await this.eventBuffer.finish();
            await $ca970ce8cf2750a2$var$sendReplay({
                replayId: replayId,
                recordingData: recordingData,
                segmentId: segmentId,
                eventContext: eventContext,
                session: this.session,
                options: this.getOptions(),
                timestamp: timestamp
            });
        } catch (err) {
            this._handleException(err);
            // This means we retried 3 times and all of them failed,
            // or we ran into a problem we don't want to retry, like rate limiting.
            // In this case, we want to completely stop the replay - otherwise, we may get inconsistent segments
            // This should never reject
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            this.stop({
                reason: 'sendReplay'
            });
            const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
            if (client) client.recordDroppedEvent('send_error', 'replay');
        }
    }
    /**
   * Flush recording data to Sentry. Creates a lock so that only a single flush
   * can be active at a time. Do not call this directly.
   */ __init5() {
        this._flush = async ({ force: force = false } = {})=>{
            if (!this._isEnabled && !force) // This can happen if e.g. the replay was stopped because of exceeding the retry limit
            return;
            if (!this.checkAndHandleExpiredSession()) {
                $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error('[Replay] Attempting to finish replay event after session expired.');
                return;
            }
            if (!this.session) // should never happen, as we would have bailed out before
            return;
            const start = this.session.started;
            const now = Date.now();
            const duration = now - start;
            // A flush is about to happen, cancel any queued flushes
            this._debouncedFlush.cancel();
            // If session is too short, or too long (allow some wiggle room over maxReplayDuration), do not send it
            // This _should_ not happen, but it may happen if flush is triggered due to a page activity change or similar
            const tooShort = duration < this._options.minReplayDuration;
            const tooLong = duration > this._options.maxReplayDuration + 5000;
            if (tooShort || tooLong) {
                $ca970ce8cf2750a2$var$logInfo(`[Replay] Session duration (${Math.floor(duration / 1000)}s) is too ${tooShort ? 'short' : 'long'}, not sending replay.`, this._options._experiments.traceInternals);
                if (tooShort) this._debouncedFlush();
                return;
            }
            const eventBuffer = this.eventBuffer;
            if (eventBuffer && this.session.segmentId === 0 && !eventBuffer.hasCheckout) $ca970ce8cf2750a2$var$logInfo('[Replay] Flushing initial segment without checkout.', this._options._experiments.traceInternals);
            // this._flushLock acts as a lock so that future calls to `_flush()`
            // will be blocked until this promise resolves
            if (!this._flushLock) {
                this._flushLock = this._runFlush();
                await this._flushLock;
                this._flushLock = undefined;
                return;
            }
            // Wait for previous flush to finish, then call the debounced `_flush()`.
            // It's possible there are other flush requests queued and waiting for it
            // to resolve. We want to reduce all outstanding requests (as well as any
            // new flush requests that occur within a second of the locked flush
            // completing) into a single flush.
            try {
                await this._flushLock;
            } catch (err) {
                $ca970ce8cf2750a2$var$DEBUG_BUILD && (0, $117c8f31aa65bddd$export$af88d00dbe7f521).error(err);
            } finally{
                this._debouncedFlush();
            }
        };
    }
    /** Save the session, if it is sticky */ _maybeSaveSession() {
        if (this.session && this._options.stickySession) $ca970ce8cf2750a2$var$saveSession(this.session);
    }
    /** Handler for rrweb.record.onMutation */ __init6() {
        this._onMutationHandler = (mutations)=>{
            const count = mutations.length;
            const mutationLimit = this._options.mutationLimit;
            const mutationBreadcrumbLimit = this._options.mutationBreadcrumbLimit;
            const overMutationLimit = mutationLimit && count > mutationLimit;
            // Create a breadcrumb if a lot of mutations happen at the same time
            // We can show this in the UI as an information with potential performance improvements
            if (count > mutationBreadcrumbLimit || overMutationLimit) {
                const breadcrumb = $ca970ce8cf2750a2$var$createBreadcrumb({
                    category: 'replay.mutations',
                    data: {
                        count: count,
                        limit: overMutationLimit
                    }
                });
                this._createCustomBreadcrumb(breadcrumb);
            }
            // Stop replay if over the mutation limit
            if (overMutationLimit) {
                // This should never reject
                // eslint-disable-next-line @typescript-eslint/no-floating-promises
                this.stop({
                    reason: 'mutationLimit',
                    forceFlush: this.recordingMode === 'session'
                });
                return false;
            }
            // `true` means we use the regular mutation handling by rrweb
            return true;
        };
    }
}
function $ca970ce8cf2750a2$var$getOption(selectors, defaultSelectors) {
    return [
        ...selectors,
        // sentry defaults
        ...defaultSelectors
    ].join(',');
}
/**
 * Returns privacy related configuration for use in rrweb
 */ function $ca970ce8cf2750a2$var$getPrivacyOptions({ mask: mask, unmask: unmask, block: block, unblock: unblock, ignore: ignore }) {
    const defaultBlockedElements = [
        'base[href="/"]'
    ];
    const maskSelector = $ca970ce8cf2750a2$var$getOption(mask, [
        '.sentry-mask',
        '[data-sentry-mask]'
    ]);
    const unmaskSelector = $ca970ce8cf2750a2$var$getOption(unmask, []);
    const options = {
        // We are making the decision to make text and input selectors the same
        maskTextSelector: maskSelector,
        unmaskTextSelector: unmaskSelector,
        blockSelector: $ca970ce8cf2750a2$var$getOption(block, [
            '.sentry-block',
            '[data-sentry-block]',
            ...defaultBlockedElements
        ]),
        unblockSelector: $ca970ce8cf2750a2$var$getOption(unblock, []),
        ignoreSelector: $ca970ce8cf2750a2$var$getOption(ignore, [
            '.sentry-ignore',
            '[data-sentry-ignore]',
            'input[type="file"]'
        ])
    };
    return options;
}
/**
 * Masks an attribute if necessary, otherwise return attribute value as-is.
 */ function $ca970ce8cf2750a2$var$maskAttribute({ el: el, key: key, maskAttributes: maskAttributes, maskAllText: maskAllText, privacyOptions: privacyOptions, value: value }) {
    // We only mask attributes if `maskAllText` is true
    if (!maskAllText) return value;
    // unmaskTextSelector takes precendence
    if (privacyOptions.unmaskTextSelector && el.matches(privacyOptions.unmaskTextSelector)) return value;
    if (maskAttributes.includes(key) || // Need to mask `value` attribute for `<input>` if it's a button-like
    // type
    key === 'value' && el.tagName === 'INPUT' && [
        'submit',
        'button'
    ].includes(el.getAttribute('type') || '')) return value.replace(/[\S]/g, '*');
    return value;
}
const $ca970ce8cf2750a2$var$MEDIA_SELECTORS = 'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]';
const $ca970ce8cf2750a2$var$DEFAULT_NETWORK_HEADERS = [
    'content-length',
    'content-type',
    'accept'
];
let $ca970ce8cf2750a2$var$_initialized = false;
/**
 * Sentry integration for [Session Replay](https://sentry.io/for/session-replay/).
 *
 * See the [Replay documentation](https://docs.sentry.io/platforms/javascript/guides/session-replay/) for more information.
 *
 * @example
 *
 * ```
 * Sentry.init({
 *   dsn: '__DSN__',
 *   integrations: [Sentry.replayIntegration()],
 * });
 * ```
 */ const $ca970ce8cf2750a2$export$d7706faf7ab354bf = (options)=>{
    return new $ca970ce8cf2750a2$var$Replay(options);
};
/**
 * Replay integration
 *
 * TODO: Rewrite this to be functional integration
 * Exported for tests.
 */ class $ca970ce8cf2750a2$var$Replay {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Replay';
    }
    /**
   * @inheritDoc
   */ /**
   * Options to pass to `rrweb.record()`
   */ /**
   * Initial options passed to the replay integration, merged with default values.
   * Note: `sessionSampleRate` and `errorSampleRate` are not required here, as they
   * can only be finally set when setupOnce() is called.
   *
   * @private
   */ constructor({ flushMinDelay: flushMinDelay = $ca970ce8cf2750a2$var$DEFAULT_FLUSH_MIN_DELAY, flushMaxDelay: flushMaxDelay = $ca970ce8cf2750a2$var$DEFAULT_FLUSH_MAX_DELAY, minReplayDuration: minReplayDuration = $ca970ce8cf2750a2$var$MIN_REPLAY_DURATION, maxReplayDuration: maxReplayDuration = $ca970ce8cf2750a2$var$MAX_REPLAY_DURATION, stickySession: stickySession = true, useCompression: useCompression = true, workerUrl: workerUrl, _experiments: _experiments = {}, maskAllText: maskAllText = true, maskAllInputs: maskAllInputs = true, blockAllMedia: blockAllMedia = true, mutationBreadcrumbLimit: mutationBreadcrumbLimit = 750, mutationLimit: mutationLimit = 10000, slowClickTimeout: slowClickTimeout = 7000, slowClickIgnoreSelectors: slowClickIgnoreSelectors = [], networkDetailAllowUrls: networkDetailAllowUrls = [], networkDetailDenyUrls: networkDetailDenyUrls = [], networkCaptureBodies: networkCaptureBodies = true, networkRequestHeaders: networkRequestHeaders = [], networkResponseHeaders: networkResponseHeaders = [], mask: mask = [], maskAttributes: maskAttributes = [
        'title',
        'placeholder'
    ], unmask: unmask = [], block: block = [], unblock: unblock = [], ignore: ignore = [], maskFn: maskFn, beforeAddRecordingEvent: beforeAddRecordingEvent, beforeErrorSampling: beforeErrorSampling } = {}){
        this.name = $ca970ce8cf2750a2$var$Replay.id;
        const privacyOptions = $ca970ce8cf2750a2$var$getPrivacyOptions({
            mask: mask,
            unmask: unmask,
            block: block,
            unblock: unblock,
            ignore: ignore
        });
        this._recordingOptions = {
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            maskInputOptions: {
                password: true
            },
            maskTextFn: maskFn,
            maskInputFn: maskFn,
            maskAttributeFn: (key, value, el)=>$ca970ce8cf2750a2$var$maskAttribute({
                    maskAttributes: maskAttributes,
                    maskAllText: maskAllText,
                    privacyOptions: privacyOptions,
                    key: key,
                    value: value,
                    el: el
                }),
            ...privacyOptions,
            // Our defaults
            slimDOMOptions: 'all',
            inlineStylesheet: true,
            // Disable inline images as it will increase segment/replay size
            inlineImages: false,
            // collect fonts, but be aware that `sentry.io` needs to be an allowed
            // origin for playback
            collectFonts: true,
            errorHandler: (err)=>{
                try {
                    err.__rrweb__ = true;
                } catch (error) {
                // ignore errors here
                // this can happen if the error is frozen or does not allow mutation for other reasons
                }
            }
        };
        this._initialOptions = {
            flushMinDelay: flushMinDelay,
            flushMaxDelay: flushMaxDelay,
            minReplayDuration: Math.min(minReplayDuration, $ca970ce8cf2750a2$var$MIN_REPLAY_DURATION_LIMIT),
            maxReplayDuration: Math.min(maxReplayDuration, $ca970ce8cf2750a2$var$MAX_REPLAY_DURATION),
            stickySession: stickySession,
            useCompression: useCompression,
            workerUrl: workerUrl,
            blockAllMedia: blockAllMedia,
            maskAllInputs: maskAllInputs,
            maskAllText: maskAllText,
            mutationBreadcrumbLimit: mutationBreadcrumbLimit,
            mutationLimit: mutationLimit,
            slowClickTimeout: slowClickTimeout,
            slowClickIgnoreSelectors: slowClickIgnoreSelectors,
            networkDetailAllowUrls: networkDetailAllowUrls,
            networkDetailDenyUrls: networkDetailDenyUrls,
            networkCaptureBodies: networkCaptureBodies,
            networkRequestHeaders: $ca970ce8cf2750a2$var$_getMergedNetworkHeaders(networkRequestHeaders),
            networkResponseHeaders: $ca970ce8cf2750a2$var$_getMergedNetworkHeaders(networkResponseHeaders),
            beforeAddRecordingEvent: beforeAddRecordingEvent,
            beforeErrorSampling: beforeErrorSampling,
            _experiments: _experiments
        };
        if (this._initialOptions.blockAllMedia) // `blockAllMedia` is a more user friendly option to configure blocking
        // embedded media elements
        this._recordingOptions.blockSelector = !this._recordingOptions.blockSelector ? $ca970ce8cf2750a2$var$MEDIA_SELECTORS : `${this._recordingOptions.blockSelector},${$ca970ce8cf2750a2$var$MEDIA_SELECTORS}`;
        if (this._isInitialized && (0, $44c797189ebd809c$export$4e09c449d6c407f7)()) throw new Error('Multiple Sentry Session Replay instances are not supported');
        this._isInitialized = true;
    }
    /** If replay has already been initialized */ get _isInitialized() {
        return $ca970ce8cf2750a2$var$_initialized;
    }
    /** Update _isInitialized */ set _isInitialized(value) {
        $ca970ce8cf2750a2$var$_initialized = value;
    }
    /**
   * Setup and initialize replay container
   */ setupOnce() {
        if (!(0, $44c797189ebd809c$export$4e09c449d6c407f7)()) return;
        this._setup();
        // Once upon a time, we tried to create a transaction in `setupOnce` and it would
        // potentially create a transaction before some native SDK integrations have run
        // and applied their own global event processor. An example is:
        // https://github.com/getsentry/sentry-javascript/blob/b47ceafbdac7f8b99093ce6023726ad4687edc48/packages/browser/src/integrations/useragent.ts
        //
        // So we call `this._initialize()` in next event loop as a workaround to wait for other
        // global event processors to finish. This is no longer needed, but keeping it
        // here to avoid any future issues.
        setTimeout(()=>this._initialize());
    }
    /**
   * Start a replay regardless of sampling rate. Calling this will always
   * create a new session. Will throw an error if replay is already in progress.
   *
   * Creates or loads a session, attaches listeners to varying events (DOM,
   * PerformanceObserver, Recording, Sentry SDK, etc)
   */ start() {
        if (!this._replay) return;
        this._replay.start();
    }
    /**
   * Start replay buffering. Buffers until `flush()` is called or, if
   * `replaysOnErrorSampleRate` > 0, until an error occurs.
   */ startBuffering() {
        if (!this._replay) return;
        this._replay.startBuffering();
    }
    /**
   * Currently, this needs to be manually called (e.g. for tests). Sentry SDK
   * does not support a teardown
   */ stop() {
        if (!this._replay) return Promise.resolve();
        return this._replay.stop({
            forceFlush: this._replay.recordingMode === 'session'
        });
    }
    /**
   * If not in "session" recording mode, flush event buffer which will create a new replay.
   * Unless `continueRecording` is false, the replay will continue to record and
   * behave as a "session"-based replay.
   *
   * Otherwise, queue up a flush.
   */ flush(options) {
        if (!this._replay || !this._replay.isEnabled()) return Promise.resolve();
        return this._replay.sendBufferedReplayOrFlush(options);
    }
    /**
   * Get the current session ID.
   */ getReplayId() {
        if (!this._replay || !this._replay.isEnabled()) return;
        return this._replay.getSessionId();
    }
    /**
   * Initializes replay.
   */ _initialize() {
        if (!this._replay) return;
        // We have to run this in _initialize, because this runs in setTimeout
        // So when this runs all integrations have been added
        // Before this, we cannot access integrations on the client,
        // so we need to mutate the options here
        this._maybeLoadFromReplayCanvasIntegration();
        this._replay.initializeSampling();
    }
    /** Setup the integration. */ _setup() {
        // Client is not available in constructor, so we need to wait until setupOnce
        const finalOptions = $ca970ce8cf2750a2$var$loadReplayOptionsFromClient(this._initialOptions);
        this._replay = new $ca970ce8cf2750a2$var$ReplayContainer({
            options: finalOptions,
            recordingOptions: this._recordingOptions
        });
    }
    /** Get canvas options from ReplayCanvas integration, if it is also added. */ _maybeLoadFromReplayCanvasIntegration() {
        // To save bundle size, we skip checking for stuff here
        // and instead just try-catch everything - as generally this should all be defined
        /* eslint-disable @typescript-eslint/no-non-null-assertion */ try {
            const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
            const canvasIntegration = client.getIntegrationByName('ReplayCanvas');
            if (!canvasIntegration) return;
            this._replay['_canvas'] = canvasIntegration.getOptions();
        } catch (e) {
        // ignore errors here
        }
    /* eslint-enable @typescript-eslint/no-non-null-assertion */ }
}
$ca970ce8cf2750a2$var$Replay.__initStatic();
/** Parse Replay-related options from SDK options */ function $ca970ce8cf2750a2$var$loadReplayOptionsFromClient(initialOptions) {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    const opt = client && client.getOptions();
    const finalOptions = {
        sessionSampleRate: 0,
        errorSampleRate: 0,
        ...(0, $68dbcfd11e00a6d4$export$d25f2688db1bb433)(initialOptions)
    };
    if (!opt) {
        (0, $117c8f31aa65bddd$export$cda52e2a8927a2ca)(()=>{
            // eslint-disable-next-line no-console
            console.warn('SDK client is not available.');
        });
        return finalOptions;
    }
    const replaysSessionSampleRate = (0, $0bb8cfda553273b7$export$a5bd2d81656d9546)(opt.replaysSessionSampleRate);
    const replaysOnErrorSampleRate = (0, $0bb8cfda553273b7$export$a5bd2d81656d9546)(opt.replaysOnErrorSampleRate);
    if (replaysSessionSampleRate == null && replaysOnErrorSampleRate == null) (0, $117c8f31aa65bddd$export$cda52e2a8927a2ca)(()=>{
        // eslint-disable-next-line no-console
        console.warn('Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.');
    });
    if (replaysSessionSampleRate != null) finalOptions.sessionSampleRate = replaysSessionSampleRate;
    if (replaysOnErrorSampleRate != null) finalOptions.errorSampleRate = replaysOnErrorSampleRate;
    return finalOptions;
}
function $ca970ce8cf2750a2$var$_getMergedNetworkHeaders(headers) {
    return [
        ...$ca970ce8cf2750a2$var$DEFAULT_NETWORK_HEADERS,
        ...headers.map((header)=>header.toLowerCase())
    ];
}
/**
 * This is a small utility to get a type-safe instance of the Replay integration.
 */ function $ca970ce8cf2750a2$export$b28310b2f161456b() {
    const client = (0, $971e6b058109b0a9$export$6bb76d6eba7e258c)();
    return client && client.getIntegrationByName('Replay');
}


var $7d59b24134129acf$exports = {};
'use strict';
function $7d59b24134129acf$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7d59b24134129acf$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7d59b24134129acf$var$checkDCE();

$7d59b24134129acf$exports = (parcelRequire("hLm8s"));



parcelRequire("5FkrB");
function $97bc1202558212af$export$2e2bcd8739ae039() {
    return $97bc1202558212af$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $97bc1202558212af$export$2e2bcd8739ae039.apply(null, arguments);
}


/**
 * Actions represent the type of change to a location value.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#action
 */ var $c29d101a2cf08ade$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($c29d101a2cf08ade$export$e19cd5f9376f8cee || ($c29d101a2cf08ade$export$e19cd5f9376f8cee = {}));
var $c29d101a2cf08ade$var$readOnly = function(obj) {
    return obj;
};
function $c29d101a2cf08ade$var$warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== 'undefined') console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
var $c29d101a2cf08ade$var$BeforeUnloadEventType = 'beforeunload';
var $c29d101a2cf08ade$var$HashChangeEventType = 'hashchange';
var $c29d101a2cf08ade$var$PopStateEventType = 'popstate';
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $c29d101a2cf08ade$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    var _options = options, _options$window = _options.window, window = _options$window === void 0 ? document.defaultView : _options$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _window$location = window.location, pathname = _window$location.pathname, search = _window$location.search, hash = _window$location.hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation = getIndexAndLocation(), nextIndex = _getIndexAndLocation[0], nextLocation = _getIndexAndLocation[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation2 = getIndexAndLocation(), index = _getIndexAndLocation2[0], location = _getIndexAndLocation2[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $97bc1202558212af$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    } // state defaults to `null` because `window.history.state` does
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $97bc1202558212af$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation3 = getIndexAndLocation();
        index = _getIndexAndLocation3[0];
        location = _getIndexAndLocation3[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr[0], url = _getHistoryStateAndUr[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr2 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr2[0], url = _getHistoryStateAndUr2[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $c29d101a2cf08ade$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    var _options2 = options, _options2$window = _options2.window, window = _options2$window === void 0 ? document.defaultView : _options2$window;
    var globalHistory = window.history;
    function getIndexAndLocation() {
        var _parsePath = $c29d101a2cf08ade$export$8ccf933b0513f8d0(window.location.hash.substr(1)), _parsePath$pathname = _parsePath.pathname, pathname = _parsePath$pathname === void 0 ? '/' : _parsePath$pathname, _parsePath$search = _parsePath.search, search = _parsePath$search === void 0 ? '' : _parsePath$search, _parsePath$hash = _parsePath.hash, hash = _parsePath$hash === void 0 ? '' : _parsePath$hash;
        var state = globalHistory.state || {};
        return [
            state.idx,
            $c29d101a2cf08ade$var$readOnly({
                pathname: pathname,
                search: search,
                hash: hash,
                state: state.usr || null,
                key: state.key || 'default'
            })
        ];
    }
    var blockedPopTx = null;
    function handlePop() {
        if (blockedPopTx) {
            blockers.call(blockedPopTx);
            blockedPopTx = null;
        } else {
            var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
            var _getIndexAndLocation4 = getIndexAndLocation(), nextIndex = _getIndexAndLocation4[0], nextLocation = _getIndexAndLocation4[1];
            if (blockers.length) {
                if (nextIndex != null) {
                    var delta = index - nextIndex;
                    if (delta) {
                        // Revert the POP
                        blockedPopTx = {
                            action: nextAction,
                            location: nextLocation,
                            retry: function retry() {
                                go(delta * -1);
                            }
                        };
                        go(delta);
                    }
                }
            } else applyTx(nextAction);
        }
    }
    window.addEventListener($c29d101a2cf08ade$var$PopStateEventType, handlePop); // popstate does not fire on hashchange in IE 11 and old (trident) Edge
    // https://developer.mozilla.org/de/docs/Web/API/Window/popstate_event
    window.addEventListener($c29d101a2cf08ade$var$HashChangeEventType, function() {
        var _getIndexAndLocation5 = getIndexAndLocation(), nextLocation = _getIndexAndLocation5[1]; // Ignore extraneous hashchange events.
        if ($c29d101a2cf08ade$export$fe53371bee54353d(nextLocation) !== $c29d101a2cf08ade$export$fe53371bee54353d(location)) handlePop();
    });
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var _getIndexAndLocation6 = getIndexAndLocation(), index = _getIndexAndLocation6[0], location = _getIndexAndLocation6[1];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $97bc1202558212af$export$2e2bcd8739ae039)({}, globalHistory.state, {
            idx: index
        }), '');
    }
    function getBaseHref() {
        var base = document.querySelector('base');
        var href = '';
        if (base && base.getAttribute('href')) {
            var url = window.location.href;
            var hashIndex = url.indexOf('#');
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href;
    }
    function createHref(to) {
        return getBaseHref() + '#' + (typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to));
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $97bc1202558212af$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            hash: '',
            search: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function getHistoryStateAndUrl(nextLocation, index) {
        return [
            {
                usr: nextLocation.state,
                key: nextLocation.key,
                idx: index
            },
            createHref(nextLocation)
        ];
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction) {
        action = nextAction;
        var _getIndexAndLocation7 = getIndexAndLocation();
        index = _getIndexAndLocation7[0];
        location = _getIndexAndLocation7[1];
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr3 = getHistoryStateAndUrl(nextLocation, index + 1), historyState = _getHistoryStateAndUr3[0], url = _getHistoryStateAndUr3[1]; // TODO: Support forced reloading
            // try...catch because iOS limits us to 100 pushState calls :/
            try {
                globalHistory.pushState(historyState, '', url);
            } catch (error) {
                // They are going to lose state here, but there is no real
                // way to warn them about it since the page will refresh...
                window.location.assign(url);
            }
            applyTx(nextAction);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            var _getHistoryStateAndUr4 = getHistoryStateAndUrl(nextLocation, index), historyState = _getHistoryStateAndUr4[0], url = _getHistoryStateAndUr4[1]; // TODO: Support forced reloading
            globalHistory.replaceState(historyState, '', url);
            applyTx(nextAction);
        }
    }
    function go(delta) {
        globalHistory.go(delta);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            var unblock = blockers.push(blocker);
            if (blockers.length === 1) window.addEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            return function() {
                unblock(); // Remove the beforeunload listener so the document may
                // still be salvageable in the pagehide event.
                // See https://html.spec.whatwg.org/#unloading-documents
                if (!blockers.length) window.removeEventListener($c29d101a2cf08ade$var$BeforeUnloadEventType, $c29d101a2cf08ade$var$promptBeforeUnload);
            };
        }
    };
    return history;
}
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#creatememoryhistory
 */ function $c29d101a2cf08ade$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    var _options3 = options, _options3$initialEntr = _options3.initialEntries, initialEntries = _options3$initialEntr === void 0 ? [
        '/'
    ] : _options3$initialEntr, initialIndex = _options3.initialIndex;
    var entries = initialEntries.map(function(entry) {
        var location = $c29d101a2cf08ade$var$readOnly((0, $97bc1202558212af$export$2e2bcd8739ae039)({
            pathname: '/',
            search: '',
            hash: '',
            state: null,
            key: $c29d101a2cf08ade$var$createKey()
        }, typeof entry === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(entry) : entry));
        return location;
    });
    var index = $c29d101a2cf08ade$var$clamp(initialIndex == null ? entries.length - 1 : initialIndex, 0, entries.length - 1);
    var action = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
    var location = entries[index];
    var listeners = $c29d101a2cf08ade$var$createEvents();
    var blockers = $c29d101a2cf08ade$var$createEvents();
    function createHref(to) {
        return typeof to === 'string' ? to : $c29d101a2cf08ade$export$fe53371bee54353d(to);
    }
    function getNextLocation(to, state) {
        if (state === void 0) state = null;
        return $c29d101a2cf08ade$var$readOnly((0, $97bc1202558212af$export$2e2bcd8739ae039)({
            pathname: location.pathname,
            search: '',
            hash: ''
        }, typeof to === 'string' ? $c29d101a2cf08ade$export$8ccf933b0513f8d0(to) : to, {
            state: state,
            key: $c29d101a2cf08ade$var$createKey()
        }));
    }
    function allowTx(action, location, retry) {
        return !blockers.length || (blockers.call({
            action: action,
            location: location,
            retry: retry
        }), false);
    }
    function applyTx(nextAction, nextLocation) {
        action = nextAction;
        location = nextLocation;
        listeners.call({
            action: action,
            location: location
        });
    }
    function push(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Push;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            push(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            applyTx(nextAction, nextLocation);
        }
    }
    function replace(to, state) {
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Replace;
        var nextLocation = getNextLocation(to, state);
        function retry() {
            replace(to, state);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            entries[index] = nextLocation;
            applyTx(nextAction, nextLocation);
        }
    }
    function go(delta) {
        var nextIndex = $c29d101a2cf08ade$var$clamp(index + delta, 0, entries.length - 1);
        var nextAction = $c29d101a2cf08ade$export$e19cd5f9376f8cee.Pop;
        var nextLocation = entries[nextIndex];
        function retry() {
            go(delta);
        }
        if (allowTx(nextAction, nextLocation, retry)) {
            index = nextIndex;
            applyTx(nextAction, nextLocation);
        }
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return location;
        },
        createHref: createHref,
        push: push,
        replace: replace,
        go: go,
        back: function back() {
            go(-1);
        },
        forward: function forward() {
            go(1);
        },
        listen: function listen(listener) {
            return listeners.push(listener);
        },
        block: function block(blocker) {
            return blockers.push(blocker);
        }
    };
    return history;
} ////////////////////////////////////////////////////////////////////////////////
// UTILS
////////////////////////////////////////////////////////////////////////////////
function $c29d101a2cf08ade$var$clamp(n, lowerBound, upperBound) {
    return Math.min(Math.max(n, lowerBound), upperBound);
}
function $c29d101a2cf08ade$var$promptBeforeUnload(event) {
    // Cancel the event.
    event.preventDefault(); // Chrome (and legacy IE) requires returnValue to be set.
    event.returnValue = '';
}
function $c29d101a2cf08ade$var$createEvents() {
    var handlers = [];
    return {
        get length () {
            return handlers.length;
        },
        push: function push(fn) {
            handlers.push(fn);
            return function() {
                handlers = handlers.filter(function(handler) {
                    return handler !== fn;
                });
            };
        },
        call: function call(arg) {
            handlers.forEach(function(fn) {
                return fn && fn(arg);
            });
        }
    };
}
function $c29d101a2cf08ade$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createpath
 */ function $c29d101a2cf08ade$export$fe53371bee54353d(_ref) {
    var _ref$pathname = _ref.pathname, pathname = _ref$pathname === void 0 ? '/' : _ref$pathname, _ref$search = _ref.search, search = _ref$search === void 0 ? '' : _ref$search, _ref$hash = _ref.hash, hash = _ref$hash === void 0 ? '' : _ref$hash;
    if (search && search !== '?') pathname += search.charAt(0) === '?' ? search : '?' + search;
    if (hash && hash !== '#') pathname += hash.charAt(0) === '#' ? hash : '#' + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#parsepath
 */ function $c29d101a2cf08ade$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf('#');
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf('?');
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}


var $ede9a19b7e4a528d$exports = {};
function $ede9a19b7e4a528d$var$_extends() {
    return $ede9a19b7e4a528d$exports = $ede9a19b7e4a528d$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $ede9a19b7e4a528d$exports.__esModule = true, $ede9a19b7e4a528d$exports["default"] = $ede9a19b7e4a528d$exports, $ede9a19b7e4a528d$var$_extends.apply(null, arguments);
}
$ede9a19b7e4a528d$exports = $ede9a19b7e4a528d$var$_extends, $ede9a19b7e4a528d$exports.__esModule = true, $ede9a19b7e4a528d$exports["default"] = $ede9a19b7e4a528d$exports;


var $184e64fa7279c0f0$exports = {};
var $f5a10e61d0aa9357$exports = {};
var $a6f3b7a9d572ec57$exports = {};
function $a6f3b7a9d572ec57$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $a6f3b7a9d572ec57$exports = $a6f3b7a9d572ec57$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $a6f3b7a9d572ec57$exports.__esModule = true, $a6f3b7a9d572ec57$exports["default"] = $a6f3b7a9d572ec57$exports, $a6f3b7a9d572ec57$var$_typeof(o);
}
$a6f3b7a9d572ec57$exports = $a6f3b7a9d572ec57$var$_typeof, $a6f3b7a9d572ec57$exports.__esModule = true, $a6f3b7a9d572ec57$exports["default"] = $a6f3b7a9d572ec57$exports;


var $f5a10e61d0aa9357$var$_typeof = $a6f3b7a9d572ec57$exports.default;
var $ca338d9498474816$exports = {};

var $ca338d9498474816$var$_typeof = $a6f3b7a9d572ec57$exports.default;
function $ca338d9498474816$var$toPrimitive(t, r) {
    if ("object" != $ca338d9498474816$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $ca338d9498474816$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
$ca338d9498474816$exports = $ca338d9498474816$var$toPrimitive, $ca338d9498474816$exports.__esModule = true, $ca338d9498474816$exports["default"] = $ca338d9498474816$exports;


function $f5a10e61d0aa9357$var$toPropertyKey(t) {
    var i = $ca338d9498474816$exports(t, "string");
    return "symbol" == $f5a10e61d0aa9357$var$_typeof(i) ? i : i + "";
}
$f5a10e61d0aa9357$exports = $f5a10e61d0aa9357$var$toPropertyKey, $f5a10e61d0aa9357$exports.__esModule = true, $f5a10e61d0aa9357$exports["default"] = $f5a10e61d0aa9357$exports;


function $184e64fa7279c0f0$var$_defineProperty(e, r, t) {
    return (r = $f5a10e61d0aa9357$exports(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
$184e64fa7279c0f0$exports = $184e64fa7279c0f0$var$_defineProperty, $184e64fa7279c0f0$exports.__esModule = true, $184e64fa7279c0f0$exports["default"] = $184e64fa7279c0f0$exports;




var $5FkrB = parcelRequire("5FkrB");


var $065a7de35543dd84$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ var $065a7de35543dd84$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $065a7de35543dd84$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $065a7de35543dd84$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $065a7de35543dd84$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $065a7de35543dd84$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $065a7de35543dd84$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $065a7de35543dd84$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $065a7de35543dd84$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $065a7de35543dd84$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $065a7de35543dd84$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $065a7de35543dd84$var$root = $065a7de35543dd84$var$freeGlobal || $065a7de35543dd84$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $065a7de35543dd84$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $065a7de35543dd84$var$objectToString = $065a7de35543dd84$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065a7de35543dd84$var$nativeMax = Math.max, $065a7de35543dd84$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $065a7de35543dd84$var$now = function() {
    return $065a7de35543dd84$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $065a7de35543dd84$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($065a7de35543dd84$var$FUNC_ERROR_TEXT);
    wait = $065a7de35543dd84$var$toNumber(wait) || 0;
    if ($065a7de35543dd84$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $065a7de35543dd84$var$nativeMax($065a7de35543dd84$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $065a7de35543dd84$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $065a7de35543dd84$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($065a7de35543dd84$var$now());
    }
    function debounced() {
        var time = $065a7de35543dd84$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $065a7de35543dd84$var$isObject(value) {
    var type = typeof value;
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $065a7de35543dd84$var$isObjectLike(value) {
    return !!value && typeof value == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $065a7de35543dd84$var$isSymbol(value) {
    return typeof value == 'symbol' || $065a7de35543dd84$var$isObjectLike(value) && $065a7de35543dd84$var$objectToString.call(value) == $065a7de35543dd84$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $065a7de35543dd84$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($065a7de35543dd84$var$isSymbol(value)) return $065a7de35543dd84$var$NAN;
    if ($065a7de35543dd84$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $065a7de35543dd84$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($065a7de35543dd84$var$reTrim, '');
    var isBinary = $065a7de35543dd84$var$reIsBinary.test(value);
    return isBinary || $065a7de35543dd84$var$reIsOctal.test(value) ? $065a7de35543dd84$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $065a7de35543dd84$var$reIsBadHex.test(value) ? $065a7de35543dd84$var$NAN : +value;
}
$065a7de35543dd84$exports = $065a7de35543dd84$var$debounce;


var $0ae6c8b81570b5e1$exports = {};
/**
 * lodash 3.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize include="noop" exports="npm" -o ./foo`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */ /**
 * A no-operation function that returns `undefined` regardless of the
 * arguments it receives.
 *
 * @static
 * @memberOf _
 * @category Util
 * @example
 *
 * var object = { 'user': 'fred' };
 *
 * _.noop(object) === undefined;
 * // => true
 */ function $0ae6c8b81570b5e1$var$noop() {
// No operation performed.
}
$0ae6c8b81570b5e1$exports = $0ae6c8b81570b5e1$var$noop;


const $9d4782ee5a008819$var$hasWindow = ()=>typeof window !== 'undefined';
const $9d4782ee5a008819$var$methodsPlaceholders = {
    push: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    listen: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports)))
};
const $9d4782ee5a008819$var$getLocation = ()=>{
    // todo - don't force non-optional search and hash
    const { pathname: pathname = '', search: search = '', hash: hash = '' } = $9d4782ee5a008819$var$hasWindow() && window.location || {};
    return {
        pathname: pathname,
        search: search,
        hash: hash
    };
};
const $9d4782ee5a008819$var$createLegacyListener = (updateExposedLocation)=>{
    const node = document.querySelector('#content');
    let prevHref = window.location.href;
    let listeners = [];
    const historyStack = [
        prevHref
    ];
    // note: window.history.length is capped at 50 entries
    let prevHistoryLength = window.history.length;
    let historyIndex = 0;
    const getAction = ()=>{
        const currentHref = window.location.href;
        if (prevHistoryLength === window.history.length) {
            if (historyStack[historyIndex - 1] === currentHref) {
                historyIndex -= 1;
                return 'POP';
            }
            if (historyStack[historyIndex + 1] === currentHref) {
                historyIndex += 1;
                return 'POP';
            }
            historyStack[historyStack.length - 1] = currentHref;
            return 'REPLACE';
        }
        historyStack.push(currentHref);
        historyIndex += 1;
        prevHistoryLength = window.history.length;
        return 'PUSH';
    };
    const onNodeChanges = (0, (/*@__PURE__*/$parcel$interopDefault($065a7de35543dd84$exports)))(()=>{
        if (prevHref !== window.location.href) {
            const newLocation = $9d4782ee5a008819$var$getLocation();
            const action = getAction();
            updateExposedLocation(newLocation, action);
            listeners.forEach((listener)=>listener(newLocation, action));
            prevHref = window.location.href;
        }
    }, 50);
    if (node) {
        const observer = new window.MutationObserver(onNodeChanges);
        observer.observe(node, {
            childList: true,
            subtree: true,
            attributes: true,
            characterData: true
        });
    }
    return (listener)=>{
        listeners = listeners.concat(listener);
        return ()=>{
            listeners = listeners.filter((lst)=>lst !== listener);
        };
    };
};
const $9d4782ee5a008819$export$883c3f3b6c000133 = ()=>{
    let currentLocation = $9d4782ee5a008819$var$getLocation();
    let currentAction = 'PUSH';
    const updateExposedLocation = (v, a)=>{
        currentLocation = v;
        currentAction = a;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        get location () {
            return currentLocation;
        },
        get length () {
            return $9d4782ee5a008819$var$hasWindow() ? window.history.length : 1; // default length is 1
        },
        get action () {
            return currentAction;
        }
    }, $9d4782ee5a008819$var$hasWindow() ? {
        push: (path)=>window.location.assign(typeof path === 'string' ? path : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(path || {})),
        replace: (path)=>window.history.replaceState({}, document.title, typeof path === 'string' ? path : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(path || {})),
        goBack: ()=>window.history.back(),
        goForward: ()=>window.history.forward(),
        listen: $9d4782ee5a008819$var$createLegacyListener(updateExposedLocation),
        block: ()=>(0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
        createHref: (location)=>(0, $c29d101a2cf08ade$export$fe53371bee54353d)(location)
    } : $9d4782ee5a008819$var$methodsPlaceholders);
};


/**
 * Tokenize input string.
 */ function $09142752f95cb46b$var$lexer(str) {
    var tokens = [];
    var i = 0;
    while(i < str.length){
        var char = str[i];
        if (char === "*" || char === "+" || char === "?") {
            tokens.push({
                type: "MODIFIER",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "\\") {
            tokens.push({
                type: "ESCAPED_CHAR",
                index: i++,
                value: str[i++]
            });
            continue;
        }
        if (char === "{") {
            tokens.push({
                type: "OPEN",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === "}") {
            tokens.push({
                type: "CLOSE",
                index: i,
                value: str[i++]
            });
            continue;
        }
        if (char === ":") {
            var name = "";
            var j = i + 1;
            while(j < str.length){
                var code = str.charCodeAt(j);
                if (// `0-9`
                code >= 48 && code <= 57 || // `A-Z`
                code >= 65 && code <= 90 || // `a-z`
                code >= 97 && code <= 122 || // `_`
                code === 95) {
                    name += str[j++];
                    continue;
                }
                break;
            }
            if (!name) throw new TypeError("Missing parameter name at ".concat(i));
            tokens.push({
                type: "NAME",
                index: i,
                value: name
            });
            i = j;
            continue;
        }
        if (char === "(") {
            var count = 1;
            var pattern = "";
            var j = i + 1;
            if (str[j] === "?") throw new TypeError("Pattern cannot start with \"?\" at ".concat(j));
            while(j < str.length){
                if (str[j] === "\\") {
                    pattern += str[j++] + str[j++];
                    continue;
                }
                if (str[j] === ")") {
                    count--;
                    if (count === 0) {
                        j++;
                        break;
                    }
                } else if (str[j] === "(") {
                    count++;
                    if (str[j + 1] !== "?") throw new TypeError("Capturing groups are not allowed at ".concat(j));
                }
                pattern += str[j++];
            }
            if (count) throw new TypeError("Unbalanced pattern at ".concat(i));
            if (!pattern) throw new TypeError("Missing pattern at ".concat(i));
            tokens.push({
                type: "PATTERN",
                index: i,
                value: pattern
            });
            i = j;
            continue;
        }
        tokens.push({
            type: "CHAR",
            index: i,
            value: str[i++]
        });
    }
    tokens.push({
        type: "END",
        index: i,
        value: ""
    });
    return tokens;
}
function $09142752f95cb46b$export$98e6a39c04603d36(str, options) {
    if (options === void 0) options = {};
    var tokens = $09142752f95cb46b$var$lexer(str);
    var _a = options.prefixes, prefixes = _a === void 0 ? "./" : _a, _b = options.delimiter, delimiter = _b === void 0 ? "/#?" : _b;
    var result = [];
    var key = 0;
    var i = 0;
    var path = "";
    var tryConsume = function(type) {
        if (i < tokens.length && tokens[i].type === type) return tokens[i++].value;
    };
    var mustConsume = function(type) {
        var value = tryConsume(type);
        if (value !== undefined) return value;
        var _a = tokens[i], nextType = _a.type, index = _a.index;
        throw new TypeError("Unexpected ".concat(nextType, " at ").concat(index, ", expected ").concat(type));
    };
    var consumeText = function() {
        var result = "";
        var value;
        while(value = tryConsume("CHAR") || tryConsume("ESCAPED_CHAR"))result += value;
        return result;
    };
    var isSafe = function(value) {
        for(var _i = 0, delimiter_1 = delimiter; _i < delimiter_1.length; _i++){
            var char = delimiter_1[_i];
            if (value.indexOf(char) > -1) return true;
        }
        return false;
    };
    var safePattern = function(prefix) {
        var prev = result[result.length - 1];
        var prevText = prefix || (prev && typeof prev === "string" ? prev : "");
        if (prev && !prevText) throw new TypeError("Must have text between two parameters, missing text after \"".concat(prev.name, "\""));
        if (!prevText || isSafe(prevText)) return "[^".concat($09142752f95cb46b$var$escapeString(delimiter), "]+?");
        return "(?:(?!".concat($09142752f95cb46b$var$escapeString(prevText), ")[^").concat($09142752f95cb46b$var$escapeString(delimiter), "])+?");
    };
    while(i < tokens.length){
        var char = tryConsume("CHAR");
        var name = tryConsume("NAME");
        var pattern = tryConsume("PATTERN");
        if (name || pattern) {
            var prefix = char || "";
            if (prefixes.indexOf(prefix) === -1) {
                path += prefix;
                prefix = "";
            }
            if (path) {
                result.push(path);
                path = "";
            }
            result.push({
                name: name || key++,
                prefix: prefix,
                suffix: "",
                pattern: pattern || safePattern(prefix),
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        var value = char || tryConsume("ESCAPED_CHAR");
        if (value) {
            path += value;
            continue;
        }
        if (path) {
            result.push(path);
            path = "";
        }
        var open = tryConsume("OPEN");
        if (open) {
            var prefix = consumeText();
            var name_1 = tryConsume("NAME") || "";
            var pattern_1 = tryConsume("PATTERN") || "";
            var suffix = consumeText();
            mustConsume("CLOSE");
            result.push({
                name: name_1 || (pattern_1 ? key++ : ""),
                pattern: name_1 && !pattern_1 ? safePattern(prefix) : pattern_1,
                prefix: prefix,
                suffix: suffix,
                modifier: tryConsume("MODIFIER") || ""
            });
            continue;
        }
        mustConsume("END");
    }
    return result;
}
function $09142752f95cb46b$export$ef7acd7185315e22(str, options) {
    return $09142752f95cb46b$export$5b9bad9e403cf3d9($09142752f95cb46b$export$98e6a39c04603d36(str, options), options);
}
function $09142752f95cb46b$export$5b9bad9e403cf3d9(tokens, options) {
    if (options === void 0) options = {};
    var reFlags = $09142752f95cb46b$var$flags(options);
    var _a = options.encode, encode = _a === void 0 ? function(x) {
        return x;
    } : _a, _b = options.validate, validate = _b === void 0 ? true : _b;
    // Compile all the tokens into regexps.
    var matches = tokens.map(function(token) {
        if (typeof token === "object") return new RegExp("^(?:".concat(token.pattern, ")$"), reFlags);
    });
    return function(data) {
        var path = "";
        for(var i = 0; i < tokens.length; i++){
            var token = tokens[i];
            if (typeof token === "string") {
                path += token;
                continue;
            }
            var value = data ? data[token.name] : undefined;
            var optional = token.modifier === "?" || token.modifier === "*";
            var repeat = token.modifier === "*" || token.modifier === "+";
            if (Array.isArray(value)) {
                if (!repeat) throw new TypeError("Expected \"".concat(token.name, "\" to not repeat, but got an array"));
                if (value.length === 0) {
                    if (optional) continue;
                    throw new TypeError("Expected \"".concat(token.name, "\" to not be empty"));
                }
                for(var j = 0; j < value.length; j++){
                    var segment = encode(value[j], token);
                    if (validate && !matches[i].test(segment)) throw new TypeError("Expected all \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                    path += token.prefix + segment + token.suffix;
                }
                continue;
            }
            if (typeof value === "string" || typeof value === "number") {
                var segment = encode(String(value), token);
                if (validate && !matches[i].test(segment)) throw new TypeError("Expected \"".concat(token.name, "\" to match \"").concat(token.pattern, "\", but got \"").concat(segment, "\""));
                path += token.prefix + segment + token.suffix;
                continue;
            }
            if (optional) continue;
            var typeOfMessage = repeat ? "an array" : "a string";
            throw new TypeError("Expected \"".concat(token.name, "\" to be ").concat(typeOfMessage));
        }
        return path;
    };
}
function $09142752f95cb46b$export$4659b591c19bdf3d(str, options) {
    var keys = [];
    var re = $09142752f95cb46b$export$71304158c7e35877(str, keys, options);
    return $09142752f95cb46b$export$968e97c88708237a(re, keys, options);
}
function $09142752f95cb46b$export$968e97c88708237a(re, keys, options) {
    if (options === void 0) options = {};
    var _a = options.decode, decode = _a === void 0 ? function(x) {
        return x;
    } : _a;
    return function(pathname) {
        var m = re.exec(pathname);
        if (!m) return false;
        var path = m[0], index = m.index;
        var params = Object.create(null);
        var _loop_1 = function(i) {
            if (m[i] === undefined) return "continue";
            var key = keys[i - 1];
            if (key.modifier === "*" || key.modifier === "+") params[key.name] = m[i].split(key.prefix + key.suffix).map(function(value) {
                return decode(value, key);
            });
            else params[key.name] = decode(m[i], key);
        };
        for(var i = 1; i < m.length; i++)_loop_1(i);
        return {
            path: path,
            index: index,
            params: params
        };
    };
}
/**
 * Escape a regular expression string.
 */ function $09142752f95cb46b$var$escapeString(str) {
    return str.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
/**
 * Get the flags for a regexp from the options.
 */ function $09142752f95cb46b$var$flags(options) {
    return options && options.sensitive ? "" : "i";
}
/**
 * Pull out keys from a regexp.
 */ function $09142752f95cb46b$var$regexpToRegexp(path, keys) {
    if (!keys) return path;
    var groupsRegex = /\((?:\?<(.*?)>)?(?!\?)/g;
    var index = 0;
    var execResult = groupsRegex.exec(path.source);
    while(execResult){
        keys.push({
            // Use parenthesized substring match if available, index otherwise
            name: execResult[1] || index++,
            prefix: "",
            suffix: "",
            modifier: "",
            pattern: ""
        });
        execResult = groupsRegex.exec(path.source);
    }
    return path;
}
/**
 * Transform an array into a regexp.
 */ function $09142752f95cb46b$var$arrayToRegexp(paths, keys, options) {
    var parts = paths.map(function(path) {
        return $09142752f95cb46b$export$71304158c7e35877(path, keys, options).source;
    });
    return new RegExp("(?:".concat(parts.join("|"), ")"), $09142752f95cb46b$var$flags(options));
}
/**
 * Create a path regexp from string input.
 */ function $09142752f95cb46b$var$stringToRegexp(path, keys, options) {
    return $09142752f95cb46b$export$9a9303716def6456($09142752f95cb46b$export$98e6a39c04603d36(path, options), keys, options);
}
function $09142752f95cb46b$export$9a9303716def6456(tokens, keys, options) {
    if (options === void 0) options = {};
    var _a = options.strict, strict = _a === void 0 ? false : _a, _b = options.start, start = _b === void 0 ? true : _b, _c = options.end, end = _c === void 0 ? true : _c, _d = options.encode, encode = _d === void 0 ? function(x) {
        return x;
    } : _d, _e = options.delimiter, delimiter = _e === void 0 ? "/#?" : _e, _f = options.endsWith, endsWith = _f === void 0 ? "" : _f;
    var endsWithRe = "[".concat($09142752f95cb46b$var$escapeString(endsWith), "]|$");
    var delimiterRe = "[".concat($09142752f95cb46b$var$escapeString(delimiter), "]");
    var route = start ? "^" : "";
    // Iterate over the tokens and create our regexp string.
    for(var _i = 0, tokens_1 = tokens; _i < tokens_1.length; _i++){
        var token = tokens_1[_i];
        if (typeof token === "string") route += $09142752f95cb46b$var$escapeString(encode(token));
        else {
            var prefix = $09142752f95cb46b$var$escapeString(encode(token.prefix));
            var suffix = $09142752f95cb46b$var$escapeString(encode(token.suffix));
            if (token.pattern) {
                if (keys) keys.push(token);
                if (prefix || suffix) {
                    if (token.modifier === "+" || token.modifier === "*") {
                        var mod = token.modifier === "*" ? "?" : "";
                        route += "(?:".concat(prefix, "((?:").concat(token.pattern, ")(?:").concat(suffix).concat(prefix, "(?:").concat(token.pattern, "))*)").concat(suffix, ")").concat(mod);
                    } else route += "(?:".concat(prefix, "(").concat(token.pattern, ")").concat(suffix, ")").concat(token.modifier);
                } else {
                    if (token.modifier === "+" || token.modifier === "*") throw new TypeError("Can not repeat \"".concat(token.name, "\" without a prefix and suffix"));
                    route += "(".concat(token.pattern, ")").concat(token.modifier);
                }
            } else route += "(?:".concat(prefix).concat(suffix, ")").concat(token.modifier);
        }
    }
    if (end) {
        if (!strict) route += "".concat(delimiterRe, "?");
        route += !options.endsWith ? "$" : "(?=".concat(endsWithRe, ")");
    } else {
        var endToken = tokens[tokens.length - 1];
        var isEndDelimited = typeof endToken === "string" ? delimiterRe.indexOf(endToken[endToken.length - 1]) > -1 : endToken === undefined;
        if (!strict) route += "(?:".concat(delimiterRe, "(?=").concat(endsWithRe, "))?");
        if (!isEndDelimited) route += "(?=".concat(delimiterRe, "|").concat(endsWithRe, ")");
    }
    return new RegExp(route, $09142752f95cb46b$var$flags(options));
}
function $09142752f95cb46b$export$71304158c7e35877(path, keys, options) {
    if (path instanceof RegExp) return $09142752f95cb46b$var$regexpToRegexp(path, keys);
    if (Array.isArray(path)) return $09142752f95cb46b$var$arrayToRegexp(path, keys, options);
    return $09142752f95cb46b$var$stringToRegexp(path, keys, options);
}


var $deb424f7a075f200$exports = {};
'use strict';
var $5654768c7acee223$exports = {};
'use strict';
/**
 * Check if we're required to add a port number.
 *
 * @see https://url.spec.whatwg.org/#default-port
 * @param {Number|String} port Port number we need to check
 * @param {String} protocol Protocol we need to check against.
 * @returns {Boolean} Is it a default port for the given protocol
 * @api private
 */ $5654768c7acee223$exports = function required(port, protocol) {
    protocol = protocol.split(':')[0];
    port = +port;
    if (!port) return false;
    switch(protocol){
        case 'http':
        case 'ws':
            return port !== 80;
        case 'https':
        case 'wss':
            return port !== 443;
        case 'ftp':
            return port !== 21;
        case 'gopher':
            return port !== 70;
        case 'file':
            return false;
    }
    return port !== 0;
};


var $3092e7c4432aeccb$exports = {};
$parcel$export($3092e7c4432aeccb$exports, "stringify", () => $3092e7c4432aeccb$export$fac44ee5b035f737, (v) => $3092e7c4432aeccb$export$fac44ee5b035f737 = v);
$parcel$export($3092e7c4432aeccb$exports, "parse", () => $3092e7c4432aeccb$export$98e6a39c04603d36, (v) => $3092e7c4432aeccb$export$98e6a39c04603d36 = v);
//
// Expose the module.
//
var $3092e7c4432aeccb$export$fac44ee5b035f737;
var $3092e7c4432aeccb$export$98e6a39c04603d36;
'use strict';
var $3092e7c4432aeccb$var$has = Object.prototype.hasOwnProperty, $3092e7c4432aeccb$var$undef;
/**
 * Decode a URI encoded string.
 *
 * @param {String} input The URI encoded string.
 * @returns {String|Null} The decoded string.
 * @api private
 */ function $3092e7c4432aeccb$var$decode(input) {
    try {
        return decodeURIComponent(input.replace(/\+/g, ' '));
    } catch (e) {
        return null;
    }
}
/**
 * Attempts to encode a given input.
 *
 * @param {String} input The string that needs to be encoded.
 * @returns {String|Null} The encoded string.
 * @api private
 */ function $3092e7c4432aeccb$var$encode(input) {
    try {
        return encodeURIComponent(input);
    } catch (e) {
        return null;
    }
}
/**
 * Simple query string parser.
 *
 * @param {String} query The query string that needs to be parsed.
 * @returns {Object}
 * @api public
 */ function $3092e7c4432aeccb$var$querystring(query) {
    var parser = /([^=?#&]+)=?([^&]*)/g, result = {}, part;
    while(part = parser.exec(query)){
        var key = $3092e7c4432aeccb$var$decode(part[1]), value = $3092e7c4432aeccb$var$decode(part[2]);
        //
        // Prevent overriding of existing properties. This ensures that build-in
        // methods like `toString` or __proto__ are not overriden by malicious
        // querystrings.
        //
        // In the case if failed decoding, we want to omit the key/value pairs
        // from the result.
        //
        if (key === null || value === null || key in result) continue;
        result[key] = value;
    }
    return result;
}
/**
 * Transform a query string to an object.
 *
 * @param {Object} obj Object that should be transformed.
 * @param {String} prefix Optional prefix.
 * @returns {String}
 * @api public
 */ function $3092e7c4432aeccb$var$querystringify(obj, prefix) {
    prefix = prefix || '';
    var pairs = [], value, key;
    //
    // Optionally prefix with a '?' if needed
    //
    if ('string' !== typeof prefix) prefix = '?';
    for(key in obj)if ($3092e7c4432aeccb$var$has.call(obj, key)) {
        value = obj[key];
        //
        // Edge cases where we actually want to encode the value to an empty
        // string instead of the stringified value.
        //
        if (!value && (value === null || value === $3092e7c4432aeccb$var$undef || isNaN(value))) value = '';
        key = $3092e7c4432aeccb$var$encode(key);
        value = $3092e7c4432aeccb$var$encode(value);
        //
        // If we failed to encode the strings, we should bail out as we don't
        // want to add invalid strings to the query.
        //
        if (key === null || value === null) continue;
        pairs.push(key + '=' + value);
    }
    return pairs.length ? prefix + pairs.join('&') : '';
}
$3092e7c4432aeccb$export$fac44ee5b035f737 = $3092e7c4432aeccb$var$querystringify;
$3092e7c4432aeccb$export$98e6a39c04603d36 = $3092e7c4432aeccb$var$querystring;


var $deb424f7a075f200$var$controlOrWhitespace = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, $deb424f7a075f200$var$CRHTLF = /[\n\r\t]/g, $deb424f7a075f200$var$slashes = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, $deb424f7a075f200$var$port = /:\d+$/, $deb424f7a075f200$var$protocolre = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, $deb424f7a075f200$var$windowsDriveLetter = /^[a-zA-Z]:/;
/**
 * Remove control characters and whitespace from the beginning of a string.
 *
 * @param {Object|String} str String to trim.
 * @returns {String} A new string representing `str` stripped of control
 *     characters and whitespace from its beginning.
 * @public
 */ function $deb424f7a075f200$var$trimLeft(str) {
    return (str ? str : '').toString().replace($deb424f7a075f200$var$controlOrWhitespace, '');
}
/**
 * These are the parse rules for the URL parser, it informs the parser
 * about:
 *
 * 0. The char it Needs to parse, if it's a string it should be done using
 *    indexOf, RegExp using exec and NaN means set as current value.
 * 1. The property we should set when parsing this value.
 * 2. Indication if it's backwards or forward parsing, when set as number it's
 *    the value of extra chars that should be split off.
 * 3. Inherit from location if non existing in the parser.
 * 4. `toLowerCase` the resulting value.
 */ var $deb424f7a075f200$var$rules = [
    [
        '#',
        'hash'
    ],
    [
        '?',
        'query'
    ],
    function sanitize(address, url) {
        return $deb424f7a075f200$var$isSpecial(url.protocol) ? address.replace(/\\/g, '/') : address;
    },
    [
        '/',
        'pathname'
    ],
    [
        '@',
        'auth',
        1
    ],
    [
        NaN,
        'host',
        undefined,
        1,
        1
    ],
    [
        /:(\d*)$/,
        'port',
        undefined,
        1
    ],
    [
        NaN,
        'hostname',
        undefined,
        1,
        1
    ] // Set left over.
];
/**
 * These properties should not be copied or inherited from. This is only needed
 * for all non blob URL's as a blob URL does not include a hash, only the
 * origin.
 *
 * @type {Object}
 * @private
 */ var $deb424f7a075f200$var$ignore = {
    hash: 1,
    query: 1
};
/**
 * The location object differs when your code is loaded through a normal page,
 * Worker or through a worker using a blob. And with the blobble begins the
 * trouble as the location object will contain the URL of the blob, not the
 * location of the page where our code is loaded in. The actual origin is
 * encoded in the `pathname` so we can thankfully generate a good "default"
 * location from it so we can generate proper relative URL's again.
 *
 * @param {Object|String} loc Optional default location object.
 * @returns {Object} lolcation object.
 * @public
 */ function $deb424f7a075f200$var$lolcation(loc) {
    var globalVar;
    if (typeof window !== 'undefined') globalVar = window;
    else if (typeof $parcel$global !== 'undefined') globalVar = $parcel$global;
    else if (typeof self !== 'undefined') globalVar = self;
    else globalVar = {};
    var location = globalVar.location || {};
    loc = loc || location;
    var finaldestination = {}, type = typeof loc, key;
    if ('blob:' === loc.protocol) finaldestination = new $deb424f7a075f200$var$Url(unescape(loc.pathname), {});
    else if ('string' === type) {
        finaldestination = new $deb424f7a075f200$var$Url(loc, {});
        for(key in $deb424f7a075f200$var$ignore)delete finaldestination[key];
    } else if ('object' === type) {
        for(key in loc){
            if (key in $deb424f7a075f200$var$ignore) continue;
            finaldestination[key] = loc[key];
        }
        if (finaldestination.slashes === undefined) finaldestination.slashes = $deb424f7a075f200$var$slashes.test(loc.href);
    }
    return finaldestination;
}
/**
 * Check whether a protocol scheme is special.
 *
 * @param {String} The protocol scheme of the URL
 * @return {Boolean} `true` if the protocol scheme is special, else `false`
 * @private
 */ function $deb424f7a075f200$var$isSpecial(scheme) {
    return scheme === 'file:' || scheme === 'ftp:' || scheme === 'http:' || scheme === 'https:' || scheme === 'ws:' || scheme === 'wss:';
}
/**
 * @typedef ProtocolExtract
 * @type Object
 * @property {String} protocol Protocol matched in the URL, in lowercase.
 * @property {Boolean} slashes `true` if protocol is followed by "//", else `false`.
 * @property {String} rest Rest of the URL that is not part of the protocol.
 */ /**
 * Extract protocol information from a URL with/without double slash ("//").
 *
 * @param {String} address URL we want to extract from.
 * @param {Object} location
 * @return {ProtocolExtract} Extracted information.
 * @private
 */ function $deb424f7a075f200$var$extractProtocol(address, location) {
    address = $deb424f7a075f200$var$trimLeft(address);
    address = address.replace($deb424f7a075f200$var$CRHTLF, '');
    location = location || {};
    var match = $deb424f7a075f200$var$protocolre.exec(address);
    var protocol = match[1] ? match[1].toLowerCase() : '';
    var forwardSlashes = !!match[2];
    var otherSlashes = !!match[3];
    var slashesCount = 0;
    var rest;
    if (forwardSlashes) {
        if (otherSlashes) {
            rest = match[2] + match[3] + match[4];
            slashesCount = match[2].length + match[3].length;
        } else {
            rest = match[2] + match[4];
            slashesCount = match[2].length;
        }
    } else if (otherSlashes) {
        rest = match[3] + match[4];
        slashesCount = match[3].length;
    } else rest = match[4];
    if (protocol === 'file:') {
        if (slashesCount >= 2) rest = rest.slice(2);
    } else if ($deb424f7a075f200$var$isSpecial(protocol)) rest = match[4];
    else if (protocol) {
        if (forwardSlashes) rest = rest.slice(2);
    } else if (slashesCount >= 2 && $deb424f7a075f200$var$isSpecial(location.protocol)) rest = match[4];
    return {
        protocol: protocol,
        slashes: forwardSlashes || $deb424f7a075f200$var$isSpecial(protocol),
        slashesCount: slashesCount,
        rest: rest
    };
}
/**
 * Resolve a relative URL pathname against a base URL pathname.
 *
 * @param {String} relative Pathname of the relative URL.
 * @param {String} base Pathname of the base URL.
 * @return {String} Resolved pathname.
 * @private
 */ function $deb424f7a075f200$var$resolve(relative, base) {
    if (relative === '') return base;
    var path = (base || '/').split('/').slice(0, -1).concat(relative.split('/')), i = path.length, last = path[i - 1], unshift = false, up = 0;
    while(i--){
        if (path[i] === '.') path.splice(i, 1);
        else if (path[i] === '..') {
            path.splice(i, 1);
            up++;
        } else if (up) {
            if (i === 0) unshift = true;
            path.splice(i, 1);
            up--;
        }
    }
    if (unshift) path.unshift('');
    if (last === '.' || last === '..') path.push('');
    return path.join('/');
}
/**
 * The actual URL instance. Instead of returning an object we've opted-in to
 * create an actual constructor as it's much more memory efficient and
 * faster and it pleases my OCD.
 *
 * It is worth noting that we should not use `URL` as class name to prevent
 * clashes with the global URL instance that got introduced in browsers.
 *
 * @constructor
 * @param {String} address URL we want to parse.
 * @param {Object|String} [location] Location defaults for relative paths.
 * @param {Boolean|Function} [parser] Parser for the query string.
 * @private
 */ function $deb424f7a075f200$var$Url(address, location, parser) {
    address = $deb424f7a075f200$var$trimLeft(address);
    address = address.replace($deb424f7a075f200$var$CRHTLF, '');
    if (!(this instanceof $deb424f7a075f200$var$Url)) return new $deb424f7a075f200$var$Url(address, location, parser);
    var relative, extracted, parse, instruction, index, key, instructions = $deb424f7a075f200$var$rules.slice(), type = typeof location, url = this, i = 0;
    //
    // The following if statements allows this module two have compatibility with
    // 2 different API:
    //
    // 1. Node.js's `url.parse` api which accepts a URL, boolean as arguments
    //    where the boolean indicates that the query string should also be parsed.
    //
    // 2. The `URL` interface of the browser which accepts a URL, object as
    //    arguments. The supplied object will be used as default values / fall-back
    //    for relative paths.
    //
    if ('object' !== type && 'string' !== type) {
        parser = location;
        location = null;
    }
    if (parser && 'function' !== typeof parser) parser = $3092e7c4432aeccb$exports.parse;
    location = $deb424f7a075f200$var$lolcation(location);
    //
    // Extract protocol information before running the instructions.
    //
    extracted = $deb424f7a075f200$var$extractProtocol(address || '', location);
    relative = !extracted.protocol && !extracted.slashes;
    url.slashes = extracted.slashes || relative && location.slashes;
    url.protocol = extracted.protocol || location.protocol || '';
    address = extracted.rest;
    //
    // When the authority component is absent the URL starts with a path
    // component.
    //
    if (extracted.protocol === 'file:' && (extracted.slashesCount !== 2 || $deb424f7a075f200$var$windowsDriveLetter.test(address)) || !extracted.slashes && (extracted.protocol || extracted.slashesCount < 2 || !$deb424f7a075f200$var$isSpecial(url.protocol))) instructions[3] = [
        /(.*)/,
        'pathname'
    ];
    for(; i < instructions.length; i++){
        instruction = instructions[i];
        if (typeof instruction === 'function') {
            address = instruction(address, url);
            continue;
        }
        parse = instruction[0];
        key = instruction[1];
        if (parse !== parse) url[key] = address;
        else if ('string' === typeof parse) {
            index = parse === '@' ? address.lastIndexOf(parse) : address.indexOf(parse);
            if (~index) {
                if ('number' === typeof instruction[2]) {
                    url[key] = address.slice(0, index);
                    address = address.slice(index + instruction[2]);
                } else {
                    url[key] = address.slice(index);
                    address = address.slice(0, index);
                }
            }
        } else if (index = parse.exec(address)) {
            url[key] = index[1];
            address = address.slice(0, index.index);
        }
        url[key] = url[key] || (relative && instruction[3] ? location[key] || '' : '');
        //
        // Hostname, host and protocol should be lowercased so they can be used to
        // create a proper `origin`.
        //
        if (instruction[4]) url[key] = url[key].toLowerCase();
    }
    //
    // Also parse the supplied query string in to an object. If we're supplied
    // with a custom parser as function use that instead of the default build-in
    // parser.
    //
    if (parser) url.query = parser(url.query);
    //
    // If the URL is relative, resolve the pathname against the base URL.
    //
    if (relative && location.slashes && url.pathname.charAt(0) !== '/' && (url.pathname !== '' || location.pathname !== '')) url.pathname = $deb424f7a075f200$var$resolve(url.pathname, location.pathname);
    //
    // Default to a / for pathname if none exists. This normalizes the URL
    // to always have a /
    //
    if (url.pathname.charAt(0) !== '/' && $deb424f7a075f200$var$isSpecial(url.protocol)) url.pathname = '/' + url.pathname;
    //
    // We should not add port numbers if they are already the default port number
    // for a given protocol. As the host also contains the port number we're going
    // override it with the hostname which contains no port number.
    //
    if (!$5654768c7acee223$exports(url.port, url.protocol)) {
        url.host = url.hostname;
        url.port = '';
    }
    //
    // Parse down the `auth` for the username and password.
    //
    url.username = url.password = '';
    if (url.auth) {
        index = url.auth.indexOf(':');
        if (~index) {
            url.username = url.auth.slice(0, index);
            url.username = encodeURIComponent(decodeURIComponent(url.username));
            url.password = url.auth.slice(index + 1);
            url.password = encodeURIComponent(decodeURIComponent(url.password));
        } else url.username = encodeURIComponent(decodeURIComponent(url.auth));
        url.auth = url.password ? url.username + ':' + url.password : url.username;
    }
    url.origin = url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    //
    // The href is just the compiled result.
    //
    url.href = url.toString();
}
/**
 * This is convenience method for changing properties in the URL instance to
 * insure that they all propagate correctly.
 *
 * @param {String} part          Property we need to adjust.
 * @param {Mixed} value          The newly assigned value.
 * @param {Boolean|Function} fn  When setting the query, it will be the function
 *                               used to parse the query.
 *                               When setting the protocol, double slash will be
 *                               removed from the final url if it is true.
 * @returns {URL} URL instance for chaining.
 * @public
 */ function $deb424f7a075f200$var$set(part, value, fn) {
    var url = this;
    switch(part){
        case 'query':
            if ('string' === typeof value && value.length) value = (fn || $3092e7c4432aeccb$exports.parse)(value);
            url[part] = value;
            break;
        case 'port':
            url[part] = value;
            if (!$5654768c7acee223$exports(value, url.protocol)) {
                url.host = url.hostname;
                url[part] = '';
            } else if (value) url.host = url.hostname + ':' + value;
            break;
        case 'hostname':
            url[part] = value;
            if (url.port) value += ':' + url.port;
            url.host = value;
            break;
        case 'host':
            url[part] = value;
            if ($deb424f7a075f200$var$port.test(value)) {
                value = value.split(':');
                url.port = value.pop();
                url.hostname = value.join(':');
            } else {
                url.hostname = value;
                url.port = '';
            }
            break;
        case 'protocol':
            url.protocol = value.toLowerCase();
            url.slashes = !fn;
            break;
        case 'pathname':
        case 'hash':
            if (value) {
                var char = part === 'pathname' ? '/' : '#';
                url[part] = value.charAt(0) !== char ? char + value : value;
            } else url[part] = value;
            break;
        case 'username':
        case 'password':
            url[part] = encodeURIComponent(value);
            break;
        case 'auth':
            var index = value.indexOf(':');
            if (~index) {
                url.username = value.slice(0, index);
                url.username = encodeURIComponent(decodeURIComponent(url.username));
                url.password = value.slice(index + 1);
                url.password = encodeURIComponent(decodeURIComponent(url.password));
            } else url.username = encodeURIComponent(decodeURIComponent(value));
    }
    for(var i = 0; i < $deb424f7a075f200$var$rules.length; i++){
        var ins = $deb424f7a075f200$var$rules[i];
        if (ins[4]) url[ins[1]] = url[ins[1]].toLowerCase();
    }
    url.auth = url.password ? url.username + ':' + url.password : url.username;
    url.origin = url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && url.host ? url.protocol + '//' + url.host : 'null';
    url.href = url.toString();
    return url;
}
/**
 * Transform the properties back in to a valid and full URL string.
 *
 * @param {Function} stringify Optional query stringify function.
 * @returns {String} Compiled version of the URL.
 * @public
 */ function $deb424f7a075f200$var$toString(stringify) {
    if (!stringify || 'function' !== typeof stringify) stringify = $3092e7c4432aeccb$exports.stringify;
    var query, url = this, host = url.host, protocol = url.protocol;
    if (protocol && protocol.charAt(protocol.length - 1) !== ':') protocol += ':';
    var result = protocol + (url.protocol && url.slashes || $deb424f7a075f200$var$isSpecial(url.protocol) ? '//' : '');
    if (url.username) {
        result += url.username;
        if (url.password) result += ':' + url.password;
        result += '@';
    } else if (url.password) {
        result += ':' + url.password;
        result += '@';
    } else if (url.protocol !== 'file:' && $deb424f7a075f200$var$isSpecial(url.protocol) && !host && url.pathname !== '/') //
    // Add back the empty userinfo, otherwise the original invalid URL
    // might be transformed into a valid one with `url.pathname` as host.
    //
    result += '@';
    //
    // Trailing colon is removed from `url.host` when it is parsed. If it still
    // ends with a colon, then add back the trailing colon that was removed. This
    // prevents an invalid URL from being transformed into a valid one.
    //
    if (host[host.length - 1] === ':' || $deb424f7a075f200$var$port.test(url.hostname) && !url.port) host += ':';
    result += host + url.pathname;
    query = 'object' === typeof url.query ? stringify(url.query) : url.query;
    if (query) result += '?' !== query.charAt(0) ? '?' + query : query;
    if (url.hash) result += url.hash;
    return result;
}
$deb424f7a075f200$var$Url.prototype = {
    set: $deb424f7a075f200$var$set,
    toString: $deb424f7a075f200$var$toString
};
//
// Expose the URL parser and some additional properties that might be useful for
// others or testing.
//
$deb424f7a075f200$var$Url.extractProtocol = $deb424f7a075f200$var$extractProtocol;
$deb424f7a075f200$var$Url.location = $deb424f7a075f200$var$lolcation;
$deb424f7a075f200$var$Url.trimLeft = $deb424f7a075f200$var$trimLeft;
$deb424f7a075f200$var$Url.qs = $3092e7c4432aeccb$exports;
$deb424f7a075f200$exports = $deb424f7a075f200$var$Url;


function $768d36b334678dfa$export$37e0729cc751960b(pattern = '/', options = {}) {
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $deb424f7a075f200$exports.qs).stringify(query, true);
    const pathname = pattern === '/' ? pattern : (0, $09142752f95cb46b$export$ef7acd7185315e22)(pattern)(params);
    return {
        pathname: `${basePath}${pathname}`,
        search: stringifiedQuery,
        hash: ''
    };
}



const $de4d1e4f61a87867$export$82476f982757e71e = (pattern = '/', params)=>pattern === '/' ? pattern : (0, $09142752f95cb46b$export$ef7acd7185315e22)(pattern)(params);


/**
 * @see https://github.com/jsdom/jsdom/releases/tag/12.0.0
 * @see https://github.com/jsdom/jsdom/issues/1537
 */ 
var $3ZMUU = parcelRequire("3ZMUU");
const $f9f42a63082f8b8d$var$isJsDomEnvironment = ()=>{
    var _navigator, _navigator2;
    return window.name === 'nodejs' || ((_navigator = navigator) == null ? void 0 : _navigator.userAgent.includes('Node.js')) || ((_navigator2 = navigator) == null ? void 0 : _navigator2.userAgent.includes('jsdom'));
};
const $f9f42a63082f8b8d$export$455cc18296abe008 = ()=>{
    if (typeof window === 'undefined' || typeof $3ZMUU !== 'undefined' && $3ZMUU.versions != null && $3ZMUU.versions.node != null) return true;
    if ($f9f42a63082f8b8d$var$isJsDomEnvironment()) return true;
    return false;
};




// TAKEN FROM https://github.com/ReactTraining/react-router/blob/master/packages/react-router/modules/matchPath.js

const $e7a9aee364b5805f$var$cache = {};
const $e7a9aee364b5805f$var$cacheLimit = 10000;
let $e7a9aee364b5805f$var$cacheCount = 0;
function $e7a9aee364b5805f$var$compilePath(path, options) {
    const cacheKey = `${options.end}${options.strict}${options.sensitive}`;
    const pathCache = $e7a9aee364b5805f$var$cache[cacheKey] || ($e7a9aee364b5805f$var$cache[cacheKey] = {});
    if (pathCache[path]) return pathCache[path];
    const keys = [];
    const regexp = (0, $09142752f95cb46b$export$71304158c7e35877)(path, keys, options);
    const result = {
        regexp: regexp,
        keys: keys
    };
    if ($e7a9aee364b5805f$var$cacheCount < $e7a9aee364b5805f$var$cacheLimit) {
        pathCache[path] = result;
        $e7a9aee364b5805f$var$cacheCount++;
    }
    return result;
}
/**
 * Public API for matching a URL pathname to a path.
 * TODO: reduce returns Array<never>
 */ function $e7a9aee364b5805f$var$matchPath(pathname, options = {}) {
    if (typeof options === 'string' || Array.isArray(options)) options = {
        path: options
    };
    const { path: p, exact: exact = false, strict: strict = false, sensitive: sensitive = false, basePath: basePath = '' } = options;
    const paths = [].concat(basePath + p);
    return paths.reduce((matched, path)=>{
        if (!path && path !== '') return null;
        if (matched) return matched;
        const { regexp: regexp, keys: keys } = $e7a9aee364b5805f$var$compilePath(path, {
            end: exact,
            strict: strict,
            sensitive: sensitive
        });
        const match = regexp.exec(pathname);
        if (!match) return null;
        const [url, ...values] = match;
        const isExact = pathname === url;
        if (exact && !isExact) return null;
        return {
            path: path,
            // the path used to match
            url: path === '/' && url === '' ? '/' : url,
            isExact: // the matched portion of the URL
            isExact,
            // whether or not we matched exactly
            params: keys.reduce((memo, key, index)=>{
                memo[key.name] = values[index];
                return memo;
            }, {})
        };
    }, null);
}
var $e7a9aee364b5805f$export$2e2bcd8739ae039 = $e7a9aee364b5805f$var$matchPath;



/**
 * Matches `queryStr` against config stored in `queryConfig`.
 *
 * Returns `pathMatch` with an additional query prop with query params if the match succeeds,
 * otherwise returns null.
 *
 */ function $3dd31f20fffa4bf7$var$matchQuery(queryConfig, queryParams, pathMatch) {
    const queryMatch = {};
    const isMatchingQuery = queryConfig.every((query)=>{
        // eslint-disable-next-line prefer-const
        let [names, value] = query.split('=');
        let negation = false;
        /* Check if negative matching query param (eg 'foo!=1') */ if (query.includes('!=')) {
            names = names.substring(0, names.length - 1);
            negation = true;
        }
        /* Allow alternate query params presence (eg 'foo|bar') */ const matched = names.split('|').map((name)=>{
            let isOptional = false;
            /* Check if optional query param (eg 'foo?') */ if (name.includes('?')) {
                // eslint-disable-next-line no-param-reassign
                name = name.substring(0, name.length - 1);
                isOptional = true;
            }
            /* First check if queryParams contains the relevant param */ let match = Object.prototype.hasOwnProperty.call(queryParams, name);
            /* Save actual value so we expose it as part of match object */ if (match) queryMatch[name] = queryParams[name] || '';
            /* If no value matching required or it is optional and the param is missing */ if (!value || isOptional && !match) return isOptional || match;
            if (value.startsWith('(')) /* Handle value being a regexp eg 's=(\\d+)' */ match = new RegExp(`^${value}$`).test(queryParams[name] || '');
            else /* Handle value exact matching eg 's=123' */ match = queryParams[name] === value;
            return negation ? !match : match;
        });
        /* If at least one of alternate query params matches then it is a match */ return matched.includes(true);
    });
    return isMatchingQuery ? (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, pathMatch, {
        query: queryMatch
    }) : null;
}
var $3dd31f20fffa4bf7$export$2e2bcd8739ae039 = $3dd31f20fffa4bf7$var$matchQuery;


/* This should match what react-router does to compute a root match. */ const $f9b6403fcc99d44d$var$computeRootMatch = (pathname)=>({
        path: '/',
        url: '/',
        params: {},
        isExact: pathname === '/',
        query: {}
    });
function $f9b6403fcc99d44d$var$execRouteMatching(route, pathname, queryObj, basePath) {
    const pathMatch = route.path ? (0, $e7a9aee364b5805f$export$2e2bcd8739ae039)(pathname, {
        path: route.path,
        exact: route.exact,
        basePath: basePath
    }) : $f9b6403fcc99d44d$var$computeRootMatch(pathname);
    let match = pathMatch;
    if (pathMatch && route.query) match = (0, $3dd31f20fffa4bf7$export$2e2bcd8739ae039)(route.query, queryObj, pathMatch);
    else if (pathMatch) match = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, pathMatch, {
        query: {}
    });
    if (match) return {
        match: match,
        route: route
    };
    return null;
}
var $f9b6403fcc99d44d$export$2e2bcd8739ae039 = $f9b6403fcc99d44d$var$execRouteMatching;


const $5945d60cd4066b5d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $5945d60cd4066b5d$var$MAX_CACHE_SIZE = 1000;
function $5945d60cd4066b5d$var$shallowEqual(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    // Test for A's keys different from B.
    for(let i = 0; i < keysA.length; i++){
        if (!$5945d60cd4066b5d$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
    }
    return true;
}
const $5945d60cd4066b5d$export$f594abf16a5ad948 = {
    cache: new Map(),
    get (pathname, queryObj, basePath) {
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) for (const [key, value] of pathCache){
            if ($5945d60cd4066b5d$var$shallowEqual(key, queryObj)) return value;
        }
    },
    set (pathname, queryObj, basePath, matchRoute) {
        if (this.cache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE) this.cache.clear();
        const pathCache = this.cache.get(basePath + pathname);
        if (pathCache) {
            if (pathCache.size > $5945d60cd4066b5d$var$MAX_CACHE_SIZE / 10) pathCache.clear();
            pathCache.set(queryObj, matchRoute);
        } else this.cache.set(basePath + pathname, new Map([
            [
                queryObj,
                matchRoute
            ]
        ]));
    }
};


/**
 * Does the given `pathname` and `queryStr` match a route in `routes`.
 *
 * Heavily based on https://github.com/ReactTraining/react-router/blob/master/packages/react-router-config/modules/matchRoute.js
 *
 * Note: This does not support nested routes at this stage.
 */ const $e7f860d2e0e9373c$var$matchRoute = (routes, pathname, queryParams = {}, basePath = '')=>{
    const queryParamObject = typeof queryParams === 'string' ? (0, $deb424f7a075f200$exports.qs).parse(queryParams) : queryParams;
    const cachedMatch = (0, $5945d60cd4066b5d$export$f594abf16a5ad948).get(pathname, queryParamObject, basePath);
    if (cachedMatch && routes.includes(cachedMatch.route)) return cachedMatch;
    for(let i = 0; i < routes.length; i++){
        const matchedRoute = (0, $f9b6403fcc99d44d$export$2e2bcd8739ae039)(routes[i], pathname, queryParamObject, basePath);
        if (matchedRoute) {
            (0, $5945d60cd4066b5d$export$f594abf16a5ad948).set(pathname, queryParamObject, basePath, matchedRoute);
            return matchedRoute;
        }
    }
    return null;
};
const $e7f860d2e0e9373c$export$ce5b73cebfeaa567 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);
const $e7f860d2e0e9373c$export$4e76f1d455ef7c95 = (route, pathname, queryParams, basePath = '')=>{
    $e7f860d2e0e9373c$var$matchRoute([
        route
    ], pathname, queryParams, basePath);
};
var $e7f860d2e0e9373c$export$2e2bcd8739ae039 = (routes, pathname, queryParams, basePath = '')=>$e7f860d2e0e9373c$var$matchRoute(routes, pathname, queryParams, basePath);





const $0100e5f4b4767f2b$export$7c22f8f9552f689e = {
    pathname: '',
    search: '',
    hash: ''
};
const $0100e5f4b4767f2b$export$2de13e891a662beb = {
    params: {},
    isExact: false,
    path: '',
    url: '',
    query: {}
};
const $0100e5f4b4767f2b$export$4eadc79233226325 = {
    path: '',
    component: ()=>null,
    name: ''
};
const $0100e5f4b4767f2b$export$39607c9878cf5148 = (0, $9d4782ee5a008819$export$883c3f3b6c000133)();
const $0100e5f4b4767f2b$export$1515254c8c90bebb = {
    location: $0100e5f4b4767f2b$export$7c22f8f9552f689e,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goBack: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    goForward: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    listen: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    block: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports))),
    createHref: (0, (/*@__PURE__*/$parcel$interopDefault($0ae6c8b81570b5e1$exports)))
};
const $0100e5f4b4767f2b$export$fa440ddf675c8a93 = 'POP';




const $10a8bc47d57825ec$export$faed15f35ddc6f99 = (route, options = {})=>{
    const { params: params = {}, query: query = {}, basePath: basePath = '' } = options;
    const pathname = (0, $de4d1e4f61a87867$export$82476f982757e71e)(route.path, params);
    const matchedRoute = (0, $e7f860d2e0e9373c$export$2e2bcd8739ae039)([
        route
    ], pathname, query, basePath);
    return {
        route: route,
        match: matchedRoute ? matchedRoute.match : (0, $0100e5f4b4767f2b$export$2de13e891a662beb),
        query: query
    };
};
const $10a8bc47d57825ec$export$a0bd0313cbeabd49 = (routes, options)=>{
    const { location: location, basePath: basePath = '' } = options;
    const { pathname: pathname, search: search } = location;
    const query = (0, $deb424f7a075f200$exports.qs).parse(search);
    const matchedRoute = (0, $e7f860d2e0e9373c$export$2e2bcd8739ae039)(routes, pathname, query, basePath);
    return {
        query: query,
        route: matchedRoute ? matchedRoute.route : (0, $0100e5f4b4767f2b$export$4eadc79233226325),
        match: matchedRoute ? matchedRoute.match : (0, $0100e5f4b4767f2b$export$2de13e891a662beb)
    };
};


const $31916272644d9021$var$isShallowEqual = (o1, o2)=>{
    const objKeys1 = Object.keys(o1);
    const objKeys2 = Object.keys(o2);
    if (objKeys1.length !== objKeys2.length) return false;
    return objKeys1.every((key)=>o1[key] === o2[key]);
};
const $31916272644d9021$export$5997e70fc4543270 = ({ prevContextMatch: prevContextMatch, nextContextMatch: nextContextMatch })=>prevContextMatch.path === nextContextMatch.path && $31916272644d9021$var$isShallowEqual(prevContextMatch.query, nextContextMatch.query) && $31916272644d9021$var$isShallowEqual(prevContextMatch.params, nextContextMatch.params);






/* eslint-disable import/no-unresolved */ 

var $3hvsM = parcelRequire("3hvsM");

var $5FkrB = parcelRequire("5FkrB");
const $659e6c773637eb0b$var$defaultMutator = (prevState, partialState)=>{
    // Merge the partial state and the previous state.
    return Object.assign({}, prevState, partialState);
};
const $659e6c773637eb0b$var$defaults = {
    batchUpdates: 'useSyncExternalStore' in (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))),
    devtools: false,
    middlewares: new Set(),
    mutator: $659e6c773637eb0b$var$defaultMutator
};
var $659e6c773637eb0b$export$2e2bcd8739ae039 = $659e6c773637eb0b$var$defaults;


const $24e4e1fa0485bf7c$var$supports = {
    scheduling () {
        return typeof window !== 'undefined' && typeof MessageChannel === 'function';
    }
};
var $24e4e1fa0485bf7c$export$2e2bcd8739ae039 = $24e4e1fa0485bf7c$var$supports;


let $49fce73d954fc894$var$isInsideBatchedSchedule = false;
function $49fce73d954fc894$export$712ea50be43a7858(fn) {
    // if we are in node/tests or nested schedule
    if (!(0, $659e6c773637eb0b$export$2e2bcd8739ae039).batchUpdates || !(0, $24e4e1fa0485bf7c$export$2e2bcd8739ae039).scheduling() || $49fce73d954fc894$var$isInsideBatchedSchedule) return (0, $7d59b24134129acf$exports.unstable_batchedUpdates)(fn);
    $49fce73d954fc894$var$isInsideBatchedSchedule = true; // Use ImmediatePriority as it has -1ms timeout
    // https://github.com/facebook/react/blob/main/packages/scheduler/src/forks/Scheduler.js#L65
    return (0, $3hvsM.unstable_scheduleCallback)((0, $3hvsM.unstable_ImmediatePriority), function scheduleBatchedUpdates() {
        (0, $7d59b24134129acf$exports.unstable_batchedUpdates)(fn);
        $49fce73d954fc894$var$isInsideBatchedSchedule = false;
    });
}


var $5FkrB = parcelRequire("5FkrB");
var $c662beeebae12502$exports = {};
'use strict';

$c662beeebae12502$exports = (parcelRequire("da6Nf"));



var $5FkrB = parcelRequire("5FkrB");


const $567e8f4619a691de$var$namedMutator = (storeState, actionName)=>function() {
        storeState.mutator.actionName = actionName;
        return storeState.mutator(...arguments);
    };
const $567e8f4619a691de$var$warnings = new WeakMap();
const $567e8f4619a691de$export$5f944353e69b9bf3 = (storeState, actionFn, actionKey, config, actions)=>{
    const callThunk = (instance, thunkFn, actionName)=>thunkFn({
            setState: (0, $659e6c773637eb0b$export$2e2bcd8739ae039).devtools ? $567e8f4619a691de$var$namedMutator(instance.storeState, actionName) : instance.storeState.mutator,
            getState: instance.storeState.getState,
            get actions () {
                if (!$567e8f4619a691de$var$warnings.has(actionFn)) $567e8f4619a691de$var$warnings.set(actionFn, console.warn(`react-sweet-state 'actions' property has been deprecated and will be removed in the next mayor. ` + `Please check action '${actionName}' of Store '${instance.storeState.key}' and use 'dispatch' instead`));
                return actions;
            },
            dispatch: (tFn)=>callThunk(instance, tFn, `${actionName}.dispatch`)
        }, config.props());
    return function() {
        return callThunk({
            storeState: storeState,
            actions: actions
        }, actionFn(...arguments), actionKey);
    };
};
const $567e8f4619a691de$export$5ee1d46cd0883a22 = function bindActions(actions, storeState, config, boundActions) {
    if (boundActions === void 0) boundActions = null;
    return Object.keys(actions).reduce((acc, k)=>{
        acc[k] = $567e8f4619a691de$export$5f944353e69b9bf3(storeState, actions[k], k, config, boundActions || acc);
        return acc;
    }, {});
};



// Mostly copied from fbjs/packages/fbjs/src/core/shallowEqual.js
// enhanced with keys cache as might get called multiple times with same args
const $4fb4cbecfc4ff1e8$var$hasOwnProperty = Object.prototype.hasOwnProperty;
const $4fb4cbecfc4ff1e8$var$CACHE = new WeakMap();
function $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039(objA, objB) {
    if (objA === objB) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    if (Array.isArray(objA) && Array.isArray(objB)) {
        // do array comparison
        if (objA.length !== objB.length) return false;
        for(let i = 0; i < objA.length; i++){
            if (objA[i] !== objB[i]) return false;
        }
        return true;
    } else {
        // Handle Date, RegExp, String, Number, ... and complex objects
        const strA = '' + objA;
        const strB = '' + objB;
        if (strA !== strB || strA[0] === '[' && strA !== '[object Object]') return false;
         // do object comparison
        let keysA;
        if ($4fb4cbecfc4ff1e8$var$CACHE.has(objA)) keysA = $4fb4cbecfc4ff1e8$var$CACHE.get(objA);
        else {
            keysA = Object.keys(objA);
            $4fb4cbecfc4ff1e8$var$CACHE.set(objA, keysA);
        }
        let keysB;
        if ($4fb4cbecfc4ff1e8$var$CACHE.has(objB)) keysB = $4fb4cbecfc4ff1e8$var$CACHE.get(objB);
        else {
            keysB = Object.keys(objB);
            $4fb4cbecfc4ff1e8$var$CACHE.set(objB, keysB);
        }
        if (keysA.length !== keysB.length) return false;
         // Test for A's keys different from B.
        for(let i = 0; i < keysA.length; i++){
            if (!$4fb4cbecfc4ff1e8$var$hasOwnProperty.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) return false;
        }
        return true;
    }
}


const $b6798b84ef80633c$var$updateMiddleware = (storeState)=>(next)=>(arg)=>{
            let output;
            const state = storeState.getState();
            const nextState = next(state, arg, (out)=>{
                output = out;
            });
            if (!(0, $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039)(nextState, state)) storeState.setState(nextState);
            return output;
        };
var $b6798b84ef80633c$export$2e2bcd8739ae039 = $b6798b84ef80633c$var$updateMiddleware;


const $5c50899a0dea3342$var$applyMiddleware = (storeState, middlewares)=>Array.from(middlewares).concat((0, $b6798b84ef80633c$export$2e2bcd8739ae039)).reduceRight((next, mw)=>mw(storeState)(next), (0, $659e6c773637eb0b$export$2e2bcd8739ae039).mutator);
var $5c50899a0dea3342$export$2e2bcd8739ae039 = $5c50899a0dea3342$var$applyMiddleware;



const $55aa2244d18072e9$var$connectDevTools = (storeState, config)=>{
    const devTools = window.__REDUX_DEVTOOLS_EXTENSION__.connect(Object.assign({
        name: `Store ${storeState.key}`,
        serialize: true,
        trace: true
    }, config));
    devTools.init(storeState.getState());
    devTools.subscribe((message)=>{
        if (message.type === 'DISPATCH') switch(message.payload.type){
            case 'RESET':
                storeState.resetState();
                devTools.init(storeState.getState());
                return;
            case 'COMMIT':
                devTools.init(storeState.getState());
                return;
            case 'ROLLBACK':
                storeState.setState(JSON.parse(message.state));
                devTools.init(storeState.getState());
                return;
            case 'JUMP_TO_STATE':
            case 'JUMP_TO_ACTION':
                storeState.setState(JSON.parse(message.state));
                return;
        }
        else if (message.type === 'ACTION') {
            let action = JSON.parse(message.payload);
            storeState.setState(action.payload);
        }
    });
    return devTools;
};
const $55aa2244d18072e9$var$withDevtools = (createStoreState)=>function() {
        const storeState = createStoreState(...arguments);
        if ((0, $659e6c773637eb0b$export$2e2bcd8739ae039).devtools && window && window.__REDUX_DEVTOOLS_EXTENSION__) {
            const origMutator = storeState.mutator;
            let devTools;
            const devtoolMutator = (arg)=>{
                const result = origMutator(arg);
                try {
                    if (!devTools) {
                        const config = typeof (0, $659e6c773637eb0b$export$2e2bcd8739ae039).devtools === 'function' ? (0, $659e6c773637eb0b$export$2e2bcd8739ae039).devtools(storeState) : {};
                        devTools = $55aa2244d18072e9$var$connectDevTools(storeState, config);
                    }
                    devTools.send({
                        type: storeState.mutator.actionName,
                        payload: arg
                    }, storeState.getState(), {}, storeState.key);
                } catch (err) {
                /* ignore devtools errors */ }
                return result;
            };
            storeState.mutator = devtoolMutator;
        }
        return storeState;
    };
var $55aa2244d18072e9$export$2e2bcd8739ae039 = $55aa2244d18072e9$var$withDevtools;






const $486da13a078d111a$var$QUEUE = [];
let $486da13a078d111a$var$scheduled;
function $486da13a078d111a$export$2e2bcd8739ae039(fn) {
    // if we are in node/tests or feature disabled, make updates sync batched
    if (!(0, $659e6c773637eb0b$export$2e2bcd8739ae039).batchUpdates || !(0, $24e4e1fa0485bf7c$export$2e2bcd8739ae039).scheduling()) return (0, $49fce73d954fc894$export$712ea50be43a7858)(()=>fn()); // Add to queue if not already there
    // so we avoid multiple notifications to same store listeners
    if (!$486da13a078d111a$var$QUEUE.includes(fn)) $486da13a078d111a$var$QUEUE.push(fn); // if something already started schedule, skip
    if ($486da13a078d111a$var$scheduled) return;
    $486da13a078d111a$var$scheduled = (0, $49fce73d954fc894$export$712ea50be43a7858)(()=>{
        let queueFn;
        while(queueFn = $486da13a078d111a$var$QUEUE.shift())queueFn();
        $486da13a078d111a$var$scheduled = null;
    });
}


function $40676ed4f7792fba$var$createStoreState(key, initialState) {
    let listeners = new Set();
    let currentState = initialState;
    const storeState = {
        key: key,
        getState () {
            return currentState;
        },
        setState (nextState) {
            currentState = nextState; // Instead of notifying all handlers immediately, we wait next tick
            // so multiple actions affecting the same store gets combined
            (0, $486da13a078d111a$export$2e2bcd8739ae039)(storeState.notify);
        },
        resetState () {
            storeState.setState(initialState);
        },
        notify () {
            for (const listener of listeners)listener(storeState.getState());
        },
        subscribe (listener) {
            listeners.add(listener);
            return function unsubscribe() {
                listeners.delete(listener);
            };
        },
        listeners () {
            return listeners;
        }
    };
    storeState.mutator = (0, $5c50899a0dea3342$export$2e2bcd8739ae039)(storeState, (0, $659e6c773637eb0b$export$2e2bcd8739ae039).middlewares);
    return storeState;
}
var $40676ed4f7792fba$export$2e2bcd8739ae039 = (0, $55aa2244d18072e9$export$2e2bcd8739ae039)($40676ed4f7792fba$var$createStoreState);


const $60909d64c4d3805d$export$e4d628ba0054221b = '__global__';
class $60909d64c4d3805d$export$acb47f32da33501e {
    constructor(defaultScope){
        var _this = this;
        if (defaultScope === void 0) defaultScope = $60909d64c4d3805d$export$e4d628ba0054221b;
        this.stores = new Map();
        this.initStore = (key, Store, config)=>{
            const { initialState: initialState, actions: actions } = Store;
            if (Store.containedBy && !config.contained(Store)) {
                const err = new Error(`Store ${Store.key} should be contained by a container but it is used globally. ` + `While it might still work, it will likely cause unexpected behaviours.`);
                if ((0, $24e4e1fa0485bf7c$export$2e2bcd8739ae039).scheduling()) Promise.reject(err);
                else throw err;
            }
            const storeState = (0, $40676ed4f7792fba$export$2e2bcd8739ae039)(key, initialState);
            let boundActions;
            const store = {
                storeState: storeState,
                // these are used only when container-less, so we generate them on-demand
                get actions () {
                    if (!boundActions) boundActions = (0, $567e8f4619a691de$export$5ee1d46cd0883a22)(actions, storeState, config);
                    return boundActions;
                }
            };
            this.stores.set(key, store);
            return store;
        };
        this.hasStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.has(key);
        };
        this.getStore = function(Store, scopeId, config) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            if (config === void 0) config = {
                props: ()=>({}),
                contained: ()=>false
            };
            const key = _this.generateKey(Store, scopeId);
            return _this.stores.get(key) || config && _this.initStore(key, Store, config);
        };
        this.deleteStore = function(Store, scopeId) {
            if (scopeId === void 0) scopeId = _this.defaultScope;
            const key = _this.generateKey(Store, scopeId);
            _this.stores.delete(key);
        };
        this.generateKey = (Store, scopeId)=>`${Store.key}@${scopeId}`;
        this.defaultScope = defaultScope;
    }
}
const $60909d64c4d3805d$export$9d726ae4880b1060 = new $60909d64c4d3805d$export$acb47f32da33501e();


const $c629e488311fc925$export$841858b892ce1f4c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createContext({
    globalRegistry: (0, $60909d64c4d3805d$export$9d726ae4880b1060),
    retrieveStore: (Store)=>(0, $60909d64c4d3805d$export$9d726ae4880b1060).getStore(Store)
}, ()=>0);



function $860d3699eb69e62e$var$exactEqual(objA, objB) {
    return objA === objB;
}
function $860d3699eb69e62e$var$areArgumentsEqual(propsMode, prev, next) {
    if (prev === null || next === null || prev.length !== next.length) return false; // If propsMode and 2 arguments, means it is an input selector
    // and we check for shallow equality on 2nd one to optimise props
    if (propsMode && prev.length === 2) return prev[0] === next[0] && (0, $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039)(prev[1], next[1]);
    for(let i = 0; i < prev.length; i++){
        if (!$860d3699eb69e62e$var$exactEqual(prev[i], next[i])) return false;
    }
    return true;
}
function $860d3699eb69e62e$export$2e2bcd8739ae039(resultFn, propsMode) {
    if (propsMode === void 0) propsMode = false;
    let lastArgs = [];
    let lastResult;
    let calledOnce = false;
    const result = function result() {
        if (calledOnce && $860d3699eb69e62e$var$areArgumentsEqual(propsMode, arguments, lastArgs)) return lastResult;
        const nextResult = resultFn.apply(this, arguments);
        if (!propsMode && (0, $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039)(nextResult, lastResult)) return lastResult;
        lastResult = nextResult;
        calledOnce = true;
        lastArgs = arguments;
        return lastResult;
    };
    return result;
}


function $927c70ef7a7597a6$export$595d22ed68ca2841() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    const resultFunc = funcs.pop();
    const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;
    const memoizedResultFunc = (0, $860d3699eb69e62e$export$2e2bcd8739ae039)(function() {
        return resultFunc.apply(null, arguments);
    }); // this memoisation is optimised for 2 arguments (state, props)
    const selector = (0, $860d3699eb69e62e$export$2e2bcd8739ae039)(function() {
        // calculate all dependencies results
        const params = [];
        for(let i = 0; i < dependencies.length; i++)params.push(dependencies[i].apply(null, arguments));
         // then call the final func with all them as arguments
        return memoizedResultFunc.apply(null, params);
    }, true); // expose so we can create per scope selectors
    // API compatible with reselect@^4
    selector.resultFunc = resultFunc;
    selector.dependencies = dependencies;
    return selector;
}
function $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector) {
    const isReselector = typeof selector.resultFunc === 'function' && Array.isArray(selector.dependencies);
    const dependencies = isReselector ? selector.dependencies : [
        (s)=>s,
        (_, p)=>p
    ];
    const resultFunc = isReselector ? selector.resultFunc : selector;
    return $927c70ef7a7597a6$export$595d22ed68ca2841(dependencies, resultFunc);
}
const $927c70ef7a7597a6$var$cache = new WeakMap();
function $927c70ef7a7597a6$export$38d24f3c60944dd5(selector, storeState, hasProps) {
    if (!hasProps) {
        if (!$927c70ef7a7597a6$var$cache.has(storeState)) $927c70ef7a7597a6$var$cache.set(storeState, new WeakMap());
        const scopeSelectors = $927c70ef7a7597a6$var$cache.get(storeState);
        if (!scopeSelectors.has(selector)) scopeSelectors.set(selector, $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector));
        return scopeSelectors.get(selector);
    }
    return $927c70ef7a7597a6$export$d2c200d79fc82f8c(selector);
}


const $c3bd6dfdb3d51ec8$var$EMPTY_SELECTOR = ()=>undefined;
const $c3bd6dfdb3d51ec8$var$DEFAULT_SELECTOR = (state)=>state;
function $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, _temp) {
    let { selector: selector } = _temp === void 0 ? {} : _temp;
    return function useSweetState(propsArg) {
        const { retrieveStore: retrieveStore } = (0, $5FkrB.useContext)((0, $c629e488311fc925$export$841858b892ce1f4c));
        const { storeState: storeState, actions: actions } = retrieveStore(Store);
        const hasPropsArg = propsArg !== undefined;
        const propsArgRef = (0, $5FkrB.useRef)(propsArg);
        propsArgRef.current = propsArg;
        const stateSelector = (0, $5FkrB.useMemo)(()=>selector ? (0, $927c70ef7a7597a6$export$38d24f3c60944dd5)(selector, storeState, hasPropsArg) : selector === null ? $c3bd6dfdb3d51ec8$var$EMPTY_SELECTOR : $c3bd6dfdb3d51ec8$var$DEFAULT_SELECTOR, [
            hasPropsArg,
            storeState
        ]);
        const forceUpdate = (0, $5FkrB.useState)({})[1];
        const getSnapshot = (0, $5FkrB.useCallback)(()=>{
            // parent scope has changed and notify was explicitly triggered by the container
            // we need to force the hook to re-render to listen new storeState
            if (retrieveStore(Store).storeState !== storeState) forceUpdate({});
            const state = storeState.getState();
            return stateSelector(state, propsArgRef.current);
        }, [
            retrieveStore,
            storeState,
            stateSelector,
            forceUpdate
        ]);
        const currentState = (0, $c662beeebae12502$exports.useSyncExternalStore)(storeState.subscribe, getSnapshot, getSnapshot);
        return [
            currentState,
            actions
        ];
    };
}
function $c3bd6dfdb3d51ec8$export$7c643e1d6648e418(Store) {
    const useHook = $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, {
        selector: null
    });
    return function useSweetStateActions() {
        return useHook()[1];
    };
}
function $c3bd6dfdb3d51ec8$export$6e4e5611de132e85(Store, _temp2) {
    let { selector: selector } = _temp2 === void 0 ? {} : _temp2;
    const useHook = $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24(Store, {
        selector: selector
    });
    return function useSweetStateState(propsArg) {
        return useHook(propsArg)[0];
    };
}


var $5FkrB = parcelRequire("5FkrB");
var $632422cfaa3e0ff5$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $632422cfaa3e0ff5$var$ReactIs, $632422cfaa3e0ff5$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$632422cfaa3e0ff5$exports = (parcelRequire("6u0Zy"))();





const $a264dce57acd4232$var$_excluded = [
    "children"
], $a264dce57acd4232$var$_excluded2 = [
    "scope",
    "isGlobal"
];
function $a264dce57acd4232$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $a264dce57acd4232$var$noop = ()=>()=>{};
function $a264dce57acd4232$export$26ae5ca175b4ec5a(StoreOrOptions, _temp) {
    if (StoreOrOptions === void 0) StoreOrOptions = {};
    let { onInit: _onInit = $a264dce57acd4232$var$noop, onUpdate: onUpdate = $a264dce57acd4232$var$noop, onCleanup: onCleanup = $a264dce57acd4232$var$noop, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    if ('key' in StoreOrOptions) {
        const Store = StoreOrOptions;
        const dn = displayName || `Container(${Store.key.split('__')[0]})`;
        return $a264dce57acd4232$var$createFunctionContainer({
            displayName: dn,
            // compat fields
            override: {
                Store: Store,
                handlers: Object.assign({}, _onInit !== $a264dce57acd4232$var$noop && {
                    onInit: ()=>_onInit()
                }, onCleanup !== $a264dce57acd4232$var$noop && {
                    onDestroy: ()=>onCleanup()
                }, onUpdate !== $a264dce57acd4232$var$noop && {
                    onContainerUpdate: ()=>onUpdate()
                })
            }
        });
    }
    return $a264dce57acd4232$var$createFunctionContainer(StoreOrOptions);
}
function $a264dce57acd4232$var$useRegistry(scope, isGlobal, _ref) {
    let { globalRegistry: globalRegistry } = _ref;
    return (0, $5FkrB.useMemo)(()=>{
        const isLocal = !scope && !isGlobal;
        return isLocal ? new (0, $60909d64c4d3805d$export$acb47f32da33501e)('__local__') : globalRegistry;
    }, [
        scope,
        isGlobal,
        globalRegistry
    ]);
}
function $a264dce57acd4232$var$useContainedStore(scope, registry, propsRef, check, override) {
    // Store contained scopes in a map, but throwing it away on scope change
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const containedStores = (0, $5FkrB.useMemo)(()=>new Map(), [
        scope
    ]);
    const getContainedStore = (0, $5FkrB.useCallback)((Store)=>{
        let containedStore = containedStores.get(Store); // first time it gets called we add store to contained map bound
        // so we can provide props to actions (only triggered by children)
        if (!containedStore) {
            const isExisting = registry.hasStore(Store, scope);
            const config = {
                props: ()=>propsRef.current.sub,
                contained: check
            };
            const { storeState: storeState } = registry.getStore(Store, scope, config);
            const actions = (0, $567e8f4619a691de$export$5ee1d46cd0883a22)(Store.actions, storeState, config);
            const handlers = (0, $567e8f4619a691de$export$5ee1d46cd0883a22)(Object.assign({}, Store.handlers, override == null ? void 0 : override.handlers), storeState, config, actions);
            containedStore = {
                storeState: storeState,
                actions: actions,
                handlers: handlers,
                unsubscribe: storeState.subscribe(()=>handlers.onUpdate == null ? void 0 : handlers.onUpdate())
            };
            containedStores.set(Store, containedStore); // Signal store is contained and ready now, so by the time
            // consumers subscribe we already have updated the store (if needed).
            // Also if override maintain legacy behaviour, triggered on every mount
            if (!isExisting || override) handlers.onInit == null || handlers.onInit();
        }
        return containedStore;
    }, [
        containedStores,
        scope,
        registry,
        propsRef,
        check,
        override
    ]);
    return [
        containedStores,
        getContainedStore
    ];
}
function $a264dce57acd4232$var$useApi(check, getContainedStore, _ref2) {
    let { globalRegistry: globalRegistry, retrieveStore: retrieveStore } = _ref2;
    const retrieveRef = (0, $5FkrB.useRef)();
    retrieveRef.current = (Store)=>check(Store) ? getContainedStore(Store) : retrieveStore(Store); // This api is "frozen", as changing it will trigger re-render across all consumers
    // so we link retrieveStore dynamically and manually call notify() on scope change
    return (0, $5FkrB.useMemo)(()=>({
            globalRegistry: globalRegistry,
            retrieveStore: (s)=>retrieveRef.current(s)
        }), [
        globalRegistry
    ]);
}
function $a264dce57acd4232$var$createFunctionContainer(_temp2) {
    let { displayName: displayName, override: override } = _temp2 === void 0 ? {} : _temp2;
    const check = (store)=>override ? store === override.Store : store.containedBy === FunctionContainer;
    function FunctionContainer(props) {
        const { children: children } = props, restProps = $a264dce57acd4232$var$_objectWithoutPropertiesLoose(props, $a264dce57acd4232$var$_excluded);
        const { scope: scope, isGlobal: isGlobal } = restProps, subProps = $a264dce57acd4232$var$_objectWithoutPropertiesLoose(restProps, $a264dce57acd4232$var$_excluded2);
        const ctx = (0, $5FkrB.useContext)((0, $c629e488311fc925$export$841858b892ce1f4c));
        const registry = $a264dce57acd4232$var$useRegistry(scope, isGlobal, ctx); // Store props in a ref to avoid re-binding actions when they change and re-rendering all
        // consumers unnecessarily. The update is handled by an effect on the component instead
        const propsRef = (0, $5FkrB.useRef)({
            prev: null,
            next: restProps,
            sub: subProps
        });
        propsRef.current = {
            prev: propsRef.current.next,
            next: restProps,
            sub: subProps // TODO remove on next major
        };
        const [containedStores, getContainedStore] = $a264dce57acd4232$var$useContainedStore(scope, registry, propsRef, check, override); // Use a stable object as is passed as value to context Provider
        const api = $a264dce57acd4232$var$useApi(check, getContainedStore, ctx); // This listens for custom props change, and so we trigger container update actions
        // before the re-render gets to consumers (hence why side effect on render).
        // We do not use React hooks because num of restProps might change and react will throws
        if (!(0, $4fb4cbecfc4ff1e8$export$2e2bcd8739ae039)(propsRef.current.next, propsRef.current.prev)) containedStores.forEach((_ref3)=>{
            let { handlers: handlers } = _ref3;
            handlers.onContainerUpdate == null || handlers.onContainerUpdate(propsRef.current.next, propsRef.current.prev);
        });
         // We support renderding "bootstrap" containers without children with override API
        // so in this case we call getCS to initialize the store globally asap
        if (override && !containedStores.size && (scope || isGlobal)) getContainedStore(override.Store);
         // This listens for scope change or component unmount, to notify all consumers
        // so all work is done on cleanup
        (0, $5FkrB.useEffect)(()=>{
            return ()=>{
                containedStores.forEach((_ref4, Store)=>{
                    let { storeState: storeState, handlers: handlers, unsubscribe: unsubscribe } = _ref4;
                    // Detatch container from subscription
                    unsubscribe(); // Trigger a forced update on all subscribers as we opted out from context
                    // Some might have already re-rendered naturally, but we "force update" all anyway.
                    // This is sub-optimal as if there are other containers with the same
                    // old scope id we will re-render those too, but still better than context
                    storeState.notify(); // Given unsubscription is handled by useSyncExternalStore, we have no control on when
                    // React decides to do it. So we schedule on next tick to run last
                    Promise.resolve().then(()=>{
                        var _registry$getStore;
                        if (!storeState.listeners().size && // ensure registry has not already created a new store with same scope
                        storeState === ((_registry$getStore = registry.getStore(Store, scope, null)) == null ? void 0 : _registry$getStore.storeState)) {
                            handlers.onDestroy == null || handlers.onDestroy(); // We only delete scoped stores, as global shall persist and local are auto-deleted
                            if (scope) registry.deleteStore(Store, scope);
                        }
                    });
                }); // no need to reset containedStores as the map is already bound to scope
            };
        }, [
            registry,
            scope,
            containedStores
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $c629e488311fc925$export$841858b892ce1f4c).Provider, {
            value: api
        }, children);
    }
    FunctionContainer.displayName = displayName || `Container`;
    FunctionContainer.propTypes = {
        children: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).node,
        scope: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).string,
        isGlobal: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).bool
    };
    return FunctionContainer;
}

/* eslint-disable */ // murmurhash2 via https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $1615da4702e70caf$export$2e2bcd8739ae039(str) {
    var l = str.length, h = l ^ l, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return (h >>> 0).toString(36);
}


function $1164a01562ee8563$var$createKey(initialState, actions, name) {
    const src = !name ? Object.keys(actions).reduce((acc, k)=>acc + actions[k].toString(), '') : '';
    return [
        name,
        (0, $1615da4702e70caf$export$2e2bcd8739ae039)(src + JSON.stringify(initialState))
    ].filter(Boolean).join('__');
}
function $1164a01562ee8563$export$f51a9068ac82ea43(_ref) {
    let { name: name = '', initialState: initialState, actions: actions, containedBy: containedBy, handlers: handlers = {} } = _ref;
    let key;
    return {
        get key () {
            // lazy evaluate key on first access
            return key || (key = $1164a01562ee8563$var$createKey(initialState, actions, name));
        },
        initialState: initialState,
        actions: actions,
        containedBy: containedBy,
        handlers: handlers
    };
}






const $c21e9538f0e35012$var$stripTrailingSlash = (path)=>path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
const $c21e9538f0e35012$var$addLeadingSlash = (path)=>path.charAt(0) === '/' ? path : '/' + path;
const $c21e9538f0e35012$export$b8ce2e8154d1dff1 = (path, prefix = '')=>{
    if (prefix) {
        prefix = $c21e9538f0e35012$var$stripTrailingSlash(prefix);
        prefix = $c21e9538f0e35012$var$addLeadingSlash(prefix);
        path = $c21e9538f0e35012$var$addLeadingSlash(path);
    }
    return prefix + path;
};
const $c21e9538f0e35012$export$e83e3719fc818ee5 = (path)=>{
    const regex = new RegExp('^([a-z]+://|//)', 'i');
    return regex.test(path);
};
const $c21e9538f0e35012$export$2fa6dede99f181e5 = (path)=>{
    if (typeof path !== 'string' || !$c21e9538f0e35012$export$e83e3719fc818ee5(path)) return false;
    const pathHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(path).hostname;
    const currentHostname = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(window.location.href).hostname;
    return pathHostname !== currentHostname;
};
const $c21e9538f0e35012$export$ae9fda833d91ed65 = (path, prefix = '')=>{
    if (typeof path !== 'string') return path;
    if (!$c21e9538f0e35012$export$e83e3719fc818ee5(path)) {
        path = $c21e9538f0e35012$export$b8ce2e8154d1dff1(path, prefix);
        return path;
    }
    const url = new (0, (/*@__PURE__*/$parcel$interopDefault($deb424f7a075f200$exports)))(path);
    return `${url.pathname}${url.query}${url.hash}`;
};
const $c21e9538f0e35012$export$92377f461a797888 = (location, query)=>{
    // @ts-ignore stringify accepts two params but it's type doesn't say so
    const stringifiedQuery = (0, $deb424f7a075f200$exports.qs).stringify(query, true);
    return `${location.pathname}${stringifiedQuery}${location.hash}`;
};
const $c21e9538f0e35012$export$9ae1c7c875ef309d = (location)=>{
    return `${location.pathname}${location.search}${location.hash}`;
};
const $c21e9538f0e35012$export$c9237620ff7fdf7c = ({ context: context, prevContext: prevContext, pluginId: pluginId })=>{
    const sameRoute = (0, $31916272644d9021$export$5997e70fc4543270)({
        prevContextMatch: prevContext.match,
        nextContextMatch: context.match
    });
    // keep old behaviour for Resources plugin
    // load Route only if path/query/params changed, and ignore the rest of query-params
    const defaultShouldReload = pluginId === 'resources-plugin' || !sameRoute;
    if (context.route === prevContext.route && context.route.EXPERIMENTAL__shouldReload) {
        const routeChoice = context.route.EXPERIMENTAL__shouldReload({
            context: context,
            prevContext: prevContext,
            pluginId: pluginId,
            defaultShouldReload: defaultShouldReload
        });
        if (typeof routeChoice === 'boolean') return routeChoice;
    }
    return defaultShouldReload;
};


const $1ddaa6502d719738$export$36d128238e6b60f5 = {
    action: (0, $0100e5f4b4767f2b$export$fa440ddf675c8a93),
    basePath: '',
    location: (0, $0100e5f4b4767f2b$export$39607c9878cf5148).location,
    history: (0, $0100e5f4b4767f2b$export$39607c9878cf5148),
    match: (0, $0100e5f4b4767f2b$export$2de13e891a662beb),
    onPrefetch: undefined,
    query: {},
    route: (0, $0100e5f4b4767f2b$export$4eadc79233226325),
    routes: [],
    unlisten: null,
    plugins: []
};
const $1ddaa6502d719738$var$actions = {
    /**
   * Bootstraps the store with initial data.
   *
   */ bootstrapStore: (props)=>({ setState: setState, dispatch: dispatch })=>{
            const { basePath: basePath = '', history: history, initialRoute: initialRoute, onPrefetch: onPrefetch, routes: routes, plugins: plugins } = props;
            const routerContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(initialRoute ? [
                initialRoute
            ] : routes, {
                location: history.location,
                basePath: basePath
            });
            setState((0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, routerContext, {
                basePath: basePath,
                history: history,
                onPrefetch: onPrefetch,
                routes: routes,
                location: history.location,
                action: history.action,
                plugins: plugins
            }));
            if (!(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) dispatch($1ddaa6502d719738$var$actions.listen());
        },
    /**
   * Starts listening to browser history and sets the unlisten function in state.
   * Will request route resources on route change.
   *
   */ listen: ()=>({ getState: getState, setState: setState })=>{
            const { history: history, unlisten: unlisten } = getState();
            if (unlisten) unlisten();
            const stopListening = history.listen((...update)=>{
                const location = update.length === 2 ? update[0] : update[0].location;
                const action = update.length === 2 ? update[1] : update[0].action;
                const { plugins: plugins, routes: routes, basePath: basePath, match: currentMatch, route: currentRoute, query: currentQuery } = getState();
                const nextContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
                const prevContext = {
                    route: currentRoute,
                    match: currentMatch,
                    query: currentQuery
                };
                const shouldReloadByPlugin = new Map(plugins.map((plugin)=>[
                        plugin.id,
                        (0, $c21e9538f0e35012$export$c9237620ff7fdf7c)({
                            context: nextContext,
                            prevContext: prevContext,
                            pluginId: plugin.id
                        })
                    ]));
                /* Explicitly batch update
       * as we need resources cleaned + route changed + resource fetch started together
       * If we do not batch, React might be re-render when route changes but resource
       * fetching has not started yet, making the app render with data null */ (0, $49fce73d954fc894$export$712ea50be43a7858)(()=>{
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.beforeRouteLoad == null || p.beforeRouteLoad({
                            context: prevContext,
                            nextContext: nextContext
                        });
                    });
                    setState((0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, nextContext, {
                        location: location,
                        action: action
                    }));
                    plugins.forEach((p)=>{
                        if (shouldReloadByPlugin.get(p.id)) p.routeLoad == null || p.routeLoad({
                            context: nextContext,
                            prevContext: prevContext
                        });
                    });
                });
            });
            setState({
                unlisten: stopListening
            });
        },
    push: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) window.location.assign(path);
            else history.push((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath), state);
        },
    pushTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, attributes, {
                basePath: basePath
            }));
            (0, $e7f860d2e0e9373c$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.push(location, attributes == null ? void 0 : attributes.state);
        },
    replace: (path, state)=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            if ((0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) window.location.replace(path);
            else history.replace((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath), state);
        },
    replaceTo: (route, attributes = {})=>({ getState: getState })=>{
            const { history: history, basePath: basePath } = getState();
            const location = (0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, attributes, {
                basePath: basePath
            }));
            (0, $e7f860d2e0e9373c$export$4e76f1d455ef7c95)(route, location.pathname, attributes.query, basePath);
            history.replace(location, attributes == null ? void 0 : attributes.state);
        },
    goBack: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goBack(), history@5 uses back()
            if ('goBack' in history) history.goBack();
            else if ('back' in history) history.back();
            else throw new Error('History does not support goBack');
        },
    goForward: ()=>({ getState: getState })=>{
            const { history: history } = getState();
            // history@4 uses goForward(), history@5 uses forward()
            if ('goForward' in history) history.goForward();
            else if ('forward' in history) history.forward();
            else throw new Error('History does not support goForward');
        },
    registerBlock: (blocker)=>({ getState: getState })=>{
            const { history: history } = getState();
            return history.block(blocker);
        },
    getContext: ()=>({ getState: getState })=>{
            const { query: query, route: route, match: match } = getState();
            return {
                query: query,
                route: route,
                match: match
            };
        },
    getBasePath: ()=>({ getState: getState })=>{
            const { basePath: basePath } = getState();
            return basePath;
        },
    updateQueryParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { query: existingQueryParams, history: history, location: location } = getState();
            const updatedQueryParams = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, existingQueryParams, params);
            // remove undefined keys
            Object.keys(updatedQueryParams).forEach((key)=>updatedQueryParams[key] === undefined && delete updatedQueryParams[key]);
            const existingPath = (0, $c21e9538f0e35012$export$92377f461a797888)(location, existingQueryParams);
            const updatedPath = (0, $c21e9538f0e35012$export$92377f461a797888)(location, updatedQueryParams);
            if (updatedPath !== existingPath) history[updateType](updatedPath);
        },
    updatePathParam: (params, updateType = 'push')=>({ getState: getState })=>{
            const { history: history, location: location, route: { path: path }, match: { params: existingPathParams }, basePath: basePath } = getState();
            const pathWithBasePath = basePath + path;
            const updatedPathParams = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, existingPathParams, params);
            const updatedPath = (0, $de4d1e4f61a87867$export$82476f982757e71e)(pathWithBasePath, updatedPathParams);
            const updatedLocation = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, location, {
                pathname: updatedPath
            });
            const existingRelativePath = (0, $c21e9538f0e35012$export$9ae1c7c875ef309d)(location);
            const updatedRelativePath = (0, $c21e9538f0e35012$export$9ae1c7c875ef309d)(updatedLocation);
            if (updatedRelativePath !== existingRelativePath) history[updateType](updatedRelativePath);
        },
    loadPlugins: ()=>({ getState: getState })=>{
            const { plugins: plugins, match: match, query: query, route: route } = getState();
            plugins.forEach((p)=>p.routeLoad == null ? void 0 : p.routeLoad({
                    context: {
                        match: match,
                        query: query,
                        route: route
                    }
                }));
        },
    prefetchRoute: (path, nextContext)=>({ getState: getState })=>{
            const { plugins: plugins, routes: routes, basePath: basePath, onPrefetch: onPrefetch } = getState();
            const { route: route, match: match, query: query } = $1ddaa6502d719738$export$ebf37f7e180b13a9();
            if (!nextContext && !(0, $c21e9538f0e35012$export$2fa6dede99f181e5)(path)) {
                const location = (0, $c29d101a2cf08ade$export$8ccf933b0513f8d0)((0, $c21e9538f0e35012$export$ae9fda833d91ed65)(path, basePath));
                nextContext = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
                    location: location,
                    basePath: basePath
                });
            }
            if (nextContext == null) return;
            const nextLocationContext = nextContext;
            (0, $49fce73d954fc894$export$712ea50be43a7858)(()=>{
                plugins.forEach((p)=>p.routePrefetch == null ? void 0 : p.routePrefetch({
                        context: {
                            route: route,
                            match: match,
                            query: query
                        },
                        nextContext: nextLocationContext
                    }));
                if (onPrefetch) onPrefetch(nextLocationContext);
            });
        }
};
const $1ddaa6502d719738$export$1cf0ecab63b1963c = (0, $1164a01562ee8563$export$f51a9068ac82ea43)({
    initialState: $1ddaa6502d719738$export$36d128238e6b60f5,
    actions: $1ddaa6502d719738$var$actions,
    name: 'router'
});
const $1ddaa6502d719738$export$d6b817abe7a77ea5 = (0, $a264dce57acd4232$export$26ae5ca175b4ec5a)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
    displayName: 'RouterContainer',
    onInit: ()=>({ dispatch: dispatch }, props)=>{
            dispatch($1ddaa6502d719738$var$actions.bootstrapStore(props));
            !(0, $f9f42a63082f8b8d$export$455cc18296abe008)() && dispatch($1ddaa6502d719738$var$actions.loadPlugins());
        },
    onCleanup: ()=>(state)=>{
            if (!(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) {
                const { unlisten: unlisten } = state.getState();
                unlisten && unlisten();
            }
        }
});
const $1ddaa6502d719738$export$9569010eab09ae9e = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ada49399abf7a3a1 = (0, $c3bd6dfdb3d51ec8$export$7c643e1d6648e418)($1ddaa6502d719738$export$1cf0ecab63b1963c);
function $1ddaa6502d719738$export$95ab46bba7ea7a22(selector) {
    const useHook = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)($1ddaa6502d719738$export$1cf0ecab63b1963c, {
        selector: selector
    });
    return function useRouterSelector(...args) {
        return useHook(...args)[0];
    };
}
const $1ddaa6502d719738$export$5ccad187366c8494 = ()=>// @ts-ignore calling `getStore` without providing a scopeId
    (0, $60909d64c4d3805d$export$9d726ae4880b1060).getStore($1ddaa6502d719738$export$1cf0ecab63b1963c);
const $1ddaa6502d719738$export$ebf37f7e180b13a9 = ()=>$1ddaa6502d719738$export$5ccad187366c8494().storeState.getState();


const $b421c015f5018cd0$export$9a302a45f65d0572 = (0, $1ddaa6502d719738$export$9569010eab09ae9e);


class $d60bad8df7964b6c$var$Redirector extends (0, $5FkrB.Component) {
    componentDidMount() {
        const { to: to, location: location, push: push, params: params, query: query, actions: actions } = this.props;
        const routeAttributes = {
            params: params,
            query: query,
            basePath: actions.getBasePath()
        };
        const newPath = typeof to === 'object' ? 'path' in to ? (0, $c29d101a2cf08ade$export$fe53371bee54353d)((0, $768d36b334678dfa$export$37e0729cc751960b)(to.path, routeAttributes)) : (0, $c29d101a2cf08ade$export$fe53371bee54353d)(to) : to;
        const currentPath = (0, $c29d101a2cf08ade$export$fe53371bee54353d)(location);
        const action = push ? actions.push : actions.replace;
        if (currentPath === newPath) return;
        action(newPath);
    }
    render() {
        return null;
    }
}
(0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($d60bad8df7964b6c$var$Redirector, "defaultProps", {
    push: false
});
const $d60bad8df7964b6c$export$2d8d895a0a0f636e = (props)=>{
    const [{ location: location }, actions] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($d60bad8df7964b6c$var$Redirector, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        actions: actions,
        location: location
    }, props));
};





var $5FkrB = parcelRequire("5FkrB");

const $ddc1dbf2b1f7581e$export$55185c17a0fcbe46 = ({ basePath: basePath, children: children, history: history, initialRoute: initialRoute, isGlobal: isGlobal = true, plugins: plugins, onPrefetch: onPrefetch, routes: routes })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1ddaa6502d719738$export$d6b817abe7a77ea5), {
        basePath: basePath,
        history: history,
        initialRoute: initialRoute,
        isGlobal: isGlobal,
        onPrefetch: onPrefetch,
        plugins: plugins != null ? plugins : [],
        routes: routes
    }, children);
};
function $ddc1dbf2b1f7581e$export$ae46f04cfaffe093(props) {
    var _props$plugins;
    const history = (0, $5FkrB.useMemo)(()=>(0, $c29d101a2cf08ade$export$2b76ad033c6e6d08)(props.location ? {
            initialEntries: [
                props.location
            ]
        } : {}), [
        props.location
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ddc1dbf2b1f7581e$export$55185c17a0fcbe46, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, props, {
        history: history,
        isGlobal: false,
        plugins: (_props$plugins = props == null ? void 0 : props.plugins) != null ? _props$plugins : []
    }));
}



var $5FkrB = parcelRequire("5FkrB");

const $7ffd4dfc86b29f7d$export$402e82ff1b20594b = (0, $1ddaa6502d719738$export$ada49399abf7a3a1);


const $f38a5098ae6c30bf$export$b371fa9cf762ad06 = ({ children: children })=>{
    const actions = (0, $7ffd4dfc86b29f7d$export$402e82ff1b20594b)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(actions));
};
$f38a5098ae6c30bf$export$b371fa9cf762ad06.displayName = 'RouterActions';


var $0d5e64210d12b637$exports = {};
function $0d5e64210d12b637$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
$0d5e64210d12b637$exports = $0d5e64210d12b637$var$_objectWithoutPropertiesLoose, $0d5e64210d12b637$exports.__esModule = true, $0d5e64210d12b637$exports["default"] = $0d5e64210d12b637$exports;



var $5FkrB = parcelRequire("5FkrB");


const $a22a4d51e8ac3bb8$var$_excluded = [
    "listen"
];
const $a22a4d51e8ac3bb8$export$672d721d310ff5f0 = ({ children: children })=>{
    const [state, _ref] = (0, $1ddaa6502d719738$export$9569010eab09ae9e)();
    const { listen: listen } = _ref, actions = (0, (/*@__PURE__*/$parcel$interopDefault($0d5e64210d12b637$exports)))(_ref, $a22a4d51e8ac3bb8$var$_excluded);
    if (!state.unlisten && !(0, $f9f42a63082f8b8d$export$455cc18296abe008)()) listen();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(state, actions));
};




var $5FkrB = parcelRequire("5FkrB");


const $5b08526dd1b3cd91$var$createPathParamHook = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
    selector: ({ match: { params: params } }, { paramKey: paramKey })=>params[paramKey]
});
const $5b08526dd1b3cd91$export$8c8591dcd57728e6 = (paramKey)=>{
    const [paramVal, routerActions] = $5b08526dd1b3cd91$var$createPathParamHook({
        paramKey: paramKey
    });
    const setPathParam = (0, $5FkrB.useCallback)((newValue, updateType)=>{
        routerActions.updatePathParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setPathParam
    ];
};



var $5FkrB = parcelRequire("5FkrB");


const $a137eec8ff4dd5ae$var$createQueryParamHook = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
    selector: ({ query: query }, { paramKey: paramKey })=>query[paramKey]
});
const $a137eec8ff4dd5ae$export$ae316f0eeb712a36 = (paramKey)=>{
    const [paramVal, routerActions] = $a137eec8ff4dd5ae$var$createQueryParamHook({
        paramKey: paramKey
    });
    const setQueryParam = (0, $5FkrB.useCallback)((newValue, updateType)=>{
        routerActions.updateQueryParam({
            [paramKey]: newValue
        }, updateType);
    }, [
        paramKey,
        routerActions
    ]);
    return [
        paramVal,
        setQueryParam
    ];
};






var $5FkrB = parcelRequire("5FkrB");

const $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName = (component)=>{
    let componentDisplayName = 'UNDEFINED';
    const { displayName: displayName, name: name } = component;
    if (displayName) componentDisplayName = displayName;
    if (name) componentDisplayName = name;
    return `withRouter(${componentDisplayName})`;
};
const $f541dcf8f1a6c6da$export$369b6b2b30582e8e = (WrappedComponent)=>{
    const displayName = $f541dcf8f1a6c6da$var$getWrappedComponentDisplayName(WrappedComponent);
    const Component = WrappedComponent;
    const ComponentWithRouter = (props)=>{
        const [{ action: action, history: history, location: location, match: match, query: query, route: route }, { push: push, replace: replace }] = (0, $1ddaa6502d719738$export$9569010eab09ae9e)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, props, {
            action: action,
            history: history,
            location: location,
            match: match,
            push: push,
            query: query,
            replace: replace,
            route: route
        }));
    };
    ComponentWithRouter.displayName = displayName;
    return ComponentWithRouter;
};








var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");
const $816a5189e752f4e6$export$d8e6abf214c9ec0f = (delay)=>{
    const timeoutId = (0, $5FkrB.useRef)();
    const schedule = (0, $5FkrB.useCallback)((callback)=>{
        if (timeoutId.current) clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay);
    }, [
        delay
    ]);
    const cancel = (0, $5FkrB.useCallback)(()=>{
        clearTimeout(timeoutId.current);
    }, []);
    return {
        schedule: schedule,
        cancel: cancel
    };
};


const $39281ff350272ced$var$VALID_LINK_TYPES = [
    'a',
    'button'
];
const $39281ff350272ced$export$855ece989b15eb57 = (type)=>$39281ff350272ced$var$VALID_LINK_TYPES.includes(type) ? type : 'a';


const $f169e8fd2c308647$export$642c6f14f6d4bbd5 = (event)=>!!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
const $f169e8fd2c308647$export$130b789831072f4c = (event)=>[
        'keypress',
        'keydown',
        'keyup'
    ].includes(event.type);


const $05c5e447ce24817b$export$706ad1af8096e280 = (event, { onClick: onClick, target: target, replace: replace, routerActions: routerActions, href: href, to: to, state: state })=>{
    if ((0, $f169e8fd2c308647$export$130b789831072f4c)(event) && event.key !== 'Enter') return;
    onClick && onClick(event);
    if (!event.defaultPrevented && // onClick prevented default
    ((0, $f169e8fd2c308647$export$130b789831072f4c)(event) && event.key === 'Enter' || event.button === 0) && // ignore everything but left clicks and Enter key
    (!target || target === '_self') && // let browser handle "target=_blank" etc.
    !(0, $f169e8fd2c308647$export$642c6f14f6d4bbd5)(event) // ignore clicks with modifier keys
    ) {
        event.preventDefault();
        if (to) {
            const method = replace ? routerActions.replaceTo : routerActions.pushTo;
            method(...to, state);
        } else {
            const method = replace ? routerActions.replace : routerActions.push;
            method(href, state);
        }
    }
};




const $dba17dfd00ae7d8f$var$_excluded = [
    "children",
    "target",
    "replace",
    "href",
    "to",
    "onClick",
    "onMouseEnter",
    "onMouseLeave",
    "onPointerDown",
    "onFocus",
    "onBlur",
    "type",
    "params",
    "query",
    "prefetch",
    "state"
];
const $dba17dfd00ae7d8f$var$PREFETCH_DELAY = 225;
const $dba17dfd00ae7d8f$var$Link = /*#__PURE__*/ (0, $5FkrB.forwardRef)((_ref, ref)=>{
    let { children: children, target: target = '_self', replace: replace = false, href: href, to: to, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onPointerDown: onPointerDown, onFocus: onFocus, onBlur: onBlur, type: linkType = 'a', params: params, query: query, prefetch: prefetch = false, state: state } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($0d5e64210d12b637$exports)))(_ref, $dba17dfd00ae7d8f$var$_excluded);
    const routerActions = (0, $1ddaa6502d719738$export$ada49399abf7a3a1)();
    const { schedule: schedule, cancel: cancel } = (0, $816a5189e752f4e6$export$d8e6abf214c9ec0f)($dba17dfd00ae7d8f$var$PREFETCH_DELAY);
    const validLinkType = (0, $39281ff350272ced$export$855ece989b15eb57)(linkType);
    const [route, setRoute] = (0, $5FkrB.useState)(()=>{
        if (to && typeof to !== 'string') {
            if ('then' in to) to.then((r)=>setRoute('default' in r ? r.default : r));
            else return to;
        }
    });
    const routeAttributes = {
        params: params,
        query: query,
        basePath: routerActions.getBasePath()
    };
    const linkDestination = href != null ? href : typeof to !== 'string' ? route && (0, $c29d101a2cf08ade$export$fe53371bee54353d)((0, $768d36b334678dfa$export$37e0729cc751960b)(route.path, routeAttributes)) || '' : to;
    const staticBasePath = href == null && typeof to === 'string' ? routeAttributes.basePath : '';
    const triggerPrefetch = (0, $5FkrB.useCallback)(()=>{
        // ignore if async route not ready yet
        if (typeof to !== 'string' && !route) return;
        const context = typeof to !== 'string' && route ? (0, $10a8bc47d57825ec$export$faed15f35ddc6f99)(route, {
            params: params,
            query: query
        }) : null;
        routerActions.prefetchRoute(linkDestination, context);
    // omit params & query as already in linkDestination
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        route,
        linkDestination,
        routerActions
    ]);
    (0, $5FkrB.useEffect)(()=>{
        if (prefetch === 'mount') schedule(triggerPrefetch);
        return cancel;
    }, [
        prefetch,
        schedule,
        cancel,
        triggerPrefetch
    ]);
    const handleLinkPress = (e)=>(0, $05c5e447ce24817b$export$706ad1af8096e280)(e, {
            onClick: onClick,
            target: target,
            replace: replace,
            routerActions: routerActions,
            href: linkDestination,
            to: route && [
                route,
                {
                    params: params,
                    query: query
                }
            ],
            state: state
        });
    const handleMouseEnter = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onMouseEnter && onMouseEnter(e);
    };
    const handleMouseLeave = (e)=>{
        if (prefetch === 'hover') cancel();
        onMouseLeave && onMouseLeave(e);
    };
    const handleFocus = (e)=>{
        if (prefetch === 'hover') schedule(triggerPrefetch);
        onFocus && onFocus(e);
    };
    const handleBlur = (e)=>{
        if (prefetch === 'hover') cancel();
        onBlur && onBlur(e);
    };
    const handlePointerDown = (e)=>{
        if (prefetch === 'hover') {
            cancel();
            triggerPrefetch();
        }
        onPointerDown && onPointerDown(e);
    };
    return /*#__PURE__*/ (0, $5FkrB.createElement)(validLinkType, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, rest, {
        href: `${staticBasePath}${linkDestination}`,
        target: target,
        onClick: handleLinkPress,
        onKeyDown: handleLinkPress,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onPointerDown: handlePointerDown,
        ref: ref
    }), children);
});
$dba17dfd00ae7d8f$var$Link.displayName = 'Link';
var $dba17dfd00ae7d8f$export$2e2bcd8739ae039 = $dba17dfd00ae7d8f$var$Link;



var $5FkrB = parcelRequire("5FkrB");

const $56c1ff970910c658$export$7903e4b73fc7d6c3 = ()=>{
    const [{ action: action, location: location, match: match, query: query, route: route }] = (0, $b421c015f5018cd0$export$9a302a45f65d0572)();
    if (!route || !route.component) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(route.component, {
        action: action,
        location: location,
        match: match,
        query: query,
        route: route
    });
};






const $5b11c5222dd8637d$export$c36ce69a82764756 = (plugins, { routes: routes, history: history, basePath: basePath })=>{
    const context = (0, $10a8bc47d57825ec$export$a0bd0313cbeabd49)(routes, {
        location: history.location,
        basePath: basePath
    });
    plugins.forEach((p)=>{
        p.routeLoad == null || p.routeLoad({
            context: context
        });
    });
};







const $56dfe361b58eb7b7$var$_excluded = [
    "children"
];
function $56dfe361b58eb7b7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $56dfe361b58eb7b7$var$hasAdditionalProps(props) {
    for(let i in props)return true;
    return false;
}
function $56dfe361b58eb7b7$export$48f338a7e080595c(Store, _temp) {
    let { selector: selector, displayName: displayName = '' } = _temp === void 0 ? {} : _temp;
    const useStore = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)(Store, {
        selector: selector
    });
    const Subscriber = function Subscriber(_ref) {
        let { children: children } = _ref, rest = $56dfe361b58eb7b7$var$_objectWithoutPropertiesLoose(_ref, $56dfe361b58eb7b7$var$_excluded);
        const api = useStore($56dfe361b58eb7b7$var$hasAdditionalProps(rest) ? rest : undefined);
        return children(...api);
    };
    Subscriber.displayName = displayName || `Subscriber(${Store.key.split('__')[0]})`;
    return Subscriber;
}




const $5d57ecbfe3b77e12$export$9ccb639b7a119f61 = ()=>Date.now();



const $bcec6d01a9b8b822$export$881d135f98d8d7d0 = 100;
const $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34 = false;
const $bcec6d01a9b8b822$export$12c1dc38ea1692da = 0;



const $77fa9025423fc23c$export$b65d7ba7fbf150f1 = (maxAge)=>Date.now() + maxAge;
const $77fa9025423fc23c$export$18d1d420fd588368 = (slice, maxAge)=>slice.expiresAt === null ? (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, slice, {
        expiresAt: $77fa9025423fc23c$export$b65d7ba7fbf150f1(maxAge)
    }) : slice;


const $108ac836d0c63e52$export$58634b3a58ae66b7 = (duration)=>{
    const promiseState = {
        timerId: null,
        isPending: true,
        promise: undefined
    };
    promiseState.promise = new Promise((r)=>{
        const timerId = setTimeout(()=>{
            promiseState.isPending = false;
            r();
        }, duration);
        promiseState.timerId = timerId;
    });
    return promiseState;
};


class $7f0f2ac24b55a8af$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super('Resource timed out: ' + message);
        this.name = 'TimeoutError';
    }
}


const $ac913cdf516a6c19$export$37d3126be6549b13 = 10000;


function $9f82c6853cb9305f$export$dc62515c8f0b52dd({ context: context, dependencies: dependencies, options: options, resource: resource, routerStoreContext: routerStoreContext }) {
    var _promiseOrData, _resource$maxAge;
    const { type: type, getData: getData } = resource;
    const { prefetch: prefetch, timeout: timeout } = options;
    // hard errors in dependencies or getData are converted into softer async error
    let promiseOrData;
    try {
        promiseOrData = getData((0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, routerStoreContext, {
            isPrefetch: !!prefetch,
            dependencies: dependencies()
        }), context);
    } catch (error) {
        promiseOrData = Promise.reject(error);
    }
    // ensure the promise includes any timeout error
    const timeoutGuard = timeout ? (0, $108ac836d0c63e52$export$58634b3a58ae66b7)(timeout) : null;
    // check if getData was sync, by looking for a Promise-like shape
    const data = typeof ((_promiseOrData = promiseOrData) == null ? void 0 : _promiseOrData.then) === 'function' ? undefined : promiseOrData;
    const promise = timeout ? Promise.race([
        promiseOrData,
        timeoutGuard == null ? void 0 : timeoutGuard.promise
    ]).then((maybeData)=>{
        if (timeoutGuard && !timeoutGuard.isPending) throw new (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c)(type);
        (timeoutGuard == null ? void 0 : timeoutGuard.timerId) && clearTimeout(timeoutGuard.timerId);
        return maybeData;
    }) : // if we already have a result, wrap it so consumers can access it via same API
    data !== undefined ? Promise.resolve(data) : promiseOrData;
    const resourceMaxAge = (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((_resource$maxAge = resource.maxAge) != null ? _resource$maxAge : (0, $bcec6d01a9b8b822$export$12c1dc38ea1692da));
    return {
        promise: promise,
        data: data,
        expiresAt: prefetch ? Math.max(resourceMaxAge, (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((0, $ac913cdf516a6c19$export$37d3126be6549b13))) : resourceMaxAge
    };
}



/**
 * Utility method to created async versions of getData functions
 */ const $7b970af4b8ce2c1d$var$handleGetDataLoader = (asyncImport)=>async (...args)=>{
        const { default: getDataFn } = await asyncImport();
        return getDataFn(...args);
    };
const $7b970af4b8ce2c1d$export$edd172c6c83c39cc = (arg)=>{
    var _getData, _arg$depends;
    return {
        type: arg.type,
        getKey: arg.getKey,
        getData: (_getData = arg.getData) != null ? _getData : $7b970af4b8ce2c1d$var$handleGetDataLoader(arg.getDataLoader),
        maxAge: typeof arg.maxAge === 'number' ? arg.maxAge : (0, $bcec6d01a9b8b822$export$12c1dc38ea1692da),
        maxCache: typeof arg.maxCache === 'number' ? arg.maxCache : (0, $bcec6d01a9b8b822$export$881d135f98d8d7d0),
        isBrowserOnly: typeof arg.isBrowserOnly === 'boolean' ? arg.isBrowserOnly : (0, $bcec6d01a9b8b822$export$9ab5bdcb8a1d6c34),
        depends: (_arg$depends = arg.depends) != null ? _arg$depends : null
    };
};







/**
 * The base defaults which should be fed into any factory that needs to derive other props.
 */ const $2fd0617e74ae762e$export$2df85a734ff5ed27 = {
    data: null,
    error: null,
    loading: false,
    promise: null
};


const $11ddcb99c77f2a5f$export$fa8e33c3301e2e94 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, (0, $2fd0617e74ae762e$export$2df85a734ff5ed27), {
        expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)((0, $bcec6d01a9b8b822$export$12c1dc38ea1692da)),
        accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
    });




function $c2289db837328500$var$_toPropertyKey(t) {
    var i = $c2289db837328500$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : String(i);
}
function $c2289db837328500$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $c2289db837328500$export$11374758be89e40 = (type, key)=>({ getState: getState })=>{
        var _prefetching$type;
        const { prefetching: prefetching } = getState();
        const slice = prefetching == null || (_prefetching$type = prefetching[type]) == null ? void 0 : _prefetching$type[key];
        // check if slice is still fresh
        if (slice && Date.now() < Number(slice.expiresAt)) return slice;
        return undefined;
    };
const $c2289db837328500$export$1e32615dc8354436 = (type, key, slice)=>({ setState: setState, getState: getState })=>{
        var _prefetching$type2, _slice$promise;
        const { prefetching: prefetching } = getState();
        // avoid doing extra set if same value
        if ((prefetching == null || (_prefetching$type2 = prefetching[type]) == null ? void 0 : _prefetching$type2[key]) === slice) return;
        // cheap optimisation to provide prefetched result syncronously
        slice == null || (_slice$promise = slice.promise) == null || _slice$promise.then((maybeData)=>slice.data = maybeData);
        setState({
            prefetching: (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, prefetching, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, prefetching == null ? void 0 : prefetching[type], {
                    [key]: slice
                })
            })
        });
    };
const $c2289db837328500$export$704f800f263b050e = (type, key, state)=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { data: data } = getState();
        // every time we override a resource we kill its prefetched
        dispatch($c2289db837328500$export$1e32615dc8354436(type, key, undefined));
        setState({
            data: (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, data, {
                [type]: (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, data[type] || {}, {
                    [key]: state
                })
            })
        });
    };
const $c2289db837328500$export$5fc90c33b03fffb = (type, key)=>({ getState: getState })=>{
        const { data: { [type]: resourceDataForType } } = getState();
        return resourceDataForType == null ? void 0 : resourceDataForType[key];
    };
const $c2289db837328500$export$d40f35dc5952864b = (type, key)=>({ getState: getState, setState: setState })=>{
        const { data: data } = getState();
        const { [type]: resourceForType } = data, remainingData = (0, (/*@__PURE__*/$parcel$interopDefault($0d5e64210d12b637$exports)))(data, [
            type
        ].map($c2289db837328500$var$_toPropertyKey));
        if (key === undefined) setState({
            data: remainingData
        });
        else if (resourceForType) {
            const remainingForType = (0, (/*@__PURE__*/$parcel$interopDefault($0d5e64210d12b637$exports)))(resourceForType, [
                key
            ].map($c2289db837328500$var$_toPropertyKey));
            setState({
                data: (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, remainingData, {
                    [type]: remainingForType
                })
            });
        }
    };


var $1114b4ff1105d34f$var$_Object$fromEntries;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/fromEntries
const $1114b4ff1105d34f$var$fromEntries = ($1114b4ff1105d34f$var$_Object$fromEntries = Object.fromEntries) != null ? $1114b4ff1105d34f$var$_Object$fromEntries : (entries)=>Object.assign({}, ...entries.map(([k, v])=>({
            [k]: v
        })));
const $1114b4ff1105d34f$var$matchType = (a)=>(b)=>{
        const [{ type: typeA }] = Array.isArray(a) ? a : [
            a
        ];
        const [{ type: typeB }] = Array.isArray(b) ? b : [
            b
        ];
        return typeA === typeB;
    };
class $1114b4ff1105d34f$export$492ad57edfe1e919 extends Error {
    constructor(message){
        super(message);
        this.name = 'ResourceDependencyError';
    }
}
const $1114b4ff1105d34f$export$12600f2e0e7fb2cc = (routeResources, tuples)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        var _routeResources$some;
        if (getState().executing) throw new Error('execution is already in progress');
        // check if there are resources and if so if there are any resources with dependencies
        const hasDependentResources = (_routeResources$some = routeResources == null ? void 0 : routeResources.some(({ depends: depends })=>depends == null ? void 0 : depends.length)) != null ? _routeResources$some : false;
        if (!hasDependentResources) return tuples.map(([, action])=>dispatch(action));
        // some resources might not be listed on the route resources so must be dispatched separate from executing state
        const listedTuples = tuples.filter(([resource])=>routeResources == null ? void 0 : routeResources.some($1114b4ff1105d34f$var$matchType(resource)));
        if (listedTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // accumulate the dependency types for all executing resources
        // find downstream resources that may also execute and include their dependencies too
        // include the resource type as well in the list
        // we don't validate that these are legal dependencies
        const [dependentTypes] = routeResources.reduce((acc, { type: type, depends: depends })=>{
            const [dependencies, executableTypes] = acc;
            const isExecutable = executableTypes.includes(type) || !!(depends != null && depends.some((dependency)=>executableTypes.includes(dependency)));
            return isExecutable ? [
                depends ? [
                    ...dependencies,
                    ...depends,
                    type
                ] : dependencies,
                [
                    ...executableTypes,
                    type
                ]
            ] : acc;
        }, [
            [],
            listedTuples.map(([{ type: type }])=>type)
        ]).filter((v, i, a)=>a.indexOf(v) === i);
        // resources that are completely independent are preferable to be dispatched separate from executing state
        const dependentTuples = listedTuples.filter(([{ type: type }])=>dependentTypes.includes(type));
        if (dependentTuples.length === 0) return tuples.map(([, action])=>dispatch(action));
        // additionally find all direct dependencies of these executing or possibly executing resources
        // we don't validate that these are legal dependencies
        const dependentAndDependencyTypes = routeResources.filter(({ type: type })=>dependentTypes.includes(type)).reduce((acc, { type: type, depends: depends })=>depends ? [
                ...acc,
                ...depends,
                type
            ] : [
                ...acc,
                type
            ], []).filter((v, i, a)=>a.indexOf(v) === i);
        // setup executing tuples in route resource order
        // this state allows actions to call executeForDependents() to influence actions that follow
        // the list includes dependency resources so that getDependencies() may validate without needing route resources
        // we use the resource definition of the given tuple where present or otherwise the definition from route resources
        const executingTuples = routeResources.filter(({ type: type })=>dependentAndDependencyTypes.includes(type)).map((resource)=>{
            var _tuples$find;
            return (_tuples$find = tuples.find($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$find : [
                resource,
                null
            ];
        });
        setState({
            executing: executingTuples
        });
        // dispatch sequentially during which executeForDependents() can cause tuples to change
        const executedResults = executingTuples.map(([{ type: expectedType }], i)=>{
            var _getState$executing;
            const latestTuple = (_getState$executing = getState().executing) == null ? void 0 : _getState$executing[i];
            const [{ type: latestType }, maybeAction] = latestTuple != null ? latestTuple : [
                {}
            ];
            if (latestType !== expectedType) {
                setState({
                    executing: null
                });
                throw new Error('execution reached an inconsistent state');
            }
            return maybeAction ? dispatch(maybeAction) : undefined;
        });
        setState({
            executing: null
        });
        // pick existing execution result or dispatch any remaining independent actions
        return tuples.map(([resource, action])=>{
            const index = executingTuples.findIndex($1114b4ff1105d34f$var$matchType(resource));
            return index < 0 ? dispatch(action) : executedResults[index];
        });
    };
const $1114b4ff1105d34f$export$5f7e1fd85734e71e = (routeResources, resource, action)=>({ dispatch: dispatch })=>dispatch($1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, [
            [
                resource,
                action
            ]
        ]))[0];
const $1114b4ff1105d34f$export$f71a65c89c987a02 = (routeResources, resources, actionCreator)=>$1114b4ff1105d34f$export$12600f2e0e7fb2cc(routeResources, resources.map((resource)=>[
            resource,
            actionCreator(resource)
        ]));
const $1114b4ff1105d34f$export$7d1ffac63c68405d = (resource, actionCreator)=>({ getState: getState, setState: setState })=>{
        var _tuples$findIndex;
        const { executing: tuples } = getState();
        // find the given resource in the currently executing tuples
        const indexForResource = (_tuples$findIndex = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex : -1;
        if (indexForResource < 0) return;
        // find dependent resources following given resource and revise their action
        const executing = tuples.map((tuple, i)=>{
            var _tupleResource$depend;
            const [tupleResource] = tuple;
            return i > indexForResource && (_tupleResource$depend = tupleResource.depends) != null && _tupleResource$depend.includes(resource.type) ? [
                tupleResource,
                actionCreator(tupleResource)
            ] : tuple;
        });
        setState({
            executing: executing
        });
    };
const $1114b4ff1105d34f$export$75915f81f2a6540a = (resource, routerStoreContext, options)=>({ getState: getState, dispatch: dispatch })=>{
        var _tuples$findIndex2;
        const { type: type, depends: depends } = resource;
        // optimise the case of no dependencies
        if (!(depends != null && depends.length)) return {};
        const { executing: tuples, context: resourceStoreContext } = getState();
        // dependent resource cannot be called outside execution state
        // find the given resource type in the currently executing tuples
        const indexForResource = (_tuples$findIndex2 = tuples == null ? void 0 : tuples.findIndex($1114b4ff1105d34f$var$matchType(resource))) != null ? _tuples$findIndex2 : -1;
        if (indexForResource < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" has dependencies so must not be missing`);
        // find tuples index for all the dependency elements
        const dependencyIndexTuples = depends.map((dependency)=>[
                dependency,
                tuples.findIndex($1114b4ff1105d34f$var$matchType({
                    type: dependency
                }))
            ]);
        // we rely on executing tuples including all dependencies of the caller resource
        dependencyIndexTuples.forEach(([dependency, index])=>{
            if (index < 0) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Missing resource: "${type}" depends "${dependency}" which is missing`);
            if (index > indexForResource) throw new $1114b4ff1105d34f$export$492ad57edfe1e919(`Illegal dependency: "${type}" depends "${dependency}" so "${dependency}" must precede "${type}"`);
        });
        return $1114b4ff1105d34f$var$fromEntries(dependencyIndexTuples.map(([dependencyType, index])=>{
            const { getKey: getKey } = tuples[index][0];
            const key = getKey(routerStoreContext, resourceStoreContext);
            let slice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(dependencyType, key)) || (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
            // when prefetching we provide only the promise to dependands
            const prefetchSlice = options.prefetch ? dispatch((0, $c2289db837328500$export$11374758be89e40)(dependencyType, key)) : undefined;
            if (prefetchSlice) slice = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, slice, {
                // not spreading prefetchSlice to persist previous slice data
                promise: prefetchSlice.promise,
                expiresAt: prefetchSlice.expiresAt,
                loading: true
            });
            return [
                dependencyType,
                slice
            ];
        }));
    };





const $8f855b3c85bfcd50$export$c616b176adf9ad4a = (resource, routerStoreContext, resourceStoreContext)=>{
    const { type: type, getKey: getKey } = resource;
    const key = getKey(routerStoreContext, resourceStoreContext);
    return `${type}/${key}`;
};
const $8f855b3c85bfcd50$export$cd7fbe7e979df558 = (resources, routerStoreContext, resourceStoreContext)=>resources.map((resource)=>$8f855b3c85bfcd50$export$c616b176adf9ad4a(resource, routerStoreContext, resourceStoreContext));



const $7ae785bb12efd361$export$740886389191c640 = (route)=>!!(route && route.resources && route.resources.length > 0);
const $7ae785bb12efd361$export$221027ff1aa38f82 = (prev, next)=>prev.name !== next.name || prev.path !== next.path;


const $22771f91a0427f12$export$7cbbc763e2f3d65d = (prevRouterStoreContext, nextRouterStoreContext, resourceStoreContext)=>{
    const { route: prevRoute } = prevRouterStoreContext;
    const { resources: prevResources = [] } = prevRoute || {};
    const { route: nextRoute } = nextRouterStoreContext;
    const { resources: nextResources = [] } = nextRoute || {};
    if (!(0, $7ae785bb12efd361$export$740886389191c640)(nextRoute)) return [];
    if ((0, $7ae785bb12efd361$export$221027ff1aa38f82)(prevRoute, nextRoute)) return nextResources;
    const prevResourceIdentifiers = (0, $8f855b3c85bfcd50$export$cd7fbe7e979df558)(prevResources, prevRouterStoreContext, resourceStoreContext);
    return nextResources.filter((resource)=>!prevResourceIdentifiers.includes((0, $8f855b3c85bfcd50$export$c616b176adf9ad4a)(resource, nextRouterStoreContext, resourceStoreContext)));
};



const $e5451870b07c58fa$export$65824bf86829963 = (routeResourceDataForType, currentKey)=>Object.keys(routeResourceDataForType).filter((resourceDataKey)=>{
        const { [resourceDataKey]: { expiresAt: expiresAt } } = routeResourceDataForType;
        return resourceDataKey !== currentKey && expiresAt && expiresAt <= Date.now();
    });
const $e5451870b07c58fa$export$6288d3096045088f = (maxCache, resourceDataForType, currentKey)=>{
    if (maxCache === Infinity || maxCache < 1) return null;
    const resourceDataKeys = Object.keys(resourceDataForType);
    if (resourceDataKeys.length < maxCache) return null;
    const expiredResourceDataKeys = $e5451870b07c58fa$export$65824bf86829963(resourceDataForType, currentKey);
    if (expiredResourceDataKeys.length > 0) return expiredResourceDataKeys[0];
    return resourceDataKeys.reduce((leastRecentKey, key)=>{
        const { [key]: { accessedAt: accessedAt }, [leastRecentKey]: { accessedAt: leastRecentAccessedAt } } = resourceDataForType;
        if (accessedAt && leastRecentAccessedAt && accessedAt < leastRecentAccessedAt) return key;
        return leastRecentKey;
    }, resourceDataKeys[0]);
};
const $e5451870b07c58fa$export$89440b7623c2c75c = (resource, key)=>({ getState: getState, dispatch: dispatch })=>{
        const { type: type, maxCache: maxCache } = resource;
        const { data: { [type]: resourceDataForType } } = getState();
        if (!resourceDataForType) return;
        const keyTobeDeleted = $e5451870b07c58fa$export$6288d3096045088f(maxCache, resourceDataForType, key);
        if (!keyTobeDeleted) return;
        dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, keyTobeDeleted));
    };




// NOTE! This has been copy pasted from https://github.com/sindresorhus/serialize-error/blob/master/index.js
// When the router moves to its own package, this must become a dependency
// For now, we have put it here so that we don't need to get it included in Jira's vendor bundle
class $a501e17e10f67e01$var$NonError extends Error {
    constructor(message){
        super(message);
        this.name = 'NonError';
        if (Error.captureStackTrace) Error.captureStackTrace(this, $a501e17e10f67e01$var$NonError);
    }
}
const $a501e17e10f67e01$var$commonProperties = [
    'name',
    'message',
    'stack',
    'code'
];
const $a501e17e10f67e01$var$destroyCircular = (from, seen, to_)=>{
    const to = to_ || (Array.isArray(from) ? [] : {});
    seen.push(from);
    for (const [key, value] of Object.entries(from)){
        if (typeof value === 'function') continue;
        if (!value || typeof value !== 'object') {
            to[key] = value;
            continue;
        }
        if (!seen.includes(from[key])) {
            to[key] = $a501e17e10f67e01$var$destroyCircular(from[key], seen.slice());
            continue;
        }
        to[key] = '[Circular]';
    }
    for (const property of $a501e17e10f67e01$var$commonProperties)if (typeof from[property] === 'string') to[property] = from[property];
    return to;
};
const $a501e17e10f67e01$export$46ff38bc6bdea8fb = (value)=>{
    if (typeof value === 'object' && value !== null) return $a501e17e10f67e01$var$destroyCircular(value, []);
    // People sometimes throw things besides Error objects…
    if (typeof value === 'function') // `JSON.stringify()` discards functions. We do too, unless a function is thrown directly.
    return `[Function: ${value.name || 'anonymous'}]`;
    return value;
};
const $a501e17e10f67e01$export$64cddc1e268e9046 = (value)=>{
    if (value instanceof Error) return value;
    if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
        const newError = new Error();
        $a501e17e10f67e01$var$destroyCircular(value, [], newError);
        return newError;
    }
    return new $a501e17e10f67e01$var$NonError(value);
};


const $2f8d085a7807db31$export$b25d2963b8a3488a = ({ expiresAt: expiresAt })=>expiresAt === null;
const $2f8d085a7807db31$var$isFresh = (resource)=>{
    if ($2f8d085a7807db31$export$b25d2963b8a3488a(resource)) return true;
    return Date.now() < Number(resource.expiresAt);
};
const $2f8d085a7807db31$export$399de8c43d0ece3c = (resource)=>{
    var _resource$error;
    if ((resource == null || (_resource$error = resource.error) == null ? void 0 : _resource$error.name) === 'TimeoutError') return false;
    if (resource.loading) return true;
    if ($2f8d085a7807db31$var$isFresh(resource)) return true;
    return false;
};



const $4798122614ec3b45$export$2e4da1b414980956 = (slice)=>slice.promise === null ? (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, slice, {
        promise: Promise.resolve(slice.data)
    }) : slice;



const $9de411b0b18cf8f2$export$3ceb62baab058c6b = (data, transformer)=>Object.keys(data).reduce((acc, type)=>{
        if (!acc[type]) acc[type] = {};
        Object.keys(data[type]).forEach((key)=>{
            const slice = data[type][key];
            acc[type][key] = transformer(slice);
        });
        return acc;
    }, {});




const $c80879d114529b7c$export$c9ed509724feb827 = (state, props)=>{
    const { type: type, key: key } = props;
    const slice = state.data[type] && state.data[type][key];
    return slice ? (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, slice) : (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
};
const $c80879d114529b7c$export$6a0b1779210de0ee = (state)=>state.context;



const $325bbf8ea5f9a12e$var$_excluded = [
    "context"
], $325bbf8ea5f9a12e$var$_excluded2 = [
    "error",
    "expiresAt",
    "loading"
];
const $325bbf8ea5f9a12e$export$3f1be494d407b77a = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   */ clearResource: (resource, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            if (routerStoreContext) {
                const key = getKey(routerStoreContext, context);
                dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, key));
                dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(dependentResource, routerStoreContext)));
            } else dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type));
        },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const _getState = getState(), { context: context } = _getState, resourceStoreState = (0, (/*@__PURE__*/$parcel$interopDefault($0d5e64210d12b637$exports)))(_getState, $325bbf8ea5f9a12e$var$_excluded);
            const key = getKey(routerStoreContext, context);
            const prevSlice = (0, $c80879d114529b7c$export$c9ed509724feb827)(resourceStoreState, {
                type: type,
                key: key
            });
            const data = getNewSliceData(prevSlice.data);
            const changes = prevSlice.loading ? {
                data: data,
                error: null,
                loading: true
            } : {
                data: data,
                error: null,
                loading: false,
                promise: Promise.resolve(data)
            };
            const newSlice = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, prevSlice, changes, {
                expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)(maxAge),
                accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
            });
            dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, newSlice));
            // trigger dependent resources on change
            if (newSlice.data !== prevSlice.data) dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, {})));
        },
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   */ getResource: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            let cached = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
            if (cached && (0, $2f8d085a7807db31$export$399de8c43d0ece3c)(cached)) {
                if ((0, $2f8d085a7807db31$export$b25d2963b8a3488a)(cached)) {
                    const withResolvedPromise = (0, $4798122614ec3b45$export$2e4da1b414980956)(cached);
                    cached = (0, $77fa9025423fc23c$export$18d1d420fd588368)(withResolvedPromise, maxAge);
                }
                cached.accessedAt = (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)();
                dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, cached));
                return cached;
            }
            return dispatch($325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options));
        },
    /**
   * Request a single resource and update the resource cache.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey, maxAge: maxAge } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const prevSlice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key)) || (0, $11ddcb99c77f2a5f$export$fa8e33c3301e2e94)();
            // abort request if already in flight
            if (prevSlice.loading) return prevSlice;
            dispatch((0, $e5451870b07c58fa$export$89440b7623c2c75c)(resource, key));
            const loadingSlice = dispatch((0, $c2289db837328500$export$11374758be89e40)(type, key)) || (0, $9f82c6853cb9305f$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $1114b4ff1105d34f$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            let resolvedSlice;
            if (loadingSlice.data === prevSlice.data) // same data (by reference) means nothing has changed and we can avoid loading state
            resolvedSlice = {};
            else {
                // enter loading state
                dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, prevSlice, loadingSlice, {
                    data: maxAge === 0 ? null : prevSlice.data,
                    error: maxAge === 0 ? null : prevSlice.error,
                    loading: true,
                    accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)()
                })));
                // trigger dependent resources to also load
                dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(dependentResource, routerStoreContext, options)));
                // in case another action occurred while loading promise may not be the one we started with
                // we need to re-assign promise consistent with error/data that we are assigning here
                try {
                    var _loadingSlice$data;
                    const data = (_loadingSlice$data = loadingSlice.data) != null ? _loadingSlice$data : await loadingSlice.promise;
                    resolvedSlice = {
                        data: data,
                        error: null,
                        // any existing error is cleared
                        loading: false,
                        promise: loadingSlice.promise
                    };
                } catch (error) {
                    if (error instanceof (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c)) resolvedSlice = {
                        error: // data: do not replace existing data
                        error,
                        loading: true,
                        // this condition cannot recover so must only be present in static/server router
                        promise: null // special case for timeout
                    };
                    else resolvedSlice = {
                        error: // data: do not replace existing data
                        // @ts-ignore
                        error,
                        loading: false,
                        promise: loadingSlice.promise
                    };
                }
            }
            // ensure most recent data when return occurs
            const recentSlice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
            const finalSlice = (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, recentSlice || prevSlice, resolvedSlice, {
                accessedAt: (0, $5d57ecbfe3b77e12$export$9ccb639b7a119f61)(),
                expiresAt: (0, $77fa9025423fc23c$export$b65d7ba7fbf150f1)(maxAge)
            });
            // protect against race conditions: if resources get cleared while await happens, we discard the result
            if (recentSlice || loadingSlice.data !== undefined) dispatch((0, $c2289db837328500$export$704f800f263b050e)(type, key, finalSlice));
            return finalSlice;
        },
    /**
   * Prefetch a single resource and store in the prefetch cache.
   */ prefetchResourceFromRemote: (resource, routerStoreContext, options)=>async ({ getState: getState, dispatch: dispatch })=>{
            const { type: type, getKey: getKey } = resource;
            const { context: context } = getState();
            const key = getKey(routerStoreContext, context);
            const loadingSlice = dispatch((0, $c2289db837328500$export$11374758be89e40)(type, key)) || (0, $9f82c6853cb9305f$export$dc62515c8f0b52dd)({
                context: context,
                dependencies: ()=>dispatch((0, $1114b4ff1105d34f$export$75915f81f2a6540a)(resource, routerStoreContext, options)),
                options: options,
                resource: resource,
                routerStoreContext: routerStoreContext
            });
            // save deferred value to be used also by dependants
            dispatch((0, $c2289db837328500$export$1e32615dc8354436)(type, key, loadingSlice));
            // trigger dependent resources to also prefetch
            dispatch((0, $1114b4ff1105d34f$export$7d1ffac63c68405d)(resource, (dependentResource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(dependentResource, routerStoreContext, options)));
        }
};
const $325bbf8ea5f9a12e$export$e324594224ef24da = {
    /**
   * Clears a resource for the current key, or where context is not provided all keys.
   * Execute such that dependencies on current route will be cleared.
   */ clearResource: (resource, routerStoreContext)=>{
        var _routerStoreContext$r;
        return (0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext == null || (_routerStoreContext$r = routerStoreContext.route) == null ? void 0 : _routerStoreContext$r.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.clearResource(resource, routerStoreContext != null ? routerStoreContext : null));
    },
    /**
   * Update the data property for a resource in the cache and reset expiresAt based
   * on maxAge.
   * Execute such that dependencies on current route will be updated.
   */ updateResourceState: (resource, routerStoreContext, getNewSliceData)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.updateResourceState(resource, routerStoreContext, getNewSliceData)),
    /**
   * Get a single resource, either from the cache if it exists and has not expired, or
   * the remote if it has expired.
   * Execute such that dependencies on current route will be updated.
   */ getResource: (resource, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options)),
    /**
   * Request a single resource and update the resource cache.
   * Execute such that dependencies on current route will be updated.
   */ getResourceFromRemote: (resource, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$5f7e1fd85734e71e)(routerStoreContext.route.resources, resource, $325bbf8ea5f9a12e$export$3f1be494d407b77a.getResourceFromRemote(resource, routerStoreContext, options)),
    /**
   * Request all resources.
   */ requestAllResources: (routerStoreContext, options = {})=>({ dispatch: dispatch })=>{
            const { route: routeDefault } = routerStoreContext || {};
            const route = routeDefault;
            if (!route || !route.resources) return Promise.all([]);
            return Promise.all(dispatch($325bbf8ea5f9a12e$export$e324594224ef24da.requestResources(route.resources, routerStoreContext, options)));
        },
    /**
   * Cleans expired resources and resets them back to their initial state.
   * We need to do this when transitioning into a route.
   */ cleanExpiredResources: (resources, routerStoreContext)=>({ getState: getState, dispatch: dispatch })=>{
            const { context: resourceContext } = getState();
            resources.forEach((resource)=>{
                const { type: type, getKey: getKey } = resource;
                const key = getKey(routerStoreContext, resourceContext);
                const slice = dispatch((0, $c2289db837328500$export$5fc90c33b03fffb)(type, key));
                if (slice && (!slice.expiresAt || slice.expiresAt < Date.now())) dispatch((0, $c2289db837328500$export$d40f35dc5952864b)(type, key));
            });
        },
    /**
   * Requests a specific set of resources.
   */ requestResources: (resources, routerStoreContext, options)=>{
        var _resources;
        const predicate = (0, $f9f42a63082f8b8d$export$455cc18296abe008)() ? ({ isBrowserOnly: isBrowserOnly })=>!isBrowserOnly : ()=>true;
        return (0, $1114b4ff1105d34f$export$f71a65c89c987a02)((_resources = routerStoreContext.route.resources) == null ? void 0 : _resources.filter(predicate), resources.filter(predicate), (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.getResource(resource, routerStoreContext, options));
    },
    /**
   * Prefetch a specific set of resources.
   */ prefetchResources: (resources, routerStoreContext, options)=>(0, $1114b4ff1105d34f$export$f71a65c89c987a02)(routerStoreContext.route.resources, resources, (resource)=>$325bbf8ea5f9a12e$export$3f1be494d407b77a.prefetchResourceFromRemote(resource, routerStoreContext, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, options, {
                prefetch: true
            }))),
    /**
   * Hydrates the store with state.
   * Will not override pre-hydrated state.
   */ hydrate: ({ resourceData: resourceData, resourceContext: resourceContext })=>({ getState: getState, setState: setState })=>{
            const { data: data, context: context } = getState();
            function getNextStateValue(prev, next) {
                if (!Object.keys(prev).length && next && Object.keys(next).length) return next;
                return prev;
            }
            const hydratedData = (0, $9de411b0b18cf8f2$export$3ceb62baab058c6b)(getNextStateValue(data, resourceData), (_ref)=>{
                let { error: error, expiresAt: expiresAt, loading: loading } = _ref, rest = (0, (/*@__PURE__*/$parcel$interopDefault($0d5e64210d12b637$exports)))(_ref, $325bbf8ea5f9a12e$var$_excluded2);
                const deserializedError = !error ? null : (0, $a501e17e10f67e01$export$64cddc1e268e9046)(error);
                const isTimeoutError = (deserializedError == null ? void 0 : deserializedError.name) === 'TimeoutError';
                return (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, rest, {
                    expiresAt: isTimeoutError ? Date.now() - 1 : expiresAt,
                    loading: isTimeoutError ? false : loading,
                    error: deserializedError
                });
            });
            setState({
                data: hydratedData,
                context: getNextStateValue(context, resourceContext)
            });
        },
    /**
   * Gets the store's context
   */ getContext: ()=>({ getState: getState })=>getState().context,
    /**
   * Returns safe, portable and rehydratable data.
   */ getSafeData: ()=>({ getState: getState })=>(0, $9de411b0b18cf8f2$export$3ceb62baab058c6b)(getState().data, ({ data: data, key: key, error: error, loading: loading })=>({
                    data: data,
                    key: key,
                    promise: null,
                    expiresAt: null,
                    accessedAt: null,
                    error: !error ? null : (0, $a501e17e10f67e01$export$46ff38bc6bdea8fb)(error instanceof Error ? error : new Error(JSON.stringify(error))),
                    loading: error instanceof (0, $7f0f2ac24b55a8af$export$66d311bf29d5c89c) ? loading : false
                }))
};
const $325bbf8ea5f9a12e$export$94f50dade551bd01 = (0, $1164a01562ee8563$export$f51a9068ac82ea43)({
    initialState: {
        data: {},
        context: {},
        executing: null,
        prefetching: null
    },
    actions: $325bbf8ea5f9a12e$export$e324594224ef24da,
    name: 'router-resources'
});
const $325bbf8ea5f9a12e$export$cc90fb9c37c5589d = (0, $a264dce57acd4232$export$26ae5ca175b4ec5a)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceContainer'
});
const $325bbf8ea5f9a12e$export$fee1a6213543bd78 = (0, $56dfe361b58eb7b7$export$48f338a7e080595c)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    displayName: 'ResourceSelectorSubscriber',
    selector: (state, props)=>(0, $c80879d114529b7c$export$c9ed509724feb827)(state, {
            type: props.resourceType,
            key: props.resourceKey
        })
});
const $325bbf8ea5f9a12e$export$6f6057d42352becb = ()=>// @ts-ignore not providing a scopeId param
    (0, $60909d64c4d3805d$export$9d726ae4880b1060).getStore($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$ac3608e0bb357c7 = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $c80879d114529b7c$export$c9ed509724feb827)
});
const $325bbf8ea5f9a12e$export$98e41a62c9bef75e = (0, $c3bd6dfdb3d51ec8$export$7c643e1d6648e418)($325bbf8ea5f9a12e$export$94f50dade551bd01);
const $325bbf8ea5f9a12e$export$e59f52df235ac7b3 = (0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)($325bbf8ea5f9a12e$export$94f50dade551bd01, {
    selector: (0, $c80879d114529b7c$export$6a0b1779210de0ee)
});



const $f97bd143060a0c12$export$a9bc0bb87abc2c4c = 'resources-plugin';
const $f97bd143060a0c12$var$loadOnUrlChange = (context, prevContext)=>{
    const { requestResources: requestResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
    const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(prevContext, context, getResourceStoreContext());
    return Promise.all(requestResources(nextResources, context, {}));
};
const $f97bd143060a0c12$var$beforeLoad = ({ context: context, nextContext: nextContext })=>{
    const { cleanExpiredResources: cleanExpiredResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
    const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
    cleanExpiredResources(nextResources, nextContext);
};
const $f97bd143060a0c12$export$23ed892c481a96fe = ({ context: initialResourceContext, resourceData: initialResourceData, timeout: timeout })=>{
    let latestLoadedResources = Promise.resolve([]);
    (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.hydrate({
        resourceContext: initialResourceContext,
        resourceData: initialResourceData
    });
    return {
        id: $f97bd143060a0c12$export$a9bc0bb87abc2c4c,
        beforeRouteLoad: $f97bd143060a0c12$var$beforeLoad,
        routeLoad: ({ context: context, prevContext: prevContext })=>{
            const { route: route, match: match, query: query } = context;
            // TODO: in next refactoring add `if (route.resources)` check
            // For now requesting resources for every route even if `resources` prop is missing on Route
            if (prevContext) latestLoadedResources = $f97bd143060a0c12$var$loadOnUrlChange(context, prevContext);
            else latestLoadedResources = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.requestAllResources({
                route: route,
                match: match,
                query: query
            }, {
                timeout: timeout
            });
        },
        routePrefetch: ({ context: context, nextContext: nextContext })=>{
            const { prefetchResources: prefetchResources, getContext: getResourceStoreContext } = (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions;
            const nextResources = (0, $22771f91a0427f12$export$7cbbc763e2f3d65d)(context, nextContext, getResourceStoreContext());
            return {
                resources: prefetchResources(nextResources, nextContext, {})
            };
        },
        getLatestResources: ()=>latestLoadedResources,
        getSerializedResources: async ()=>{
            await latestLoadedResources;
            return (0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().actions.getSafeData();
        }
    };
};



var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");



const $5c5601e773daa875$export$9f6abfd74295843b = (resource, options)=>{
    const actions = (0, $325bbf8ea5f9a12e$export$98e41a62c9bef75e)();
    const { getContext: getRouterContext } = (0, $1ddaa6502d719738$export$ada49399abf7a3a1)();
    // Dynamically generate a router subscriber based on the resource:
    // makes the component re-render only when key changes instead of
    // after every route change
    const useKey = (0, $5FkrB.useMemo)(()=>(0, $c3bd6dfdb3d51ec8$export$e7f733c8fc2b8a24)((0, $1ddaa6502d719738$export$1cf0ecab63b1963c), {
            selector: ({ match: match, query: query, route: route }, keyArg)=>resource.getKey(keyArg != null ? keyArg : {
                    match: match,
                    query: query,
                    route: route
                }, actions.getContext())
        }), [
        resource,
        actions
    ]);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    const key = useKey(options == null ? void 0 : options.routerContext)[0];
    const [slice] = (0, $325bbf8ea5f9a12e$export$ac3608e0bb357c7)({
        type: resource.type,
        key: key
    });
    // we keep route context bound to key, so route context won't refresh
    // unless key changes. This allows refresh to be called on effect cleanup
    // or asynchronously, when route context might already have changed
    const routerContext = (0, $5FkrB.useMemo)(// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
    ()=>(options == null ? void 0 : options.routerContext) || getRouterContext(), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        key
    ]);
    const update = (0, $5FkrB.useCallback)((updater)=>{
        actions.updateResourceState(resource, routerContext, updater);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clear = (0, $5FkrB.useCallback)(()=>{
        actions.clearResource(resource, routerContext);
    }, [
        resource,
        routerContext,
        actions
    ]);
    const clearAll = (0, $5FkrB.useCallback)(()=>{
        actions.clearResource(resource);
    }, [
        resource,
        actions
    ]);
    const refresh = (0, $5FkrB.useCallback)(()=>{
        actions.getResourceFromRemote(resource, routerContext, {
            prefetch: false
        });
    }, [
        resource,
        routerContext,
        actions
    ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, slice, {
        update: update,
        key: key,
        refresh: refresh,
        clear: clear,
        clearAll: clearAll
    });
};


const $b4ab5dace00b8583$export$fee1a6213543bd78 = ({ children: children, resource: resource, options: options })=>{
    const result = (0, $5c5601e773daa875$export$9f6abfd74295843b)(resource, options);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(result));
};




const $57615bd5aef4bc45$export$dee7bf9fc0ff48c3 = (fn)=>(0, $325bbf8ea5f9a12e$export$6f6057d42352becb)().storeState.subscribe(fn);




const $57d0234526918c1c$export$d4864d13105dc5ed = {
    loading: false,
    error: null,
    data: {
        foo: 'bar'
    },
    promise: null,
    expiresAt: Date.now(),
    accessedAt: Date.now(),
    key: ''
};







parcelRequire("5FkrB");

var $810bb85dfd1fd032$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ 'use strict';
var $28ad538f41ed45f8$exports = {};
'use strict';
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */ var $28ad538f41ed45f8$var$_uppercasePattern = /([A-Z])/g;
/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */ function $28ad538f41ed45f8$var$hyphenate(string) {
    return string.replace($28ad538f41ed45f8$var$_uppercasePattern, '-$1').toLowerCase();
}
$28ad538f41ed45f8$exports = $28ad538f41ed45f8$var$hyphenate;


var $810bb85dfd1fd032$var$msPattern = /^ms-/;
/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */ function $810bb85dfd1fd032$var$hyphenateStyleName(string) {
    return $28ad538f41ed45f8$exports(string).replace($810bb85dfd1fd032$var$msPattern, '-ms-');
}
$810bb85dfd1fd032$exports = $810bb85dfd1fd032$var$hyphenateStyleName;



var $5FkrB = parcelRequire("5FkrB");
var $64302b0f26692d6c$exports = {};
/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */ (function(factory) {
    $64302b0f26692d6c$exports = factory(null);
})(/** @param {*=} options */ function factory(options) {
    'use strict';
    /**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */ var nullptn = /^\0+/g /* matches leading null characters */ ;
    var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */ ;
    var colonptn = /: */g /* splits animation rules */ ;
    var cursorptn = /zoo|gra/ /* assert cursor varient */ ;
    var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */ ;
    var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */ ;
    var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */ ;
    var elementptn = / *[\0] */g /* selector elements */ ;
    var selectorptn = /,\r+?/g /* splits selectors */ ;
    var andptn = /([\t\r\n ])*\f?&/g /* match & */ ;
    var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */ ;
    var invalidptn = /\W+/g /* removes invalid characters from keyframes */ ;
    var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */ ;
    var plcholdrptn = /::(place)/g /* match ::placeholder varient */ ;
    var readonlyptn = /:(read-only)/g /* match :read-only varient */ ;
    var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */ ;
    var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */ ;
    var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */ ;
    var whiteptn = /\s{2,}/g /* matches repeating whitespace */ ;
    var pseudoptn = /([^\(])(:+) */g /* pseudo element */ ;
    var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */ ;
    var gradientptn = /([\w-]+t\()/g /* match *gradient property */ ;
    var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */ ;
    var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */ ;
    var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */ ;
    var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */ ;
    var trimptn = /[ \t]+$/ /* match tail whitspace */ ;
    var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */ ;
    var imgsrcptn = /([^-])(image-set\()/;
    /* vendors */ var webkit = '-webkit-';
    var moz = '-moz-';
    var ms = '-ms-';
    /* character codes */ var SEMICOLON = 59 /* ; */ ;
    var CLOSEBRACES = 125 /* } */ ;
    var OPENBRACES = 123 /* { */ ;
    var OPENPARENTHESES = 40 /* ( */ ;
    var CLOSEPARENTHESES = 41 /* ) */ ;
    var OPENBRACKET = 91 /* [ */ ;
    var CLOSEBRACKET = 93 /* ] */ ;
    var NEWLINE = 10 /* \n */ ;
    var CARRIAGE = 13 /* \r */ ;
    var TAB = 9 /* \t */ ;
    var AT = 64 /* @ */ ;
    var SPACE = 32 /*   */ ;
    var AND = 38 /* & */ ;
    var DASH = 45 /* - */ ;
    var UNDERSCORE = 95 /* _ */ ;
    var STAR = 42 /* * */ ;
    var COMMA = 44 /* , */ ;
    var COLON = 58 /* : */ ;
    var SINGLEQUOTE = 39 /* ' */ ;
    var DOUBLEQUOTE = 34 /* " */ ;
    var FOWARDSLASH = 47 /* / */ ;
    var GREATERTHAN = 62 /* > */ ;
    var PLUS = 43 /* + */ ;
    var TILDE = 126 /* ~ */ ;
    var NULL = 0 /* \0 */ ;
    var FORMFEED = 12 /* \f */ ;
    var VERTICALTAB = 11 /* \v */ ;
    /* special identifiers */ var KEYFRAME = 107 /* k */ ;
    var MEDIA = 109 /* m */ ;
    var SUPPORTS = 115 /* s */ ;
    var PLACEHOLDER = 112 /* p */ ;
    var READONLY = 111 /* o */ ;
    var IMPORT = 105 /* <at>i */ ;
    var CHARSET = 99 /* <at>c */ ;
    var DOCUMENT = 100 /* <at>d */ ;
    var PAGE = 112 /* <at>p */ ;
    var column = 1 /* current column */ ;
    var line = 1 /* current line numebr */ ;
    var pattern = 0 /* :pattern */ ;
    var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */ ;
    var prefix = 1 /* vendor prefix */ ;
    var escape = 1 /* escape :global() pattern */ ;
    var compress = 0 /* compress output */ ;
    var semicolon = 0 /* no/semicolon option */ ;
    var preserve = 0 /* preserve empty selectors */ ;
    /* empty reference */ var array = [];
    /* plugins */ var plugins = [];
    var plugged = 0;
    var should = null;
    /* plugin context */ var POSTS = -2;
    var PREPS = -1;
    var UNKWN = 0;
    var PROPS = 1;
    var BLCKS = 2;
    var ATRUL = 3;
    /* plugin newline context */ var unkwn = 0;
    /* keyframe animation */ var keyed = 1;
    var key = '';
    /* selector namespace */ var nscopealt = '';
    var nscope = '';
    /**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */ function compile(parent, current, body, id, depth) {
        var bracket = 0 /* brackets [] */ ;
        var comment = 0 /* comments /* // or /* */ ;
        var parentheses = 0 /* functions () */ ;
        var quote = 0 /* quotes '', "" */ ;
        var first = 0 /* first character code */ ;
        var second = 0 /* second character code */ ;
        var code = 0 /* current character code */ ;
        var tail = 0 /* previous character code */ ;
        var trail = 0 /* character before previous code */ ;
        var peak = 0 /* previous non-whitespace code */ ;
        var counter = 0 /* count sequence termination */ ;
        var context = 0 /* track current context */ ;
        var atrule = 0 /* track @at-rule context */ ;
        var pseudo = 0 /* track pseudo token index */ ;
        var caret = 0 /* current character index */ ;
        var format = 0 /* control character formating context */ ;
        var insert = 0 /* auto semicolon insertion */ ;
        var invert = 0 /* inverted selector pattern */ ;
        var length = 0 /* generic length address */ ;
        var eof = body.length /* end of file(length) */ ;
        var eol = eof - 1 /* end of file(characters) */ ;
        var char = '' /* current character */ ;
        var chars = '' /* current buffer of characters */ ;
        var child = '' /* next buffer of characters */ ;
        var out = '' /* compiled body */ ;
        var children = '' /* compiled children */ ;
        var flat = '' /* compiled leafs */ ;
        var selector /* generic selector address */ ;
        var result /* generic address */ ;
        // ...build body
        while(caret < eof){
            code = body.charCodeAt(caret);
            // eof varient
            if (caret === eol) // last character + noop context, add synthetic padding for noop context to terminate
            {
                if (comment + quote + parentheses + bracket !== 0) {
                    if (comment !== 0) code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH;
                    quote = parentheses = bracket = 0;
                    eof++;
                    eol++;
                }
            }
            if (comment + quote + parentheses + bracket === 0) {
                // eof varient
                if (caret === eol) {
                    if (format > 0) chars = chars.replace(formatptn, '');
                    if (chars.trim().length > 0) {
                        switch(code){
                            case SPACE:
                            case TAB:
                            case SEMICOLON:
                            case CARRIAGE:
                            case NEWLINE:
                                break;
                            default:
                                chars += body.charAt(caret);
                        }
                        code = SEMICOLON;
                    }
                }
                // auto semicolon insertion
                if (insert === 1) switch(code){
                    // false flags
                    case OPENBRACES:
                    case CLOSEBRACES:
                    case SEMICOLON:
                    case DOUBLEQUOTE:
                    case SINGLEQUOTE:
                    case OPENPARENTHESES:
                    case CLOSEPARENTHESES:
                    case COMMA:
                        insert = 0;
                    // ignore
                    case TAB:
                    case CARRIAGE:
                    case NEWLINE:
                    case SPACE:
                        break;
                    // valid
                    default:
                        insert = 0;
                        length = caret;
                        first = code;
                        caret--;
                        code = SEMICOLON;
                        while(length < eof)switch(body.charCodeAt(length++)){
                            case NEWLINE:
                            case CARRIAGE:
                            case SEMICOLON:
                                ++caret;
                                code = first;
                                length = eof;
                                break;
                            case COLON:
                                if (format > 0) {
                                    ++caret;
                                    code = first;
                                }
                            case OPENBRACES:
                                length = eof;
                        }
                }
                // token varient
                switch(code){
                    case OPENBRACES:
                        chars = chars.trim();
                        first = chars.charCodeAt(0);
                        counter = 1;
                        length = ++caret;
                        while(caret < eof){
                            switch(code = body.charCodeAt(caret)){
                                case OPENBRACES:
                                    counter++;
                                    break;
                                case CLOSEBRACES:
                                    counter--;
                                    break;
                                case FOWARDSLASH:
                                    switch(second = body.charCodeAt(caret + 1)){
                                        // /*, //
                                        case STAR:
                                        case FOWARDSLASH:
                                            caret = delimited(second, caret, eol, body);
                                    }
                                    break;
                                // given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
                                case OPENBRACKET:
                                    code++;
                                // given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
                                case OPENPARENTHESES:
                                    code++;
                                // quote tail delimiter is identical to the head delimiter hence noop,
                                // fallthrough clauses have been shifted to the correct tail delimiter
                                case DOUBLEQUOTE:
                                case SINGLEQUOTE:
                                    while(caret++ < eol){
                                        if (body.charCodeAt(caret) === code) break;
                                    }
                            }
                            if (counter === 0) break;
                            caret++;
                        }
                        child = body.substring(length, caret);
                        if (first === NULL) first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0);
                        switch(first){
                            // @at-rule
                            case AT:
                                if (format > 0) chars = chars.replace(formatptn, '');
                                second = chars.charCodeAt(1);
                                switch(second){
                                    case DOCUMENT:
                                    case MEDIA:
                                    case SUPPORTS:
                                    case DASH:
                                        selector = current;
                                        break;
                                    default:
                                        selector = array;
                                }
                                child = compile(current, selector, child, second, depth + 1);
                                length = child.length;
                                // preserve empty @at-rule
                                if (preserve > 0 && length === 0) length = chars.length;
                                // execute plugins, @at-rule context
                                if (plugged > 0) {
                                    selector = select(array, chars, invert);
                                    result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id);
                                    chars = selector.join('');
                                    if (result !== void 0) {
                                        if ((length = (child = result.trim()).length) === 0) {
                                            second = 0;
                                            child = '';
                                        }
                                    }
                                }
                                if (length > 0) switch(second){
                                    case SUPPORTS:
                                        chars = chars.replace(supportsptn, supports);
                                    case DOCUMENT:
                                    case MEDIA:
                                    case DASH:
                                        child = chars + '{' + child + '}';
                                        break;
                                    case KEYFRAME:
                                        chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''));
                                        child = chars + '{' + child + '}';
                                        if (prefix === 1 || prefix === 2 && vendor('@' + child, 3)) child = '@' + webkit + child + '@' + child;
                                        else child = '@' + child;
                                        break;
                                    default:
                                        child = chars + child;
                                        if (id === PAGE) child = (out += child, '');
                                }
                                else child = '';
                                break;
                            // selector
                            default:
                                child = compile(current, select(current, chars, invert), child, id, depth + 1);
                        }
                        children += child;
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        atrule = 0;
                        chars = '';
                        child = '';
                        code = body.charCodeAt(++caret);
                        break;
                    case CLOSEBRACES:
                    case SEMICOLON:
                        chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim();
                        if ((length = chars.length) > 1) {
                            // monkey-patch missing colon
                            if (pseudo === 0) {
                                first = chars.charCodeAt(0);
                                // first character is a letter or dash, buffer has a space character
                                if (first === DASH || first > 96 && first < 123) length = (chars = chars.replace(' ', ':')).length;
                            }
                            // execute plugins, property context
                            if (plugged > 0) {
                                if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
                                    if ((length = (chars = result.trim()).length) === 0) chars = '\0\0';
                                }
                            }
                            first = chars.charCodeAt(0);
                            second = chars.charCodeAt(1);
                            switch(first){
                                case NULL:
                                    break;
                                case AT:
                                    if (second === IMPORT || second === CHARSET) {
                                        flat += chars + body.charAt(caret);
                                        break;
                                    }
                                default:
                                    if (chars.charCodeAt(length - 1) === COLON) break;
                                    out += property(chars, first, second, chars.charCodeAt(2));
                            }
                        }
                        // reset
                        context = 0;
                        insert = 0;
                        pseudo = 0;
                        format = 0;
                        invert = 0;
                        chars = '';
                        code = body.charCodeAt(++caret);
                        break;
                }
            }
            // parse characters
            switch(code){
                case CARRIAGE:
                case NEWLINE:
                    // auto insert semicolon
                    if (comment + quote + parentheses + bracket + semicolon === 0) // valid non-whitespace characters that
                    // may precede a newline
                    switch(peak){
                        case CLOSEPARENTHESES:
                        case SINGLEQUOTE:
                        case DOUBLEQUOTE:
                        case AT:
                        case TILDE:
                        case GREATERTHAN:
                        case STAR:
                        case PLUS:
                        case FOWARDSLASH:
                        case DASH:
                        case COLON:
                        case COMMA:
                        case SEMICOLON:
                        case OPENBRACES:
                        case CLOSEBRACES:
                            break;
                        default:
                            // current buffer has a colon
                            if (pseudo > 0) insert = 1;
                    }
                    // terminate line comment
                    if (comment === FOWARDSLASH) comment = 0;
                    else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
                        format = 1;
                        chars += '\0';
                    }
                    // execute plugins, newline context
                    if (plugged * unkwn > 0) proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id);
                    // next line, reset column position
                    column = 1;
                    line++;
                    break;
                case SEMICOLON:
                case CLOSEBRACES:
                    if (comment + quote + parentheses + bracket === 0) {
                        column++;
                        break;
                    }
                default:
                    // increment column position
                    column++;
                    // current character
                    char = body.charAt(caret);
                    // remove comments, escape functions, strings, attributes and prepare selectors
                    switch(code){
                        case TAB:
                        case SPACE:
                            if (quote + bracket + comment === 0) switch(tail){
                                case COMMA:
                                case COLON:
                                case TAB:
                                case SPACE:
                                    char = '';
                                    break;
                                default:
                                    if (code !== SPACE) char = ' ';
                            }
                            break;
                        // escape breaking control characters
                        case NULL:
                            char = '\\0';
                            break;
                        case FORMFEED:
                            char = '\\f';
                            break;
                        case VERTICALTAB:
                            char = '\\v';
                            break;
                        // &
                        case AND:
                            // inverted selector pattern i.e html &
                            if (quote + comment + bracket === 0 && cascade > 0) {
                                invert = 1;
                                format = 1;
                                char = '\f' + char;
                            }
                            break;
                        // ::p<l>aceholder, l
                        // :read-on<l>y, l
                        case 108:
                            if (quote + comment + bracket + pattern === 0 && pseudo > 0) switch(caret - pseudo){
                                // ::placeholder
                                case 2:
                                    if (tail === PLACEHOLDER && body.charCodeAt(caret - 3) === COLON) pattern = tail;
                                // :read-only
                                case 8:
                                    if (trail === READONLY) pattern = trail;
                            }
                            break;
                        // :<pattern>
                        case COLON:
                            if (quote + comment + bracket === 0) pseudo = caret;
                            break;
                        // selectors
                        case COMMA:
                            if (comment + parentheses + quote + bracket === 0) {
                                format = 1;
                                char += '\r';
                            }
                            break;
                        // quotes
                        case DOUBLEQUOTE:
                        case SINGLEQUOTE:
                            if (comment === 0) quote = quote === code ? 0 : quote === 0 ? code : quote;
                            break;
                        // attributes
                        case OPENBRACKET:
                            if (quote + comment + parentheses === 0) bracket++;
                            break;
                        case CLOSEBRACKET:
                            if (quote + comment + parentheses === 0) bracket--;
                            break;
                        // functions
                        case CLOSEPARENTHESES:
                            if (quote + comment + bracket === 0) parentheses--;
                            break;
                        case OPENPARENTHESES:
                            if (quote + comment + bracket === 0) {
                                if (context === 0) switch(tail * 2 + trail * 3){
                                    // :matches
                                    case 533:
                                        break;
                                    // :global, :not, :nth-child etc...
                                    default:
                                        counter = 0;
                                        context = 1;
                                }
                                parentheses++;
                            }
                            break;
                        case AT:
                            if (comment + parentheses + quote + bracket + pseudo + atrule === 0) atrule = 1;
                            break;
                        // block/line comments
                        case STAR:
                        case FOWARDSLASH:
                            if (quote + bracket + parentheses > 0) break;
                            switch(comment){
                                // initialize line/block comment context
                                case 0:
                                    switch(code * 2 + body.charCodeAt(caret + 1) * 3){
                                        // //
                                        case 235:
                                            comment = FOWARDSLASH;
                                            break;
                                        // /*
                                        case 220:
                                            length = caret;
                                            comment = STAR;
                                            break;
                                    }
                                    break;
                                // end block comment context
                                case STAR:
                                    if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
                                        // /*<!> ... */, !
                                        if (body.charCodeAt(length + 2) === 33) out += body.substring(length, caret + 1);
                                        char = '';
                                        comment = 0;
                                    }
                            }
                    }
                    // ignore comment blocks
                    if (comment === 0) {
                        // aggressive isolation mode, divide each individual selector
                        // including selectors in :not function but excluding selectors in :global function
                        if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) switch(code){
                            case COMMA:
                            case TILDE:
                            case GREATERTHAN:
                            case PLUS:
                            case CLOSEPARENTHESES:
                            case OPENPARENTHESES:
                                if (context === 0) {
                                    // outside of an isolated context i.e nth-child(<...>)
                                    switch(tail){
                                        case TAB:
                                        case SPACE:
                                        case NEWLINE:
                                        case CARRIAGE:
                                            char = char + '\0';
                                            break;
                                        default:
                                            char = '\0' + char + (code === COMMA ? '' : '\0');
                                    }
                                    format = 1;
                                } else // within an isolated context, sleep untill it's terminated
                                switch(code){
                                    case OPENPARENTHESES:
                                        // :globa<l>(
                                        if (pseudo + 7 === caret && tail === 108) pseudo = 0;
                                        context = ++counter;
                                        break;
                                    case CLOSEPARENTHESES:
                                        if ((context = --counter) === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                        break;
                                }
                                break;
                            case TAB:
                            case SPACE:
                                switch(tail){
                                    case NULL:
                                    case OPENBRACES:
                                    case CLOSEBRACES:
                                    case SEMICOLON:
                                    case COMMA:
                                    case FORMFEED:
                                    case TAB:
                                    case SPACE:
                                    case NEWLINE:
                                    case CARRIAGE:
                                        break;
                                    default:
                                        // ignore in isolated contexts
                                        if (context === 0) {
                                            format = 1;
                                            char += '\0';
                                        }
                                }
                        }
                        // concat buffer of characters
                        chars += char;
                        // previous non-whitespace character code
                        if (code !== SPACE && code !== TAB) peak = code;
                    }
            }
            // tail character codes
            trail = tail;
            tail = code;
            // visit every character
            caret++;
        }
        length = out.length;
        // preserve empty selector
        if (preserve > 0) {
            if (length === 0 && children.length === 0 && current[0].length === 0 === false) {
                if (id !== MEDIA || current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0]) length = current.join(',').length + 2;
            }
        }
        if (length > 0) {
            // cascade isolation mode?
            selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current;
            // execute plugins, block context
            if (plugged > 0) {
                result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id);
                if (result !== void 0 && (out = result).length === 0) return flat + out + children;
            }
            out = selector.join(',') + '{' + out + '}';
            if (prefix * pattern !== 0) {
                if (prefix === 2 && !vendor(out, 2)) pattern = 0;
                switch(pattern){
                    // ::read-only
                    case READONLY:
                        out = out.replace(readonlyptn, ':' + moz + '$1') + out;
                        break;
                    // ::placeholder
                    case PLACEHOLDER:
                        out = out.replace(plcholdrptn, '::' + webkit + 'input-$1') + out.replace(plcholdrptn, '::' + moz + '$1') + out.replace(plcholdrptn, ':' + ms + 'input-$1') + out;
                        break;
                }
                pattern = 0;
            }
        }
        return flat + out + children;
    }
    /**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */ function select(parent, current, invert) {
        var selectors = current.trim().split(selectorptn);
        var out = selectors;
        var length = selectors.length;
        var l = parent.length;
        switch(l){
            // 0-1 parent selectors
            case 0:
            case 1:
                for(var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i)out[i] = scope(selector, out[i], invert, l).trim();
                break;
            // >2 parent selectors, nested
            default:
                for(var i = 0, j = 0, out = []; i < length; ++i)for(var k = 0; k < l; ++k)out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim();
        }
        return out;
    }
    /**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */ function scope(parent, current, invert, level) {
        var selector = current;
        var code = selector.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (selector = selector.trim()).charCodeAt(0);
        switch(code){
            // &
            case AND:
                switch(cascade + level){
                    case 0:
                    case 1:
                        if (parent.trim().length === 0) break;
                    default:
                        return selector.replace(andptn, '$1' + parent.trim());
                }
                break;
            // :
            case COLON:
                switch(selector.charCodeAt(1)){
                    // g in :global
                    case 103:
                        if (escape > 0 && cascade > 0) return selector.replace(escapeptn, '$1').replace(andptn, '$1' + nscope);
                        break;
                    default:
                        // :hover
                        return parent.trim() + selector.replace(andptn, '$1' + parent.trim());
                }
            default:
                // html &
                if (invert * cascade > 0 && selector.indexOf('\f') > 0) return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1') + parent.trim());
        }
        return parent + selector;
    }
    /**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */ function property(input, first, second, third) {
        var index = 0;
        var out = input + ';';
        var hash = first * 2 + second * 3 + third * 4;
        var cache;
        // animation: a, n, i characters
        if (hash === 944) return animation(out);
        else if (prefix === 0 || prefix === 2 && !vendor(out, 1)) return out;
        // vendor prefix
        switch(hash){
            // text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
            case 1015:
                // text-shadow/text-align/text-transform, a
                return out.charCodeAt(10) === 97 ? webkit + out + out : out;
            // filter/fill f, i, l
            case 951:
                // filter, t
                return out.charCodeAt(3) === 116 ? webkit + out + out : out;
            // color/column, c, o, l
            case 963:
                // column, n
                return out.charCodeAt(5) === 110 ? webkit + out + out : out;
            // box-decoration-break, b, o, x
            case 1009:
                if (out.charCodeAt(4) !== 100) break;
            // mask, m, a, s
            // clip-path, c, l, i
            case 969:
            case 942:
                return webkit + out + out;
            // appearance: a, p, p
            case 978:
                return webkit + out + moz + out + out;
            // hyphens: h, y, p
            // user-select: u, s, e
            case 1019:
            case 983:
                return webkit + out + moz + out + ms + out + out;
            // background/backface-visibility, b, a, c
            case 883:
                // backface-visibility, -
                if (out.charCodeAt(8) === DASH) return webkit + out + out;
                // image-set(...)
                if (out.indexOf('image-set(', 11) > 0) return out.replace(imgsrcptn, '$1' + webkit + '$2') + out;
                return out;
            // flex: f, l, e
            case 932:
                if (out.charCodeAt(4) === DASH) switch(out.charCodeAt(5)){
                    // flex-grow, g
                    case 103:
                        return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out;
                    // flex-shrink, s
                    case 115:
                        return webkit + out + ms + out.replace('shrink', 'negative') + out;
                    // flex-basis, b
                    case 98:
                        return webkit + out + ms + out.replace('basis', 'preferred-size') + out;
                }
                return webkit + out + ms + out + out;
            // order: o, r, d
            case 964:
                return webkit + out + ms + 'flex' + '-' + out + out;
            // justify-items/justify-content, j, u, s
            case 1023:
                // justify-content, c
                if (out.charCodeAt(8) !== 99) break;
                cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify');
                return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out;
            // cursor, c, u, r
            case 1005:
                return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out;
            // writing-mode, w, r, i
            case 1000:
                cache = out.substring(13).trim();
                index = cache.indexOf('-') + 1;
                switch(cache.charCodeAt(0) + cache.charCodeAt(index)){
                    // vertical-lr
                    case 226:
                        cache = out.replace(writingptn, 'tb');
                        break;
                    // vertical-rl
                    case 232:
                        cache = out.replace(writingptn, 'tb-rl');
                        break;
                    // horizontal-tb
                    case 220:
                        cache = out.replace(writingptn, 'lr');
                        break;
                    default:
                        return out;
                }
                return webkit + out + ms + cache + out;
            // position: sticky
            case 1017:
                if (out.indexOf('sticky', 9) === -1) return out;
            // display(flex/inline-flex/inline-box): d, i, s
            case 975:
                index = (out = input).length - 10;
                cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim();
                switch(hash = cache.charCodeAt(0) + (cache.charCodeAt(7) | 0)){
                    // inline-
                    case 203:
                        // inline-box
                        if (cache.charCodeAt(8) < 111) break;
                    // inline-box/sticky
                    case 115:
                        out = out.replace(cache, webkit + cache) + ';' + out;
                        break;
                    // inline-flex
                    // flex
                    case 207:
                    case 102:
                        out = out.replace(cache, webkit + (hash > 102 ? 'inline-' : '') + 'box') + ';' + out.replace(cache, webkit + cache) + ';' + out.replace(cache, ms + cache + 'box') + ';' + out;
                }
                return out + ';';
            // align-items, align-center, align-self: a, l, i, -
            case 938:
                if (out.charCodeAt(5) === DASH) switch(out.charCodeAt(6)){
                    // align-items, i
                    case 105:
                        cache = out.replace('-items', '');
                        return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out;
                    // align-self, s
                    case 115:
                        return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out;
                    // align-content
                    default:
                        return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out;
                }
                break;
            // min/max
            case 973:
            case 989:
                // min-/max- height/width/block-size/inline-size
                if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) break;
            // height/width: min-content / width: max-content
            case 931:
            case 953:
                if (dimensionptn.test(input) === true) {
                    // stretch
                    if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115) return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch');
                    else return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out;
                }
                break;
            // transform, transition: t, r, a
            case 962:
                out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out;
                // transitions
                if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out;
                break;
        }
        return out;
    }
    /**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */ function vendor(content, context) {
        var index = content.indexOf(context === 1 ? ':' : '{');
        var key = content.substring(0, context !== 3 ? index : 10);
        var value = content.substring(index + 1, content.length - 1);
        return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context);
    }
    /**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */ function supports(match, group) {
        var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2));
        return out !== group + ';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '(' + group + ')';
    }
    /**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */ function animation(input) {
        var length = input.length;
        var index = input.indexOf(':', 9) + 1;
        var declare = input.substring(0, index).trim();
        var out = input.substring(index, length - 1).trim();
        switch(input.charCodeAt(9) * keyed){
            case 0:
                break;
            // animation-*, -
            case DASH:
                // animation-name, n
                if (input.charCodeAt(10) !== 110) break;
            // animation/animation-name
            default:
                // split in case of multiple animations
                var list = out.split((out = '', animationptn));
                for(var i = 0, index = 0, length = list.length; i < length; index = 0, ++i){
                    var value = list[i];
                    var items = value.split(propertiesptn);
                    while(value = items[index]){
                        var peak = value.charCodeAt(0);
                        if (keyed === 1 && (// letters
                        peak > AT && peak < 90 || peak > 96 && peak < 123 || peak === UNDERSCORE || // dash but not in sequence i.e --
                        peak === DASH && value.charCodeAt(1) !== DASH)) // not a number/function
                        switch(isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)){
                            case 1:
                                switch(value){
                                    // not a valid reserved keyword
                                    case 'infinite':
                                    case 'alternate':
                                    case 'backwards':
                                    case 'running':
                                    case 'normal':
                                    case 'forwards':
                                    case 'both':
                                    case 'none':
                                    case 'linear':
                                    case 'ease':
                                    case 'ease-in':
                                    case 'ease-out':
                                    case 'ease-in-out':
                                    case 'paused':
                                    case 'reverse':
                                    case 'alternate-reverse':
                                    case 'inherit':
                                    case 'initial':
                                    case 'unset':
                                    case 'step-start':
                                    case 'step-end':
                                        break;
                                    default:
                                        value += key;
                                }
                        }
                        items[index++] = value;
                    }
                    out += (i === 0 ? '' : ',') + items.join(' ');
                }
        }
        out = declare + out + ';';
        if (prefix === 1 || prefix === 2 && vendor(out, 1)) return webkit + out + out;
        return out;
    }
    /**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */ function isolate(current) {
        for(var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i){
            // split individual elements in a selector i.e h1 h2 === [h1, h2]
            var elements = current[i].split(elementptn);
            var out = '';
            for(var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j){
                // empty element
                if ((size = (element = elements[j]).length) === 0 && l > 1) continue;
                tail = out.charCodeAt(out.length - 1);
                code = element.charCodeAt(0);
                padding = '';
                if (j !== 0) // determine if we need padding
                switch(tail){
                    case STAR:
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case OPENPARENTHESES:
                        break;
                    default:
                        padding = ' ';
                }
                switch(code){
                    case AND:
                        element = padding + nscopealt;
                    case TILDE:
                    case GREATERTHAN:
                    case PLUS:
                    case SPACE:
                    case CLOSEPARENTHESES:
                    case OPENPARENTHESES:
                        break;
                    case OPENBRACKET:
                        element = padding + element + nscopealt;
                        break;
                    case COLON:
                        switch(element.charCodeAt(1) * 2 + element.charCodeAt(2) * 3){
                            // :global
                            case 530:
                                if (escape > 0) {
                                    element = padding + element.substring(8, size - 1);
                                    break;
                                }
                            // :hover, :nth-child(), ...
                            default:
                                if (j < 1 || elements[j - 1].length < 1) element = padding + nscopealt + element;
                        }
                        break;
                    case COMMA:
                        padding = '';
                    default:
                        if (size > 1 && element.indexOf(':') > 0) element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2');
                        else element = padding + element + nscopealt;
                }
                out += element;
            }
            selector[i] = out.replace(formatptn, '').trim();
        }
        return selector;
    }
    /**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */ function proxy(context, content, selectors, parents, line, column, length, id, depth, at) {
        for(var i = 0, out = content, next; i < plugged; ++i)switch(next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)){
            case void 0:
            case false:
            case true:
            case null:
                break;
            default:
                out = next;
        }
        if (out !== content) return out;
    }
    /**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */ function delimited(code, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            // /*
            case FOWARDSLASH:
                if (code === STAR) {
                    if (body.charCodeAt(i - 1) === STAR && index + 2 !== i) return i + 1;
                }
                break;
            // //
            case NEWLINE:
                if (code === FOWARDSLASH) return i + 1;
        }
        return i;
    }
    /**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */ function match(type, index, length, body) {
        for(var i = index + 1; i < length; ++i)switch(body.charCodeAt(i)){
            case type:
                return i;
        }
        return i;
    }
    /**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */ function minify(output) {
        return output.replace(formatptn, '').replace(beforeptn, '').replace(afterptn, '$1').replace(tailptn, '$1').replace(whiteptn, ' ');
    }
    /**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */ function use(plugin) {
        switch(plugin){
            case void 0:
            case null:
                plugged = plugins.length = 0;
                break;
            default:
                if (typeof plugin === 'function') plugins[plugged++] = plugin;
                else if (typeof plugin === 'object') for(var i = 0, length = plugin.length; i < length; ++i)use(plugin[i]);
                else unkwn = !!plugin | 0;
        }
        return use;
    }
    /**
	 * Set
	 *
	 * @param {*} options
	 */ function set(options) {
        for(var name in options){
            var value = options[name];
            switch(name){
                case 'keyframe':
                    keyed = value | 0;
                    break;
                case 'global':
                    escape = value | 0;
                    break;
                case 'cascade':
                    cascade = value | 0;
                    break;
                case 'compress':
                    compress = value | 0;
                    break;
                case 'semicolon':
                    semicolon = value | 0;
                    break;
                case 'preserve':
                    preserve = value | 0;
                    break;
                case 'prefix':
                    should = null;
                    if (!value) prefix = 0;
                    else if (typeof value !== 'function') prefix = 1;
                    else {
                        prefix = 2;
                        should = value;
                    }
            }
        }
        return set;
    }
    /**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */ function stylis(selector, input) {
        if (this !== void 0 && this.constructor === stylis) return factory(selector);
        // setup
        var ns = selector;
        var code = ns.charCodeAt(0);
        // trim leading whitespace
        if (code < 33) code = (ns = ns.trim()).charCodeAt(0);
        // keyframe/animation namespace
        if (keyed > 0) key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-');
        // reset, used to assert if a plugin is moneky-patching the return value
        code = 1;
        // cascade/isolate
        if (cascade === 1) nscope = ns;
        else nscopealt = ns;
        var selectors = [
            nscope
        ];
        var result;
        // execute plugins, pre-process context
        if (plugged > 0) {
            result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0);
            if (result !== void 0 && typeof result === 'string') input = result;
        }
        // build
        var output = compile(array, selectors, input, 0, 0);
        // execute plugins, post-process context
        if (plugged > 0) {
            result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0);
            // bypass minification
            if (result !== void 0 && typeof (output = result) !== 'string') code = 0;
        }
        // reset
        key = '';
        nscope = '';
        nscopealt = '';
        pattern = 0;
        line = 1;
        column = 1;
        return compress * code === 0 ? output : minify(output);
    }
    stylis['use'] = use;
    stylis['set'] = set;
    if (options !== void 0) set(options);
    return stylis;
});


var $bdb0654fe2595d49$exports = {};
(function(factory) {
    $bdb0654fe2595d49$exports = factory();
})(function() {
    'use strict';
    return function(insertRule) {
        var delimiter = '/*|*/';
        var needle = delimiter + '}';
        function toSheet(block) {
            if (block) try {
                insertRule(block + '}');
            } catch (e) {}
        }
        return function ruleSheet(context, content, selectors, parents, line, column, length, ns, depth, at) {
            switch(context){
                // property
                case 1:
                    // @import
                    if (depth === 0 && content.charCodeAt(0) === 64) return insertRule(content + ';'), '';
                    break;
                // selector
                case 2:
                    if (ns === 0) return content + delimiter;
                    break;
                // at-rule
                case 3:
                    switch(ns){
                        // @font-face, @page
                        case 102:
                        case 112:
                            return insertRule(selectors[0] + content), '';
                        default:
                            return content + (at === 0 ? delimiter : '');
                    }
                case -2:
                    content.split(needle).forEach(toSheet);
            }
        };
    };
});



var $4f68a738abfc7829$exports = {};
'use strict';
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $4f68a738abfc7829$var$REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $4f68a738abfc7829$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $4f68a738abfc7829$var$defineProperty = Object.defineProperty;
var $4f68a738abfc7829$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $4f68a738abfc7829$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $4f68a738abfc7829$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $4f68a738abfc7829$var$getPrototypeOf = Object.getPrototypeOf;
var $4f68a738abfc7829$var$objectPrototype = $4f68a738abfc7829$var$getPrototypeOf && $4f68a738abfc7829$var$getPrototypeOf(Object);
function $4f68a738abfc7829$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        if ($4f68a738abfc7829$var$objectPrototype) {
            var inheritedComponent = $4f68a738abfc7829$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $4f68a738abfc7829$var$objectPrototype) $4f68a738abfc7829$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $4f68a738abfc7829$var$getOwnPropertyNames(sourceComponent);
        if ($4f68a738abfc7829$var$getOwnPropertySymbols) keys = keys.concat($4f68a738abfc7829$var$getOwnPropertySymbols(sourceComponent));
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$4f68a738abfc7829$var$REACT_STATICS[key] && !$4f68a738abfc7829$var$KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = $4f68a738abfc7829$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $4f68a738abfc7829$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
        return targetComponent;
    }
    return targetComponent;
}
$4f68a738abfc7829$exports = $4f68a738abfc7829$var$hoistNonReactStatics;


var $faa8b3ec9683c8b0$exports = {};
'use strict';

$faa8b3ec9683c8b0$exports = (parcelRequire("3gsre"));



var $3ZMUU = parcelRequire("3ZMUU");
var $33e6c02704dbf3f8$var$_typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function(obj) {
    return typeof obj;
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};
var $33e6c02704dbf3f8$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $33e6c02704dbf3f8$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $33e6c02704dbf3f8$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $33e6c02704dbf3f8$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $33e6c02704dbf3f8$var$objectWithoutProperties = function(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
};
var $33e6c02704dbf3f8$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
// 
var $33e6c02704dbf3f8$var$isPlainObject = function(x) {
    return (typeof x === 'undefined' ? 'undefined' : $33e6c02704dbf3f8$var$_typeof(x)) === 'object' && x.constructor === Object;
};
// 
/**
 * Parse errors.md and turn it into a simple hash of code: message
 */ var $33e6c02704dbf3f8$var$ERRORS = {};
/**
 * super basic version of sprintf
 */ function $33e6c02704dbf3f8$var$format() {
    for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var a = args[0];
    var b = [];
    var c = void 0;
    for(c = 1; c < args.length; c += 1)b.push(args[c]);
    b.forEach(function(d) {
        a = a.replace(/%[a-z]/, d);
    });
    return a;
}
/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */ var $33e6c02704dbf3f8$var$StyledComponentsError = function(_Error) {
    $33e6c02704dbf3f8$var$inherits(StyledComponentsError, _Error);
    function StyledComponentsError(code) {
        $33e6c02704dbf3f8$var$classCallCheck(this, StyledComponentsError);
        for(var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)interpolations[_key2 - 1] = arguments[_key2];
        var _this;
        var _this = $33e6c02704dbf3f8$var$possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
        return $33e6c02704dbf3f8$var$possibleConstructorReturn(_this);
    }
    return StyledComponentsError;
}(Error);
// 
var $33e6c02704dbf3f8$var$objToCss = function objToCss(obj, prevKey) {
    var css = Object.keys(obj).filter(function(key) {
        var chunk = obj[key];
        return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
    }).map(function(key) {
        if ($33e6c02704dbf3f8$var$isPlainObject(obj[key])) return objToCss(obj[key], key);
        return (0, (/*@__PURE__*/$parcel$interopDefault($810bb85dfd1fd032$exports)))(key) + ': ' + obj[key] + ';';
    }).join(' ');
    return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};
var $33e6c02704dbf3f8$var$flatten = function flatten(chunks, executionContext) {
    return chunks.reduce(function(ruleSet, chunk) {
        /* Remove falsey values */ if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
        /* Flatten ruleSet */ if (Array.isArray(chunk)) {
            ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
            return ruleSet;
        }
        /* Handle other components */ if (chunk.hasOwnProperty('styledComponentId')) {
            // $FlowFixMe not sure how to make this pass
            ruleSet.push('.' + chunk.styledComponentId);
            return ruleSet;
        }
        /* Either execute or defer the function */ if (typeof chunk === 'function') {
            if (executionContext) {
                var nextChunk = chunk(executionContext);
                /* Throw if a React Element was given styles */ if ((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).isValidElement(nextChunk)) {
                    var elementName = chunk.displayName || chunk.name;
                    throw new $33e6c02704dbf3f8$var$StyledComponentsError(11, elementName);
                }
                ruleSet.push.apply(ruleSet, flatten([
                    nextChunk
                ], executionContext));
            } else ruleSet.push(chunk);
            return ruleSet;
        }
        /* Handle objects */ ruleSet.push(// $FlowFixMe have to add %checks somehow to isPlainObject
        $33e6c02704dbf3f8$var$isPlainObject(chunk) ? $33e6c02704dbf3f8$var$objToCss(chunk) : chunk.toString());
        return ruleSet;
    }, []);
};
// 
var $33e6c02704dbf3f8$var$COMMENT_REGEX = /^\s*\/\/.*$/gm;
// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var $33e6c02704dbf3f8$var$stylisSplitter = new (0, (/*@__PURE__*/$parcel$interopDefault($64302b0f26692d6c$exports)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: false,
    compress: false,
    semicolon: true
});
var $33e6c02704dbf3f8$var$stylis = new (0, (/*@__PURE__*/$parcel$interopDefault($64302b0f26692d6c$exports)))({
    global: false,
    cascade: true,
    keyframe: false,
    prefix: true,
    compress: false,
    semicolon: false // NOTE: This means "autocomplete missing semicolons"
});
// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture
var $33e6c02704dbf3f8$var$parsingRules = [];
// eslint-disable-next-line consistent-return
var $33e6c02704dbf3f8$var$returnRulesPlugin = function returnRulesPlugin(context) {
    if (context === -2) {
        var parsedRules = $33e6c02704dbf3f8$var$parsingRules;
        $33e6c02704dbf3f8$var$parsingRules = [];
        return parsedRules;
    }
};
var $33e6c02704dbf3f8$var$parseRulesPlugin = (0, (/*@__PURE__*/$parcel$interopDefault($bdb0654fe2595d49$exports)))(function(rule) {
    $33e6c02704dbf3f8$var$parsingRules.push(rule);
});
$33e6c02704dbf3f8$var$stylis.use([
    $33e6c02704dbf3f8$var$parseRulesPlugin,
    $33e6c02704dbf3f8$var$returnRulesPlugin
]);
$33e6c02704dbf3f8$var$stylisSplitter.use([
    $33e6c02704dbf3f8$var$parseRulesPlugin,
    $33e6c02704dbf3f8$var$returnRulesPlugin
]);
var $33e6c02704dbf3f8$var$stringifyRules = function stringifyRules(rules, selector, prefix) {
    var flatCSS = rules.join('').replace($33e6c02704dbf3f8$var$COMMENT_REGEX, ''); // replace JS comments
    var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;
    return $33e6c02704dbf3f8$var$stylis(prefix || !selector ? '' : selector, cssStr);
};
var $33e6c02704dbf3f8$var$splitByRules = function splitByRules(css) {
    return $33e6c02704dbf3f8$var$stylisSplitter('', css);
};
// 
function $33e6c02704dbf3f8$export$7ba318d8d2f06c76(target) /* : %checks */ {
    return(// $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string');
}
// 
/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */ function $33e6c02704dbf3f8$export$953e7e0c06f2f28b() {}
// 
/* eslint-disable no-bitwise */ /* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */ var $33e6c02704dbf3f8$var$charsLength = 52;
/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */ var $33e6c02704dbf3f8$var$getAlphabeticChar = function getAlphabeticChar(code) {
    return String.fromCharCode(code + (code > 25 ? 39 : 97));
};
/* input a number, usually a hash and convert it to base-52 */ var $33e6c02704dbf3f8$var$generateAlphabeticName = function generateAlphabeticName(code) {
    var name = '';
    var x = void 0;
    /* get a char and divide by alphabet-length */ for(x = code; x > $33e6c02704dbf3f8$var$charsLength; x = Math.floor(x / $33e6c02704dbf3f8$var$charsLength))name = $33e6c02704dbf3f8$var$getAlphabeticChar(x % $33e6c02704dbf3f8$var$charsLength) + name;
    return $33e6c02704dbf3f8$var$getAlphabeticChar(x % $33e6c02704dbf3f8$var$charsLength) + name;
};
// 
var $33e6c02704dbf3f8$var$interleave = function(strings, interpolations) {
    var result = [
        strings[0]
    ];
    for(var i = 0, len = interpolations.length; i < len; i += 1)result.push(interpolations[i], strings[i + 1]);
    return result;
};
// 
var $33e6c02704dbf3f8$var$EMPTY_ARRAY = Object.freeze([]);
var $33e6c02704dbf3f8$var$EMPTY_OBJECT = Object.freeze({});
// 
var $33e6c02704dbf3f8$export$dbf350e5966cf602 = function(styles) {
    for(var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)interpolations[_key - 1] = arguments[_key];
    if (typeof styles === 'function' || $33e6c02704dbf3f8$var$isPlainObject(styles)) // $FlowFixMe
    return $33e6c02704dbf3f8$var$flatten($33e6c02704dbf3f8$var$interleave($33e6c02704dbf3f8$var$EMPTY_ARRAY, [
        styles
    ].concat(interpolations)));
    // $FlowFixMe
    return $33e6c02704dbf3f8$var$flatten($33e6c02704dbf3f8$var$interleave(styles, interpolations));
};
// 
var $33e6c02704dbf3f8$var$SC_ATTR = (typeof $3ZMUU !== 'undefined' && undefined, 'data-styled-components');
var $33e6c02704dbf3f8$var$SC_STREAM_ATTR = 'data-styled-streamed';
var $33e6c02704dbf3f8$var$CONTEXT_KEY = '__styled-components-stylesheet__';
var $33e6c02704dbf3f8$var$IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;
var $33e6c02704dbf3f8$var$DISABLE_SPEEDY = false;
// 
var $33e6c02704dbf3f8$var$SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;
var $33e6c02704dbf3f8$var$extractComps = function(maybeCSS) {
    var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
    var existingComponents = [];
    css.replace($33e6c02704dbf3f8$var$SC_COMPONENT_ID, function(match, componentId, matchIndex) {
        existingComponents.push({
            componentId: componentId,
            matchIndex: matchIndex
        });
        return match;
    });
    return existingComponents.map(function(_ref, i) {
        var componentId = _ref.componentId, matchIndex = _ref.matchIndex;
        var nextComp = existingComponents[i + 1];
        var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
        return {
            componentId: componentId,
            cssFromDOM: cssFromDOM
        };
    });
};
// 
/* eslint-disable camelcase, no-undef */ var $33e6c02704dbf3f8$var$getNonce = function() {
    return typeof __webpack_nonce__ !== 'undefined' ? __webpack_nonce__ : null;
};
// 
// Helper to call a given function, only once
var $33e6c02704dbf3f8$var$once = function(cb) {
    var called = false;
    return function() {
        if (!called) {
            called = true;
            cb();
        }
    };
};
// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */ /* adds a new ID:name pairing to a names dictionary */ var $33e6c02704dbf3f8$var$addNameForId = function addNameForId(names, id, name) {
    if (name) {
        // eslint-disable-next-line no-param-reassign
        var namesForId = names[id] || (names[id] = Object.create(null));
        namesForId[name] = true;
    }
};
/* resets an ID entirely by overwriting it in the dictionary */ var $33e6c02704dbf3f8$var$resetIdNames = function resetIdNames(names, id) {
    // eslint-disable-next-line no-param-reassign
    names[id] = Object.create(null);
};
/* factory for a names dictionary checking the existance of an ID:name pairing */ var $33e6c02704dbf3f8$var$hasNameForId = function hasNameForId(names) {
    return function(id, name) {
        return names[id] !== undefined && names[id][name];
    };
};
/* stringifies names for the html/element output */ var $33e6c02704dbf3f8$var$stringifyNames = function stringifyNames(names) {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for(var id in names)str += Object.keys(names[id]).join(' ') + ' ';
    return str.trim();
};
/* clones the nested names dictionary */ var $33e6c02704dbf3f8$var$cloneNames = function cloneNames(names) {
    var clone = Object.create(null);
    // eslint-disable-next-line guard-for-in
    for(var id in names)clone[id] = $33e6c02704dbf3f8$var$_extends({}, names[id]);
    return clone;
};
// 
/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */ /* retrieve a sheet for a given style tag */ var $33e6c02704dbf3f8$var$sheetForTag = function sheetForTag(tag) {
    // $FlowFixMe
    if (tag.sheet) return tag.sheet;
    /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */ var size = document.styleSheets.length;
    for(var i = 0; i < size; i += 1){
        var sheet = document.styleSheets[i];
        // $FlowFixMe
        if (sheet.ownerNode === tag) return sheet;
    }
    /* we should always be able to find a tag */ throw new $33e6c02704dbf3f8$var$StyledComponentsError(10);
};
/* insert a rule safely and return whether it was actually injected */ var $33e6c02704dbf3f8$var$safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
    /* abort early if cssRule string is falsy */ if (!cssRule) return false;
    var maxIndex = sheet.cssRules.length;
    try {
        /* use insertRule and cap passed index with maxIndex (no of cssRules) */ sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
    } catch (err) {
        /* any error indicates an invalid rule */ return false;
    }
    return true;
};
/* deletes `size` rules starting from `removalIndex` */ var $33e6c02704dbf3f8$var$deleteRules = function deleteRules(sheet, removalIndex, size) {
    var lowerBound = removalIndex - size;
    for(var i = removalIndex; i > lowerBound; i -= 1)sheet.deleteRule(i);
};
// 
/* this marker separates component styles and is important for rehydration */ var $33e6c02704dbf3f8$var$makeTextMarker = function makeTextMarker(id) {
    return '\n/* sc-component-id: ' + id + ' */\n';
};
/* add up all numbers in array up until and including the index */ var $33e6c02704dbf3f8$var$addUpUntilIndex = function addUpUntilIndex(sizes, index) {
    var totalUpToIndex = 0;
    for(var i = 0; i <= index; i += 1)totalUpToIndex += sizes[i];
    return totalUpToIndex;
};
/* create a new style tag after lastEl */ var $33e6c02704dbf3f8$var$makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
    var el = document.createElement('style');
    el.setAttribute($33e6c02704dbf3f8$var$SC_ATTR, '');
    var nonce = $33e6c02704dbf3f8$var$getNonce();
    if (nonce) el.setAttribute('nonce', nonce);
    /* Work around insertRule quirk in EdgeHTML */ el.appendChild(document.createTextNode(''));
    if (target && !tagEl) /* Append to target when no previous element was passed */ target.appendChild(el);
    else {
        if (!tagEl || !target || !tagEl.parentNode) throw new $33e6c02704dbf3f8$var$StyledComponentsError(6);
        /* Insert new style tag after the previous one */ tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
    }
    return el;
};
/* takes a css factory function and outputs an html styled tag factory */ var $33e6c02704dbf3f8$var$wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
    return function(additionalAttrs) {
        var nonce = $33e6c02704dbf3f8$var$getNonce();
        var attrs = [
            nonce && 'nonce="' + nonce + '"',
            $33e6c02704dbf3f8$var$SC_ATTR + '="' + $33e6c02704dbf3f8$var$stringifyNames(names) + '"',
            additionalAttrs
        ];
        var htmlAttr = attrs.filter(Boolean).join(' ');
        return '<style ' + htmlAttr + '>' + css() + '</style>';
    };
};
/* takes a css factory function and outputs an element factory */ var $33e6c02704dbf3f8$var$wrapAsElement = function wrapAsElement(css, names) {
    return function() {
        var _props;
        var props = (_props = {}, _props[$33e6c02704dbf3f8$var$SC_ATTR] = $33e6c02704dbf3f8$var$stringifyNames(names), _props);
        var nonce = $33e6c02704dbf3f8$var$getNonce();
        if (nonce) // $FlowFixMe
        props.nonce = nonce;
        // eslint-disable-next-line react/no-danger
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement('style', $33e6c02704dbf3f8$var$_extends({}, props, {
            dangerouslySetInnerHTML: {
                __html: css()
            }
        }));
    };
};
var $33e6c02704dbf3f8$var$getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
    return function() {
        return Object.keys(markers);
    };
};
/* speedy tags utilise insertRule */ var $33e6c02704dbf3f8$var$makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var sizes = [];
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = sizes.length;
        sizes.push(0);
        $33e6c02704dbf3f8$var$resetIdNames(names, id);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var sheet = $33e6c02704dbf3f8$var$sheetForTag(el);
        var insertIndex = $33e6c02704dbf3f8$var$addUpUntilIndex(sizes, marker);
        var injectedRules = 0;
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var cssRule = cssRules[i];
            var mayHaveImport = extractImport; /* @import rules are reordered to appear first */ 
            if (mayHaveImport && cssRule.indexOf('@import') !== -1) importRules.push(cssRule);
            else if ($33e6c02704dbf3f8$var$safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
                mayHaveImport = false;
                injectedRules += 1;
            }
        }
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
        sizes[marker] += injectedRules; /* add up no of injected rules */ 
        $33e6c02704dbf3f8$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        var size = sizes[marker];
        var sheet = $33e6c02704dbf3f8$var$sheetForTag(el);
        var removalIndex = $33e6c02704dbf3f8$var$addUpUntilIndex(sizes, marker);
        $33e6c02704dbf3f8$var$deleteRules(sheet, removalIndex, size);
        sizes[marker] = 0;
        $33e6c02704dbf3f8$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var _sheetForTag = $33e6c02704dbf3f8$var$sheetForTag(el), cssRules = _sheetForTag.cssRules;
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            str += $33e6c02704dbf3f8$var$makeTextMarker(id);
            var marker = markers[id];
            var end = $33e6c02704dbf3f8$var$addUpUntilIndex(sizes, marker);
            var size = sizes[marker];
            for(var i = end - size; i < end; i += 1){
                var rule = cssRules[i];
                if (rule !== undefined) str += rule.cssText;
            }
        }
        return str;
    };
    return {
        clone: function clone() {
            throw new $33e6c02704dbf3f8$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $33e6c02704dbf3f8$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $33e6c02704dbf3f8$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $33e6c02704dbf3f8$var$wrapAsElement(css, names),
        toHTML: $33e6c02704dbf3f8$var$wrapAsHtmlTag(css, names)
    };
};
var $33e6c02704dbf3f8$var$makeTextNode = function makeTextNode(id) {
    return document.createTextNode($33e6c02704dbf3f8$var$makeTextMarker(id));
};
var $33e6c02704dbf3f8$var$makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
    var names = Object.create(null);
    var markers = Object.create(null);
    var extractImport = getImportRuleTag !== undefined;
    /* indicates whther getImportRuleTag was called */ var usedImportRuleTag = false;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        markers[id] = $33e6c02704dbf3f8$var$makeTextNode(id);
        el.appendChild(markers[id]);
        names[id] = Object.create(null);
        return markers[id];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        var importRules = [];
        var cssRulesSize = cssRules.length;
        for(var i = 0; i < cssRulesSize; i += 1){
            var rule = cssRules[i];
            var mayHaveImport = extractImport;
            if (mayHaveImport && rule.indexOf('@import') !== -1) importRules.push(rule);
            else {
                mayHaveImport = false;
                var separator = i === cssRulesSize - 1 ? '' : ' ';
                marker.appendData('' + rule + separator);
            }
        }
        $33e6c02704dbf3f8$var$addNameForId(names, id, name);
        if (extractImport && importRules.length > 0) {
            usedImportRuleTag = true;
            // $FlowFixMe
            getImportRuleTag().insertRules(id + '-import', importRules);
        }
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        /* create new empty text node and replace the current one */ var newMarker = $33e6c02704dbf3f8$var$makeTextNode(id);
        el.replaceChild(newMarker, marker);
        markers[id] = newMarker;
        $33e6c02704dbf3f8$var$resetIdNames(names, id);
        if (extractImport && usedImportRuleTag) // $FlowFixMe
        getImportRuleTag().removeRules(id + '-import');
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers)str += markers[id].data;
        return str;
    };
    return {
        clone: function clone() {
            throw new $33e6c02704dbf3f8$var$StyledComponentsError(5);
        },
        css: css,
        getIds: $33e6c02704dbf3f8$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $33e6c02704dbf3f8$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: el,
        toElement: $33e6c02704dbf3f8$var$wrapAsElement(css, names),
        toHTML: $33e6c02704dbf3f8$var$wrapAsHtmlTag(css, names)
    };
};
var $33e6c02704dbf3f8$var$makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
    var names = namesArg === undefined ? Object.create(null) : namesArg;
    var markers = markersArg === undefined ? Object.create(null) : markersArg;
    var insertMarker = function insertMarker(id) {
        var prev = markers[id];
        if (prev !== undefined) return prev;
        return markers[id] = [
            ''
        ];
    };
    var insertRules = function insertRules(id, cssRules, name) {
        var marker = insertMarker(id);
        marker[0] += cssRules.join(' ');
        $33e6c02704dbf3f8$var$addNameForId(names, id, name);
    };
    var removeRules = function removeRules(id) {
        var marker = markers[id];
        if (marker === undefined) return;
        marker[0] = '';
        $33e6c02704dbf3f8$var$resetIdNames(names, id);
    };
    var css = function css() {
        var str = '';
        // eslint-disable-next-line guard-for-in
        for(var id in markers){
            var cssForId = markers[id][0];
            if (cssForId) str += $33e6c02704dbf3f8$var$makeTextMarker(id) + cssForId;
        }
        return str;
    };
    var clone = function clone() {
        var namesClone = $33e6c02704dbf3f8$var$cloneNames(names);
        var markersClone = Object.create(null);
        // eslint-disable-next-line guard-for-in
        for(var id in markers)markersClone[id] = [
            markers[id][0]
        ];
        return makeServerTagInternal(namesClone, markersClone);
    };
    var tag = {
        clone: clone,
        css: css,
        getIds: $33e6c02704dbf3f8$var$getIdsFromMarkersFactory(markers),
        hasNameForId: $33e6c02704dbf3f8$var$hasNameForId(names),
        insertMarker: insertMarker,
        insertRules: insertRules,
        removeRules: removeRules,
        sealed: false,
        styleTag: null,
        toElement: $33e6c02704dbf3f8$var$wrapAsElement(css, names),
        toHTML: $33e6c02704dbf3f8$var$wrapAsHtmlTag(css, names)
    };
    return tag;
};
var $33e6c02704dbf3f8$var$makeServerTag = function makeServerTag() {
    return $33e6c02704dbf3f8$var$makeServerTagInternal();
};
var $33e6c02704dbf3f8$var$makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
    if ($33e6c02704dbf3f8$var$IS_BROWSER && !forceServer) {
        var el = $33e6c02704dbf3f8$var$makeStyleTag(target, tagEl, insertBefore);
        if ($33e6c02704dbf3f8$var$DISABLE_SPEEDY) return $33e6c02704dbf3f8$var$makeBrowserTag(el, getImportRuleTag);
        else return $33e6c02704dbf3f8$var$makeSpeedyTag(el, getImportRuleTag);
    }
    return $33e6c02704dbf3f8$var$makeServerTag();
};
/* wraps a given tag so that rehydration is performed once when necessary */ var $33e6c02704dbf3f8$var$makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
    /* rehydration function that adds all rules to the new tag */ var rehydrate = $33e6c02704dbf3f8$var$once(function() {
        /* add all extracted components to the new tag */ for(var i = 0, len = extracted.length; i < len; i += 1){
            var _extracted$i = extracted[i], componentId = _extracted$i.componentId, cssFromDOM = _extracted$i.cssFromDOM;
            var cssRules = $33e6c02704dbf3f8$var$splitByRules(cssFromDOM);
            tag.insertRules(componentId, cssRules);
        }
        /* remove old HTMLStyleElements, since they have been rehydrated */ for(var _i = 0, _len = els.length; _i < _len; _i += 1){
            var el = els[_i];
            if (el.parentNode) el.parentNode.removeChild(el);
        }
    });
    if (immediateRehydration) rehydrate();
    return $33e6c02704dbf3f8$var$_extends({}, tag, {
        /* add rehydration hook to insertion methods */ insertMarker: function insertMarker(id) {
            rehydrate();
            return tag.insertMarker(id);
        },
        insertRules: function insertRules(id, cssRules, name) {
            rehydrate();
            return tag.insertRules(id, cssRules, name);
        }
    });
};
// 
var $33e6c02704dbf3f8$var$SPLIT_REGEX = /\s+/;
/* determine the maximum number of components before tags are sharded */ var $33e6c02704dbf3f8$var$MAX_SIZE = void 0;
if ($33e6c02704dbf3f8$var$IS_BROWSER) /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */ $33e6c02704dbf3f8$var$MAX_SIZE = $33e6c02704dbf3f8$var$DISABLE_SPEEDY ? 40 : 1000;
else /* for servers we do not need to shard at all */ $33e6c02704dbf3f8$var$MAX_SIZE = -1;
var $33e6c02704dbf3f8$var$sheetRunningId = 0;
var $33e6c02704dbf3f8$var$master = void 0;
var $33e6c02704dbf3f8$var$StyleSheet = function() {
    /* a map from ids to tags */ /* deferred rules for a given id */ /* this is used for not reinjecting rules via hasNameForId() */ /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */ /* a list of tags belonging to this StyleSheet */ /* a tag for import rules */ /* current capacity until a new tag must be created */ /* children (aka clones) of this StyleSheet inheriting all and future injections */ function StyleSheet() {
        var _this = this;
        var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $33e6c02704dbf3f8$var$IS_BROWSER ? document.head : null;
        var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        $33e6c02704dbf3f8$var$classCallCheck(this, StyleSheet);
        this.getImportRuleTag = function() {
            var importRuleTag = _this.importRuleTag;
            if (importRuleTag !== undefined) return importRuleTag;
            var firstTag = _this.tags[0];
            var insertBefore = true;
            return _this.importRuleTag = $33e6c02704dbf3f8$var$makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
        };
        $33e6c02704dbf3f8$var$sheetRunningId += 1;
        this.id = $33e6c02704dbf3f8$var$sheetRunningId;
        this.forceServer = forceServer;
        this.target = forceServer ? null : target;
        this.tagMap = {};
        this.deferred = {};
        this.rehydratedNames = {};
        this.ignoreRehydratedNames = {};
        this.tags = [];
        this.capacity = 1;
        this.clones = [];
    }
    /* rehydrate all SSR'd style tags */ StyleSheet.prototype.rehydrate = function rehydrate() {
        if (!$33e6c02704dbf3f8$var$IS_BROWSER || this.forceServer) return this;
        var els = [];
        var extracted = [];
        var isStreamed = false;
        /* retrieve all of our SSR style elements from the DOM */ var nodes = document.querySelectorAll('style[' + $33e6c02704dbf3f8$var$SC_ATTR + ']');
        var nodesSize = nodes.length;
        /* abort rehydration if no previous style tags were found */ if (nodesSize === 0) return this;
        for(var i = 0; i < nodesSize; i += 1){
            // $FlowFixMe: We can trust that all elements in this query are style elements
            var el = nodes[i];
            /* check if style tag is a streamed tag */ if (!isStreamed) isStreamed = !!el.getAttribute($33e6c02704dbf3f8$var$SC_STREAM_ATTR);
            /* retrieve all component names */ var elNames = (el.getAttribute($33e6c02704dbf3f8$var$SC_ATTR) || '').trim().split($33e6c02704dbf3f8$var$SPLIT_REGEX);
            var elNamesSize = elNames.length;
            for(var j = 0; j < elNamesSize; j += 1){
                var name = elNames[j];
                /* add rehydrated name to sheet to avoid readding styles */ this.rehydratedNames[name] = true;
            }
            /* extract all components and their CSS */ extracted.push.apply(extracted, $33e6c02704dbf3f8$var$extractComps(el.textContent));
            /* store original HTMLStyleElement */ els.push(el);
        }
        /* abort rehydration if nothing was extracted */ var extractedSize = extracted.length;
        if (extractedSize === 0) return this;
        /* create a tag to be used for rehydration */ var tag = this.makeTag(null);
        var rehydrationTag = $33e6c02704dbf3f8$var$makeRehydrationTag(tag, els, extracted, isStreamed);
        /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */ this.capacity = Math.max(1, $33e6c02704dbf3f8$var$MAX_SIZE - extractedSize);
        this.tags.push(rehydrationTag);
        /* retrieve all component ids */ for(var _j = 0; _j < extractedSize; _j += 1)this.tagMap[extracted[_j].componentId] = rehydrationTag;
        return this;
    };
    /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */ /* reset the internal "master" instance */ StyleSheet.reset = function reset() {
        var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        $33e6c02704dbf3f8$var$master = new StyleSheet(undefined, forceServer).rehydrate();
    };
    /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */ StyleSheet.prototype.clone = function clone() {
        var sheet = new StyleSheet(this.target, this.forceServer);
        /* add to clone array */ this.clones.push(sheet);
        /* clone all tags */ sheet.tags = this.tags.map(function(tag) {
            var ids = tag.getIds();
            var newTag = tag.clone();
            /* reconstruct tagMap */ for(var i = 0; i < ids.length; i += 1)sheet.tagMap[ids[i]] = newTag;
            return newTag;
        });
        /* clone other maps */ sheet.rehydratedNames = $33e6c02704dbf3f8$var$_extends({}, this.rehydratedNames);
        sheet.deferred = $33e6c02704dbf3f8$var$_extends({}, this.deferred);
        return sheet;
    };
    /* force StyleSheet to create a new tag on the next injection */ StyleSheet.prototype.sealAllTags = function sealAllTags() {
        this.capacity = 1;
        this.tags.forEach(function(tag) {
            // eslint-disable-next-line no-param-reassign
            tag.sealed = true;
        });
    };
    StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
        var lastEl = tag ? tag.styleTag : null;
        var insertBefore = false;
        return $33e6c02704dbf3f8$var$makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
    };
    /* get a tag for a given componentId, assign the componentId to one, or shard */ StyleSheet.prototype.getTagForId = function getTagForId(id) {
        /* simply return a tag, when the componentId was already assigned one */ var prev = this.tagMap[id];
        if (prev !== undefined && !prev.sealed) return prev;
        var tag = this.tags[this.tags.length - 1];
        /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */ this.capacity -= 1;
        if (this.capacity === 0) {
            this.capacity = $33e6c02704dbf3f8$var$MAX_SIZE;
            tag = this.makeTag(tag);
            this.tags.push(tag);
        }
        return this.tagMap[id] = tag;
    };
    /* mainly for injectGlobal to check for its id */ StyleSheet.prototype.hasId = function hasId(id) {
        return this.tagMap[id] !== undefined;
    };
    /* caching layer checking id+name to already have a corresponding tag and injected rules */ StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
        /* exception for rehydrated names which are checked separately */ if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) return true;
        var tag = this.tagMap[id];
        return tag !== undefined && tag.hasNameForId(id, name);
    };
    /* registers a componentId and registers it on its tag */ StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
        /* don't inject when the id is already registered */ if (this.tagMap[id] !== undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].deferredInject(id, cssRules);
        this.getTagForId(id).insertMarker(id);
        this.deferred[id] = cssRules;
    };
    /* injects rules for a given id with a name that will need to be cached */ StyleSheet.prototype.inject = function inject(id, cssRules, name) {
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].inject(id, cssRules, name);
        var tag = this.getTagForId(id);
        /* add deferred rules for component */ if (this.deferred[id] !== undefined) {
            // Combine passed cssRules with previously deferred CSS rules
            // NOTE: We cannot mutate the deferred array itself as all clones
            // do the same (see clones[i].inject)
            var rules = this.deferred[id].concat(cssRules);
            tag.insertRules(id, rules, name);
            this.deferred[id] = undefined;
        } else tag.insertRules(id, cssRules, name);
    };
    /* removes all rules for a given id, which doesn't remove its marker but resets it */ StyleSheet.prototype.remove = function remove(id) {
        var tag = this.tagMap[id];
        if (tag === undefined) return;
        var clones = this.clones;
        for(var i = 0; i < clones.length; i += 1)clones[i].remove(id);
        /* remove all rules from the tag */ tag.removeRules(id);
        /* ignore possible rehydrated names */ this.ignoreRehydratedNames[id] = true;
        /* delete possible deferred rules */ this.deferred[id] = undefined;
    };
    StyleSheet.prototype.toHTML = function toHTML() {
        return this.tags.map(function(tag) {
            return tag.toHTML();
        }).join('');
    };
    StyleSheet.prototype.toReactElements = function toReactElements() {
        var id = this.id;
        return this.tags.map(function(tag, i) {
            var key = 'sc-' + id + '-' + i;
            return (0, $5FkrB.cloneElement)(tag.toElement(), {
                key: key
            });
        });
    };
    $33e6c02704dbf3f8$var$createClass(StyleSheet, null, [
        {
            key: 'master',
            get: function get$$1() {
                return $33e6c02704dbf3f8$var$master || ($33e6c02704dbf3f8$var$master = new StyleSheet().rehydrate());
            }
        },
        {
            key: 'instance',
            get: function get$$1() {
                return StyleSheet.master;
            }
        }
    ]);
    return StyleSheet;
}();
var $33e6c02704dbf3f8$var$_StyleSheetManager$ch;
var $33e6c02704dbf3f8$export$a473771da2f0ff7c = function(_Component) {
    $33e6c02704dbf3f8$var$inherits(StyleSheetManager, _Component);
    function StyleSheetManager() {
        $33e6c02704dbf3f8$var$classCallCheck(this, StyleSheetManager);
        return $33e6c02704dbf3f8$var$possibleConstructorReturn(this, _Component.apply(this, arguments));
    }
    StyleSheetManager.prototype.getChildContext = function getChildContext() {
        var _ref;
        return _ref = {}, _ref[$33e6c02704dbf3f8$var$CONTEXT_KEY] = this.sheetInstance, _ref;
    };
    StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
        if (this.props.sheet) this.sheetInstance = this.props.sheet;
        else if (this.props.target) this.sheetInstance = new $33e6c02704dbf3f8$var$StyleSheet(this.props.target);
        else throw new $33e6c02704dbf3f8$var$StyledComponentsError(4);
    };
    StyleSheetManager.prototype.render = function render() {
        /* eslint-disable react/prop-types */ // Flow v0.43.1 will report an error accessing the `children` property,
        // but v0.47.0 will not. It is necessary to use a type cast instead of
        // a "fixme" comment to satisfy both Flow versions.
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(this.props.children);
    };
    return StyleSheetManager;
}((0, $5FkrB.Component));
$33e6c02704dbf3f8$export$a473771da2f0ff7c.childContextTypes = ($33e6c02704dbf3f8$var$_StyleSheetManager$ch = {}, $33e6c02704dbf3f8$var$_StyleSheetManager$ch[$33e6c02704dbf3f8$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).instanceOf($33e6c02704dbf3f8$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).instanceOf($33e6c02704dbf3f8$export$ae8c7d15c8b89a20)
]).isRequired, $33e6c02704dbf3f8$var$_StyleSheetManager$ch);
// 
var $33e6c02704dbf3f8$export$ae8c7d15c8b89a20 = function() {
    function ServerStyleSheet() {
        $33e6c02704dbf3f8$var$classCallCheck(this, ServerStyleSheet);
        /* The master sheet might be reset, so keep a reference here */ this.masterSheet = $33e6c02704dbf3f8$var$StyleSheet.master;
        this.instance = this.masterSheet.clone();
        this.closed = false;
    }
    ServerStyleSheet.prototype.complete = function complete() {
        if (!this.closed) {
            /* Remove closed StyleSheets from the master sheet */ var index = this.masterSheet.clones.indexOf(this.instance);
            this.masterSheet.clones.splice(index, 1);
            this.closed = true;
        }
    };
    ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
        if (this.closed) throw new $33e6c02704dbf3f8$var$StyledComponentsError(2);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($33e6c02704dbf3f8$export$a473771da2f0ff7c, {
            sheet: this.instance
        }, children);
    };
    ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
        this.complete();
        return this.instance.toHTML();
    };
    ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
        this.complete();
        return this.instance.toReactElements();
    };
    ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
        var _this = this;
        var instance, instanceTagIndex, streamAttr, transformer;
        throw new $33e6c02704dbf3f8$var$StyledComponentsError(3);
    };
    return ServerStyleSheet;
}();
// 
var $33e6c02704dbf3f8$var$LIMIT = 200;
var $33e6c02704dbf3f8$var$createWarnTooManyClasses = function(displayName) {
    var generatedClasses = {};
    var warningSeen = false;
    return function(className) {
        if (!warningSeen) {
            generatedClasses[className] = true;
            if (Object.keys(generatedClasses).length >= $33e6c02704dbf3f8$var$LIMIT) {
                // Unable to find latestRule in test environment.
                /* eslint-disable no-console, prefer-template */ console.warn('Over ' + $33e6c02704dbf3f8$var$LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
                warningSeen = true;
                generatedClasses = {};
            }
        }
    };
};
// 
var $33e6c02704dbf3f8$var$determineTheme = function(props, fallbackTheme, defaultProps) {
    // Props should take precedence over ThemeProvider, which should take precedence over
    // defaultProps, but React automatically puts defaultProps on props.
    /* eslint-disable react/prop-types */ var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
    var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
    /* eslint-enable */ return theme;
};
// 
var $33e6c02704dbf3f8$var$escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var $33e6c02704dbf3f8$var$dashesAtEnds = /(^-|-$)/g;
/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */ function $33e6c02704dbf3f8$var$escape(str) {
    return str// Replace all possible CSS selectors
    .replace($33e6c02704dbf3f8$var$escapeRegex, '-')// Remove extraneous hyphens at the start and end
    .replace($33e6c02704dbf3f8$var$dashesAtEnds, '');
}
// 
function $33e6c02704dbf3f8$var$getComponentName(target) {
    return target.displayName || target.name || 'Component';
}
// 
function $33e6c02704dbf3f8$var$isTag(target) /* : %checks */ {
    return typeof target === 'string';
}
// 
function $33e6c02704dbf3f8$var$generateDisplayName(target) {
    return $33e6c02704dbf3f8$var$isTag(target) ? 'styled.' + target : 'Styled(' + $33e6c02704dbf3f8$var$getComponentName(target) + ')';
}
// 
/* eslint-disable max-len */ /**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */ /*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/ /* eslint-enable max-len */ var $33e6c02704dbf3f8$var$ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */ var $33e6c02704dbf3f8$var$ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var $33e6c02704dbf3f8$var$ATTRIBUTE_NAME_CHAR = $33e6c02704dbf3f8$var$ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var $33e6c02704dbf3f8$var$isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + $33e6c02704dbf3f8$var$ATTRIBUTE_NAME_CHAR + ']*$'));
var $33e6c02704dbf3f8$var$validAttr = function(name) {
    return $33e6c02704dbf3f8$var$ATTRIBUTE_REGEX.test(name) || $33e6c02704dbf3f8$var$isCustomAttribute(name.toLowerCase());
};
// 
function $33e6c02704dbf3f8$var$hasInInheritanceChain(child, parent) {
    var target = child;
    while(target){
        target = Object.getPrototypeOf(target);
        if (target && target === parent) return true;
    }
    return false;
}
// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */ var $33e6c02704dbf3f8$var$createBroadcast = function createBroadcast(initialState) {
    var listeners = {};
    var id = 0;
    var state = initialState;
    function publish(nextState) {
        state = nextState;
        // eslint-disable-next-line guard-for-in, no-restricted-syntax
        for(var key in listeners){
            var listener = listeners[key];
            if (listener === undefined) continue;
            listener(state);
        }
    }
    function subscribe(listener) {
        var currentId = id;
        listeners[currentId] = listener;
        id += 1;
        listener(state);
        return currentId;
    }
    function unsubscribe(unsubID) {
        listeners[unsubID] = undefined;
    }
    return {
        publish: publish,
        subscribe: subscribe,
        unsubscribe: unsubscribe
    };
};
var $33e6c02704dbf3f8$var$_contextShape, $33e6c02704dbf3f8$var$_ThemeProvider$contex;
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var $33e6c02704dbf3f8$var$CHANNEL = '__styled-components__';
var $33e6c02704dbf3f8$var$CHANNEL_NEXT = $33e6c02704dbf3f8$var$CHANNEL + 'next__';
var $33e6c02704dbf3f8$var$CONTEXT_CHANNEL_SHAPE = (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).shape({
    getTheme: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).func,
    subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).func,
    unsubscribe: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).func
});
var $33e6c02704dbf3f8$var$contextShape = ($33e6c02704dbf3f8$var$_contextShape = {}, $33e6c02704dbf3f8$var$_contextShape[$33e6c02704dbf3f8$var$CHANNEL] = (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).func, $33e6c02704dbf3f8$var$_contextShape[$33e6c02704dbf3f8$var$CHANNEL_NEXT] = $33e6c02704dbf3f8$var$CONTEXT_CHANNEL_SHAPE, $33e6c02704dbf3f8$var$_contextShape);
var $33e6c02704dbf3f8$var$warnChannelDeprecated = void 0;
var $33e6c02704dbf3f8$var$isFunction = function isFunction(test) {
    return typeof test === 'function';
};
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */ var $33e6c02704dbf3f8$export$d8964aec282183a3 = function(_Component) {
    $33e6c02704dbf3f8$var$inherits(ThemeProvider, _Component);
    function ThemeProvider() {
        $33e6c02704dbf3f8$var$classCallCheck(this, ThemeProvider);
        var _this = $33e6c02704dbf3f8$var$possibleConstructorReturn(this, _Component.call(this));
        _this.unsubscribeToOuterId = -1;
        _this.getTheme = _this.getTheme.bind(_this);
        return _this;
    }
    ThemeProvider.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
        // with the outer theme
        var outerContext = this.context[$33e6c02704dbf3f8$var$CHANNEL_NEXT];
        if (outerContext !== undefined) this.unsubscribeToOuterId = outerContext.subscribe(function(theme) {
            _this2.outerTheme = theme;
            if (_this2.broadcast !== undefined) _this2.publish(_this2.props.theme);
        });
        this.broadcast = $33e6c02704dbf3f8$var$createBroadcast(this.getTheme());
    };
    ThemeProvider.prototype.getChildContext = function getChildContext() {
        var _this3 = this, _babelHelpers$extends;
        return $33e6c02704dbf3f8$var$_extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[$33e6c02704dbf3f8$var$CHANNEL_NEXT] = {
            getTheme: this.getTheme,
            subscribe: this.broadcast.subscribe,
            unsubscribe: this.broadcast.unsubscribe
        }, _babelHelpers$extends[$33e6c02704dbf3f8$var$CHANNEL] = function(subscriber) {
            // Patch the old `subscribe` provide via `CHANNEL` for older clients.
            var unsubscribeId = _this3.broadcast.subscribe(subscriber);
            return function() {
                return _this3.broadcast.unsubscribe(unsubscribeId);
            };
        }, _babelHelpers$extends));
    };
    ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (this.props.theme !== nextProps.theme) this.publish(nextProps.theme);
    };
    ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.unsubscribeToOuterId !== -1) this.context[$33e6c02704dbf3f8$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    };
    // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
    ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
        var theme = passedTheme || this.props.theme;
        if ($33e6c02704dbf3f8$var$isFunction(theme)) {
            var mergedTheme = theme(this.outerTheme);
            return mergedTheme;
        }
        if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : $33e6c02704dbf3f8$var$_typeof(theme)) !== 'object') throw new $33e6c02704dbf3f8$var$StyledComponentsError(8);
        return $33e6c02704dbf3f8$var$_extends({}, this.outerTheme, theme);
    };
    ThemeProvider.prototype.publish = function publish(theme) {
        this.broadcast.publish(this.getTheme(theme));
    };
    ThemeProvider.prototype.render = function render() {
        if (!this.props.children) return null;
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(this.props.children);
    };
    return ThemeProvider;
}((0, $5FkrB.Component));
$33e6c02704dbf3f8$export$d8964aec282183a3.childContextTypes = $33e6c02704dbf3f8$var$contextShape;
$33e6c02704dbf3f8$export$d8964aec282183a3.contextTypes = ($33e6c02704dbf3f8$var$_ThemeProvider$contex = {}, $33e6c02704dbf3f8$var$_ThemeProvider$contex[$33e6c02704dbf3f8$var$CHANNEL_NEXT] = $33e6c02704dbf3f8$var$CONTEXT_CHANNEL_SHAPE, $33e6c02704dbf3f8$var$_ThemeProvider$contex);
var $33e6c02704dbf3f8$var$_babelHelpers$extends;
// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var $33e6c02704dbf3f8$var$STATIC_EXECUTION_CONTEXT = {};
var $33e6c02704dbf3f8$var$modifiedContextShape = $33e6c02704dbf3f8$var$_extends({}, $33e6c02704dbf3f8$var$contextShape, ($33e6c02704dbf3f8$var$_babelHelpers$extends = {}, $33e6c02704dbf3f8$var$_babelHelpers$extends[$33e6c02704dbf3f8$var$CONTEXT_KEY] = (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).oneOfType([
    (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).instanceOf($33e6c02704dbf3f8$var$StyleSheet),
    (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).instanceOf($33e6c02704dbf3f8$export$ae8c7d15c8b89a20)
]), $33e6c02704dbf3f8$var$_babelHelpers$extends));
var $33e6c02704dbf3f8$var$identifiers = {};
/* We depend on components having unique IDs */ var $33e6c02704dbf3f8$var$generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : $33e6c02704dbf3f8$var$escape(_displayName);
    /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */ var nr = ($33e6c02704dbf3f8$var$identifiers[displayName] || 0) + 1;
    $33e6c02704dbf3f8$var$identifiers[displayName] = nr;
    var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};
var $33e6c02704dbf3f8$var$warnExtendDeprecated = function warnExtendDeprecated() {};
// $FlowFixMe
var $33e6c02704dbf3f8$var$BaseStyledComponent = function(_Component) {
    $33e6c02704dbf3f8$var$inherits(BaseStyledComponent, _Component);
    function BaseStyledComponent() {
        var _temp, _this, _ret;
        $33e6c02704dbf3f8$var$classCallCheck(this, BaseStyledComponent);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $33e6c02704dbf3f8$var$possibleConstructorReturn(this, _Component.call.apply(_Component, [
            this
        ].concat(args))), _this), _this.attrs = {}, _this.state = {
            theme: null,
            generatedClassName: ''
        }, _this.unsubscribeId = -1, _temp), $33e6c02704dbf3f8$var$possibleConstructorReturn(_this, _ret);
    }
    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
        if (this.unsubscribeId !== -1) this.context[$33e6c02704dbf3f8$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    };
    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
        var attrs = this.constructor.attrs;
        var context = $33e6c02704dbf3f8$var$_extends({}, props, {
            theme: theme
        });
        if (attrs === undefined) return context;
        this.attrs = Object.keys(attrs).reduce(function(acc, key) {
            var attr = attrs[key];
            // eslint-disable-next-line no-param-reassign
            acc[key] = typeof attr === 'function' && !$33e6c02704dbf3f8$var$hasInInheritanceChain(attr, (0, $5FkrB.Component)) ? attr(context) : attr;
            return acc;
        }, {});
        return $33e6c02704dbf3f8$var$_extends({}, context, this.attrs);
    };
    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
        var _constructor = this.constructor, attrs = _constructor.attrs, componentStyle = _constructor.componentStyle, warnTooManyClasses = _constructor.warnTooManyClasses;
        var styleSheet = this.context[$33e6c02704dbf3f8$var$CONTEXT_KEY] || $33e6c02704dbf3f8$var$StyleSheet.master;
        // statically styled-components don't need to build an execution context object,
        // and shouldn't be increasing the number of class names
        if (componentStyle.isStatic && attrs === undefined) return componentStyle.generateAndInjectStyles($33e6c02704dbf3f8$var$STATIC_EXECUTION_CONTEXT, styleSheet);
        else {
            var executionContext = this.buildExecutionContext(theme, props);
            var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);
            return className;
        }
    };
    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var componentStyle = this.constructor.componentStyle;
        var styledContext = this.context[$33e6c02704dbf3f8$var$CHANNEL_NEXT];
        // If this is a statically-styled component, we don't need to the theme
        // to generate or build styles.
        if (componentStyle.isStatic) {
            var generatedClassName = this.generateAndInjectStyles($33e6c02704dbf3f8$var$STATIC_EXECUTION_CONTEXT, this.props);
            this.setState({
                generatedClassName: generatedClassName
            });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
        } else if (styledContext !== undefined) {
            var subscribe = styledContext.subscribe;
            this.unsubscribeId = subscribe(function(nextTheme) {
                // This will be called once immediately
                var theme = $33e6c02704dbf3f8$var$determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
                var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);
                _this2.setState({
                    theme: theme,
                    generatedClassName: generatedClassName
                });
            });
        } else {
            // eslint-disable-next-line react/prop-types
            var theme = this.props.theme || $33e6c02704dbf3f8$var$EMPTY_OBJECT;
            var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
            this.setState({
                theme: theme,
                generatedClassName: _generatedClassName
            });
        }
    };
    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        var _this3 = this;
        // If this is a statically-styled component, we don't need to listen to
        // props changes to update styles
        var componentStyle = this.constructor.componentStyle;
        if (componentStyle.isStatic) return;
        this.setState(function(prevState) {
            var theme = $33e6c02704dbf3f8$var$determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
            var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);
            return {
                theme: theme,
                generatedClassName: generatedClassName
            };
        });
    };
    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unsubscribeFromContext();
    };
    BaseStyledComponent.prototype.render = function render() {
        // eslint-disable-next-line react/prop-types
        var innerRef = this.props.innerRef;
        var generatedClassName = this.state.generatedClassName;
        var _constructor2 = this.constructor, styledComponentId = _constructor2.styledComponentId, target = _constructor2.target;
        var isTargetTag = $33e6c02704dbf3f8$var$isTag(target);
        var className = [
            // eslint-disable-next-line react/prop-types
            this.props.className,
            styledComponentId,
            this.attrs.className,
            generatedClassName
        ].filter(Boolean).join(' ');
        var baseProps = $33e6c02704dbf3f8$var$_extends({}, this.attrs, {
            className: className
        });
        if ($33e6c02704dbf3f8$export$7ba318d8d2f06c76(target)) baseProps.innerRef = innerRef;
        else baseProps.ref = innerRef;
        var propsForElement = baseProps;
        var key = void 0;
        for(key in this.props)// Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || $33e6c02704dbf3f8$var$validAttr(key))) propsForElement[key] = key === 'style' && key in this.attrs ? $33e6c02704dbf3f8$var$_extends({}, this.attrs[key], this.props[key]) : this.props[key];
        return (0, $5FkrB.createElement)(target, propsForElement);
    };
    return BaseStyledComponent;
}((0, $5FkrB.Component));
var $33e6c02704dbf3f8$var$_StyledComponent = function(ComponentStyle, constructWithOptions) {
    var createStyledComponent = function createStyledComponent(target, options, rules) {
        var _options$isClass = options.isClass, isClass = _options$isClass === undefined ? !$33e6c02704dbf3f8$var$isTag(target) : _options$isClass, _options$displayName = options.displayName, displayName = _options$displayName === undefined ? $33e6c02704dbf3f8$var$generateDisplayName(target) : _options$displayName, _options$componentId = options.componentId, componentId = _options$componentId === undefined ? $33e6c02704dbf3f8$var$generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId, _options$ParentCompon = options.ParentComponent, ParentComponent = _options$ParentCompon === undefined ? $33e6c02704dbf3f8$var$BaseStyledComponent : _options$ParentCompon, extendingRules = options.rules, attrs = options.attrs;
        var styledComponentId = options.displayName && options.componentId ? $33e6c02704dbf3f8$var$escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;
        var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);
        var StyledComponent = function(_ParentComponent) {
            $33e6c02704dbf3f8$var$inherits(StyledComponent, _ParentComponent);
            function StyledComponent() {
                $33e6c02704dbf3f8$var$classCallCheck(this, StyledComponent);
                return $33e6c02704dbf3f8$var$possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
            }
            StyledComponent.withComponent = function withComponent(tag) {
                var previousComponentId = options.componentId, optionsToCopy = $33e6c02704dbf3f8$var$objectWithoutProperties(options, [
                    'componentId'
                ]);
                var newComponentId = previousComponentId && previousComponentId + '-' + ($33e6c02704dbf3f8$var$isTag(tag) ? tag : $33e6c02704dbf3f8$var$escape($33e6c02704dbf3f8$var$getComponentName(tag)));
                var newOptions = $33e6c02704dbf3f8$var$_extends({}, optionsToCopy, {
                    componentId: newComponentId,
                    ParentComponent: StyledComponent
                });
                return createStyledComponent(tag, newOptions, rules);
            };
            $33e6c02704dbf3f8$var$createClass(StyledComponent, null, [
                {
                    key: 'extend',
                    get: function get$$1() {
                        var rulesFromOptions = options.rules, parentComponentId = options.componentId, optionsToCopy = $33e6c02704dbf3f8$var$objectWithoutProperties(options, [
                            'rules',
                            'componentId'
                        ]);
                        var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);
                        var newOptions = $33e6c02704dbf3f8$var$_extends({}, optionsToCopy, {
                            rules: newRules,
                            parentComponentId: parentComponentId,
                            ParentComponent: StyledComponent
                        });
                        $33e6c02704dbf3f8$var$warnExtendDeprecated();
                        return constructWithOptions(createStyledComponent, target, newOptions);
                    }
                }
            ]);
            return StyledComponent;
        }(ParentComponent);
        StyledComponent.attrs = attrs;
        StyledComponent.componentStyle = componentStyle;
        StyledComponent.contextTypes = $33e6c02704dbf3f8$var$modifiedContextShape;
        StyledComponent.displayName = displayName;
        StyledComponent.styledComponentId = styledComponentId;
        StyledComponent.target = target;
        if (isClass) (0, (/*@__PURE__*/$parcel$interopDefault($4f68a738abfc7829$exports)))(StyledComponent, target, {
            // all SC-specific things should not be hoisted
            attrs: true,
            componentStyle: true,
            displayName: true,
            extend: true,
            styledComponentId: true,
            target: true,
            warnTooManyClasses: true,
            withComponent: true
        });
        return StyledComponent;
    };
    return createStyledComponent;
};
// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function $33e6c02704dbf3f8$var$murmurhash(str) {
    var l = str.length | 0, h = l | 0, i = 0, k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
}
// 
var $33e6c02704dbf3f8$var$areStylesCacheable = $33e6c02704dbf3f8$var$IS_BROWSER;
var $33e6c02704dbf3f8$var$isStaticRules = function isStaticRules(rules, attrs) {
    for(var i = 0, len = rules.length; i < len; i += 1){
        var rule = rules[i];
        // recursive case
        if (Array.isArray(rule) && !isStaticRules(rule)) return false;
        else if (typeof rule === 'function' && !$33e6c02704dbf3f8$export$7ba318d8d2f06c76(rule)) // functions are allowed to be static if they're just being
        // used to get the classname of a nested styled component
        return false;
    }
    if (attrs !== undefined) // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for(var key in attrs){
        if (typeof attrs[key] === 'function') return false;
    }
    return true;
};
var $33e6c02704dbf3f8$var$isHMREnabled = null && false;
/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */ var $33e6c02704dbf3f8$var$_ComponentStyle = function(nameGenerator, flatten, stringifyRules) {
    /* combines hashStr (murmurhash) and nameGenerator for convenience */ var generateRuleHash = function generateRuleHash(str) {
        return nameGenerator($33e6c02704dbf3f8$var$murmurhash(str));
    };
    var ComponentStyle = function() {
        function ComponentStyle(rules, attrs, componentId) {
            $33e6c02704dbf3f8$var$classCallCheck(this, ComponentStyle);
            this.rules = rules;
            this.isStatic = !$33e6c02704dbf3f8$var$isHMREnabled && $33e6c02704dbf3f8$var$isStaticRules(rules, attrs);
            this.componentId = componentId;
            if (!$33e6c02704dbf3f8$var$StyleSheet.master.hasId(componentId)) {
                var placeholder = [];
                $33e6c02704dbf3f8$var$StyleSheet.master.deferredInject(componentId, placeholder);
            }
        }
        /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */ ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
            var isStatic = this.isStatic, componentId = this.componentId, lastClassName = this.lastClassName;
            if ($33e6c02704dbf3f8$var$areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) return lastClassName;
            var flatCSS = flatten(this.rules, executionContext);
            var name = generateRuleHash(this.componentId + flatCSS.join(''));
            if (!styleSheet.hasNameForId(componentId, name)) styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
            this.lastClassName = name;
            return name;
        };
        ComponentStyle.generateName = function generateName(str) {
            return generateRuleHash(str);
        };
        return ComponentStyle;
    }();
    return ComponentStyle;
};
// 
// Thanks to ReactDOMFactories for this handy list!
var $33e6c02704dbf3f8$var$domElements = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    // SVG
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
// 
var $33e6c02704dbf3f8$var$_styled = function(styledComponent, constructWithOptions) {
    var styled = function styled(tag) {
        return constructWithOptions(styledComponent, tag);
    };
    // Shorthands for all valid HTML Elements
    $33e6c02704dbf3f8$var$domElements.forEach(function(domElement) {
        styled[domElement] = styled(domElement);
    });
    return styled;
};
// 
var $33e6c02704dbf3f8$var$replaceWhitespace = function replaceWhitespace(str) {
    return str.replace(/\s|\\n/g, '');
};
var $33e6c02704dbf3f8$var$_keyframes = function(nameGenerator, stringifyRules, css) {
    return function() {
        var styleSheet = $33e6c02704dbf3f8$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var name = nameGenerator($33e6c02704dbf3f8$var$murmurhash($33e6c02704dbf3f8$var$replaceWhitespace(JSON.stringify(rules))));
        var id = 'sc-keyframes-' + name;
        if (!styleSheet.hasNameForId(id, name)) styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
        return name;
    };
};
// 
var $33e6c02704dbf3f8$var$_injectGlobal = function(stringifyRules, css) {
    var injectGlobal = function injectGlobal() {
        var styleSheet = $33e6c02704dbf3f8$var$StyleSheet.master;
        var rules = css.apply(undefined, arguments);
        var hash = $33e6c02704dbf3f8$var$murmurhash(JSON.stringify(rules));
        var id = 'sc-global-' + hash;
        if (!styleSheet.hasId(id)) styleSheet.inject(id, stringifyRules(rules));
    };
    return injectGlobal;
};
// 
var $33e6c02704dbf3f8$var$_constructWithOptions = function(css) {
    var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
        var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $33e6c02704dbf3f8$var$EMPTY_OBJECT;
        if (!(0, $faa8b3ec9683c8b0$exports.isValidElementType)(tag)) throw new $33e6c02704dbf3f8$var$StyledComponentsError(1, String(tag));
        /* This is callable directly as a template function */ // $FlowFixMe: Not typed to avoid destructuring arguments
        var templateFunction = function templateFunction() {
            return componentConstructor(tag, options, css.apply(undefined, arguments));
        };
        /* If config methods are called, wrap up a new template function and merge options */ templateFunction.withConfig = function(config) {
            return constructWithOptions(componentConstructor, tag, $33e6c02704dbf3f8$var$_extends({}, options, config));
        };
        templateFunction.attrs = function(attrs) {
            return constructWithOptions(componentConstructor, tag, $33e6c02704dbf3f8$var$_extends({}, options, {
                attrs: $33e6c02704dbf3f8$var$_extends({}, options.attrs || $33e6c02704dbf3f8$var$EMPTY_OBJECT, attrs)
            }));
        };
        return templateFunction;
    };
    return constructWithOptions;
};
// 
var $33e6c02704dbf3f8$export$e8748c6a27b910dc = function(Component$$1) {
    var isStatelessFunctionalComponent = typeof Component$$1 === 'function' && // $FlowFixMe TODO: flow for prototype
    !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);
    // NOTE: We can't pass a ref to a stateless functional component
    var shouldSetInnerRef = $33e6c02704dbf3f8$export$7ba318d8d2f06c76(Component$$1) || isStatelessFunctionalComponent;
    var WithTheme = function(_React$Component) {
        $33e6c02704dbf3f8$var$inherits(WithTheme, _React$Component);
        function WithTheme() {
            var _temp, _this, _ret;
            $33e6c02704dbf3f8$var$classCallCheck(this, WithTheme);
            for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return _ret = (_temp = (_this = $33e6c02704dbf3f8$var$possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
                this
            ].concat(args))), _this), _this.state = $33e6c02704dbf3f8$var$EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), $33e6c02704dbf3f8$var$possibleConstructorReturn(_this, _ret);
        }
        // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping
        WithTheme.prototype.componentWillMount = function componentWillMount() {
            var _this2 = this;
            var defaultProps = this.constructor.defaultProps;
            var styledContext = this.context[$33e6c02704dbf3f8$var$CHANNEL_NEXT];
            var themeProp = $33e6c02704dbf3f8$var$determineTheme(this.props, undefined, defaultProps);
            if (styledContext === undefined && themeProp !== undefined) this.setState({
                theme: themeProp
            });
            else {
                var subscribe = styledContext.subscribe;
                this.unsubscribeId = subscribe(function(nextTheme) {
                    var theme = $33e6c02704dbf3f8$var$determineTheme(_this2.props, nextTheme, defaultProps);
                    _this2.setState({
                        theme: theme
                    });
                });
            }
        };
        WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
            var defaultProps = this.constructor.defaultProps;
            this.setState(function(oldState) {
                var theme = $33e6c02704dbf3f8$var$determineTheme(nextProps, oldState.theme, defaultProps);
                return {
                    theme: theme
                };
            });
        };
        WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
            if (this.unsubscribeId !== -1) this.context[$33e6c02704dbf3f8$var$CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
        };
        WithTheme.prototype.render = function render() {
            var props = $33e6c02704dbf3f8$var$_extends({
                theme: this.state.theme
            }, this.props);
            if (!shouldSetInnerRef) {
                props.ref = props.innerRef;
                delete props.innerRef;
            }
            return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Component$$1, props);
        };
        return WithTheme;
    }((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Component);
    WithTheme.contextTypes = $33e6c02704dbf3f8$var$contextShape;
    WithTheme.displayName = 'WithTheme(' + $33e6c02704dbf3f8$var$getComponentName(Component$$1) + ')';
    WithTheme.styledComponentId = 'withTheme';
    return (0, (/*@__PURE__*/$parcel$interopDefault($4f68a738abfc7829$exports)))(WithTheme, Component$$1);
};
// 
/* eslint-disable */ var $33e6c02704dbf3f8$export$84079c323bb0915e = {
    StyleSheet: $33e6c02704dbf3f8$var$StyleSheet
};
/* Instantiate singletons */ var $33e6c02704dbf3f8$var$ComponentStyle = $33e6c02704dbf3f8$var$_ComponentStyle($33e6c02704dbf3f8$var$generateAlphabeticName, $33e6c02704dbf3f8$var$flatten, $33e6c02704dbf3f8$var$stringifyRules);
var $33e6c02704dbf3f8$var$constructWithOptions = $33e6c02704dbf3f8$var$_constructWithOptions($33e6c02704dbf3f8$export$dbf350e5966cf602);
var $33e6c02704dbf3f8$var$StyledComponent = $33e6c02704dbf3f8$var$_StyledComponent($33e6c02704dbf3f8$var$ComponentStyle, $33e6c02704dbf3f8$var$constructWithOptions);
/* Instantiate exported singletons */ var $33e6c02704dbf3f8$export$d25ddfdf17c3ad3e = $33e6c02704dbf3f8$var$_keyframes($33e6c02704dbf3f8$var$generateAlphabeticName, $33e6c02704dbf3f8$var$stringifyRules, $33e6c02704dbf3f8$export$dbf350e5966cf602);
var $33e6c02704dbf3f8$export$efb9f5caaa2ca0c7 = $33e6c02704dbf3f8$var$_injectGlobal($33e6c02704dbf3f8$var$stringifyRules, $33e6c02704dbf3f8$export$dbf350e5966cf602);
var $33e6c02704dbf3f8$var$styled = $33e6c02704dbf3f8$var$_styled($33e6c02704dbf3f8$var$StyledComponent, $33e6c02704dbf3f8$var$constructWithOptions);
var $33e6c02704dbf3f8$export$2e2bcd8739ae039 = $33e6c02704dbf3f8$var$styled;



parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/ // $FlowFixMe
function $7fa809f9c19f15c3$var$sheetForTag(tag) {
    if (tag.sheet) // $FlowFixMe
    return tag.sheet;
     // this weirdness brought to you by firefox
    /* istanbul ignore next */ for(var i = 0; i < document.styleSheets.length; i++){
        if (document.styleSheets[i].ownerNode === tag) // $FlowFixMe
        return document.styleSheets[i];
    }
}
function $7fa809f9c19f15c3$var$createStyleElement(options) {
    var tag = document.createElement('style');
    tag.setAttribute('data-emotion', options.key);
    if (options.nonce !== undefined) tag.setAttribute('nonce', options.nonce);
    tag.appendChild(document.createTextNode(''));
    tag.setAttribute('data-s', '');
    return tag;
}
var $7fa809f9c19f15c3$export$9d753cd7ae895cce = /*#__PURE__*/ function() {
    // Using Node instead of HTMLElement since container may be a ShadowRoot
    function StyleSheet(options) {
        var _this = this;
        this._insertTag = function(tag) {
            var before;
            if (_this.tags.length === 0) {
                if (_this.insertionPoint) before = _this.insertionPoint.nextSibling;
                else if (_this.prepend) before = _this.container.firstChild;
                else before = _this.before;
            } else before = _this.tags[_this.tags.length - 1].nextSibling;
            _this.container.insertBefore(tag, before);
            _this.tags.push(tag);
        };
        this.isSpeedy = options.speedy === undefined ? true : options.speedy;
        this.tags = [];
        this.ctr = 0;
        this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets
        this.key = options.key;
        this.container = options.container;
        this.prepend = options.prepend;
        this.insertionPoint = options.insertionPoint;
        this.before = null;
    }
    var _proto = StyleSheet.prototype;
    _proto.hydrate = function hydrate(nodes) {
        nodes.forEach(this._insertTag);
    };
    _proto.insert = function insert(rule) {
        // the max length is how many rules we have per style tag, it's 65000 in speedy mode
        // it's 1 in dev because we insert source maps that map a single rule to a location
        // and you can only have one source map per style tag
        if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) this._insertTag($7fa809f9c19f15c3$var$createStyleElement(this));
        var tag = this.tags[this.tags.length - 1];
        var isImportRule;
        if (this.isSpeedy) {
            var sheet = $7fa809f9c19f15c3$var$sheetForTag(tag);
            try {
                // this is the ultrafast version, works across browsers
                // the big drawback is that the css won't be editable in devtools
                sheet.insertRule(rule, sheet.cssRules.length);
            } catch (e) {}
        } else tag.appendChild(document.createTextNode(rule));
        this.ctr++;
    };
    _proto.flush = function flush() {
        // $FlowFixMe
        this.tags.forEach(function(tag) {
            return tag.parentNode && tag.parentNode.removeChild(tag);
        });
        this.tags = [];
        this.ctr = 0;
    };
    return StyleSheet;
}();


var $b868588574af2763$export$71ad59f2e432cfe8 = "-ms-";
var $b868588574af2763$export$2c0f367103c8d01c = "-moz-";
var $b868588574af2763$export$39dfd62a25e0fe93 = "-webkit-";
var $b868588574af2763$export$a29989082612d0d9 = "comm";
var $b868588574af2763$export$aa3a2e812ca8570d = "rule";
var $b868588574af2763$export$527d108ccf083c2b = "decl";
var $b868588574af2763$export$d3d35020fa5b54f0 = "@page";
var $b868588574af2763$export$500415a86c544f73 = "@media";
var $b868588574af2763$export$a763edbf796b780a = "@import";
var $b868588574af2763$export$2790aeb8b4e5c826 = "@charset";
var $b868588574af2763$export$1cc683e23b84b133 = "@viewport";
var $b868588574af2763$export$9447a5efea57e862 = "@supports";
var $b868588574af2763$export$ef011b4e114b1fba = "@document";
var $b868588574af2763$export$6aad947bda0f3f46 = "@namespace";
var $b868588574af2763$export$b44a8529a35fcb60 = "@keyframes";
var $b868588574af2763$export$2c16de31893252e6 = "@font-face";
var $b868588574af2763$export$3d846dd52e150c6f = "@counter-style";
var $b868588574af2763$export$22314bfbb57653fe = "@font-feature-values";
var $b868588574af2763$export$d773506282b3cfe6 = "@layer";
var $b868588574af2763$export$2335f513bbd82c6d = Math.abs;
var $b868588574af2763$export$6788812c4e6611e6 = String.fromCharCode;
var $b868588574af2763$export$e6e34fd1f2686227 = Object.assign;
function $b868588574af2763$export$d6af199866bfb566(e, r) {
    return $b868588574af2763$export$a9db5e087081082d(e, 0) ^ 45 ? (((r << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 0)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 1)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 2)) << 2 ^ $b868588574af2763$export$a9db5e087081082d(e, 3) : 0;
}
function $b868588574af2763$export$87c2784dc9fc4ab(e) {
    return e.trim();
}
function $b868588574af2763$export$4659b591c19bdf3d(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function $b868588574af2763$export$77ad94ebf1c2b9ed(e, r, a) {
    return e.replace(r, a);
}
function $b868588574af2763$export$f8e21b1e77979a08(e, r) {
    return e.indexOf(r);
}
function $b868588574af2763$export$a9db5e087081082d(e, r) {
    return e.charCodeAt(r) | 0;
}
function $b868588574af2763$export$2f35ab04d2335697(e, r, a) {
    return e.slice(r, a);
}
function $b868588574af2763$export$36776f635604f274(e) {
    return e.length;
}
function $b868588574af2763$export$f9084667e487ed46(e) {
    return e.length;
}
function $b868588574af2763$export$10d8903dec122b9d(e, r) {
    return r.push(e), e;
}
function $b868588574af2763$export$1be1fc439b849fdf(e, r) {
    return e.map(r).join("");
}
var $b868588574af2763$export$53f1d5ea8de3d7c = 1;
var $b868588574af2763$export$4e0c71f277ca26b3 = 1;
var $b868588574af2763$export$f24224f1c91d8156 = 0;
var $b868588574af2763$export$5880b8b5730aff45 = 0;
var $b868588574af2763$export$c0306caf338ac095 = 0;
var $b868588574af2763$export$30a86d91af8ff6e6 = "";
function $b868588574af2763$export$35059013cd4a06db(e, r, a, n, c, s, t) {
    return {
        value: e,
        root: r,
        parent: a,
        type: n,
        props: c,
        children: s,
        line: $b868588574af2763$export$53f1d5ea8de3d7c,
        column: $b868588574af2763$export$4e0c71f277ca26b3,
        length: t,
        return: ""
    };
}
function $b868588574af2763$export$784d13d8ee351f07(e, r) {
    return $b868588574af2763$export$e6e34fd1f2686227($b868588574af2763$export$35059013cd4a06db("", null, null, "", null, null, 0), e, {
        length: -e.length
    }, r);
}
function $b868588574af2763$export$eba6f6f03b0a92e7() {
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$232faf9add678146() {
    $b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$5880b8b5730aff45 > 0 ? $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, --$b868588574af2763$export$5880b8b5730aff45) : 0;
    if ($b868588574af2763$export$4e0c71f277ca26b3--, $b868588574af2763$export$c0306caf338ac095 === 10) $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$53f1d5ea8de3d7c--;
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$48cfd1e771a65c4f() {
    $b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$5880b8b5730aff45 < $b868588574af2763$export$f24224f1c91d8156 ? $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, $b868588574af2763$export$5880b8b5730aff45++) : 0;
    if ($b868588574af2763$export$4e0c71f277ca26b3++, $b868588574af2763$export$c0306caf338ac095 === 10) $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$53f1d5ea8de3d7c++;
    return $b868588574af2763$export$c0306caf338ac095;
}
function $b868588574af2763$export$4d3fb11e950abb9e() {
    return $b868588574af2763$export$a9db5e087081082d($b868588574af2763$export$30a86d91af8ff6e6, $b868588574af2763$export$5880b8b5730aff45);
}
function $b868588574af2763$export$e88cb2efb12ae807() {
    return $b868588574af2763$export$5880b8b5730aff45;
}
function $b868588574af2763$export$58adb3bec8346d0f(e, r) {
    return $b868588574af2763$export$2f35ab04d2335697($b868588574af2763$export$30a86d91af8ff6e6, e, r);
}
function $b868588574af2763$export$9e1725a4cfeada27(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function $b868588574af2763$export$2de70f21292aac9e(e) {
    return $b868588574af2763$export$53f1d5ea8de3d7c = $b868588574af2763$export$4e0c71f277ca26b3 = 1, $b868588574af2763$export$f24224f1c91d8156 = $b868588574af2763$export$36776f635604f274($b868588574af2763$export$30a86d91af8ff6e6 = e), $b868588574af2763$export$5880b8b5730aff45 = 0, [];
}
function $b868588574af2763$export$45918ac1574455b1(e) {
    return $b868588574af2763$export$30a86d91af8ff6e6 = "", e;
}
function $b868588574af2763$export$410ac95b9ec204b8(e) {
    return $b868588574af2763$export$87c2784dc9fc4ab($b868588574af2763$export$58adb3bec8346d0f($b868588574af2763$export$5880b8b5730aff45 - 1, $b868588574af2763$export$c889f2fcc19dbf12(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function $b868588574af2763$export$660b2ee2d4fb4eff(e) {
    return $b868588574af2763$export$45918ac1574455b1($b868588574af2763$export$5f8c09e3ae6f64e1($b868588574af2763$export$2de70f21292aac9e(e)));
}
function $b868588574af2763$export$7af1228ff777d175(e) {
    while($b868588574af2763$export$c0306caf338ac095 = $b868588574af2763$export$4d3fb11e950abb9e())if ($b868588574af2763$export$c0306caf338ac095 < 33) $b868588574af2763$export$48cfd1e771a65c4f();
    else break;
    return $b868588574af2763$export$9e1725a4cfeada27(e) > 2 || $b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$c0306caf338ac095) > 3 ? "" : " ";
}
function $b868588574af2763$export$5f8c09e3ae6f64e1(e) {
    while($b868588574af2763$export$48cfd1e771a65c4f())switch($b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$c0306caf338ac095)){
        case 0:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$c2ab62c7bf24634($b868588574af2763$export$5880b8b5730aff45 - 1), e);
            break;
        case 2:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$410ac95b9ec204b8($b868588574af2763$export$c0306caf338ac095), e);
            break;
        default:
            $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$6788812c4e6611e6($b868588574af2763$export$c0306caf338ac095), e);
    }
    return e;
}
function $b868588574af2763$export$955ba06d119e085e(e, r) {
    while(--r && $b868588574af2763$export$48cfd1e771a65c4f())if ($b868588574af2763$export$c0306caf338ac095 < 48 || $b868588574af2763$export$c0306caf338ac095 > 102 || $b868588574af2763$export$c0306caf338ac095 > 57 && $b868588574af2763$export$c0306caf338ac095 < 65 || $b868588574af2763$export$c0306caf338ac095 > 70 && $b868588574af2763$export$c0306caf338ac095 < 97) break;
    return $b868588574af2763$export$58adb3bec8346d0f(e, $b868588574af2763$export$e88cb2efb12ae807() + (r < 6 && $b868588574af2763$export$4d3fb11e950abb9e() == 32 && $b868588574af2763$export$48cfd1e771a65c4f() == 32));
}
function $b868588574af2763$export$c889f2fcc19dbf12(e) {
    while($b868588574af2763$export$48cfd1e771a65c4f())switch($b868588574af2763$export$c0306caf338ac095){
        case e:
            return $b868588574af2763$export$5880b8b5730aff45;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) $b868588574af2763$export$c889f2fcc19dbf12($b868588574af2763$export$c0306caf338ac095);
            break;
        case 40:
            if (e === 41) $b868588574af2763$export$c889f2fcc19dbf12(e);
            break;
        case 92:
            $b868588574af2763$export$48cfd1e771a65c4f();
            break;
    }
    return $b868588574af2763$export$5880b8b5730aff45;
}
function $b868588574af2763$export$4254d4e2b3745c4c(e, r) {
    while($b868588574af2763$export$48cfd1e771a65c4f())if (e + $b868588574af2763$export$c0306caf338ac095 === 57) break;
    else if (e + $b868588574af2763$export$c0306caf338ac095 === 84 && $b868588574af2763$export$4d3fb11e950abb9e() === 47) break;
    return "/*" + $b868588574af2763$export$58adb3bec8346d0f(r, $b868588574af2763$export$5880b8b5730aff45 - 1) + "*" + $b868588574af2763$export$6788812c4e6611e6(e === 47 ? e : $b868588574af2763$export$48cfd1e771a65c4f());
}
function $b868588574af2763$export$c2ab62c7bf24634(e) {
    while(!$b868588574af2763$export$9e1725a4cfeada27($b868588574af2763$export$4d3fb11e950abb9e()))$b868588574af2763$export$48cfd1e771a65c4f();
    return $b868588574af2763$export$58adb3bec8346d0f(e, $b868588574af2763$export$5880b8b5730aff45);
}
function $b868588574af2763$export$ef7acd7185315e22(e) {
    return $b868588574af2763$export$45918ac1574455b1($b868588574af2763$export$98e6a39c04603d36("", null, null, null, [
        ""
    ], e = $b868588574af2763$export$2de70f21292aac9e(e), 0, [
        0
    ], e));
}
function $b868588574af2763$export$98e6a39c04603d36(e, r, a, n, c, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var v = 0;
    var p = 0;
    var h = 0;
    var b = 1;
    var w = 1;
    var d = 1;
    var $ = 0;
    var g = "";
    var m = c;
    var x = s;
    var y = n;
    var j = g;
    while(w)switch(h = $, $ = $b868588574af2763$export$48cfd1e771a65c4f()){
        case 40:
            if (h != 108 && $b868588574af2763$export$a9db5e087081082d(j, l - 1) == 58) {
                if ($b868588574af2763$export$f8e21b1e77979a08(j += $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$410ac95b9ec204b8($), "&", "&\f"), "&\f") != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            j += $b868588574af2763$export$410ac95b9ec204b8($);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            j += $b868588574af2763$export$7af1228ff777d175(h);
            break;
        case 92:
            j += $b868588574af2763$export$955ba06d119e085e($b868588574af2763$export$e88cb2efb12ae807() - 1, 7);
            continue;
        case 47:
            switch($b868588574af2763$export$4d3fb11e950abb9e()){
                case 42:
                case 47:
                    $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$4a34f930e789283c($b868588574af2763$export$4254d4e2b3745c4c($b868588574af2763$export$48cfd1e771a65c4f(), $b868588574af2763$export$e88cb2efb12ae807()), r, a), i);
                    break;
                default:
                    j += "/";
            }
            break;
        case 123 * b:
            u[f++] = $b868588574af2763$export$36776f635604f274(j) * d;
        case 125 * b:
        case 59:
        case 0:
            switch($){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) j = $b868588574af2763$export$77ad94ebf1c2b9ed(j, /\f/g, "");
                    if (p > 0 && $b868588574af2763$export$36776f635604f274(j) - l) $b868588574af2763$export$10d8903dec122b9d(p > 32 ? $b868588574af2763$export$f8483753829ec8f3(j + ";", n, a, l - 1) : $b868588574af2763$export$f8483753829ec8f3($b868588574af2763$export$77ad94ebf1c2b9ed(j, " ", "") + ";", n, a, l - 2), i);
                    break;
                case 59:
                    j += ";";
                default:
                    $b868588574af2763$export$10d8903dec122b9d(y = $b868588574af2763$export$3307ffa7023ede1e(j, r, a, f, o, c, u, g, m = [], x = [], l), s);
                    if ($ === 123) {
                        if (o === 0) $b868588574af2763$export$98e6a39c04603d36(j, r, y, y, m, s, l, u, x);
                        else switch(v === 99 && $b868588574af2763$export$a9db5e087081082d(j, 3) === 110 ? 100 : v){
                            case 100:
                            case 108:
                            case 109:
                            case 115:
                                $b868588574af2763$export$98e6a39c04603d36(e, y, y, n && $b868588574af2763$export$10d8903dec122b9d($b868588574af2763$export$3307ffa7023ede1e(e, y, y, 0, 0, c, u, g, c, m = [], l), x), c, x, l, u, n ? m : x);
                                break;
                            default:
                                $b868588574af2763$export$98e6a39c04603d36(j, y, y, y, [
                                    ""
                                ], x, 0, u, x);
                        }
                    }
            }
            f = o = p = 0, b = d = 1, g = j = "", l = t;
            break;
        case 58:
            l = 1 + $b868588574af2763$export$36776f635604f274(j), p = h;
        default:
            if (b < 1) {
                if ($ == 123) --b;
                else if ($ == 125 && b++ == 0 && $b868588574af2763$export$232faf9add678146() == 125) continue;
            }
            switch(j += $b868588574af2763$export$6788812c4e6611e6($), $ * b){
                case 38:
                    d = o > 0 ? 1 : (j += "\f", -1);
                    break;
                case 44:
                    u[f++] = ($b868588574af2763$export$36776f635604f274(j) - 1) * d, d = 1;
                    break;
                case 64:
                    if ($b868588574af2763$export$4d3fb11e950abb9e() === 45) j += $b868588574af2763$export$410ac95b9ec204b8($b868588574af2763$export$48cfd1e771a65c4f());
                    v = $b868588574af2763$export$4d3fb11e950abb9e(), o = l = $b868588574af2763$export$36776f635604f274(g = j += $b868588574af2763$export$c2ab62c7bf24634($b868588574af2763$export$e88cb2efb12ae807())), $++;
                    break;
                case 45:
                    if (h === 45 && $b868588574af2763$export$36776f635604f274(j) == 2) b = 0;
            }
    }
    return s;
}
function $b868588574af2763$export$3307ffa7023ede1e(e, r, a, n, s, t, u, i, f, o, l) {
    var v = s - 1;
    var p = s === 0 ? t : [
        ""
    ];
    var h = $b868588574af2763$export$f9084667e487ed46(p);
    for(var b = 0, w = 0, d = 0; b < n; ++b)for(var $ = 0, k = $b868588574af2763$export$2f35ab04d2335697(e, v + 1, v = $b868588574af2763$export$2335f513bbd82c6d(w = u[b])), m = e; $ < h; ++$)if (m = $b868588574af2763$export$87c2784dc9fc4ab(w > 0 ? p[$] + " " + k : $b868588574af2763$export$77ad94ebf1c2b9ed(k, /&\f/g, p[$]))) f[d++] = m;
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, s === 0 ? $b868588574af2763$export$aa3a2e812ca8570d : i, f, o, l);
}
function $b868588574af2763$export$4a34f930e789283c(e, r, a) {
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, $b868588574af2763$export$a29989082612d0d9, $b868588574af2763$export$6788812c4e6611e6($b868588574af2763$export$eba6f6f03b0a92e7()), $b868588574af2763$export$2f35ab04d2335697(e, 2, -2), 0);
}
function $b868588574af2763$export$f8483753829ec8f3(e, r, a, n) {
    return $b868588574af2763$export$35059013cd4a06db(e, r, a, $b868588574af2763$export$527d108ccf083c2b, $b868588574af2763$export$2f35ab04d2335697(e, 0, n), $b868588574af2763$export$2f35ab04d2335697(e, n + 1, -1), n);
}
function $b868588574af2763$export$82e9f45cca5ba907(n, c, s) {
    switch($b868588574af2763$export$d6af199866bfb566(n, c)){
        case 5103:
            return $b868588574af2763$export$39dfd62a25e0fe93 + "print-" + n + n;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + n;
        case 4789:
            return $b868588574af2763$export$2c0f367103c8d01c + n + n;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$2c0f367103c8d01c + n + $b868588574af2763$export$71ad59f2e432cfe8 + n + n;
        case 5936:
            switch($b868588574af2763$export$a9db5e087081082d(n, c + 11)){
                case 114:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb") + n;
                case 108:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "tb-rl") + n;
                case 45:
                    return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /[svh]\w+-[tblr]{2}/, "lr") + n;
            }
        case 6828:
        case 4268:
        case 2903:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + n + n;
        case 6165:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-" + n + n;
        case 5187:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(\w+).+(:[^]+)/, $b868588574af2763$export$39dfd62a25e0fe93 + "box-$1$2" + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-$1$2") + n;
        case 5443:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-item-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") + (!$b868588574af2763$export$4659b591c19bdf3d(n, /flex-|baseline/) ? $b868588574af2763$export$71ad59f2e432cfe8 + "grid-row-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /flex-|-self/g, "") : "") + n;
        case 4675:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-line-pack" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /align-content|flex-|-self/g, "") + n;
        case 5548:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "shrink", "negative") + n;
        case 5292:
            return $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "basis", "preferred-size") + n;
        case 6060:
            return $b868588574af2763$export$39dfd62a25e0fe93 + "box-" + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-grow", "") + $b868588574af2763$export$39dfd62a25e0fe93 + n + $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "grow", "positive") + n;
        case 4554:
            return $b868588574af2763$export$39dfd62a25e0fe93 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, /([^-])(transform)/g, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2") + n;
        case 6187:
            return $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, /(zoom-|grab)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1"), /(image-set)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1"), n, "") + n;
        case 5495:
        case 3959:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(image-set\([^]*)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1" + "$`$1");
        case 4968:
            return $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)(flex-)?(.*)/, $b868588574af2763$export$39dfd62a25e0fe93 + "box-pack:$3" + $b868588574af2763$export$71ad59f2e432cfe8 + "flex-pack:$3"), /s.+-b[^;]+/, "justify") + $b868588574af2763$export$39dfd62a25e0fe93 + n + n;
        case 4200:
            if (!$b868588574af2763$export$4659b591c19bdf3d(n, /flex-|baseline/)) return $b868588574af2763$export$71ad59f2e432cfe8 + "grid-column-align" + $b868588574af2763$export$2f35ab04d2335697(n, c) + n;
            break;
        case 2592:
        case 3360:
            return $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "template-", "") + n;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return c = r, $b868588574af2763$export$4659b591c19bdf3d(e.props, /grid-\w+-end/);
            })) return ~$b868588574af2763$export$f8e21b1e77979a08(n + (s = s[c].value), "span") ? n : $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-start", "") + n + $b868588574af2763$export$71ad59f2e432cfe8 + "grid-row-span:" + (~$b868588574af2763$export$f8e21b1e77979a08(s, "span") ? $b868588574af2763$export$4659b591c19bdf3d(s, /\d+/) : +$b868588574af2763$export$4659b591c19bdf3d(s, /\d+/) - +$b868588574af2763$export$4659b591c19bdf3d(n, /\d+/)) + ";";
            return $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed(n, "-start", "") + n;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return $b868588574af2763$export$4659b591c19bdf3d(e.props, /grid-\w+-start/);
            }) ? n : $b868588574af2763$export$71ad59f2e432cfe8 + $b868588574af2763$export$77ad94ebf1c2b9ed($b868588574af2763$export$77ad94ebf1c2b9ed(n, "-end", "-span"), "span ", "") + n;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+)-inline(.+)/, $b868588574af2763$export$39dfd62a25e0fe93 + "$1$2") + n;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if ($b868588574af2763$export$36776f635604f274(n) - 1 - c > 6) switch($b868588574af2763$export$a9db5e087081082d(n, c + 1)){
                case 109:
                    if ($b868588574af2763$export$a9db5e087081082d(n, c + 4) !== 45) break;
                case 102:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)(.+)-([^]+)/, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2-$3" + "$1" + $b868588574af2763$export$2c0f367103c8d01c + ($b868588574af2763$export$a9db5e087081082d(n, c + 3) == 108 ? "$3" : "$2-$3")) + n;
                case 115:
                    return ~$b868588574af2763$export$f8e21b1e77979a08(n, "stretch") ? $b868588574af2763$export$82e9f45cca5ba907($b868588574af2763$export$77ad94ebf1c2b9ed(n, "stretch", "fill-available"), c, s) + n : n;
            }
            break;
        case 5152:
        case 5920:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, c, s, t, u, i) {
                return $b868588574af2763$export$71ad59f2e432cfe8 + a + ":" + c + i + (s ? $b868588574af2763$export$71ad59f2e432cfe8 + a + "-span:" + (t ? u : +u - +c) + i : "") + n;
            });
        case 4949:
            if ($b868588574af2763$export$a9db5e087081082d(n, c + 6) === 121) return $b868588574af2763$export$77ad94ebf1c2b9ed(n, ":", ":" + $b868588574af2763$export$39dfd62a25e0fe93) + n;
            break;
        case 6444:
            switch($b868588574af2763$export$a9db5e087081082d(n, $b868588574af2763$export$a9db5e087081082d(n, 14) === 45 ? 18 : 11)){
                case 120:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + ($b868588574af2763$export$a9db5e087081082d(n, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + $b868588574af2763$export$39dfd62a25e0fe93 + "$2$3" + "$1" + $b868588574af2763$export$71ad59f2e432cfe8 + "$2box$3") + n;
                case 100:
                    return $b868588574af2763$export$77ad94ebf1c2b9ed(n, ":", ":" + $b868588574af2763$export$71ad59f2e432cfe8) + n;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return $b868588574af2763$export$77ad94ebf1c2b9ed(n, "scroll-", "scroll-snap-") + n;
    }
    return n;
}
function $b868588574af2763$export$dfdc1655ccc5b9cb(e, r) {
    var a = "";
    var n = $b868588574af2763$export$f9084667e487ed46(e);
    for(var c = 0; c < n; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function $b868588574af2763$export$fac44ee5b035f737(e, r, a, t) {
    switch(e.type){
        case $b868588574af2763$export$d773506282b3cfe6:
            if (e.children.length) break;
        case $b868588574af2763$export$a763edbf796b780a:
        case $b868588574af2763$export$527d108ccf083c2b:
            return e.return = e.return || e.value;
        case $b868588574af2763$export$a29989082612d0d9:
            return "";
        case $b868588574af2763$export$b44a8529a35fcb60:
            return e.return = e.value + "{" + $b868588574af2763$export$dfdc1655ccc5b9cb(e.children, t) + "}";
        case $b868588574af2763$export$aa3a2e812ca8570d:
            e.value = e.props.join(",");
    }
    return $b868588574af2763$export$36776f635604f274(a = $b868588574af2763$export$dfdc1655ccc5b9cb(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function $b868588574af2763$export$5a7767152ae0305f(e) {
    var r = $b868588574af2763$export$f9084667e487ed46(e);
    return function(a, n, c, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, n, c, s) || "";
        return t;
    };
}
function $b868588574af2763$export$38bcb760f1d4871c(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function $b868588574af2763$export$e08c7d021b829b7a(n, t, u, i) {
    if (n.length > -1) {
        if (!n.return) switch(n.type){
            case $b868588574af2763$export$527d108ccf083c2b:
                n.return = $b868588574af2763$export$82e9f45cca5ba907(n.value, n.length, u);
                return;
            case $b868588574af2763$export$b44a8529a35fcb60:
                return $b868588574af2763$export$dfdc1655ccc5b9cb([
                    $b868588574af2763$export$784d13d8ee351f07(n, {
                        value: $b868588574af2763$export$77ad94ebf1c2b9ed(n.value, "@", "@" + $b868588574af2763$export$39dfd62a25e0fe93)
                    })
                ], i);
            case $b868588574af2763$export$aa3a2e812ca8570d:
                if (n.length) return $b868588574af2763$export$1be1fc439b849fdf(n.props, function(c) {
                    switch($b868588574af2763$export$4659b591c19bdf3d(c, /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            return $b868588574af2763$export$dfdc1655ccc5b9cb([
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(read-\w+)/, ":" + $b868588574af2763$export$2c0f367103c8d01c + "$1")
                                    ]
                                })
                            ], i);
                        case "::placeholder":
                            return $b868588574af2763$export$dfdc1655ccc5b9cb([
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b868588574af2763$export$39dfd62a25e0fe93 + "input-$1")
                                    ]
                                }),
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, ":" + $b868588574af2763$export$2c0f367103c8d01c + "$1")
                                    ]
                                }),
                                $b868588574af2763$export$784d13d8ee351f07(n, {
                                    props: [
                                        $b868588574af2763$export$77ad94ebf1c2b9ed(c, /:(plac\w+)/, $b868588574af2763$export$71ad59f2e432cfe8 + "input-$1")
                                    ]
                                })
                            ], i);
                    }
                    return "";
                });
        }
    }
}
function $b868588574af2763$export$76a88f7de6507443(e) {
    switch(e.type){
        case $b868588574af2763$export$aa3a2e812ca8570d:
            e.props = e.props.map(function(r) {
                return $b868588574af2763$export$1be1fc439b849fdf($b868588574af2763$export$660b2ee2d4fb4eff(r), function(r, a, n) {
                    switch($b868588574af2763$export$a9db5e087081082d(r, 0)){
                        case 12:
                            return $b868588574af2763$export$2f35ab04d2335697(r, 1, $b868588574af2763$export$36776f635604f274(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (n[++a] === "global") n[a] = "", n[++a] = "\f" + $b868588574af2763$export$2f35ab04d2335697(n[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return $b868588574af2763$export$f9084667e487ed46(n) > 1 ? "" : r;
                                case a = $b868588574af2763$export$f9084667e487ed46(n) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}


var $1590e71a06f1c94c$export$2e2bcd8739ae039 = function weakMemoize(func) {
    // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
    var cache = new WeakMap();
    return function(arg) {
        if (cache.has(arg)) // $FlowFixMe
        return cache.get(arg);
        var ret = func(arg);
        cache.set(arg, ret);
        return ret;
    };
};


function $5c4b43fa4ca9ca56$export$2e2bcd8739ae039(fn) {
    var cache = Object.create(null);
    return function(arg) {
        if (cache[arg] === undefined) cache[arg] = fn(arg);
        return cache[arg];
    };
}


var $2af2a3b133a3d08e$var$identifierWithPointTracking = function identifierWithPointTracking(begin, points, index) {
    var previous = 0;
    var character = 0;
    while(true){
        previous = character;
        character = (0, $b868588574af2763$export$4d3fb11e950abb9e)(); // &\f
        if (previous === 38 && character === 12) points[index] = 1;
        if ((0, $b868588574af2763$export$9e1725a4cfeada27)(character)) break;
        (0, $b868588574af2763$export$48cfd1e771a65c4f)();
    }
    return (0, $b868588574af2763$export$58adb3bec8346d0f)(begin, (0, $b868588574af2763$export$5880b8b5730aff45));
};
var $2af2a3b133a3d08e$var$toRules = function toRules(parsed, points) {
    // pretend we've started with a comma
    var index = -1;
    var character = 44;
    do switch((0, $b868588574af2763$export$9e1725a4cfeada27)(character)){
        case 0:
            // &\f
            if (character === 38 && (0, $b868588574af2763$export$4d3fb11e950abb9e)() === 12) // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
            // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
            // and when it should just concatenate the outer and inner selectors
            // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
            points[index] = 1;
            parsed[index] += $2af2a3b133a3d08e$var$identifierWithPointTracking((0, $b868588574af2763$export$5880b8b5730aff45) - 1, points, index);
            break;
        case 2:
            parsed[index] += (0, $b868588574af2763$export$410ac95b9ec204b8)(character);
            break;
        case 4:
            // comma
            if (character === 44) {
                // colon
                parsed[++index] = (0, $b868588574af2763$export$4d3fb11e950abb9e)() === 58 ? '&\f' : '';
                points[index] = parsed[index].length;
                break;
            }
        // fallthrough
        default:
            parsed[index] += (0, $b868588574af2763$export$6788812c4e6611e6)(character);
    }
    while (character = (0, $b868588574af2763$export$48cfd1e771a65c4f)());
    return parsed;
};
var $2af2a3b133a3d08e$var$getRules = function getRules(value, points) {
    return (0, $b868588574af2763$export$45918ac1574455b1)($2af2a3b133a3d08e$var$toRules((0, $b868588574af2763$export$2de70f21292aac9e)(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11
var $2af2a3b133a3d08e$var$fixedElements = /* #__PURE__ */ new WeakMap();
var $2af2a3b133a3d08e$var$compat = function compat(element) {
    if (element.type !== 'rule' || !element.parent || // positive .length indicates that this rule contains pseudo
    // negative .length indicates that this rule has been already prefixed
    element.length < 1) return;
    var value = element.value, parent = element.parent;
    var isImplicitRule = element.column === parent.column && element.line === parent.line;
    while(parent.type !== 'rule'){
        parent = parent.parent;
        if (!parent) return;
    } // short-circuit for the simplest case
    if (element.props.length === 1 && value.charCodeAt(0) !== 58 && !$2af2a3b133a3d08e$var$fixedElements.get(parent)) return;
     // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
    // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"
    if (isImplicitRule) return;
    $2af2a3b133a3d08e$var$fixedElements.set(element, true);
    var points = [];
    var rules = $2af2a3b133a3d08e$var$getRules(value, points);
    var parentRules = parent.props;
    for(var i = 0, k = 0; i < rules.length; i++)for(var j = 0; j < parentRules.length; j++, k++)element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
};
var $2af2a3b133a3d08e$var$removeLabel = function removeLabel(element) {
    if (element.type === 'decl') {
        var value = element.value;
        if (value.charCodeAt(0) === 108 && // charcode for b
        value.charCodeAt(2) === 98) {
            // this ignores label
            element["return"] = '';
            element.value = '';
        }
    }
};
var $2af2a3b133a3d08e$var$ignoreFlag = 'emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason';
var $2af2a3b133a3d08e$var$isIgnoringComment = function isIgnoringComment(element) {
    return element.type === 'comm' && element.children.indexOf($2af2a3b133a3d08e$var$ignoreFlag) > -1;
};
var $2af2a3b133a3d08e$var$createUnsafeSelectorsAlarm = function createUnsafeSelectorsAlarm(cache) {
    return function(element, index, children) {
        if (element.type !== 'rule' || cache.compat) return;
        var unsafePseudoClasses = element.value.match(/(:first|:nth|:nth-last)-child/g);
        if (unsafePseudoClasses) {
            var isNested = !!element.parent; // in nested rules comments become children of the "auto-inserted" rule and that's always the `element.parent`
            //
            // considering this input:
            // .a {
            //   .b /* comm */ {}
            //   color: hotpink;
            // }
            // we get output corresponding to this:
            // .a {
            //   & {
            //     /* comm */
            //     color: hotpink;
            //   }
            //   .b {}
            // }
            var commentContainer = isNested ? element.parent.children : children;
            for(var i = commentContainer.length - 1; i >= 0; i--){
                var node = commentContainer[i];
                if (node.line < element.line) break;
                 // it is quite weird but comments are *usually* put at `column: element.column - 1`
                // so we seek *from the end* for the node that is earlier than the rule's `element` and check that
                // this will also match inputs like this:
                // .a {
                //   /* comm */
                //   .b {}
                // }
                //
                // but that is fine
                //
                // it would be the easiest to change the placement of the comment to be the first child of the rule:
                // .a {
                //   .b { /* comm */ }
                // }
                // with such inputs we wouldn't have to search for the comment at all
                // TODO: consider changing this comment placement in the next major version
                if (node.column < element.column) {
                    if ($2af2a3b133a3d08e$var$isIgnoringComment(node)) return;
                    break;
                }
            }
            unsafePseudoClasses.forEach(function(unsafePseudoClass) {
                console.error("The pseudo class \"" + unsafePseudoClass + "\" is potentially unsafe when doing server-side rendering. Try changing it to \"" + unsafePseudoClass.split('-child')[0] + "-of-type\".");
            });
        }
    };
};
var $2af2a3b133a3d08e$var$isImportRule = function isImportRule(element) {
    return element.type.charCodeAt(1) === 105 && element.type.charCodeAt(0) === 64;
};
var $2af2a3b133a3d08e$var$isPrependedWithRegularRules = function isPrependedWithRegularRules(index, children) {
    for(var i = index - 1; i >= 0; i--){
        if (!$2af2a3b133a3d08e$var$isImportRule(children[i])) return true;
    }
    return false;
}; // use this to remove incorrect elements from further processing
// so they don't get handed to the `sheet` (or anything else)
// as that could potentially lead to additional logs which in turn could be overhelming to the user
var $2af2a3b133a3d08e$var$nullifyElement = function nullifyElement(element) {
    element.type = '';
    element.value = '';
    element["return"] = '';
    element.children = '';
    element.props = '';
};
var $2af2a3b133a3d08e$var$incorrectImportAlarm = function incorrectImportAlarm(element, index, children) {
    if (!$2af2a3b133a3d08e$var$isImportRule(element)) return;
    if (element.parent) {
        console.error("`@import` rules can't be nested inside other rules. Please move it to the top level and put it before regular rules. Keep in mind that they can only be used within global styles.");
        $2af2a3b133a3d08e$var$nullifyElement(element);
    } else if ($2af2a3b133a3d08e$var$isPrependedWithRegularRules(index, children)) {
        console.error("`@import` rules can't be after other rules. Please put your `@import` rules before your other rules.");
        $2af2a3b133a3d08e$var$nullifyElement(element);
    }
};
/* eslint-disable no-fallthrough */ function $2af2a3b133a3d08e$var$prefix(value, length) {
    switch((0, $b868588574af2763$export$d6af199866bfb566)(value, length)){
        // color-adjust
        case 5103:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + 'print-' + value + value;
        // animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
        case 4855:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + value;
        // appearance, user-select, transform, hyphens, text-size-adjust
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$2c0f367103c8d01c) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + value + value;
        // flex, flex-direction
        case 6828:
        case 4268:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + value + value;
        // order
        case 6165:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + 'flex-' + value + value;
        // align-items
        case 5187:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(\w+).+(:[^]+)/, (0, $b868588574af2763$export$39dfd62a25e0fe93) + 'box-$1$2' + (0, $b868588574af2763$export$71ad59f2e432cfe8) + 'flex-$1$2') + value;
        // align-self
        case 5443:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + 'flex-item-' + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /flex-|-self/, '') + value;
        // align-content
        case 4675:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + 'flex-line-pack' + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /align-content|flex-|-self/, '') + value;
        // flex-shrink
        case 5548:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, 'shrink', 'negative') + value;
        // flex-basis
        case 5292:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, 'basis', 'preferred-size') + value;
        // flex-grow
        case 6060:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + 'box-' + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, '-grow', '') + (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, 'grow', 'positive') + value;
        // transition
        case 4554:
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /([^-])(transform)/g, '$1' + (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$2') + value;
        // cursor
        case 6187:
            return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)((0, $b868588574af2763$export$77ad94ebf1c2b9ed)((0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(zoom-|grab)/, (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$1'), /(image-set)/, (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$1'), value, '') + value;
        // background, background-image
        case 5495:
        case 3959:
            return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(image-set\([^]*)/, (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$1' + '$`$1');
        // justify-content
        case 4968:
            return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)((0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(.+:)(flex-)?(.*)/, (0, $b868588574af2763$export$39dfd62a25e0fe93) + 'box-pack:$3' + (0, $b868588574af2763$export$71ad59f2e432cfe8) + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + value;
        // (margin|padding)-inline-(start|end)
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(.+)-inline(.+)/, (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$1$2') + value;
        // (min|max)?(width|height|inline-size|block-size)
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            // stretch, max-content, min-content, fill-available
            if ((0, $b868588574af2763$export$36776f635604f274)(value) - 1 - length > 6) switch((0, $b868588574af2763$export$a9db5e087081082d)(value, length + 1)){
                // (m)ax-content, (m)in-content
                case 109:
                    // -
                    if ((0, $b868588574af2763$export$a9db5e087081082d)(value, length + 4) !== 45) break;
                // (f)ill-available, (f)it-content
                case 102:
                    return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(.+:)(.+)-([^]+)/, '$1' + (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$2-$3' + '$1' + (0, $b868588574af2763$export$2c0f367103c8d01c) + ((0, $b868588574af2763$export$a9db5e087081082d)(value, length + 3) == 108 ? '$3' : '$2-$3')) + value;
                // (s)tretch
                case 115:
                    return ~(0, $b868588574af2763$export$f8e21b1e77979a08)(value, 'stretch') ? $2af2a3b133a3d08e$var$prefix((0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, 'stretch', 'fill-available'), length) + value : value;
            }
            break;
        // position: sticky
        case 4949:
            // (s)ticky?
            if ((0, $b868588574af2763$export$a9db5e087081082d)(value, length + 1) !== 115) break;
        // display: (flex|inline-flex)
        case 6444:
            switch((0, $b868588574af2763$export$a9db5e087081082d)(value, (0, $b868588574af2763$export$36776f635604f274)(value) - 3 - (~(0, $b868588574af2763$export$f8e21b1e77979a08)(value, '!important') && 10))){
                // stic(k)y
                case 107:
                    return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, ':', ':' + (0, $b868588574af2763$export$39dfd62a25e0fe93)) + value;
                // (inline-)?fl(e)x
                case 101:
                    return (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + (0, $b868588574af2763$export$39dfd62a25e0fe93) + ((0, $b868588574af2763$export$a9db5e087081082d)(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + (0, $b868588574af2763$export$39dfd62a25e0fe93) + '$2$3' + '$1' + (0, $b868588574af2763$export$71ad59f2e432cfe8) + '$2box$3') + value;
            }
            break;
        // writing-mode
        case 5936:
            switch((0, $b868588574af2763$export$a9db5e087081082d)(value, length + 11)){
                // vertical-l(r)
                case 114:
                    return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb') + value;
                // vertical-r(l)
                case 108:
                    return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value;
                // horizontal(-)tb
                case 45:
                    return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /[svh]\w+-[tblr]{2}/, 'lr') + value;
            }
            return (0, $b868588574af2763$export$39dfd62a25e0fe93) + value + (0, $b868588574af2763$export$71ad59f2e432cfe8) + value + value;
    }
    return value;
}
var $2af2a3b133a3d08e$var$prefixer = function prefixer(element, index, children, callback) {
    if (element.length > -1) {
        if (!element["return"]) switch(element.type){
            case 0, $b868588574af2763$export$527d108ccf083c2b:
                element["return"] = $2af2a3b133a3d08e$var$prefix(element.value, element.length);
                break;
            case 0, $b868588574af2763$export$b44a8529a35fcb60:
                return (0, $b868588574af2763$export$dfdc1655ccc5b9cb)([
                    (0, $b868588574af2763$export$784d13d8ee351f07)(element, {
                        value: (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(element.value, '@', '@' + (0, $b868588574af2763$export$39dfd62a25e0fe93))
                    })
                ], callback);
            case 0, $b868588574af2763$export$aa3a2e812ca8570d:
                if (element.length) return (0, $b868588574af2763$export$1be1fc439b849fdf)(element.props, function(value) {
                    switch((0, $b868588574af2763$export$4659b591c19bdf3d)(value, /(::plac\w+|:read-\w+)/)){
                        // :read-(only|write)
                        case ':read-only':
                        case ':read-write':
                            return (0, $b868588574af2763$export$dfdc1655ccc5b9cb)([
                                (0, $b868588574af2763$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /:(read-\w+)/, ':' + (0, $b868588574af2763$export$2c0f367103c8d01c) + '$1')
                                    ]
                                })
                            ], callback);
                        // :placeholder
                        case '::placeholder':
                            return (0, $b868588574af2763$export$dfdc1655ccc5b9cb)([
                                (0, $b868588574af2763$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $b868588574af2763$export$39dfd62a25e0fe93) + 'input-$1')
                                    ]
                                }),
                                (0, $b868588574af2763$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, ':' + (0, $b868588574af2763$export$2c0f367103c8d01c) + '$1')
                                    ]
                                }),
                                (0, $b868588574af2763$export$784d13d8ee351f07)(element, {
                                    props: [
                                        (0, $b868588574af2763$export$77ad94ebf1c2b9ed)(value, /:(plac\w+)/, (0, $b868588574af2763$export$71ad59f2e432cfe8) + 'input-$1')
                                    ]
                                })
                            ], callback);
                    }
                    return '';
                });
        }
    }
};
var $2af2a3b133a3d08e$var$defaultStylisPlugins = [
    $2af2a3b133a3d08e$var$prefixer
];
var $2af2a3b133a3d08e$export$2e2bcd8739ae039 = function createCache(options) {
    var key = options.key;
    if (key === 'css') {
        var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
        // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
        // note this very very intentionally targets all style elements regardless of the key to ensure
        // that creating a cache works inside of render of a React component
        Array.prototype.forEach.call(ssrStyles, function(node) {
            // we want to only move elements which have a space in the data-emotion attribute value
            // because that indicates that it is an Emotion 11 server-side rendered style elements
            // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
            // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
            // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
            // will not result in the Emotion 10 styles being destroyed
            var dataEmotionAttribute = node.getAttribute('data-emotion');
            if (dataEmotionAttribute.indexOf(' ') === -1) return;
            document.head.appendChild(node);
            node.setAttribute('data-s', '');
        });
    }
    var stylisPlugins = options.stylisPlugins || $2af2a3b133a3d08e$var$defaultStylisPlugins;
    var inserted = {};
    var container;
    var nodesToHydrate = [];
    container = options.container || document.head;
    Array.prototype.forEach.call(// means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function(node) {
        var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe
        for(var i = 1; i < attrib.length; i++)inserted[attrib[i]] = true;
        nodesToHydrate.push(node);
    });
    var _insert;
    var omnipresentPlugins = [
        $2af2a3b133a3d08e$var$compat,
        $2af2a3b133a3d08e$var$removeLabel
    ];
    var currentSheet;
    var finalizingPlugins = [
        (0, $b868588574af2763$export$fac44ee5b035f737),
        (0, $b868588574af2763$export$38bcb760f1d4871c)(function(rule) {
            currentSheet.insert(rule);
        })
    ];
    var serializer = (0, $b868588574af2763$export$5a7767152ae0305f)(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));
    var stylis = function stylis(styles) {
        return (0, $b868588574af2763$export$dfdc1655ccc5b9cb)((0, $b868588574af2763$export$ef7acd7185315e22)(styles), serializer);
    };
    _insert = function insert(selector, serialized, sheet, shouldCache) {
        currentSheet = sheet;
        stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
        if (shouldCache) cache.inserted[serialized.name] = true;
    };
    var cache = {
        key: key,
        sheet: new (0, $7fa809f9c19f15c3$export$9d753cd7ae895cce)({
            key: key,
            container: container,
            nonce: options.nonce,
            speedy: options.speedy,
            prepend: options.prepend,
            insertionPoint: options.insertionPoint
        }),
        nonce: options.nonce,
        inserted: inserted,
        registered: {},
        insert: _insert
    };
    cache.sheet.hydrate(nodesToHydrate);
    return cache;
};




var $ed62d7b2a7b04291$exports = {};
'use strict';

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */ var $ed62d7b2a7b04291$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $ed62d7b2a7b04291$var$FORWARD_REF_STATICS = {
    '$$typeof': true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $ed62d7b2a7b04291$var$MEMO_STATICS = {
    '$$typeof': true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $ed62d7b2a7b04291$var$TYPE_STATICS = {};
$ed62d7b2a7b04291$var$TYPE_STATICS[$faa8b3ec9683c8b0$exports.ForwardRef] = $ed62d7b2a7b04291$var$FORWARD_REF_STATICS;
$ed62d7b2a7b04291$var$TYPE_STATICS[$faa8b3ec9683c8b0$exports.Memo] = $ed62d7b2a7b04291$var$MEMO_STATICS;
function $ed62d7b2a7b04291$var$getStatics(component) {
    // React v16.11 and below
    if ($faa8b3ec9683c8b0$exports.isMemo(component)) return $ed62d7b2a7b04291$var$MEMO_STATICS;
     // React v16.12 and above
    return $ed62d7b2a7b04291$var$TYPE_STATICS[component['$$typeof']] || $ed62d7b2a7b04291$var$REACT_STATICS;
}
var $ed62d7b2a7b04291$var$defineProperty = Object.defineProperty;
var $ed62d7b2a7b04291$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $ed62d7b2a7b04291$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $ed62d7b2a7b04291$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $ed62d7b2a7b04291$var$getPrototypeOf = Object.getPrototypeOf;
var $ed62d7b2a7b04291$var$objectPrototype = Object.prototype;
function $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') {
        // don't hoist over string (html) components
        if ($ed62d7b2a7b04291$var$objectPrototype) {
            var inheritedComponent = $ed62d7b2a7b04291$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $ed62d7b2a7b04291$var$objectPrototype) $ed62d7b2a7b04291$var$hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
        }
        var keys = $ed62d7b2a7b04291$var$getOwnPropertyNames(sourceComponent);
        if ($ed62d7b2a7b04291$var$getOwnPropertySymbols) keys = keys.concat($ed62d7b2a7b04291$var$getOwnPropertySymbols(sourceComponent));
        var targetStatics = $ed62d7b2a7b04291$var$getStatics(targetComponent);
        var sourceStatics = $ed62d7b2a7b04291$var$getStatics(sourceComponent);
        for(var i = 0; i < keys.length; ++i){
            var key = keys[i];
            if (!$ed62d7b2a7b04291$var$KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                var descriptor = $ed62d7b2a7b04291$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    // Avoid failures from read-only properties
                    $ed62d7b2a7b04291$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
$ed62d7b2a7b04291$exports = $ed62d7b2a7b04291$var$hoistNonReactStatics;


// this file isolates this package that is not tree-shakeable
// and if this module doesn't actually contain any logic of its own
// then Rollup just use 'hoist-non-react-statics' directly in other chunks
var $4b415f6a5b424019$export$2e2bcd8739ae039 = function(targetComponent, sourceComponent) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ed62d7b2a7b04291$exports)))(targetComponent, sourceComponent);
};


var $d123aa206da6f3da$var$isBrowser = true;
function $d123aa206da6f3da$export$95d99596f328fd52(registered, registeredStyles, classNames) {
    var rawClassName = '';
    classNames.split(' ').forEach(function(className) {
        if (registered[className] !== undefined) registeredStyles.push(registered[className] + ";");
        else rawClassName += className + " ";
    });
    return rawClassName;
}
var $d123aa206da6f3da$export$580009a5da2a8b4b = function registerStyles(cache, serialized, isStringTag) {
    var className = cache.key + "-" + serialized.name;
    if (// class name could be used further down
    // the tree but if it's a string tag, we know it won't
    // so we don't have to add it to registered cache.
    // this improves memory usage since we can avoid storing the whole style string
    (isStringTag === false || // we need to always store it if we're in compat mode and
    // in node since emotion-server relies on whether a style is in
    // the registered cache to know whether a style is global or not
    // also, note that this check will be dead code eliminated in the browser
    $d123aa206da6f3da$var$isBrowser === false) && cache.registered[className] === undefined) cache.registered[className] = serialized.styles;
};
var $d123aa206da6f3da$export$6f077d94b33a01aa = function insertStyles(cache, serialized, isStringTag) {
    $d123aa206da6f3da$export$580009a5da2a8b4b(cache, serialized, isStringTag);
    var className = cache.key + "-" + serialized.name;
    if (cache.inserted[serialized.name] === undefined) {
        var current = serialized;
        do {
            cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);
            current = current.next;
        }while (current !== undefined);
    }
};


/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function $0eca61e9ec9ac574$export$2e2bcd8739ae039(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}


var $7d6106d35293dee3$export$2e2bcd8739ae039 = {
    animationIterationCount: 1,
    aspectRatio: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};



var $930631f5ca46f34c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $930631f5ca46f34c$var$UNDEFINED_AS_OBJECT_KEY_ERROR = "You have passed in falsy value as style object's key (can happen when in example you pass unexported component as computed key).";
var $930631f5ca46f34c$var$hyphenateRegex = /[A-Z]|^ms/g;
var $930631f5ca46f34c$var$animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;
var $930631f5ca46f34c$var$isCustomProperty = function isCustomProperty(property) {
    return property.charCodeAt(1) === 45;
};
var $930631f5ca46f34c$var$isProcessableValue = function isProcessableValue(value) {
    return value != null && typeof value !== 'boolean';
};
var $930631f5ca46f34c$var$processStyleName = /* #__PURE__ */ (0, $5c4b43fa4ca9ca56$export$2e2bcd8739ae039)(function(styleName) {
    return $930631f5ca46f34c$var$isCustomProperty(styleName) ? styleName : styleName.replace($930631f5ca46f34c$var$hyphenateRegex, '-$&').toLowerCase();
});
var $930631f5ca46f34c$var$processStyleValue = function processStyleValue(key, value) {
    switch(key){
        case 'animation':
        case 'animationName':
            if (typeof value === 'string') return value.replace($930631f5ca46f34c$var$animationRegex, function(match, p1, p2) {
                $930631f5ca46f34c$var$cursor = {
                    name: p1,
                    styles: p2,
                    next: $930631f5ca46f34c$var$cursor
                };
                return p1;
            });
    }
    if ((0, $7d6106d35293dee3$export$2e2bcd8739ae039)[key] !== 1 && !$930631f5ca46f34c$var$isCustomProperty(key) && typeof value === 'number' && value !== 0) return value + 'px';
    return value;
};
var $930631f5ca46f34c$var$contentValuePattern, $930631f5ca46f34c$var$contentValues, $930631f5ca46f34c$var$oldProcessStyleValue, $930631f5ca46f34c$var$msPattern, $930631f5ca46f34c$var$hyphenPattern, $930631f5ca46f34c$var$hyphenatedCache;
var $930631f5ca46f34c$var$noComponentSelectorMessage = "Component selectors can only be used in conjunction with @emotion/babel-plugin, the swc Emotion plugin, or another Emotion-aware compiler transform.";
function $930631f5ca46f34c$var$handleInterpolation(mergedProps, registered, interpolation) {
    if (interpolation == null) return '';
    if (interpolation.__emotion_styles !== undefined) return interpolation;
    switch(typeof interpolation){
        case 'boolean':
            return '';
        case 'object':
            if (interpolation.anim === 1) {
                $930631f5ca46f34c$var$cursor = {
                    name: interpolation.name,
                    styles: interpolation.styles,
                    next: $930631f5ca46f34c$var$cursor
                };
                return interpolation.name;
            }
            if (interpolation.styles !== undefined) {
                var next = interpolation.next;
                if (next !== undefined) // not the most efficient thing ever but this is a pretty rare case
                // and there will be very few iterations of this generally
                while(next !== undefined){
                    $930631f5ca46f34c$var$cursor = {
                        name: next.name,
                        styles: next.styles,
                        next: $930631f5ca46f34c$var$cursor
                    };
                    next = next.next;
                }
                var styles = interpolation.styles + ";";
                return styles;
            }
            return $930631f5ca46f34c$var$createStringFromObject(mergedProps, registered, interpolation);
        case 'function':
            if (mergedProps !== undefined) {
                var previousCursor = $930631f5ca46f34c$var$cursor;
                var result = interpolation(mergedProps);
                $930631f5ca46f34c$var$cursor = previousCursor;
                return $930631f5ca46f34c$var$handleInterpolation(mergedProps, registered, result);
            }
            break;
        case 'string':
            var matched, replaced;
            break;
    } // finalize string values (regular strings and functions interpolated into css calls)
    if (registered == null) return interpolation;
    var cached = registered[interpolation];
    return cached !== undefined ? cached : interpolation;
}
function $930631f5ca46f34c$var$createStringFromObject(mergedProps, registered, obj) {
    var string = '';
    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)string += $930631f5ca46f34c$var$handleInterpolation(mergedProps, registered, obj[i]) + ";";
    else for(var _key in obj){
        var value = obj[_key];
        if (typeof value !== 'object') {
            if (registered != null && registered[value] !== undefined) string += _key + "{" + registered[value] + "}";
            else if ($930631f5ca46f34c$var$isProcessableValue(value)) string += $930631f5ca46f34c$var$processStyleName(_key) + ":" + $930631f5ca46f34c$var$processStyleValue(_key, value) + ";";
        } else {
            _key;
            if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
                for(var _i = 0; _i < value.length; _i++)if ($930631f5ca46f34c$var$isProcessableValue(value[_i])) string += $930631f5ca46f34c$var$processStyleName(_key) + ":" + $930631f5ca46f34c$var$processStyleValue(_key, value[_i]) + ";";
            } else {
                var interpolated = $930631f5ca46f34c$var$handleInterpolation(mergedProps, registered, value);
                switch(_key){
                    case 'animation':
                    case 'animationName':
                        string += $930631f5ca46f34c$var$processStyleName(_key) + ":" + interpolated + ";";
                        break;
                    default:
                        string += _key + "{" + interpolated + "}";
                }
            }
        }
    }
    return string;
}
var $930631f5ca46f34c$var$labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
var $930631f5ca46f34c$var$sourceMapPattern;
// keyframes are stored on the SerializedStyles object as a linked list
var $930631f5ca46f34c$var$cursor;
var $930631f5ca46f34c$export$6321afa313b251b5 = function serializeStyles(args, registered, mergedProps) {
    if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) return args[0];
    var stringMode = true;
    var styles = '';
    $930631f5ca46f34c$var$cursor = undefined;
    var strings = args[0];
    if (strings == null || strings.raw === undefined) {
        stringMode = false;
        styles += $930631f5ca46f34c$var$handleInterpolation(mergedProps, registered, strings);
    } else styles += strings[0];
     // we start at 1 since we've already handled the first arg
    for(var i = 1; i < args.length; i++){
        styles += $930631f5ca46f34c$var$handleInterpolation(mergedProps, registered, args[i]);
        if (stringMode) styles += strings[i];
    }
    var sourceMap;
    $930631f5ca46f34c$var$labelPattern.lastIndex = 0;
    var identifierName = '';
    var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5
    while((match = $930631f5ca46f34c$var$labelPattern.exec(styles)) !== null)identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
    var name = (0, $0eca61e9ec9ac574$export$2e2bcd8739ae039)(styles) + identifierName;
    return {
        name: name,
        styles: styles,
        next: $930631f5ca46f34c$var$cursor
    };
};



var $5FkrB = parcelRequire("5FkrB");
var $38d12fd915127030$var$syncFallback = function syncFallback(create) {
    return create();
};
var $38d12fd915127030$var$useInsertionEffect = $5FkrB.useInsertionEffect ? $5FkrB.useInsertionEffect : false;
var $38d12fd915127030$export$db21c7ffa21794e7 = $38d12fd915127030$var$useInsertionEffect || $38d12fd915127030$var$syncFallback;
var $38d12fd915127030$export$811a713a7276cb9d = $38d12fd915127030$var$useInsertionEffect || $5FkrB.useLayoutEffect;


var $66527bcb8c2a609a$export$23f2a1d2818174ef = true;
var $66527bcb8c2a609a$export$dda1d9f60106f0e9 = {}.hasOwnProperty;
var $66527bcb8c2a609a$var$EmotionCacheContext = /* #__PURE__ */ $5FkrB.createContext(// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */ (0, $2af2a3b133a3d08e$export$2e2bcd8739ae039)({
    key: 'css'
}) : null);
var $66527bcb8c2a609a$export$e7094788287c5e9b = $66527bcb8c2a609a$var$EmotionCacheContext.Provider;
var $66527bcb8c2a609a$export$71511d61b312f219 = function useEmotionCache() {
    return (0, $5FkrB.useContext)($66527bcb8c2a609a$var$EmotionCacheContext);
};
var $66527bcb8c2a609a$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    // $FlowFixMe
    return /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
        // the cache will never be null in the browser
        var cache = (0, $5FkrB.useContext)($66527bcb8c2a609a$var$EmotionCacheContext);
        return func(props, cache, ref);
    });
};
if (!$66527bcb8c2a609a$export$23f2a1d2818174ef) $66527bcb8c2a609a$export$efccba1c4a2ef57b = function withEmotionCache(func) {
    return function(props) {
        var cache = (0, $5FkrB.useContext)($66527bcb8c2a609a$var$EmotionCacheContext);
        if (cache === null) {
            // yes, we're potentially creating this on every render
            // it doesn't actually matter though since it's only on the server
            // so there will only every be a single render
            // that could change in the future because of suspense and etc. but for now,
            // this works and i don't want to optimise for a future thing that we aren't sure about
            cache = (0, $2af2a3b133a3d08e$export$2e2bcd8739ae039)({
                key: 'css'
            });
            return /*#__PURE__*/ $5FkrB.createElement($66527bcb8c2a609a$var$EmotionCacheContext.Provider, {
                value: cache
            }, func(props, cache));
        } else return func(props, cache);
    };
};
var $66527bcb8c2a609a$export$971d5caa766a69d7 = /* #__PURE__ */ $5FkrB.createContext({});
var $66527bcb8c2a609a$export$3b14a55fb2447963 = function useTheme() {
    return $5FkrB.useContext($66527bcb8c2a609a$export$971d5caa766a69d7);
};
var $66527bcb8c2a609a$var$getTheme = function getTheme(outerTheme, theme) {
    if (typeof theme === 'function') {
        var mergedTheme = theme(outerTheme);
        return mergedTheme;
    }
    return (0, $97bc1202558212af$export$2e2bcd8739ae039)({}, outerTheme, theme);
};
var $66527bcb8c2a609a$var$createCacheWithTheme = /* #__PURE__ */ (0, $1590e71a06f1c94c$export$2e2bcd8739ae039)(function(outerTheme) {
    return (0, $1590e71a06f1c94c$export$2e2bcd8739ae039)(function(theme) {
        return $66527bcb8c2a609a$var$getTheme(outerTheme, theme);
    });
});
var $66527bcb8c2a609a$export$407448d2b89b1813 = function ThemeProvider(props) {
    var theme = $5FkrB.useContext($66527bcb8c2a609a$export$971d5caa766a69d7);
    if (props.theme !== theme) theme = $66527bcb8c2a609a$var$createCacheWithTheme(theme)(props.theme);
    return /*#__PURE__*/ $5FkrB.createElement($66527bcb8c2a609a$export$971d5caa766a69d7.Provider, {
        value: theme
    }, props.children);
};
function $66527bcb8c2a609a$export$8b22cf2602fb60ce(Component) {
    var componentName = Component.displayName || Component.name || 'Component';
    var render = function render(props, ref) {
        var theme = $5FkrB.useContext($66527bcb8c2a609a$export$971d5caa766a69d7);
        return /*#__PURE__*/ $5FkrB.createElement(Component, (0, $97bc1202558212af$export$2e2bcd8739ae039)({
            theme: theme,
            ref: ref
        }, props));
    }; // $FlowFixMe
    var WithTheme = /*#__PURE__*/ $5FkrB.forwardRef(render);
    WithTheme.displayName = "WithTheme(" + componentName + ")";
    return (0, $4b415f6a5b424019$export$2e2bcd8739ae039)(WithTheme, Component);
}
var $66527bcb8c2a609a$var$getLastPart = function getLastPart(functionName) {
    // The match may be something like 'Object.createEmotionProps' or
    // 'Loader.prototype.render'
    var parts = functionName.split('.');
    return parts[parts.length - 1];
};
var $66527bcb8c2a609a$var$getFunctionNameFromStackTraceLine = function getFunctionNameFromStackTraceLine(line) {
    // V8
    var match = /^\s+at\s+([A-Za-z0-9$.]+)\s/.exec(line);
    if (match) return $66527bcb8c2a609a$var$getLastPart(match[1]); // Safari / Firefox
    match = /^([A-Za-z0-9$.]+)@/.exec(line);
    if (match) return $66527bcb8c2a609a$var$getLastPart(match[1]);
    return undefined;
};
var $66527bcb8c2a609a$var$internalReactFunctionNames = /* #__PURE__ */ new Set([
    'renderWithHooks',
    'processChild',
    'finishClassComponent',
    'renderToString'
]); // These identifiers come from error stacks, so they have to be valid JS
// identifiers, thus we only need to replace what is a valid character for JS,
// but not for CSS.
var $66527bcb8c2a609a$var$sanitizeIdentifier = function sanitizeIdentifier(identifier) {
    return identifier.replace(/\$/g, '-');
};
var $66527bcb8c2a609a$var$getLabelFromStackTrace = function getLabelFromStackTrace(stackTrace) {
    if (!stackTrace) return undefined;
    var lines = stackTrace.split('\n');
    for(var i = 0; i < lines.length; i++){
        var functionName = $66527bcb8c2a609a$var$getFunctionNameFromStackTraceLine(lines[i]); // The first line of V8 stack traces is just "Error"
        if (!functionName) continue; // If we reach one of these, we have gone too far and should quit
        if ($66527bcb8c2a609a$var$internalReactFunctionNames.has(functionName)) break; // The component name is the first function in the stack that starts with an
        // uppercase letter
        if (/^[A-Z]/.test(functionName)) return $66527bcb8c2a609a$var$sanitizeIdentifier(functionName);
    }
    return undefined;
};
var $66527bcb8c2a609a$var$typePropName = '__EMOTION_TYPE_PLEASE_DO_NOT_USE__';
var $66527bcb8c2a609a$var$labelPropName = '__EMOTION_LABEL_PLEASE_DO_NOT_USE__';
var $66527bcb8c2a609a$export$db3b6bfb95261072 = function createEmotionProps(type, props) {
    var newProps = {};
    for(var key in props)if ($66527bcb8c2a609a$export$dda1d9f60106f0e9.call(props, key)) newProps[key] = props[key];
    newProps[$66527bcb8c2a609a$var$typePropName] = type; // For performance, only call getLabelFromStackTrace in development and when
    var label;
    return newProps;
};
var $66527bcb8c2a609a$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serialized = _ref.serialized, isStringTag = _ref.isStringTag;
    (0, $d123aa206da6f3da$export$580009a5da2a8b4b)(cache, serialized, isStringTag);
    (0, $38d12fd915127030$export$db21c7ffa21794e7)(function() {
        return (0, $d123aa206da6f3da$export$6f077d94b33a01aa)(cache, serialized, isStringTag);
    });
    return null;
};
var $66527bcb8c2a609a$var$Emotion = /* #__PURE__ */ $66527bcb8c2a609a$export$efccba1c4a2ef57b(function(props, cache, ref) {
    var cssProp = props.css; // so that using `css` from `emotion` and passing the result to the css prop works
    // not passing the registered cache to serializeStyles because it would
    // make certain babel optimisations not possible
    if (typeof cssProp === 'string' && cache.registered[cssProp] !== undefined) cssProp = cache.registered[cssProp];
    var WrappedComponent = props[$66527bcb8c2a609a$var$typePropName];
    var registeredStyles = [
        cssProp
    ];
    var className = '';
    if (typeof props.className === 'string') className = (0, $d123aa206da6f3da$export$95d99596f328fd52)(cache.registered, registeredStyles, props.className);
    else if (props.className != null) className = props.className + " ";
    var serialized = (0, $930631f5ca46f34c$export$6321afa313b251b5)(registeredStyles, undefined, $5FkrB.useContext($66527bcb8c2a609a$export$971d5caa766a69d7));
    var labelFromStack;
    className += cache.key + "-" + serialized.name;
    var newProps = {};
    for(var key in props)if ($66527bcb8c2a609a$export$dda1d9f60106f0e9.call(props, key) && key !== 'css' && key !== $66527bcb8c2a609a$var$typePropName && true) newProps[key] = props[key];
    newProps.ref = ref;
    newProps.className = className;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($66527bcb8c2a609a$var$Insertion, {
        cache: cache,
        serialized: serialized,
        isStringTag: typeof WrappedComponent === 'string'
    }), /*#__PURE__*/ $5FkrB.createElement(WrappedComponent, newProps));
});
var $66527bcb8c2a609a$export$a9c23c6ac3fc3eca = $66527bcb8c2a609a$var$Emotion;



var $5FkrB = parcelRequire("5FkrB");








var $1bbaca91e5cf6bc9$var$pkg = {
    name: "@emotion/react",
    version: "11.11.3",
    main: "dist/emotion-react.cjs.js",
    module: "dist/emotion-react.esm.js",
    browser: {
        "./dist/emotion-react.esm.js": "./dist/emotion-react.browser.esm.js"
    },
    exports: {
        ".": {
            module: {
                worker: "./dist/emotion-react.worker.esm.js",
                browser: "./dist/emotion-react.browser.esm.js",
                "default": "./dist/emotion-react.esm.js"
            },
            "import": "./dist/emotion-react.cjs.mjs",
            "default": "./dist/emotion-react.cjs.js"
        },
        "./jsx-runtime": {
            module: {
                worker: "./jsx-runtime/dist/emotion-react-jsx-runtime.worker.esm.js",
                browser: "./jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js",
                "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.esm.js"
            },
            "import": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.mjs",
            "default": "./jsx-runtime/dist/emotion-react-jsx-runtime.cjs.js"
        },
        "./_isolated-hnrs": {
            module: {
                worker: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.worker.esm.js",
                browser: "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.browser.esm.js",
                "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.esm.js"
            },
            "import": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.mjs",
            "default": "./_isolated-hnrs/dist/emotion-react-_isolated-hnrs.cjs.js"
        },
        "./jsx-dev-runtime": {
            module: {
                worker: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.worker.esm.js",
                browser: "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.browser.esm.js",
                "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.esm.js"
            },
            "import": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.mjs",
            "default": "./jsx-dev-runtime/dist/emotion-react-jsx-dev-runtime.cjs.js"
        },
        "./package.json": "./package.json",
        "./types/css-prop": "./types/css-prop.d.ts",
        "./macro": {
            types: {
                "import": "./macro.d.mts",
                "default": "./macro.d.ts"
            },
            "default": "./macro.js"
        }
    },
    types: "types/index.d.ts",
    files: [
        "src",
        "dist",
        "jsx-runtime",
        "jsx-dev-runtime",
        "_isolated-hnrs",
        "types/*.d.ts",
        "macro.*"
    ],
    sideEffects: false,
    author: "Emotion Contributors",
    license: "MIT",
    scripts: {
        "test:typescript": "dtslint types"
    },
    dependencies: {
        "@babel/runtime": "^7.18.3",
        "@emotion/babel-plugin": "^11.11.0",
        "@emotion/cache": "^11.11.0",
        "@emotion/serialize": "^1.1.3",
        "@emotion/use-insertion-effect-with-fallbacks": "^1.0.1",
        "@emotion/utils": "^1.2.1",
        "@emotion/weak-memoize": "^0.3.1",
        "hoist-non-react-statics": "^3.3.1"
    },
    peerDependencies: {
        react: ">=16.8.0"
    },
    peerDependenciesMeta: {
        "@types/react": {
            optional: true
        }
    },
    devDependencies: {
        "@definitelytyped/dtslint": "0.0.112",
        "@emotion/css": "11.11.2",
        "@emotion/css-prettifier": "1.1.3",
        "@emotion/server": "11.11.0",
        "@emotion/styled": "11.11.0",
        "html-tag-names": "^1.1.2",
        react: "16.14.0",
        "svg-tag-names": "^1.1.1",
        typescript: "^4.5.5"
    },
    repository: "https://github.com/emotion-js/emotion/tree/main/packages/react",
    publishConfig: {
        access: "public"
    },
    "umd:main": "dist/emotion-react.umd.min.js",
    preconstruct: {
        entrypoints: [
            "./index.js",
            "./jsx-runtime.js",
            "./jsx-dev-runtime.js",
            "./_isolated-hnrs.js"
        ],
        umdName: "emotionReact",
        exports: {
            envConditions: [
                "browser",
                "worker"
            ],
            extra: {
                "./types/css-prop": "./types/css-prop.d.ts",
                "./macro": {
                    types: {
                        "import": "./macro.d.mts",
                        "default": "./macro.d.ts"
                    },
                    "default": "./macro.js"
                }
            }
        }
    }
};
var $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d = function jsx(type, props) {
    var args = arguments;
    if (props == null || !(0, $66527bcb8c2a609a$export$dda1d9f60106f0e9).call(props, 'css')) // $FlowFixMe
    return $5FkrB.createElement.apply(undefined, args);
    var argsLength = args.length;
    var createElementArgArray = new Array(argsLength);
    createElementArgArray[0] = (0, $66527bcb8c2a609a$export$a9c23c6ac3fc3eca);
    createElementArgArray[1] = (0, $66527bcb8c2a609a$export$db3b6bfb95261072)(type, props);
    for(var i = 2; i < argsLength; i++)createElementArgArray[i] = args[i];
     // $FlowFixMe
    return $5FkrB.createElement.apply(null, createElementArgArray);
};
var $1bbaca91e5cf6bc9$var$warnedAboutCssPropForGlobal = false; // maintain place over rerenders.
// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag
var $1bbaca91e5cf6bc9$export$98f03c5d19621d70 = /* #__PURE__ */ (0, $66527bcb8c2a609a$export$efccba1c4a2ef57b)(function(props, cache) {
    var styles = props.styles;
    var serialized = (0, $930631f5ca46f34c$export$6321afa313b251b5)([
        styles
    ], undefined, $5FkrB.useContext((0, $66527bcb8c2a609a$export$971d5caa766a69d7)));
    if (!(0, $66527bcb8c2a609a$export$23f2a1d2818174ef)) {
        var _ref;
        var serializedNames = serialized.name;
        var serializedStyles = serialized.styles;
        var next = serialized.next;
        while(next !== undefined){
            serializedNames += ' ' + next.name;
            serializedStyles += next.styles;
            next = next.next;
        }
        var shouldCache = cache.compat === true;
        var rules = cache.insert("", {
            name: serializedNames,
            styles: serializedStyles
        }, cache.sheet, shouldCache);
        if (shouldCache) return null;
        return /*#__PURE__*/ $5FkrB.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
            __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref));
    } // yes, i know these hooks are used conditionally
    // but it is based on a constant that will never change at runtime
    // it's effectively like having two implementations and switching them out
    // so it's not actually breaking anything
    var sheetRef = $5FkrB.useRef();
    (0, $38d12fd915127030$export$811a713a7276cb9d)(function() {
        var key = cache.key + "-global"; // use case of https://github.com/emotion-js/emotion/issues/2675
        var sheet = new cache.sheet.constructor({
            key: key,
            nonce: cache.sheet.nonce,
            container: cache.sheet.container,
            speedy: cache.sheet.isSpeedy
        });
        var rehydrating = false; // $FlowFixMe
        var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");
        if (cache.sheet.tags.length) sheet.before = cache.sheet.tags[0];
        if (node !== null) {
            rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s
            node.setAttribute('data-emotion', key);
            sheet.hydrate([
                node
            ]);
        }
        sheetRef.current = [
            sheet,
            rehydrating
        ];
        return function() {
            sheet.flush();
        };
    }, [
        cache
    ]);
    (0, $38d12fd915127030$export$811a713a7276cb9d)(function() {
        var sheetRefCurrent = sheetRef.current;
        var sheet = sheetRefCurrent[0], rehydrating = sheetRefCurrent[1];
        if (rehydrating) {
            sheetRefCurrent[1] = false;
            return;
        }
        if (serialized.next !== undefined) // insert keyframes
        (0, $d123aa206da6f3da$export$6f077d94b33a01aa)(cache, serialized.next, true);
        if (sheet.tags.length) {
            // if this doesn't exist then it will be null so the style element will be appended
            var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
            sheet.before = element;
            sheet.flush();
        }
        cache.insert("", serialized, sheet, false);
    }, [
        cache,
        serialized.name
    ]);
    return null;
});
function $1bbaca91e5cf6bc9$export$dbf350e5966cf602() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return (0, $930631f5ca46f34c$export$6321afa313b251b5)(args);
}
var $1bbaca91e5cf6bc9$export$d25ddfdf17c3ad3e = function keyframes() {
    var insertable = $1bbaca91e5cf6bc9$export$dbf350e5966cf602.apply(void 0, arguments);
    var name = "animation-" + insertable.name; // $FlowFixMe
    return {
        name: name,
        styles: "@keyframes " + name + "{" + insertable.styles + "}",
        anim: 1,
        toString: function toString() {
            return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
        }
    };
};
var $1bbaca91e5cf6bc9$var$classnames = function classnames(args) {
    var len = args.length;
    var i = 0;
    var cls = '';
    for(; i < len; i++){
        var arg = args[i];
        if (arg == null) continue;
        var toAdd = void 0;
        switch(typeof arg){
            case 'boolean':
                break;
            case 'object':
                if (Array.isArray(arg)) toAdd = classnames(arg);
                else {
                    toAdd = '';
                    for(var k in arg)if (arg[k] && k) {
                        toAdd && (toAdd += ' ');
                        toAdd += k;
                    }
                }
                break;
            default:
                toAdd = arg;
        }
        if (toAdd) {
            cls && (cls += ' ');
            cls += toAdd;
        }
    }
    return cls;
};
function $1bbaca91e5cf6bc9$var$merge(registered, css, className) {
    var registeredStyles = [];
    var rawClassName = (0, $d123aa206da6f3da$export$95d99596f328fd52)(registered, registeredStyles, className);
    if (registeredStyles.length < 2) return className;
    return rawClassName + css(registeredStyles);
}
var $1bbaca91e5cf6bc9$var$Insertion = function Insertion(_ref) {
    var cache = _ref.cache, serializedArr = _ref.serializedArr;
    (0, $38d12fd915127030$export$db21c7ffa21794e7)(function() {
        for(var i = 0; i < serializedArr.length; i++)(0, $d123aa206da6f3da$export$6f077d94b33a01aa)(cache, serializedArr[i], false);
    });
    return null;
};
var $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8 = /* #__PURE__ */ (0, $66527bcb8c2a609a$export$efccba1c4a2ef57b)(function(props, cache) {
    var hasRendered = false;
    var serializedArr = [];
    var css = function css() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var serialized = (0, $930631f5ca46f34c$export$6321afa313b251b5)(args, cache.registered);
        serializedArr.push(serialized); // registration has to happen here as the result of this might get consumed by `cx`
        (0, $d123aa206da6f3da$export$580009a5da2a8b4b)(cache, serialized, false);
        return cache.key + "-" + serialized.name;
    };
    var cx = function cx() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        return $1bbaca91e5cf6bc9$var$merge(cache.registered, css, $1bbaca91e5cf6bc9$var$classnames(args));
    };
    var content = {
        css: css,
        cx: cx,
        theme: $5FkrB.useContext((0, $66527bcb8c2a609a$export$971d5caa766a69d7))
    };
    var ele = props.children(content);
    hasRendered = true;
    return /*#__PURE__*/ $5FkrB.createElement($5FkrB.Fragment, null, /*#__PURE__*/ $5FkrB.createElement($1bbaca91e5cf6bc9$var$Insertion, {
        cache: cache,
        serializedArr: serializedArr
    }), ele);
});
var $1bbaca91e5cf6bc9$var$isBrowser, $1bbaca91e5cf6bc9$var$isTestEnv, $1bbaca91e5cf6bc9$var$globalContext, $1bbaca91e5cf6bc9$var$globalKey;



var $1664a63d282a7249$exports = {};

function $1664a63d282a7249$var$_objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = $0d5e64210d12b637$exports(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
$1664a63d282a7249$exports = $1664a63d282a7249$var$_objectWithoutProperties, $1664a63d282a7249$exports.__esModule = true, $1664a63d282a7249$exports["default"] = $1664a63d282a7249$exports;



var $5FkrB = parcelRequire("5FkrB");



var $6fbf1a0fc3bf0ef0$export$4ef52930e33717cd = 'data-theme';
var $6fbf1a0fc3bf0ef0$export$a00eac3f8684bcd0 = 'data-color-mode';
var $6fbf1a0fc3bf0ef0$export$2112803007239c61 = 'data-contrast-mode';
var $6fbf1a0fc3bf0ef0$export$352e418ed5b6193a = 'data-custom-theme';
var $6fbf1a0fc3bf0ef0$export$2faeed762aac6741 = 'light';
var $6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92 = 'ds';
var $6fbf1a0fc3bf0ef0$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
var $6fbf1a0fc3bf0ef0$export$dddac1532e822863 = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-token-not-found");
var $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa = "--".concat($6fbf1a0fc3bf0ef0$export$6f0c6fb8c80fcc92, "-elevation-surface-current");


function $378c4d85499699db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $378c4d85499699db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $378c4d85499699db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $378c4d85499699db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $378c4d85499699db$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $378c4d85499699db$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $378c4d85499699db$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $378c4d85499699db$export$632685d741f3dbbf = $378c4d85499699db$var$_objectSpread($378c4d85499699db$var$_objectSpread({}, $378c4d85499699db$export$958d0ae7f2977ae4), $378c4d85499699db$export$d2dc61f58390201c);
var $378c4d85499699db$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $378c4d85499699db$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $378c4d85499699db$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $378c4d85499699db$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $378c4d85499699db$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $378c4d85499699db$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $378c4d85499699db$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
var $378c4d85499699db$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $378c4d85499699db$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $378c4d85499699db$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $378c4d85499699db$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $378c4d85499699db$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $378c4d85499699db$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $378c4d85499699db$export$3c7e9587132614b4 = {
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $378c4d85499699db$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $378c4d85499699db$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $378c4d85499699db$export$e615f061ca585a6c = $378c4d85499699db$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $378c4d85499699db$var$getSerializedStylesMap(spacingProperty, $378c4d85499699db$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $378c4d85499699db$export$bf46c3f9eeafc71f = $378c4d85499699db$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $378c4d85499699db$var$getSerializedStylesMap(spacingProperty, $378c4d85499699db$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $378c4d85499699db$export$e7af83bafe7f9e63 = $378c4d85499699db$var$getSerializedStylesMap('backgroundColor', $378c4d85499699db$export$d1d79bf68ac056bd);
var $378c4d85499699db$export$3a1bcba60b23d7f0 = $378c4d85499699db$var$getSerializedStylesMap('color', $378c4d85499699db$export$8473307aa00d6ea1);
var $378c4d85499699db$export$45f3f4fe16f9f7d5 = $378c4d85499699db$var$getSerializedStylesMap('fontWeight', $378c4d85499699db$export$303e322c6b1ed114);
var $378c4d85499699db$export$68cc305da27dbaa4 = $378c4d85499699db$var$getSerializedStylesMap('fontFamily', $378c4d85499699db$export$3c7e9587132614b4);
var $378c4d85499699db$export$128f10c238242f83 = $378c4d85499699db$var$getSerializedStylesMap('font', $378c4d85499699db$export$6cc560b4dedf3816);
var $378c4d85499699db$export$ff257d957d48c421 = $378c4d85499699db$var$getSerializedStylesMap((0, $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa), $378c4d85499699db$export$41a358c9c2356760);
var $378c4d85499699db$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $378c4d85499699db$export$41a358c9c2356760[color] !== undefined;
};


var $b5e0d6462918fd61$exports = {};
var $5d43a7b0c15e0a9e$exports = {};
var $59169e612a7ccfc3$exports = {};
function $59169e612a7ccfc3$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
$59169e612a7ccfc3$exports = $59169e612a7ccfc3$var$_arrayLikeToArray, $59169e612a7ccfc3$exports.__esModule = true, $59169e612a7ccfc3$exports["default"] = $59169e612a7ccfc3$exports;


function $5d43a7b0c15e0a9e$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $59169e612a7ccfc3$exports(r);
}
$5d43a7b0c15e0a9e$exports = $5d43a7b0c15e0a9e$var$_arrayWithoutHoles, $5d43a7b0c15e0a9e$exports.__esModule = true, $5d43a7b0c15e0a9e$exports["default"] = $5d43a7b0c15e0a9e$exports;


var $226d70a7652df90f$exports = {};
function $226d70a7652df90f$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
$226d70a7652df90f$exports = $226d70a7652df90f$var$_iterableToArray, $226d70a7652df90f$exports.__esModule = true, $226d70a7652df90f$exports["default"] = $226d70a7652df90f$exports;


var $8e0efdd2cb2ea886$exports = {};

function $8e0efdd2cb2ea886$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $59169e612a7ccfc3$exports(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $59169e612a7ccfc3$exports(r, a) : void 0;
    }
}
$8e0efdd2cb2ea886$exports = $8e0efdd2cb2ea886$var$_unsupportedIterableToArray, $8e0efdd2cb2ea886$exports.__esModule = true, $8e0efdd2cb2ea886$exports["default"] = $8e0efdd2cb2ea886$exports;


var $a79aacb7570835cb$exports = {};
function $a79aacb7570835cb$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$a79aacb7570835cb$exports = $a79aacb7570835cb$var$_nonIterableSpread, $a79aacb7570835cb$exports.__esModule = true, $a79aacb7570835cb$exports["default"] = $a79aacb7570835cb$exports;


function $b5e0d6462918fd61$var$_toConsumableArray(r) {
    return $5d43a7b0c15e0a9e$exports(r) || $226d70a7652df90f$exports(r) || $8e0efdd2cb2ea886$exports(r) || $a79aacb7570835cb$exports();
}
$b5e0d6462918fd61$exports = $b5e0d6462918fd61$var$_toConsumableArray, $b5e0d6462918fd61$exports.__esModule = true, $b5e0d6462918fd61$exports["default"] = $b5e0d6462918fd61$exports;



var $dd10e4fe59ebf2c1$exports = {};
var $33cb35214efb072a$exports = {};
function $33cb35214efb072a$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
$33cb35214efb072a$exports = $33cb35214efb072a$var$_arrayWithHoles, $33cb35214efb072a$exports.__esModule = true, $33cb35214efb072a$exports["default"] = $33cb35214efb072a$exports;


var $1718055c8ee40965$exports = {};
function $1718055c8ee40965$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
$1718055c8ee40965$exports = $1718055c8ee40965$var$_iterableToArrayLimit, $1718055c8ee40965$exports.__esModule = true, $1718055c8ee40965$exports["default"] = $1718055c8ee40965$exports;



var $fb4d51eeedba6c65$exports = {};
function $fb4d51eeedba6c65$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
$fb4d51eeedba6c65$exports = $fb4d51eeedba6c65$var$_nonIterableRest, $fb4d51eeedba6c65$exports.__esModule = true, $fb4d51eeedba6c65$exports["default"] = $fb4d51eeedba6c65$exports;


function $dd10e4fe59ebf2c1$var$_slicedToArray(r, e) {
    return $33cb35214efb072a$exports(r) || $1718055c8ee40965$exports(r, e) || $8e0efdd2cb2ea886$exports(r, e) || $fb4d51eeedba6c65$exports();
}
$dd10e4fe59ebf2c1$exports = $dd10e4fe59ebf2c1$var$_slicedToArray, $dd10e4fe59ebf2c1$exports.__esModule = true, $dd10e4fe59ebf2c1$exports["default"] = $dd10e4fe59ebf2c1$exports;






var $3ZMUU = parcelRequire("3ZMUU");
function $837291fbb45fe878$var$_createForOfIteratorHelper(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (!it) {
        if (Array.isArray(o) || (it = $837291fbb45fe878$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
            if (it) o = it;
            var i = 0;
            var F = function F() {};
            return {
                s: F,
                n: function n() {
                    if (i >= o.length) return {
                        done: true
                    };
                    return {
                        done: false,
                        value: o[i++]
                    };
                },
                e: function e(_e) {
                    throw _e;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var normalCompletion = true, didErr = false, err;
    return {
        s: function s() {
            it = it.call(o);
        },
        n: function n() {
            var step = it.next();
            normalCompletion = step.done;
            return step;
        },
        e: function e(_e2) {
            didErr = true;
            err = _e2;
        },
        f: function f() {
            try {
                if (!normalCompletion && it.return != null) it.return();
            } finally{
                if (didErr) throw err;
            }
        }
    };
}
function $837291fbb45fe878$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $837291fbb45fe878$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $837291fbb45fe878$var$_arrayLikeToArray(o, minLen);
}
function $837291fbb45fe878$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $837291fbb45fe878$export$9a199fbafee0014e = {
    backgroundColor: (0, $378c4d85499699db$export$d1d79bf68ac056bd),
    blockSize: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderBottomColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderLeftColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $378c4d85499699db$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    borderWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    bottom: (0, $378c4d85499699db$export$632685d741f3dbbf),
    boxShadow: (0, $378c4d85499699db$export$7aff6e7ba39bb774),
    color: (0, $378c4d85499699db$export$8473307aa00d6ea1),
    columnGap: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    gap: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    height: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    inlineSize: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    inset: (0, $378c4d85499699db$export$632685d741f3dbbf),
    insetBlock: (0, $378c4d85499699db$export$632685d741f3dbbf),
    insetBlockEnd: (0, $378c4d85499699db$export$632685d741f3dbbf),
    insetBlockStart: (0, $378c4d85499699db$export$632685d741f3dbbf),
    insetInline: (0, $378c4d85499699db$export$632685d741f3dbbf),
    insetInlineEnd: (0, $378c4d85499699db$export$632685d741f3dbbf),
    insetInlineStart: (0, $378c4d85499699db$export$632685d741f3dbbf),
    left: (0, $378c4d85499699db$export$632685d741f3dbbf),
    margin: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginBlock: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginBlockEnd: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginBlockStart: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginBottom: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginInline: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginInlineEnd: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginInlineStart: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginLeft: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginRight: (0, $378c4d85499699db$export$632685d741f3dbbf),
    marginTop: (0, $378c4d85499699db$export$632685d741f3dbbf),
    maxBlockSize: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    maxHeight: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    maxWidth: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    minBlockSize: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    minHeight: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    minInlineSize: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    minWidth: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    opacity: (0, $378c4d85499699db$export$daf94a976c798b4f),
    outlineColor: (0, $378c4d85499699db$export$1531ad5bb3fbedac),
    outlineOffset: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    outlineWidth: (0, $378c4d85499699db$export$e1b83c5210c471b8),
    padding: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingBlock: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingBottom: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingInline: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingLeft: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingRight: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    paddingTop: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    right: (0, $378c4d85499699db$export$632685d741f3dbbf),
    rowGap: (0, $378c4d85499699db$export$958d0ae7f2977ae4),
    top: (0, $378c4d85499699db$export$632685d741f3dbbf),
    width: (0, $378c4d85499699db$export$6ccdbebca2ee545f),
    zIndex: (0, $378c4d85499699db$export$b5f31a7e431d2eab)
};
var $837291fbb45fe878$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $837291fbb45fe878$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))($3ZMUU.env) === 'object' && false;
};
var $837291fbb45fe878$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $837291fbb45fe878$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $837291fbb45fe878$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))(value) === 'object' && $837291fbb45fe878$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($837291fbb45fe878$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($837291fbb45fe878$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $837291fbb45fe878$export$9a199fbafee0014e)) return;
        var tokenValue = $837291fbb45fe878$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $837291fbb45fe878$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $837291fbb45fe878$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, $837291fbb45fe878$var$uniqueSymbol, (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)(transformedStyles));
};
var $837291fbb45fe878$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) {
        var emotion = [];
        var staticArr = [];
        var _iterator = $837291fbb45fe878$var$_createForOfIteratorHelper(args), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var arg = _step.value;
                var result = parseXcss(arg);
                if (result.emotion) emotion.push.apply(emotion, (0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(result.emotion));
                if (result.static) staticArr.push(result.static);
            }
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    var objArgs = args;
    var _ref4 = objArgs || {}, styles = _ref4[$837291fbb45fe878$var$uniqueSymbol];
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        var stringifiedArgs = "".concat(args);
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $837291fbb45fe878$export$f6c783d06584602c(style) {
    return $837291fbb45fe878$var$baseXcss(style);
}



var $5FkrB = parcelRequire("5FkrB");
var $ba6c262da1fc21df$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $5FkrB.createContext)('elevation.surface');
var $ba6c262da1fc21df$export$1aeb4f6b93c4540d = function useSurface() {
    return (0, $5FkrB.useContext)($ba6c262da1fc21df$export$1ca2a26fecb070ae);
};
$ba6c262da1fc21df$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';


var $389592ecebf8a6ff$var$_excluded = [
    "as",
    "children",
    "backgroundColor",
    "padding",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "style",
    "testId",
    "xcss"
], $389592ecebf8a6ff$var$_excluded2 = [
    "className"
];
var $389592ecebf8a6ff$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, children = _ref.children, backgroundColor = _ref.backgroundColor, padding = _ref.padding, paddingBlock = _ref.paddingBlock, paddingBlockStart = _ref.paddingBlockStart, paddingBlockEnd = _ref.paddingBlockEnd, paddingInline = _ref.paddingInline, paddingInlineStart = _ref.paddingInlineStart, paddingInlineEnd = _ref.paddingInlineEnd, style = _ref.style, testId = _ref.testId, xcss = _ref.xcss, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(_ref, $389592ecebf8a6ff$var$_excluded);
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    var _spreadClass = htmlAttributes.className, safeHtmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(htmlAttributes, $389592ecebf8a6ff$var$_excluded2);
    var resolvedStyles = (0, $837291fbb45fe878$export$a9c84988c8f81f2d)(xcss);
    var node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $389592ecebf8a6ff$var$baseStyles,
            backgroundColor && (0, $378c4d85499699db$export$e7af83bafe7f9e63)[backgroundColor],
            (0, $378c4d85499699db$export$5e65a44e5b6ecadb)(backgroundColor) && (0, $378c4d85499699db$export$ff257d957d48c421)[backgroundColor],
            padding && (0, $378c4d85499699db$export$e615f061ca585a6c).padding[padding],
            paddingBlock && (0, $378c4d85499699db$export$e615f061ca585a6c).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $378c4d85499699db$export$e615f061ca585a6c).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $378c4d85499699db$export$e615f061ca585a6c).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $378c4d85499699db$export$e615f061ca585a6c).paddingInline[paddingInline],
            paddingInlineStart && (0, $378c4d85499699db$export$e615f061ca585a6c).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $378c4d85499699db$export$e615f061ca585a6c).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $ba6c262da1fc21df$export$1ca2a26fecb070ae).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $389592ecebf8a6ff$export$2e2bcd8739ae039 = $389592ecebf8a6ff$export$e71c4d32a2263218;
var $389592ecebf8a6ff$var$baseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});



var $5FkrB = parcelRequire("5FkrB");


/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");



var $8f5f7229c58c7ccd$var$justifyContentMap = {
    start: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'start'
    }),
    center: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'center'
    }),
    end: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'end'
    }),
    'space-between': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'stretch'
    })
};
var $8f5f7229c58c7ccd$var$flexDirectionMap = {
    column: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexDirection: 'column'
    }),
    row: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexDirection: 'row'
    })
};
var $8f5f7229c58c7ccd$var$flexWrapMap = {
    wrap: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexWrap: 'nowrap'
    })
};
var $8f5f7229c58c7ccd$var$alignItemsMap = {
    start: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'start'
    }),
    center: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'center'
    }),
    baseline: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'baseline'
    }),
    end: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'end'
    }),
    stretch: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'stretch'
    })
};
var $8f5f7229c58c7ccd$var$baseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $8f5f7229c58c7ccd$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var resolvedStyles = (0, $837291fbb45fe878$export$a9c84988c8f81f2d)(xcss);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Component, {
        role: role,
        className: resolvedStyles.static,
        css: [
            $8f5f7229c58c7ccd$var$baseStyles,
            gap && (0, $378c4d85499699db$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $378c4d85499699db$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $378c4d85499699db$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $8f5f7229c58c7ccd$var$alignItemsMap[alignItems],
            direction && $8f5f7229c58c7ccd$var$flexDirectionMap[direction],
            justifyContent && $8f5f7229c58c7ccd$var$justifyContentMap[justifyContent],
            wrap && $8f5f7229c58c7ccd$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$8f5f7229c58c7ccd$var$Flex.displayName = 'Flex';
var $8f5f7229c58c7ccd$export$2e2bcd8739ae039 = $8f5f7229c58c7ccd$var$Flex;


var $f6416c645ccb1742$var$flexGrowMap = {
    hug: (0, $837291fbb45fe878$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $837291fbb45fe878$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $f6416c645ccb1742$var$separatorStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $f6416c645ccb1742$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: $f6416c645ccb1742$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $f6416c645ccb1742$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)($f6416c645ccb1742$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    var styles = grow ? [
        $f6416c645ccb1742$var$flexGrowMap[grow]
    ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(Array.isArray(xcss) ? xcss : [
        xcss
    ])) : xcss;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $8f5f7229c58c7ccd$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$f6416c645ccb1742$var$Inline.displayName = 'Inline';
var $f6416c645ccb1742$export$2e2bcd8739ae039 = $f6416c645ccb1742$var$Inline;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ /* eslint-disable prefer-rest-params */ /* eslint-disable no-console */ var $f2f4a868e548940a$var$printed = {};
function $f2f4a868e548940a$export$2e2bcd8739ae039(message) {
    if ($f2f4a868e548940a$var$printed[message]) return;
    $f2f4a868e548940a$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}



var $3ZMUU = parcelRequire("3ZMUU");
function $ef3aa319a548c3c6$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $f2f4a868e548940a$export$2e2bcd8739ae039)("[".concat(packageName, "]: The ").concat(api, " is deprecated.").concat(additionalMessage && " ".concat(additionalMessage)));
}
function $ef3aa319a548c3c6$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $3ZMUU;
}



var $46bf0aae0dfb1de2$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
var $46bf0aae0dfb1de2$export$c93026a968943f95 = 'light';
var $46bf0aae0dfb1de2$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
var $46bf0aae0dfb1de2$export$7a57f79000377ca2 = function borderRadius() {
    return 3;
};
var $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8 = function gridSize() {
    return 8;
};
var $46bf0aae0dfb1de2$export$85e3c3ca0c6fb93 = function fontSize() {
    return 14;
};
var $46bf0aae0dfb1de2$export$6746fe0d9c9fab54 = function fontSizeSmall() {
    return 11;
};
var $46bf0aae0dfb1de2$export$a5975749f0374264 = function fontFamily() {
    return "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif";
};
var $46bf0aae0dfb1de2$export$356129969ee49c55 = function codeFontFamily() {
    return "'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace";
};
var $46bf0aae0dfb1de2$export$8e24544ddba725ee = function focusRing() {
    var color = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "var(--ds-border-focused, ".concat((0, $5738e2919e19457f$export$215b7063051591f1), ")");
    var outlineWidth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8() / 4;
    (0, $ef3aa319a548c3c6$export$2e2bcd8739ae039)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return "\n  &:focus {\n    outline: none;\n    box-shadow: 0px 0px 0px ".concat(outlineWidth, "px ").concat(color, ";\n  }\n");
};
var $46bf0aae0dfb1de2$export$c0dd343266bc3261 = function noFocusRing() {
    return "\n  box-shadow: none;\n";
};
var $46bf0aae0dfb1de2$export$7be255094ccdc533 = {
    card: function card() {
        return 100;
    },
    navigation: function navigation() {
        return 200;
    },
    dialog: function dialog() {
        return 300;
    },
    layer: function layer() {
        return 400;
    },
    blanket: function blanket() {
        return 500;
    },
    modal: function modal() {
        return 510;
    },
    flag: function flag() {
        return 600;
    },
    spotlight: function spotlight() {
        return 700;
    },
    tooltip: function tooltip() {
        return 9999;
    }
};
var $46bf0aae0dfb1de2$export$a1b3edb637fb4f35 = function visuallyHidden() {
    (0, $ef3aa319a548c3c6$export$2e2bcd8739ae039)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
var $46bf0aae0dfb1de2$export$ba1d834b86d72a09 = $46bf0aae0dfb1de2$export$a1b3edb637fb4f35;
var $46bf0aae0dfb1de2$export$e497e856b4f89fcd = function skeletonShimmer() {
    return {
        css: {
            backgroundColor: "var(--ds-skeleton, ".concat((0, $5738e2919e19457f$export$2a0674ff2eb10214)(), ")"),
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: "var(--ds-skeleton, ".concat((0, $5738e2919e19457f$export$2a0674ff2eb10214)(), ")")
            },
            to: {
                backgroundColor: "var(--ds-skeleton-subtle, ".concat((0, $5738e2919e19457f$export$920c0d5c49070351), ")")
            }
        }
    };
};


function $01155cd9f0909f58$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $46bf0aae0dfb1de2$export$44ffba16bd48dac6) in props.theme) return props.theme[0, $46bf0aae0dfb1de2$export$44ffba16bd48dac6];
        else if ('mode' in props.theme && (0, $46bf0aae0dfb1de2$export$6ba72c8346b4c57e).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $46bf0aae0dfb1de2$export$c93026a968943f95)
    };
}


// Unpack custom variants, and get correct value for the current theme
function $5e100033e0322651$var$themedVariants(variantProp, variants) {
    return function(props) {
        var theme = (0, $01155cd9f0909f58$export$2e2bcd8739ae039)(props);
        if (props && props[variantProp] && variants) {
            var modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                var value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $5e100033e0322651$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $5e100033e0322651$var$themedVariants(modesOrVariant, variantModes);
    var modes = modesOrVariant;
    return function(props) {
        // Get theme from the user's props
        var theme = (0, $01155cd9f0909f58$export$2e2bcd8739ae039)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            var value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}


var $5738e2919e19457f$export$4b84fd0e2c617bd = '#FFEBE6';
var $5738e2919e19457f$export$b34b069eff244586 = '#FFBDAD';
var $5738e2919e19457f$export$be802dd0d8b57f35 = '#FF8F73';
var $5738e2919e19457f$export$60847d42f9da92a6 = '#FF7452';
var $5738e2919e19457f$export$4a7404f376229999 = '#FF5630';
var $5738e2919e19457f$export$2010d0fb4295b346 = '#DE350B';
var $5738e2919e19457f$export$2837b5a1a71d5c02 = '#BF2600';
var $5738e2919e19457f$export$8d9596b529bbb9cf = '#FFFAE6';
var $5738e2919e19457f$export$41060a744ab0b7ae = '#FFF0B3';
var $5738e2919e19457f$export$1cc05bbbf340e559 = '#FFE380';
var $5738e2919e19457f$export$5aae31392d72caaa = '#FFC400';
var $5738e2919e19457f$export$c6930421db9fa514 = '#FFAB00';
var $5738e2919e19457f$export$59619663aa6500fb = '#FF991F';
var $5738e2919e19457f$export$874739ea9e379ab6 = '#FF8B00';
var $5738e2919e19457f$export$8a6341c32b6a3ee6 = '#E3FCEF';
var $5738e2919e19457f$export$69a3bf21b9686c2b = '#ABF5D1';
var $5738e2919e19457f$export$afbce1382ec95f73 = '#79F2C0';
var $5738e2919e19457f$export$747d86715d4175de = '#57D9A3';
var $5738e2919e19457f$export$940e1f69e873f202 = '#36B37E';
var $5738e2919e19457f$export$a49394138f7b8e85 = '#00875A';
var $5738e2919e19457f$export$6fa04827ac68a4fb = '#006644';
var $5738e2919e19457f$export$226de0355ed012f8 = '#DEEBFF';
var $5738e2919e19457f$export$8c13c2ee36917869 = '#B3D4FF';
var $5738e2919e19457f$export$ecfc1dff386a3e7a = '#4C9AFF';
var $5738e2919e19457f$export$215b7063051591f1 = '#2684FF';
var $5738e2919e19457f$export$e62e8919cca44969 = '#0065FF';
var $5738e2919e19457f$export$b3de0ae08da2ce64 = '#0052CC';
var $5738e2919e19457f$export$a6ee3d71bc067634 = '#0747A6';
var $5738e2919e19457f$export$363e4475840015bb = '#EAE6FF';
var $5738e2919e19457f$export$4b0a4417ed59760f = '#C0B6F2';
var $5738e2919e19457f$export$6011520a64d9a187 = '#998DD9';
var $5738e2919e19457f$export$a7175d4e9206bc80 = '#8777D9';
var $5738e2919e19457f$export$b48405b95304b5a1 = '#6554C0';
var $5738e2919e19457f$export$c71e4279dd54a18d = '#5243AA';
var $5738e2919e19457f$export$147899de772240ec = '#403294';
var $5738e2919e19457f$export$2cf711fe14c66f06 = '#E6FCFF';
var $5738e2919e19457f$export$7a8f4d33f6f9772c = '#B3F5FF';
var $5738e2919e19457f$export$776c9c497ef08533 = '#79E2F2';
var $5738e2919e19457f$export$69cb3ca10c1e330e = '#00C7E6';
var $5738e2919e19457f$export$9dc1ef0f3f48059b = '#00B8D9';
var $5738e2919e19457f$export$7c835c78b6fcdef8 = '#00A3BF';
var $5738e2919e19457f$export$6036577f95c3877e = '#008DA6';
var $5738e2919e19457f$export$29a4f05edc054374 = '#FFFFFF';
var $5738e2919e19457f$export$e655ef011c4aa1a2 = '#FAFBFC';
var $5738e2919e19457f$export$9fdfb749e33cdf97 = '#F4F5F7';
var $5738e2919e19457f$export$3e51e8f1440314ba = '#EBECF0';
var $5738e2919e19457f$export$1ce2d1575d444ceb = '#DFE1E6';
var $5738e2919e19457f$export$8754fc7e6d8b3000 = '#C1C7D0';
var $5738e2919e19457f$export$c2e91cbeada39b8b = '#B3BAC5';
var $5738e2919e19457f$export$5f71e19f3a7ad9de = '#A5ADBA';
var $5738e2919e19457f$export$eaa8c8a70ac22806 = '#97A0AF';
var $5738e2919e19457f$export$7c87d337fb91a97d = '#8993A4';
var $5738e2919e19457f$export$d6447c357493214f = '#7A869A';
var $5738e2919e19457f$export$f563ee71e9ee74cd = '#6B778C';
var $5738e2919e19457f$export$e2ef2124cf4024b1 = '#5E6C84';
var $5738e2919e19457f$export$eece5f492e429f08 = '#505F79';
var $5738e2919e19457f$export$c39c0fe0f26207ae = '#42526E';
var $5738e2919e19457f$export$7090862dc3038a9f = '#344563';
var $5738e2919e19457f$export$ad0bacf983b7ddaa = '#253858';
var $5738e2919e19457f$export$7d61b15e0da132af = '#172B4D';
var $5738e2919e19457f$export$fbda843f0a27fe96 = '#091E42';
var $5738e2919e19457f$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
var $5738e2919e19457f$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
var $5738e2919e19457f$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
var $5738e2919e19457f$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
var $5738e2919e19457f$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
var $5738e2919e19457f$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
var $5738e2919e19457f$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
var $5738e2919e19457f$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
var $5738e2919e19457f$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
var $5738e2919e19457f$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
var $5738e2919e19457f$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
var $5738e2919e19457f$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
var $5738e2919e19457f$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
var $5738e2919e19457f$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
var $5738e2919e19457f$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
var $5738e2919e19457f$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
var $5738e2919e19457f$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
var $5738e2919e19457f$export$2f6319cf7d736c2a = '#E6EDFA';
var $5738e2919e19457f$export$95126bc8884d6634 = '#DCE5F5';
var $5738e2919e19457f$export$8338d8c35d44ff1 = '#CED9EB';
var $5738e2919e19457f$export$5368d76ae4fbbda7 = '#B8C7E0';
var $5738e2919e19457f$export$9f0a771d16ec8d36 = '#ABBBD6';
var $5738e2919e19457f$export$abcf8c38338b4aa5 = '#9FB0CC';
var $5738e2919e19457f$export$97e81faa16a182c7 = '#8C9CB8';
var $5738e2919e19457f$export$bfe21c59123ecf33 = '#7988A3';
var $5738e2919e19457f$export$ee82aa2ea6a1558 = '#67758F';
var $5738e2919e19457f$export$682927c6ed76be02 = '#56637A';
var $5738e2919e19457f$export$91fd9994c5be9757 = '#455166';
var $5738e2919e19457f$export$d281fbfe3cff2df6 = '#3B475C';
var $5738e2919e19457f$export$3902c91d8b98a753 = '#313D52';
var $5738e2919e19457f$export$8e8133c1ba5845b5 = '#283447';
var $5738e2919e19457f$export$33ff357f6620b39 = '#202B3D';
var $5738e2919e19457f$export$633847cf062b69e0 = '#1B2638';
var $5738e2919e19457f$export$9776a6e503bdbf76 = '#121A29';
var $5738e2919e19457f$export$6c813d5160dff5db = '#0E1624';
var $5738e2919e19457f$export$3d4f271a500072a = '#0D1424';
var $5738e2919e19457f$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
var $5738e2919e19457f$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
var $5738e2919e19457f$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
var $5738e2919e19457f$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
var $5738e2919e19457f$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
var $5738e2919e19457f$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
var $5738e2919e19457f$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
var $5738e2919e19457f$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
var $5738e2919e19457f$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
var $5738e2919e19457f$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
var $5738e2919e19457f$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
var $5738e2919e19457f$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
var $5738e2919e19457f$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
var $5738e2919e19457f$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
var $5738e2919e19457f$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
var $5738e2919e19457f$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
var $5738e2919e19457f$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
var $5738e2919e19457f$export$8ce1fd94bee2f412 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-surface, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface, ".concat($5738e2919e19457f$export$633847cf062b69e0, ")")
});
var $5738e2919e19457f$export$b861914ea877b580 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$226de0355ed012f8, ")"),
    dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$8c13c2ee36917869, ")")
});
var $5738e2919e19457f$export$3f1b020df94387af = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-background-neutral-hovered, ".concat($5738e2919e19457f$export$3e51e8f1440314ba, ")"),
    dark: "var(--ds-background-neutral-hovered, ".concat($5738e2919e19457f$export$d281fbfe3cff2df6, ")")
});
var $5738e2919e19457f$export$c0183dbab98ca63e = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-surface-overlay, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")"),
    dark: "var(--ds-surface-overlay, ".concat($5738e2919e19457f$export$8e8133c1ba5845b5, ")")
});
var $5738e2919e19457f$export$6f093cfa640b7166 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($5738e2919e19457f$export$fbda843f0a27fe96, ")"),
    dark: "var(--ds-text, ".concat($5738e2919e19457f$export$5368d76ae4fbbda7, ")")
});
var $5738e2919e19457f$export$42f8e9c698766e7a = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5738e2919e19457f$export$5368d76ae4fbbda7, ")")
});
var $5738e2919e19457f$export$c2d157ca1c34b6e3 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")")
});
var $5738e2919e19457f$export$1905ba28d7cf066f = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($5738e2919e19457f$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5738e2919e19457f$export$97e81faa16a182c7, ")")
});
var $5738e2919e19457f$export$bd9002130d306d39 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($5738e2919e19457f$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5738e2919e19457f$export$bfe21c59123ecf33, ")")
});
var $5738e2919e19457f$export$46e4a324ac90507f = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")"),
    dark: "var(--ds-text, ".concat($5738e2919e19457f$export$5368d76ae4fbbda7, ")")
});
var $5738e2919e19457f$export$79f3f2b82beb0d36 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-text-subtlest, ".concat($5738e2919e19457f$export$f563ee71e9ee74cd, ")"),
    dark: "var(--ds-text-subtlest, ".concat($5738e2919e19457f$export$97e81faa16a182c7, ")")
});
var $5738e2919e19457f$export$7bb0d5c671655cc4 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$9fdfb749e33cdf97,
    dark: $5738e2919e19457f$export$8e8133c1ba5845b5
});
var $5738e2919e19457f$export$9c30223ca0a664fb = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-link, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-link, ".concat($5738e2919e19457f$export$ecfc1dff386a3e7a, ")")
});
var $5738e2919e19457f$export$7ed258b0728b004b = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($5738e2919e19457f$export$e62e8919cca44969, ")"),
    dark: "var(--ds-link-pressed, ".concat($5738e2919e19457f$export$215b7063051591f1, ")")
});
var $5738e2919e19457f$export$dfa920d8decc8a59 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-link-pressed, ".concat($5738e2919e19457f$export$a6ee3d71bc067634, ")"),
    dark: "var(--ds-link-pressed, ".concat($5738e2919e19457f$export$ecfc1dff386a3e7a, ")")
});
var $5738e2919e19457f$export$6069e6ad5c78f632 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-border-focused, ".concat($5738e2919e19457f$export$215b7063051591f1, ")"),
    dark: "var(--ds-border-focused, ".concat($5738e2919e19457f$export$215b7063051591f1, ")")
});
var $5738e2919e19457f$export$9ad721cf3b3debe0 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: "var(--ds-background-brand-bold, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
    dark: "var(--ds-background-brand-bold, ".concat($5738e2919e19457f$export$ecfc1dff386a3e7a, ")")
});
var $5738e2919e19457f$export$2aa0182783e7e9de = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$b3de0ae08da2ce64,
    dark: $5738e2919e19457f$export$ecfc1dff386a3e7a
});
var $5738e2919e19457f$export$8bf7dff220b82b4a = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$9dc1ef0f3f48059b,
    dark: $5738e2919e19457f$export$69cb3ca10c1e330e
});
var $5738e2919e19457f$export$e13cce2a2d16a9d4 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$b48405b95304b5a1,
    dark: $5738e2919e19457f$export$6011520a64d9a187
});
var $5738e2919e19457f$export$a90204d1394caf30 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$4a7404f376229999,
    dark: $5738e2919e19457f$export$4a7404f376229999
});
var $5738e2919e19457f$export$594c5a8758200c32 = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$c6930421db9fa514,
    dark: $5738e2919e19457f$export$c6930421db9fa514
});
var $5738e2919e19457f$export$955a2ebd2fb142ae = (0, $5e100033e0322651$export$2e2bcd8739ae039)({
    light: $5738e2919e19457f$export$940e1f69e873f202,
    dark: $5738e2919e19457f$export$940e1f69e873f202
});
var $5738e2919e19457f$export$2a0674ff2eb10214 = function skeleton() {
    return "var(--ds-skeleton, ".concat($5738e2919e19457f$export$8d43898f60b96a82, ")");
};


var $42d41419fcc93b93$var$CSS_VAR_TEXT_COLOR = '--banner-text-color';
var $42d41419fcc93b93$var$textStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    color: "var(".concat($42d41419fcc93b93$var$CSS_VAR_TEXT_COLOR, ")"),
    fontWeight: "var(--ds-font-weight-medium, 500)",
    lineHeight: "var(--ds-font-lineHeight-300, 24px)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'a, a:visited, a:hover, a:focus, a:active': {
        color: 'currentColor',
        textDecoration: 'underline'
    }
});
var $42d41419fcc93b93$var$backgroundColors = {
    warning: 'color.background.warning.bold',
    error: 'color.background.danger.bold',
    announcement: 'color.background.neutral.bold'
};
var $42d41419fcc93b93$var$tokenBackgroundColors = {
    warning: "var(--ds-background-warning-bold, ".concat((0, $5738e2919e19457f$export$c6930421db9fa514), ")"),
    error: "var(--ds-background-danger-bold, ".concat((0, $5738e2919e19457f$export$2010d0fb4295b346), ")"),
    announcement: "var(--ds-background-neutral-bold, ".concat((0, $5738e2919e19457f$export$c39c0fe0f26207ae), ")")
};
var $42d41419fcc93b93$var$tokenTextColors = {
    warning: "var(--ds-text-warning-inverse, ".concat((0, $5738e2919e19457f$export$ad0bacf983b7ddaa), ")"),
    error: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
    announcement: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")")
};
var $42d41419fcc93b93$var$containerStyles = (0, $837291fbb45fe878$export$f6c783d06584602c)({
    overflow: 'hidden',
    maxHeight: 'size.500'
});
var $42d41419fcc93b93$var$iconWrapperStyles = (0, $837291fbb45fe878$export$f6c783d06584602c)({
    display: 'block',
    width: 'size.200',
    height: 'size.200',
    // This matches Icon's "medium" size, without this the (line-)height is greater than that of the Icon
    flexShrink: '0'
});
/**
 * __Banner__
 *
 * A banner displays a prominent message at the top of the screen.
 *
 * - [Examples](https://atlassian.design/components/banner/examples)
 * - [Code](https://atlassian.design/components/banner/code)
 * - [Usage](https://atlassian.design/components/banner/usage)
 */ var $42d41419fcc93b93$var$Banner = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'warning' : _ref$appearance, children = _ref.children, icon = _ref.icon, testId = _ref.testId;
    var appearanceType = appearance in $42d41419fcc93b93$var$backgroundColors ? appearance : 'warning';
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $389592ecebf8a6ff$export$2e2bcd8739ae039), {
        xcss: $42d41419fcc93b93$var$containerStyles,
        backgroundColor: $42d41419fcc93b93$var$backgroundColors[appearanceType],
        padding: "space.150",
        testId: testId,
        ref: ref,
        role: "alert"
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $f6416c645ccb1742$export$2e2bcd8739ae039), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start"
    }, icon ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $389592ecebf8a6ff$export$2e2bcd8739ae039), {
        as: "span",
        xcss: $42d41419fcc93b93$var$iconWrapperStyles,
        style: {
            fill: $42d41419fcc93b93$var$tokenBackgroundColors[appearanceType],
            color: $42d41419fcc93b93$var$tokenTextColors[appearanceType]
        }
    }, icon) : null, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        style: (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, $42d41419fcc93b93$var$CSS_VAR_TEXT_COLOR, $42d41419fcc93b93$var$tokenTextColors[appearanceType]),
        css: $42d41419fcc93b93$var$textStyles
    }, children)));
});
var $42d41419fcc93b93$export$2e2bcd8739ae039 = $42d41419fcc93b93$var$Banner;


var $64346ccf5e752443$exports = {};
"use strict";
Object.defineProperty($64346ccf5e752443$exports, "__esModule", {
    value: true
});
$64346ccf5e752443$exports.default = void 0;

var $64346ccf5e752443$var$_react = $64346ccf5e752443$var$_interopRequireDefault((parcelRequire("5FkrB")));



var $5FkrB = parcelRequire("5FkrB");

var $af3d88314f58e1dc$export$18cb9425622d4e06 = function getBackground() {
    return "var(--ds-surface, #FFFFFF)";
};


var $bd8f31a1f7f76490$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
var $bd8f31a1f7f76490$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
var $bd8f31a1f7f76490$export$62ad7b0c781000e9 = {
    small: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.small,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.medium,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.large,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.xlarge,
        height: $bd8f31a1f7f76490$export$c647cb0ee6e282fe.xlarge
    }
};



var $ca1cc7c0f89123c0$export$16374db1c3e6dfba = {
    overflow: 'hidden',
    pointerEvents: 'none',
    /**
   * Stop-color doesn't properly apply in chrome when the inherited/current color changes.
   * We have to initially set stop-color to inherit (either via DOM attribute or an initial CSS
   * rule) and then override it with currentColor for the color changes to be picked up.
   */ stop: {
        stopColor: 'currentColor'
    }
};
var $ca1cc7c0f89123c0$var$smallStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, $bd8f31a1f7f76490$export$62ad7b0c781000e9).small);
var $ca1cc7c0f89123c0$var$mediumStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, $bd8f31a1f7f76490$export$62ad7b0c781000e9).medium);
var $ca1cc7c0f89123c0$var$largeStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, $bd8f31a1f7f76490$export$62ad7b0c781000e9).large);
var $ca1cc7c0f89123c0$var$xlargeStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, $bd8f31a1f7f76490$export$62ad7b0c781000e9).xlarge);
var $ca1cc7c0f89123c0$export$ef0ad74202575b64 = {
    small: $ca1cc7c0f89123c0$var$smallStyles,
    medium: $ca1cc7c0f89123c0$var$mediumStyles,
    large: $ca1cc7c0f89123c0$var$largeStyles,
    xlarge: $ca1cc7c0f89123c0$var$xlargeStyles
};
var $ca1cc7c0f89123c0$export$3eb7d6130acfda37 = function getIconSize(_ref) {
    var width = _ref.width, height = _ref.height, size = _ref.size;
    if (width && height) return {
        width: width,
        height: height
    };
    if (size) return (0, $bd8f31a1f7f76490$export$62ad7b0c781000e9)[size];
    return undefined;
};


function $21888af2d2e194e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $21888af2d2e194e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $21888af2d2e194e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $21888af2d2e194e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * We are hiding these props from consumers as they're used to
 * hack around icon sizing specifically for icon-file-type.
 */ var $21888af2d2e194e9$var$iconStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'inline-block',
    flexShrink: 0,
    lineHeight: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': $21888af2d2e194e9$var$_objectSpread($21888af2d2e194e9$var$_objectSpread({}, (0, $ca1cc7c0f89123c0$export$16374db1c3e6dfba)), {}, {
        maxWidth: '100%',
        maxHeight: '100%',
        color: 'var(--icon-primary-color)',
        fill: 'var(--icon-secondary-color)',
        verticalAlign: 'bottom'
    })
});
/**
 * For windows high contrast mode
 */ var $21888af2d2e194e9$var$baseHcmStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            filter: 'grayscale(1)',
            '--icon-primary-color': 'CanvasText',
            // foreground
            '--icon-secondary-color': 'Canvas' // background
        }
    }
});
var $21888af2d2e194e9$var$primaryEqualsSecondaryHcmStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            // if the primaryColor is the same as the secondaryColor we
            // set the --icon-primary-color to Canvas
            // this is usually to convey state i.e. Checkbox checked -> not checked
            '--icon-primary-color': 'Canvas' // foreground
        }
    }
});
var $21888af2d2e194e9$var$secondaryTransparentHcmStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '> svg': {
            '--icon-secondary-color': 'transparent' // background
        }
    }
});
var $21888af2d2e194e9$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5FkrB.memo)(function Icon(props) {
    var _ref = props, Glyph = _ref.glyph, dangerouslySetGlyph = _ref.dangerouslySetGlyph, _ref$primaryColor = _ref.primaryColor, primaryColor = _ref$primaryColor === void 0 ? 'currentColor' : _ref$primaryColor, secondaryColor = _ref.secondaryColor, size = _ref.size, testId = _ref.testId, label = _ref.label, width = _ref.width, height = _ref.height;
    var glyphProps = dangerouslySetGlyph ? {
        dangerouslySetInnerHTML: {
            __html: dangerouslySetGlyph
        }
    } : {
        children: Glyph ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Glyph, {
            role: "presentation"
        }) : null
    };
    var dimensions = (0, $ca1cc7c0f89123c0$export$3eb7d6130acfda37)({
        width: width,
        height: height,
        size: size
    });
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        "data-testid": testId,
        role: label ? 'img' : undefined,
        "aria-label": label ? label : undefined,
        "aria-hidden": label ? undefined : true,
        style: {
            '--icon-primary-color': primaryColor,
            '--icon-secondary-color': secondaryColor || (0, $af3d88314f58e1dc$export$18cb9425622d4e06)()
        }
    }, glyphProps, {
        css: [
            $21888af2d2e194e9$var$iconStyles,
            $21888af2d2e194e9$var$baseHcmStyles,
            primaryColor === secondaryColor && $21888af2d2e194e9$var$primaryEqualsSecondaryHcmStyles,
            secondaryColor === 'transparent' && $21888af2d2e194e9$var$secondaryTransparentHcmStyles,
            // NB: This can be resolved if this component, composes base SVG / and/or skeleton
            // We could then simplify how common styles are dealt with simply by encapsualting them
            // at their appropriate level and/or having a singular approach to css variables in the package
            dimensions && // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
                width: dimensions.width,
                height: dimensions.height,
                '> svg': dimensions
            })
        ]
    }));
});
var $21888af2d2e194e9$export$2e2bcd8739ae039 = $21888af2d2e194e9$export$f04a61298a47a40f;


function $64346ccf5e752443$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $64346ccf5e752443$var$NotificationIcon = (props)=>/*#__PURE__*/ $64346ccf5e752443$var$_react.default.createElement($21888af2d2e194e9$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M6.485 17.669a2 2 0 002.829 0l-2.829-2.83a2 2 0 000 2.83zm4.897-12.191l-.725.725c-.782.782-2.21 1.813-3.206 2.311l-3.017 1.509c-.495.248-.584.774-.187 1.171l8.556 8.556c.398.396.922.313 1.171-.188l1.51-3.016c.494-.988 1.526-2.42 2.311-3.206l.725-.726a5.048 5.048 0 00.64-6.356 1.01 1.01 0 10-1.354-1.494c-.023.025-.046.049-.066.075a5.043 5.043 0 00-2.788-.84 5.036 5.036 0 00-3.57 1.478z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$64346ccf5e752443$var$NotificationIcon.displayName = 'NotificationIcon';
var $64346ccf5e752443$var$_default = $64346ccf5e752443$var$NotificationIcon;
$64346ccf5e752443$exports.default = $64346ccf5e752443$var$_default;


const $6c9dff951d5063ec$export$23a850224f96ccbb = ()=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $42d41419fcc93b93$export$2e2bcd8739ae039), {
        appearance: "announcement",
        icon: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($64346ccf5e752443$exports))), {
            label: "",
            secondaryColor: "inherit"
        }),
        children: [
            "Bifrost Baked Cookies website is under constuction, but we are on it.",
            ' ',
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("a", {
                href: "/components/banner/examples",
                children: "Learn more details"
            })
        ]
    });
};





parcelRequire("5FkrB");
/** @jsx jsx */ 


var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $ec8f8fc8c8703c3d$var$_ref, $ec8f8fc8c8703c3d$var$_process, $ec8f8fc8c8703c3d$var$_process2;
// We can't rely on NODE_ENV === 'test' if its value is already configured by the consumer to some other value, so better to use JEST_WORKER_ID
// https://jestjs.io/docs/environment-variables#jest_worker_id
var $ec8f8fc8c8703c3d$var$TESTS_MODE = ($ec8f8fc8c8703c3d$var$_ref = (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process === void 0 || ($ec8f8fc8c8703c3d$var$_process = $ec8f8fc8c8703c3d$var$_process.env) === null || $ec8f8fc8c8703c3d$var$_process === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process.JEST_WORKER_ID) !== undefined, $ec8f8fc8c8703c3d$var$_ref !== void 0) ? $ec8f8fc8c8703c3d$var$_ref : false;
var $ec8f8fc8c8703c3d$var$DEBUG_MODE = !$ec8f8fc8c8703c3d$var$TESTS_MODE && (globalThis === null || globalThis === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = globalThis.process) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 || ($ec8f8fc8c8703c3d$var$_process2 = $ec8f8fc8c8703c3d$var$_process2.env) === null || $ec8f8fc8c8703c3d$var$_process2 === void 0 ? void 0 : $ec8f8fc8c8703c3d$var$_process2.NODE_ENV) !== 'production';
var $ec8f8fc8c8703c3d$export$1c9f709888824e05 = function debug() {
    var _console;
    if (!$ec8f8fc8c8703c3d$var$DEBUG_MODE) return;
    // eslint-disable-next-line no-console
    (_console = console).debug.apply(_console, arguments);
};



var $3ZMUU = parcelRequire("3ZMUU");
var $fd90cb3103826b9d$var$pkgName = '@atlaskit/platform-feature-flags';
var $fd90cb3103826b9d$export$7e41b1b2bdee3f98 = '__PLATFORM_FEATURE_FLAGS__';
var $fd90cb3103826b9d$var$hasProcessEnv = typeof $3ZMUU !== 'undefined' && typeof $3ZMUU.env !== 'undefined';
// FF global overrides can be configured by test runners or Storybook
var $fd90cb3103826b9d$var$ENV_ENABLE_PLATFORM_FF = $fd90cb3103826b9d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
// STORYBOOK_ENABLE_PLATFORM_FF is included as storybook only allows env vars prefixed with STORYBOOK
// https://github.com/storybookjs/storybook/issues/12270
var $fd90cb3103826b9d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF = $fd90cb3103826b9d$var$hasProcessEnv ? // Use global "process" variable and process.env['FLAG_NAME'] syntax, so it can be replaced by webpack DefinePlugin
false : false;
var $fd90cb3103826b9d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE = $fd90cb3103826b9d$var$ENV_ENABLE_PLATFORM_FF || $fd90cb3103826b9d$var$ENV_STORYBOOK_ENABLE_PLATFORM_FF;
var $fd90cb3103826b9d$var$DEFAULT_PFF_GLOBAL = {
    // In development mode we want to capture any feature flag checks that happen using the default resolver and log this result when the resolver is replaced.
    // This is because evaluating feature flags when the resolver/FF client is loaded asynchronously could cause unexpected issues.
    earlyResolvedFlags: new Map(),
    booleanResolver: function booleanResolver(flagKey) {
        var unresolvedFlagCount;
        return false;
    }
};
var $fd90cb3103826b9d$var$globalVar = typeof window !== 'undefined' ? window : globalThis;
$fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98] = $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98] || $fd90cb3103826b9d$var$DEFAULT_PFF_GLOBAL;
function $fd90cb3103826b9d$export$f2b591175b3e424c(resolver) {
    $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98].booleanResolver = resolver;
    var _globalVar$PFF_GLOBAL;
}
function $fd90cb3103826b9d$export$6333b6aff9fc6275(flagKey) {
    if ($fd90cb3103826b9d$var$ENABLE_GLOBAL_PLATFORM_FF_OVERRIDE) {
        (0, $ec8f8fc8c8703c3d$export$1c9f709888824e05)('[%s]: The feature flags were enabled while running tests. The flag "%s" will be always enabled.', $fd90cb3103826b9d$var$pkgName, flagKey);
        return true;
    }
    try {
        var _globalVar$PFF_GLOBAL2;
        var result = (_globalVar$PFF_GLOBAL2 = $fd90cb3103826b9d$var$globalVar[$fd90cb3103826b9d$export$7e41b1b2bdee3f98]) === null || _globalVar$PFF_GLOBAL2 === void 0 ? void 0 : _globalVar$PFF_GLOBAL2.booleanResolver(flagKey);
        if (typeof result !== 'boolean') {
            // eslint-disable-next-line no-console
            console.warn("".concat(flagKey, " resolved to a non-boolean value, returning false for safety"));
            return false;
        }
        return result;
    } catch (e) {
        return false;
    }
}


function $74654669a87807aa$export$ba05d765b8392e5e(flagResolver) {
    (0, $fd90cb3103826b9d$export$f2b591175b3e424c)(flagResolver);
}
function $74654669a87807aa$export$470e5c2be1411c89(name) {
    return (0, $fd90cb3103826b9d$export$6333b6aff9fc6275)(name);
}



var $726d8db65a256fd4$exports = {};
function $726d8db65a256fd4$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
$726d8db65a256fd4$exports = $726d8db65a256fd4$var$_classCallCheck, $726d8db65a256fd4$exports.__esModule = true, $726d8db65a256fd4$exports["default"] = $726d8db65a256fd4$exports;


var $79b2697ff32e0117$exports = {};

function $79b2697ff32e0117$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $f5a10e61d0aa9357$exports(o.key), o);
    }
}
function $79b2697ff32e0117$var$_createClass(e, r, t) {
    return r && $79b2697ff32e0117$var$_defineProperties(e.prototype, r), t && $79b2697ff32e0117$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
$79b2697ff32e0117$exports = $79b2697ff32e0117$var$_createClass, $79b2697ff32e0117$exports.__esModule = true, $79b2697ff32e0117$exports["default"] = $79b2697ff32e0117$exports;


var $d5b556b08c8aee39$exports = {};
function $d5b556b08c8aee39$var$_assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
$d5b556b08c8aee39$exports = $d5b556b08c8aee39$var$_assertThisInitialized, $d5b556b08c8aee39$exports.__esModule = true, $d5b556b08c8aee39$exports["default"] = $d5b556b08c8aee39$exports;


var $a98c007cb7076ed5$exports = {};
var $7d946a7286a692c7$exports = {};
function $7d946a7286a692c7$var$_setPrototypeOf(t, e) {
    return $7d946a7286a692c7$exports = $7d946a7286a692c7$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $7d946a7286a692c7$exports.__esModule = true, $7d946a7286a692c7$exports["default"] = $7d946a7286a692c7$exports, $7d946a7286a692c7$var$_setPrototypeOf(t, e);
}
$7d946a7286a692c7$exports = $7d946a7286a692c7$var$_setPrototypeOf, $7d946a7286a692c7$exports.__esModule = true, $7d946a7286a692c7$exports["default"] = $7d946a7286a692c7$exports;


function $a98c007cb7076ed5$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $7d946a7286a692c7$exports(t, e);
}
$a98c007cb7076ed5$exports = $a98c007cb7076ed5$var$_inherits, $a98c007cb7076ed5$exports.__esModule = true, $a98c007cb7076ed5$exports["default"] = $a98c007cb7076ed5$exports;


var $f1660048948b9f64$exports = {};

var $f1660048948b9f64$var$_typeof = $a6f3b7a9d572ec57$exports.default;

function $f1660048948b9f64$var$_possibleConstructorReturn(t, e) {
    if (e && ("object" == $f1660048948b9f64$var$_typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return $d5b556b08c8aee39$exports(t);
}
$f1660048948b9f64$exports = $f1660048948b9f64$var$_possibleConstructorReturn, $f1660048948b9f64$exports.__esModule = true, $f1660048948b9f64$exports["default"] = $f1660048948b9f64$exports;


var $973318e0cb84a68c$exports = {};
function $973318e0cb84a68c$var$_getPrototypeOf(t) {
    return $973318e0cb84a68c$exports = $973318e0cb84a68c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $973318e0cb84a68c$exports.__esModule = true, $973318e0cb84a68c$exports["default"] = $973318e0cb84a68c$exports, $973318e0cb84a68c$var$_getPrototypeOf(t);
}
$973318e0cb84a68c$exports = $973318e0cb84a68c$var$_getPrototypeOf, $973318e0cb84a68c$exports.__esModule = true, $973318e0cb84a68c$exports["default"] = $973318e0cb84a68c$exports;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $2fdf6e45620f1c96$var$AnalyticsNextContext = (0, $5FkrB.createContext)({
    getAtlaskitAnalyticsContext: function() {
        return [];
    },
    getAtlaskitAnalyticsEventHandlers: function() {
        return [];
    }
});
var $2fdf6e45620f1c96$export$2e2bcd8739ae039 = $2fdf6e45620f1c96$var$AnalyticsNextContext;


var $d82667e77467cbe0$export$2e2bcd8739ae039 = (0, $2fdf6e45620f1c96$export$2e2bcd8739ae039);


function $b4492ce4107f08c4$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $b4492ce4107f08c4$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($973318e0cb84a68c$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($973318e0cb84a68c$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1660048948b9f64$exports)))(this, result);
    };
}
function $b4492ce4107f08c4$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($b4492ce4107f08c4$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $b4492ce4107f08c4$var$ContextTypes = {
    getAtlaskitAnalyticsContext: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).func,
    getAtlaskitAnalyticsEventHandlers: (0, (/*@__PURE__*/$parcel$interopDefault($632422cfaa3e0ff5$exports))).func
};
var $b4492ce4107f08c4$var$noop = function noop() {
    return [];
};
// eslint-disable-next-line @repo/internal/react/no-class-components
var $b4492ce4107f08c4$var$AnalyticsContext = /*#__PURE__*/ function(_Component) {
    (0, (/*@__PURE__*/$parcel$interopDefault($a98c007cb7076ed5$exports)))(AnalyticsContext, _Component);
    var _super = $b4492ce4107f08c4$var$_createSuper(AnalyticsContext);
    function AnalyticsContext(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($726d8db65a256fd4$exports)))(this, AnalyticsContext);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), "getChildContext", function() {
            return {
                getAtlaskitAnalyticsContext: _this.getAnalyticsContext
            };
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), "getAnalyticsContext", function() {
            var data = _this.props.data;
            var _this$context$getAtla = _this.context.getAtlaskitAnalyticsContext, getAtlaskitAnalyticsContext = _this$context$getAtla === void 0 ? $b4492ce4107f08c4$var$noop : _this$context$getAtla;
            return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(getAtlaskitAnalyticsContext()), [
                data
            ]);
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), "getAnalyticsEventHandlers", function() {
            var _this$context$getAtla2 = _this.context.getAtlaskitAnalyticsEventHandlers, getAtlaskitAnalyticsEventHandlers = _this$context$getAtla2 === void 0 ? $b4492ce4107f08c4$var$noop : _this$context$getAtla2;
            return getAtlaskitAnalyticsEventHandlers();
        });
        _this.contextValue = {
            getAtlaskitAnalyticsContext: _this.getAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: _this.getAnalyticsEventHandlers
        };
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($79b2697ff32e0117$exports)))(AnalyticsContext, [
        {
            key: "render",
            value: function render() {
                var children = this.props.children;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d82667e77467cbe0$export$2e2bcd8739ae039).Provider, {
                    value: this.contextValue
                }, children);
            }
        }
    ]);
    return AnalyticsContext;
}((0, $5FkrB.Component));
(0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($b4492ce4107f08c4$var$AnalyticsContext, "contextTypes", $b4492ce4107f08c4$var$ContextTypes);
(0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($b4492ce4107f08c4$var$AnalyticsContext, "childContextTypes", $b4492ce4107f08c4$var$ContextTypes);
var $b4492ce4107f08c4$export$2e2bcd8739ae039 = $b4492ce4107f08c4$var$AnalyticsContext;




var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $3a4497eea280292e$export$d1f587f82ad51c4 = function useAnalyticsContext() {
    return (0, $5FkrB.useContext)((0, $d82667e77467cbe0$export$2e2bcd8739ae039));
};



var $5FkrB = parcelRequire("5FkrB");
var $90d091140a6cc984$export$1d27a74659855e44 = function useTrackedRef(value) {
    var ref = (0, $5FkrB.useRef)(value);
    (0, $5FkrB.useEffect)(function() {
        ref.current = value;
    }, [
        value
    ]);
    return ref;
};


var $97ca9e2bedb57888$var$AnalyticsContext = function AnalyticsContext(_ref) {
    var data = _ref.data, children = _ref.children;
    var dataRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(data);
    var analyticsContext = (0, $3a4497eea280292e$export$d1f587f82ad51c4)();
    var getAtlaskitAnalyticsContext = (0, $5FkrB.useCallback)(function() {
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(analyticsContext.getAtlaskitAnalyticsContext()), [
            dataRef.current
        ]);
    }, [
        analyticsContext,
        dataRef
    ]);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            getAtlaskitAnalyticsContext: getAtlaskitAnalyticsContext,
            getAtlaskitAnalyticsEventHandlers: analyticsContext.getAtlaskitAnalyticsEventHandlers
        };
    }, [
        analyticsContext,
        getAtlaskitAnalyticsContext
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d82667e77467cbe0$export$2e2bcd8739ae039).Provider, {
        value: value
    }, children);
};
var $97ca9e2bedb57888$export$2e2bcd8739ae039 = $97ca9e2bedb57888$var$AnalyticsContext;



var $3ZMUU = parcelRequire("3ZMUU");
var $f6709ac4711d5a89$var$ExportedAnalyticsContext = function ExportedAnalyticsContext(props) {
    var _process$env;
    var isModernContextEnabledEnv = typeof $3ZMUU !== 'undefined' && $3ZMUU !== null && ((_process$env = {}, _process$env === void 0) ? void 0 : _process$env['ANALYTICS_NEXT_MODERN_CONTEXT']);
    return isModernContextEnabledEnv || (0, $74654669a87807aa$export$470e5c2be1411c89)('platform.analytics-next-use-modern-context_fqgbx') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $97ca9e2bedb57888$export$2e2bcd8739ae039), props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4492ce4107f08c4$export$2e2bcd8739ae039), props);
};
var $f6709ac4711d5a89$export$2e2bcd8739ae039 = $f6709ac4711d5a89$var$ExportedAnalyticsContext;


var $c122abe76d5b40d8$var$createNamespaceContext = function createNamespaceContext(namespace) {
    var displayName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'NamespacedContext';
    var Component = function Component(props) {
        var newData = (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, namespace, props.data);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f6709ac4711d5a89$export$2e2bcd8739ae039), {
            data: newData
        }, (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.only(props.children));
    };
    Component.displayName = displayName;
    return Component;
};
var $c122abe76d5b40d8$export$2e2bcd8739ae039 = $c122abe76d5b40d8$var$createNamespaceContext;


var $5485bcf8dc53d39f$export$80450e0a84a5ede9 = 'fabricElementsCtx';
var $5485bcf8dc53d39f$export$3fe25500478a635c = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($5485bcf8dc53d39f$export$80450e0a84a5ede9, 'FabricElementsAnalyticsContext');



var $fb54a115516e258d$export$1fd3aad76a7c6788 = 'navigationCtx';
var $fb54a115516e258d$export$d0a82da1a0b94929 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($fb54a115516e258d$export$1fd3aad76a7c6788, 'NavigationAnalyticsContext');



var $f127cdcabdc66218$export$8c8f6d8f1fa796f0 = 'fabricEditorCtx';
var $f127cdcabdc66218$export$9eb2b47430ed3f7c = /*#__PURE__*/ function(EDITOR_APPEARANCE_CONTEXT) {
    EDITOR_APPEARANCE_CONTEXT["FIXED_WIDTH"] = "fixedWidth";
    EDITOR_APPEARANCE_CONTEXT["FULL_WIDTH"] = "fullWidth";
    EDITOR_APPEARANCE_CONTEXT["COMMENT"] = "comment";
    EDITOR_APPEARANCE_CONTEXT["CHROMELESS"] = "chromeless";
    EDITOR_APPEARANCE_CONTEXT["MOBILE"] = "mobile";
    return EDITOR_APPEARANCE_CONTEXT;
}({});
var $f127cdcabdc66218$export$629cada6c5e621e1 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($f127cdcabdc66218$export$8c8f6d8f1fa796f0, 'FabricEditorAnalyticsContext');


// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
var $c07b4cab76aa5901$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx



var $9073b35d423b273a$export$b326383bee6cb993 = 'peopleTeamsCtx';
var $9073b35d423b273a$export$4119ddb38ccbfb87 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($9073b35d423b273a$export$b326383bee6cb993, 'PeopleTeamsAnalyticsContext');



var $c5bfaa24e1ac3102$export$da1befb791e93c7e = 'NotificationsCtx';
var $c5bfaa24e1ac3102$export$6f8e7ff1e3feafd7 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($c5bfaa24e1ac3102$export$da1befb791e93c7e, 'NotificationsAnalyticsContext');



var $9c832766ec71e470$export$fc7a65795610cb71 = 'RecentWorkCtx';
var $9c832766ec71e470$export$745926731087ebe2 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($9c832766ec71e470$export$fc7a65795610cb71, 'RecentWorkAnalyticsContext');



var $a1c5a3176be927c9$export$4906017439f33fc0 = 'atlasCtx';
var $a1c5a3176be927c9$export$43ebbe41370d4543 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($a1c5a3176be927c9$export$4906017439f33fc0, 'AtlasAnalyticsContext');



var $861cd462966d849a$export$3240443bf2b83834 = 'linkingPlatformCtx';
var $861cd462966d849a$export$6d568da622ce0a08 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($861cd462966d849a$export$3240443bf2b83834, 'LinkingPlatformAnalyticsContext');



var $6dc82853dd29f159$export$ef0c05448f0f8f9 = 'postOfficeCtx';
var $6dc82853dd29f159$export$dcd232f3be312f94 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($6dc82853dd29f159$export$ef0c05448f0f8f9, 'PostOfficeAnalyticsContext');



var $9c861e9da48289b6$export$5c3a6fd8b96e8b66 = 'aiMateCtx';
var $9c861e9da48289b6$export$de3826c30468da26 = (0, $c122abe76d5b40d8$export$2e2bcd8739ae039)($9c861e9da48289b6$export$5c3a6fd8b96e8b66, 'AIMateAnalyticsContext');







var $9e0b6f96d7dc4701$export$85e3c3ca0c6fb93 = (0, $46bf0aae0dfb1de2$export$85e3c3ca0c6fb93)();
var $9e0b6f96d7dc4701$export$30fa7cc5f2690a43 = 56;
var $9e0b6f96d7dc4701$export$4033a111ca79977d = 1280;
var $9e0b6f96d7dc4701$export$24ec62cee78b7042 = 1130;
var $9e0b6f96d7dc4701$export$d8bde68ac946124f = '--ds--ans--fbc';
var $9e0b6f96d7dc4701$export$73e44f54603a0964 = '--ds--ans--hbgc';
var $9e0b6f96d7dc4701$export$13f8aa8f663f4c99 = '--ds--ans--bgc';
var $9e0b6f96d7dc4701$export$d81606c1fc5119bc = '--ds--ans--c';
var $9e0b6f96d7dc4701$export$65f656ad520ea71 = '--ds--ans--bc';







function $9de014d0ca2dbeda$var$fromHex(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace("#", "").match(/.{2}/g);
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a], 16);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9de014d0ca2dbeda$var$fromRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "hex":
            return 1 == (g = Math.round(n.r).toString(16)).length && (g = "0" + g), 1 == (y = Math.round(n.g).toString(16)).length && (y = "0" + y), 1 == (_ = Math.round(n.b).toString(16)).length && (_ = "0" + _), "#" + g + y + _;
        case "cssrgb":
            return "rgb(" + Math.round(n.r) + "," + Math.round(n.g) + "," + Math.round(n.b) + ")";
        case "hsl":
            var a = [
                g = n.r / 255,
                y = n.g / 255,
                _ = n.b / 255
            ].sort(), i = (a[0] + a[2]) / 2 * 100;
            return a[0] == a[2] ? (b = 0, d = 0) : (b = i >= 50 ? (a[2] - a[0]) / (2 - a[2] - a[0]) * 100 : (a[2] - a[0]) / (a[2] + a[0]) * 100, (d = a[2] == g ? (y - _) / (a[2] - a[0]) * 60 : a[2] == y ? 60 * (2 + (_ - g) / (a[2] - a[0])) : 60 * (4 + (g - y) / (a[2] - a[0]))) < 0 ? d += 360 : d > 360 && (d %= 360)), {
                h: d,
                s: b,
                l: i
            };
        case "csshsl":
            var c = o.convert({
                conversions: t,
                helpers: s
            }, "hsl", n);
            return "hsl(" + Math.round(c.h) + "," + Math.round(c.s) + "%," + Math.round(c.l) + "%)";
        case "cmyk":
            var u = n.r / 255, l = n.g / 255, h = n.b / 255, v = 1 - Math.max(u, l, h);
            if (1 != v) var p = (1 - u - v) / (1 - v), f = (1 - l - v) / (1 - v), m = (1 - h - v) / (1 - v);
            else var p = 0, f = 0, m = 0;
            return {
                c: p,
                m: f,
                y: m,
                k: v
            };
        case "hsv":
            var d, b, g = n.r / 255, y = n.g / 255, _ = n.b / 255, M = Math.min(g, y, _), Y = Math.max(g, y, _), L = Y - M, X = Y;
            if (0 == L) d = 0, b = 0;
            else {
                b = L / Y;
                var Z = ((Y - g) / 6 + L / 2) / L, R = ((Y - y) / 6 + L / 2) / L, w = ((Y - _) / 6 + L / 2) / L;
                g == Y ? d = w - R : y == Y ? d = 1 / 3 + Z - w : _ == Y && (d = 2 / 3 + R - Z), d < 0 && (d += 1), d > 1 && (d -= 1);
            }
            return {
                h: 360 * d,
                s: 100 * b,
                v: 100 * X
            };
        case "yiq":
            var m = n.r / 255 * .299 + n.g / 255 * .587 + n.b / 255 * .114, C = n.r / 255 * .596 + n.g / 255 * -0.274 + n.b / 255 * -0.322, x = n.r / 255 * .211 + n.g / 255 * -0.523 + n.b / 255 * .312;
            return C = s.bounded(C, [
                -0.5957,
                .5957
            ]), x = s.bounded(x, [
                -0.5226,
                .5226
            ]), {
                y: m,
                i: C,
                q: x
            };
        case "XYZ":
            var A = [
                n.r,
                n.g,
                n.b
            ].map(function(r) {
                return r / 255;
            }).map(function(r) {
                return r <= .04045 ? r / 12.92 : Math.pow((r + .055) / 1.055, 2.4);
            }), S = s.getTransform("SRGB_XYZ").map(function(r) {
                return A.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return 100 * r;
            }), O = $9de014d0ca2dbeda$var$slicedToArray(S, 3);
            return {
                X: O[0],
                Y: O[1],
                Z: O[2]
            };
        case "lms":
        case "cielab":
        case "cieluv":
        case "xyY":
            var I = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, I);
        case "cielch":
            var j = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, j);
        case "hsluv":
            var D = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, D);
    }
}
function $9de014d0ca2dbeda$var$fromCssRgb(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/((rgb\(|\))|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "rgb":
            return {
                r: n[0],
                g: n[1],
                b: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                r: n[0],
                g: n[1],
                b: n[2]
            });
    }
}
function $9de014d0ca2dbeda$var$fromHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            if (0 == n.s) {
                var a = n.l / 100 * 255;
                return {
                    r: a,
                    g: a,
                    b: a
                };
            }
            var i, c, u;
            i = n.l >= 50 ? n.l / 100 + n.s / 100 - n.l / 100 * (n.s / 100) : n.l / 100 * (1 + n.s / 100), c = n.l / 100 * 2 - i;
            var l, h, v, p = ((u = n.h / 360) + .333) % 1, f = u, m = s.negMod(u - .333, 1);
            return l = 6 * p < 1 ? c + 6 * (i - c) * p : 2 * p < 1 ? i : 3 * p < 2 ? c + 6 * (.666 - p) * (i - c) : c, h = 6 * f < 1 ? c + 6 * (i - c) * f : 2 * f < 1 ? i : 3 * f < 2 ? c + 6 * (.666 - f) * (i - c) : c, v = 6 * m < 1 ? c + 6 * (i - c) * m : 2 * m < 1 ? i : 3 * m < 2 ? c + 6 * (.666 - m) * (i - c) : c, l < 0 && (l = 0), h < 0 && (h = 0), v < 0 && (v = 0), {
                r: 255 * l,
                g: 255 * h,
                b: 255 * v
            };
        case "csshsl":
            return "hsl(" + Math.round(n.h) + "," + Math.round(n.s) + "%," + Math.round(n.l) + "%)";
        case "hsv":
            n.s = n.s / 100, n.l = n.l / 100;
            var d = n.s * (n.l < .5 ? n.l : 1 - n.l);
            return {
                h: n.h,
                s: 100 * (2 * d / (n.l + d)),
                v: 100 * (n.l + d)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9de014d0ca2dbeda$var$fromCssHsl(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    n = n.replace(/(hsl\(|\)|%|[\s]*)/g, "").split(",");
    for(var a = 0; a < n.length; a++)n[a] = parseInt(n[a]);
    switch(e){
        case "hsl":
            return {
                h: n[0],
                s: n[1],
                l: n[2]
            };
        default:
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, {
                h: n[0],
                s: n[1],
                l: n[2]
            });
    }
}
function $9de014d0ca2dbeda$var$fromHsv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            var a, i, c;
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            var u = 6 * n.h;
            6 == u && (u = 0);
            var l, h, v, p = Math.round(u), f = n.v * (1 - n.s), m = n.v * (1 - n.s * (u - p)), d = n.v * (1 - n.s * (1 - (u - p)));
            return 0 == p ? (l = n.v, h = d, v = f) : 1 == p ? (l = m, h = n.v, v = f) : 2 == p ? (l = f, h = n.v, v = d) : 3 == p ? (l = f, h = m, v = n.v) : 4 == p ? (l = d, h = f, v = n.v) : (l = n.v, h = f, v = m), a = 255 * l, i = 255 * h, c = 255 * v, {
                r: a,
                g: i,
                b: c
            };
        case "hsl":
            n.h = n.h / 360, n.s = n.s / 100, n.v = n.v / 100;
            return {
                h: 360 * n.h,
                s: 100 * ((2 - n.s) * n.v < 1 ? n.s * n.v / ((2 - n.s) * n.v) : n.s * n.v / (2 - (2 - n.s) * n.v)),
                l: 100 * ((2 - n.s) * n.v / 2)
            };
        default:
            var b = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, b);
    }
}
function $9de014d0ca2dbeda$var$fromCmyk(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "rgb":
            return {
                r: a = 255 * (1 - n.c) * (1 - n.k),
                g: i = 255 * (1 - n.m) * (1 - n.k),
                b: c = 255 * (1 - n.y) * (1 - n.k)
            };
        case "cssrgb":
            var a = 255 * (1 - n.c) * (1 - n.k), i = 255 * (1 - n.m) * (1 - n.k), c = 255 * (1 - n.y) * (1 - n.k);
            return "rgb(" + Math.round(a) + "," + Math.round(i) + "," + Math.round(c) + ")";
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9de014d0ca2dbeda$var$fromYiq(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(n.i = s.bounded(n.i, [
        -0.5957,
        .5957
    ]), n.q = s.bounded(n.q, [
        -0.5226,
        .5226
    ]), e){
        case "rgb":
            var a = 255 * (n.y + .956 * n.i + .621 * n.q), i = 255 * (n.y + -0.272 * n.i + -0.647 * n.q), c = 255 * (n.y + -1.106 * n.i + -1.703 * n.q);
            return a = s.bounded(a, [
                0,
                255
            ]), i = s.bounded(i, [
                0,
                255
            ]), c = s.bounded(c, [
                0,
                255
            ]), {
                r: a,
                g: i,
                b: c
            };
        default:
            var u = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, u);
    }
}
function $9de014d0ca2dbeda$var$fromXYZ(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers, a = s.getIlluminant("D65");
    switch(e){
        case "rgb":
            var i = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), c = s.getTransform("INVERSE_SRGB_XYZ").map(function(r) {
                return i.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            }).map(function(r) {
                return r <= .0031308 ? 12.92 * r : 1.055 * Math.pow(r, 1 / 2.4) - .055;
            }).map(function(r) {
                return 255 * r;
            }), u = $9de014d0ca2dbeda$var$slicedToArray(c, 3), l = u[0], h = u[1], v = u[2];
            return s.boundedRgb({
                r: l,
                g: h,
                b: v
            });
        case "lms":
            var p = [
                n.X,
                n.Y,
                n.Z
            ].map(function(r) {
                return r / 100;
            }), f = s.getTransform("BRADFORD").map(function(r) {
                return p.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                rho: f[0],
                gamma: f[1],
                beta: f[2]
            };
        case "cielab":
            var m = n.X / a.X, d = n.Y / a.Y, b = n.Z / a.Z, g = function(r) {
                return r > .008856 ? s.cbrt(r) : (903.3 * r + 16) / 116;
            }, y = g(m), _ = g(d);
            return {
                L: 116 * _ - 16,
                a: 500 * (y - _),
                b: 200 * (_ - g(b))
            };
        case "cieluv":
            var M = n.Y / a.Y, Y = M > .008856 ? 116 * s.cbrt(M) - 16 : 903.3 * M, L = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }, X = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            };
            return {
                L: Y,
                u: 13 * Y * (L(n) - L(a)),
                v: 13 * Y * (X(n) - X(a))
            };
        case "xyY":
            return {
                x: n.X / (n.X + n.Y + n.Z),
                y: n.Y / (n.X + n.Y + n.Z),
                Y: n.Y
            };
        default:
            var Z = s.boundedRgb(o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "rgb", n));
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, Z);
    }
}
function $9de014d0ca2dbeda$var$fromxyY(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = n.Y / n.y * n.x, i = n.Y / n.y * (1 - n.x - n.y);
            return {
                X: a,
                Y: n.Y,
                Z: i
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9de014d0ca2dbeda$var$fromLms(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = [
                n.rho,
                n.gamma,
                n.beta
            ], i = s.getTransform("INVERSE_BRADFORD").map(function(r) {
                return a.reduce(function(e, n, t) {
                    return r[t] * n + e;
                }, 0);
            });
            return {
                X: 100 * i[0],
                Y: 100 * i[1],
                Z: 100 * i[2]
            };
        default:
            var c = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, c);
    }
}
function $9de014d0ca2dbeda$var$fromCieLab(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = (n.L + 16) / 116, c = n.a / 500 + i, u = i - n.b / 200, l = function(r) {
                return Math.pow(r, 3) > .008856 ? Math.pow(r, 3) : (116 * r - 16) / 903.3;
            }, h = l(c), v = l(u), p = n.L > 903.3 * .008856 ? Math.pow(i, 3) : n.L / 903.3;
            return {
                X: h * a.X,
                Y: p * a.Y,
                Z: v * a.Z
            };
        default:
            var f = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, f);
    }
}
function $9de014d0ca2dbeda$var$fromCieLuv(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "XYZ":
            var a = s.getIlluminant("D65"), i = function(r) {
                return 4 * r.X / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), c = function(r) {
                return 9 * r.Y / (r.X + 15 * r.Y + 3 * r.Z);
            }(a), u = 1 / 3 * (52 * n.L / (n.u + 13 * n.L * i) - 1), l = n.L > 903.3 * .008856 ? Math.pow((n.L + 16) / 116, 3) : n.L / 903.3, h = -5 * l, v = (l * (39 * n.L / (n.v + 13 * n.L * c) - 5) - h) / (u - -1 / 3);
            return {
                X: 100 * v,
                Y: 100 * l,
                Z: 100 * (v * u + h)
            };
        case "cielch":
            var p = Math.sqrt(Math.pow(n.u, 2) + Math.pow(n.v, 2)), f = Math.atan2(n.v, n.u);
            return f < 0 && (f += 2 * Math.PI), f = s.toDeg(f), {
                L: n.L,
                C: p,
                h: f
            };
        default:
            var m = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "XYZ", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, m);
    }
}
function $9de014d0ca2dbeda$var$fromCieLch(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cieluv":
            var a = s.toRad(n.h), i = n.C * Math.cos(a), c = n.C * Math.sin(a);
            return {
                L: n.L,
                u: i,
                v: c
            };
        case "hsluv":
            if (n.L > 99.9999999) return {
                hu: n.h,
                s: 0,
                l: 100
            };
            if (n.L < 1e-8) return {
                hu: n.h,
                s: 0,
                l: 0
            };
            for(var u = (n.L + 16) / 1560896, l = u > .008856 ? u : n.L / 903.3, h = s.getTransform("INVERSE_SRGB_XYZ"), v = [], p = 0; p < 3; p++)for(var f = h[p][0], m = h[p][1], d = h[p][2], b = 0; b < 2; b++){
                var g = (284517 * f - 94839 * d) * l, y = (838422 * d + 769860 * m + 731718 * f) * n.L * l - 769860 * b * n.L, _ = (632260 * d - 126452 * m) * l + 126452 * b;
                v.push({
                    m: g / _,
                    b: y / _
                });
            }
            var M = Number.MAX_VALUE, Y = s.toRad(n.h);
            v.forEach(function(r) {
                var e = r.b / (Math.sin(Y) - r.m * Math.cos(Y));
                e >= 0 && (M = Math.min(M, e));
            });
            var L = M;
            return {
                hu: n.h,
                s: n.C / L * 100,
                l: n.L
            };
        default:
            var X = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cieluv", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, X);
    }
}
function $9de014d0ca2dbeda$var$fromCieLch$1(r, e, n) {
    var t = r.conversions, o = r.operations, s = r.helpers;
    switch(e){
        case "cielch":
            if (n.L > 99.9999999) return {
                L: 100,
                C: 0,
                h: n.hu
            };
            if (n.L < 1e-8) return {
                L: 0,
                C: 0,
                h: n.hu
            };
            for(var a = (n.l + 16) / 1560896, i = a > .008856 ? a : n.l / 903.3, c = s.getTransform("INVERSE_SRGB_XYZ"), u = [], l = 0; l < 3; l++)for(var h = c[l][0], v = c[l][1], p = c[l][2], f = 0; f < 2; f++){
                var m = (284517 * h - 94839 * p) * i, d = (838422 * p + 769860 * v + 731718 * h) * n.l * i - 769860 * f * n.l, b = (632260 * p - 126452 * v) * i + 126452 * f;
                u.push({
                    m: m / b,
                    b: d / b
                });
            }
            var g = Number.MAX_VALUE, y = s.toRad(n.hu);
            u.forEach(function(r) {
                var e = r.b / (Math.sin(y) - r.m * Math.cos(y));
                e >= 0 && (g = Math.min(g, e));
            });
            var _ = g;
            return {
                L: n.l,
                C: _ / 100 * n.s,
                h: n.hu
            };
        default:
            var M = o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, "cielch", n);
            return o.convert({
                conversions: t,
                operations: o,
                helpers: s
            }, e, M);
    }
}
function $9de014d0ca2dbeda$var$contains(r, e) {
    return Object.keys(r).every(function(r) {
        return -1 !== e.indexOf(r);
    });
}
function $9de014d0ca2dbeda$var$adapt(r, e, n, t) {
    var o = r.operations.convert(r, "XYZ", e), s = r.operations.convert(r, "lms", n);
    if (t) a = r.operations.convert(r, "lms", t);
    else var a = r.operations.convert(r, "lms", r.helpers.getIlluminant("D65"));
    var i = r.helpers.getTransform("BRADFORD"), c = r.helpers.getTransform("INVERSE_BRADFORD"), u = [
        [
            s.rho / a.rho,
            0,
            0
        ],
        [
            0,
            s.gamma / a.gamma,
            0
        ],
        [
            0,
            0,
            s.beta / a.beta
        ]
    ], l = r.helpers.matrixMultiply(c, u), h = r.helpers.matrixMultiply(l, i), v = [
        [
            o.X
        ],
        [
            o.Y
        ],
        [
            o.Z
        ]
    ], p = r.helpers.matrixMultiply(h, v), f = {
        X: p[0][0],
        Y: p[1][0],
        Z: p[2][0]
    };
    return r.helpers.ready(r, f);
}
function $9de014d0ca2dbeda$var$adjacent(r, e, n, t) {
    for(var o = r.operations.convert(r, "hsl", t), s = [
        {
            h: o.h,
            s: o.s,
            l: o.l
        }
    ], a = 0; a < n - 1; a++)o.h = r.helpers.negMod(o.h + e, 360), s.push({
        h: o.h,
        s: o.s,
        l: o.l
    });
    return r.helpers.ready(r, s);
}
function $9de014d0ca2dbeda$var$brightness(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.l += e, t.l < 0 ? t.l = 0 : t.l > 100 && (t.l = 100), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$complementary(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.h = (n.h + 180) % 360, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$contrast(r, e, n) {
    var t = r.operations.convert(r, "rgb", n);
    return t.r = 255 * ((t.r / 255 - .5) * e + .5), t.r < 0 ? t.r = 0 : t.r > 255 && (t.r = 255), t.g = 255 * ((t.g / 255 - .5) * e + .5), t.g < 0 ? t.g = 0 : t.g > 255 && (t.g = 255), t.b = 255 * ((t.b / 255 - .5) * e + .5), t.b < 0 ? t.b = 0 : t.b > 255 && (t.b = 255), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$contrastRatio(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n = (299 * n.r + 587 * n.g + 114 * n.b) / 1e3 >= 128 ? {
        r: 0,
        g: 0,
        b: 0
    } : {
        r: 255,
        g: 255,
        b: 255
    }, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$convert(r, e, n) {
    if (Object.keys(r.conversions).indexOf(e) > -1) {
        n.colour ? n = n.colour : n.colours && (n = n.colours);
        var t = r.helpers.determineMode(n);
        return t != e ? r.conversions[t].convert(r, e, n) : n;
    }
    return r.helpers.ready(r, e);
}
function $9de014d0ca2dbeda$var$difference(r, e, n, t, o) {
    t = t || 1, o = o || 1;
    var s = r.operations.convert(r, "cielab", e), a = r.operations.convert(r, "cielab", n), i = Math.sqrt(Math.pow(s.a, 2) + Math.pow(s.b, 2)), c = i - Math.sqrt(Math.pow(a.a, 2) + Math.pow(a.b, 2)), u = s.L - a.L, l = s.a - a.a, h = s.b - a.b, v = Math.sqrt(Math.pow(l, 2) + Math.pow(h, 2) - Math.pow(c, 2)), p = s.L < 16 ? .511 : .040975 * s.L / (1.01765 * s.L), f = .0638 * i / (1.0131 * i), m = Math.atan2(s.b, s.a), d = m >= 0 ? m : m + 360, b = 164 <= d && d <= 345 ? .56 + Math.abs(.2 * Math.cos(r.helpers.toRad(d + 168))) : .36 + Math.abs(.4 * Math.cos(r.helpers.toRad(d + 35))), g = Math.pow(i, 4) / (Math.pow(i, 4) + 1900), y = f * (g * b + 1 - g), _ = Math.pow(u / (t * p), 2);
    return Math.sqrt(_ + _ + _);
}
function $9de014d0ca2dbeda$var$fade(r, e, n, t) {
    var o = r.operations.convert(r, "rgb", n), s = r.operations.convert(r, "rgb", t), a = [
        o
    ];
    e -= 1;
    for(var i = (s.r - o.r) / e, c = (s.g - o.g) / e, u = (s.b - o.b) / e, l = {
        r: o.r,
        g: o.g,
        b: o.b
    }, h = 0; h < e - 1; h++)l.r = r.helpers.slopeMod(l.r + i, 255), l.g = r.helpers.slopeMod(l.g + c, 255), l.b = r.helpers.slopeMod(l.b + u, 255), a.push({
        r: l.r,
        g: l.g,
        b: l.b
    });
    return a.push(s), r.helpers.ready(r, a);
}
function $9de014d0ca2dbeda$var$greyscale(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = (n.r + n.g + n.b) / 3;
    return n = {
        r: t,
        g: t,
        b: t
    }, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$hue(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.h = r.helpers.negMod(t.h + e, 360), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$invert(r, e) {
    var n = r.operations.convert(r, "rgb", e);
    return n.r = r.helpers.negMod(255 - n.r, 255), n.g = r.helpers.negMod(255 - n.g, 255), n.b = r.helpers.negMod(255 - n.b, 255), r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$invertLightness(r, e) {
    var n = r.operations.convert(r, "hsl", e);
    return n.l = 100 - n.l, r.helpers.ready(r, n);
}
function $9de014d0ca2dbeda$var$mid(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: (t.h + o.h) / 2,
        s: (t.s + o.s) / 2,
        l: (t.l + o.l) / 2
    };
    return r.helpers.ready(r, s);
}
function $9de014d0ca2dbeda$var$multiply(r, e, n) {
    var t = r.operations.convert(r, "hsl", e), o = r.operations.convert(r, "hsl", n), s = {
        h: t.h,
        s: t.s,
        l: t.l / 100 * (o.l / 100) * 100
    };
    return s.l = s.l > 100 ? 100 : s.l, s.l = s.l < 0 ? 0 : s.l, r.helpers.ready(r, s);
}
function $9de014d0ca2dbeda$var$saturation(r, e, n) {
    var t = r.operations.convert(r, "hsl", n);
    return t.s += e, t.s < 0 ? t.s = 0 : t.s > 100 && (t.s = 100), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$sepia(r, e) {
    var n = r.operations.convert(r, "rgb", e), t = {};
    return t.r = .393 * n.r + .769 * n.g + .189 * n.b, t.g = .349 * n.r + .686 * n.g + .168 * n.b, t.b = .272 * n.r + .534 * n.g + .131 * n.b, r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$shade(r, e, n) {
    var t = r.operations.convert(r, "hsv", n);
    return t.v += e, t.v < 0 ? t.v = 0 : t.v > 100 && (t.v = 100), r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$temperature(r, e) {
    var n = r.operations.convert(r, "xyY", e), t = (n.x - .332) / (n.y - .1858);
    return -449 * Math.pow(t, 3) + 3525 * Math.pow(t, 2) - 6823.3 * t + 5520.33;
}
function $9de014d0ca2dbeda$var$tetrad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 3; o++)n.h = (n.h + 90) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
function $9de014d0ca2dbeda$var$triad(r, e) {
    for(var n = r.operations.convert(r, "hsl", e), t = [
        {
            h: n.h,
            s: n.s,
            l: n.l
        }
    ], o = 0; o < 2; o++)n.h = (n.h + 120) % 360, t.push({
        h: n.h,
        s: n.s,
        l: n.l
    });
    return r.helpers.ready(r, t);
}
var $9de014d0ca2dbeda$var$fromHex_1 = $9de014d0ca2dbeda$var$fromHex, $9de014d0ca2dbeda$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(r) {
    return typeof r;
} : function(r) {
    return r && "function" == typeof Symbol && r.constructor === Symbol && r !== Symbol.prototype ? "symbol" : typeof r;
}, $9de014d0ca2dbeda$var$slicedToArray = function() {
    function r(r, e) {
        var n = [], t = !0, o = !1, s = void 0;
        try {
            for(var a, i = r[Symbol.iterator](); !(t = (a = i.next()).done) && (n.push(a.value), !e || n.length !== e); t = !0);
        } catch (r) {
            o = !0, s = r;
        } finally{
            try {
                !t && i.return && i.return();
            } finally{
                if (o) throw s;
            }
        }
        return n;
    }
    return function(e, n) {
        if (Array.isArray(e)) return e;
        if (Symbol.iterator in Object(e)) return r(e, n);
        throw new TypeError("Invalid attempt to destructure non-iterable instance");
    };
}(), $9de014d0ca2dbeda$var$toConsumableArray = function(r) {
    if (Array.isArray(r)) {
        for(var e = 0, n = Array(r.length); e < r.length; e++)n[e] = r[e];
        return n;
    }
    return Array.from(r);
}, $9de014d0ca2dbeda$var$fromRgb_1 = $9de014d0ca2dbeda$var$fromRgb, $9de014d0ca2dbeda$var$fromCssRgb_1 = $9de014d0ca2dbeda$var$fromCssRgb, $9de014d0ca2dbeda$var$fromHsl_1 = $9de014d0ca2dbeda$var$fromHsl, $9de014d0ca2dbeda$var$fromCssHsl_1 = $9de014d0ca2dbeda$var$fromCssHsl, $9de014d0ca2dbeda$var$fromHsv_1 = $9de014d0ca2dbeda$var$fromHsv, $9de014d0ca2dbeda$var$fromCmyk_1 = $9de014d0ca2dbeda$var$fromCmyk, $9de014d0ca2dbeda$var$fromYiq_1 = $9de014d0ca2dbeda$var$fromYiq, $9de014d0ca2dbeda$var$fromXYZ_1 = $9de014d0ca2dbeda$var$fromXYZ, $9de014d0ca2dbeda$var$fromxyY_1 = $9de014d0ca2dbeda$var$fromxyY, $9de014d0ca2dbeda$var$fromLms_1 = $9de014d0ca2dbeda$var$fromLms, $9de014d0ca2dbeda$var$fromCieLab_1 = $9de014d0ca2dbeda$var$fromCieLab, $9de014d0ca2dbeda$var$fromCieLuv_1 = $9de014d0ca2dbeda$var$fromCieLuv, $9de014d0ca2dbeda$var$fromCieLch_1 = $9de014d0ca2dbeda$var$fromCieLch, $9de014d0ca2dbeda$var$fromHsluv = $9de014d0ca2dbeda$var$fromCieLch$1, $9de014d0ca2dbeda$var$index = {
    hex: {
        test: function(r) {
            return "string" == typeof r && "#" === r.slice(0, 1);
        },
        convert: $9de014d0ca2dbeda$var$fromHex_1
    },
    rgb: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "r",
                "g",
                "b"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromRgb_1
    },
    cssrgb: {
        test: function(r) {
            return "string" == typeof r && "rgb(" === r.slice(0, 4);
        },
        convert: $9de014d0ca2dbeda$var$fromCssRgb_1
    },
    hsl: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "h",
                "s",
                "l"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromHsl_1
    },
    csshsl: {
        test: function(r) {
            return "string" == typeof r && "hsl(" === r.slice(0, 4);
        },
        convert: $9de014d0ca2dbeda$var$fromCssHsl_1
    },
    hsv: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "h",
                "s",
                "v"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromHsv_1
    },
    cmyk: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "c",
                "m",
                "y",
                "k"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCmyk_1
    },
    yiq: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "y",
                "i",
                "q"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromYiq_1
    },
    XYZ: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "X",
                "Y",
                "Z"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromXYZ_1
    },
    xyY: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "x",
                "y",
                "Y"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromxyY_1
    },
    lms: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "rho",
                "gamma",
                "beta"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromLms_1
    },
    cielab: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "L",
                "a",
                "b"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCieLab_1
    },
    cieluv: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "L",
                "u",
                "v"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCieLuv_1
    },
    cielch: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "L",
                "C",
                "h"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromCieLch_1
    },
    hsluv: {
        test: function(r) {
            return $9de014d0ca2dbeda$var$contains(r, [
                "hu",
                "s",
                "l"
            ]);
        },
        convert: $9de014d0ca2dbeda$var$fromHsluv
    }
}, $9de014d0ca2dbeda$var$adapt_1 = $9de014d0ca2dbeda$var$adapt, $9de014d0ca2dbeda$var$adjacent_1 = $9de014d0ca2dbeda$var$adjacent, $9de014d0ca2dbeda$var$brightness_1 = $9de014d0ca2dbeda$var$brightness, $9de014d0ca2dbeda$var$complementary_1 = $9de014d0ca2dbeda$var$complementary, $9de014d0ca2dbeda$var$contrast_1 = $9de014d0ca2dbeda$var$contrast, $9de014d0ca2dbeda$var$contrastRatio_1 = $9de014d0ca2dbeda$var$contrastRatio, $9de014d0ca2dbeda$var$convert_1 = $9de014d0ca2dbeda$var$convert, $9de014d0ca2dbeda$var$difference_1 = $9de014d0ca2dbeda$var$difference, $9de014d0ca2dbeda$var$fade_1 = $9de014d0ca2dbeda$var$fade, $9de014d0ca2dbeda$var$greyscale_1 = $9de014d0ca2dbeda$var$greyscale, $9de014d0ca2dbeda$var$hue_1 = $9de014d0ca2dbeda$var$hue, $9de014d0ca2dbeda$var$invert_1 = $9de014d0ca2dbeda$var$invert, $9de014d0ca2dbeda$var$invertLightness_1 = $9de014d0ca2dbeda$var$invertLightness, $9de014d0ca2dbeda$var$mid_1 = $9de014d0ca2dbeda$var$mid, $9de014d0ca2dbeda$var$multiply_1 = $9de014d0ca2dbeda$var$multiply, $9de014d0ca2dbeda$var$saturation_1 = $9de014d0ca2dbeda$var$saturation, $9de014d0ca2dbeda$var$sepia_1 = $9de014d0ca2dbeda$var$sepia, $9de014d0ca2dbeda$var$shade_1 = $9de014d0ca2dbeda$var$shade, $9de014d0ca2dbeda$var$temperature_1 = $9de014d0ca2dbeda$var$temperature, $9de014d0ca2dbeda$var$tetrad_1 = $9de014d0ca2dbeda$var$tetrad, $9de014d0ca2dbeda$var$triad_1 = $9de014d0ca2dbeda$var$triad, $9de014d0ca2dbeda$var$index$2 = {
    adapt: $9de014d0ca2dbeda$var$adapt_1,
    adjacent: $9de014d0ca2dbeda$var$adjacent_1,
    brightness: $9de014d0ca2dbeda$var$brightness_1,
    complementary: $9de014d0ca2dbeda$var$complementary_1,
    contrast: $9de014d0ca2dbeda$var$contrast_1,
    contrastRatio: $9de014d0ca2dbeda$var$contrastRatio_1,
    convert: $9de014d0ca2dbeda$var$convert_1,
    difference: $9de014d0ca2dbeda$var$difference_1,
    fade: $9de014d0ca2dbeda$var$fade_1,
    greyscale: $9de014d0ca2dbeda$var$greyscale_1,
    hue: $9de014d0ca2dbeda$var$hue_1,
    invert: $9de014d0ca2dbeda$var$invert_1,
    invertLightness: $9de014d0ca2dbeda$var$invertLightness_1,
    mid: $9de014d0ca2dbeda$var$mid_1,
    multiply: $9de014d0ca2dbeda$var$multiply_1,
    saturation: $9de014d0ca2dbeda$var$saturation_1,
    sepia: $9de014d0ca2dbeda$var$sepia_1,
    shade: $9de014d0ca2dbeda$var$shade_1,
    temperature: $9de014d0ca2dbeda$var$temperature_1,
    tetrad: $9de014d0ca2dbeda$var$tetrad_1,
    triad: $9de014d0ca2dbeda$var$triad_1
}, $9de014d0ca2dbeda$var$constants = {
    ILLUMINANTS: {
        A: {
            X: 1.0985 * 100,
            Y: 100,
            Z: 35.585
        },
        B: {
            X: 99.072,
            Y: 100,
            Z: 85.223
        },
        C: {
            X: 98.074,
            Y: 100,
            Z: 118.232
        },
        D50: {
            X: 96.422,
            Y: 100,
            Z: 82.521
        },
        D55: {
            X: 95.682,
            Y: 100,
            Z: 92.149
        },
        D65: {
            X: 95.047,
            Y: 100,
            Z: 108.883
        },
        D75: {
            X: 94.972,
            Y: 100,
            Z: 122.638
        },
        E: {
            X: 100,
            Y: 100,
            Z: 100
        },
        F2: {
            X: .99186 * 100,
            Y: 100,
            Z: 67.393
        },
        F7: {
            X: 95.041,
            Y: 100,
            Z: 108.747
        },
        F11: {
            X: 1.00962 * 100,
            Y: 100,
            Z: 64.35
        }
    },
    TRANSFORMS: {
        BRADFORD: [
            [
                .8951,
                .2664,
                -0.1614
            ],
            [
                -0.7502,
                1.7135,
                .0367
            ],
            [
                .0389,
                -0.0685,
                1.0296
            ]
        ],
        INVERSE_BRADFORD: [
            [
                .9869929,
                -0.1470543,
                .1599627
            ],
            [
                .4323053,
                .5183603,
                .0492912
            ],
            [
                -0.0085287,
                .0400428,
                .9684867
            ]
        ],
        SRGB_XYZ: [
            [
                .4124,
                .3576,
                .1805
            ],
            [
                .2126,
                .7152,
                .0722
            ],
            [
                .0193,
                .1192,
                .9505
            ]
        ],
        INVERSE_SRGB_XYZ: [
            [
                3.2406,
                -1.5372,
                -0.4986
            ],
            [
                -0.9689,
                1.8758,
                .0415
            ],
            [
                .0557,
                -0.204,
                1.057
            ]
        ]
    }
}, $9de014d0ca2dbeda$var$api = function(r, e, n) {
    var t = Object.keys(r.operations).reduce(function(e, t) {
        var o = r.operations[t];
        return e[t] = function() {
            for(var e = arguments.length, t = Array(e), s = 0; s < e; s++)t[s] = arguments[s];
            var a = t.slice(0).map(function(r) {
                return "object" === (void 0 === r ? "undefined" : $9de014d0ca2dbeda$var$_typeof(r)) ? Object.assign({}, r) : r;
            });
            if (n && n.colours) return function e(n) {
                var t = n.map(function(n) {
                    if (Array.isArray(n)) {
                        var t = e(n);
                        return t.colours || t.colour;
                    }
                    var s = o.apply(void 0, [
                        r
                    ].concat($9de014d0ca2dbeda$var$toConsumableArray(a), [
                        n
                    ]));
                    return "object" === (void 0 === s ? "undefined" : $9de014d0ca2dbeda$var$_typeof(s)) ? s.colours || s.colour : s;
                });
                return "number" != typeof t[0] ? r.helpers.ready(r, t) : t;
            }(n.colours);
            return o.apply(void 0, [
                r
            ].concat($9de014d0ca2dbeda$var$toConsumableArray(a), [
                n ? n.colour : void 0
            ]));
        }, e;
    }, {});
    return n || (t = Object.assign(t, e)), t;
}, $9de014d0ca2dbeda$var$api_1 = $9de014d0ca2dbeda$var$api, $9de014d0ca2dbeda$var$helpers = {
    getIlluminant: function(r) {
        return $9de014d0ca2dbeda$var$constants.ILLUMINANTS[r];
    },
    getTransform: function(r) {
        return $9de014d0ca2dbeda$var$constants.TRANSFORMS[r];
    },
    matrixMultiply: function(r, e) {
        for(var n = [], t = 0; t < r.length; t++){
            n[t] = [];
            for(var o = 0; o < e[0].length; o++){
                for(var s = 0, a = 0; a < r[0].length; a++)s += r[t][a] * e[a][o];
                n[t][o] = s;
            }
        }
        return n;
    },
    cbrt: function(r) {
        if (Math.cbrt) return Math.cbrt(r);
        var e = Math.pow(Math.abs(r), 1 / 3);
        return r < 0 ? -e : e;
    },
    toRad: function(r) {
        return r * (Math.PI / 180);
    },
    toDeg: function(r) {
        return r * (180 / Math.PI);
    },
    negMod: function(r, e) {
        return (r % e + e) % e;
    },
    slopeMod: function(r) {
        function e(e, n) {
            return r.apply(this, arguments);
        }
        return e.toString = function() {
            return r.toString();
        }, e;
    }(function(r, e) {
        return r > 2 * e ? slopeMod(r - 2 * e, e) : r > e ? 2 * e - r : r < 0 ? slopeMod(r + 2 * e, e) : r;
    }),
    bounded: function(r, e) {
        return r < e[0] ? r = e[0] : r > e[1] && (r = e[1]), r;
    },
    boundedRgb: function(r) {
        var e = this, n = function(r) {
            return e.bounded(r, [
                0,
                255
            ]);
        };
        return {
            r: n(r.r),
            g: n(r.g),
            b: n(r.b)
        };
    },
    determineMode: function(r) {
        for(var e in $9de014d0ca2dbeda$var$index)if ($9de014d0ca2dbeda$var$index.hasOwnProperty(e) && $9de014d0ca2dbeda$var$index[e].test(r)) return e;
        return null;
    },
    ready: function(r, e) {
        var n = r.conversions, t = r.operations, o = r.helpers, s = {};
        switch(Object.prototype.toString.call(e)){
            case "[object Object]":
            case "[object String]":
                s.colour = e;
                for(var a in n)n.hasOwnProperty(a) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            o.determineMode(e);
                            return t.convert({
                                conversions: n,
                                operations: t,
                                helpers: o
                            }, r, e);
                        },
                        enumerable: !0
                    });
                }(a);
                return s = Object.assign(s, $9de014d0ca2dbeda$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9de014d0ca2dbeda$var$constants, s));
            case "[object Array]":
                s.colours = e;
                for(var i in n)n.hasOwnProperty(i) && function(r) {
                    Object.defineProperty(s, r, {
                        get: function() {
                            return function e(s) {
                                return s.map(function(s) {
                                    return Array.isArray(s) ? e(s) : t.convert({
                                        conversions: n,
                                        operations: t,
                                        helpers: o
                                    }, r, s);
                                });
                            }(e);
                        },
                        enumerable: !0
                    });
                }(i);
                return s = Object.assign(s, $9de014d0ca2dbeda$var$api_1({
                    conversions: n,
                    operations: t,
                    helpers: o
                }, $9de014d0ca2dbeda$var$constants, s));
            default:
                return null;
        }
    }
}, $9de014d0ca2dbeda$var$helpers_1 = $9de014d0ca2dbeda$var$helpers, $9de014d0ca2dbeda$var$dependencies = {
    conversions: $9de014d0ca2dbeda$var$index,
    operations: $9de014d0ca2dbeda$var$index$2,
    helpers: $9de014d0ca2dbeda$var$helpers_1
}, $9de014d0ca2dbeda$var$entry = $9de014d0ca2dbeda$var$api_1($9de014d0ca2dbeda$var$dependencies, $9de014d0ca2dbeda$var$constants);
var $9de014d0ca2dbeda$export$2e2bcd8739ae039 = $9de014d0ca2dbeda$var$entry;


function $5c1fa422fc8ac587$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c1fa422fc8ac587$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c1fa422fc8ac587$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c1fa422fc8ac587$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5c1fa422fc8ac587$export$7229be6d7219ee6a = function hexToRGBA(hex) {
    var opacity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    var rgba = $5c1fa422fc8ac587$var$_objectSpread($5c1fa422fc8ac587$var$_objectSpread({}, (0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).convert(hex).rgb), {
        a: opacity
    });
    return "rgba(".concat(Object.values(rgba).join(', '), ")");
};
var $5c1fa422fc8ac587$export$bba5a971afe05444 = function getBoxShadow(color) {
    return "0 0 0 2px ".concat(color);
};
var $5c1fa422fc8ac587$var$hex = '[a-z0-9]';
var $5c1fa422fc8ac587$var$shortHandHexColorPattern = new RegExp("#(".concat($5c1fa422fc8ac587$var$hex, ")(").concat($5c1fa422fc8ac587$var$hex, ")(").concat($5c1fa422fc8ac587$var$hex, ")"), 'i');
var $5c1fa422fc8ac587$var$repeat = function repeat(str, times) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(Array(times)).map(function() {
        return str;
    }).join('');
};
var $5c1fa422fc8ac587$var$isShortHexColor = function isShortHexColor(color) {
    return color && color.length === 4;
};
var $5c1fa422fc8ac587$var$completeHexColor = function completeHexColor(colors) {
    var hex = colors.map(function(color) {
        return $5c1fa422fc8ac587$var$repeat(color, 2);
    }).join('');
    return "#".concat(hex);
};
var $5c1fa422fc8ac587$var$completeTriplet = function completeTriplet(colors) {
    return "#".concat($5c1fa422fc8ac587$var$repeat(colors[1], 6));
};
var $5c1fa422fc8ac587$var$isTriplet = function isTriplet(colors) {
    return colors[0] === colors[1] && colors[1] === colors[2];
};
var $5c1fa422fc8ac587$export$db8d2130677f868c = function convertHexShorthand(color) {
    if ($5c1fa422fc8ac587$var$isShortHexColor(color)) {
        // when color = '#ccc', matches is structured as ['#ccc', 'c', 'c', 'c', ...]
        var matches = color.match($5c1fa422fc8ac587$var$shortHandHexColorPattern);
        if (matches) {
            var colors = matches.slice(1, 4);
            if ($5c1fa422fc8ac587$var$isTriplet(colors)) return $5c1fa422fc8ac587$var$completeTriplet(colors);
            else return $5c1fa422fc8ac587$var$completeHexColor(colors);
        }
    }
    // return the color as is when it's not hex color shorthand
    return color;
};
var $5c1fa422fc8ac587$export$10a10e7cd1193377 = function generateTextColor(color) {
    var converted = $5c1fa422fc8ac587$export$db8d2130677f868c(color);
    return (0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).contrastRatio(converted).hex;
};
var $5c1fa422fc8ac587$export$77a1051494882576 = function getContrastColor(contrastValue, opacityValue, color) {
    return $5c1fa422fc8ac587$export$7229be6d7219ee6a((0, $9de014d0ca2dbeda$export$2e2bcd8739ae039).contrast(contrastValue, color).hex, opacityValue);
};


var $ffde35be8257144f$var$defaultTheme = {
    mode: {
        create: {
            active: {
                color: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-pressed, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$b3de0ae08da2ce64), 0.8), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
                backgroundColor: "var(--ds-background-brand-bold-hovered, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$b3de0ae08da2ce64), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: '',
                backgroundColor: '',
                boxShadow: ''
            }
        },
        iconButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$7090862dc3038a9f), ")"),
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$7090862dc3038a9f), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ''
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: ''
            }
        },
        navigation: {
            backgroundColor: "var(--ds-surface, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
            color: "var(--ds-text-subtlest, ".concat((0, $5738e2919e19457f$export$f563ee71e9ee74cd), ")")
        },
        productHome: {
            backgroundColor: "var(--ds-text-brand, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
            color: "var(--ds-text, ".concat((0, $5738e2919e19457f$export$ad0bacf983b7ddaa), ")"),
            borderRight: "1px solid ".concat("var(--ds-border, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$f563ee71e9ee74cd), 0.3), ")")),
            // TODO: (DSP-1256) These colors should be moved into the Logo package
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStart: (0, $5738e2919e19457f$export$b3de0ae08da2ce64),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconGradientStop: (0, $5738e2919e19457f$export$215b7063051591f1),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
            iconColor: (0, $5738e2919e19457f$export$215b7063051591f1)
        },
        primaryButton: {
            active: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-pressed, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: ''
            },
            default: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$7090862dc3038a9f), ")"),
                backgroundColor: 'transparent',
                boxShadow: ''
            },
            focus: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$7090862dc3038a9f), ")"),
                backgroundColor: '',
                boxShadow: ''
            },
            hover: {
                color: "var(--ds-text-subtle, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-neutral-hovered, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.9), ")"),
                boxShadow: ''
            },
            selected: {
                color: "var(--ds-text-selected, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.7), ")"),
                boxShadow: '',
                borderColor: "var(--ds-border-selected, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")")
            },
            selectedHover: {
                color: "var(--ds-text-selected, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")"),
                backgroundColor: "var(--ds-background-selected-hovered, ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)((0, $5738e2919e19457f$export$226de0355ed012f8), 0.6), ")"),
                boxShadow: '',
                borderColor: "var(--ds-border-selected, ".concat((0, $5738e2919e19457f$export$b3de0ae08da2ce64), ")")
            }
        },
        search: {
            default: {
                backgroundColor: "var(--ds-background-input, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
                color: "var(--ds-text-subtlest, ".concat((0, $5738e2919e19457f$export$f563ee71e9ee74cd), ")"),
                borderColor: "var(--ds-border-input, ".concat((0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.border-checkbox_nyoiu') ? (0, $5738e2919e19457f$export$d6447c357493214f) : (0, $5738e2919e19457f$export$1ce2d1575d444ceb), ")")
            },
            focus: {
                borderColor: "var(--ds-border-focused, ".concat((0, $5738e2919e19457f$export$215b7063051591f1), ")")
            },
            hover: {
                backgroundColor: "var(--ds-background-input-hovered, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")")
            }
        },
        skeleton: {
            backgroundColor: "var(--ds-background-neutral, ".concat((0, $5738e2919e19457f$export$9fdfb749e33cdf97), ")"),
            opacity: 1
        }
    }
};
var $ffde35be8257144f$export$2491e13b198e597d = 'atlassian';
var $ffde35be8257144f$export$2e2bcd8739ae039 = $ffde35be8257144f$var$defaultTheme;





function $80737e0d5599a7a8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80737e0d5599a7a8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80737e0d5599a7a8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80737e0d5599a7a8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $80737e0d5599a7a8$var$generateOpacityValue = function generateOpacityValue(color) {
    return color === '#000000' ? 0.3 : 0.6;
};
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $80737e0d5599a7a8$var$generateButtonCSSStates = function generateButtonCSSStates(colors, buttonType) {
    var backgroundColor = colors.backgroundColor, color = colors.color, highlightColor = colors.highlightColor;
    // Add less opacity for white text so it is still legible.
    var opacityValue = $80737e0d5599a7a8$var$generateOpacityValue(color);
    var isCreateButton = buttonType === 'create';
    return {
        active: {
            backgroundColor: isCreateButton ? (0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)(backgroundColor, 0.65) : (0, $5c1fa422fc8ac587$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            boxShadow: (0, $5c1fa422fc8ac587$export$bba5a971afe05444)('transparent'),
            color: color
        },
        default: {
            backgroundColor: backgroundColor,
            boxShadow: (0, $5c1fa422fc8ac587$export$bba5a971afe05444)('transparent'),
            color: color
        },
        focus: {
            boxShadow: 'none',
            color: color,
            backgroundColor: backgroundColor
        },
        hover: {
            backgroundColor: isCreateButton ? (0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)(backgroundColor, 0.8) : (0, $5c1fa422fc8ac587$export$77a1051494882576)(0.1, opacityValue, backgroundColor),
            boxShadow: (0, $5c1fa422fc8ac587$export$bba5a971afe05444)('transparent'),
            color: color
        },
        selected: {
            color: color,
            backgroundColor: (0, $5c1fa422fc8ac587$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $5c1fa422fc8ac587$export$bba5a971afe05444)('transparent')
        },
        selectedHover: {
            color: color,
            backgroundColor: (0, $5c1fa422fc8ac587$export$77a1051494882576)(0.3, opacityValue, backgroundColor),
            borderColor: highlightColor,
            boxShadow: (0, $5c1fa422fc8ac587$export$bba5a971afe05444)('transparent')
        }
    };
};
var $80737e0d5599a7a8$var$generateCreateButtonColors = function generateCreateButtonColors(themeBackground, themeHighlight) {
    return {
        backgroundColor: themeHighlight,
        color: (0, $5c1fa422fc8ac587$export$10a10e7cd1193377)(themeHighlight),
        highlightColor: themeHighlight
    };
};
var $80737e0d5599a7a8$export$2e4ecffaca289a18 = function generateTheme(themeColors) {
    var backgroundColor = themeColors.backgroundColor, highlightColor = themeColors.highlightColor, name = themeColors.name;
    var color = (0, $5c1fa422fc8ac587$export$10a10e7cd1193377)(backgroundColor);
    var colors = $80737e0d5599a7a8$var$_objectSpread($80737e0d5599a7a8$var$_objectSpread({}, themeColors), {}, {
        color: color
    });
    if (name === (0, $ffde35be8257144f$export$2491e13b198e597d)) return 0, $ffde35be8257144f$export$2e2bcd8739ae039;
    return {
        mode: {
            create: $80737e0d5599a7a8$var$generateButtonCSSStates($80737e0d5599a7a8$var$generateCreateButtonColors(backgroundColor, highlightColor), 'create'),
            iconButton: $80737e0d5599a7a8$var$generateButtonCSSStates(colors, 'iconButton'),
            primaryButton: $80737e0d5599a7a8$var$generateButtonCSSStates(colors, 'primaryButton'),
            navigation: {
                backgroundColor: backgroundColor,
                color: color
            },
            productHome: {
                color: color,
                backgroundColor: highlightColor,
                borderRight: "1px solid ".concat((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)(color, 0.5))
            },
            search: {
                default: {
                    backgroundColor: backgroundColor,
                    color: color,
                    borderColor: (0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)(color, 0.5)
                },
                focus: {
                    borderColor: (0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)(highlightColor, 0.8),
                    boxShadow: (0, $5c1fa422fc8ac587$export$bba5a971afe05444)((0, $5c1fa422fc8ac587$export$7229be6d7219ee6a)(highlightColor, 0.5))
                },
                hover: {
                    backgroundColor: (0, $5c1fa422fc8ac587$export$77a1051494882576)(0.1, $80737e0d5599a7a8$var$generateOpacityValue(color), backgroundColor),
                    color: color
                }
            },
            skeleton: {
                backgroundColor: color,
                opacity: 0.08
            }
        }
    };
};
var $80737e0d5599a7a8$export$2e2bcd8739ae039 = $80737e0d5599a7a8$export$2e4ecffaca289a18;


var $4692d5c70ecef3eb$export$eeee8619e1b91cb0 = (0, $80737e0d5599a7a8$export$2e4ecffaca289a18)({
    name: (0, $ffde35be8257144f$export$2491e13b198e597d),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    backgroundColor: (0, $5738e2919e19457f$export$29a4f05edc054374),
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    highlightColor: (0, $5738e2919e19457f$export$b3de0ae08da2ce64)
});
var $4692d5c70ecef3eb$export$164de7ab8df77ef0 = $4692d5c70ecef3eb$export$eeee8619e1b91cb0;


var $5FkrB = parcelRequire("5FkrB");

var $0cbbe03340c55ac9$export$2c657da244d00bd6 = /*#__PURE__*/ (0, $5FkrB.createContext)((0, $4692d5c70ecef3eb$export$164de7ab8df77ef0));
var $0cbbe03340c55ac9$export$d8964aec282183a3 = $0cbbe03340c55ac9$export$2c657da244d00bd6.Provider;





var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $91a91a1bf1b7e1c6$var$safeIsNaN = Number.isNaN || function ponyfill(value) {
    return typeof value === 'number' && value !== value;
};
function $91a91a1bf1b7e1c6$var$isEqual(first, second) {
    if (first === second) return true;
    if ($91a91a1bf1b7e1c6$var$safeIsNaN(first) && $91a91a1bf1b7e1c6$var$safeIsNaN(second)) return true;
    return false;
}
function $91a91a1bf1b7e1c6$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (!$91a91a1bf1b7e1c6$var$isEqual(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function $91a91a1bf1b7e1c6$export$2e2bcd8739ae039(resultFn, isEqual) {
    if (isEqual === void 0) isEqual = $91a91a1bf1b7e1c6$var$areInputsEqual;
    var cache = null;
    function memoized() {
        var newArgs = [];
        for(var _i = 0; _i < arguments.length; _i++)newArgs[_i] = arguments[_i];
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        var lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult: lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}



var $5FkrB = parcelRequire("5FkrB");
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $adcefb868cf2fc9d$export$2e2bcd8739ae039() {}


var $f98e4bcec8e77da9$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $5FkrB.createContext)(0);
var $f98e4bcec8e77da9$export$48b383b280e20440 = /*#__PURE__*/ (0, $5FkrB.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ var $f98e4bcec8e77da9$var$LevelProvider = function LevelProvider(_ref) {
    var children = _ref.children, currentLevel = _ref.currentLevel;
    var _useContext = (0, $5FkrB.useContext)($f98e4bcec8e77da9$export$48b383b280e20440), setTopLevel = _useContext.setTopLevel;
    setTopLevel(currentLevel);
    (0, $5FkrB.useEffect)(function() {
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return function() {
            setTimeout(function() {
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f98e4bcec8e77da9$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ var $f98e4bcec8e77da9$var$LayeringProvider = function LayeringProvider(_ref2) {
    var children = _ref2.children;
    var topLevelRef = (0, $5FkrB.useRef)(0);
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            topLevelRef: topLevelRef,
            setTopLevel: function setTopLevel(level) {
                topLevelRef.current = level;
            }
        };
    }, [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f98e4bcec8e77da9$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
var $f98e4bcec8e77da9$export$a183686c3f6f4ea8 = function UNSAFE_LAYERING(_ref3) {
    var children = _ref3.children, _ref3$isDisabled = _ref3.isDisabled, isDisabled = _ref3$isDisabled === void 0 ? true : _ref3$isDisabled;
    var currentLevel = (0, $5FkrB.useContext)($f98e4bcec8e77da9$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children);
    var isNested = currentLevel > 0;
    var content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f98e4bcec8e77da9$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($f98e4bcec8e77da9$var$LayeringProvider, null, content);
};



var $5FkrB = parcelRequire("5FkrB");
var $cc0477161a7a3c78$export$3dbd3405086fec7b = $5FkrB.createContext();
var $cc0477161a7a3c78$export$cbabb21c2529b130 = $5FkrB.createContext();
function $cc0477161a7a3c78$export$d0d38e7dec7a1a61(_ref) {
    var children = _ref.children;
    var _React$useState = $5FkrB.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
    var hasUnmounted = $5FkrB.useRef(false);
    $5FkrB.useEffect(function() {
        return function() {
            hasUnmounted.current = true;
        };
    }, []);
    var handleSetReferenceNode = $5FkrB.useCallback(function(node) {
        if (!hasUnmounted.current) setReferenceNode(node);
    }, []);
    return /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$3dbd3405086fec7b.Provider, {
        value: referenceNode
    }, /*#__PURE__*/ $5FkrB.createElement($cc0477161a7a3c78$export$cbabb21c2529b130.Provider, {
        value: handleSetReferenceNode
    }, children));
}


var $5FkrB = parcelRequire("5FkrB");
var $4e6f8530dbdc4e71$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $4e6f8530dbdc4e71$var$__DEV__ = false;
var $4e6f8530dbdc4e71$var$warning = function() {};
if ($4e6f8530dbdc4e71$var$__DEV__) {
    var $4e6f8530dbdc4e71$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $4e6f8530dbdc4e71$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $4e6f8530dbdc4e71$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$4e6f8530dbdc4e71$exports = $4e6f8530dbdc4e71$var$warning;




var $5FkrB = parcelRequire("5FkrB");
var $51ef3a8e2c42379b$export$f52c55943429c8b6 = function unwrapArray(arg) {
    return Array.isArray(arg) ? arg[0] : arg;
};
var $51ef3a8e2c42379b$export$3dfa7c28635fe028 = function safeInvoke(fn) {
    if (typeof fn === 'function') {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
        return fn.apply(void 0, args);
    }
};
var $51ef3a8e2c42379b$export$4bb192c7cacf928f = function setRef(ref, node) {
    // if its a function call it
    if (typeof ref === 'function') return $51ef3a8e2c42379b$export$3dfa7c28635fe028(ref, node);
    else if (ref != null) ref.current = node;
};
var $51ef3a8e2c42379b$export$5150077fc2e7c662 = function fromEntries(entries) {
    return entries.reduce(function(acc, _ref) {
        var key = _ref[0], value = _ref[1];
        acc[key] = value;
        return acc;
    }, {});
};
var $51ef3a8e2c42379b$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5FkrB.useLayoutEffect : $5FkrB.useEffect;


function $77963faf785db48a$export$e0be378c32fb70a7(_ref) {
    var children = _ref.children, innerRef = _ref.innerRef;
    var setReferenceNode = $5FkrB.useContext((0, $cc0477161a7a3c78$export$cbabb21c2529b130));
    var refHandler = $5FkrB.useCallback(function(node) {
        (0, $51ef3a8e2c42379b$export$4bb192c7cacf928f)(innerRef, node);
        (0, $51ef3a8e2c42379b$export$3dfa7c28635fe028)(setReferenceNode, node);
    }, [
        innerRef,
        setReferenceNode
    ]); // ran on unmount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $5FkrB.useEffect(function() {
        return function() {
            return (0, $51ef3a8e2c42379b$export$4bb192c7cacf928f)(innerRef, null);
        };
    }, []);
    $5FkrB.useEffect(function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($4e6f8530dbdc4e71$exports)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
    }, [
        setReferenceNode
    ]);
    return (0, $51ef3a8e2c42379b$export$f52c55943429c8b6)(children)({
        ref: refHandler
    });
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");

var $ce35719b8fe24aa7$export$e4c79eb95c23a0da = 'atlaskit-portal-container';
var $ce35719b8fe24aa7$export$72f415121273627e = 'body > .atlaskit-portal-container';
var $ce35719b8fe24aa7$export$13f57c02915787b3 = 'atlaskit-portal';


var $783f74b8edf7ca7b$export$26ae5ca175b4ec5a = function createContainer(zIndex) {
    var container = document.createElement('div');
    container.className = (0, $ce35719b8fe24aa7$export$13f57c02915787b3);
    container.style.zIndex = "".concat(zIndex);
    return container;
};
/**
 * Returns document body element
 * @return {number} - The document body element
 */ var $783f74b8edf7ca7b$var$getBody = function getBody() {
    return document.body;
};
/**
 * Returns portal parent container. If no container exists already then it creates a new container with class name 'atlaskit-portal-container'
 * @return {Element} - The portal parent container div element
 */ var $783f74b8edf7ca7b$var$getPortalParent = function getPortalParent() {
    var parentElement = document.querySelector((0, $ce35719b8fe24aa7$export$72f415121273627e));
    if (!parentElement) {
        var parent = document.createElement('div');
        parent.className = (0, $ce35719b8fe24aa7$export$e4c79eb95c23a0da);
        // we are setting display to flex because we want each portal to create a new stacking context
        // See https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Positioning/Understanding_z_index/The_stacking_context
        parent.style.display = 'flex';
        $783f74b8edf7ca7b$var$getBody().appendChild(parent);
        return parent;
    }
    return parentElement;
};
var $783f74b8edf7ca7b$export$da99f98bf3fe55b3 = function removePortalContainer(container) {
    $783f74b8edf7ca7b$var$getPortalParent().removeChild(container);
};
var $783f74b8edf7ca7b$export$c582005add11e141 = function appendPortalContainerIfNotAppended(container) {
    if (!container.parentElement) $783f74b8edf7ca7b$var$getPortalParent().appendChild(container);
};


function $407c3f4d80e747f9$export$2e2bcd8739ae039(props) {
    var zIndex = props.zIndex, children = props.children;
    var container = (0, $5FkrB.useMemo)(function() {
        return (0, $783f74b8edf7ca7b$export$26ae5ca175b4ec5a)(zIndex);
    }, [
        zIndex
    ]);
    // This is in the render method instead of useEffect so that
    // the portal will be added to the DOM before the children render.
    // For any further changes, ensure that the container does not have a
    // parent besides the portal parent.
    (0, $783f74b8edf7ca7b$export$c582005add11e141)(container);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            (0, $783f74b8edf7ca7b$export$da99f98bf3fe55b3)(container);
        };
    }, [
        container
    ]);
    return /*#__PURE__*/ (0, $7d59b24134129acf$exports.createPortal)(children, container);
}




var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
var $accd0c7719cc05e3$export$700979bc83e7db82 = typeof window !== 'undefined' ? (0, $5FkrB.useLayoutEffect) : (0, $5FkrB.useEffect);


var $83d077a9d4e5feff$var$useIsSubsequentRender = function useIsSubsequentRender(mountStrategy) {
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), isSubsequentRender = _useState2[0], setIsSubsequentRender = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(function() {
        return mountStrategy === 'layoutEffect' ? (0, $accd0c7719cc05e3$export$700979bc83e7db82) : (0, $5FkrB.useEffect);
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState3, 1), useMountEffect = _useState4[0];
    useMountEffect(function() {
        setIsSubsequentRender(true);
    }, []);
    return isSubsequentRender;
};
var $83d077a9d4e5feff$export$2e2bcd8739ae039 = $83d077a9d4e5feff$var$useIsSubsequentRender;



var $5FkrB = parcelRequire("5FkrB");
var $5e12f7691be82ebc$export$ed5835cc67e87f72 = 'akPortalMount';
var $5e12f7691be82ebc$export$80816bd900e5bd00 = 'akPortalUnmount';


var $13d8b9306358618f$var$zIndexToName = {
    100: 'card',
    200: 'navigation',
    300: 'dialog',
    400: 'layer',
    500: 'blanket',
    510: 'modal',
    600: 'flag',
    700: 'spotlight',
    9999: 'tooltip'
};
/**
 * return layer name in Atlassian design system corresponding to given z-index
 * @param {number} zIndex - z-index value for which layer name is needed
 * @returns {LayerName | null} - The layer name for given z-index. If layer name is not found then null is returned
 */ var $13d8b9306358618f$var$getLayerName = function getLayerName(zIndex) {
    return $13d8b9306358618f$var$zIndexToName.hasOwnProperty(zIndex) ? $13d8b9306358618f$var$zIndexToName[zIndex] : null;
};
/**
 * Creates a PortalEvent object with given eventName, given zIndex and corresponding layer
 * @param {string} eventName - either of Mount or Unmount event name
 * @param {number} zIndex - z-index value which will be included in the event to be dispatched
 * @returns {PortalEvent} - The newly created PortalEvent object
 */ var $13d8b9306358618f$var$getEvent = function getEvent(eventName, zIndex) {
    var detail = {
        layer: $13d8b9306358618f$var$getLayerName(Number(zIndex)),
        zIndex: zIndex
    };
    return new CustomEvent(eventName, {
        detail: detail
    });
};
function $13d8b9306358618f$export$2e2bcd8739ae039(eventName, zIndex) {
    var event = $13d8b9306358618f$var$getEvent(eventName, zIndex);
    window.dispatchEvent(event);
}


var $e2b5db1d8b3115ec$var$useFirePortalEvent = function useFirePortalEvent(zIndex) {
    var zIndexNumber = Number(zIndex);
    (0, $5FkrB.useEffect)(function() {
        (0, $13d8b9306358618f$export$2e2bcd8739ae039)((0, $5e12f7691be82ebc$export$ed5835cc67e87f72), zIndexNumber);
        return function() {
            (0, $13d8b9306358618f$export$2e2bcd8739ae039)((0, $5e12f7691be82ebc$export$80816bd900e5bd00), zIndexNumber);
        };
    }, [
        zIndexNumber
    ]);
};
var $e2b5db1d8b3115ec$export$2e2bcd8739ae039 = $e2b5db1d8b3115ec$var$useFirePortalEvent;


function $b972fda2d5cd73a8$export$2e2bcd8739ae039(_ref) {
    var _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? 0 : _ref$zIndex, children = _ref.children, _ref$mountStrategy = _ref.mountStrategy, mountStrategy = _ref$mountStrategy === void 0 ? 'effect' : _ref$mountStrategy;
    var isSubsequentRender = (0, $83d077a9d4e5feff$export$2e2bcd8739ae039)(mountStrategy);
    (0, $e2b5db1d8b3115ec$export$2e2bcd8739ae039)(zIndex);
    return isSubsequentRender ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $407c3f4d80e747f9$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, children) : null;
}








var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $5b617c1f48263075$exports = {};
"use strict";
Object.defineProperty($5b617c1f48263075$exports, "__esModule", {
    value: true
});
$5b617c1f48263075$exports.bindAll = $5b617c1f48263075$exports.bind = void 0;
var $bae1c2098f2dd253$exports = {};
"use strict";
Object.defineProperty($bae1c2098f2dd253$exports, "__esModule", {
    value: true
});
$bae1c2098f2dd253$exports.bind = void 0;
function $bae1c2098f2dd253$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
$bae1c2098f2dd253$exports.bind = $bae1c2098f2dd253$var$bind;


Object.defineProperty($5b617c1f48263075$exports, "bind", {
    enumerable: true,
    get: function() {
        return $bae1c2098f2dd253$exports.bind;
    }
});
var $f6f23e2d6cc820f3$exports = {};
"use strict";
var $f6f23e2d6cc820f3$var$__assign = $f6f23e2d6cc820f3$exports && $f6f23e2d6cc820f3$exports.__assign || function() {
    $f6f23e2d6cc820f3$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f6f23e2d6cc820f3$var$__assign.apply(this, arguments);
};
Object.defineProperty($f6f23e2d6cc820f3$exports, "__esModule", {
    value: true
});
$f6f23e2d6cc820f3$exports.bindAll = void 0;

function $f6f23e2d6cc820f3$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, original), {
        options: $f6f23e2d6cc820f3$var$__assign($f6f23e2d6cc820f3$var$__assign({}, $f6f23e2d6cc820f3$var$toOptions(sharedOptions)), $f6f23e2d6cc820f3$var$toOptions(original.options))
    });
    return binding;
}
function $f6f23e2d6cc820f3$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $f6f23e2d6cc820f3$var$getBinding(original, sharedOptions);
        return (0, $bae1c2098f2dd253$exports.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
$f6f23e2d6cc820f3$exports.bindAll = $f6f23e2d6cc820f3$var$bindAll;


Object.defineProperty($5b617c1f48263075$exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $f6f23e2d6cc820f3$exports.bindAll;
    }
});



var $9781b722f37843eb$var$ESCAPE = 'Escape';
function $9781b722f37843eb$export$4a4bf067ea9e7886(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var _UNSAFE_useLayering = $9781b722f37843eb$export$cec37b93989366d4(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        var isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9781b722f37843eb$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $5b617c1f48263075$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $9781b722f37843eb$export$cec37b93989366d4() {
    var currentLevel = (0, $5FkrB.useContext)((0, $f98e4bcec8e77da9$export$650d12d3c2ddb8fc));
    var _useContext = (0, $5FkrB.useContext)((0, $f98e4bcec8e77da9$export$48b383b280e20440)), topLevelRef = _useContext.topLevelRef;
    var isLayerDisabled = (0, $5FkrB.useCallback)(function() {
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}






var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

function $e23a441bbff67a45$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $fae30bcfba640a43$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $fae30bcfba640a43$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $fae30bcfba640a43$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $f060345502b6b7d0$export$8960430cfd85939f = Math.max;
var $f060345502b6b7d0$export$96ec731ed4dcb222 = Math.min;
var $f060345502b6b7d0$export$2077e0241d6afd3c = Math.round;



function $b440a9b7db95e092$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $c3aa63da5ec3538b$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $b440a9b7db95e092$export$2e2bcd8739ae039)());
}


function $448fca4b88e71bae$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(element) ? (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $c3aa63da5ec3538b$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}



function $735acd4717b89a9b$export$2e2bcd8739ae039(node) {
    var win = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}




function $fd408f0f7fc6f904$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $cf1ccf76c8705f19$export$2e2bcd8739ae039(node) {
    if (node === (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(node) || !(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(node)) return (0, $735acd4717b89a9b$export$2e2bcd8739ae039)(node);
    else return (0, $fd408f0f7fc6f904$export$2e2bcd8739ae039)(node);
}


function $87e8112f115e0ba7$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}





function $1d367e31a7efd199$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $60b6a422aa1d7c27$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $448fca4b88e71bae$export$2e2bcd8739ae039)((0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element)).left + (0, $735acd4717b89a9b$export$2e2bcd8739ae039)(element).scrollLeft;
}




function $cda54693c6d70b8e$export$2e2bcd8739ae039(element) {
    return (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}


function $e48536f1c83ff3f8$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}



function $30ac1953654104c9$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $30ac1953654104c9$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(offsetParent) && $30ac1953654104c9$var$isElementScaled(offsetParent);
    var documentElement = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $e48536f1c83ff3f8$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $cf1ccf76c8705f19$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $60b6a422aa1d7c27$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}



function $940b5b44ec492788$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}





function $f854ccb3f447e492$export$2e2bcd8739ae039(element) {
    if ((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fae30bcfba640a43$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element) // fallback
    );
}





function $a5e33d0134a56fa3$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(node) && (0, $e48536f1c83ff3f8$export$2e2bcd8739ae039)(node)) return node;
    return $a5e33d0134a56fa3$export$2e2bcd8739ae039((0, $f854ccb3f447e492$export$2e2bcd8739ae039)(node));
}





function $c6726702709c9e29$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $a5e33d0134a56fa3$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $e48536f1c83ff3f8$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($c6726702709c9e29$export$2e2bcd8739ae039((0, $f854ccb3f447e492$export$2e2bcd8739ae039)(target)));
}







function $7b5c3e787e434546$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element)) >= 0;
}




function $80e068c783f2bee0$var$getTrueOffsetParent(element) {
    if (!(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $80e068c783f2bee0$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $b440a9b7db95e092$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $b440a9b7db95e092$export$2e2bcd8739ae039)());
    if (isIE && (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $f854ccb3f447e492$export$2e2bcd8739ae039)(element);
    if ((0, $fae30bcfba640a43$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $80e068c783f2bee0$export$2e2bcd8739ae039(element) {
    var window = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element);
    var offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $7b5c3e787e434546$export$2e2bcd8739ae039)(offsetParent) && (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $80e068c783f2bee0$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $80e068c783f2bee0$var$getContainingBlock(element) || window;
}


var $02ac7a7efb891b05$export$1e95b668f3b82d = 'top';
var $02ac7a7efb891b05$export$40e543e69a8b3fbb = 'bottom';
var $02ac7a7efb891b05$export$79ffe56a765070d2 = 'right';
var $02ac7a7efb891b05$export$eabcd2c8791e7bf4 = 'left';
var $02ac7a7efb891b05$export$dfb5619354ba860 = 'auto';
var $02ac7a7efb891b05$export$aec2ce47c367b8c3 = [
    $02ac7a7efb891b05$export$1e95b668f3b82d,
    $02ac7a7efb891b05$export$40e543e69a8b3fbb,
    $02ac7a7efb891b05$export$79ffe56a765070d2,
    $02ac7a7efb891b05$export$eabcd2c8791e7bf4
];
var $02ac7a7efb891b05$export$b3571188c770cc5a = 'start';
var $02ac7a7efb891b05$export$bd5df0f255a350f8 = 'end';
var $02ac7a7efb891b05$export$390fd549c5303b4d = 'clippingParents';
var $02ac7a7efb891b05$export$d7b7311ec04a3e8f = 'viewport';
var $02ac7a7efb891b05$export$ae5ab1c730825774 = 'popper';
var $02ac7a7efb891b05$export$ca50aac9f3ba507f = 'reference';
var $02ac7a7efb891b05$export$368f9a87e87fa4e1 = /*#__PURE__*/ $02ac7a7efb891b05$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []);
var $02ac7a7efb891b05$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($02ac7a7efb891b05$export$aec2ce47c367b8c3, [
    $02ac7a7efb891b05$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $02ac7a7efb891b05$export$b3571188c770cc5a,
        placement + "-" + $02ac7a7efb891b05$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $02ac7a7efb891b05$export$421679a7c3d56e = 'beforeRead';
var $02ac7a7efb891b05$export$aafa59e2e03f2942 = 'read';
var $02ac7a7efb891b05$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $02ac7a7efb891b05$export$c65e99957a05207c = 'beforeMain';
var $02ac7a7efb891b05$export$f22da7240b7add18 = 'main';
var $02ac7a7efb891b05$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $02ac7a7efb891b05$export$8d4d2d70e7d46032 = 'beforeWrite';
var $02ac7a7efb891b05$export$68d8715fc104d294 = 'write';
var $02ac7a7efb891b05$export$70a6e5159acce2e6 = 'afterWrite';
var $02ac7a7efb891b05$export$d087d3878fdf71d5 = [
    $02ac7a7efb891b05$export$421679a7c3d56e,
    $02ac7a7efb891b05$export$aafa59e2e03f2942,
    $02ac7a7efb891b05$export$6964f6c886723980,
    $02ac7a7efb891b05$export$c65e99957a05207c,
    $02ac7a7efb891b05$export$f22da7240b7add18,
    $02ac7a7efb891b05$export$bab79516f2d662fe,
    $02ac7a7efb891b05$export$8d4d2d70e7d46032,
    $02ac7a7efb891b05$export$68d8715fc104d294,
    $02ac7a7efb891b05$export$70a6e5159acce2e6
];


function $7f1e9f55695d8404$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $7f1e9f55695d8404$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $7f1e9f55695d8404$var$order(modifiers); // order based on phase
    return (0, $02ac7a7efb891b05$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $e2024b46b66a297d$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $2fb4e4733e092ed9$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $bf58442f71e0a59e$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $bf58442f71e0a59e$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $bf58442f71e0a59e$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $bf58442f71e0a59e$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $bf58442f71e0a59e$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(reference) ? (0, $c6726702709c9e29$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $c6726702709c9e29$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $c6726702709c9e29$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7f1e9f55695d8404$export$2e2bcd8739ae039)((0, $2fb4e4733e092ed9$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $30ac1953654104c9$export$2e2bcd8739ae039)(reference, (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $940b5b44ec492788$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $e2024b46b66a297d$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$bf58442f71e0a59e$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $bf58442f71e0a59e$export$8f7491d57c8f97a9 = /*#__PURE__*/ $bf58442f71e0a59e$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules



var $06f218a851c306cc$var$passive = {
    passive: true
};
function $06f218a851c306cc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $06f218a851c306cc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $06f218a851c306cc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $06f218a851c306cc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $06f218a851c306cc$var$effect,
    data: {}
};



function $41a74276d1437cf3$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $dea175e1fbb039f4$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}


function $73e81d9ee133d820$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $3c149818943b8402$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $02ac7a7efb891b05$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $02ac7a7efb891b05$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $02ac7a7efb891b05$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $73e81d9ee133d820$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $02ac7a7efb891b05$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $02ac7a7efb891b05$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}


function $e0ca49ea984cd711$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $3c149818943b8402$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $e0ca49ea984cd711$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $e0ca49ea984cd711$var$popperOffsets,
    data: {}
};










var $638a36f4ddb5d6c8$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $638a36f4ddb5d6c8$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $f060345502b6b7d0$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $638a36f4ddb5d6c8$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
    var sideY = (0, $02ac7a7efb891b05$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(popper);
            if ((0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $02ac7a7efb891b05$export$1e95b668f3b82d) || (placement === (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4) || placement === (0, $02ac7a7efb891b05$export$79ffe56a765070d2)) && variation === (0, $02ac7a7efb891b05$export$bd5df0f255a350f8)) {
            sideY = (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4) || (placement === (0, $02ac7a7efb891b05$export$1e95b668f3b82d) || placement === (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)) && variation === (0, $02ac7a7efb891b05$export$bd5df0f255a350f8)) {
            sideX = (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $638a36f4ddb5d6c8$var$unsetSides);
    var _ref4 = roundOffsets === true ? $638a36f4ddb5d6c8$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $638a36f4ddb5d6c8$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $638a36f4ddb5d6c8$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $638a36f4ddb5d6c8$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $638a36f4ddb5d6c8$var$computeStyles,
    data: {}
};




// and applies them to the HTMLElements such as popper and arrow
function $69e846f9616ad096$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) || !(0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $69e846f9616ad096$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) || !(0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $69e846f9616ad096$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $69e846f9616ad096$var$applyStyles,
    effect: $69e846f9616ad096$var$effect,
    requires: [
        'computeStyles'
    ]
};




function $f7552b997e91c31f$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4),
        (0, $02ac7a7efb891b05$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4),
        (0, $02ac7a7efb891b05$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $f7552b997e91c31f$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $02ac7a7efb891b05$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $f7552b997e91c31f$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $f7552b997e91c31f$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $f7552b997e91c31f$var$offset
};


var $2eeb6ba489107ea4$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $2eeb6ba489107ea4$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $2eeb6ba489107ea4$var$hash[matched];
    });
}



var $5ff3c44405c30b93$var$hash = {
    start: 'end',
    end: 'start'
};
function $5ff3c44405c30b93$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $5ff3c44405c30b93$var$hash[matched];
    });
}







function $965d83c411363a82$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $e23a441bbff67a45$export$2e2bcd8739ae039)(element);
    var html = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $c3aa63da5ec3538b$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $60b6a422aa1d7c27$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $867d6f9773686e85$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $735acd4717b89a9b$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $f060345502b6b7d0$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $f060345502b6b7d0$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $60b6a422aa1d7c27$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $f060345502b6b7d0$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}










function $f16668aaebdec374$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fae30bcfba640a43$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $9ddda9cf12580473$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $08bb5a68a7569dd1$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $02ac7a7efb891b05$export$d7b7311ec04a3e8f) ? (0, $9ddda9cf12580473$export$2e2bcd8739ae039)((0, $965d83c411363a82$export$2e2bcd8739ae039)(element, strategy)) : (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(clippingParent) ? $08bb5a68a7569dd1$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $9ddda9cf12580473$export$2e2bcd8739ae039)((0, $867d6f9773686e85$export$2e2bcd8739ae039)((0, $1d367e31a7efd199$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $08bb5a68a7569dd1$var$getClippingParents(element) {
    var clippingParents = (0, $c6726702709c9e29$export$2e2bcd8739ae039)((0, $f854ccb3f447e492$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $cda54693c6d70b8e$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fae30bcfba640a43$export$1b3bfaa9684536aa)(element) ? (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(clippingParent) && (0, $f16668aaebdec374$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $87e8112f115e0ba7$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $08bb5a68a7569dd1$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $08bb5a68a7569dd1$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $f060345502b6b7d0$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $f060345502b6b7d0$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $08bb5a68a7569dd1$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $9f77d3f4875fb909$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $0f8bbf2cee5893df$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $9f77d3f4875fb909$export$2e2bcd8739ae039)(), paddingObject);
}


function $521ed68a58dda134$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


function $76513b0dab162e77$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $02ac7a7efb891b05$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $02ac7a7efb891b05$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $02ac7a7efb891b05$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $0f8bbf2cee5893df$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $521ed68a58dda134$export$2e2bcd8739ae039)(padding, (0, $02ac7a7efb891b05$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $02ac7a7efb891b05$export$ae5ab1c730825774) ? (0, $02ac7a7efb891b05$export$ca50aac9f3ba507f) : (0, $02ac7a7efb891b05$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $08bb5a68a7569dd1$export$2e2bcd8739ae039)((0, $fae30bcfba640a43$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $1d367e31a7efd199$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $448fca4b88e71bae$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $3c149818943b8402$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $9ddda9cf12580473$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $02ac7a7efb891b05$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $02ac7a7efb891b05$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $02ac7a7efb891b05$export$79ffe56a765070d2),
                (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
                (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $12122352a478c0c2$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $02ac7a7efb891b05$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $02ac7a7efb891b05$export$368f9a87e87fa4e1) : (0, $02ac7a7efb891b05$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $02ac7a7efb891b05$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(placement) {
    if ((0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement) === (0, $02ac7a7efb891b05$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(placement);
    return [
        (0, $5ff3c44405c30b93$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $5ff3c44405c30b93$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $a8d612a7f4de3fca$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $a8d612a7f4de3fca$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement) === (0, $02ac7a7efb891b05$export$dfb5619354ba860) ? (0, $12122352a478c0c2$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(placement) === (0, $02ac7a7efb891b05$export$b3571188c770cc5a);
        var isVertical = [
            (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
            (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $02ac7a7efb891b05$export$79ffe56a765070d2) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $2eeb6ba489107ea4$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $a8d612a7f4de3fca$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $a8d612a7f4de3fca$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};





function $1d862fcd66e44014$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}



function $8124b495417018b8$export$f28d906d67a997f3(min, value, max) {
    return (0, $f060345502b6b7d0$export$8960430cfd85939f)(min, (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(value, max));
}
function $8124b495417018b8$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $8124b495417018b8$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}








function $ca1d8fd29157d544$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $dea175e1fbb039f4$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $73e81d9ee133d820$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $1d862fcd66e44014$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $02ac7a7efb891b05$export$1e95b668f3b82d) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $02ac7a7efb891b05$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $02ac7a7efb891b05$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $940b5b44ec492788$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $9f77d3f4875fb909$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $8124b495417018b8$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $8124b495417018b8$export$f28d906d67a997f3)(tether ? (0, $f060345502b6b7d0$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $f060345502b6b7d0$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $02ac7a7efb891b05$export$1e95b668f3b82d) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
            (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $8124b495417018b8$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $8124b495417018b8$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $ca1d8fd29157d544$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $ca1d8fd29157d544$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};











var $14141253d5c51d60$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $0f8bbf2cee5893df$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $521ed68a58dda134$export$2e2bcd8739ae039)(padding, (0, $02ac7a7efb891b05$export$aec2ce47c367b8c3)));
};
function $14141253d5c51d60$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $41a74276d1437cf3$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $73e81d9ee133d820$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4),
        (0, $02ac7a7efb891b05$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $14141253d5c51d60$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $940b5b44ec492788$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $02ac7a7efb891b05$export$1e95b668f3b82d) : (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb) : (0, $02ac7a7efb891b05$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $80e068c783f2bee0$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $8124b495417018b8$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $14141253d5c51d60$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $f16668aaebdec374$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $14141253d5c51d60$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $14141253d5c51d60$var$arrow,
    effect: $14141253d5c51d60$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};




function $caae528698324902$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $caae528698324902$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $02ac7a7efb891b05$export$1e95b668f3b82d),
        (0, $02ac7a7efb891b05$export$79ffe56a765070d2),
        (0, $02ac7a7efb891b05$export$40e543e69a8b3fbb),
        (0, $02ac7a7efb891b05$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $caae528698324902$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $76513b0dab162e77$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $caae528698324902$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $caae528698324902$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $caae528698324902$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $caae528698324902$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $caae528698324902$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $caae528698324902$var$hide
};




var $d07b3555e5780154$export$d34966752335dd47 = [
    (0, $06f218a851c306cc$export$2e2bcd8739ae039),
    (0, $e0ca49ea984cd711$export$2e2bcd8739ae039),
    (0, $638a36f4ddb5d6c8$export$2e2bcd8739ae039),
    (0, $69e846f9616ad096$export$2e2bcd8739ae039),
    (0, $f7552b997e91c31f$export$2e2bcd8739ae039),
    (0, $a8d612a7f4de3fca$export$2e2bcd8739ae039),
    (0, $ca1d8fd29157d544$export$2e2bcd8739ae039),
    (0, $14141253d5c51d60$export$2e2bcd8739ae039),
    (0, $caae528698324902$export$2e2bcd8739ae039)
];
var $d07b3555e5780154$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $bf58442f71e0a59e$export$ed5e13716264f202)({
    defaultModifiers: $d07b3555e5780154$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


var $99c19f4408065da5$exports = {};
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var $99c19f4408065da5$var$hasElementType = typeof Element !== 'undefined';
var $99c19f4408065da5$var$hasMap = typeof Map === 'function';
var $99c19f4408065da5$var$hasSet = typeof Set === 'function';
var $99c19f4408065da5$var$hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function $99c19f4408065da5$var$equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!$99c19f4408065da5$var$equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if ($99c19f4408065da5$var$hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!$99c19f4408065da5$var$equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if ($99c19f4408065da5$var$hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if ($99c19f4408065da5$var$hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if ($99c19f4408065da5$var$hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!$99c19f4408065da5$var$equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
$99c19f4408065da5$exports = function isEqual(a, b) {
    try {
        return $99c19f4408065da5$var$equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};



var $0ca28497a8a04ea7$var$EMPTY_MODIFIERS = [];
var $0ca28497a8a04ea7$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
    if (options === void 0) options = {};
    var prevOptions = $5FkrB.useRef(null);
    var optionsWithDefaults = {
        onFirstUpdate: options.onFirstUpdate,
        placement: options.placement || 'bottom',
        strategy: options.strategy || 'absolute',
        modifiers: options.modifiers || $0ca28497a8a04ea7$var$EMPTY_MODIFIERS
    };
    var _React$useState = $5FkrB.useState({
        styles: {
            popper: {
                position: optionsWithDefaults.strategy,
                left: '0',
                top: '0'
            },
            arrow: {
                position: 'absolute'
            }
        },
        attributes: {}
    }), state = _React$useState[0], setState = _React$useState[1];
    var updateStateModifier = $5FkrB.useMemo(function() {
        return {
            name: 'updateState',
            enabled: true,
            phase: 'write',
            fn: function fn(_ref) {
                var state = _ref.state;
                var elements = Object.keys(state.elements);
                $7d59b24134129acf$exports.flushSync(function() {
                    setState({
                        styles: (0, $51ef3a8e2c42379b$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.styles[element] || {}
                            ];
                        })),
                        attributes: (0, $51ef3a8e2c42379b$export$5150077fc2e7c662)(elements.map(function(element) {
                            return [
                                element,
                                state.attributes[element]
                            ];
                        }))
                    });
                });
            },
            requires: [
                'computeStyles'
            ]
        };
    }, []);
    var popperOptions = $5FkrB.useMemo(function() {
        var newOptions = {
            onFirstUpdate: optionsWithDefaults.onFirstUpdate,
            placement: optionsWithDefaults.placement,
            strategy: optionsWithDefaults.strategy,
            modifiers: [].concat(optionsWithDefaults.modifiers, [
                updateStateModifier,
                {
                    name: 'applyStyles',
                    enabled: false
                }
            ])
        };
        if ((0, (/*@__PURE__*/$parcel$interopDefault($99c19f4408065da5$exports)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
        else {
            prevOptions.current = newOptions;
            return newOptions;
        }
    }, [
        optionsWithDefaults.onFirstUpdate,
        optionsWithDefaults.placement,
        optionsWithDefaults.strategy,
        optionsWithDefaults.modifiers,
        updateStateModifier
    ]);
    var popperInstanceRef = $5FkrB.useRef();
    (0, $51ef3a8e2c42379b$export$700979bc83e7db82)(function() {
        if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
    }, [
        popperOptions
    ]);
    (0, $51ef3a8e2c42379b$export$700979bc83e7db82)(function() {
        if (referenceElement == null || popperElement == null) return;
        var createPopper = options.createPopper || (0, $d07b3555e5780154$export$8f7491d57c8f97a9);
        var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
        popperInstanceRef.current = popperInstance;
        return function() {
            popperInstance.destroy();
            popperInstanceRef.current = null;
        };
    }, [
        referenceElement,
        popperElement,
        options.createPopper
    ]);
    return {
        state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
        styles: state.styles,
        attributes: state.attributes,
        update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
        forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
    };
};


var $f9e8ed8665cc0109$var$NOOP = function NOOP() {
    return void 0;
};
var $f9e8ed8665cc0109$var$NOOP_PROMISE = function NOOP_PROMISE() {
    return Promise.resolve(null);
};
var $f9e8ed8665cc0109$var$EMPTY_MODIFIERS = [];
function $f9e8ed8665cc0109$export$badac9ada3a0bdf9(_ref) {
    var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $f9e8ed8665cc0109$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
    var referenceNode = $5FkrB.useContext((0, $cc0477161a7a3c78$export$3dbd3405086fec7b));
    var _React$useState = $5FkrB.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
    var _React$useState2 = $5FkrB.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
    $5FkrB.useEffect(function() {
        (0, $51ef3a8e2c42379b$export$4bb192c7cacf928f)(innerRef, popperElement);
    }, [
        innerRef,
        popperElement
    ]);
    var options = $5FkrB.useMemo(function() {
        return {
            placement: placement,
            strategy: strategy,
            onFirstUpdate: onFirstUpdate,
            modifiers: [].concat(modifiers, [
                {
                    name: 'arrow',
                    enabled: arrowElement != null,
                    options: {
                        element: arrowElement
                    }
                }
            ])
        };
    }, [
        placement,
        strategy,
        onFirstUpdate,
        modifiers,
        arrowElement
    ]);
    var _usePopper = (0, $0ca28497a8a04ea7$export$f4d5bf230a36dd6e)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
    var childrenProps = $5FkrB.useMemo(function() {
        return {
            ref: setPopperElement,
            style: styles.popper,
            placement: state ? state.placement : placement,
            hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
            isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
            arrowProps: {
                style: styles.arrow,
                ref: setArrowElement
            },
            forceUpdate: forceUpdate || $f9e8ed8665cc0109$var$NOOP,
            update: update || $f9e8ed8665cc0109$var$NOOP_PROMISE
        };
    }, [
        setPopperElement,
        setArrowElement,
        placement,
        state,
        styles,
        update,
        forceUpdate
    ]);
    return (0, $51ef3a8e2c42379b$export$f52c55943429c8b6)(children)(childrenProps);
}



// Export types from PopperJS / React Popper
var $42e5b75ea169c552$var$constantModifiers = [
    {
        name: 'flip',
        options: {
            flipVariations: false,
            padding: 5,
            boundary: 'clippingParents',
            rootBoundary: 'viewport'
        }
    },
    {
        name: 'preventOverflow',
        options: {
            padding: 5,
            rootBoundary: 'document'
        }
    }
];
function $42e5b75ea169c552$var$defaultChildrenFn() {
    return null;
}
var $42e5b75ea169c552$var$defaultOffset = [
    0,
    8
];
function $42e5b75ea169c552$export$badac9ada3a0bdf9(_ref) {
    var _ref$children = _ref.children, children = _ref$children === void 0 ? $42e5b75ea169c552$var$defaultChildrenFn : _ref$children, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? $42e5b75ea169c552$var$defaultOffset : _ref$offset, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom-start' : _ref$placement, _ref$referenceElement = _ref.referenceElement, referenceElement = _ref$referenceElement === void 0 ? undefined : _ref$referenceElement, modifiers = _ref.modifiers, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy;
    var _offset = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(offset, 2), offsetX = _offset[0], offsetY = _offset[1];
    // Merge a new offset modifier only if new offset values passed in
    var internalModifiers = (0, $5FkrB.useMemo)(function() {
        var offsetModifier = {
            name: 'offset',
            options: {
                offset: [
                    offsetX,
                    offsetY
                ]
            }
        };
        return [].concat($42e5b75ea169c552$var$constantModifiers, [
            offsetModifier
        ]);
    }, [
        offsetX,
        offsetY
    ]);
    // Merge custom props and memoize
    var mergedModifiers = (0, $5FkrB.useMemo)(function() {
        if (modifiers == null) return internalModifiers;
        return [].concat((0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(internalModifiers), (0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(modifiers));
    }, [
        internalModifiers,
        modifiers
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $f9e8ed8665cc0109$export$badac9ada3a0bdf9), {
        modifiers: mergedModifiers,
        placement: placement,
        strategy: strategy,
        referenceElement: referenceElement
    }, children);
}






var $5FkrB = parcelRequire("5FkrB");
var $a7edaecb351c1789$export$51eddd7655ca235a = function RepositionOnUpdate(_ref) {
    var children = _ref.children, update = _ref.update;
    // Ref used here to skip update on first render (when refs haven't been set)
    var isFirstRenderRef = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useLayoutEffect)(function() {
        if (isFirstRenderRef.current) {
            isFirstRenderRef.current = false;
            return;
        }
        // callback function from popper that repositions pop-up on content Update
        update();
    }, [
        update
    ]);
    // wrapping in fragment to make TS happy (known issue with FC returning children)
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, children);
};



var $5FkrB = parcelRequire("5FkrB");



var $ead5479bf2690ca1$export$92dae2778ae88f9d = function useCloseManager(_ref) {
    var isOpen = _ref.isOpen, onClose = _ref.onClose, popupRef = _ref.popupRef, triggerRef = _ref.triggerRef, capture = _ref.shouldUseCaptureOnOutsideClick;
    var _UNSAFE_useLayering = (0, $9781b722f37843eb$export$cec37b93989366d4)(), isLayerDisabled = _UNSAFE_useLayering.isLayerDisabled;
    (0, $5FkrB.useEffect)(function() {
        if (!isOpen || !popupRef) return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        var closePopup = function closePopup(event) {
            if (onClose) onClose(event);
        };
        // This check is required for cases where components like
        // Select or DDM are placed inside a Popup. A click
        // on a MenuItem or Option would close the Popup, without registering
        // a click on DDM/Select.
        // Users would have to call `onClose` manually to close the Popup in these cases.
        // You can see the bug in action here:
        // https://codesandbox.io/s/atlaskitpopup-default-forked-2eb87?file=/example.tsx:0-1788
        var onClick = function onClick(event) {
            var target = event.target;
            var doesDomNodeExist = document.body.contains(target);
            if (!doesDomNodeExist) return;
            var isClickOnPopup = popupRef && popupRef.contains(target);
            var isClickOnTrigger = triggerRef && triggerRef.contains(target);
            if (!isClickOnPopup && !isClickOnTrigger) closePopup(event);
        };
        var onKeyDown = function onKeyDown(event) {
            if (isLayerDisabled()) return;
            var key = event.key;
            if (key === 'Escape' || key === 'Esc') closePopup(event);
        };
        var unbind = (0, $5b617c1f48263075$exports.bindAll)(window, [
            {
                type: 'click',
                listener: onClick,
                options: {
                    capture: capture
                }
            },
            {
                type: 'keydown',
                listener: onKeyDown
            }
        ]);
        return unbind;
    }, [
        isOpen,
        onClose,
        popupRef,
        triggerRef,
        capture,
        isLayerDisabled
    ]);
};



var $5FkrB = parcelRequire("5FkrB");
var $8161d9da2c93c765$exports = {};
var $fe654298f8d91f4b$exports = {};
$fe654298f8d91f4b$exports = function(el, options) {
    options = options || {};
    var elementDocument = el.ownerDocument || el;
    var basicTabbables = [];
    var orderedTabbables = [];
    // A node is "available" if
    // - it's computed style
    var isUnavailable = $fe654298f8d91f4b$var$createIsUnavailable(elementDocument);
    var candidateSelectors = [
        'input',
        'select',
        'a[href]',
        'textarea',
        'button',
        '[tabindex]'
    ];
    var candidates = el.querySelectorAll(candidateSelectors.join(','));
    if (options.includeContainer) {
        var matches = Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
        if (candidateSelectors.some(function(candidateSelector) {
            return matches.call(el, candidateSelector);
        })) {
            candidates = Array.prototype.slice.apply(candidates);
            candidates.unshift(el);
        }
    }
    var candidate, candidateIndexAttr, candidateIndex;
    for(var i = 0, l = candidates.length; i < l; i++){
        candidate = candidates[i];
        candidateIndexAttr = parseInt(candidate.getAttribute('tabindex'), 10);
        candidateIndex = isNaN(candidateIndexAttr) ? candidate.tabIndex : candidateIndexAttr;
        if (candidateIndex < 0 || candidate.tagName === 'INPUT' && candidate.type === 'hidden' || candidate.disabled || isUnavailable(candidate, elementDocument)) continue;
        if (candidateIndex === 0) basicTabbables.push(candidate);
        else orderedTabbables.push({
            index: i,
            tabIndex: candidateIndex,
            node: candidate
        });
    }
    var tabbableNodes = orderedTabbables.sort(function(a, b) {
        return a.tabIndex === b.tabIndex ? a.index - b.index : a.tabIndex - b.tabIndex;
    }).map(function(a) {
        return a.node;
    });
    Array.prototype.push.apply(tabbableNodes, basicTabbables);
    return tabbableNodes;
};
function $fe654298f8d91f4b$var$createIsUnavailable(elementDocument) {
    // Node cache must be refreshed on every check, in case
    // the content of the element has changed
    var isOffCache = [];
    // "off" means `display: none;`, as opposed to "hidden",
    // which means `visibility: hidden;`. getComputedStyle
    // accurately reflects visiblity in context but not
    // "off" state, so we need to recursively check parents.
    function isOff(node, nodeComputedStyle) {
        if (node === elementDocument.documentElement) return false;
        // Find the cached node (Array.prototype.find not available in IE9)
        for(var i = 0, length = isOffCache.length; i < length; i++){
            if (isOffCache[i][0] === node) return isOffCache[i][1];
        }
        nodeComputedStyle = nodeComputedStyle || elementDocument.defaultView.getComputedStyle(node);
        var result = false;
        if (nodeComputedStyle.display === 'none') result = true;
        else if (node.parentNode) result = isOff(node.parentNode);
        isOffCache.push([
            node,
            result
        ]);
        return result;
    }
    return function isUnavailable(node) {
        if (node === elementDocument.documentElement) return false;
        var computedStyle = elementDocument.defaultView.getComputedStyle(node);
        if (isOff(node, computedStyle)) return true;
        return computedStyle.visibility === 'hidden';
    };
}


var $8161d9da2c93c765$var$listeningFocusTrap = null;
function $8161d9da2c93c765$var$focusTrap(element, userOptions) {
    var tabbableNodes = [];
    var firstTabbableNode = null;
    var lastTabbableNode = null;
    var nodeFocusedBeforeActivation = null;
    var active = false;
    var paused = false;
    var tabEvent = null;
    var container = typeof element === 'string' ? document.querySelector(element) : element;
    var config = userOptions || {};
    config.returnFocusOnDeactivate = userOptions && userOptions.returnFocusOnDeactivate !== undefined ? userOptions.returnFocusOnDeactivate : true;
    config.escapeDeactivates = userOptions && userOptions.escapeDeactivates !== undefined ? userOptions.escapeDeactivates : true;
    var trap = {
        activate: activate,
        deactivate: deactivate,
        pause: pause,
        unpause: unpause
    };
    return trap;
    function activate(activateOptions) {
        if (active) return;
        var defaultedActivateOptions = {
            onActivate: activateOptions && activateOptions.onActivate !== undefined ? activateOptions.onActivate : config.onActivate
        };
        active = true;
        paused = false;
        nodeFocusedBeforeActivation = document.activeElement;
        if (defaultedActivateOptions.onActivate) defaultedActivateOptions.onActivate();
        addListeners();
        return trap;
    }
    function deactivate(deactivateOptions) {
        if (!active) return;
        var defaultedDeactivateOptions = {
            returnFocus: deactivateOptions && deactivateOptions.returnFocus !== undefined ? deactivateOptions.returnFocus : config.returnFocusOnDeactivate,
            onDeactivate: deactivateOptions && deactivateOptions.onDeactivate !== undefined ? deactivateOptions.onDeactivate : config.onDeactivate
        };
        removeListeners();
        if (defaultedDeactivateOptions.onDeactivate) defaultedDeactivateOptions.onDeactivate();
        if (defaultedDeactivateOptions.returnFocus) setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(nodeFocusedBeforeActivation);
        }, 0);
        active = false;
        paused = false;
        return this;
    }
    function pause() {
        if (paused || !active) return;
        paused = true;
        removeListeners();
    }
    function unpause() {
        if (!paused || !active) return;
        paused = false;
        addListeners();
    }
    function addListeners() {
        if (!active) return;
        // There can be only one listening focus trap at a time
        if ($8161d9da2c93c765$var$listeningFocusTrap) $8161d9da2c93c765$var$listeningFocusTrap.pause();
        $8161d9da2c93c765$var$listeningFocusTrap = trap;
        updateTabbableNodes();
        // Ensure that the focused element doesn't capture the event that caused the focus trap activation
        setTimeout(function() {
            $8161d9da2c93c765$var$tryFocus(firstFocusNode());
        }, 0);
        document.addEventListener('focus', checkFocus, true);
        document.addEventListener('click', checkClick, true);
        document.addEventListener('mousedown', checkPointerDown, true);
        document.addEventListener('touchstart', checkPointerDown, true);
        document.addEventListener('keydown', checkKey, true);
        return trap;
    }
    function removeListeners() {
        if (!active || $8161d9da2c93c765$var$listeningFocusTrap !== trap) return;
        document.removeEventListener('focus', checkFocus, true);
        document.removeEventListener('click', checkClick, true);
        document.removeEventListener('mousedown', checkPointerDown, true);
        document.removeEventListener('touchstart', checkPointerDown, true);
        document.removeEventListener('keydown', checkKey, true);
        $8161d9da2c93c765$var$listeningFocusTrap = null;
        return trap;
    }
    function getNodeForOption(optionName) {
        var optionValue = config[optionName];
        var node = optionValue;
        if (!optionValue) return null;
        if (typeof optionValue === 'string') {
            node = document.querySelector(optionValue);
            if (!node) throw new Error('`' + optionName + '` refers to no known node');
        }
        if (typeof optionValue === 'function') {
            node = optionValue();
            if (!node) throw new Error('`' + optionName + '` did not return a node');
        }
        return node;
    }
    function firstFocusNode() {
        var node;
        if (getNodeForOption('initialFocus') !== null) node = getNodeForOption('initialFocus');
        else if (container.contains(document.activeElement)) node = document.activeElement;
        else node = tabbableNodes[0] || getNodeForOption('fallbackFocus');
        if (!node) throw new Error('You can\'t have a focus-trap without at least one focusable element');
        return node;
    }
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event
    function checkPointerDown(e) {
        if (config.clickOutsideDeactivates && !container.contains(e.target)) deactivate({
            returnFocus: false
        });
    }
    function checkClick(e) {
        if (config.clickOutsideDeactivates) return;
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    }
    function checkFocus(e) {
        if (container.contains(e.target)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
        // Checking for a blur method here resolves a Firefox issue (#15)
        if (typeof e.target.blur === 'function') e.target.blur();
        if (tabEvent) readjustFocus(tabEvent);
    }
    function checkKey(e) {
        if (e.key === 'Tab' || e.keyCode === 9) handleTab(e);
        if (config.escapeDeactivates !== false && $8161d9da2c93c765$var$isEscapeEvent(e)) deactivate();
    }
    function handleTab(e) {
        updateTabbableNodes();
        if (e.target.hasAttribute('tabindex') && Number(e.target.getAttribute('tabindex')) < 0) return tabEvent = e;
        e.preventDefault();
        var currentFocusIndex = tabbableNodes.indexOf(e.target);
        if (e.shiftKey) {
            if (e.target === firstTabbableNode || tabbableNodes.indexOf(e.target) === -1) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
            return $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex - 1]);
        }
        if (e.target === lastTabbableNode) return $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
        $8161d9da2c93c765$var$tryFocus(tabbableNodes[currentFocusIndex + 1]);
    }
    function updateTabbableNodes() {
        tabbableNodes = $fe654298f8d91f4b$exports(container);
        firstTabbableNode = tabbableNodes[0];
        lastTabbableNode = tabbableNodes[tabbableNodes.length - 1];
    }
    function readjustFocus(e) {
        if (e.shiftKey) return $8161d9da2c93c765$var$tryFocus(lastTabbableNode);
        $8161d9da2c93c765$var$tryFocus(firstTabbableNode);
    }
}
function $8161d9da2c93c765$var$isEscapeEvent(e) {
    return e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
}
function $8161d9da2c93c765$var$tryFocus(node) {
    if (!node || !node.focus) return;
    if (node === document.activeElement) return;
    node.focus();
    if (node.tagName.toLowerCase() === 'input') node.select();
}
$8161d9da2c93c765$exports = $8161d9da2c93c765$var$focusTrap;



var $984b16538a2886c6$export$10c5169755ce7bd7 = function useFocusManager(_ref) {
    var initialFocusRef = _ref.initialFocusRef, popupRef = _ref.popupRef;
    (0, $5FkrB.useEffect)(function() {
        if (!popupRef) return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        var trapConfig = {
            clickOutsideDeactivates: true,
            escapeDeactivates: true,
            initialFocus: initialFocusRef || popupRef,
            fallbackFocus: popupRef,
            returnFocusOnDeactivate: true
        };
        var focusTrap = (0, (/*@__PURE__*/$parcel$interopDefault($8161d9da2c93c765$exports)))(popupRef, trapConfig);
        var frameId = null;
        // wait for the popup to reposition itself before we focus
        frameId = requestAnimationFrame(function() {
            frameId = null;
            focusTrap.activate();
        });
        return function() {
            if (frameId != null) {
                cancelAnimationFrame(frameId);
                frameId = null;
            }
            focusTrap.deactivate();
        };
    }, [
        popupRef,
        initialFocusRef
    ]);
};


var $01e0383d73d1296a$var$_excluded = [
    "shouldRenderToParent",
    "children"
];
var $01e0383d73d1296a$var$_css;
var $01e0383d73d1296a$var$popupStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)(($01e0383d73d1296a$var$_css = {
    display: 'block',
    boxSizing: 'border-box',
    zIndex: (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).layer(),
    flex: '1 1 auto',
    backgroundColor: "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: "var(--ds-shadow-overlay, ".concat("0 4px 8px -2px ".concat((0, $5738e2919e19457f$export$7d3359664e8bb0e5), ", 0 0 1px ").concat((0, $5738e2919e19457f$export$d2d3bedfb276cac0)), ")")
}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($01e0383d73d1296a$var$_css, (0, $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa), "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")")), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($01e0383d73d1296a$var$_css, ':focus', {
    outline: 'none'
}), $01e0383d73d1296a$var$_css));
var $01e0383d73d1296a$var$popupOverflowStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    overflow: 'auto'
});
// disables iframe pointer events while popup is open, except if iframe is nested inside popup
// solves an issue of popup not being closed on iframe click
var $01e0383d73d1296a$var$blockPointerEventsOnExternalIframeStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'iframe:not([data-ds--level] iframe)': {
        pointerEvents: 'none'
    }
});
var $01e0383d73d1296a$var$DefaultPopupComponent = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var shouldRenderToParent = props.shouldRenderToParent, children = props.children, htmlAttributes = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(props, $01e0383d73d1296a$var$_excluded);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        css: [
            $01e0383d73d1296a$var$popupStyles,
            !shouldRenderToParent && $01e0383d73d1296a$var$popupOverflowStyles
        ]
    }, htmlAttributes, {
        ref: ref
    }), children);
});
function $01e0383d73d1296a$var$PopperWrapper(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, content = _ref.content, fallbackPlacements = _ref.fallbackPlacements, onClose = _ref.onClose, boundary = _ref.boundary, rootBoundary = _ref.rootBoundary, shouldFlip = _ref.shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, _ref$popupComponent = _ref.popupComponent, PopupContainer = _ref$popupComponent === void 0 ? $01e0383d73d1296a$var$DefaultPopupComponent : _ref$popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, triggerRef = _ref.triggerRef, shouldUseCaptureOnOutsideClick = _ref.shouldUseCaptureOnOutsideClick, shouldRenderToParent = _ref.shouldRenderToParent;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), popupRef = _useState2[0], setPopupRef = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(null), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState3, 2), initialFocusRef = _useState4[0], setInitialFocusRef = _useState4[1];
    (0, $984b16538a2886c6$export$10c5169755ce7bd7)({
        initialFocusRef: initialFocusRef,
        popupRef: popupRef
    });
    (0, $ead5479bf2690ca1$export$92dae2778ae88f9d)({
        isOpen: isOpen,
        onClose: onClose,
        popupRef: popupRef,
        triggerRef: triggerRef,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick
    });
    var _UNSAFE_useLayering = (0, $9781b722f37843eb$export$cec37b93989366d4)(), currentLevel = _UNSAFE_useLayering.currentLevel;
    var modifiers = (0, $5FkrB.useMemo)(function() {
        return [
            {
                name: 'flip',
                enabled: shouldFlip,
                options: {
                    rootBoundary: rootBoundary,
                    boundary: boundary,
                    fallbackPlacements: fallbackPlacements
                }
            }
        ];
    }, [
        shouldFlip,
        rootBoundary,
        boundary,
        fallbackPlacements
    ]);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $42e5b75ea169c552$export$badac9ada3a0bdf9), {
        placement: placement,
        offset: offset,
        modifiers: modifiers
    }, function(_ref2) {
        var _ref3 = _ref2.ref, style = _ref2.style, placement = _ref2.placement, update = _ref2.update;
        return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(PopupContainer, {
            id: id,
            "data-ds--level": currentLevel,
            "data-placement": placement,
            "data-testid": testId,
            ref: function ref(node) {
                if (node) {
                    if (typeof _ref3 === 'function') _ref3(node);
                    else _ref3.current = node;
                    setPopupRef(node);
                }
            },
            style: style,
            tabIndex: autoFocus ? 0 : undefined,
            shouldRenderToParent: shouldRenderToParent
        }, (0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.iframe_gojiv') && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $1bbaca91e5cf6bc9$export$98f03c5d19621d70), {
            styles: $01e0383d73d1296a$var$blockPointerEventsOnExternalIframeStyles
        }), (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $a7edaecb351c1789$export$51eddd7655ca235a), {
            update: update
        }, content({
            update: update,
            isOpen: isOpen,
            onClose: onClose,
            setInitialFocusRef: setInitialFocusRef
        })));
    });
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$01e0383d73d1296a$export$2e2bcd8739ae039 = $01e0383d73d1296a$var$PopperWrapper;


var $a2b7f495199a9de5$var$defaultLayer = (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).layer();
var $a2b7f495199a9de5$export$129a32eedafa97c5 = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var isOpen = _ref.isOpen, id = _ref.id, offset = _ref.offset, testId = _ref.testId, trigger = _ref.trigger, content = _ref.content, onClose = _ref.onClose, boundary = _ref.boundary, _ref$rootBoundary = _ref.rootBoundary, rootBoundary = _ref$rootBoundary === void 0 ? 'viewport' : _ref$rootBoundary, _ref$shouldFlip = _ref.shouldFlip, shouldFlip = _ref$shouldFlip === void 0 ? true : _ref$shouldFlip, _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'auto' : _ref$placement, fallbackPlacements = _ref.fallbackPlacements, PopupContainer = _ref.popupComponent, _ref$autoFocus = _ref.autoFocus, autoFocus = _ref$autoFocus === void 0 ? true : _ref$autoFocus, _ref$zIndex = _ref.zIndex, zIndex = _ref$zIndex === void 0 ? $a2b7f495199a9de5$var$defaultLayer : _ref$zIndex, _ref$shouldUseCapture = _ref.shouldUseCaptureOnOutsideClick, shouldUseCaptureOnOutsideClick = _ref$shouldUseCapture === void 0 ? false : _ref$shouldUseCapture, _ref$shouldRenderToPa = _ref.shouldRenderToParent, shouldRenderToParent = _ref$shouldRenderToPa === void 0 ? false : _ref$shouldRenderToPa;
    var _useState = (0, $5FkrB.useState)(null), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), triggerRef = _useState2[0], setTriggerRef = _useState2[1];
    /*
   * Get a memoized functional ref for use within this Popup's Trigger.
   * This is still very volatile to change as `prop.isOpen` will regularly change, but it's better than nothing.
   * This is memoized within our component as to not be shared across all Popup instances, just this one.
   *
   * This is complex because the inputs are split across three different scopes:
   *  - `props.isOpen`
   *  - `useState.setTriggerRef`
   *  - `renderProps.ref`
   */ var _useState3 = (0, $5FkrB.useState)(function() {
        return (0, $91a91a1bf1b7e1c6$export$2e2bcd8739ae039)(function(ref, setTriggerRef, isOpen) {
            return function(node) {
                if (node && isOpen) {
                    if (typeof ref === 'function') ref(node);
                    else if (ref) ref.current = node;
                    setTriggerRef(node);
                }
            };
        });
    }), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState3, 1), getMergedTriggerRef = _useState4[0];
    var renderPopperWrapper = (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $f98e4bcec8e77da9$export$a183686c3f6f4ea8), {
        isDisabled: false
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $01e0383d73d1296a$export$2e2bcd8739ae039), {
        content: content,
        isOpen: isOpen,
        placement: placement,
        fallbackPlacements: fallbackPlacements,
        boundary: boundary,
        rootBoundary: rootBoundary,
        shouldFlip: shouldFlip,
        offset: offset,
        popupComponent: PopupContainer,
        id: id,
        testId: testId,
        onClose: onClose,
        autoFocus: autoFocus,
        shouldUseCaptureOnOutsideClick: shouldUseCaptureOnOutsideClick,
        shouldRenderToParent: shouldRenderToParent,
        triggerRef: triggerRef
    }));
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $cc0477161a7a3c78$export$d0d38e7dec7a1a61), null, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $77963faf785db48a$export$e0be378c32fb70a7), null, function(_ref2) {
        var ref = _ref2.ref;
        return trigger({
            ref: getMergedTriggerRef(ref, setTriggerRef, isOpen),
            'aria-controls': id,
            'aria-expanded': isOpen,
            'aria-haspopup': true
        });
    }), isOpen && (shouldRenderToParent ? renderPopperWrapper : (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $b972fda2d5cd73a8$export$2e2bcd8739ae039), {
        zIndex: zIndex
    }, renderPopperWrapper)));
});
var $a2b7f495199a9de5$export$2e2bcd8739ae039 = $a2b7f495199a9de5$export$129a32eedafa97c5;


var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$e1c154d3dc3a0528$export$2e2bcd8739ae039 = (0, $a2b7f495199a9de5$export$129a32eedafa97c5);



var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
function $cbd0ee50051aaaeb$export$2f62ee6831462844() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var ref = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var observerInstance = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef();
    var _React$useState = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useState({
        inView: false,
        entry: undefined,
        target: undefined
    }), _React$useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_React$useState, 2), state = _React$useState2[0], setState = _React$useState2[1];
    var threshold = options.threshold, root = options.root, rootMargin = options.rootMargin;
    var setRef = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useCallback(function(node) {
        observerInstance.current = new IntersectionObserver(function(entries) {
            if (entries && entries.length) {
                var intersection = entries[0];
                var isIntersecting = intersection.isIntersecting, intersectionRatio = intersection.intersectionRatio;
                if (intersectionRatio >= 0) {
                    var inView = intersectionRatio >= (threshold || 0);
                    if (isIntersecting !== undefined) inView = inView && isIntersecting;
                    setState({
                        inView: inView,
                        entry: intersection,
                        target: node
                    });
                }
            }
        }, {
            threshold: threshold,
            root: root,
            rootMargin: rootMargin
        });
        if (ref.current) observerInstance.current.unobserve(ref.current);
        if (node) observerInstance.current.observe(node);
        // Store a reference to the node
        ref.current = node;
    }, [
        threshold,
        root,
        rootMargin
    ]);
    /**
   * Unsubscribe IntersectionObserver before unmounting a component.
   */ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        return function() {
            if (observerInstance.current && ref.current) observerInstance.current.unobserve(ref.current);
        };
    }, []);
    return [
        setRef,
        state.inView,
        state.target,
        state.entry
    ];
}


var $9bffc6fe1a50f729$export$ff983d2a2b6112ea = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var setWidth = _ref.setWidth, offscreen = _ref.offscreen;
    var _useInView = (0, $cbd0ee50051aaaeb$export$2f62ee6831462844)({
        /* Optional options */ threshold: 0
    }), _useInView2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useInView, 3), inViewRef = _useInView2[0], inView = _useInView2[1], target = _useInView2[2];
    var observer = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useRef(function() {
        if (typeof window === 'undefined') return null;
        // https://github.com/DefinitelyTyped/DefinitelyTyped/pull/40909
        // @ts-ignore
        return new ResizeObserver(function(entries) {
            if (!Array.isArray(entries) || !entries.length) return;
            var width = entries[0].contentRect.width;
            setWidth(Math.round(width));
        });
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).useEffect(function() {
        var currentObserver = observer.current;
        var resizeObserver = currentObserver();
        if (resizeObserver === null) return;
        if (target) {
            if (inView || offscreen) resizeObserver.observe(target);
            else resizeObserver.unobserve(target);
        }
        return function() {
            resizeObserver.disconnect();
        };
    }, [
        target,
        inView,
        offscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("div", {
        style: {
            display: 'block',
            width: '100%',
            position: 'absolute'
        },
        ref: inViewRef
    });
});


var $868076b348d71ed1$export$b2ad68b9bc407b80 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $9bffc6fe1a50f729$export$ff983d2a2b6112ea), {
        setWidth: props.setWidth,
        offscreen: props.offscreen
    });
});
var $868076b348d71ed1$export$2e2bcd8739ae039 = $868076b348d71ed1$export$b2ad68b9bc407b80;




var $5FkrB = parcelRequire("5FkrB");
var $2494a48c3c318569$exports = {};
var $ad50c8eeec1f512b$exports = {};
var $fceb7d20fd150820$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $fceb7d20fd150820$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$fceb7d20fd150820$exports = $fceb7d20fd150820$var$isObject;


var $1faf09b77d13e0f6$exports = {};
var $dcd24212e9610d38$exports = {};
var $19ff8c897068d84b$exports = {};
/** Detect free variable `global` from Node.js. */ var $19ff8c897068d84b$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$19ff8c897068d84b$exports = $19ff8c897068d84b$var$freeGlobal;


/** Detect free variable `self`. */ var $dcd24212e9610d38$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $dcd24212e9610d38$var$root = $19ff8c897068d84b$exports || $dcd24212e9610d38$var$freeSelf || Function('return this')();
$dcd24212e9610d38$exports = $dcd24212e9610d38$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $1faf09b77d13e0f6$var$now = function() {
    return $dcd24212e9610d38$exports.Date.now();
};
$1faf09b77d13e0f6$exports = $1faf09b77d13e0f6$var$now;


var $8a7089fbe4706c31$exports = {};
var $21e8cef54ead7066$exports = {};
var $e1f961ac832bfec6$exports = {};
/** Used to match a single whitespace character. */ var $e1f961ac832bfec6$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $e1f961ac832bfec6$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $e1f961ac832bfec6$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$e1f961ac832bfec6$exports = $e1f961ac832bfec6$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $21e8cef54ead7066$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $21e8cef54ead7066$var$baseTrim(string) {
    return string ? string.slice(0, $e1f961ac832bfec6$exports(string) + 1).replace($21e8cef54ead7066$var$reTrimStart, '') : string;
}
$21e8cef54ead7066$exports = $21e8cef54ead7066$var$baseTrim;



var $2856825500e2bbb2$exports = {};
var $5c516ff9b4ec4333$exports = {};
var $b0cdf5f82c284b2b$exports = {};

/** Built-in value references. */ var $b0cdf5f82c284b2b$var$Symbol = $dcd24212e9610d38$exports.Symbol;
$b0cdf5f82c284b2b$exports = $b0cdf5f82c284b2b$var$Symbol;


var $3e8c179708a8a55c$exports = {};

/** Used for built-in method references. */ var $3e8c179708a8a55c$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $3e8c179708a8a55c$var$hasOwnProperty = $3e8c179708a8a55c$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $3e8c179708a8a55c$var$nativeObjectToString = $3e8c179708a8a55c$var$objectProto.toString;
/** Built-in value references. */ var $3e8c179708a8a55c$var$symToStringTag = $b0cdf5f82c284b2b$exports ? $b0cdf5f82c284b2b$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $3e8c179708a8a55c$var$getRawTag(value) {
    var isOwn = $3e8c179708a8a55c$var$hasOwnProperty.call(value, $3e8c179708a8a55c$var$symToStringTag), tag = value[$3e8c179708a8a55c$var$symToStringTag];
    try {
        value[$3e8c179708a8a55c$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $3e8c179708a8a55c$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$3e8c179708a8a55c$var$symToStringTag] = tag;
        else delete value[$3e8c179708a8a55c$var$symToStringTag];
    }
    return result;
}
$3e8c179708a8a55c$exports = $3e8c179708a8a55c$var$getRawTag;


var $247a3d9d42b555d0$exports = {};
/** Used for built-in method references. */ var $247a3d9d42b555d0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $247a3d9d42b555d0$var$nativeObjectToString = $247a3d9d42b555d0$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $247a3d9d42b555d0$var$objectToString(value) {
    return $247a3d9d42b555d0$var$nativeObjectToString.call(value);
}
$247a3d9d42b555d0$exports = $247a3d9d42b555d0$var$objectToString;


/** `Object#toString` result references. */ var $5c516ff9b4ec4333$var$nullTag = '[object Null]', $5c516ff9b4ec4333$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $5c516ff9b4ec4333$var$symToStringTag = $b0cdf5f82c284b2b$exports ? $b0cdf5f82c284b2b$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $5c516ff9b4ec4333$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $5c516ff9b4ec4333$var$undefinedTag : $5c516ff9b4ec4333$var$nullTag;
    return $5c516ff9b4ec4333$var$symToStringTag && $5c516ff9b4ec4333$var$symToStringTag in Object(value) ? $3e8c179708a8a55c$exports(value) : $247a3d9d42b555d0$exports(value);
}
$5c516ff9b4ec4333$exports = $5c516ff9b4ec4333$var$baseGetTag;


var $71ee7875aed49df0$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $71ee7875aed49df0$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$71ee7875aed49df0$exports = $71ee7875aed49df0$var$isObjectLike;


/** `Object#toString` result references. */ var $2856825500e2bbb2$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2856825500e2bbb2$var$isSymbol(value) {
    return typeof value == 'symbol' || $71ee7875aed49df0$exports(value) && $5c516ff9b4ec4333$exports(value) == $2856825500e2bbb2$var$symbolTag;
}
$2856825500e2bbb2$exports = $2856825500e2bbb2$var$isSymbol;


/** Used as references for various `Number` constants. */ var $8a7089fbe4706c31$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $8a7089fbe4706c31$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $8a7089fbe4706c31$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $8a7089fbe4706c31$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $8a7089fbe4706c31$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $8a7089fbe4706c31$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2856825500e2bbb2$exports(value)) return $8a7089fbe4706c31$var$NAN;
    if ($fceb7d20fd150820$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $fceb7d20fd150820$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $21e8cef54ead7066$exports(value);
    var isBinary = $8a7089fbe4706c31$var$reIsBinary.test(value);
    return isBinary || $8a7089fbe4706c31$var$reIsOctal.test(value) ? $8a7089fbe4706c31$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $8a7089fbe4706c31$var$reIsBadHex.test(value) ? $8a7089fbe4706c31$var$NAN : +value;
}
$8a7089fbe4706c31$exports = $8a7089fbe4706c31$var$toNumber;


/** Error message constants. */ var $ad50c8eeec1f512b$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ad50c8eeec1f512b$var$nativeMax = Math.max, $ad50c8eeec1f512b$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $ad50c8eeec1f512b$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($ad50c8eeec1f512b$var$FUNC_ERROR_TEXT);
    wait = $8a7089fbe4706c31$exports(wait) || 0;
    if ($fceb7d20fd150820$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $ad50c8eeec1f512b$var$nativeMax($8a7089fbe4706c31$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $ad50c8eeec1f512b$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $1faf09b77d13e0f6$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($1faf09b77d13e0f6$exports());
    }
    function debounced() {
        var time = $1faf09b77d13e0f6$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$ad50c8eeec1f512b$exports = $ad50c8eeec1f512b$var$debounce;



/** Error message constants. */ var $2494a48c3c318569$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $2494a48c3c318569$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($2494a48c3c318569$var$FUNC_ERROR_TEXT);
    if ($fceb7d20fd150820$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $ad50c8eeec1f512b$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$2494a48c3c318569$exports = $2494a48c3c318569$var$throttle;



// Prevent width detector from triggering too many re-renders
var $d4fbcb4e162f9016$var$THROTTLE_INTERVAL = 64;
// Approx min width of items (based of "More" size)
var $d4fbcb4e162f9016$var$ITEM_APPROX_MINWIDTH = 70;
var $d4fbcb4e162f9016$var$calculateHash = function calculateHash(w, n) {
    return w + '#' + n;
};
var $d4fbcb4e162f9016$var$updateHashRef = function updateHashRef(currentRef, value) {
    currentRef.unshift(value);
    currentRef.length = 3;
};
var $d4fbcb4e162f9016$var$OverflowContext = /*#__PURE__*/ (0, $5FkrB.createContext)({
    isVisible: true,
    openOverflowMenu: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039),
    closeOverflowMenu: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
});
var $d4fbcb4e162f9016$export$a3a2def3937905a0 = function OverflowProvider(_ref) {
    var children = _ref.children, isVisible = _ref.isVisible, openOverflowMenu = _ref.openOverflowMenu, closeOverflowMenu = _ref.closeOverflowMenu;
    var Provider = $d4fbcb4e162f9016$var$OverflowContext.Provider;
    var value = (0, $5FkrB.useMemo)(function() {
        return {
            isVisible: isVisible,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: closeOverflowMenu
        };
    }, [
        isVisible,
        openOverflowMenu,
        closeOverflowMenu
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Provider, {
        value: value
    }, children);
};
var $d4fbcb4e162f9016$export$3fcfc71fab3314f2 = function useOverflowStatus() {
    return (0, $5FkrB.useContext)($d4fbcb4e162f9016$var$OverflowContext);
};
var $d4fbcb4e162f9016$export$705aa66a39c35bf7 = function useOverflowController(nodes) {
    var items = (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(nodes);
    var _useState = (0, $5FkrB.useState)(9999), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), width = _useState2[0], setWidth = _useState2[1];
    var _useState3 = (0, $5FkrB.useState)(items.length), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState3, 2), itemsLimit = _useState4[0], setItemsLimit = _useState4[1];
    var _useState5 = (0, $5FkrB.useState)({}), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState5, 2), forceEffectValue = _useState6[0], triggerForceEffect = _useState6[1];
    // Storing items approximate width so we can try expanding when there is enough room
    var itemsWidths = (0, $5FkrB.useRef)([]).current;
    // Storing a couple of width + items count in order to stabilize
    var hashRef = (0, $5FkrB.useRef)([]);
    // AFP-2511 TODO: Fix automatic suppressions below
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var throttleSetWidth = (0, $5FkrB.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($2494a48c3c318569$exports)))(setWidth, $d4fbcb4e162f9016$var$THROTTLE_INTERVAL), [
        setWidth
    ]);
    (0, $5FkrB.useEffect)(function() {
        var lastItemWidth = itemsWidths[itemsLimit] || 0;
        var wasJustLimited = lastItemWidth < 0;
        var currentHash = $d4fbcb4e162f9016$var$calculateHash(width, itemsLimit);
        if (hashRef.current[0] === currentHash) {
            // After removing an item, if width has not changed yet we schedule a force update
            // to handle case where removing an item does not actually trigger width change
            var t = setTimeout(function() {
                $d4fbcb4e162f9016$var$updateHashRef(hashRef.current, '');
                triggerForceEffect({});
            }, $d4fbcb4e162f9016$var$THROTTLE_INTERVAL * 1.5);
            return function() {
                return clearTimeout(t);
            };
        }
        if (wasJustLimited) {
            // Width was updated either via resize or after changing the limit
            // we cap the width between ITEM_APPROX_MINWIDTH and 2*ITEM_APPROX_MINWIDTH
            // because width is throttled as when fast expanding/resizing partialWidth
            // will not be reliable (edge case)
            var partialWidth = Math.max(Math.min(width + lastItemWidth, $d4fbcb4e162f9016$var$ITEM_APPROX_MINWIDTH * 2), $d4fbcb4e162f9016$var$ITEM_APPROX_MINWIDTH);
            itemsWidths[itemsLimit] = partialWidth;
        }
        if (width < $d4fbcb4e162f9016$var$ITEM_APPROX_MINWIDTH * 0.9 && itemsLimit) {
            // If current width is less than an item approx width we remove an item
            // marking the width as negative so we will calculate it on width update
            // plus we set the hash to stabilise and not removing more than one element
            // until we are sure width was updated
            var nextHash = $d4fbcb4e162f9016$var$calculateHash(width, itemsLimit - 1);
            if (hashRef.current.indexOf(nextHash) === -1) {
                setItemsLimit(itemsLimit - 1);
                itemsWidths[itemsLimit - 1] = -(width || 1);
                $d4fbcb4e162f9016$var$updateHashRef(hashRef.current, nextHash);
            }
            return;
        }
        /**
     * This is not necessarily equal to `lastItemWidth` because the
     * ```js
     * if (wasJustLimited) {}
     * ```
     * branch above modifies `itemsWidths`.
     *
     * Using `lastItemWidth` here can cause collapsing behavior to fail,
     * such as the issue reported in DSP-7329.
     */ var currentLastItemWidth = itemsWidths[itemsLimit] || 0;
        if (width - currentLastItemWidth > $d4fbcb4e162f9016$var$ITEM_APPROX_MINWIDTH * 1.1 && itemsLimit < items.length) {
            // If we have enough room to accomodate next item width we increase the limit
            // unless it has been recently removed
            var _nextHash = $d4fbcb4e162f9016$var$calculateHash(width, itemsLimit + 1);
            if (hashRef.current.indexOf(_nextHash) === -1) {
                setItemsLimit(itemsLimit + 1);
                $d4fbcb4e162f9016$var$updateHashRef(hashRef.current, _nextHash);
            }
            return;
        }
    }, [
        width,
        hashRef,
        itemsLimit,
        itemsWidths,
        forceEffectValue,
        items.length
    ]);
    return {
        visibleItems: items.slice(0, itemsLimit),
        overflowItems: items.slice(itemsLimit),
        updateWidth: throttleSetWidth
    };
};
var // Used to extract props for useOverflowStatus();
// eslint-disable-next-line @repo/internal/react/use-noop
$d4fbcb4e162f9016$export$2e2bcd8739ae039 = function(props) {};




var $5FkrB = parcelRequire("5FkrB");

var $ddcb8665769ee06e$exports = {};
"use strict";
Object.defineProperty($ddcb8665769ee06e$exports, "__esModule", {
    value: true
});
$ddcb8665769ee06e$exports.default = void 0;

var $ddcb8665769ee06e$var$_react = $ddcb8665769ee06e$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $ddcb8665769ee06e$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $ddcb8665769ee06e$var$ChevronDownIcon = (props)=>/*#__PURE__*/ $ddcb8665769ee06e$var$_react.default.createElement($21888af2d2e194e9$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path d="M8.292 10.293a1.009 1.009 0 000 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 000-1.419.987.987 0 00-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 00-1.406 0z" fill="currentColor" fill-rule="evenodd"/></svg>`
    }, props));
$ddcb8665769ee06e$var$ChevronDownIcon.displayName = 'ChevronDownIcon';
var $ddcb8665769ee06e$var$_default = $ddcb8665769ee06e$var$ChevronDownIcon;
$ddcb8665769ee06e$exports.default = $ddcb8665769ee06e$var$_default;



/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5FkrB = parcelRequire("5FkrB");








function $e955727b9ac9b5b6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e955727b9ac9b5b6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e955727b9ac9b5b6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e955727b9ac9b5b6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $e955727b9ac9b5b6$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
var $e955727b9ac9b5b6$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
var $e955727b9ac9b5b6$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
var $e955727b9ac9b5b6$export$632685d741f3dbbf = $e955727b9ac9b5b6$var$_objectSpread($e955727b9ac9b5b6$var$_objectSpread({}, $e955727b9ac9b5b6$export$958d0ae7f2977ae4), $e955727b9ac9b5b6$export$d2dc61f58390201c);
var $e955727b9ac9b5b6$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
var $e955727b9ac9b5b6$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
var $e955727b9ac9b5b6$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
var $e955727b9ac9b5b6$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
var $e955727b9ac9b5b6$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
var $e955727b9ac9b5b6$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
var $e955727b9ac9b5b6$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
var $e955727b9ac9b5b6$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
var $e955727b9ac9b5b6$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
var $e955727b9ac9b5b6$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
var $e955727b9ac9b5b6$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
var $e955727b9ac9b5b6$export$6cc560b4dedf3816 = {
    'font.size.050': "var(--ds-font-size-050, 11px)",
    'font.size.075': "var(--ds-font-size-075, 12px)",
    'font.size.100': "var(--ds-font-size-100, 14px)",
    'font.size.200': "var(--ds-font-size-200, 16px)",
    'font.size.300': "var(--ds-font-size-300, 20px)",
    'font.size.400': "var(--ds-font-size-400, 24px)",
    'font.size.500': "var(--ds-font-size-500, 29px)",
    'font.size.600': "var(--ds-font-size-600, 35px)"
};
var $e955727b9ac9b5b6$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
var $e955727b9ac9b5b6$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand': "var(--ds-font-family-brand, Charlie Sans)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.monospace': "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.sans': "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
};
var $e955727b9ac9b5b6$export$360c29a380c1a34 = {
    'font.lineHeight.1': "var(--ds-font-lineHeight-1, 1)",
    'font.lineHeight.100': "var(--ds-font-lineHeight-100, 16px)",
    'font.lineHeight.200': "var(--ds-font-lineHeight-200, 20px)",
    'font.lineHeight.300': "var(--ds-font-lineHeight-300, 24px)",
    'font.lineHeight.400': "var(--ds-font-lineHeight-400, 28px)",
    'font.lineHeight.500': "var(--ds-font-lineHeight-500, 32px)",
    'font.lineHeight.600': "var(--ds-font-lineHeight-600, 40px)"
};
var $e955727b9ac9b5b6$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
var $e955727b9ac9b5b6$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'ui.small': "var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
var $e955727b9ac9b5b6$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
var $e955727b9ac9b5b6$var$getSerializedStylesMap = function getSerializedStylesMap(cssProperty, tokenMap) {
    return Object.keys(tokenMap).reduce(function(emotionSpacingMap, token) {
        emotionSpacingMap[token] = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, cssProperty, tokenMap[token]));
        return emotionSpacingMap;
    }, {});
};
var $e955727b9ac9b5b6$export$e615f061ca585a6c = $e955727b9ac9b5b6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e955727b9ac9b5b6$var$getSerializedStylesMap(spacingProperty, $e955727b9ac9b5b6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e955727b9ac9b5b6$export$bf46c3f9eeafc71f = $e955727b9ac9b5b6$var$spacingProperties.reduce(function(styleMap, spacingProperty) {
    styleMap[spacingProperty] = $e955727b9ac9b5b6$var$getSerializedStylesMap(spacingProperty, $e955727b9ac9b5b6$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
var $e955727b9ac9b5b6$export$e7af83bafe7f9e63 = $e955727b9ac9b5b6$var$getSerializedStylesMap('backgroundColor', $e955727b9ac9b5b6$export$d1d79bf68ac056bd);
var $e955727b9ac9b5b6$export$3a1bcba60b23d7f0 = $e955727b9ac9b5b6$var$getSerializedStylesMap('color', $e955727b9ac9b5b6$export$8473307aa00d6ea1);
var $e955727b9ac9b5b6$export$f7183c9e2dbc2543 = $e955727b9ac9b5b6$var$getSerializedStylesMap('fontSize', $e955727b9ac9b5b6$export$6cc560b4dedf3816);
var $e955727b9ac9b5b6$export$45f3f4fe16f9f7d5 = $e955727b9ac9b5b6$var$getSerializedStylesMap('fontWeight', $e955727b9ac9b5b6$export$303e322c6b1ed114);
var $e955727b9ac9b5b6$export$68cc305da27dbaa4 = $e955727b9ac9b5b6$var$getSerializedStylesMap('fontFamily', $e955727b9ac9b5b6$export$3c7e9587132614b4);
var $e955727b9ac9b5b6$export$8be4a21014f48eb1 = $e955727b9ac9b5b6$var$getSerializedStylesMap('lineHeight', $e955727b9ac9b5b6$export$360c29a380c1a34);
var $e955727b9ac9b5b6$export$a1962444bbf058e = $e955727b9ac9b5b6$var$getSerializedStylesMap('font', $e955727b9ac9b5b6$export$b5bac06d7d8fd0d1);
var $e955727b9ac9b5b6$export$ca3e246f24657bd6 = $e955727b9ac9b5b6$var$getSerializedStylesMap('font', $e955727b9ac9b5b6$export$b27166c9cf2c9f74);
var $e955727b9ac9b5b6$export$ff257d957d48c421 = $e955727b9ac9b5b6$var$getSerializedStylesMap((0, $6fbf1a0fc3bf0ef0$export$9d7b58831ae93caa), $e955727b9ac9b5b6$export$41a358c9c2356760);
var $e955727b9ac9b5b6$export$5e65a44e5b6ecadb = function isSurfaceColorToken(color) {
    return $e955727b9ac9b5b6$export$41a358c9c2356760[color] !== undefined;
};



var $3ZMUU = parcelRequire("3ZMUU");
var $c1bec583fa49072f$export$9a199fbafee0014e = {
    backgroundColor: (0, $e955727b9ac9b5b6$export$d1d79bf68ac056bd),
    blockSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    borderBlockColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBlockEndColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBlockEndWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderBlockStartColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBlockStartWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderBlockWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderBottomColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderBottomLeftRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderBottomRightRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderBottomWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderEndEndRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderEndStartRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderInlineColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderInlineEndColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderInlineEndWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderInlineStartColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderInlineStartWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderInlineWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderLeftColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderLeftWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderRightColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderRightWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderStartEndRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderStartStartRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderTopColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    borderTopLeftRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderTopRightRadius: (0, $e955727b9ac9b5b6$export$3c0a6c3e64bb180d),
    borderTopWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    borderWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    bottom: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    boxShadow: (0, $e955727b9ac9b5b6$export$7aff6e7ba39bb774),
    color: (0, $e955727b9ac9b5b6$export$8473307aa00d6ea1),
    columnGap: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    gap: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    height: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    inlineSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    inset: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetBlock: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetBlockEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetBlockStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetInline: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetInlineEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    insetInlineStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    left: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    margin: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBlock: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBlockEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBlockStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginBottom: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginInline: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginInlineEnd: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginInlineStart: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginLeft: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginRight: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    marginTop: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    maxBlockSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    maxHeight: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    maxInlineSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    maxWidth: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minBlockSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minHeight: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minInlineSize: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    minWidth: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    opacity: (0, $e955727b9ac9b5b6$export$daf94a976c798b4f),
    outlineColor: (0, $e955727b9ac9b5b6$export$1531ad5bb3fbedac),
    outlineOffset: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    outlineWidth: (0, $e955727b9ac9b5b6$export$e1b83c5210c471b8),
    padding: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBlock: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBlockEnd: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBlockStart: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingBottom: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingInline: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingInlineEnd: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingInlineStart: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingLeft: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingRight: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    paddingTop: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    right: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    rowGap: (0, $e955727b9ac9b5b6$export$958d0ae7f2977ae4),
    top: (0, $e955727b9ac9b5b6$export$632685d741f3dbbf),
    width: (0, $e955727b9ac9b5b6$export$6ccdbebca2ee545f),
    zIndex: (0, $e955727b9ac9b5b6$export$b5f31a7e431d2eab)
};
var $c1bec583fa49072f$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
var $c1bec583fa49072f$var$isSafeEnvToThrow = function isSafeEnvToThrow() {
    return (typeof $3ZMUU === "undefined" ? "undefined" : (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))($3ZMUU)) === 'object' && (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))($3ZMUU.env) === 'object' && false;
};
var $c1bec583fa49072f$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
var $c1bec583fa49072f$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
var $c1bec583fa49072f$var$transformStyles = function transformStyles(styleObj) {
    if (!styleObj || (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))(styleObj) !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map(transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(function(_ref) {
        var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_ref, 2), key = _ref2[0], value = _ref2[1];
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if ((0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))(value) === 'object' && $c1bec583fa49072f$var$safeSelectors.test(key)) {
            styleObj[key] = transformStyles(value);
            return;
        }
        if ($c1bec583fa49072f$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($c1bec583fa49072f$var$reNestedSelectors.test(key)) throw new Error("Styles not supported for key '".concat(key, "'."));
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $c1bec583fa49072f$export$9a199fbafee0014e)) return;
        var tokenValue = $c1bec583fa49072f$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
var $c1bec583fa49072f$var$baseXcss = function baseXcss(style) {
    var transformedStyles = $c1bec583fa49072f$var$transformStyles(style);
    return (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, $c1bec583fa49072f$var$uniqueSymbol, (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)(transformedStyles));
};
var $c1bec583fa49072f$export$a9c84988c8f81f2d = function parseXcss(args) {
    if (Array.isArray(args)) return args.map(function(x) {
        return x && parseXcss(x);
    }).filter(Boolean);
    var styles = args[$c1bec583fa49072f$var$uniqueSymbol];
    typeof $3ZMUU === "undefined" || (0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))($3ZMUU);
    return styles;
};
function $c1bec583fa49072f$export$f6c783d06584602c(style) {
    return $c1bec583fa49072f$var$baseXcss(style);
}


var $04801a706bfa6e2c$var$baseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    boxSizing: 'border-box'
});
var $04801a706bfa6e2c$var$blockBleedMap = {
    'space.025': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginBlock: "var(--ds-space-negative-025, -0.125rem)"
    }),
    'space.050': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginBlock: "var(--ds-space-negative-050, -0.25rem)"
    }),
    'space.100': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginBlock: "var(--ds-space-negative-100, -0.5rem)"
    }),
    'space.150': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginBlock: "var(--ds-space-negative-150, -0.75rem)"
    }),
    'space.200': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginBlock: "var(--ds-space-negative-200, -1rem)"
    })
};
var $04801a706bfa6e2c$var$inlineBleedMap = {
    'space.025': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginInline: "var(--ds-space-negative-025, -0.125rem)"
    }),
    'space.050': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginInline: "var(--ds-space-negative-050, -0.25rem)"
    }),
    'space.100': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginInline: "var(--ds-space-negative-100, -0.5rem)"
    }),
    'space.150': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginInline: "var(--ds-space-negative-150, -0.75rem)"
    }),
    'space.200': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        marginInline: "var(--ds-space-negative-200, -1rem)"
    })
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ var $04801a706bfa6e2c$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(function(_ref) {
    var children = _ref.children, testId = _ref.testId, inline = _ref.inline, block = _ref.block, all = _ref.all, xcss = _ref.xcss;
    var xcssStyles = xcss && (0, $c1bec583fa49072f$export$a9c84988c8f81f2d)(xcss);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        css: [
            $04801a706bfa6e2c$var$baseStyles,
            (inline || all) && $04801a706bfa6e2c$var$inlineBleedMap[inline || all],
            (block || all) && $04801a706bfa6e2c$var$blockBleedMap[block || all],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssStyles
        ],
        "data-testid": testId
    }, children);
});
$04801a706bfa6e2c$var$Bleed.displayName = 'Bleed';
var $04801a706bfa6e2c$export$2e2bcd8739ae039 = $04801a706bfa6e2c$var$Bleed;






var $5FkrB = parcelRequire("5FkrB");






var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $d55244cb311b88fe$var$_excluded = [
    "children"
];
function $d55244cb311b88fe$export$25d302a5b900a763(defaultGetTokens) {
    var emptyThemeFn = function emptyThemeFn(getTokens, props) {
        return getTokens(props);
    };
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ var ThemeContext = /*#__PURE__*/ (0, $5FkrB.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        var theme = (0, $5FkrB.useContext)(ThemeContext);
        var themeFn = theme || emptyThemeFn;
        var tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        var children = props.children, themeProps = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(props, $d55244cb311b88fe$var$_excluded);
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        var tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        var themeFn = (0, $5FkrB.useContext)(ThemeContext);
        var valueFn = props.value || emptyThemeFn;
        var mixedFn = (0, $5FkrB.useCallback)(function(themeProps) {
            return valueFn(themeFn, themeProps);
        }, [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}


// Create default global light theme
var $6e1f8f60750fb56d$var$_createTheme = (0, $d55244cb311b88fe$export$25d302a5b900a763)(function() {
    return {
        mode: 'light'
    };
}), $6e1f8f60750fb56d$var$Provider = $6e1f8f60750fb56d$var$_createTheme.Provider, $6e1f8f60750fb56d$var$Consumer = $6e1f8f60750fb56d$var$_createTheme.Consumer, $6e1f8f60750fb56d$export$7692396083754928 = $6e1f8f60750fb56d$var$_createTheme.useTheme;
var $6e1f8f60750fb56d$export$2e2bcd8739ae039 = {
    Provider: $6e1f8f60750fb56d$var$Provider,
    Consumer: $6e1f8f60750fb56d$var$Consumer
};





var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
function $a060da77483cc5d3$var$areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(var i = 0; i < newInputs.length; i++){
        if (newInputs[i] !== lastInputs[i]) return false;
    }
    return true;
}
function $a060da77483cc5d3$export$b6feb8998cd9b342(getResult, inputs) {
    var initial = (0, $5FkrB.useState)(function() {
        return {
            inputs: inputs,
            result: getResult()
        };
    })[0];
    var isFirstRun = (0, $5FkrB.useRef)(true);
    var committed = (0, $5FkrB.useRef)(initial);
    var useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && $a060da77483cc5d3$var$areInputsEqual(inputs, committed.current.inputs));
    var cache = useCache ? committed.current : {
        inputs: inputs,
        result: getResult()
    };
    (0, $5FkrB.useEffect)(function() {
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function $a060da77483cc5d3$export$33752cf3ee811995(callback, inputs) {
    return $a060da77483cc5d3$export$b6feb8998cd9b342(function() {
        return callback;
    }, inputs);
}
var $a060da77483cc5d3$export$1538c33de8887b59 = $a060da77483cc5d3$export$b6feb8998cd9b342;
var $a060da77483cc5d3$export$35808ee640e87ca7 = $a060da77483cc5d3$export$33752cf3ee811995;






var $faad9e602d30b37d$exports = {};
var $4e1e51a03226bd6a$exports = {};

function $4e1e51a03226bd6a$var$_superPropBase(t, o) {
    for(; !({}).hasOwnProperty.call(t, o) && null !== (t = $973318e0cb84a68c$exports(t)););
    return t;
}
$4e1e51a03226bd6a$exports = $4e1e51a03226bd6a$var$_superPropBase, $4e1e51a03226bd6a$exports.__esModule = true, $4e1e51a03226bd6a$exports["default"] = $4e1e51a03226bd6a$exports;


function $faad9e602d30b37d$var$_get() {
    return $faad9e602d30b37d$exports = $faad9e602d30b37d$var$_get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function(e, t, r) {
        var p = $4e1e51a03226bd6a$exports(e, t);
        if (p) {
            var n = Object.getOwnPropertyDescriptor(p, t);
            return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
        }
    }, $faad9e602d30b37d$exports.__esModule = true, $faad9e602d30b37d$exports["default"] = $faad9e602d30b37d$exports, $faad9e602d30b37d$var$_get.apply(null, arguments);
}
$faad9e602d30b37d$exports = $faad9e602d30b37d$var$_get, $faad9e602d30b37d$exports.__esModule = true, $faad9e602d30b37d$exports["default"] = $faad9e602d30b37d$exports;










function $81ff880d8cb76a60$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $81ff880d8cb76a60$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $81ff880d8cb76a60$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $81ff880d8cb76a60$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $81ff880d8cb76a60$export$ad4be5c2ec28cecf = function isAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $81ff880d8cb76a60$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
var $81ff880d8cb76a60$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    function AnalyticsEvent(props) {
        var _this = this;
        (0, (/*@__PURE__*/$parcel$interopDefault($726d8db65a256fd4$exports)))(this, AnalyticsEvent);
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(this, "_isAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(this, "clone", function() {
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            var payload = $81ff880d8cb76a60$var$_objectSpread({}, _this.payload);
            return new AnalyticsEvent({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($79b2697ff32e0117$exports)))(AnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (typeof updater === 'function') this.payload = updater(this.payload);
                if ((0, (/*@__PURE__*/$parcel$interopDefault($a6f3b7a9d572ec57$exports)))(updater) === 'object') this.payload = $81ff880d8cb76a60$var$_objectSpread($81ff880d8cb76a60$var$_objectSpread({}, this.payload), updater);
                return this;
            }
        }
    ]);
    return AnalyticsEvent;
}();


function $0a7b95699500e142$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $0a7b95699500e142$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = (0, (/*@__PURE__*/$parcel$interopDefault($973318e0cb84a68c$exports)))(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, (/*@__PURE__*/$parcel$interopDefault($973318e0cb84a68c$exports)))(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, (/*@__PURE__*/$parcel$interopDefault($f1660048948b9f64$exports)))(this, result);
    };
}
function $0a7b95699500e142$var$_isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($0a7b95699500e142$var$_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
var $0a7b95699500e142$export$35f8383928ba8d7 = function isUIAnalyticsEvent(obj) {
    var _obj$constructor;
    return obj instanceof $0a7b95699500e142$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 || (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
var $0a7b95699500e142$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_AnalyticsEvent) {
    (0, (/*@__PURE__*/$parcel$interopDefault($a98c007cb7076ed5$exports)))(UIAnalyticsEvent, _AnalyticsEvent);
    var _super = $0a7b95699500e142$var$_createSuper(UIAnalyticsEvent);
    function UIAnalyticsEvent(props) {
        var _this;
        (0, (/*@__PURE__*/$parcel$interopDefault($726d8db65a256fd4$exports)))(this, UIAnalyticsEvent);
        _this = _super.call(this, props);
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), "_isUIAnalyticsEvent", true);
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), "clone", function() {
            if (_this.hasFired) return null;
            var context = (0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(_this.context);
            var handlers = (0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(_this.handlers);
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ var payload = JSON.parse(JSON.stringify(_this.payload));
            return new UIAnalyticsEvent({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), "fire", function(channel) {
            if (_this.hasFired) return;
            _this.handlers.forEach(function(handler) {
                return handler((0, (/*@__PURE__*/$parcel$interopDefault($d5b556b08c8aee39$exports)))(_this), channel);
            });
            _this.hasFired = true;
        });
        _this.context = props.context || [];
        _this.handlers = props.handlers || [];
        _this.hasFired = false;
        return _this;
    }
    (0, (/*@__PURE__*/$parcel$interopDefault($79b2697ff32e0117$exports)))(UIAnalyticsEvent, [
        {
            key: "update",
            value: function update(updater) {
                if (this.hasFired) return this;
                return (0, (/*@__PURE__*/$parcel$interopDefault($faad9e602d30b37d$exports)))((0, (/*@__PURE__*/$parcel$interopDefault($973318e0cb84a68c$exports)))(UIAnalyticsEvent.prototype), "update", this).call(this, updater);
            }
        }
    ]);
    return UIAnalyticsEvent;
}((0, $81ff880d8cb76a60$export$2e2bcd8739ae039));



function $879f28ba40c47674$export$5bf35293e545f20c() {
    var analyticsContext = (0, $3a4497eea280292e$export$d1f587f82ad51c4)();
    var createAnalyticsEvent = (0, $a060da77483cc5d3$export$33752cf3ee811995)(function(payload) {
        return new (0, $0a7b95699500e142$export$2e2bcd8739ae039)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}



function $7d6daf9bcf6c0b57$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7d6daf9bcf6c0b57$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7d6daf9bcf6c0b57$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7d6daf9bcf6c0b57$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $7d6daf9bcf6c0b57$export$a4687b0234b40e28(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, actionSubject = _ref.actionSubject, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function(value) {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $7d6daf9bcf6c0b57$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $5FkrB = parcelRequire("5FkrB");
function $bf3b13d9d73de104$export$2e2bcd8739ae039(ref, autoFocus) {
    var initialMount = (0, $5FkrB.useRef)(true);
    (0, $5FkrB.useEffect)(function() {
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}


/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");

var $ae7f66a126864790$var$BORDER_WIDTH = 2;
var $ae7f66a126864790$var$baseFocusOutsideStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    outline: "".concat($ae7f66a126864790$var$BORDER_WIDTH, "px solid ", "var(--ds-border-focused, #2684FF)"),
    outlineOffset: $ae7f66a126864790$var$BORDER_WIDTH
});
var $ae7f66a126864790$var$baseInsetStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    outlineColor: "var(--ds-border-focused, #2684FF)",
    outlineOffset: -$ae7f66a126864790$var$BORDER_WIDTH,
    outlineStyle: 'solid',
    outlineWidth: "var(--ds-border-width-outline, 2px)"
});
var $ae7f66a126864790$var$focusRingStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    '&:focus-visible': $ae7f66a126864790$var$baseFocusOutsideStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $ae7f66a126864790$var$baseFocusOutsideStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
var $ae7f66a126864790$var$insetFocusRingStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    '&:focus-visible': $ae7f66a126864790$var$baseInsetStyles,
    '@supports not selector(*:focus-visible)': {
        '&:focus': $ae7f66a126864790$var$baseInsetStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid',
            outlineOffset: '-1px'
        }
    }
});
/**
 * __Focus ring__
 *
 * A focus ring visually indicates the currently focused item.
 *
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/focus-ring)
 *
 * @example
 * ```jsx
 * import FocusRing from '@atlaskit/focus-ring';
 *
 * const InteractiveComponent = () => (
 *   <FocusRing>
 *     <button type="button">Hello</button>
 *   </FocusRing>
 * )
 * ```
 */ var $ae7f66a126864790$var$FocusRing = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var children = _ref.children, isInset = _ref.isInset, focus = _ref.focus;
    var controlledStyles = isInset ? $ae7f66a126864790$var$baseInsetStyles : $ae7f66a126864790$var$baseFocusOutsideStyles;
    var uncontrolledStyles = isInset ? $ae7f66a126864790$var$insetFocusRingStyles : $ae7f66a126864790$var$focusRingStyles;
    var focusCls = typeof focus === 'undefined' ? uncontrolledStyles : focus === 'on' && controlledStyles;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css, cx = _ref2.cx;
        return (0, $5FkrB.Children).only(// This may look unwieldy but means we skip applying styles / cloning if no className is applicable
        focusCls ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, $5FkrB.cloneElement)(children, {
            className: cx([
                css(focusCls),
                children.props.className
            ])
        }) : children);
    });
});
$ae7f66a126864790$var$FocusRing.displayName = 'FocusRing';
var $ae7f66a126864790$export$2e2bcd8739ae039 = $ae7f66a126864790$var$FocusRing;



var $5FkrB = parcelRequire("5FkrB");
var $a81fd7e45a8c2ef5$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5FkrB.createContext)(null);




function $af21457669944388$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
var $af21457669944388$var$tabKeyCode = 9;
function $af21457669944388$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $af21457669944388$var$tabKeyCode) return;
    $af21457669944388$var$abort(event);
}
var $af21457669944388$var$block = {
    onMouseDownCapture: $af21457669944388$var$abort,
    onMouseUpCapture: $af21457669944388$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $af21457669944388$var$onKey,
    onKeyUpCapture: $af21457669944388$var$onKey,
    onTouchStartCapture: $af21457669944388$var$abort,
    onTouchEndCapture: $af21457669944388$var$abort,
    onPointerDownCapture: $af21457669944388$var$abort,
    onPointerUpCapture: $af21457669944388$var$abort,
    onClickCapture: $af21457669944388$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $af21457669944388$var$abort
};
var $af21457669944388$var$doNotBlock = {};
function $af21457669944388$export$2e2bcd8739ae039(_ref) {
    var isInteractive = _ref.isInteractive;
    return isInteractive ? $af21457669944388$var$doNotBlock : $af21457669944388$var$block;
}






// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
var $259a41bd47c8bbe9$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
var $259a41bd47c8bbe9$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: "var(--ds-background-neutral, ".concat($5738e2919e19457f$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-neutral, ".concat($5738e2919e19457f$export$d281fbfe3cff2df6, ")")
            },
            hover: {
                light: "var(--ds-background-neutral-hovered, ".concat($5738e2919e19457f$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-hovered, ".concat($5738e2919e19457f$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-pressed, ".concat($259a41bd47c8bbe9$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-pressed, ".concat($5738e2919e19457f$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$3d4f271a500072a, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-background-brand-bold, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-background-brand-bold, ".concat($5738e2919e19457f$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-background-brand-bold-hovered, ".concat($5738e2919e19457f$export$e62e8919cca44969, ")"),
                dark: "var(--ds-background-brand-bold-hovered, ".concat($5738e2919e19457f$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-background-brand-bold-pressed, ".concat($5738e2919e19457f$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-background-brand-bold-pressed, ".concat($5738e2919e19457f$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$3d4f271a500072a, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-background-warning-bold, ".concat($5738e2919e19457f$export$c6930421db9fa514, ")"),
                dark: "var(--ds-background-warning-bold, ".concat($5738e2919e19457f$export$c6930421db9fa514, ")")
            },
            hover: {
                light: "var(--ds-background-warning-bold-hovered, ".concat($5738e2919e19457f$export$5aae31392d72caaa, ")"),
                dark: "var(--ds-background-warning-bold-hovered, ".concat($5738e2919e19457f$export$5aae31392d72caaa, ")")
            },
            active: {
                light: "var(--ds-background-warning-bold-pressed, ".concat($5738e2919e19457f$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-warning-bold-pressed, ".concat($5738e2919e19457f$export$59619663aa6500fb, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$59619663aa6500fb, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$59619663aa6500fb, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$59619663aa6500fb, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-background-danger-bold, ".concat($5738e2919e19457f$export$2010d0fb4295b346, ")"),
                dark: "var(--ds-background-danger-bold, ".concat($5738e2919e19457f$export$2010d0fb4295b346, ")")
            },
            hover: {
                light: "var(--ds-background-danger-bold-hovered, ".concat($5738e2919e19457f$export$4a7404f376229999, ")"),
                dark: "var(--ds-background-danger-bold-hovered, ".concat($5738e2919e19457f$export$4a7404f376229999, ")")
            },
            active: {
                light: "var(--ds-background-danger-bold-pressed, ".concat($5738e2919e19457f$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-danger-bold-pressed, ".concat($5738e2919e19457f$export$2837b5a1a71d5c02, ")")
            },
            disabled: {
                light: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$8d43898f60b96a82, ")"),
                dark: "var(--ds-background-disabled, ".concat($5738e2919e19457f$export$d281fbfe3cff2df6, ")")
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$2837b5a1a71d5c02, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$2837b5a1a71d5c02, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$2837b5a1a71d5c02, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: "var(--ds-background-neutral-subtle-hovered, ".concat($5738e2919e19457f$export$920c0d5c49070351, ")"),
                dark: "var(--ds-background-neutral-subtle-hovered, ".concat($5738e2919e19457f$export$3902c91d8b98a753, ")")
            },
            active: {
                light: "var(--ds-background-neutral-subtle-pressed, ".concat($259a41bd47c8bbe9$var$fadedB75, ")"),
                dark: "var(--ds-background-neutral-subtle-pressed, ".concat($5738e2919e19457f$export$8c13c2ee36917869, ")")
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$3d4f271a500072a, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$3d4f271a500072a, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")")
            },
            focusSelected: {
                light: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")"),
                dark: "var(--ds-background-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")")
            }
        }
    },
    color: {
        default: {
            default: {
                light: "var(--ds-text, ".concat($5738e2919e19457f$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            }
        },
        primary: {
            default: {
                light: "var(--ds-text-inverse, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($5738e2919e19457f$export$633847cf062b69e0, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            }
        },
        warning: {
            default: {
                light: "var(--ds-text-warning-inverse, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-warning-inverse, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$7d61b15e0da132af, ")")
            }
        },
        danger: {
            default: {
                light: "var(--ds-text-inverse, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-inverse, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$633847cf062b69e0, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$29a4f05edc054374, ")")
            }
        },
        link: {
            default: {
                light: "var(--ds-link, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-link, ".concat($5738e2919e19457f$export$ecfc1dff386a3e7a, ")")
            },
            hover: {
                light: "var(--ds-link, ".concat($5738e2919e19457f$export$e62e8919cca44969, ")"),
                dark: "var(--ds-link, ".concat($5738e2919e19457f$export$8c13c2ee36917869, ")")
            },
            active: {
                light: "var(--ds-link-pressed, ".concat($5738e2919e19457f$export$a6ee3d71bc067634, ")"),
                dark: "var(--ds-link-pressed, ".concat($5738e2919e19457f$export$215b7063051591f1, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$ad0bacf983b7ddaa, ")")
            }
        },
        subtle: {
            default: {
                light: "var(--ds-text, ".concat($5738e2919e19457f$export$c39c0fe0f26207ae, ")"),
                dark: "var(--ds-text, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")"),
                dark: "var(--ds-text, ".concat($5738e2919e19457f$export$b3de0ae08da2ce64, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-text-subtle, ".concat($5738e2919e19457f$export$f563ee71e9ee74cd, ")"),
                dark: "var(--ds-text-subtle, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            hover: {
                light: "var(--ds-text-subtle, ".concat($5738e2919e19457f$export$7c87d337fb91a97d, ")"),
                dark: "var(--ds-text-subtle, ".concat($5738e2919e19457f$export$226de0355ed012f8, ")")
            },
            active: {
                light: "var(--ds-text, ".concat($5738e2919e19457f$export$eece5f492e429f08, ")"),
                dark: "var(--ds-text, ".concat($5738e2919e19457f$export$97e81faa16a182c7, ")")
            },
            disabled: {
                light: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$5f71e19f3a7ad9de, ")"),
                dark: "var(--ds-text-disabled, ".concat($5738e2919e19457f$export$ee82aa2ea6a1558, ")")
            },
            selected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            },
            focusSelected: {
                light: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$9fdfb749e33cdf97, ")"),
                dark: "var(--ds-text-selected, ".concat($5738e2919e19457f$export$abcf8c38338b4aa5, ")")
            }
        }
    }
};
var $259a41bd47c8bbe9$export$2e2bcd8739ae039 = $259a41bd47c8bbe9$var$values;


function $3b65d2a4fe6a7488$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b65d2a4fe6a7488$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b65d2a4fe6a7488$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b65d2a4fe6a7488$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $3b65d2a4fe6a7488$var$gridSize = (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)();
var $3b65d2a4fe6a7488$var$fontSize = (0, $46bf0aae0dfb1de2$export$85e3c3ca0c6fb93)();
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
var $3b65d2a4fe6a7488$var$heights = {
    default: "".concat($3b65d2a4fe6a7488$var$gridSize * 4 / $3b65d2a4fe6a7488$var$fontSize, "em"),
    // 32px
    compact: "".concat($3b65d2a4fe6a7488$var$gridSize * 3 / $3b65d2a4fe6a7488$var$fontSize, "em"),
    none: 'auto'
};
var $3b65d2a4fe6a7488$var$lineHeights = {
    default: $3b65d2a4fe6a7488$var$heights.default,
    compact: $3b65d2a4fe6a7488$var$heights.compact,
    none: 'inherit'
};
var $3b65d2a4fe6a7488$var$padding = {
    // 10px gutter
    default: "0 ".concat($3b65d2a4fe6a7488$var$gridSize + $3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    compact: "0 ".concat($3b65d2a4fe6a7488$var$gridSize + $3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    none: '0'
};
var $3b65d2a4fe6a7488$var$singleIconPadding = {
    // 2px gutter
    compact: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    default: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    none: '0'
};
var $3b65d2a4fe6a7488$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
var $3b65d2a4fe6a7488$var$innerMargin = {
    content: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px"),
    icon: "0 ".concat($3b65d2a4fe6a7488$var$gridSize / 4, "px")
};
function $3b65d2a4fe6a7488$var$getColor(_ref) {
    var group = _ref.group, key = _ref.key, mode = _ref.mode;
    var rule = group[key] || group.default;
    return rule[mode];
}
function $3b65d2a4fe6a7488$var$getColors(_ref2) {
    var appearance = _ref2.appearance, key = _ref2.key, mode = _ref2.mode;
    return {
        background: $3b65d2a4fe6a7488$var$getColor({
            group: (0, $259a41bd47c8bbe9$export$2e2bcd8739ae039).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: "".concat($3b65d2a4fe6a7488$var$getColor({
            group: (0, $259a41bd47c8bbe9$export$2e2bcd8739ae039).color[appearance],
            key: key,
            mode: mode
        }), " !important")
    };
}
function $3b65d2a4fe6a7488$export$955358618f994a11(_ref3) {
    var appearance = _ref3.appearance, spacing = _ref3.spacing, mode = _ref3.mode, isSelected = _ref3.isSelected, shouldFitContainer = _ref3.shouldFitContainer, isOnlySingleIcon = _ref3.isOnlySingleIcon;
    var baseColors = $3b65d2a4fe6a7488$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap'
    }, baseColors), {}, {
        cursor: 'pointer',
        height: $3b65d2a4fe6a7488$var$heights[spacing],
        lineHeight: $3b65d2a4fe6a7488$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $3b65d2a4fe6a7488$var$singleIconPadding[spacing] : $3b65d2a4fe6a7488$var$padding[spacing],
        verticalAlign: $3b65d2a4fe6a7488$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        // Disabling visited styles (just using the base colors)
        '&:visited': $3b65d2a4fe6a7488$var$_objectSpread({}, baseColors),
        '&:hover': $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'hover',
            mode: mode
        })), {}, {
            textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
            // background, box-shadow
            transitionDuration: '0s, 0.15s'
        }),
        // giving active styles preference by listing them after focus
        '&:active': $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // preventDefault prevents regular active styles from applying in Firefox
        '&[data-firefox-is-active="true"]': $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'active',
            mode: mode
        })), {}, {
            // background, box-shadow
            transitionDuration: '0s, 0s'
        }),
        // Giving disabled styles preference over active by listing them after.
        // Not using '&:disabled' because :disabled is not a valid state for all element types
        // so we are targeting the attribute
        // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
        '&[disabled]': $3b65d2a4fe6a7488$var$_objectSpread($3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$getColors({
            appearance: appearance,
            key: 'disabled',
            mode: mode
        })), {}, {
            cursor: 'not-allowed',
            textDecoration: 'none'
        }),
        '&[data-has-overlay="true"]': {
            cursor: 'default',
            textDecoration: 'none'
        },
        // disabling hover and active color changes when there is an overlay, but the button is not disabled
        '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': $3b65d2a4fe6a7488$var$_objectSpread({}, $3b65d2a4fe6a7488$var$getColors({
            appearance: appearance,
            key: isSelected ? 'selected' : 'default',
            mode: mode
        })),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    });
}
function $3b65d2a4fe6a7488$export$864eea3f4ec3368f(_ref4) {
    var spacing = _ref4.spacing;
    return (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $3b65d2a4fe6a7488$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $3b65d2a4fe6a7488$export$7ad0316cc0dd65a(_ref5) {
    var spacing = _ref5.spacing;
    return (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
        margin: spacing === 'none' ? 0 : $3b65d2a4fe6a7488$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $3b65d2a4fe6a7488$export$1b5827d324e945b1(_ref6) {
    var hasOverlay = _ref6.hasOverlay;
    return (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
var $3b65d2a4fe6a7488$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};



var $5FkrB = parcelRequire("5FkrB");
/** @jsx jsx */ 
// eslint-disable-next-line @atlaskit/design-system/use-visually-hidden
var $a4a1a9cdc7bf2d54$var$visuallyHiddenStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    width: '1px',
    height: '1px',
    padding: '0',
    position: 'absolute',
    border: '0',
    clip: 'rect(1px, 1px, 1px, 1px)',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
/**
 * __Visually hidden__
 *
 * A composable element to apply a visually hidden effect to children.
 * Useful for accessibility compliance.
 *
 * @example
 * ```jsx
 * import VisuallyHidden from '@atlaskit/visually-hidden';
 *
 * export default () => (
 *   <div style={{ border: '1px solid black' }}>
 *      There is text hidden between the brackets [
 *      <VisuallyHidden>Can't see me!</VisuallyHidden>]
 *   </div>
 * );
 * ```
 */ var $a4a1a9cdc7bf2d54$var$VisuallyHidden = function VisuallyHidden(_ref) {
    var children = _ref.children, testId = _ref.testId, role = _ref.role, id = _ref.id;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        id: id,
        "data-testid": testId,
        css: $a4a1a9cdc7bf2d54$var$visuallyHiddenStyles,
        role: role
    }, children);
};
var $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039 = $a4a1a9cdc7bf2d54$var$VisuallyHidden;


var $eb6132b48d587eca$export$20bbd2efb0d734c4 = function getIfVisuallyHiddenChildren(children) {
    return children && /*#__PURE__*/ (0, $5FkrB.isValidElement)(children) && children.type === (0, $a4a1a9cdc7bf2d54$export$2e2bcd8739ae039);
};


var $5f7b778c870b53cc$var$_excluded = [
    "analyticsContext",
    "appearance",
    "autoFocus",
    "buttonCss",
    "children",
    "className",
    "href",
    "component",
    "iconAfter",
    "iconBefore",
    "interactionName",
    "isDisabled",
    "isSelected",
    "onBlur",
    "onClick",
    "onFocus",
    "onMouseDown",
    "overlay",
    "shouldFitContainer",
    "spacing",
    "tabIndex",
    "type",
    "testId"
];
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
var $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
var $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    marginLeft: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$iconAfterSpacingFixStyle = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    marginRight: "var(--ds-space-negative-025, -2px)"
});
var $5f7b778c870b53cc$var$getSpacingFix = function getSpacingFix(children, spacingStyles) {
    if (!(0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.icon-button-spacing-fix_o1zc5') || !children || (0, $eb6132b48d587eca$export$20bbd2efb0d734c4)(children)) return null;
    return spacingStyles;
};
var $5f7b778c870b53cc$var$getChildren = function getChildren(children, childrenStyles) {
    if ((0, $eb6132b48d587eca$export$20bbd2efb0d734c4)(children)) return children;
    return children ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: childrenStyles
    }, children) : null;
};
var $5f7b778c870b53cc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function ButtonBase(props, ref) {
    var analyticsContext = props.analyticsContext, _props$appearance = props.appearance, appearance = _props$appearance === void 0 ? 'default' : _props$appearance, _props$autoFocus = props.autoFocus, autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus, buttonCss = props.buttonCss, children = props.children, className = props.className, href = props.href, _props$component = props.component, Component = _props$component === void 0 ? href ? 'a' : 'button' : _props$component, iconAfter = props.iconAfter, iconBefore = props.iconBefore, interactionName = props.interactionName, _props$isDisabled = props.isDisabled, isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled, _props$isSelected = props.isSelected, isSelected = _props$isSelected === void 0 ? false : _props$isSelected, onBlur = props.onBlur, _props$onClick = props.onClick, providedOnClick = _props$onClick === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onClick, onFocus = props.onFocus, _props$onMouseDown = props.onMouseDown, providedOnMouseDown = _props$onMouseDown === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _props$onMouseDown, overlay = props.overlay, shouldFitContainer = props.shouldFitContainer, _props$spacing = props.spacing, spacing = _props$spacing === void 0 ? 'default' : _props$spacing, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, _props$type = props.type, type = _props$type === void 0 ? !href ? 'button' : undefined : _props$type, testId = props.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(props, $5f7b778c870b53cc$var$_excluded);
    var ourRef = (0, $5FkrB.useRef)();
    var setRef = (0, $5FkrB.useCallback)(function(node) {
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $bf3b13d9d73de104$export$2e2bcd8739ae039)(ourRef, autoFocus);
    var interactionContext = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    var handleClick = (0, $5FkrB.useCallback)(function(e, analyticsEvent) {
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    var onClick = (0, $7d6daf9bcf6c0b57$export$a4687b0234b40e28)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "16.18.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $5FkrB.useEffect)(function() {
        var el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    var hasOverlay = Boolean(overlay);
    var fadeStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, $3b65d2a4fe6a7488$export$1b5827d324e945b1)({
        hasOverlay: hasOverlay
    }));
    var isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: "".concat(isSelected || isDisabled ? "var(--ds-icon-subtle, ".concat((0, $5738e2919e19457f$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-warning-inverse, ".concat((0, $5738e2919e19457f$export$c39c0fe0f26207ae), ")"), " !important")
        }
    };
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $ae7f66a126864790$export$2e2bcd8739ae039), null, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Component, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $5f7b778c870b53cc$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $af21457669944388$export$2e2bcd8739ae039)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            (0, $3b65d2a4fe6a7488$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, !(0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && children ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            (0, $3b65d2a4fe6a7488$export$7ad0316cc0dd65a)({
                spacing: spacing
            })
        ]
    }, children) : null, (0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && $5f7b778c870b53cc$var$getChildren(children, [
        fadeStyles,
        (0, $3b65d2a4fe6a7488$export$7ad0316cc0dd65a)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: [
            fadeStyles,
            (0, $3b65d2a4fe6a7488$export$864eea3f4ec3368f)({
                spacing: spacing
            }),
            $5f7b778c870b53cc$var$getSpacingFix(children, $5f7b778c870b53cc$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: [
            (0, $3b65d2a4fe6a7488$export$1a9fe1b84c876bb5),
            spinnerHackCss
        ]
    }, overlay) : null));
});




function $4fdd9d09d2bfaab9$export$2e2bcd8739ae039(_ref) {
    var children = _ref.children, iconBefore = _ref.iconBefore, iconAfter = _ref.iconAfter;
    if ((0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.icon-button-spacing-fix_o1zc5') && (0, $eb6132b48d587eca$export$20bbd2efb0d734c4)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}



var $5FkrB = parcelRequire("5FkrB");
/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");



var $b77e143823b2f7d8$export$4e9f1640bbe7a1a8 = {
    xsmall: 8,
    small: 16,
    medium: 24,
    large: 48,
    xlarge: 96
};


/**
 * Returns the appropriate circle stroke color.
 */ function $6f7e5f007cf95a87$var$getStrokeColor(appearance) {
    return appearance === 'inherit' ? "var(--ds-icon-subtle, ".concat((0, $5738e2919e19457f$export$c39c0fe0f26207ae), ")") : "var(--ds-icon-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")");
}
var $6f7e5f007cf95a87$var$rotate = (0, $1bbaca91e5cf6bc9$export$d25ddfdf17c3ad3e)({
    to: {
        transform: 'rotate(360deg)'
    }
});
var $6f7e5f007cf95a87$var$rotateStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    animation: "".concat($6f7e5f007cf95a87$var$rotate, " 0.86s infinite"),
    animationTimingFunction: 'cubic-bezier(0.4, 0.15, 0.6, 0.85)',
    transformOrigin: 'center'
});
/**
 * There are three parts to the load in animation:
 * 1. Fade in
 * 2. Accelerated spin
 * 3. Stretch the spinner line
 */ var $6f7e5f007cf95a87$var$loadIn = (0, $1bbaca91e5cf6bc9$export$d25ddfdf17c3ad3e)({
    from: {
        transform: 'rotate(50deg)',
        opacity: 0,
        strokeDashoffset: 60
    },
    to: {
        transform: 'rotate(230deg)',
        opacity: 1,
        strokeDashoffset: 50
    }
});
var $6f7e5f007cf95a87$var$loadInStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    animation: "".concat($6f7e5f007cf95a87$var$loadIn, " 1s ease-in-out"),
    /**
   * When the animation completes, stay at the last frame of the animation.
   */ animationFillMode: 'forwards',
    /**
   * We are going to animate this in.
   */ opacity: 0
});
var $6f7e5f007cf95a87$var$wrapperStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'inline-flex',
    /**
   * Align better inline with text.
   */ verticalAlign: 'middle'
});
var $6f7e5f007cf95a87$var$circleStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    fill: 'none',
    strokeDasharray: 60,
    strokeDashoffset: 'inherit',
    strokeLinecap: 'round',
    strokeWidth: 1.5,
    '@media screen and (forced-colors: active)': {
        filter: 'grayscale(100%)',
        stroke: 'CanvasText'
    }
});
/**
 * `useLayoutEffect` is being used in SSR safe form. On the server, this work doesn’t need to run.
 * `useEffect` is used in-place, because `useEffect` is not run on the server and it matches types
 * which makes things simpler than doing an `isServer` check or a `null` check.
 *
 * @see https://hello.atlassian.net/wiki/spaces/DST/pages/2081696628/DSTDACI-010+-+Interaction+Tracing+hooks+in+DS+components
 */ var $6f7e5f007cf95a87$var$useLayoutEffect = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);
var $6f7e5f007cf95a87$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function Spinner(_ref, ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'inherit' : _ref$appearance, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay, interactionName = _ref.interactionName, label = _ref.label, _ref$size = _ref.size, providedSize = _ref$size === void 0 ? 'medium' : _ref$size, testId = _ref.testId;
    var size = typeof providedSize === 'number' ? providedSize : (0, $b77e143823b2f7d8$export$4e9f1640bbe7a1a8)[providedSize];
    var animationDelay = "".concat(delay, "ms");
    var stroke = $6f7e5f007cf95a87$var$getStrokeColor(appearance);
    var context = (0, $5FkrB.useContext)((0, $a81fd7e45a8c2ef5$export$2e2bcd8739ae039));
    $6f7e5f007cf95a87$var$useLayoutEffect(function() {
        if (context != null) return context.hold(interactionName);
    }, [
        context,
        interactionName
    ]);
    /**
   * The Spinner animation uses a combination of two
   * css animations on two separate elements.
   */ return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        /**
     * This span exists to off-load animations from the circle element,
     * which were causing performance issues (style recalculations)
     * on Safari and older versions of Chrome.
     *
     * This can be removed and styles placed back on the circle element once
     * Safari fixes this bug and off-loads rendering to the GPU from the CPU.
     */ css: [
            $6f7e5f007cf95a87$var$wrapperStyles,
            $6f7e5f007cf95a87$var$rotateStyles
        ],
        "data-testid": testId && "".concat(testId, "-wrapper"),
        style: {
            animationDelay: animationDelay,
            width: size,
            height: size
        }
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 16 16",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": testId,
        ref: ref,
        "aria-label": label || undefined,
        css: $6f7e5f007cf95a87$var$loadInStyles,
        style: {
            animationDelay: animationDelay
        },
        role: label ? 'img' : 'none'
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        css: $6f7e5f007cf95a87$var$circleStyles,
        style: {
            stroke: stroke
        }
    })));
}));


function $5b2cbb3d7b661df7$var$getSpinnerAppearance(_ref) {
    var appearance = _ref.appearance, isDisabled = _ref.isDisabled, isSelected = _ref.isSelected;
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $5b2cbb3d7b661df7$export$2e2bcd8739ae039(_ref2) {
    var appearance = _ref2.appearance, isDisabled = _ref2.isDisabled, isSelected = _ref2.isSelected, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing;
    var size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6f7e5f007cf95a87$export$2e2bcd8739ae039), {
        size: size,
        label: ", Loading",
        appearance: $5b2cbb3d7b661df7$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}





function $a3988abed06d3f6c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a3988abed06d3f6c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a3988abed06d3f6c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a3988abed06d3f6c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a3988abed06d3f6c$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $a3988abed06d3f6c$export$31512de7fa606fa4(_ref) {
    var _ref$appearance = _ref.appearance, appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance, _ref$spacing = _ref.spacing, spacing = _ref$spacing === void 0 ? 'default' : _ref$spacing, _ref$mode = _ref.mode, mode = _ref$mode === void 0 ? 'light' : _ref$mode, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$shouldFitContain = _ref.shouldFitContainer, shouldFitContainer = _ref$shouldFitContain === void 0 ? false : _ref$shouldFitContain, _ref$iconIsOnlyChild = _ref.iconIsOnlyChild, iconIsOnlyChild = _ref$iconIsOnlyChild === void 0 ? false : _ref$iconIsOnlyChild, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading, state = _ref.state;
    var result = (0, $3b65d2a4fe6a7488$export$955358618f994a11)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    var selector = $a3988abed06d3f6c$var$stateToSelectorMap[state];
    if (selector) result = $a3988abed06d3f6c$var$_objectSpread($a3988abed06d3f6c$var$_objectSpread({}, result), result[selector]);
    if (isLoading) result = $a3988abed06d3f6c$var$_objectSpread($a3988abed06d3f6c$var$_objectSpread({}, result), result['&[data-has-overlay="true"]']);
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach(function(key) {
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $a3988abed06d3f6c$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $a3988abed06d3f6c$export$437a7f77d13d7916(current, values) {
    return current(values);
}
var $a3988abed06d3f6c$var$Theme = (0, $d55244cb311b88fe$export$25d302a5b900a763)(function(themeProps) {
    return {
        buttonStyles: $a3988abed06d3f6c$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    };
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a3988abed06d3f6c$export$2e2bcd8739ae039 = $a3988abed06d3f6c$var$Theme;


var $079ca7802c1bfb5a$var$_excluded = [
    "appearance",
    "autoFocus",
    "isDisabled",
    "isSelected",
    "shouldFitContainer",
    "spacing",
    "isLoading",
    "onMouseEnter",
    "onMouseLeave",
    "onMouseDown",
    "onMouseUp",
    "onFocus",
    "onBlur",
    "theme"
];
function $079ca7802c1bfb5a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $079ca7802c1bfb5a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $079ca7802c1bfb5a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $079ca7802c1bfb5a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $079ca7802c1bfb5a$var$getInteractionState(_ref) {
    var _ref$isDisabled = _ref.isDisabled, isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled, _ref$isActive = _ref.isActive, isActive = _ref$isActive === void 0 ? false : _ref$isActive, _ref$isFocus = _ref.isFocus, isFocus = _ref$isFocus === void 0 ? false : _ref$isFocus, _ref$isHover = _ref.isHover, isHover = _ref$isHover === void 0 ? false : _ref$isHover, _ref$isSelected = _ref.isSelected, isSelected = _ref$isSelected === void 0 ? false : _ref$isSelected, _ref$isLoading = _ref.isLoading, isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
var $079ca7802c1bfb5a$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ var $079ca7802c1bfb5a$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).forwardRef(function CustomThemeButton(_ref2, ref) {
    var _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'default' : _ref2$appearance, _ref2$autoFocus = _ref2.autoFocus, autoFocus = _ref2$autoFocus === void 0 ? false : _ref2$autoFocus, _ref2$isDisabled = _ref2.isDisabled, isDisabled = _ref2$isDisabled === void 0 ? false : _ref2$isDisabled, _ref2$isSelected = _ref2.isSelected, isSelected = _ref2$isSelected === void 0 ? false : _ref2$isSelected, _ref2$shouldFitContai = _ref2.shouldFitContainer, shouldFitContainer = _ref2$shouldFitContai === void 0 ? false : _ref2$shouldFitContai, _ref2$spacing = _ref2.spacing, spacing = _ref2$spacing === void 0 ? 'default' : _ref2$spacing, _ref2$isLoading = _ref2.isLoading, isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading, providedOnMouseEnter = _ref2.onMouseEnter, providedOnMouseLeave = _ref2.onMouseLeave, providedOnMouseDown = _ref2.onMouseDown, providedOnMouseUp = _ref2.onMouseUp, providedOnFocus = _ref2.onFocus, providedOnBlur = _ref2.onBlur, _ref2$theme = _ref2.theme, theme = _ref2$theme === void 0 ? (0, $a3988abed06d3f6c$export$437a7f77d13d7916) : _ref2$theme, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(_ref2, $079ca7802c1bfb5a$var$_excluded);
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    var restProps = $079ca7802c1bfb5a$var$_objectSpread({
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing
    }, rest);
    var _useState = (0, $5FkrB.useState)($079ca7802c1bfb5a$var$initial), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var onMouseEnter = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isHover: true
            });
        });
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    var onMouseLeave = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isHover: false,
                isActive: false
            });
        });
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isActive: true
            });
        });
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    var onMouseUp = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isActive: false
            });
        });
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    var onFocus = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isFocus: true
            });
        });
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function(event) {
        setState(function(current) {
            return $079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, current), {}, {
                isFocus: false
            });
        });
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a3988abed06d3f6c$export$2e2bcd8739ae039).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $6e1f8f60750fb56d$export$2e2bcd8739ae039).Consumer, null, function(_ref3) {
        var mode = _ref3.mode;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a3988abed06d3f6c$export$2e2bcd8739ae039).Consumer, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
            mode: mode,
            state: $079ca7802c1bfb5a$var$getInteractionState($079ca7802c1bfb5a$var$_objectSpread($079ca7802c1bfb5a$var$_objectSpread({}, state), {}, {
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            })),
            iconIsOnlyChild: (0, $4fdd9d09d2bfaab9$export$2e2bcd8739ae039)(restProps),
            isLoading: isLoading
        }, restProps), function(_ref4) {
            var buttonStyles = _ref4.buttonStyles;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5f7b778c870b53cc$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5b2cbb3d7b661df7$export$2e2bcd8739ae039), restProps) : null,
                "aria-disabled": isLoading || undefined,
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $a3988abed06d3f6c$export$643db0b8d8778e)(buttonStyles)
            }));
        });
    }));
}));
// Tools including enzyme rely on components having a display name
$079ca7802c1bfb5a$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $079ca7802c1bfb5a$export$2e2bcd8739ae039 = $079ca7802c1bfb5a$var$CustomThemeButton;






var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");


function $290fa485630d1395$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $290fa485630d1395$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $290fa485630d1395$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $290fa485630d1395$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $290fa485630d1395$export$1a04351537078b55(_ref) {
    var fn = _ref.fn, action = _ref.action, componentName = _ref.componentName, packageName = _ref.packageName, packageVersion = _ref.packageVersion, analyticsData = _ref.analyticsData;
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    var dataRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(analyticsData);
    var fnRef = (0, $90d091140a6cc984$export$1d27a74659855e44)(fn);
    var handler = (0, $5FkrB.useCallback)(function() {
        var analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        var context = $290fa485630d1395$var$_objectSpread({
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion
        }, dataRef.current);
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}




var $5FkrB = parcelRequire("5FkrB");

/**
 * Character key codes which can be used in keyboard events.
 */ var $f8dc452a9f988247$export$390330c10ff2b9a1 = 'ArrowUp';
var $f8dc452a9f988247$export$a80636c6f41931fe = 'ArrowDown';
var $f8dc452a9f988247$export$4af703091671bc = 'Home';
var $f8dc452a9f988247$export$e2bc30913faa5db7 = 'End';
var $f8dc452a9f988247$export$2bb790b9008907b4 = 'Escape';


function $cc68d04423a653c6$export$2e2bcd8739ae039(_ref) {
    var onClose = _ref.onClose, isDisabled = _ref.isDisabled;
    var escapePressed = (0, $5FkrB.useRef)(false);
    var onKeyDown = (0, $5FkrB.useCallback)(function(e) {
        if (isDisabled || escapePressed.current || e.key !== (0, $f8dc452a9f988247$export$2bb790b9008907b4)) // We're either already handling the key down event or it's not escape.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled
    ]);
    var onKeyUp = (0, $5FkrB.useCallback)(function() {
        escapePressed.current = false;
    }, []);
    (0, $5FkrB.useEffect)(function() {
        return (0, $5b617c1f48263075$exports.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}



var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");

var $c388794be4d106d9$var$isMatchMediaAvailable = function isMatchMediaAvailable() {
    return typeof window !== 'undefined' && 'matchMedia' in window;
};
var $c388794be4d106d9$export$b7baf7667a68d87c = function isReducedMotion() {
    if (!$c388794be4d106d9$var$isMatchMediaAvailable()) return false;
    var _window$matchMedia = window.matchMedia('(prefers-reduced-motion: reduce)'), matches = _window$matchMedia.matches;
    return matches;
};
var $c388794be4d106d9$export$c537e63161742ce3 = function useIsReducedMotion() {
    var _useState = (0, $5FkrB.useState)($c388794be4d106d9$export$b7baf7667a68d87c), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), prefersReducedMotion = _useState2[0], setPrefersReducedMotion = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        if (!$c388794be4d106d9$var$isMatchMediaAvailable()) return;
        var mediaQueryList = window.matchMedia('(prefers-reduced-motion: reduce)');
        var onChange = function onChange(event) {
            return setPrefersReducedMotion(event.matches);
        };
        return (0, $5b617c1f48263075$exports.bind)(mediaQueryList, {
            type: 'change',
            listener: onChange
        });
    }, []);
    return prefersReducedMotion;
};
var $c388794be4d106d9$export$f0f789643ba5a83c = {
    '@media (prefers-reduced-motion: reduce)': {
        animation: 'none',
        transition: 'none'
    }
};
var $c388794be4d106d9$export$ff7706047246b98b = function prefersReducedMotion() {
    return $c388794be4d106d9$export$f0f789643ba5a83c;
};




var $5FkrB = parcelRequire("5FkrB");
var $afbbdbc8459ff722$export$b902f6ef73d6633a = function useForceRender() {
    var _useState = (0, $5FkrB.useState)({}), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), updateState = _useState2[1];
    var forceRender = (0, $5FkrB.useCallback)(function() {
        return updateState({});
    }, []);
    return forceRender;
};


/**
 * Internally we will be playing with an element that will always have a key defined.
 */ /**
 * Internal data passed to child motions.
 */ // We define empty context here so the object doesn't change.
var $7dce5bdaf433551a$var$emptyContext = {
    // Motions will always appear if not inside a exiting persistence component.
    appear: true,
    isExiting: false
};
var $7dce5bdaf433551a$var$ExitingContext = /*#__PURE__*/ (0, $5FkrB.createContext)($7dce5bdaf433551a$var$emptyContext);
var $7dce5bdaf433551a$var$isAnyPreviousKeysMissingFromCurrent = function isAnyPreviousKeysMissingFromCurrent(currentMap, previous) {
    for(var i = 0; i < previous.length; i++){
        var element = previous[i];
        var _key = element.key;
        if (!currentMap[_key]) return true;
    }
    return false;
};
/**
 * This method will wrap any React element with a context provider. We're using context (instead of
 * cloneElement) so we can communicate between multiple elements without the need of prop drilling
 * (results in a better API for consumers).
 */ var $7dce5bdaf433551a$var$wrapChildWithContextProvider = function wrapChildWithContextProvider(child) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $7dce5bdaf433551a$var$emptyContext;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($7dce5bdaf433551a$var$ExitingContext.Provider, {
        key: "".concat(child.key, "-provider"),
        value: value
    }, child);
};
var $7dce5bdaf433551a$var$childrenToObj = function childrenToObj(children) {
    return children.reduce(function(acc, child) {
        acc[child.key] = child;
        return acc;
    }, {});
};
var $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious = function spliceNewElementsIntoPrevious(current, previous) {
    var splicedChildren = previous.concat([]);
    var previousMap = $7dce5bdaf433551a$var$childrenToObj(previous);
    for(var i = 0; i < current.length; i++){
        var child = current[i];
        var childIsNew = !previousMap[child.key];
        if (childIsNew) // This will insert the new element after the previous element.
        splicedChildren.splice(i + 1, 0, child);
    }
    return splicedChildren;
};
/**
 * This function will convert all children types to an array while also filtering out non-valid React elements.
 */ var $7dce5bdaf433551a$var$childrenToArray = function childrenToArray(children) {
    var childrenAsArray = [];
    // We convert children to an array using this helper method as it will add keys to children that do not
    // have them, such as when we have hardcoded children that are conditionally rendered.
    (0, $5FkrB.Children).toArray(children).forEach(function(child) {
        // We ignore any boolean children to make our code a little more simple later on,
        // and also filter out any falsies (empty strings, nulls, and undefined).
        if (typeof child !== 'boolean' && Boolean(child)) // Children WILL have a key after being forced into an array using the React.Children helper.
        childrenAsArray.push(child);
    });
    return childrenAsArray;
};
/**
 * This handles the case when a render updates during an exit motion.
 * If any child is mounted again we removed them from the exiting children object and return true.
 */ var $7dce5bdaf433551a$var$hasAnyExitingChildMountedAgain = function hasAnyExitingChildMountedAgain(exitingChildren, children) {
    var exitingChildMountedAgain = false;
    children.forEach(function(child) {
        if (exitingChildren.current[child.key]) {
            exitingChildMountedAgain = true;
            delete exitingChildren.current[child.key];
        }
    });
    return exitingChildMountedAgain;
};
/**
 * __ExitingPersistence__
 *
 * Useful for enabling elements to persist and animate away when they are removed from the DOM.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $7dce5bdaf433551a$var$ExitingPersistence = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref) {
    var _ref$appear = _ref.appear, appearFromProp = _ref$appear === void 0 ? false : _ref$appear, childs = _ref.children, exitThenEnter = _ref.exitThenEnter;
    var children = $7dce5bdaf433551a$var$childrenToArray(childs);
    var childrenObj = $7dce5bdaf433551a$var$childrenToObj(children);
    var previousChildren = (0, $5FkrB.useRef)([]);
    var persistedChildren = (0, $5FkrB.useRef)([]);
    var forceRender = (0, $afbbdbc8459ff722$export$b902f6ef73d6633a)();
    var exitingChildren = (0, $5FkrB.useRef)({});
    var appear = (0, $5FkrB.useRef)(appearFromProp);
    var defaultContextValue = (0, $5FkrB.useMemo)(function() {
        return {
            appear: appear.current,
            isExiting: false
        };
    }, // React rules of hooks says this isn't needed because mutating appear won't cause a re-render.
    // While technically true - it will trigger this to make a new object on the _next_ render which is what we want.
    // Remove this or use appear instead of appear.current and you will notice a test breaks.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        appear.current
    ]);
    if ((0, $c388794be4d106d9$export$b7baf7667a68d87c)()) return children;
    if (!appear.current) // We always want child motions to appear after the initial mount.
    appear.current = true;
    // This entire block can't be an effect because we need it to run synchronously during a render
    // else when elements are being removed they will be remounted instead of being updated.
    if (previousChildren.current.length && $7dce5bdaf433551a$var$isAnyPreviousKeysMissingFromCurrent(childrenObj, previousChildren.current)) {
        if (persistedChildren.current.length === 0 || $7dce5bdaf433551a$var$hasAnyExitingChildMountedAgain(exitingChildren, children)) persistedChildren.current = previousChildren.current;
        // We have persisted children now set from previous children.
        // Let's update previous children so we have it available next render.
        previousChildren.current = children;
        return (exitThenEnter ? persistedChildren.current : $7dce5bdaf433551a$var$spliceNewElementsIntoPrevious(children, persistedChildren.current)).map(function(child) {
            // eslint-disable-next-line @repo/internal/react/no-children-properties-access
            var currentChild = childrenObj[child.key];
            if (!currentChild) {
                // We've found an exiting child - mark it!
                exitingChildren.current[child.key] = true;
                return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, {
                    isExiting: true,
                    appear: true,
                    onFinish: function onFinish() {
                        delete exitingChildren.current[child.key];
                        // We will only remove the exiting elements when any subsequent exiting elements have also finished.
                        // Think of removing many items from a todo list - when removing a few over a few clicks we don't
                        // want the list jumping around when they exit.
                        if (Object.keys(exitingChildren.current).length === 0) {
                            // Set previous children to nothing.
                            // This let's us skip the next render check as it's assumed children and previous will be the same.
                            previousChildren.current = [];
                            persistedChildren.current = [];
                            // Re-render after the element(s) have animated away which will end up rendering the latest children.
                            forceRender();
                        }
                    }
                });
            }
            // This element isn't exiting.
            // Wrap context and let's continue on our way.
            return $7dce5bdaf433551a$var$wrapChildWithContextProvider(currentChild, defaultContextValue);
        });
    } else previousChildren.current = children;
    return children.map(function(child) {
        return $7dce5bdaf433551a$var$wrapChildWithContextProvider(child, defaultContextValue);
    });
});
var $7dce5bdaf433551a$export$3b6f38abbdcbd000 = function useExitingPersistence() {
    return (0, $5FkrB.useContext)($7dce5bdaf433551a$var$ExitingContext);
};
$7dce5bdaf433551a$var$ExitingPersistence.displayName = 'ExitingPersistence';
var $7dce5bdaf433551a$export$2e2bcd8739ae039 = $7dce5bdaf433551a$var$ExitingPersistence;



var $5FkrB = parcelRequire("5FkrB");
var $6a30af0ce01ddfc7$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
var $6a30af0ce01ddfc7$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
var $6a30af0ce01ddfc7$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';


/**
 * Think of this as the motion equivalent of the @atlaskit/theme `grid()`.
 */ var $a81000281e311a76$export$368bacef0dacbe05 = 25;
var $a81000281e311a76$export$2023a81c8547415f = $a81000281e311a76$export$368bacef0dacbe05 * 4;
var $a81000281e311a76$export$6fa259be09e118a7 = $a81000281e311a76$export$368bacef0dacbe05 * 14;
var $a81000281e311a76$export$9424640c29bc466d = $a81000281e311a76$export$368bacef0dacbe05 * 28;





var $5FkrB = parcelRequire("5FkrB");




var $5FkrB = parcelRequire("5FkrB");
var $2a2978d9adc4a4d3$var$getHookDeps = function getHookDeps(opts) {
    switch(opts.cleanup){
        case 'next-effect':
            return undefined;
        case 'unmount':
        default:
            return [];
    }
};
var $2a2978d9adc4a4d3$export$1775f27e7c8051ca = function useRequestAnimationFrame() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var frames = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (frames.current.length) {
                frames.current.forEach(function(id) {
                    return cancelAnimationFrame(id);
                });
                frames.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2a2978d9adc4a4d3$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler) {
        var id = requestAnimationFrame(function(time) {
            frames.current = frames.current.filter(function(frameId) {
                return frameId !== id;
            });
            handler(time);
        });
        frames.current.push(id);
    }, []);
};
var $2a2978d9adc4a4d3$export$4f34107a2b00f39c = function useSetTimeout() {
    var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        cleanup: 'unmount'
    };
    var timeouts = (0, $5FkrB.useRef)([]);
    (0, $5FkrB.useEffect)(function() {
        return function() {
            if (timeouts.current.length) {
                timeouts.current.forEach(function(id) {
                    return clearTimeout(id);
                });
                timeouts.current = [];
            }
        };
    // We dynamically set this so we either clean up on the next effect - or on unmount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, $2a2978d9adc4a4d3$var$getHookDeps(opts));
    return (0, $5FkrB.useCallback)(function(handler, timeout) {
        for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
        var id = setTimeout.apply(void 0, [
            function() {
                timeouts.current = timeouts.current.filter(function(timeoutId) {
                    return timeoutId !== id;
                });
                handler();
            },
            timeout
        ].concat(args));
        timeouts.current.push(id);
    }, []);
};





var $5FkrB = parcelRequire("5FkrB");


var $5FkrB = parcelRequire("5FkrB");
var $3451ac6466de4e7e$export$e5c5a5f917a5871c = typeof window === 'undefined' ? (0, $5FkrB.useEffect) : (0, $5FkrB.useLayoutEffect);


/* eslint-disable @repo/internal/react/disallow-unstable-values */ 
var $5FkrB = parcelRequire("5FkrB");
function $0a47d42961a6a5a3$export$c485849f2e393253() {
    var identifier = (0, $5FkrB.useRef)('');
    if (!identifier.current) identifier.current = '_' + (Number(String(Math.random()).slice(2)) + Date.now() + Math.round(performance.now())).toString(36);
    return identifier.current;
}


var $ad83d708a15a323e$var$StaggeredEntranceContext = /*#__PURE__*/ (0, $5FkrB.createContext)(function() {
    return {
        isReady: true,
        delay: 0,
        ref: (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039)
    };
});
var $ad83d708a15a323e$export$25c7213fc07ec080 = function useStaggeredEntrance() {
    var indentifier = (0, $0a47d42961a6a5a3$export$c485849f2e393253)();
    var context = (0, $5FkrB.useContext)($ad83d708a15a323e$var$StaggeredEntranceContext);
    return context(indentifier);
};
/**
 * For a list of elements that need to animate in,
 * this should be used in conjunction with entering components.
 * This does not need Javascript to execute so it will run immediately for any SSR rendered React apps before the JS has executed.
 *
 * Will dynamically add delay to each child entering component.
 * Unfortunately all entering components _NEED_ to be a direct descendant.
 */ var $ad83d708a15a323e$var$StaggeredEntrance = function StaggeredEntrance(_ref) {
    var children = _ref.children, column = _ref.column, _ref$columns = _ref.columns, columns = _ref$columns === void 0 ? 'responsive' : _ref$columns, _ref$delayStep = _ref.delayStep, delayStep = _ref$delayStep === void 0 ? 50 : _ref$delayStep;
    var elementRefs = (0, $5FkrB.useRef)([]);
    var indexes = [];
    var _useState = (0, $5FkrB.useState)(function() {
        if (typeof columns === 'number') // A hardcoded columns is set so bail out and set it to that!
        return columns;
        if (typeof column === 'number') // A hardcoded column is set so we will set actualColumns to be 1.
        return 1;
        // We are in "responsive" mode.
        // So we will be calculating when the Javascript executes on the client how many columns there will be.
        return 0;
    }), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), actualColumns = _useState2[0], setActualColumns = _useState2[1];
    (0, $3451ac6466de4e7e$export$e5c5a5f917a5871c)(function() {
        // We want to only run this code when we are in "responsive" mode.
        // It is assumed we are in responsive mode if `columns` is "responsive",
        // we have children element refs ready to be read (i.e. if there are no children this won't run as well)
        // and finally that `actualColumns` is `0` - this is because for the first render cycle `actualColumns` will be `0` (set above)
        // and then after this layout effect runs the value for `actualColumns` will then be calculated and set.
        if (columns === 'responsive' && elementRefs.current.length && actualColumns === 0) {
            var currentTop = 0;
            var numberColumns = 0;
            if (elementRefs.current.length <= 1) {
                setActualColumns(1);
                return;
            }
            // We set the current top to the first elements.
            // We will be comparing this and incrementing the column count
            // until we hit an element that has a different offset top (or we run out of elements).
            currentTop = elementRefs.current[0] ? elementRefs.current[0].offsetTop : 0;
            for(var i = 0; i < elementRefs.current.length; i++){
                var child = elementRefs.current[i];
                if (!child) break;
                if (currentTop === child.offsetTop) {
                    numberColumns += 1;
                    if (elementRefs.current.length - 1 === i) setActualColumns(numberColumns);
                    continue;
                }
                setActualColumns(numberColumns);
                break;
            }
        }
    // We only want this effect to run once - on initial mount.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($ad83d708a15a323e$var$StaggeredEntranceContext.Provider, {
        value: function value(id) {
            if (!indexes.includes(id)) indexes.push(id);
            var isReady = actualColumns > 0;
            var index = indexes.indexOf(id);
            var currentColumn = column || index % actualColumns;
            var currentRow = Math.floor(index / actualColumns);
            var distanceFromTopLeftElement = currentRow + currentColumn;
            // We don't want loads of elements to have the same staggered delay as it ends up looking slow for users.
            // To get around that we calculate the logarithm using `distanceFromTopLeftElement` which ends making
            // elements appear faster the further away from the top left element.
            var delay = Math.ceil(Math.log(distanceFromTopLeftElement + 1) * delayStep * 1.5) || 0;
            return {
                delay: delay,
                isReady: isReady,
                ref: function ref(element) {
                    return elementRefs.current[index] = element;
                }
            };
        }
    }, children);
};
var $ad83d708a15a323e$export$2e2bcd8739ae039 = $ad83d708a15a323e$var$StaggeredEntrance;


function $b4f4bca1dbeb6cba$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4f4bca1dbeb6cba$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4f4bca1dbeb6cba$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4f4bca1dbeb6cba$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * These are props that motions should use as their external props for consumers.
 * See [FadeIn](packages/helpers/motion/src/entering/fade-in.tsx) for an example usage.
 */ /**
 * Used to multiply the initial duration for exiting motions.
 */ var $b4f4bca1dbeb6cba$var$EXITING_MOTION_MULTIPLIER = 0.5;
/**
 * This is the base INTERNAL component used for all other entering motions.
 * This does not need Javascript to execute on the client so it will run immediately
 * for any SSR rendered React apps before the JS has executed.
 */ var $b4f4bca1dbeb6cba$var$EnteringMotion = function EnteringMotion(_ref) {
    var children = _ref.children, animationTimingFunction = _ref.animationTimingFunction, enteringAnimation = _ref.enteringAnimation, exitingAnimation = _ref.exitingAnimation, isPaused = _ref.isPaused, onFinishMotion = _ref.onFinish, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $a81000281e311a76$export$9424640c29bc466d) : _ref$duration;
    var staggered = (0, $ad83d708a15a323e$export$25c7213fc07ec080)();
    var _useExitingPersistenc = (0, $7dce5bdaf433551a$export$3b6f38abbdcbd000)(), isExiting = _useExitingPersistenc.isExiting, onExitFinished = _useExitingPersistenc.onFinish, appear = _useExitingPersistenc.appear;
    var setTimeout = (0, $2a2978d9adc4a4d3$export$4f34107a2b00f39c)();
    var paused = isPaused || !staggered.isReady;
    var delay = isExiting ? 0 : staggered.delay;
    var state = isExiting ? 'exiting' : 'entering';
    var _useState = (0, $5FkrB.useState)(appear), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), hasAnimationStyles = _useState2[0], setHasAnimationStyles = _useState2[1];
    (0, $5FkrB.useEffect)(function() {
        // Tracking this to prevent changing state on an unmounted component
        var isCancelled = false;
        if (paused) return;
        // On initial mount if elements aren't set to animate on appear, we return early and callback
        if (!appear) {
            onFinishMotion && onFinishMotion(state);
            return;
        }
        // Elements may need animation styles back after initial mount (they could animate out)
        setHasAnimationStyles(true);
        setTimeout(function() {
            if (state === 'exiting') onExitFinished && onExitFinished();
            if (!isCancelled) setHasAnimationStyles(false);
            onFinishMotion && onFinishMotion(state);
        }, isExiting ? duration * $b4f4bca1dbeb6cba$var$EXITING_MOTION_MULTIPLIER : duration + delay);
        return function() {
            isCancelled = true;
        };
    // We ignore this for onFinishMotion as consumers could potentially inline the function
    // which would then trigger this effect every re-render.
    // We want to make it easier for consumers so we go down this path unfortunately.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        onExitFinished,
        state,
        isExiting,
        duration,
        delay,
        paused,
        setTimeout
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8), null, function(_ref2) {
        var css = _ref2.css;
        return children({
            ref: staggered.ref,
            className: hasAnimationStyles ? css($b4f4bca1dbeb6cba$var$_objectSpread($b4f4bca1dbeb6cba$var$_objectSpread({}, (0, $c388794be4d106d9$export$f0f789643ba5a83c)), {}, {
                animationDelay: "".concat(delay, "ms"),
                animationDuration: "".concat(isExiting ? duration * $b4f4bca1dbeb6cba$var$EXITING_MOTION_MULTIPLIER : duration, "ms"),
                animationFillMode: isExiting ? 'forwards' : 'backwards',
                animationName: "".concat((0, $1bbaca91e5cf6bc9$export$d25ddfdf17c3ad3e)(isExiting ? exitingAnimation || enteringAnimation : enteringAnimation)),
                animationPlayState: paused ? 'paused' : 'running',
                animationTimingFunction: animationTimingFunction(state)
            })) : ''
        }, state);
    });
};
var $b4f4bca1dbeb6cba$export$2e2bcd8739ae039 = $b4f4bca1dbeb6cba$var$EnteringMotion;


function $faf8d110486344ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $faf8d110486344ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $faf8d110486344ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $faf8d110486344ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $faf8d110486344ab$var$directionMotions = {
    proportional: {
        bottom: 'translate3d(0, calc(5% + 4px), 0)',
        left: 'translate3d(calc(-5% - 4px), 0, 0)',
        right: 'translate3d(calc(5% + 4px), 0, 0)',
        top: 'translate3d(0, calc(-5% - 4px), 0)'
    },
    constant: {
        bottom: 'translate3d(0, 4px, 0)',
        left: 'translate3d(-4px, 0, 0)',
        right: 'translate3d(4px, 0, 0)',
        top: 'translate3d(0, -4px, 0)'
    }
};
var $faf8d110486344ab$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
var $faf8d110486344ab$export$8497679fcaaeceb = function fadeInAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: $faf8d110486344ab$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $faf8d110486344ab$var$directionMotions[distance][direction]
        }),
        '50%': {
            opacity: 1
        },
        to: {
            transform: direction !== undefined ? 'none' : undefined
        }
    };
};
var $faf8d110486344ab$export$c9190c6659ea755b = function fadeOutAnimation(direction) {
    var distance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'proportional';
    return {
        from: {
            opacity: 1,
            transform: direction !== undefined ? 'translate3d(0, 0, 0)' : undefined
        },
        to: $faf8d110486344ab$var$_objectSpread({
            opacity: 0
        }, direction !== undefined && {
            transform: $faf8d110486344ab$var$directionMotions[distance][direction]
        })
    };
};
/**
 * Props for controlling the behavior of the FadeIn animation
 */ /**
 * __FadeIn__
 *
 * Useful for fading in one or more elements.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ var $faf8d110486344ab$var$FadeIn = function FadeIn(_ref) {
    var children = _ref.children, _ref$duration = _ref.duration, duration = _ref$duration === void 0 ? (0, $a81000281e311a76$export$9424640c29bc466d) : _ref$duration, entranceDirection = _ref.entranceDirection, exitDirection = _ref.exitDirection, _ref$distance = _ref.distance, distance = _ref$distance === void 0 ? 'proportional' : _ref$distance, onFinish = _ref.onFinish, isPaused = _ref.isPaused;
    var invertedEntranceDirection = entranceDirection && $faf8d110486344ab$var$invertedDirection[entranceDirection];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b4f4bca1dbeb6cba$export$2e2bcd8739ae039), {
        duration: duration,
        enteringAnimation: $faf8d110486344ab$export$8497679fcaaeceb(entranceDirection, distance),
        exitingAnimation: $faf8d110486344ab$export$c9190c6659ea755b(exitDirection || invertedEntranceDirection, distance),
        animationTimingFunction: function animationTimingFunction() {
            return 0, $6a30af0ce01ddfc7$export$c07234257a03d5e9;
        },
        onFinish: onFinish,
        isPaused: isPaused
    }, children);
};
var $faf8d110486344ab$export$2e2bcd8739ae039 = $faf8d110486344ab$var$FadeIn;






/**
 * We are listening directly to drag events instead of using a monitor from
 * `@atlaskit/pragmatic-drag-and-drop` to avoid the bundle size cost, as it
 * would affect almost every view in every product.
 *
 * We can reconsider this choice in the future.
 */ 
var $752ab03f37f22fda$var$registrations = new Set();
var $752ab03f37f22fda$var$cleanupEndEventListeners = null;
function $752ab03f37f22fda$var$onDragStart() {
    if ($752ab03f37f22fda$var$cleanupEndEventListeners) // If the cleanup function exists then we've already run this
    return;
    $752ab03f37f22fda$var$cleanupEndEventListeners = (0, $5b617c1f48263075$exports.bindAll)(window, [
        {
            type: 'dragend',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointerdown',
            listener: $752ab03f37f22fda$var$onDragEnd
        },
        {
            type: 'pointermove',
            listener: function() {
                var callCount = 0;
                return function listener() {
                    // Using 20 as it is far bigger than the most observed (3)
                    if (callCount < 20) {
                        callCount++;
                        return;
                    }
                    $752ab03f37f22fda$var$onDragEnd();
                };
            }()
        }
    ]);
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragStart();
    });
}
function $752ab03f37f22fda$var$onDragEnd() {
    var _cleanupEndEventListe;
    (_cleanupEndEventListe = $752ab03f37f22fda$var$cleanupEndEventListeners) === null || _cleanupEndEventListe === void 0 || _cleanupEndEventListe();
    $752ab03f37f22fda$var$cleanupEndEventListeners = null;
    var clone = Array.from($752ab03f37f22fda$var$registrations);
    clone.forEach(function(subscriber) {
        subscriber.onDragEnd();
    });
}
function $752ab03f37f22fda$var$bindStartEvents() {
    return (0, $5b617c1f48263075$exports.bindAll)(window, [
        {
            type: 'dragstart',
            listener: $752ab03f37f22fda$var$onDragStart
        },
        {
            type: 'dragenter',
            listener: $752ab03f37f22fda$var$onDragStart
        }
    ]);
}
var $752ab03f37f22fda$var$cleanupStartEventListeners = null;
function $752ab03f37f22fda$export$6503ec6e8aabbaf(registration) {
    // if first registration, bind event listeners
    if (!$752ab03f37f22fda$var$cleanupStartEventListeners) // note: currently never unbinding these event listeners
    $752ab03f37f22fda$var$cleanupStartEventListeners = $752ab03f37f22fda$var$bindStartEvents();
    $752ab03f37f22fda$var$registrations.add(registration);
    /**
   * The reasoning for this behavior is so that if a tooltip mounts during
   * a drag it can still be suppressed.
   *
   * We use a separate callback instead of onDragStart to avoid infinite loops.
   */ registration.onRegister({
        isDragging: $752ab03f37f22fda$var$cleanupEndEventListeners !== null
    });
    return function unregister() {
        $752ab03f37f22fda$var$registrations.delete(registration);
        if ($752ab03f37f22fda$var$registrations.size === 0) {
            var _cleanupStartEventLis;
            (_cleanupStartEventLis = $752ab03f37f22fda$var$cleanupStartEventListeners) === null || _cleanupStartEventLis === void 0 || _cleanupStartEventLis();
            $752ab03f37f22fda$var$cleanupStartEventListeners = null;
        }
    };
}


var $4b4b9238463f4e56$var$delayId = null;
function $4b4b9238463f4e56$export$eaf678f6f93f5250() {
    if ($4b4b9238463f4e56$var$delayId != null) {
        window.clearTimeout($4b4b9238463f4e56$var$delayId);
        $4b4b9238463f4e56$var$delayId = null;
    }
}
function $4b4b9238463f4e56$export$5f4d6617421d489b(fn, delay) {
    $4b4b9238463f4e56$export$eaf678f6f93f5250();
    $4b4b9238463f4e56$var$delayId = window.setTimeout(function() {
        $4b4b9238463f4e56$var$delayId = null;
        fn();
    }, delay);
}


// This file is a singleton for managing tooltips
var $20886030c0da208f$var$active = null;
function $20886030c0da208f$export$57bf213be019eeb0(entry) {
    var phase = 'waiting-to-show';
    function isActive() {
        return Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.entry === entry);
    }
    function cleanup() {
        if (isActive()) {
            (0, $4b4b9238463f4e56$export$eaf678f6f93f5250)();
            $20886030c0da208f$var$active = null;
        }
    }
    function done() {
        if (isActive()) entry.done();
        phase = 'done';
        cleanup();
    }
    function immediatelyHideAndDone() {
        if (isActive()) entry.hide({
            isImmediate: true
        });
        done();
    }
    function keep() {
        if (!isActive()) return;
        // aborting a wait to hide
        if (phase === 'waiting-to-hide') {
            phase = 'shown';
            (0, $4b4b9238463f4e56$export$eaf678f6f93f5250)();
            return;
        }
        // aborting hide animation
        if (phase === 'hide-animating') {
            phase = 'shown';
            (0, $4b4b9238463f4e56$export$eaf678f6f93f5250)();
            entry.show({
                isImmediate: false
            });
            return;
        }
    }
    function requestHide(_ref) {
        var isImmediate = _ref.isImmediate;
        if (!isActive()) return;
        // If we were not showing yet anyway; finish straight away
        if (phase === 'waiting-to-show') {
            immediatelyHideAndDone();
            return;
        }
        // already waiting to hide
        if (phase === 'waiting-to-hide') return;
        if (isImmediate) {
            immediatelyHideAndDone();
            return;
        }
        phase = 'waiting-to-hide';
        (0, $4b4b9238463f4e56$export$5f4d6617421d489b)(function() {
            phase = 'hide-animating';
            entry.hide({
                isImmediate: false
            });
        }, entry.delay);
    }
    function finishHideAnimation() {
        if (isActive() && phase === 'hide-animating') done();
    }
    function isVisible() {
        return phase === 'shown' || phase === 'waiting-to-hide' || phase === 'hide-animating';
    }
    function getInitialMouse() {
        if (entry.source.type === 'mouse') return entry.source.mouse;
        return null;
    }
    function start() {
        var showImmediately = Boolean($20886030c0da208f$var$active && $20886030c0da208f$var$active.isVisible());
        // If there was an active tooltip; we tell it to remove itself at once!
        if ($20886030c0da208f$var$active) {
            (0, $4b4b9238463f4e56$export$eaf678f6f93f5250)();
            $20886030c0da208f$var$active.entry.hide({
                isImmediate: true
            });
            $20886030c0da208f$var$active.entry.done();
            $20886030c0da208f$var$active = null;
        }
        // this tooltip is now the active tooltip
        $20886030c0da208f$var$active = {
            entry: entry,
            isVisible: isVisible
        };
        function show() {
            phase = 'shown';
            entry.show({
                isImmediate: showImmediately
            });
        }
        if (showImmediately) {
            show();
            return;
        }
        phase = 'waiting-to-show';
        (0, $4b4b9238463f4e56$export$5f4d6617421d489b)(show, entry.delay);
    }
    // let's get started!
    start();
    var result = {
        keep: keep,
        abort: cleanup,
        isActive: isActive,
        requestHide: requestHide,
        finishHideAnimation: finishHideAnimation,
        mousePosition: getInitialMouse()
    };
    return result;
}



var $5FkrB = parcelRequire("5FkrB");

var $5FkrB = parcelRequire("5FkrB");
/**
 * generates a UID factory
 * @internal
 * @example
 * const uid = generateUID();
 * uid(object) = 1;
 * uid(object) = 1;
 * uid(anotherObject) = 2;
 */ var $e9ce486011a08a46$export$bdbb4cbb3078e58d = function() {
    var counter = 1;
    var map = new WeakMap();
    /**
     * @borrows {uid}
     */ var uid = function(item, index) {
        if (typeof item === 'number' || typeof item === 'string') return index ? "idx-".concat(index) : "val-".concat(item);
        if (!map.has(item)) {
            map.set(item, counter++);
            return uid(item);
        }
        return 'uid' + map.get(item);
    };
    return uid;
};
var $e9ce486011a08a46$export$e2a22331486dcca0 = $e9ce486011a08a46$export$bdbb4cbb3078e58d();


var $878686cdae50c4f9$export$1921362e86c73c88 = function(prefix) {
    if (prefix === void 0) prefix = '';
    return {
        value: 1,
        prefix: prefix,
        uid: (0, $e9ce486011a08a46$export$bdbb4cbb3078e58d)()
    };
};
var $878686cdae50c4f9$export$e575061ef2a070eb = $878686cdae50c4f9$export$1921362e86c73c88();
var $878686cdae50c4f9$export$b4d5da5f34fb77ad = $5FkrB.createContext($878686cdae50c4f9$export$1921362e86c73c88());
var $878686cdae50c4f9$export$218c8c3169c024d2 = function(source) {
    return source.value++;
};
var $878686cdae50c4f9$export$36e24695f02d4503 = function(source) {
    return source ? source.prefix : '';
};


var $8120b68af314e225$var$generateUID = function(context) {
    var quartz = context || (0, $878686cdae50c4f9$export$e575061ef2a070eb);
    var prefix = (0, $878686cdae50c4f9$export$36e24695f02d4503)(quartz);
    var id = (0, $878686cdae50c4f9$export$218c8c3169c024d2)(quartz);
    var uid = prefix + id;
    var gen = function(item) {
        return uid + quartz.uid(item);
    };
    return {
        uid: uid,
        gen: gen
    };
};
var $8120b68af314e225$var$useUIDState = function() {
    var context = (0, $5FkrB.useContext)((0, $878686cdae50c4f9$export$b4d5da5f34fb77ad));
    var uid = (0, $5FkrB.useState)(function() {
        return $8120b68af314e225$var$generateUID(context);
    })[0];
    return uid;
};
var $8120b68af314e225$export$87d05f07e65211f1 = function() {
    var uid = $8120b68af314e225$var$useUIDState().uid;
    return uid;
};
var $8120b68af314e225$export$bb5ca5fba6fb4f1f = function() {
    var gen = $8120b68af314e225$var$useUIDState().gen;
    return gen;
};


function $e266314cb40581a7$export$2e2bcd8739ae039(prefix, shouldRenderId) {
    var seed = (0, $8120b68af314e225$export$bb5ca5fba6fb4f1f)();
    return shouldRenderId ? "".concat(seed(prefix)) : undefined;
}


/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");




var $5FkrB = parcelRequire("5FkrB");


function $5c2d0e1050976d8c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5c2d0e1050976d8c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5c2d0e1050976d8c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5c2d0e1050976d8c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5c2d0e1050976d8c$var$VAR_PRIMITIVE_ZINDEX = 'tooltipPrimitiveZindex';
var $5c2d0e1050976d8c$var$primitiveStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    zindex: "var(".concat($5c2d0e1050976d8c$var$VAR_PRIMITIVE_ZINDEX, ")"),
    cursor: "default"
});
var $5c2d0e1050976d8c$var$TooltipPrimitive = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipPrimitive(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    var styleWithZIndex = $5c2d0e1050976d8c$var$_objectSpread($5c2d0e1050976d8c$var$_objectSpread({}, style), {}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, $5c2d0e1050976d8c$var$VAR_PRIMITIVE_ZINDEX, (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).tooltip()));
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        ref: ref,
        style: styleWithZIndex,
        "data-testid": testId ? "".concat(testId, "--wrapper") : undefined
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        role: "tooltip",
        className: className,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: $5c2d0e1050976d8c$var$primitiveStyles,
        "data-placement": placement,
        "data-testid": testId,
        id: id
    }, children));
});
$5c2d0e1050976d8c$var$TooltipPrimitive.displayName = 'TooltipPrimitive';
var $5c2d0e1050976d8c$export$2e2bcd8739ae039 = $5c2d0e1050976d8c$var$TooltipPrimitive;


var $0a2ab42ccb34ae20$var$baseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    boxSizing: 'border-box',
    maxWidth: '240px',
    padding: "var(--ds-space-025, 2px)".concat(" ", "var(--ds-space-075, 6px)"),
    insetBlockStart: "var(--ds-space-0, 0px)",
    insetInlineStart: "var(--ds-space-0, 0px)",
    borderRadius: "var(--ds-border-radius, 3px)",
    fontSize: "var(--ds-font-size-075, 12px)",
    lineHeight: 1.3,
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    backgroundColor: "var(--ds-background-neutral-bold, ".concat((0, $5738e2919e19457f$export$7d61b15e0da132af), ")"),
    color: "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")")
});
var $0a2ab42ccb34ae20$var$truncateStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    maxWidth: '420px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $0a2ab42ccb34ae20$var$TooltipContainer = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function TooltipContainer(_ref, ref) {
    var style = _ref.style, className = _ref.className, children = _ref.children, truncate = _ref.truncate, placement = _ref.placement, testId = _ref.testId, onMouseOut = _ref.onMouseOut, onMouseOver = _ref.onMouseOver, id = _ref.id;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $5c2d0e1050976d8c$export$2e2bcd8739ae039), {
        ref: ref,
        style: style,
        className: className,
        placement: placement,
        testId: testId,
        id: id,
        onMouseOut: onMouseOut,
        onMouseOver: onMouseOver,
        css: [
            $0a2ab42ccb34ae20$var$baseStyles,
            truncate ? $0a2ab42ccb34ae20$var$truncateStyles : null
        ]
    }, children);
});
$0a2ab42ccb34ae20$var$TooltipContainer.displayName = 'TooltipContainer';
var $0a2ab42ccb34ae20$export$2e2bcd8739ae039 = $0a2ab42ccb34ae20$var$TooltipContainer;


function $62f7b8f11efc4419$export$642213d516a9b928(mouseCoordinates) {
    var safeMouse = mouseCoordinates || {
        top: 0,
        left: 0
    };
    var getBoundingClientRect = function getBoundingClientRect() {
        return {
            top: safeMouse.top,
            left: safeMouse.left,
            bottom: safeMouse.top,
            right: safeMouse.left,
            width: 0,
            height: 0
        };
    };
    return {
        getBoundingClientRect: getBoundingClientRect,
        clientWidth: 0,
        clientHeight: 0
    };
}


function $a28343ba4306daf0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a28343ba4306daf0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a28343ba4306daf0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a28343ba4306daf0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $a28343ba4306daf0$var$tooltipZIndex = (0, $46bf0aae0dfb1de2$export$7be255094ccdc533).tooltip();
var $a28343ba4306daf0$var$analyticsAttributes = {
    componentName: 'tooltip',
    packageName: "@atlaskit/tooltip",
    packageVersion: "18.1.1"
};
// Inverts motion direction
var $a28343ba4306daf0$var$invertedDirection = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left'
};
/**
 * Converts a Popper placement to it's general direction.
 *
 * @param position - Popper Placement value, e.g. 'top-start'
 * @returns Popper Direction, e.g. 'top'
 */ var $a28343ba4306daf0$var$getDirectionFromPlacement = function getDirectionFromPlacement(placement) {
    return placement.split('-')[0];
};
function $a28343ba4306daf0$var$Tooltip(_ref) {
    var children = _ref.children, _ref$position = _ref.position, position = _ref$position === void 0 ? 'bottom' : _ref$position, _ref$mousePosition = _ref.mousePosition, mousePosition = _ref$mousePosition === void 0 ? 'bottom' : _ref$mousePosition, content = _ref.content, _ref$truncate = _ref.truncate, truncate = _ref$truncate === void 0 ? false : _ref$truncate, _ref$component = _ref.component, Container = _ref$component === void 0 ? (0, $0a2ab42ccb34ae20$export$2e2bcd8739ae039) : _ref$component, _ref$tag = _ref.tag, TargetContainer = _ref$tag === void 0 ? 'div' : _ref$tag, testId = _ref.testId, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 300 : _ref$delay, _ref$onShow = _ref.onShow, onShow = _ref$onShow === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onShow, _ref$onHide = _ref.onHide, onHide = _ref$onHide === void 0 ? (0, $adcefb868cf2fc9d$export$2e2bcd8739ae039) : _ref$onHide, _ref$hideTooltipOnCli = _ref.hideTooltipOnClick, hideTooltipOnClick = _ref$hideTooltipOnCli === void 0 ? false : _ref$hideTooltipOnCli, _ref$hideTooltipOnMou = _ref.hideTooltipOnMouseDown, hideTooltipOnMouseDown = _ref$hideTooltipOnMou === void 0 ? false : _ref$hideTooltipOnMou, analyticsContext = _ref.analyticsContext, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'fixed' : _ref$strategy;
    var tooltipPosition = position === 'mouse' ? mousePosition : position;
    var onShowHandler = (0, $290fa485630d1395$export$1a04351537078b55)($a28343ba4306daf0$var$_objectSpread({
        fn: onShow,
        action: 'displayed',
        analyticsData: analyticsContext
    }, $a28343ba4306daf0$var$analyticsAttributes));
    var onHideHandler = (0, $290fa485630d1395$export$1a04351537078b55)($a28343ba4306daf0$var$_objectSpread({
        fn: onHide,
        action: 'hidden',
        analyticsData: analyticsContext
    }, $a28343ba4306daf0$var$analyticsAttributes));
    var apiRef = (0, $5FkrB.useRef)(null);
    var _useState = (0, $5FkrB.useState)('hide'), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), state = _useState2[0], setState = _useState2[1];
    var targetRef = (0, $5FkrB.useRef)(null);
    var containerRef = (0, $5FkrB.useRef)(null);
    // This function is deliberately _not_ memoized as it needs to re-run every render
    // to pick up any child ref changes. If you use render props you don't have this issue.
    var setImplicitRefFromChildren = function setImplicitRefFromChildren(node) {
        containerRef.current = node;
        targetRef.current = node ? node.firstElementChild : null;
    };
    // This is memoized and passed into the render props callback.
    var setDirectRef = (0, $5FkrB.useCallback)(function(node) {
        targetRef.current = node;
    }, []);
    // Putting a few things into refs so that we don't have to break memoization
    var lastState = (0, $5FkrB.useRef)(state);
    var lastDelay = (0, $5FkrB.useRef)(delay);
    var lastHandlers = (0, $5FkrB.useRef)({
        onShowHandler: onShowHandler,
        onHideHandler: onHideHandler
    });
    var hasCalledShowHandler = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        lastState.current = state;
        lastDelay.current = delay;
        lastHandlers.current = {
            onShowHandler: onShowHandler,
            onHideHandler: onHideHandler
        };
    }, [
        delay,
        onHideHandler,
        onShowHandler,
        state
    ]);
    var start = (0, $5FkrB.useCallback)(function(api) {
        // @ts-ignore
        apiRef.current = api;
        hasCalledShowHandler.current = false;
    }, []);
    var done = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
        // @ts-ignore
        hasCalledShowHandler.current = false;
        // just in case
        setState('hide');
    }, []);
    var abort = (0, $5FkrB.useCallback)(function() {
        if (!apiRef.current) return;
        apiRef.current.abort();
        // Only call onHideHandler if we have called onShowHandler
        if (hasCalledShowHandler.current) lastHandlers.current.onHideHandler();
        // @ts-ignore
        apiRef.current = null;
    }, []);
    (0, $5FkrB.useEffect)(function mount() {
        return function unmount() {
            if (apiRef.current) abort();
        };
    }, [
        abort
    ]);
    var isDraggingRef = (0, $5FkrB.useRef)(false);
    (0, $5FkrB.useEffect)(function() {
        return (0, $752ab03f37f22fda$export$6503ec6e8aabbaf)({
            onRegister: function onRegister(_ref2) {
                var isDragging = _ref2.isDragging;
                isDraggingRef.current = isDragging;
            },
            onDragStart: function onDragStart() {
                var _apiRef$current;
                /**
         * Hiding any visible tooltips when a drag starts because otherwise it
         * looks janky (disappears and reappears), and is not required.
         */ (_apiRef$current = apiRef.current) === null || _apiRef$current === void 0 || _apiRef$current.requestHide({
                    isImmediate: true
                });
                isDraggingRef.current = true;
            },
            onDragEnd: function onDragEnd() {
                isDraggingRef.current = false;
            }
        });
    }, []);
    var showTooltip = (0, $5FkrB.useCallback)(function(source) {
        /**
     * Prevent tooltips from being shown during a drag. This can occur with
     * the native drag and drop API, where some pointer events can fire
     * when they should not and lead to jank with tooltips.
     */ if (isDraggingRef.current) return;
        if (apiRef.current && !apiRef.current.isActive()) abort();
        // Tell the tooltip to keep showing
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
        var entry = {
            source: source,
            delay: lastDelay.current,
            show: function show(_ref3) {
                var isImmediate = _ref3.isImmediate;
                // Call the onShow handler if it hasn't been called yet
                if (!hasCalledShowHandler.current) {
                    hasCalledShowHandler.current = true;
                    lastHandlers.current.onShowHandler();
                }
                setState(isImmediate ? 'show-immediate' : 'fade-in');
            },
            hide: function hide(_ref4) {
                var isImmediate = _ref4.isImmediate;
                if (isImmediate) setState('hide');
                else setState('before-fade-out');
            },
            done: done
        };
        var api = (0, $20886030c0da208f$export$57bf213be019eeb0)(entry);
        start(api);
    }, [
        abort,
        done,
        start
    ]);
    var hideTooltipOnEsc = (0, $5FkrB.useCallback)(function() {
        var _apiRef$current2;
        (_apiRef$current2 = apiRef.current) === null || _apiRef$current2 === void 0 || _apiRef$current2.requestHide({
            isImmediate: true
        });
    }, [
        apiRef
    ]);
    (0, $cc68d04423a653c6$export$2e2bcd8739ae039)({
        onClose: hideTooltipOnEsc,
        isDisabled: state === 'hide' || state === 'fade-out'
    });
    (0, $5FkrB.useEffect)(function() {
        if (state === 'hide') return 0, $adcefb868cf2fc9d$export$2e2bcd8739ae039;
        if (state === 'before-fade-out') setState('fade-out');
        var unbind = (0, $5b617c1f48263075$exports.bind)(window, {
            type: 'scroll',
            listener: function listener() {
                if (apiRef.current) apiRef.current.requestHide({
                    isImmediate: true
                });
            },
            options: {
                capture: true,
                passive: true,
                once: true
            }
        });
        return unbind;
    }, [
        state
    ]);
    var onMouseDown = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnMouseDown && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnMouseDown
    ]);
    var onClick = (0, $5FkrB.useCallback)(function() {
        if (hideTooltipOnClick && apiRef.current) apiRef.current.requestHide({
            isImmediate: true
        });
    }, [
        hideTooltipOnClick
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseover of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOver = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        var source = position === 'mouse' ? {
            type: 'mouse',
            // TODO: ideally not recalculating this object each time
            mouse: (0, $62f7b8f11efc4419$export$642213d516a9b928)({
                left: event.clientX,
                top: event.clientY
            })
        } : {
            type: 'keyboard'
        };
        showTooltip(source);
    }, [
        position,
        showTooltip
    ]);
    // Ideally we would be using onMouseEnter here, but
    // because we are binding the event to the target parent
    // we need to listen for the mouseout of all sub elements
    // This means when moving along a tooltip we are quickly toggling
    // between api.requestHide and api.keep. This it not ideal
    var onMouseOut = (0, $5FkrB.useCallback)(function(event) {
        // Ignoring events from the container ref
        if (containerRef.current && event.target === containerRef.current) return;
        // Using prevent default as a signal that parent tooltips
        if (event.defaultPrevented) return;
        event.preventDefault();
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onMouseMove = position === 'mouse' ? function(event) {
        var _apiRef$current3;
        if ((_apiRef$current3 = apiRef.current) !== null && _apiRef$current3 !== void 0 && _apiRef$current3.isActive()) apiRef.current.mousePosition = (0, $62f7b8f11efc4419$export$642213d516a9b928)({
            left: event.clientX,
            top: event.clientY
        });
    } : undefined;
    var onMouseOverTooltip = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current && apiRef.current.isActive()) {
            apiRef.current.keep();
            return;
        }
    }, []);
    var onFocus = (0, $5FkrB.useCallback)(function() {
        showTooltip({
            type: 'keyboard'
        });
    }, [
        showTooltip
    ]);
    var onBlur = (0, $5FkrB.useCallback)(function() {
        if (apiRef.current) apiRef.current.requestHide({
            isImmediate: false
        });
    }, []);
    var onAnimationFinished = (0, $5FkrB.useCallback)(function(transition) {
        // Using lastState here because motion is not picking up the latest value
        if (transition === 'exiting' && lastState.current === 'fade-out' && apiRef.current) // @ts-ignore: refs are writeable
        apiRef.current.finishHideAnimation();
    }, []);
    // Doing a cast because typescript is struggling to narrow the type
    var CastTargetContainer = TargetContainer;
    var shouldRenderTooltipContainer = state !== 'hide' && Boolean(content);
    var shouldRenderTooltipChildren = state !== 'hide' && state !== 'fade-out';
    var getReferenceElement = function getReferenceElement() {
        var _apiRef$current4;
        if (position === 'mouse' && (_apiRef$current4 = apiRef.current) !== null && _apiRef$current4 !== void 0 && _apiRef$current4.mousePosition) {
            var _apiRef$current5;
            return (_apiRef$current5 = apiRef.current) === null || _apiRef$current5 === void 0 ? void 0 : _apiRef$current5.mousePosition;
        }
        return targetRef.current || undefined;
    };
    var tooltipId = (0, $e266314cb40581a7$export$2e2bcd8739ae039)('tooltip', shouldRenderTooltipContainer);
    var tooltipTriggerProps = {
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        onMouseMove: onMouseMove,
        onMouseDown: onMouseDown,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur
    };
    // Don't set `data-testid` unless it's defined, as it's not in the interface.
    if (testId) // @ts-expect-error - Adding `data-testid` to the TriggerProps interface breaks Buttons.
    tooltipTriggerProps['data-testid'] = "".concat(testId, "--container");
    // This useEffect is purely for managing the aria attribute when using the
    // wrapped children approach.
    (0, $5FkrB.useEffect)(function() {
        // If there is no container element, we should exit early, because that
        // means they are using the render prop API, and that is implemented in a
        // different way. If there is no target element yet or tooltipId, we also
        // shouldn't do anything because there is nothing to operate on or with.
        if (!containerRef.current || !targetRef.current || !tooltipId) return;
        var target = targetRef.current;
        if (shouldRenderTooltipContainer) target.setAttribute('aria-describedby', tooltipId);
        else target.removeAttribute('aria-describedby');
    }, [
        shouldRenderTooltipContainer,
        tooltipId
    ]);
    var hiddenContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "data-testid": testId ? "".concat(testId, "-hidden") : undefined,
        hidden: true,
        id: tooltipId
    }, typeof content === 'function' ? content({}) : content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, typeof children === 'function' ? /*#__PURE__*/ // once we deprecate the wrapped approach, we can put the aria
    // attribute back into the tooltipTriggerProps and make it required
    // instead of optional in `types`
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, children($a28343ba4306daf0$var$_objectSpread($a28343ba4306daf0$var$_objectSpread({}, tooltipTriggerProps), {}, {
        'aria-describedby': tooltipId,
        ref: setDirectRef
    })), shouldRenderTooltipContainer && hiddenContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(CastTargetContainer, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({}, tooltipTriggerProps, {
        ref: setImplicitRefFromChildren,
        role: "presentation"
    }), children, shouldRenderTooltipContainer && hiddenContent), shouldRenderTooltipContainer ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $b972fda2d5cd73a8$export$2e2bcd8739ae039), {
        zIndex: $a28343ba4306daf0$var$tooltipZIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $42e5b75ea169c552$export$badac9ada3a0bdf9), {
        placement: tooltipPosition,
        referenceElement: getReferenceElement(),
        strategy: strategy
    }, function(_ref5) {
        var ref = _ref5.ref, style = _ref5.style, update = _ref5.update, placement = _ref5.placement;
        // Invert the entrance and exit directions.
        // E.g. a tooltip's position is on the 'right', it should enter from and exit to the 'left'
        // This gives the effect the tooltip is appearing from the target
        var direction = position === 'mouse' ? undefined : $a28343ba4306daf0$var$invertedDirection[$a28343ba4306daf0$var$getDirectionFromPlacement(placement)];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $7dce5bdaf433551a$export$2e2bcd8739ae039), {
            appear: true
        }, shouldRenderTooltipChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $faf8d110486344ab$export$2e2bcd8739ae039), {
            distance: "constant",
            entranceDirection: direction,
            exitDirection: direction,
            onFinish: onAnimationFinished,
            duration: state === 'show-immediate' ? 0 : (0, $a81000281e311a76$export$6fa259be09e118a7)
        }, function(_ref6) {
            var className = _ref6.className;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Container, {
                ref: ref,
                className: "Tooltip ".concat(className),
                style: style,
                truncate: truncate,
                placement: tooltipPosition,
                testId: getReferenceElement() ? testId : testId && "".concat(testId, "--unresolved"),
                onMouseOut: onMouseOut,
                onMouseOver: onMouseOverTooltip
            }, typeof content === 'function' ? content({
                update: update
            }) : content);
        }));
    })) : null);
}
$a28343ba4306daf0$var$Tooltip.displayName = 'Tooltip';
var $a28343ba4306daf0$export$2e2bcd8739ae039 = $a28343ba4306daf0$var$Tooltip;



var $5FkrB = parcelRequire("5FkrB");

var $063f49374ce1ab43$export$93d4e7f90805808f = function useTheme() {
    return (0, $5FkrB.useContext)((0, $0cbbe03340c55ac9$export$2c657da244d00bd6));
};



function $1572bef186bf27f4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1572bef186bf27f4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1572bef186bf27f4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1572bef186bf27f4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $1572bef186bf27f4$export$14dd6915caf431fe = function getPrimaryButtonTheme(_ref) {
    var primaryButton = _ref.mode.primaryButton;
    return function(current, props) {
        var _current = current(props), buttonStyles = _current.buttonStyles, spinnerStyles = _current.spinnerStyles;
        return {
            buttonStyles: $1572bef186bf27f4$var$_objectSpread($1572bef186bf27f4$var$_objectSpread($1572bef186bf27f4$var$_objectSpread($1572bef186bf27f4$var$_objectSpread({}, buttonStyles), primaryButton.default), props.isSelected && primaryButton.selected), {}, {
                fontWeight: 500,
                padding: "0 ".concat("var(--ds-space-050, 4px)"),
                marginLeft: 0,
                marginRight: 0,
                ':hover': props.isSelected ? primaryButton.selectedHover : primaryButton.hover,
                ':focus': primaryButton.focus,
                // :active doesn't work in FF, because we do a
                // e.preventDefault() on mouse down in Button.
                // '&&' is required to add more CSS specificity
                // && it not a valid CSSObject property
                // @ts-ignore
                '&&': $1572bef186bf27f4$var$_objectSpread({}, props.state === 'active' && primaryButton.active)
            }),
            spinnerStyles: spinnerStyles
        };
    };
};


var $e8bdf0e0b15b45e3$var$_excluded = [
    "children",
    "testId",
    "tooltip",
    "isSelected",
    "isHighlighted"
];
var $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_COLOR = '--button-selected-color';
var $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_BORDER_COLOR = '--button-selected-border-color';
var $e8bdf0e0b15b45e3$var$buttonBaseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
});
var $e8bdf0e0b15b45e3$var$buttonHighlightedStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '&& > *': {
        color: "var(".concat($e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_COLOR, ")")
    },
    '&:after': {
        height: 3,
        position: 'absolute',
        backgroundColor: "var(".concat($e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_BORDER_COLOR, ")"),
        borderStartEndRadius: "var(--ds-border-radius-050, 1px)",
        borderStartStartRadius: "var(--ds-border-radius-050, 1px)",
        content: '""',
        insetBlockEnd: 0,
        insetInlineEnd: "var(--ds-space-050, 4px)",
        insetInlineStart: "var(--ds-space-050, 4px)"
    }
});
var $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84 = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    var _ref;
    var children = props.children, testId = props.testId, tooltip = props.tooltip, isSelected = props.isSelected, isHighlighted = props.isHighlighted, buttonProps = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(props, $e8bdf0e0b15b45e3$var$_excluded);
    var theme = (0, $063f49374ce1ab43$export$93d4e7f90805808f)();
    var button = (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        style: (_ref = {}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_ref, $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_COLOR, theme.mode.primaryButton.selected.color), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_ref, $e8bdf0e0b15b45e3$var$VAR_BUTTON_SELECTED_BORDER_COLOR, theme.mode.primaryButton.selected.borderColor), _ref),
        css: [
            $e8bdf0e0b15b45e3$var$buttonBaseStyles,
            isHighlighted && $e8bdf0e0b15b45e3$var$buttonHighlightedStyles
        ]
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $079ca7802c1bfb5a$export$2e2bcd8739ae039), (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        appearance: "primary",
        testId: testId,
        ref: ref,
        isSelected: isSelected,
        theme: (0, $1572bef186bf27f4$export$14dd6915caf431fe)(theme)
    }, buttonProps), children));
    if (tooltip) return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $a28343ba4306daf0$export$2e2bcd8739ae039), {
        content: tooltip,
        hideTooltipOnClick: true
    }, button);
    return button;
});
var $e8bdf0e0b15b45e3$export$2e2bcd8739ae039 = $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84;


var $a8c7121eb827a20e$var$chevronIconStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    opacity: 0.51
});
var $a8c7121eb827a20e$var$chevronIconStylesWithSpacingFixStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    opacity: 0.51,
    marginInlineEnd: "var(--ds-space-negative-050, -0.25rem)"
});
var $a8c7121eb827a20e$export$bb3af89fb196520d = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(props, ref) {
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84), (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        iconAfter: (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $04801a706bfa6e2c$export$2e2bcd8739ae039), {
            xcss: (0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.icon-button-spacing-fix_o1zc5') ? $a8c7121eb827a20e$var$chevronIconStylesWithSpacingFixStyles : $a8c7121eb827a20e$var$chevronIconStyles,
            inline: "space.100"
        }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($ddcb8665769ee06e$exports))), {
            label: ""
        })),
        ref: ref
    }, props));
});
var $a8c7121eb827a20e$export$2e2bcd8739ae039 = $a8c7121eb827a20e$export$bb3af89fb196520d;


var $ae1bddf578a341f7$var$containerStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    height: '100%',
    position: 'relative',
    alignItems: 'stretch',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        margin: "0 ".concat("var(--ds-space-050, 4px)"),
        flexShrink: 0
    }
});
var $ae1bddf578a341f7$var$widthObserverContainerStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    width: '100%',
    minWidth: '1px',
    margin: '0px',
    position: 'relative',
    flexShrink: 1
});
var $ae1bddf578a341f7$export$43e704064d596a9e = function PrimaryItemsContainer(_ref) {
    var moreLabel = _ref.moreLabel, items = _ref.items, Create = _ref.create, theme = _ref.theme, testId = _ref.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var _useOverflowControlle = (0, $d4fbcb4e162f9016$export$705aa66a39c35bf7)(items), updateWidth = _useOverflowControlle.updateWidth, visibleItems = _useOverflowControlle.visibleItems, overflowItems = _useOverflowControlle.overflowItems;
    var onMoreClick = (0, $5FkrB.useCallback)(function() {
        setIsMoreOpen(!isMoreOpen);
    }, [
        isMoreOpen,
        setIsMoreOpen
    ]);
    var onMoreClose = (0, $5FkrB.useCallback)(function() {
        setIsMoreOpen(false);
    }, []);
    var openOverflowMenu = (0, $5FkrB.useCallback)(function() {
        setIsMoreOpen(true);
    }, []);
    var trigger = (0, $5FkrB.useCallback)(function(triggerProps) {
        return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $a8c7121eb827a20e$export$bb3af89fb196520d), (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $5FkrB.useCallback)(function() {
        return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $d4fbcb4e162f9016$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, overflowItems);
    }, // Overflow items has an unstable reference - so we will only recalculate
    // content if `overflowItems` length changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        overflowItems.length,
        openOverflowMenu,
        onMoreClose
    ]);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        css: $ae1bddf578a341f7$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-primary-actions")
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $d4fbcb4e162f9016$export$a3a2def3937905a0), {
        isVisible: true,
        openOverflowMenu: openOverflowMenu,
        closeOverflowMenu: onMoreClose
    }, visibleItems), overflowItems.length > 0 && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $e1c154d3dc3a0528$export$2e2bcd8739ae039), {
        placement: "bottom-start",
        content: content,
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    }), Create && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Create, null), (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        css: $ae1bddf578a341f7$var$widthObserverContainerStyles
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $868076b348d71ed1$export$b2ad68b9bc407b80), {
        offscreen: true,
        setWidth: updateWidth
    })));
};






var $5FkrB = parcelRequire("5FkrB");



var $5FkrB = parcelRequire("5FkrB");


/** @jsx jsx */ 
var $5FkrB = parcelRequire("5FkrB");



var $1b254ba6a068f2f1$var$justifyContentMap = {
    start: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'start'
    }),
    center: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'center'
    }),
    end: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'end'
    }),
    'space-between': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        justifyContent: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$flexDirectionMap = {
    column: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexDirection: 'column'
    }),
    row: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexDirection: 'row'
    })
};
var $1b254ba6a068f2f1$var$flexWrapMap = {
    wrap: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        flexWrap: 'nowrap'
    })
};
var $1b254ba6a068f2f1$var$alignItemsMap = {
    start: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'start'
    }),
    center: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'center'
    }),
    baseline: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'baseline'
    }),
    end: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'end'
    }),
    stretch: (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        alignItems: 'stretch'
    })
};
var $1b254ba6a068f2f1$var$baseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ var $1b254ba6a068f2f1$var$Flex = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref, ref) {
    var _ref$as = _ref.as, Component = _ref$as === void 0 ? 'div' : _ref$as, role = _ref.role, alignItems = _ref.alignItems, justifyContent = _ref.justifyContent, gap = _ref.gap, columnGap = _ref.columnGap, rowGap = _ref.rowGap, children = _ref.children, testId = _ref.testId, direction = _ref.direction, wrap = _ref.wrap, xcss = _ref.xcss;
    var xcssClassName = xcss && (0, $c1bec583fa49072f$export$a9c84988c8f81f2d)(xcss);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Component, {
        role: role,
        css: [
            $1b254ba6a068f2f1$var$baseStyles,
            gap && (0, $e955727b9ac9b5b6$export$bf46c3f9eeafc71f).gap[gap],
            columnGap && (0, $e955727b9ac9b5b6$export$bf46c3f9eeafc71f).columnGap[columnGap],
            rowGap && (0, $e955727b9ac9b5b6$export$bf46c3f9eeafc71f).rowGap[rowGap],
            alignItems && $1b254ba6a068f2f1$var$alignItemsMap[alignItems],
            direction && $1b254ba6a068f2f1$var$flexDirectionMap[direction],
            justifyContent && $1b254ba6a068f2f1$var$justifyContentMap[justifyContent],
            wrap && $1b254ba6a068f2f1$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$1b254ba6a068f2f1$var$Flex.displayName = 'Flex';
var $1b254ba6a068f2f1$export$2e2bcd8739ae039 = $1b254ba6a068f2f1$var$Flex;


var $10b0af967ce59e29$var$flexGrowMap = {
    hug: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        flexGrow: 0
    }),
    fill: (0, $c1bec583fa49072f$export$f6c783d06584602c)({
        width: '100%',
        flexGrow: 1
    })
};
var $10b0af967ce59e29$var$separatorStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: "var(--ds-space-negative-025, -2px)",
    pointerEvents: 'none',
    userSelect: 'none'
});
var $10b0af967ce59e29$var$Separator = function Separator(_ref) {
    var children = _ref.children;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: $10b0af967ce59e29$var$separatorStyles
    }, children);
};
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ var $10b0af967ce59e29$var$Inline = /*#__PURE__*/ (0, $5FkrB.memo)(/*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var as = _ref2.as, alignInline = _ref2.alignInline, _ref2$alignBlock = _ref2.alignBlock, alignItems = _ref2$alignBlock === void 0 ? 'start' : _ref2$alignBlock, _ref2$shouldWrap = _ref2.shouldWrap, shouldWrap = _ref2$shouldWrap === void 0 ? false : _ref2$shouldWrap, spread = _ref2.spread, grow = _ref2.grow, space = _ref2.space, rowSpace = _ref2.rowSpace, separator = _ref2.separator, xcss = _ref2.xcss, testId = _ref2.testId, role = _ref2.role, rawChildren = _ref2.children;
    var separatorComponent = typeof separator === 'string' ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)($10b0af967ce59e29$var$Separator, null, separator) : separator;
    var children = separatorComponent ? (0, $5FkrB.Children).toArray(rawChildren).filter(Boolean).map(function(child, index) {
        return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $5FkrB.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    var justifyContent = spread || alignInline;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $1b254ba6a068f2f1$export$2e2bcd8739ae039), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: grow ? [
            $10b0af967ce59e29$var$flexGrowMap[grow]
        ].concat((0, (/*@__PURE__*/$parcel$interopDefault($b5e0d6462918fd61$exports)))(Array.isArray(xcss) ? xcss : [
            xcss
        ])) : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$10b0af967ce59e29$var$Inline.displayName = 'Inline';
var $10b0af967ce59e29$export$2e2bcd8739ae039 = $10b0af967ce59e29$var$Inline;


/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see https://compiledcssinjs.com/docs/atomic-css#selector-specificity
 */ var $92693c60dc1696c3$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
var $92693c60dc1696c3$export$c881183ca713c214 = $92693c60dc1696c3$export$987d49ffe1b0900f;


var $5FkrB = parcelRequire("5FkrB");


var $965bfce17c5c9621$var$_window, $965bfce17c5c9621$var$_window$matchMedia, $965bfce17c5c9621$var$_window2, $965bfce17c5c9621$var$_window2$matchMedia, $965bfce17c5c9621$var$_window3, $965bfce17c5c9621$var$_window3$matchMedia, $965bfce17c5c9621$var$_window4, $965bfce17c5c9621$var$_window4$matchMedia, $965bfce17c5c9621$var$_window5, $965bfce17c5c9621$var$_window5$matchMedia, $965bfce17c5c9621$var$_window6, $965bfce17c5c9621$var$_window6$matchMedia, $965bfce17c5c9621$var$_window7, $965bfce17c5c9621$var$_window7$matchMedia, $965bfce17c5c9621$var$_window8, $965bfce17c5c9621$var$_window8$matchMedia, $965bfce17c5c9621$var$_window9, $965bfce17c5c9621$var$_window9$matchMedia, $965bfce17c5c9621$var$_window10, $965bfce17c5c9621$var$_window10$matchMedia, $965bfce17c5c9621$var$_window11, $965bfce17c5c9621$var$_window11$matchMedia;
var $965bfce17c5c9621$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window = window) === null || $965bfce17c5c9621$var$_window === void 0 || ($965bfce17c5c9621$var$_window$matchMedia = $965bfce17c5c9621$var$_window.matchMedia) === null || $965bfce17c5c9621$var$_window$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window$matchMedia.call($965bfce17c5c9621$var$_window, (0, $92693c60dc1696c3$export$c881183ca713c214).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window2 = window) === null || $965bfce17c5c9621$var$_window2 === void 0 || ($965bfce17c5c9621$var$_window2$matchMedia = $965bfce17c5c9621$var$_window2.matchMedia) === null || $965bfce17c5c9621$var$_window2$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window2$matchMedia.call($965bfce17c5c9621$var$_window2, (0, $92693c60dc1696c3$export$c881183ca713c214).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window3 = window) === null || $965bfce17c5c9621$var$_window3 === void 0 || ($965bfce17c5c9621$var$_window3$matchMedia = $965bfce17c5c9621$var$_window3.matchMedia) === null || $965bfce17c5c9621$var$_window3$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window3$matchMedia.call($965bfce17c5c9621$var$_window3, (0, $92693c60dc1696c3$export$c881183ca713c214).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window4 = window) === null || $965bfce17c5c9621$var$_window4 === void 0 || ($965bfce17c5c9621$var$_window4$matchMedia = $965bfce17c5c9621$var$_window4.matchMedia) === null || $965bfce17c5c9621$var$_window4$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window4$matchMedia.call($965bfce17c5c9621$var$_window4, (0, $92693c60dc1696c3$export$c881183ca713c214).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window5 = window) === null || $965bfce17c5c9621$var$_window5 === void 0 || ($965bfce17c5c9621$var$_window5$matchMedia = $965bfce17c5c9621$var$_window5.matchMedia) === null || $965bfce17c5c9621$var$_window5$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window5$matchMedia.call($965bfce17c5c9621$var$_window5, (0, $92693c60dc1696c3$export$c881183ca713c214).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window6 = window) === null || $965bfce17c5c9621$var$_window6 === void 0 || ($965bfce17c5c9621$var$_window6$matchMedia = $965bfce17c5c9621$var$_window6.matchMedia) === null || $965bfce17c5c9621$var$_window6$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window6$matchMedia.call($965bfce17c5c9621$var$_window6, (0, $92693c60dc1696c3$export$c881183ca713c214).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window7 = window) === null || $965bfce17c5c9621$var$_window7 === void 0 || ($965bfce17c5c9621$var$_window7$matchMedia = $965bfce17c5c9621$var$_window7.matchMedia) === null || $965bfce17c5c9621$var$_window7$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window7$matchMedia.call($965bfce17c5c9621$var$_window7, (0, $92693c60dc1696c3$export$c881183ca713c214).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window8 = window) === null || $965bfce17c5c9621$var$_window8 === void 0 || ($965bfce17c5c9621$var$_window8$matchMedia = $965bfce17c5c9621$var$_window8.matchMedia) === null || $965bfce17c5c9621$var$_window8$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window8$matchMedia.call($965bfce17c5c9621$var$_window8, (0, $92693c60dc1696c3$export$c881183ca713c214).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window9 = window) === null || $965bfce17c5c9621$var$_window9 === void 0 || ($965bfce17c5c9621$var$_window9$matchMedia = $965bfce17c5c9621$var$_window9.matchMedia) === null || $965bfce17c5c9621$var$_window9$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window9$matchMedia.call($965bfce17c5c9621$var$_window9, (0, $92693c60dc1696c3$export$c881183ca713c214).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window10 = window) === null || $965bfce17c5c9621$var$_window10 === void 0 || ($965bfce17c5c9621$var$_window10$matchMedia = $965bfce17c5c9621$var$_window10.matchMedia) === null || $965bfce17c5c9621$var$_window10$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window10$matchMedia.call($965bfce17c5c9621$var$_window10, (0, $92693c60dc1696c3$export$c881183ca713c214).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($965bfce17c5c9621$var$_window11 = window) === null || $965bfce17c5c9621$var$_window11 === void 0 || ($965bfce17c5c9621$var$_window11$matchMedia = $965bfce17c5c9621$var$_window11.matchMedia) === null || $965bfce17c5c9621$var$_window11$matchMedia === void 0 ? void 0 : $965bfce17c5c9621$var$_window11$matchMedia.call($965bfce17c5c9621$var$_window11, (0, $92693c60dc1696c3$export$c881183ca713c214).below.xl.replace('@media ', '').trim())
};
var $965bfce17c5c9621$export$49e55ae2c03d6045 = function UNSAFE_useMediaQuery(queryString, listener) {
    var listenerRef = (0, $5FkrB.useRef)(listener);
    (0, $5FkrB.useEffect)(function() {
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ var hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ var mq = $965bfce17c5c9621$var$queries[queryString];
    (0, $5FkrB.useLayoutEffect)(function() {
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $5b617c1f48263075$exports.bind)(mq, {
            type: 'change',
            listener: function listener(event) {
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};




var $5b4104c1e6d44b94$var$_xcss2;
var $5b4104c1e6d44b94$var$sharedContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)({
    height: '100%',
    alignItems: 'stretch',
    paddingInlineEnd: 'space.050',
    gap: 'space.100'
});
var $5b4104c1e6d44b94$var$smallContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, (0, $92693c60dc1696c3$export$987d49ffe1b0900f).above.sm, {
    display: 'none'
}));
var $5b4104c1e6d44b94$var$mediumContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)(($5b4104c1e6d44b94$var$_xcss2 = {
    display: 'none'
}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($5b4104c1e6d44b94$var$_xcss2, (0, $92693c60dc1696c3$export$987d49ffe1b0900f).above.sm, {
    display: 'flex'
}), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($5b4104c1e6d44b94$var$_xcss2, (0, $92693c60dc1696c3$export$987d49ffe1b0900f).above.lg, {
    display: 'none'
}), $5b4104c1e6d44b94$var$_xcss2));
var $5b4104c1e6d44b94$var$largeContainerStyles = (0, $c1bec583fa49072f$export$f6c783d06584602c)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({
    display: 'none'
}, (0, $92693c60dc1696c3$export$987d49ffe1b0900f).above.lg, {
    display: 'flex'
}));
var $5b4104c1e6d44b94$var$MoreItemsPopup = function MoreItemsPopup(_ref) {
    var moreLabel = _ref.moreLabel, testId = _ref.testId, items = _ref.items;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), isMoreOpen = _useState2[0], setIsMoreOpen = _useState2[1];
    var onMoreClose = (0, $5FkrB.useCallback)(function() {
        return setIsMoreOpen(false);
    }, []);
    var onMoreClick = (0, $5FkrB.useCallback)(function() {
        return setIsMoreOpen(function(current) {
            return !current;
        });
    }, []);
    var openOverflowMenu = (0, $5FkrB.useCallback)(function() {
        return setIsMoreOpen(true);
    }, []);
    var trigger = (0, $5FkrB.useCallback)(function(triggerProps) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a8c7121eb827a20e$export$bb3af89fb196520d), (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
            onClick: onMoreClick,
            isSelected: isMoreOpen,
            testId: testId ? "".concat(testId, "-overflow-menu-trigger") : 'overflow-menu-trigger'
        }, triggerProps), moreLabel);
    }, [
        moreLabel,
        onMoreClick,
        isMoreOpen,
        testId
    ]);
    var content = (0, $5FkrB.useCallback)(function() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $d4fbcb4e162f9016$export$a3a2def3937905a0), {
            isVisible: false,
            openOverflowMenu: openOverflowMenu,
            closeOverflowMenu: onMoreClose
        }, items);
    }, [
        items,
        openOverflowMenu,
        onMoreClose
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $e1c154d3dc3a0528$export$2e2bcd8739ae039), {
        placement: "bottom-start",
        isOpen: isMoreOpen,
        onClose: onMoreClose,
        trigger: trigger,
        content: content,
        testId: testId ? "".concat(testId, "-overflow-menu-popup") : 'overflow-menu-popup'
    });
};
var $5b4104c1e6d44b94$export$43e704064d596a9e = /*#__PURE__*/ (0, $5FkrB.memo)(function(_ref2) {
    var moreLabel = _ref2.moreLabel, items = _ref2.items, Create = _ref2.create, theme = _ref2.theme, testId = _ref2.testId;
    // We render a CSS media query based nav at first to handle SSR, then use
    // our useMediaQuery hook once we are hydrated so there is only one set of nav items
    var _useState3 = (0, $5FkrB.useState)(false), _useState4 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState3, 2), isClient = _useState4[0], setIsClient = _useState4[1];
    (0, $5FkrB.useEffect)(function() {
        setIsClient(true);
    }, []);
    // Setting up our media queries to use once app is hydrated
    var mqSm = (0, $965bfce17c5c9621$export$49e55ae2c03d6045)('above.sm', function(event) {
        return setIsAboveSm(event.matches);
    });
    var _useState5 = (0, $5FkrB.useState)(mqSm === null || mqSm === void 0 ? void 0 : mqSm.matches), _useState6 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState5, 2), isAboveSm = _useState6[0], setIsAboveSm = _useState6[1];
    var mqLg = (0, $965bfce17c5c9621$export$49e55ae2c03d6045)('above.lg', function(event) {
        return setIsAboveLg(event.matches);
    });
    var _useState7 = (0, $5FkrB.useState)(mqLg === null || mqLg === void 0 ? void 0 : mqLg.matches), _useState8 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState7, 2), isAboveLg = _useState8[0], setIsAboveLg = _useState8[1];
    // Filter out any falsy items passed in
    var filteredItems = (0, $5FkrB.useMemo)(function() {
        return (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Children.toArray(items).filter(function(item) {
            return !!item;
        });
    }, [
        items
    ]);
    // NOTE: we could make these max items configurable in the future. For now
    // we are using sensible defaults. Anything over the max gets put in the
    // overflow menu for that screen size.
    // While it may be tempting to use more than 3 items for the medium nav when
    // you see the available space, you need to consider internationalistion.
    // 3 is the safe, defensive choice across many languages and scripts.
    var smallMaxItems = 0;
    var mediumMaxItems = 3;
    var largeMaxItems = 8;
    // We re-use this in both the CSS media query nav that loads in for SSR,
    // and the JS/hook media query nav that is used once hydrated
    var navItems = (0, $5FkrB.useMemo)(function() {
        return {
            small: {
                navBarItems: [],
                overflowItems: filteredItems
            },
            medium: {
                navBarItems: filteredItems.slice(0, mediumMaxItems),
                overflowItems: filteredItems.slice(mediumMaxItems, filteredItems.length)
            },
            large: {
                navBarItems: filteredItems.slice(0, largeMaxItems),
                overflowItems: filteredItems.slice(largeMaxItems, filteredItems.length)
            }
        };
    }, [
        filteredItems
    ]);
    var hydratedNavItems = (0, $5FkrB.useMemo)(function() {
        if (isAboveLg) return navItems.large;
        if (isAboveSm && !isAboveLg) return navItems.medium;
        return navItems.small;
    }, [
        isAboveLg,
        isAboveSm,
        navItems.large,
        navItems.medium,
        navItems.small
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, isClient ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
        testId: testId && "".concat(testId, "-primary-actions"),
        xcss: $5b4104c1e6d44b94$var$sharedContainerStyles
    }, hydratedNavItems.navBarItems, hydratedNavItems.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5b4104c1e6d44b94$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        items: hydratedNavItems.overflowItems,
        testId: testId
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
        xcss: [
            $5b4104c1e6d44b94$var$sharedContainerStyles,
            $5b4104c1e6d44b94$var$smallContainerStyles
        ]
    }, filteredItems.length > smallMaxItems && /*#__PURE__*/ // We don't need to pass items into popup, it won't be interactive (SSR only)
    (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5b4104c1e6d44b94$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
        xcss: [
            $5b4104c1e6d44b94$var$sharedContainerStyles,
            $5b4104c1e6d44b94$var$mediumContainerStyles
        ]
    }, navItems.medium.navBarItems, navItems.medium.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5b4104c1e6d44b94$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $10b0af967ce59e29$export$2e2bcd8739ae039), {
        xcss: [
            $5b4104c1e6d44b94$var$sharedContainerStyles,
            $5b4104c1e6d44b94$var$largeContainerStyles
        ]
    }, navItems.large.navBarItems, navItems.large.overflowItems.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($5b4104c1e6d44b94$var$MoreItemsPopup, {
        moreLabel: moreLabel,
        testId: testId
    }))), Create && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement(Create, null));
});


var $fade497bfa6efef0$var$containerStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box',
    height: (0, $9e0b6f96d7dc4701$export$30fa7cc5f2690a43),
    paddingRight: "var(--ds-space-150, 12px)",
    paddingLeft: "var(--ds-space-150, 12px)",
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexShrink: 0,
    borderBottom: "1px solid ".concat("var(--ds-border, ".concat((0, $5738e2919e19457f$export$3e51e8f1440314ba), ")"))
});
var $fade497bfa6efef0$var$leftStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    minWidth: 0,
    height: 'inherit',
    alignItems: 'center',
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        flexShrink: 0
    }
});
var $fade497bfa6efef0$var$rightStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    alignItems: 'center',
    flexShrink: 0,
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        marginRight: "var(--ds-space-050, 4px)",
        flexShrink: 0
    }
});
var $fade497bfa6efef0$var$analyticsData = {
    attributes: {
        navigationLayer: 'global'
    },
    componentName: 'atlassianNavigation'
};
var $fade497bfa6efef0$export$f66ccb39f60980e5 = function AtlassianNavigation(props) {
    var label = props.label, _props$primaryItems = props.primaryItems, primaryItems = _props$primaryItems === void 0 ? [] : _props$primaryItems, AppSwitcher = props.renderAppSwitcher, create = props.renderCreate, Help = props.renderHelp, Notifications = props.renderNotifications, ProductHome = props.renderProductHome, Profile = props.renderProfile, Search = props.renderSearch, SignIn = props.renderSignIn, Settings = props.renderSettings, _props$moreLabel = props.moreLabel, moreLabel = _props$moreLabel === void 0 ? "\u2026" : _props$moreLabel, _props$theme = props.theme, theme = _props$theme === void 0 ? (0, $4692d5c70ecef3eb$export$164de7ab8df77ef0) : _props$theme, testId = props.testId;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $0cbbe03340c55ac9$export$d8964aec282183a3), {
        value: theme
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $fb54a115516e258d$export$d0a82da1a0b94929), {
        data: $fade497bfa6efef0$var$analyticsData
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("header", {
        style: theme.mode.navigation,
        css: $fade497bfa6efef0$var$containerStyles,
        "data-testid": testId && "".concat(testId, "-header"),
        role: "banner"
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("nav", {
        css: $fade497bfa6efef0$var$leftStyles,
        "aria-label": label
    }, AppSwitcher && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(AppSwitcher, null), ProductHome && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(ProductHome, null), (0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.navigation-v2-no-jank_5yhbd') ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $5b4104c1e6d44b94$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    }) : (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $ae1bddf578a341f7$export$43e704064d596a9e), {
        testId: testId,
        moreLabel: moreLabel,
        items: primaryItems,
        create: create,
        theme: theme
    })), (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        css: $fade497bfa6efef0$var$rightStyles,
        "data-testid": testId && "".concat(testId, "-secondary-actions")
    }, Search && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Search, null), Notifications && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Notifications, null), Help && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Help, null), Settings && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Settings, null), SignIn && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(SignIn, null), Profile && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Profile, null)))));
};
var $fade497bfa6efef0$export$2e2bcd8739ae039 = $fade497bfa6efef0$export$f66ccb39f60980e5;





var $5FkrB = parcelRequire("5FkrB");




var $f4c563dd72a7132a$export$dad497fe1f6e27c0 = function getTag(onClick, href) {
    if (href) return 'a';
    if (onClick) return 'button';
    return 'div';
};


var $4c4e598cd6612632$var$_excluded = [
    "icon",
    "logo",
    "siteTitle",
    "onClick",
    "href",
    "onMouseDown",
    "testId",
    "logoMaxWidth"
];
var $4c4e598cd6612632$var$_css;
var $4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH = '--logo-max-width';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_ACTIVE = '--product-home-color-active';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE = '--product-home-bg-color-active';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE = '--product-home-box-shadow-active';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_FOCUS = '--product-home-color-focus';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS = '--product-home-bg-color-focus';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS = '--product-home-box-shadow-focus';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_HOVER = '--product-home-color-hover';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER = '--product-home-bg-color-hover';
var $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER = '--product-home-box-shadow-hover';
var $4c4e598cd6612632$var$productHomeButtonStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)(($4c4e598cd6612632$var$_css = {
    display: 'flex',
    padding: "var(--ds-space-050, 4px)",
    alignItems: 'center',
    background: 'none',
    border: 0,
    borderRadius: "var(--ds-border-radius, 3px)",
    color: 'inherit',
    cursor: 'pointer',
    '&::-moz-focus-inner': {
        border: 0
    },
    '&:first-of-type': {
        marginLeft: 0
    },
    '&:hover': {
        backgroundColor: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, ")"),
        boxShadow: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, ")"),
        color: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_HOVER, ")")
    },
    '&:active': {
        backgroundColor: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, ")"),
        boxShadow: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, ")"),
        color: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, ")")
    },
    '&:focus-visible': {
        backgroundColor: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, ")"),
        color: "var(".concat($4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_FOCUS, ")"),
        outline: "var(--ds-border-width-outline, 2px)".concat(" solid ", "var(--ds-border-focused, #4C9AFF)")
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    'div&': {
        pointerEvents: 'none'
    }
}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($4c4e598cd6612632$var$_css, "@media (max-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d) - 0.1, "px)"), {
    margin: "0 ".concat("var(--ds-space-100, 8px)")
}), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))($4c4e598cd6612632$var$_css, "@media (min-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d), "px)"), {
    margin: "0 ".concat("var(--ds-space-200, 16px)")
}), $4c4e598cd6612632$var$_css));
var $4c4e598cd6612632$var$productLogoStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    maxWidth: "var(".concat($4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH, ")"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    },
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > span > svg': {
        maxWidth: "var(".concat($4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH, ")")
    }
}, "@media (max-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d) - 0.1, "px)"), {
    display: 'none'
}));
var $4c4e598cd6612632$var$customMaxHeightStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    maxHeight: 28
});
var $4c4e598cd6612632$var$productIconStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({
    // Ensure anything passed into
    // productHome is aligned correctly
    display: 'flex',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '& > *': {
        maxHeight: 24
    }
}, "@media (min-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d), "px)"), {
    display: 'none'
}));
var $4c4e598cd6612632$var$siteTitleStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    // Overridden in PFF styles applied below; consolidate in FF cleanup
    marginRight: "var(--ds-space-050, 4px)",
    marginLeft: "var(--ds-space-050, 4px)",
    paddingRight: "var(--ds-space-200, 16px)",
    alignItems: 'center'
});
// When cleaning up feature flag, these styles can be moved into the above block
var $4c4e598cd6612632$var$featureFlaggedSiteTitleStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)((0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({
    // Under the FF, we've made the site title handle it's spacing, with the
    // PrimaryItemsContainer not needing to worry about its paddingInlineStart.
    // This makes it cleaner for the title styles to appear and disappear with mq's
    marginRight: "var(--ds-space-100, 8px)"
}, "@media (max-width: ".concat((0, $9e0b6f96d7dc4701$export$4033a111ca79977d) - 0.1, "px)"), {
    display: 'none'
}));
/**
 * __Product home__
 *
 * The ProductHome component displays the product visual identity composed of:
 * logo, icon, and optional text. Values for logo and icon are never displayed
 * at the same time, where icon is used only when space is restricted. Should be
 * passed into `AtlassianNavigation`'s `renderProductHome` prop.
 *
 * - [Examples](https://atlassian.design/components/atlassian-navigation/examples#product-home)
 * - [Code](https://atlassian.design/components/atlassian-navigation/code)
 */ var $4c4e598cd6612632$var$ProductHome = function ProductHome(_ref) {
    var _productHomeButtonDyn;
    var Icon = _ref.icon, Logo = _ref.logo, siteTitle = _ref.siteTitle, onClick = _ref.onClick, href = _ref.href, onMouseDown = _ref.onMouseDown, testId = _ref.testId, _ref$logoMaxWidth = _ref.logoMaxWidth, logoMaxWidth = _ref$logoMaxWidth === void 0 ? 260 : _ref$logoMaxWidth, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(_ref, $4c4e598cd6612632$var$_excluded);
    var theme = (0, $063f49374ce1ab43$export$93d4e7f90805808f)();
    var primaryButton = theme.mode.primaryButton;
    var _theme$mode$productHo = theme.mode.productHome, _theme$mode$productHo2 = _theme$mode$productHo.iconColor, iconColor = _theme$mode$productHo2 === void 0 ? 'inherit' : _theme$mode$productHo2, _theme$mode$productHo3 = _theme$mode$productHo.iconGradientStart, iconGradientStart = _theme$mode$productHo3 === void 0 ? 'inherit' : _theme$mode$productHo3, _theme$mode$productHo4 = _theme$mode$productHo.iconGradientStop, iconGradientStop = _theme$mode$productHo4 === void 0 ? 'inherit' : _theme$mode$productHo4, _theme$mode$productHo5 = _theme$mode$productHo.textColor, textColor = _theme$mode$productHo5 === void 0 ? theme.mode.productHome.color : _theme$mode$productHo5;
    var Tag = (0, $f4c563dd72a7132a$export$dad497fe1f6e27c0)(onClick, href);
    var preventFocusRing = function preventFocusRing(e) {
        e.preventDefault();
        onMouseDown && onMouseDown(e);
    };
    var productHomeButtonDynamicStyles = (_productHomeButtonDyn = {}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_ACTIVE, primaryButton.active.color), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_ACTIVE, primaryButton.active.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_ACTIVE, primaryButton.active.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_FOCUS, primaryButton.focus.color), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_FOCUS, primaryButton.focus.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_FOCUS, primaryButton.focus.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_COLOR_HOVER, primaryButton.hover.color), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BACKGROUND_COLOR_HOVER, primaryButton.hover.backgroundColor), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_PRODUCT_HOME_BOX_SHADOW_HOVER, primaryButton.hover.boxShadow), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_productHomeButtonDyn, $4c4e598cd6612632$var$VAR_LOGO_MAX_WIDTH, "".concat(logoMaxWidth, "px")), _productHomeButtonDyn);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $5FkrB.Fragment), null, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Tag, (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        style: productHomeButtonDynamicStyles,
        css: $4c4e598cd6612632$var$productHomeButtonStyles,
        href: href,
        onClick: onClick,
        onMouseDown: preventFocusRing,
        "data-testid": testId && "".concat(testId, "-container")
    }, rest), (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        css: [
            $4c4e598cd6612632$var$customMaxHeightStyles,
            $4c4e598cd6612632$var$productLogoStyles
        ],
        "data-testid": testId && "".concat(testId, "-logo")
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Logo, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor
    })), (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        css: [
            $4c4e598cd6612632$var$customMaxHeightStyles,
            $4c4e598cd6612632$var$productIconStyles
        ],
        "data-testid": testId && "".concat(testId, "-icon")
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(Icon, {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    }))), siteTitle && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
        style: {
            borderRight: theme.mode.productHome.borderRight
        },
        css: [
            $4c4e598cd6612632$var$siteTitleStyles,
            (0, $74654669a87807aa$export$470e5c2be1411c89)('platform.design-system-team.navigation-v2-no-jank_5yhbd') && $4c4e598cd6612632$var$featureFlaggedSiteTitleStyles
        ],
        "data-testid": testId && "".concat(testId, "-site-title")
    }, siteTitle));
};
var $4c4e598cd6612632$export$2e2bcd8739ae039 = $4c4e598cd6612632$var$ProductHome;


/* eslint-disable max-len */ 
var $5FkrB = parcelRequire("5FkrB");

/**
 * These are the default parameters for LogoProps if the user does not specify values.
 */ var $61c2bd5f28c47c3c$export$438460117ae6b7ee = {
    iconColor: 'inherit',
    iconGradientStart: 'inherit',
    iconGradientStop: 'inherit',
    label: '',
    size: 'medium',
    textColor: 'currentColor'
};
var $61c2bd5f28c47c3c$export$c647cb0ee6e282fe = {
    xsmall: 16,
    small: 24,
    medium: 32,
    large: 40,
    xlarge: 48
};
var $61c2bd5f28c47c3c$export$31d7044b7540a6d8 = $61c2bd5f28c47c3c$export$438460117ae6b7ee;


/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $aa1eab89c59a5ddf$export$bbacc3980e0f3029 = function getColorsFromAppearance(appearance) {
    var iconGradientStart, iconGradientStop, iconColor, textColor, atlassianLogoTextColor;
    switch(appearance){
        case 'brand':
            iconGradientStart = (0, $5738e2919e19457f$export$b3de0ae08da2ce64);
            iconGradientStop = (0, $5738e2919e19457f$export$215b7063051591f1);
            iconColor = (0, $5738e2919e19457f$export$215b7063051591f1);
            textColor = "var(--ds-text, ".concat((0, $5738e2919e19457f$export$7d61b15e0da132af), ")");
            // This is only used for the top level Atlassian wordmark (see AtlassianLogo
            // or AtlassianStartLogo for example), and is only different for the Brand
            // appearance - a bold brand color. For other appearances,
            // atlassianLogoTextColor is the same as textColor.
            atlassianLogoTextColor = (0, $5738e2919e19457f$export$b3de0ae08da2ce64);
            break;
        case 'neutral':
            iconGradientStart = (0, $5738e2919e19457f$export$7090862dc3038a9f);
            iconGradientStop = (0, $5738e2919e19457f$export$d6447c357493214f);
            iconColor = (0, $5738e2919e19457f$export$d6447c357493214f);
            textColor = (0, $5738e2919e19457f$export$eece5f492e429f08);
            atlassianLogoTextColor = (0, $5738e2919e19457f$export$eece5f492e429f08);
            break;
        case 'inverse':
            iconGradientStart = (0, $5738e2919e19457f$export$8754fc7e6d8b3000);
            iconGradientStop = (0, $5738e2919e19457f$export$29a4f05edc054374);
            iconColor = (0, $5738e2919e19457f$export$29a4f05edc054374);
            textColor = "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")");
            atlassianLogoTextColor = "var(--ds-text-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")");
            break;
    }
    return {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        atlassianLogoTextColor: atlassianLogoTextColor
    };
};








var $96958b5ae3603ec3$var$_excluded = [
    "label",
    "svg",
    "size",
    "appearance",
    "iconGradientStart",
    "iconGradientStop",
    "iconColor",
    "textColor",
    "testId"
];
var $96958b5ae3603ec3$var$CSS_VAR_COLOR = '--logo-color';
var $96958b5ae3603ec3$var$CSS_VAR_FILL = '--logo-fill';
var $96958b5ae3603ec3$var$baseWrapperStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'inline-block',
    position: 'relative',
    color: "var(".concat($96958b5ae3603ec3$var$CSS_VAR_COLOR, ")"),
    fill: "var(".concat($96958b5ae3603ec3$var$CSS_VAR_FILL, ")"),
    lineHeight: 1,
    userSelect: 'none',
    whiteSpace: 'normal',
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    '> svg': {
        height: '100%',
        fill: 'inherit'
    }
});
var $96958b5ae3603ec3$var$stopColorStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
    stop: {
        stopColor: 'currentColor'
    }
});
var $96958b5ae3603ec3$var$sizeStyles = Object.entries((0, $61c2bd5f28c47c3c$export$c647cb0ee6e282fe)).reduce(function(acc, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_ref, 2), key = _ref2[0], val = _ref2[1];
    acc[key] = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        height: "".concat(val, "px")
    });
    return acc;
}, {});
/**
 * __Wrapper__
 *
 * An internal component used by `@atlaskit/logo` to render logo SVGs with correct styles.
 */ var $96958b5ae3603ec3$var$Wrapper = function Wrapper(_ref3) {
    var _ref4;
    var label = _ref3.label, svg = _ref3.svg, size = _ref3.size, appearance = _ref3.appearance, iconGradientStart = _ref3.iconGradientStart, iconGradientStop = _ref3.iconGradientStop, iconColor = _ref3.iconColor, textColor = _ref3.textColor, userDefinedTestId = _ref3.testId, rest = (0, (/*@__PURE__*/$parcel$interopDefault($1664a63d282a7249$exports)))(_ref3, $96958b5ae3603ec3$var$_excluded);
    var shouldApplyStopColor = iconGradientStart === 'inherit' && iconGradientStop === 'inherit' && appearance === undefined;
    var testId = userDefinedTestId && "".concat(userDefinedTestId, "--wrapper");
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", (0, (/*@__PURE__*/$parcel$interopDefault($ede9a19b7e4a528d$exports)))({
        css: [
            $96958b5ae3603ec3$var$baseWrapperStyles,
            shouldApplyStopColor && $96958b5ae3603ec3$var$stopColorStyles,
            size && $96958b5ae3603ec3$var$sizeStyles[size]
        ],
        "data-testid": testId,
        style: (_ref4 = {}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_ref4, $96958b5ae3603ec3$var$CSS_VAR_COLOR, iconColor), (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(_ref4, $96958b5ae3603ec3$var$CSS_VAR_FILL, textColor), _ref4),
        "aria-label": label ? label : undefined,
        role: label ? 'img' : undefined,
        dangerouslySetInnerHTML: {
            __html: svg
        }
    }, rest));
};
var $96958b5ae3603ec3$export$2e2bcd8739ae039 = $96958b5ae3603ec3$var$Wrapper;


var $3e183359b9aa4f3d$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $e9ce486011a08a46$export$e2a22331486dcca0)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $aa1eab89c59a5ddf$export$bbacc3980e0f3029)(appearance);
    return "\n  <svg viewBox=\"0 0 32 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient id=\"".concat(id, "\" x1=\"14.8402\" y1=\"15.8324\" x2=\"8.6599\" y2=\"26.5369\" gradientUnits=\"userSpaceOnUse\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"0.9228\"></stop>\n      </linearGradient>\n    </defs>\n    <path fill=\"url(#").concat(id, ")\" d=\"M11.6397 14.0398C11.2789 13.643 10.7378 13.679 10.4852 14.148L4.64091 25.8728C4.42446 26.3418 4.74912 26.8829 5.25419 26.8829H13.4074C13.6599 26.8829 13.9125 26.7386 14.0207 26.4861C15.7885 22.8424 14.7061 17.3227 11.6397 14.0398Z\" />\n    <path fill=\"").concat(colors.iconColor, "\" d=\"M15.9343 3.36124C12.6513 8.55622 12.8678 14.2923 15.0324 18.6215C17.1969 22.9506 18.8565 26.2336 18.9647 26.4861C19.0729 26.7386 19.3254 26.8829 19.578 26.8829H27.7312C28.2363 26.8829 28.597 26.3418 28.3445 25.8728C28.3445 25.8728 17.3774 3.93846 17.0887 3.39732C16.8723 2.89225 16.259 2.85618 15.9343 3.36124Z\" />\n  </svg>");
};
var $3e183359b9aa4f3d$export$8a485e2e7ed91e8f = function AtlassianIcon(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor, testId = _ref2.testId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $3e183359b9aa4f3d$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        textColor: textColor,
        size: size,
        testId: testId
    });
};

/* eslint-disable max-len */ 
var $5FkrB = parcelRequire("5FkrB");




var $735e7ad94fc5994f$var$svg = function svg(_ref) {
    var appearance = _ref.appearance, iconGradientStart = _ref.iconGradientStart, iconGradientStop = _ref.iconGradientStop, iconColor = _ref.iconColor, textColor = _ref.textColor;
    var colors = {
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        iconColor: iconColor,
        textColor: textColor,
        // We treat the word "Atlassian" differently to normal product logos, it has a bold brand look
        atlassianLogoTextColor: textColor
    };
    // Will be fixed upon removal of deprecated iconGradientStart and
    // iconGradientStop props, or with React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    var id = (0, $e9ce486011a08a46$export$e2a22331486dcca0)({
        iconGradientStart: iconGradientStop
    });
    if (appearance) colors = (0, $aa1eab89c59a5ddf$export$bbacc3980e0f3029)(appearance);
    return "\n  <svg viewBox=\"0 0 190 32\" height=\"32\" xmlns=\"http://www.w3.org/2000/svg\" focusable=\"false\" aria-hidden=\"true\">\n    <defs>\n      <linearGradient x1=\"99.684716%\" y1=\"15.8138128%\" x2=\"39.8444399%\" y2=\"97.4388388%\" id=\"".concat(id, "\">\n        <stop stop-color=\"").concat(colors.iconGradientStart, "\" ").concat(colors.iconGradientStart === 'inherit' ? 'stop-opacity="0.4"' : '', " offset=\"0%\"></stop>\n        <stop stop-color=\"").concat(colors.iconGradientStop, "\" offset=\"100%\"></stop>\n      </linearGradient>\n    </defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"").concat(colors.atlassianLogoTextColor, "\" >\n      <path fill=\"url(#").concat(id, ")\" d=\"M6.90502605,15.6123193 C6.76436383,15.4302139 6.53773035,15.3340846 6.30742588,15.35884 C6.0771214,15.3835955 5.876643,15.525635 5.7787929,15.7333781 L0.0719979599,27.0218487 C-0.0337056449,27.2310259 -0.0224063827,27.4794358 0.101860917,27.6783741 C0.226128216,27.8773125 0.445645594,27.9984148 0.68202605,27.9984369 L8.62844459,27.9984369 C8.88847261,28.0044096 9.12761649,27.8581627 9.23847268,27.6253781 C10.9526159,24.1210252 9.91378448,18.7926722 6.90502605,15.6123193 Z\"></path>\n      <path fill=\"").concat(colors.iconColor, "\" d=\"M11.0859556,5.33713587 C8.19309829,9.74089822 7.85921851,15.3267488 10.2073011,20.0371359 L14.0383488,27.6176065 C14.1538739,27.8462194 14.3900332,27.9906411 14.6483769,27.9906653 L22.5933685,27.9906653 C22.829749,27.9906431 23.0492663,27.8695408 23.1735336,27.6706025 C23.2978009,27.4716641 23.3091002,27.2232543 23.2033966,27.014077 C23.2033966,27.014077 12.5147056,5.8619594 12.2460792,5.33290058 C12.1377032,5.11315026 11.9118188,4.97410225 11.6646746,4.97500451 C11.4175304,4.97590676 11.1926893,5.11660025 11.0859556,5.33713587 L11.0859556,5.33713587 Z\"></path>\n      <path d=\"M104.2774,14.3919316 C104.2774,17.1872257 105.588069,19.4065198 110.714802,20.3862846 C113.773504,21.0215787 114.414212,21.5100493 114.414212,22.5187551 C114.414212,23.4985198 113.772077,24.1327551 111.617715,24.1327551 C109.013896,24.0864379 106.462135,23.403307 104.189999,22.1442846 L104.189999,26.6972257 C105.733976,27.4465198 107.772754,28.2822846 111.559566,28.2822846 C116.919251,28.2822846 119.045788,25.9175787 119.045788,22.4033434 M119.045788,22.4033434 C119.045788,19.0892257 117.268858,17.5327551 112.25878,16.4668728 C109.491535,15.8615787 108.821574,15.2566375 108.821574,14.3919316 C108.821574,13.297814 109.811889,12.835814 111.646968,12.835814 C113.860906,12.835814 116.045591,13.4986375 118.113622,14.4208728 L118.113622,10.0691081 C116.130615,9.17615406 113.970906,8.73311319 111.792518,8.7724022 C106.840589,8.7724022 104.2774,10.9048728 104.2774,14.3919316\" fill=\"inherit\"></path>\n      <polygon fill=\"inherit\" points=\"173.129997 9.07000017 173.129997 28.0038825 177.20791 28.0038825 177.20791 13.5657649 178.926691 17.3983531 184.694132 28.0038825 189.820865 28.0038825 189.820865 9.07000017 185.742952 9.07000017 185.742952 21.2891766 184.198975 17.7442355 179.567399 9.07000017\"></polygon>\n      <rect fill=\"inherit\" x=\"142.740005\" y=\"9.07000017\" width=\"4.45677247\" height=\"18.9338824\"></rect>\n      <path d=\"M137.600792,22.4033434 C137.600792,19.0892257 135.823862,17.5327551 130.813784,16.4668728 C128.046539,15.8615787 127.376579,15.2566375 127.376579,14.3919316 C127.376579,13.297814 128.366893,12.835814 130.201972,12.835814 C132.41591,12.835814 134.600595,13.4986375 136.668626,14.4208728 L136.668626,10.0691081 C134.685619,9.17615406 132.52591,8.73311319 130.347522,8.7724022 C125.395593,8.7724022 122.832404,10.9048728 122.832404,14.3919316 C122.832404,17.1872257 124.143073,19.4065198 129.269806,20.3862846 C132.328508,21.0215787 132.969216,21.5100493 132.969216,22.5187551 C132.969216,23.4985198 132.327081,24.1327551 130.172719,24.1327551 C127.568901,24.0864379 125.017139,23.403307 122.745003,22.1442846 L122.745003,26.6972257 C124.28898,27.4465198 126.327758,28.2822846 130.11457,28.2822846 C135.474256,28.2822846 137.600792,25.9175787 137.600792,22.4033434\" fill=\"inherit\"></path>\n      <polygon fill=\"inherit\" points=\"69.6599979 9.07000017 69.6599979 28.0038825 78.8204081 28.0038825 80.2627142 23.9115296 74.1456665 23.9115296 74.1456665 9.07000017\"></polygon>\n      <polygon fill=\"inherit\" points=\"51.5549984 9.07000017 51.5549984 13.1620002 56.5069282 13.1620002 56.5069282 28.0038825 60.9925967 28.0038825 60.9925967 13.1620002 66.2941332 13.1620002 66.2941332 9.07000017\"></polygon>\n      <path d=\"M45.0573091,9.07000017 L39.1785647,9.07000017 L32.5050001,28.0038825 L37.6014102,28.0038825 L38.5474889,24.815059 C40.877531,25.4919503 43.3551322,25.4919503 45.6851743,24.815059 L46.6312529,28.0038825 L51.7287333,28.0038825 L45.0573091,9.07000017 Z M42.1177585,21.4007061 C41.287584,21.4006584 40.4616854,21.2831148 39.6651602,21.0516472 L42.1177585,12.7889413 L44.5703569,21.0544708 C43.7736914,21.2849831 42.9477956,21.4015755 42.1177585,21.4007061 L42.1177585,21.4007061 Z\" fill=\"inherit\"></path>\n      <path d=\"M94.6019534,9.07000017 L88.7235658,9.07000017 L82.0500011,28.0038825 L87.1474815,28.0038825 L88.0935601,24.815059 C90.4236023,25.4919503 92.9012034,25.4919503 95.2312455,24.815059 L96.1773242,28.0038825 L101.274805,28.0038825 L94.6019534,9.07000017 Z M91.6627596,21.4007061 C90.8325851,21.4006584 90.0066865,21.2831148 89.2101613,21.0516472 L91.6627596,12.7889413 L94.1153579,21.0544708 C93.3186924,21.2849831 92.4927966,21.4015755 91.6627596,21.4007061 L91.6627596,21.4007061 Z\" fill=\"inherit\"></path>\n      <path d=\"M163.256954,9.07000017 L157.378566,9.07000017 L150.705002,28.0038825 L155.802482,28.0038825 L156.748561,24.815059 C159.078603,25.4919503 161.556204,25.4919503 163.886246,24.815059 L164.832325,28.0038825 L169.930162,28.0038825 L163.256954,9.07000017 Z M160.315977,21.4007061 C159.485802,21.4006584 158.659903,21.2831148 157.863378,21.0516472 L160.315977,12.7889413 L162.768575,21.0544708 C161.971909,21.2849831 161.146014,21.4015755 160.315977,21.4007061 L160.315977,21.4007061 Z\" fill=\"inherit\"></path>\n    </g>\n  </svg>");
};
var $735e7ad94fc5994f$export$765cacec8b0843f3 = function AtlassianLogo(_ref2) {
    var appearance = _ref2.appearance, _ref2$label = _ref2.label, label = _ref2$label === void 0 ? 'Atlassian' : _ref2$label, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).size : _ref2$size, testId = _ref2.testId, _ref2$iconColor = _ref2.iconColor, iconColor = _ref2$iconColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconColor : _ref2$iconColor, _ref2$iconGradientSta = _ref2.iconGradientStart, iconGradientStart = _ref2$iconGradientSta === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconGradientStart : _ref2$iconGradientSta, _ref2$iconGradientSto = _ref2.iconGradientStop, iconGradientStop = _ref2$iconGradientSto === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).iconGradientStop : _ref2$iconGradientSto, _ref2$textColor = _ref2.textColor, textColor = _ref2$textColor === void 0 ? (0, $61c2bd5f28c47c3c$export$438460117ae6b7ee).textColor : _ref2$textColor;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $96958b5ae3603ec3$export$2e2bcd8739ae039), {
        appearance: appearance,
        label: label,
        svg: $735e7ad94fc5994f$var$svg({
            appearance: appearance,
            iconGradientStart: iconGradientStart,
            iconGradientStop: iconGradientStop,
            iconColor: iconColor,
            textColor: textColor
        }),
        iconColor: iconColor,
        iconGradientStart: iconGradientStart,
        iconGradientStop: iconGradientStop,
        size: size,
        testId: testId,
        textColor: textColor
    });
};


const $f8f7c9b561960f4a$var$AtlassianProductHome = ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $4c4e598cd6612632$export$2e2bcd8739ae039), {
        icon: (0, $3e183359b9aa4f3d$export$8a485e2e7ed91e8f),
        logo: (0, $735e7ad94fc5994f$export$765cacec8b0843f3)
    });
const $f8f7c9b561960f4a$export$b8a61e5c71402559 = ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $fade497bfa6efef0$export$f66ccb39f60980e5), {
        label: "site",
        primaryItems: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84), {
                children: "Bifrost"
            }, "BifrostBtn"),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $a8c7121eb827a20e$export$bb3af89fb196520d), {
                children: "Cookies"
            }, "CookiesBtn"),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $a8c7121eb827a20e$export$bb3af89fb196520d), {
                children: "UI"
            }, "UIBtn2"),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84), {
                children: "Repositories"
            }, "RepositoriesBtn"),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e8bdf0e0b15b45e3$export$ac16a6a04d9b7c84), {
                href: "/ssr",
                children: "SSR Baked Cakes"
            }, "SsrBtn")
        ],
        renderProductHome: $f8f7c9b561960f4a$var$AtlassianProductHome
    });



parcelRequire("5FkrB");

const $a44c7a2536e6d1bc$var$Wrapper = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  border: dashed 1px #333;
  padding: 20px;
  background: ${(props)=>props.background};
`;
const $a44c7a2536e6d1bc$var$colorMap = {
    // greenish
    test: 'rgb(134 255 166 / 10%);',
    // blueish
    fallback: 'rgb(134 138 255 / 10%)',
    // yellowish
    other: 'rgb(255 246 134 / 10%)'
};
const $a44c7a2536e6d1bc$var$versionToBgColor = (version)=>{
    const matchedColors = Object.keys($a44c7a2536e6d1bc$var$colorMap).filter((versionKey)=>{
        return version.includes(versionKey);
    }).map((versionKey)=>$a44c7a2536e6d1bc$var$colorMap[versionKey]);
    if (matchedColors.length > 0) return matchedColors[0];
    return 'rgb(255 134 134 / 10%)'; // redish
};
const $a44c7a2536e6d1bc$export$682c179f50ab847d = ()=>{
    const version = "t-aefa28d";
    const background = $a44c7a2536e6d1bc$var$versionToBgColor(version);
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($a44c7a2536e6d1bc$var$Wrapper, {
        background: background,
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("b", {
                children: "App version: "
            }),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                children: version
            })
        ]
    });
};


const $3f8c6c7a2023732b$var$Wrapper = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  width: 800px;
  margin: 50px auto 50px auto;
`;
const $3f8c6c7a2023732b$export$42a852a2b6b56249 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $f8f7c9b561960f4a$export$b8a61e5c71402559), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($3f8c6c7a2023732b$var$Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $a44c7a2536e6d1bc$export$682c179f50ab847d), {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("br", {}),
                    children
                ]
            })
        ]
    });
};


var $568ea384b993a138$exports = {};
$568ea384b993a138$exports = new URL("cookies-history.a2fb9675.jpeg", import.meta.url).toString();


var $133dd0437b987b15$exports = {};
$133dd0437b987b15$exports = new URL("macaroons.ff0f1526.jpeg", import.meta.url).toString();



const $cd782026aa9d5816$var$Wrapper = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  border: 1px solid #333;
  padding: 20px;
  background: rgb(0, 0, 40, 3%);
`;
const $cd782026aa9d5816$export$c8424c4d8ba2150 = ()=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $3f8c6c7a2023732b$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6c9dff951d5063ec$export$23a850224f96ccbb), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($cd782026aa9d5816$var$Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("h2", {
                        children: "Cookies: An Origin Story"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                        className: "banner",
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($568ea384b993a138$exports))),
                            alt: "History"
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("p", {
                        className: "content",
                        children: "A little about the where cookies came from and how they came to be\u2026 But first -- before we get into the origin of cookies -- what exactly are cookies?"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("p", {
                        className: "content",
                        children: "Today\u2019s cookie story is brought to you by Jane, who said this is what she\u2019d like to learn about. If you guys didn\u2019t know, I take requests. I don\u2019t always fill them immediately, but I often write about foods or ingredients I was asked to teach about in here. In this particular case, I asked Jane what she wanted to know about. Thanks, Jane, for our tour of cookies and biscuits today!"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("p", {
                        className: "content",
                        children: "Before we really get into the nuts and bolts of cookies, let\u2019s talk about what cookies are. No one seems really clear about that, and ditto which word should be used for them. Cookies are small, thin cakes. They are generally also sweet, but I have baked cookies that outraged eaters told me were not cookies because they weren\u2019t sweet. These were still cookies. Just not standard American ones."
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                        className: "banner",
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($133dd0437b987b15$exports))),
                            alt: "Marcaroon apparently"
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("p", {
                        className: "content",
                        children: "There\u2019s a reason I\u2019m still talking about macarons and macaroons. Even though many of people seem to pronounce these the same way and think they\u2019re the same thing, this is not the case. I assume these get confused because they\u2019re made similarly and both are gluten-free, but they really are fairly different"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dba17dfd00ae7d8f$export$2e2bcd8739ae039), {
                        to: "/",
                        children: "Back To Home"
                    })
                ]
            })
        ]
    });
};


const $e431900aa6d2f9ec$export$4392f8efcc9c2eae = {
    name: 'about',
    path: '/about',
    exact: true,
    component: (0, $cd782026aa9d5816$export$c8424c4d8ba2150),
    resources: []
};



parcelRequire("5FkrB");

var $fb7b4e90f3581f68$exports = {};
function $fb7b4e90f3581f68$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
$fb7b4e90f3581f68$exports = $fb7b4e90f3581f68$var$_taggedTemplateLiteral, $fb7b4e90f3581f68$exports.__esModule = true, $fb7b4e90f3581f68$exports["default"] = $fb7b4e90f3581f68$exports;



var $5FkrB = parcelRequire("5FkrB");



// eslint-disable-next-line @repo/internal/fs/filename-pattern-match, @atlaskit/design-system/no-deprecated-imports

var $e2d32c51724787d2$export$9a270941bcff7e77 = {
    xsmall: (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)() * 2,
    small: (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)() * 3,
    medium: (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)() * 4,
    large: (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)() * 5,
    xlarge: (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)() * 12,
    xxlarge: (0, $46bf0aae0dfb1de2$export$6d8204c2cb2e06b8)() * 16
};
var $e2d32c51724787d2$export$e6da6efe4d1a5c9b = {
    xsmall: 2,
    small: 2,
    medium: 3,
    large: 3,
    xlarge: 6,
    xxlarge: 12
};
var $e2d32c51724787d2$export$e2bd4c1faded7921 = 2;
var $e2d32c51724787d2$export$89a980dfdf90df51 = 0.9;
var $e2d32c51724787d2$export$3c061e31594ebabe = '--avatar-background-color';
var $e2d32c51724787d2$export$fdc820179f1f9be4 = {
    small: 12,
    medium: 14,
    large: 15,
    xlarge: 18
};
var $e2d32c51724787d2$export$382610e783aa2ae8 = {
    small: 0,
    medium: 0,
    large: 1,
    xlarge: 7
};


/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match


var $b3471526f53d532d$var$baseStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'block',
    margin: "var(--ds-space-0, 0px)",
    color: "var(--ds-text, ".concat((0, $5738e2919e19457f$export$fbda843f0a27fe96), ")")
});
var $b3471526f53d532d$var$truncateStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
var $b3471526f53d532d$var$secondaryStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    color: "var(--ds-text-subtlest, ".concat((0, $5738e2919e19457f$export$f563ee71e9ee74cd), ")"),
    fontSize: '0.85em'
});
/**
 * __Text__
 *
 * Text is used internally only.
 */ var $b3471526f53d532d$var$Text = function Text(_ref) {
    var isSecondary = _ref.isSecondary, children = _ref.children, shouldTruncate = _ref.shouldTruncate;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: [
            $b3471526f53d532d$var$baseStyles,
            isSecondary && $b3471526f53d532d$var$secondaryStyles,
            shouldTruncate && $b3471526f53d532d$var$truncateStyles
        ]
    }, children);
};
var $b3471526f53d532d$export$2e2bcd8739ae039 = $b3471526f53d532d$var$Text;


// eslint-disable-next-line @repo/internal/fs/filename-pattern-match
var $b7ee0964e61b12d9$export$60113ebe1cf0ecf = function getLinkProps(href, target) {
    return {
        href: href,
        rel: target === '_blank' ? 'noopener noreferrer' : null,
        target: target
    };
};
var $b7ee0964e61b12d9$export$cca6f1bef43616d3 = function getButtonProps(onClick) {
    return {
        type: 'button',
        onClick: onClick
    };
};
var $b7ee0964e61b12d9$export$83ee468102cdf04c = function getCustomElement(isDisabled, href, onClick) {
    if (href && !isDisabled) return 'a';
    if (onClick || isDisabled) return 'button';
    return 'span';
};


var $5207d043ac3d2569$var$_templateObject;
function $5207d043ac3d2569$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5207d043ac3d2569$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5207d043ac3d2569$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5207d043ac3d2569$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5207d043ac3d2569$var$avatarItemStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    minWidth: 0,
    maxWidth: '100%',
    flex: '1 1 100%',
    lineHeight: '1.4',
    paddingInlineStart: "var(--ds-space-100, 8px)"
});
var $5207d043ac3d2569$var$getStyles = function getStyles(css, _ref) {
    var backgroundColor = _ref.backgroundColor, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($5207d043ac3d2569$var$_templateObject || ($5207d043ac3d2569$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($fb7b4e90f3581f68$exports)))([
        "\n    align-items: center;\n    background-color: ",
        ";\n    border-radius: ",
        "px;\n    border: ",
        "px solid transparent;\n    box-sizing: border-box;\n    color: inherit;\n    display: flex;\n    font-size: inherit;\n    font-style: normal;\n    font-weight: normal;\n    line-height: 1;\n    outline: none;\n    margin: ",
        ";\n    padding: ",
        ";\n    text-align: left;\n    text-decoration: none;\n    width: 100%;\n\n    ",
        "\n\n    ",
        "\n  "
    ])), backgroundColor, (0, $46bf0aae0dfb1de2$export$7a57f79000377ca2)(), (0, $e2d32c51724787d2$export$e2bd4c1faded7921), "var(--ds-space-0, 0px)", "var(--ds-space-050, 4px)", isInteractive && "\n        :hover {\n          background-color: ".concat("var(--ds-background-neutral-subtle-hovered, ".concat((0, $5738e2919e19457f$export$3e51e8f1440314ba), ")"), ";\n          cursor: pointer;\n          text-decoration: none;\n        }\n\n        :focus {\n          outline: none;\n          border-color: ", "var(--ds-border-focused, ".concat((0, $5738e2919e19457f$export$215b7063051591f1), ")"), ";\n        }\n\n        :active {\n          background-color: ", "var(--ds-background-neutral-subtle-pressed, ".concat((0, $5738e2919e19457f$export$226de0355ed012f8), ")"), ";\n        }\n      "), isDisabled && "\n        cursor: not-allowed;\n        opacity: ".concat("var(--ds-opacity-disabled, 0.5)", ";\n        pointer-events: none;\n      "));
};
/**
 * __Avatar item__
 *
 * An avatar item is a wrapper that goes around an avatar when it's displayed alongside text, such as a name or status.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-item/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-item/code)
 */ var $5207d043ac3d2569$var$AvatarItem = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var avatar = _ref2.avatar, _ref2$backgroundColor = _ref2.backgroundColor, backgroundColor = _ref2$backgroundColor === void 0 ? 'transparent' : _ref2$backgroundColor, children = _ref2.children, isTruncationDisabled = _ref2.isTruncationDisabled, href = _ref2.href, isDisabled = _ref2.isDisabled, onClick = _ref2.onClick, primaryText = _ref2.primaryText, secondaryText = _ref2.secondaryText, target = _ref2.target, testId = _ref2.testId, label = _ref2.label;
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            'data-testid': "".concat(testId, "--itemInner")
        } : {
            testId: "".concat(testId, "--itemInner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $5207d043ac3d2569$var$_objectSpread($5207d043ac3d2569$var$_objectSpread({}, href && (0, $b7ee0964e61b12d9$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $b7ee0964e61b12d9$export$cca6f1bef43616d3)(onClick) : {
            onClick: onClick
        });
    };
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8), null, function(_ref3) {
        var css = _ref3.css;
        var props = $5207d043ac3d2569$var$_objectSpread($5207d043ac3d2569$var$_objectSpread($5207d043ac3d2569$var$_objectSpread($5207d043ac3d2569$var$_objectSpread({
            ref: ref,
            className: $5207d043ac3d2569$var$getStyles(css, {
                backgroundColor: backgroundColor,
                isInteractive: Boolean(onClick || href),
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (onClick || href) && {
            'aria-label': label
        }), {}, {
            children: (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $5FkrB.Fragment), null, avatar, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("div", {
                css: $5207d043ac3d2569$var$avatarItemStyles
            }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $b3471526f53d532d$export$2e2bcd8739ae039), {
                shouldTruncate: !isTruncationDisabled
            }, primaryText), (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $b3471526f53d532d$export$2e2bcd8739ae039), {
                isSecondary: true,
                shouldTruncate: !isTruncationDisabled
            }, secondaryText)))
        });
        return children ? children(props) : /*#__PURE__*/ (0, $5FkrB.createElement)((0, $b7ee0964e61b12d9$export$83ee468102cdf04c)(isDisabled, href, onClick), props);
    });
});
$5207d043ac3d2569$var$AvatarItem.displayName = 'AvatarItem';
var $5207d043ac3d2569$export$2e2bcd8739ae039 = $5207d043ac3d2569$var$AvatarItem;




var $5FkrB = parcelRequire("5FkrB");







var $5FkrB = parcelRequire("5FkrB");

var $4a4d29a29390b2ae$exports = {};
"use strict";
Object.defineProperty($4a4d29a29390b2ae$exports, "__esModule", {
    value: true
});
$4a4d29a29390b2ae$exports.default = void 0;

var $4a4d29a29390b2ae$var$_react = $4a4d29a29390b2ae$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $4a4d29a29390b2ae$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $4a4d29a29390b2ae$var$PersonIcon = (props)=>/*#__PURE__*/ $4a4d29a29390b2ae$var$_react.default.createElement($21888af2d2e194e9$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"/><circle cx="12" cy="7" r="4"/></g></svg>`
    }, props));
$4a4d29a29390b2ae$var$PersonIcon.displayName = 'PersonIcon';
var $4a4d29a29390b2ae$var$_default = $4a4d29a29390b2ae$var$PersonIcon;
$4a4d29a29390b2ae$exports.default = $4a4d29a29390b2ae$var$_default;


var $880de5cd8580e66c$exports = {};
"use strict";
Object.defineProperty($880de5cd8580e66c$exports, "__esModule", {
    value: true
});
$880de5cd8580e66c$exports.default = void 0;

var $880de5cd8580e66c$var$_react = $880de5cd8580e66c$var$_interopRequireDefault((parcelRequire("5FkrB")));

function $880de5cd8580e66c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const $880de5cd8580e66c$var$ShipIcon = (props)=>/*#__PURE__*/ $880de5cd8580e66c$var$_react.default.createElement($21888af2d2e194e9$export$f04a61298a47a40f, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentColor" fill-rule="evenodd"><path d="M6 12h8v-2H6v2zM4 8.99C4 8.445 4.456 8 5.002 8h9.996C15.55 8 16 8.451 16 8.99V14H4V8.99z" fill-rule="nonzero"/><path d="M6 7.005C6 5.898 6.898 5 7.998 5h2.004C11.106 5 12 5.894 12 7.005V10H6V7.005zm4 0V7H7.999c.005 0 .002.003.002.005V8h2v-.995z"/><path d="M4.5 17h13.994l1.002-3H4.14l.36 3zm-2.495-4.012A.862.862 0 012.883 12h18.393c.55 0 .857.417.681.944l-1.707 5.112c-.174.521-.758.944-1.315.944H3.725a1.149 1.149 0 01-1.118-.988l-.602-5.024z" fill-rule="nonzero"/></g></svg>`
    }, props));
$880de5cd8580e66c$var$ShipIcon.displayName = 'ShipIcon';
var $880de5cd8580e66c$var$_default = $880de5cd8580e66c$var$ShipIcon;
$880de5cd8580e66c$exports.default = $880de5cd8580e66c$var$_default;




function $4c43fa344e499ff8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4c43fa344e499ff8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4c43fa344e499ff8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4c43fa344e499ff8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $4c43fa344e499ff8$export$ebe0b8fe8b6acbfd = "var(--ds-icon-inverse, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")");
var $4c43fa344e499ff8$export$72502e51aebdd94e = "var(--ds-icon-subtle, ".concat((0, $5738e2919e19457f$export$7c87d337fb91a97d), ")");
var $4c43fa344e499ff8$var$avatarDefaultIconStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: $4c43fa344e499ff8$export$72502e51aebdd94e
});
var $4c43fa344e499ff8$var$nestedAvatarStyles = Object.entries((0, $e2d32c51724787d2$export$9a270941bcff7e77)).reduce(function(styles, _ref) {
    var _ref2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_ref, 2), key = _ref2[0], size = _ref2[1];
    return $4c43fa344e499ff8$var$_objectSpread($4c43fa344e499ff8$var$_objectSpread({}, styles), {}, (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))({}, key, (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
        '& svg': {
            width: "".concat(size, "px"),
            height: "".concat(size, "px")
        }
    })));
}, {});
var $4c43fa344e499ff8$var$avatarImageStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    width: '100%',
    height: '100%',
    flex: '1 1 100%'
});
/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */ var $4c43fa344e499ff8$var$AvatarImage = function AvatarImage(_ref3) {
    var _ref3$alt = _ref3.alt, alt = _ref3$alt === void 0 ? '' : _ref3$alt, src = _ref3.src, appearance = _ref3.appearance, size = _ref3.size, testId = _ref3.testId;
    var _useState = (0, $5FkrB.useState)(false), _useState2 = (0, (/*@__PURE__*/$parcel$interopDefault($dd10e4fe59ebf2c1$exports)))(_useState, 2), hasImageErrored = _useState2[0], setHasImageErrored = _useState2[1];
    var borderRadius = appearance === 'circle' ? '50%' : "".concat((0, $e2d32c51724787d2$export$e6da6efe4d1a5c9b)[size], "px");
    var isHidden = !alt ? true : undefined;
    // If src changes, reset state
    (0, $5FkrB.useEffect)(function() {
        setHasImageErrored(false);
    }, [
        src
    ]);
    if (!src || hasImageErrored) return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: [
            $4c43fa344e499ff8$var$avatarDefaultIconStyles,
            $4c43fa344e499ff8$var$nestedAvatarStyles[size]
        ]
    }, appearance === 'circle' ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($4a4d29a29390b2ae$exports))), {
        label: alt,
        primaryColor: $4c43fa344e499ff8$export$ebe0b8fe8b6acbfd,
        secondaryColor: $4c43fa344e499ff8$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--person"),
        "aria-hidden": isHidden
    }) : (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, (/*@__PURE__*/$parcel$interopDefault($880de5cd8580e66c$exports))), {
        label: alt,
        primaryColor: $4c43fa344e499ff8$export$ebe0b8fe8b6acbfd,
        secondaryColor: $4c43fa344e499ff8$export$72502e51aebdd94e,
        testId: testId && "".concat(testId, "--ship"),
        "aria-hidden": isHidden
    }));
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("img", {
        src: src,
        alt: alt,
        "data-testid": testId && "".concat(testId, "--image"),
        css: $4c43fa344e499ff8$var$avatarImageStyles,
        style: {
            borderRadius: borderRadius
        },
        onError: function onError() {
            return setHasImageErrored(true);
        },
        "aria-hidden": isHidden
    });
};
var $4c43fa344e499ff8$export$2e2bcd8739ae039 = $4c43fa344e499ff8$var$AvatarImage;



// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5FkrB = parcelRequire("5FkrB");


/** @jsx jsx */ // eslint-disable-next-line @repo/internal/fs/filename-pattern-match



var $a4956755bb3835e5$var$iconWrapperStyles = (0, $1bbaca91e5cf6bc9$export$dbf350e5966cf602)({
    display: 'flex',
    boxSizing: 'border-box',
    width: '100%',
    height: '100%',
    alignItems: 'center',
    alignContent: 'center',
    borderRadius: "var(--ds-border-radius-circle, 50%)",
    overflow: 'hidden'
});
/**
 * __Icon wrapper__
 *
 * An icon wrapper is used internally only.
 */ var $a4956755bb3835e5$var$IconWrapper = function IconWrapper(_ref) {
    var _ref$bgColor = _ref.bgColor, bgColor = _ref$bgColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")") : _ref$bgColor, children = _ref.children;
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        css: $a4956755bb3835e5$var$iconWrapperStyles,
        role: "presentation",
        style: {
            border: "".concat((0, $e2d32c51724787d2$export$e2bd4c1faded7921), "px solid ").concat(bgColor),
            backgroundColor: bgColor
        }
    }, children);
};
var $a4956755bb3835e5$export$2e2bcd8739ae039 = $a4956755bb3835e5$var$IconWrapper;


var $cb40f4e389081e0e$var$BusyIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $5738e2919e19457f$export$4a7404f376229999), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
    d: "M3.3,1.9l2.8,2.8c0.2,0.2,0.2,0.5,0,0.7L5.4,6.1c-0.2,0.2-0.5,0.2-0.7,0L1.9,3.3c-0.2-0.2-0.2-0.5,0-0.7l0.7-0.7C2.8,1.7,3.1,1.7,3.3,1.9z"
}));
var $cb40f4e389081e0e$var$FocusIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-icon-discovery, ".concat((0, $5738e2919e19457f$export$b48405b95304b5a1), ")"),
    d: "M4,8 C1.790861,8 0,6.209139 0,4 C0,1.790861 1.790861,0 4,0 C6.209139,0 8,1.790861 8,4 C8,6.209139 6.209139,8 4,8 Z M4,6.66666667 C5.47275933,6.66666667 6.66666667,5.47275933 6.66666667,4 C6.66666667,2.52724067 5.47275933,1.33333333 4,1.33333333 C2.52724067,1.33333333 1.33333333,2.52724067 1.33333333,4 C1.33333333,5.47275933 2.52724067,6.66666667 4,6.66666667 Z M4,5.33333333 C3.26362033,5.33333333 2.66666667,4.73637967 2.66666667,4 C2.66666667,3.26362033 3.26362033,2.66666667 4,2.66666667 C4.73637967,2.66666667 5.33333333,3.26362033 5.33333333,4 C5.33333333,4.73637967 4.73637967,5.33333333 4,5.33333333 Z"
}));
var $cb40f4e389081e0e$var$OfflineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-text-subtlest, ".concat((0, $5738e2919e19457f$export$f563ee71e9ee74cd), ")"),
    d: "M4,8 C6.209139,8 8,6.209139 8,4 C8,1.790861 6.209139,0 4,0 C1.790861,0 0,1.790861 0,4 C0,6.209139 1.790861,8 4,8 Z M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$1ce2d1575d444ceb), ")"),
    d: "M4,6 C5.1045695,6 6,5.1045695 6,4 C6,2.8954305 5.1045695,2 4,2 C2.8954305,2 2,2.8954305 2,4 C2,5.1045695 2.8954305,6 4,6 Z"
}));
var $cb40f4e389081e0e$var$OnlineIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $5738e2919e19457f$export$940e1f69e873f202), ")"),
    cx: "4",
    cy: "4",
    r: "4"
});
function $cb40f4e389081e0e$var$getPresence(presence) {
    switch(presence){
        case 'busy':
            return $cb40f4e389081e0e$var$BusyIndicator;
        case 'focus':
            return $cb40f4e389081e0e$var$FocusIndicator;
        case 'offline':
            return $cb40f4e389081e0e$var$OfflineIndicator;
        case 'online':
            return $cb40f4e389081e0e$var$OnlineIndicator;
    }
}
/**
 * A presence shows an avatar’s availability.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-presence/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-presence/code)
 * - [Usage](https://atlassian.design/components/avatar/avatar-presence/usage).
 */ var $cb40f4e389081e0e$var$AvatarPresence = function AvatarPresence(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, presence = _ref.presence;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4956755bb3835e5$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, presence ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $cb40f4e389081e0e$var$getPresence(presence)) : children);
};
var $cb40f4e389081e0e$export$2e2bcd8739ae039 = $cb40f4e389081e0e$var$AvatarPresence;
var $cb40f4e389081e0e$export$972c5e90200fa0ef = function PresenceWrapper(_ref2) {
    var size = _ref2.size, appearance = _ref2.appearance, children = _ref2.children, borderColor = _ref2.borderColor, presence = _ref2.presence, testId = _ref2.testId;
    var position = appearance === 'square' ? -4 : (0, $e2d32c51724787d2$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--presence"),
        style: {
            pointerEvents: 'none',
            position: 'absolute',
            bottom: "".concat(position, "px"),
            height: "".concat((0, $e2d32c51724787d2$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            width: "".concat((0, $e2d32c51724787d2$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($cb40f4e389081e0e$var$AvatarPresence, {
        borderColor: borderColor,
        presence: !children ? presence : undefined
    }, children));
};


// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $5FkrB = parcelRequire("5FkrB");



var $4249ad42d81065fd$var$ApprovedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-success, ".concat((0, $5738e2919e19457f$export$a49394138f7b8e85), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
    d: "M2.47140452,3.52859548 C2.21105499,3.26824595 1.78894501,3.26824595 1.52859548,3.52859548 C1.26824595,3.78894501 1.26824595,4.21105499 1.52859548,4.47140452 L2.86192881,5.80473785 C3.12227834,6.06508738 3.54438833,6.06508738 3.80473785,5.80473785 L6.47140452,3.13807119 C6.73175405,2.87772166 6.73175405,2.45561167 6.47140452,2.19526215 C6.21105499,1.93491262 5.78894501,1.93491262 5.52859548,2.19526215 L3.33333333,4.39052429 L2.47140452,3.52859548 Z"
}));
var $4249ad42d81065fd$var$DeclinedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-icon-danger, ".concat((0, $5738e2919e19457f$export$2010d0fb4295b346), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"),
    d: "M4.890661,4.0088336 L5.81806461,3.07802178 C6.06167933,2.83351177 6.06048933,2.43826992 5.81540668,2.19522442 C5.57032402,1.95217891 5.17415651,1.95336612 4.93054179,2.19787613 L4.00765946,3.12415007 L3.06906871,2.18377143 C2.82523777,1.93947602 2.42906937,1.93863765 2.18420182,2.18189887 C1.93933427,2.42516008 1.93849394,2.82040282 2.18232488,3.06469822 L3.12544091,4.00961077 L2.20275024,4.93569234 C1.95913552,5.18020236 1.96032551,5.5754442 2.20540817,5.81848971 C2.45049083,6.06153521 2.84665833,6.060348 3.09027306,5.81583799 L4.00844245,4.89429431 L4.9092123,5.79678001 C5.15304324,6.04107541 5.54921164,6.04191379 5.79407919,5.79865257 C6.03894674,5.55539135 6.03978708,5.16014862 5.79595614,4.91585321 L4.890661,4.0088336 Z"
}));
var $4249ad42d81065fd$var$LockedIndicator = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $5FkrB.Fragment), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("circle", {
    fill: "var(--ds-text-subtlest, ".concat((0, $5738e2919e19457f$export$1ce2d1575d444ceb), ")"),
    cx: "4",
    cy: "4",
    r: "4"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("path", {
    fill: "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$c39c0fe0f26207ae), ")"),
    d: "M4.13074827,1.21766493 L4.10368158,1.21766493 C3.36340745,1.21766493 2.76388015,1.80793503 2.76388015,2.5367787 L2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,2.54344089 C3.44054754,2.17901906 3.74031119,1.88388401 4.11044825,1.88388401 L4.1239816,1.88388401 C4.49411866,1.88388401 4.79388232,2.17901906 4.79388232,2.54344089 L4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,2.5367787 C5.47054971,1.80793503 4.8710224,1.21766493 4.13074827,1.21766493 M2.76388015,3.21632216 L3.44054754,3.21632216 L3.44054754,3.88254123 L2.76388015,3.88254123 L2.76388015,3.21632216 Z M4.79388232,3.21632216 L5.47054971,3.21632216 L5.47054971,3.88254123 L4.79388232,3.88254123 L4.79388232,3.21632216 Z M4.79401765,3.88254123 L3.44068287,3.88254123 L2.76401548,3.88254123 C2.39049508,3.88254123 2.08734809,4.18100738 2.08734809,4.54876031 L2.08734809,5.54808892 C2.08734809,6.10000287 2.53735205,6.54741753 3.09094491,6.54741753 L5.14375561,6.54741753 C5.69802683,6.54741753 6.14735243,6.10385072 6.14735243,5.54808892 L6.14735243,4.54876031 C6.14735243,4.18100738 5.84420544,3.88254123 5.47068504,3.88254123 L4.79401765,3.88254123 Z"
}));
function $4249ad42d81065fd$var$getStatus(status) {
    switch(status){
        case 'approved':
            return $4249ad42d81065fd$var$ApprovedIndicator;
        case 'declined':
            return $4249ad42d81065fd$var$DeclinedIndicator;
        case 'locked':
            return $4249ad42d81065fd$var$LockedIndicator;
    }
}
/**
 * An avatar status shows contextual information, such as if someone approves or declines something.
 *
 * - [Examples](https://atlassian.design/components/avatar/avatar-status/examples)
 * - [Code](https://atlassian.design/components/avatar/avatar-status/code).
 */ var $4249ad42d81065fd$var$AvatarStatus = function AvatarStatus(_ref) {
    var borderColor = _ref.borderColor, children = _ref.children, status = _ref.status;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement((0, $a4956755bb3835e5$export$2e2bcd8739ae039), {
        bgColor: borderColor
    }, status ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("svg", {
        height: "100%",
        version: "1.1",
        viewBox: "0 0 8 8",
        width: "100%",
        xmlns: "http://www.w3.org/2000/svg"
    }, $4249ad42d81065fd$var$getStatus(status)) : children);
};
var $4249ad42d81065fd$export$2e2bcd8739ae039 = $4249ad42d81065fd$var$AvatarStatus;
var $4249ad42d81065fd$export$8045894f255f9726 = function StatusWrapper(_ref2) {
    var size = _ref2.size, status = _ref2.status, appearance = _ref2.appearance, borderColor = _ref2.borderColor, children = _ref2.children, testId = _ref2.testId;
    var position = appearance === 'square' ? 0 : (0, $e2d32c51724787d2$export$382610e783aa2ae8)[size];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement("span", {
        "aria-hidden": "true",
        "data-testid": testId && "".concat(testId, "--status"),
        style: {
            position: 'absolute',
            height: "".concat((0, $e2d32c51724787d2$export$fdc820179f1f9be4)[size], "px"),
            right: "".concat(position, "px"),
            top: "".concat(position, "px"),
            width: "".concat((0, $e2d32c51724787d2$export$fdc820179f1f9be4)[size], "px")
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5FkrB))).createElement($4249ad42d81065fd$var$AvatarStatus, {
        borderColor: borderColor,
        status: !children ? status : undefined
    }, children));
};



var $74274c840266cbd1$var$_templateObject;
function $74274c840266cbd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $74274c840266cbd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $74274c840266cbd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, (/*@__PURE__*/$parcel$interopDefault($184e64fa7279c0f0$exports)))(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $74274c840266cbd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $74274c840266cbd1$var$packageName = "@atlaskit/avatar";
var $74274c840266cbd1$var$packageVersion = "21.4.6";
// eslint-disable-next-line @repo/internal/react/consistent-types-definitions
var $74274c840266cbd1$var$getStyles = function getStyles(css, _ref) {
    var size = _ref.size, radius = _ref.radius, appearance = _ref.appearance, _ref$borderColor = _ref.borderColor, borderColor = _ref$borderColor === void 0 ? "var(--ds-surface-overlay, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")") : _ref$borderColor, stackIndex = _ref.stackIndex, isInteractive = _ref.isInteractive, isDisabled = _ref.isDisabled;
    return css($74274c840266cbd1$var$_templateObject || ($74274c840266cbd1$var$_templateObject = (0, (/*@__PURE__*/$parcel$interopDefault($fb7b4e90f3581f68$exports)))([
        "\n    height: ",
        "px;\n    width: ",
        "px;\n    align-items: stretch;\n    background-color: ",
        ";\n    border-radius: ",
        ";\n    box-sizing: content-box;\n    cursor: inherit;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    outline: none;\n    overflow: hidden;\n    position: static;\n    transform: translateZ(0);\n    transition: transform 200ms, opacity 200ms;\n    box-shadow: 0 0 0 ",
        "px ",
        ";\n    border: none;\n    margin: ",
        ";\n    padding: ",
        ";\n\n    /* Added font-size and font-family styles to fix alignment issue in firefox for interactive button avatar */\n    font-size: inherit;\n    font-family: inherit;\n\n    &::-moz-focus-inner {\n      border: 0;\n      margin: ",
        ";\n      padding: ",
        ";\n    }\n\n    &::after {\n      background-color: transparent;\n      inset: 0px;\n\n      /* Added border-radius style to fix hover issue in safari */\n      border-radius: ",
        ";\n      content: ' ';\n      opacity: 0;\n      pointer-events: none;\n      position: absolute;\n      transition: opacity 200ms;\n      width: 100%;\n    }\n\n    ",
        "\n\n    ",
        "\n\n    ",
        "\n  "
    ])), size, size, borderColor, appearance === 'circle' ? '50%' : "".concat(radius, "px"), (0, $e2d32c51724787d2$export$e2bd4c1faded7921), borderColor, "var(--ds-space-025, 2px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", "var(--ds-space-0, 0px)", appearance === 'circle' ? '50%' : "".concat(radius, "px"), stackIndex && "position: relative;", isInteractive && "\n      cursor: pointer;\n\n      :focus {\n        outline: none;\n        box-shadow: 0 0 0 ".concat((0, $e2d32c51724787d2$export$e2bd4c1faded7921), "px ", "var(--ds-border-focused, ".concat((0, $5738e2919e19457f$export$e62e8919cca44969), ")"), "\n      }\n\n      :hover {\n        &::after {\n          background-color: ", "var(--ds-interaction-hovered, ".concat((0, $5738e2919e19457f$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        &::after {\n          background-color: ", "var(--ds-interaction-pressed, ".concat((0, $5738e2919e19457f$export$6e5e7499ff054f6d), ")"), ";\n          opacity: 1;\n        }\n      }\n\n      :active {\n        transform: scale(").concat((0, $e2d32c51724787d2$export$89a980dfdf90df51), ");\n      }\n\n      @media screen and (forced-colors: active) {\n        &:focus-visible {\n          outline: 1px solid\n        }\n      }\n    "), isDisabled && "\n        cursor: not-allowed;\n\n        &::after {\n          opacity: ".concat("var(--ds-opacity-disabled, 0.7)", ";\n          pointer-events: none;\n          background-color: ", "var(--ds-surface, ".concat((0, $5738e2919e19457f$export$29a4f05edc054374), ")"), ";\n        }\n      "));
};
/**
 * An avatar is a visual representation of a user or entity.
 *
 * - [Examples](https://atlassian.design/components/avatar/examples)
 * - [Code](https://atlassian.design/components/avatar/code)
 * - [Usage](https://atlassian.design/components/avatar/usage).
 */ var $74274c840266cbd1$var$Avatar = /*#__PURE__*/ (0, $5FkrB.forwardRef)(function(_ref2, ref) {
    var analyticsContext = _ref2.analyticsContext, _ref2$appearance = _ref2.appearance, appearance = _ref2$appearance === void 0 ? 'circle' : _ref2$appearance, label = _ref2.label, borderColor = _ref2.borderColor, children = _ref2.children, href = _ref2.href, isDisabled = _ref2.isDisabled, name = _ref2.name, onClick = _ref2.onClick, presence = _ref2.presence, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? 'medium' : _ref2$size, src = _ref2.src, stackIndex = _ref2.stackIndex, status = _ref2.status, target = _ref2.target, testId = _ref2.testId, _ref2$as = _ref2.as, AvatarContainer = _ref2$as === void 0 ? 'div' : _ref2$as;
    var _useAnalyticsEvents = (0, $879f28ba40c47674$export$5bf35293e545f20c)(), createAnalyticsEvent = _useAnalyticsEvents.createAnalyticsEvent;
    var customPresenceNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(presence) ? presence : null;
    var customStatusNode = /*#__PURE__*/ (0, $5FkrB.isValidElement)(status) ? status : null;
    var isValidIconSize = size !== 'xxlarge' && size !== 'xsmall';
    var lastAnalytics = (0, $5FkrB.useRef)(analyticsContext);
    var uuid = (0, $8120b68af314e225$export$bb5ca5fba6fb4f1f)()('avatar');
    (0, $5FkrB.useEffect)(function() {
        lastAnalytics.current = analyticsContext;
    }, [
        analyticsContext
    ]);
    var onClickHandler = (0, $5FkrB.useCallback)(function(event) {
        if (isDisabled || typeof onClick !== 'function') return;
        var analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'avatar',
            attributes: {
                componentName: 'avatar',
                packageName: $74274c840266cbd1$var$packageName,
                packageVersion: $74274c840266cbd1$var$packageVersion
            }
        });
        /**
     * To avoid wrapping this component in AnalyticsContext we manually
     * push the parent context's meta data into the context.
     */ var context = $74274c840266cbd1$var$_objectSpread({
            componentName: 'avatar',
            packageName: $74274c840266cbd1$var$packageName,
            packageVersion: $74274c840266cbd1$var$packageVersion
        }, lastAnalytics.current);
        analyticsEvent.context.push(context);
        /**
     * Replicating the logic in the `withAnalyticsEvents` HOC.
     */ var clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        onClick(event, analyticsEvent);
    }, [
        createAnalyticsEvent,
        isDisabled,
        onClick
    ]);
    var getTestId = function getTestId(testId, children) {
        return !children ? {
            'data-testid': "".concat(testId, "--inner")
        } : {
            testId: "".concat(testId, "--inner")
        };
    };
    var componentProps = function componentProps() {
        if (isDisabled) return {
            disabled: true
        };
        // return only relevant props for either anchor or button elements
        return $74274c840266cbd1$var$_objectSpread($74274c840266cbd1$var$_objectSpread({}, href && (0, $b7ee0964e61b12d9$export$60113ebe1cf0ecf)(href, target)), onClick && !href ? (0, $b7ee0964e61b12d9$export$cca6f1bef43616d3)(onClickHandler) : {
            onClick: onClick
        });
    };
    var isPresence = isValidIconSize && presence && !status;
    var isStatus = isValidIconSize && status;
    // add presence or status to the label by default if presence and status are passed as a string
    // if status or presence are nodes this is not added to the label by default
    var defaultLabel = [
        name,
        isStatus && !customStatusNode && "(".concat(status, ")"),
        isPresence && !customPresenceNode && "(".concat(presence, ")")
    ].filter(Boolean).join(' ');
    var isInteractive = onClick || href || isDisabled;
    var containerShouldBeImage = Boolean(!isInteractive && defaultLabel);
    return (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)(AvatarContainer, {
        "data-testid": testId,
        role: containerShouldBeImage ? 'img' : undefined,
        "aria-labelledby": containerShouldBeImage ? "".concat(uuid, "-label") : undefined,
        style: {
            display: 'inline-block',
            position: 'relative',
            outline: 0,
            zIndex: stackIndex
        }
    }, (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $1bbaca91e5cf6bc9$export$9b9c0f9d9f3552b8), null, function(_ref3) {
        var css = _ref3.css;
        var props = $74274c840266cbd1$var$_objectSpread($74274c840266cbd1$var$_objectSpread($74274c840266cbd1$var$_objectSpread($74274c840266cbd1$var$_objectSpread({
            className: $74274c840266cbd1$var$getStyles(css, {
                size: (0, $e2d32c51724787d2$export$9a270941bcff7e77)[size],
                radius: (0, $e2d32c51724787d2$export$e6da6efe4d1a5c9b)[size],
                appearance: appearance,
                borderColor: borderColor,
                stackIndex: stackIndex,
                isInteractive: Boolean(href || onClick) && !isDisabled,
                isDisabled: isDisabled
            })
        }, componentProps()), testId && getTestId(testId, children)), (isInteractive || children) && {
            'aria-label': label || defaultLabel
        }), {}, {
            children: (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $4c43fa344e499ff8$export$2e2bcd8739ae039), {
                alt: !containerShouldBeImage && src ? name : undefined,
                appearance: appearance,
                size: size,
                src: src,
                testId: testId
            }),
            ref: ref
        });
        return children ? children(props) : /*#__PURE__*/ (0, $5FkrB.createElement)((0, $b7ee0964e61b12d9$export$83ee468102cdf04c)(isDisabled, href, onClick), props);
    }), isPresence && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $cb40f4e389081e0e$export$972c5e90200fa0ef), {
        appearance: appearance,
        size: size,
        presence: typeof presence === 'string' ? presence : undefined,
        testId: testId
    }, customPresenceNode), isStatus && (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)((0, $4249ad42d81065fd$export$8045894f255f9726), {
        appearance: appearance,
        size: size,
        borderColor: borderColor,
        status: typeof status === 'string' ? status : undefined,
        testId: testId
    }, customStatusNode), containerShouldBeImage ? (0, $1bbaca91e5cf6bc9$export$c8a8987d4410bf2d)("span", {
        id: "".concat(uuid, "-label"),
        hidden: true
    }, defaultLabel) : undefined);
});
$74274c840266cbd1$var$Avatar.displayName = 'Avatar';
var $74274c840266cbd1$export$2e2bcd8739ae039 = $74274c840266cbd1$var$Avatar;






var $4ed15b582fcfec66$exports = {};
$4ed15b582fcfec66$exports = new URL("cookies-lover.60ddb270.gif", import.meta.url).toString();


var $a42a8102f0ef89bb$exports = {};
$a42a8102f0ef89bb$exports = new URL("recipes-cookies-1.7b3434f9.jpeg", import.meta.url).toString();


var $1e3a5e6a3e93b5b0$exports = {};
$1e3a5e6a3e93b5b0$exports = new URL("recipes-cookies-2.3482d22c.jpeg", import.meta.url).toString();


var $f7d9b0052cd7590b$exports = {};
$f7d9b0052cd7590b$exports = new URL("recipes-cookies-3.684ec5b1.jpeg", import.meta.url).toString();


var $3563cf8a5a8dc2a8$exports = {};
$3563cf8a5a8dc2a8$exports = new URL("recipes-cookies-4.a625a530.jpeg", import.meta.url).toString();


var $7724c871fb68757d$exports = {};
$7724c871fb68757d$exports = new URL("recipes-cookies-5.f342ae46.jpeg", import.meta.url).toString();



const $469116626a9ec898$var$Wrapper = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  border: 1px solid #333;
  padding: 20px;
  background: rgb(0, 0, 40, 3%);
`;
const $469116626a9ec898$export$b94310965bed44e6 = ()=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $3f8c6c7a2023732b$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6c9dff951d5063ec$export$23a850224f96ccbb), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($469116626a9ec898$var$Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("h2", {
                        children: "How to bake your cookies"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $5207d043ac3d2569$export$2e2bcd8739ae039), {
                            avatar: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $74274c840266cbd1$export$2e2bcd8739ae039), {
                                presence: "online",
                                label: "Jack (online)"
                            }),
                            primaryText: "Jack"
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                        className: "banner",
                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($4ed15b582fcfec66$exports))),
                            alt: "Cookie Lover"
                        })
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                        className: "recipeIngredients",
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("h2", {
                                children: "Ingredients"
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                                className: "rdpIngredients",
                                children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "2 1/4"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "cups Gold Medal\u2122 all-purpose flour"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "teaspoon"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "baking soda"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "1/2"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "teaspoon"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "salt"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "cup"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "butter, softened "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "3/4"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "cup"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "granulated sugar "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "3/4"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "cup"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "packed brown sugar "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "egg "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "teaspoon"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "vanilla "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "2"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "cups"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "semisweet chocolate chips "
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("li", {
                                            className: "ingredient",
                                            children: [
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "quantity",
                                                    children: "1"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "unitOfMeasure",
                                                    children: "cup"
                                                }),
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("span", {
                                                    className: "description",
                                                    children: "coarsely chopped nuts, if desired"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                        className: "rdpSteps",
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("h2", {
                                children: "Steps"
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("ul", {
                                className: "recipeSteps",
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("li", {
                                        className: "recipeStep",
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                                            className: "stepDescription",
                                            children: [
                                                "1. Heat oven to 375\xb0F. In small bowl, mix flour, baking soda and salt; set aside.",
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                                                    className: "stepShotContainer",
                                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                                                        className: "lazyImage",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($a42a8102f0ef89bb$exports))),
                                                        alt: "Step 1"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("li", {
                                        className: "recipeStep",
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                                            className: "stepDescription",
                                            children: [
                                                "2.In large bowl, beat softened butter and sugars with electric mixer on medium speed, or mix with spoon about 1 minute or until fluffy, scraping side of bowl occasionally.",
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                                                    className: "stepShotContainer",
                                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                                                        className: "lazyImage",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($1e3a5e6a3e93b5b0$exports))),
                                                        alt: "Step 2"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("li", {
                                        className: "recipeStep",
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                                            className: "stepDescription",
                                            children: [
                                                "3. Beat in egg and vanilla until smooth. Stir in flour mixture just until blended (dough will be stiff). Stir in chocolate chips and nuts.",
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                                                    className: "stepShotContainer",
                                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                                                        className: "lazyImage",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($f7d9b0052cd7590b$exports))),
                                                        alt: "Step 3"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("li", {
                                        className: "recipeStep",
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                                            className: "stepDescription",
                                            children: [
                                                "4. Onto ungreased cookie sheets, drop dough by rounded tablespoonfuls 2 inches apart.",
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                                                    className: "stepShotContainer",
                                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                                                        className: "lazyImage",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($3563cf8a5a8dc2a8$exports))),
                                                        alt: "Step 4"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("li", {
                                        className: "recipeStep",
                                        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)("div", {
                                            className: "stepDescription",
                                            children: [
                                                "5. Bake 8 to 10 minutes or until light brown (centers will be soft). Cool 2 minutes; remove from cookie sheet to cooling rack. Cool completely, about 30 minutes. Store covered in airtight container.",
                                                /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("div", {
                                                    className: "stepShotContainer",
                                                    children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("img", {
                                                        className: "lazyImage",
                                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($7724c871fb68757d$exports))),
                                                        alt: "Step 5"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("br", {}),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $dba17dfd00ae7d8f$export$2e2bcd8739ae039), {
                        to: "/about",
                        children: "About the Cookies History"
                    })
                ]
            })
        ]
    });
};


const $4b0d2c34f0df68d2$export$c344a3deb8f83e2f = {
    name: 'home',
    path: '/',
    component: (0, $469116626a9ec898$export$b94310965bed44e6),
    resources: []
};



parcelRequire("5FkrB");



const $4b625651049329a7$var$Wrapper = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  border: 1px solid #333;
  padding: 20px;
  background: rgb(0, 0, 40, 3%);
`;
const $4b625651049329a7$var$CardGrid = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 20px;
`;
const $4b625651049329a7$var$CardRow = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).div`
  display: flex;
  gap: 20px;
`;
const $4b625651049329a7$var$Card = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).a`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex: 1;
  padding: 30px 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background: #fff;
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    border-color: #0052cc;
    color: #0052cc;
  }
`;
const $4b625651049329a7$var$Emoji = (0, $33e6c02704dbf3f8$export$2e2bcd8739ae039).span`
  font-size: 40px;
  margin-bottom: 12px;
`;
const $4b625651049329a7$var$baseUrl = ()=>window.location.origin;
const $4b625651049329a7$export$7ed5dc0038c81cec = ()=>/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)((0, $3f8c6c7a2023732b$export$42a852a2b6b56249), {
        children: [
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $6c9dff951d5063ec$export$23a850224f96ccbb), {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Wrapper, {
                children: [
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("h2", {
                        children: "\uD83C\uDF82 Baked Cakes: Our Server-Side Rendered Pages"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)("p", {
                        children: "Select an SSR experience below to try it out:"
                    }),
                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardGrid, {
                        children: [
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/async-init`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDE80"
                                            }),
                                            "Async Init"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/proxy`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDD01"
                                            }),
                                            "Atlassian Proxy"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/auth-headers`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDD10"
                                            }),
                                            "Auth Headers"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/bad-bundle`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDC94"
                                            }),
                                            "Test Broken Bundle"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/base-url`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDD17"
                                            }),
                                            "Base URL"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/feature-gate`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDEA9"
                                            }),
                                            "Feature Gate"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/fetch`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83C\uDF10"
                                            }),
                                            "Simple Fetch"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/flakey`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83C\uDFB2"
                                            }),
                                            "Flakey SSR Test"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/graphql-gateway`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDD00"
                                            }),
                                            "GraphQL Gateway Test"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/kv`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDDC4\uFE0F"
                                            }),
                                            "KV API"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/load?amount=5&time=1000`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDEA6"
                                            }),
                                            "Load Shedding"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/service-to-service`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDCF1\uD83D\uDD04\uD83D\uDCF1"
                                            }),
                                            "Service-to-Service Test"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/ssr-context`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDD0D"
                                            }),
                                            "SSR Context"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/hello_ssr_world`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDC4B"
                                            }),
                                            "Hello SSR World"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$CardRow, {
                                children: [
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/stargate`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\u2B50\u26E9\uFE0F"
                                            }),
                                            "Stargate Test"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsxs)($4b625651049329a7$var$Card, {
                                        href: `${$4b625651049329a7$var$baseUrl()}/ssr/window-location`,
                                        children: [
                                            /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)($4b625651049329a7$var$Emoji, {
                                                children: "\uD83D\uDCCD"
                                            }),
                                            "Window Location"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });


const $0e6ba4c1c5072955$export$2b274a81415272ba = {
    name: 'ssr',
    path: '/ssr',
    exact: true,
    component: (0, $4b625651049329a7$export$7ed5dc0038c81cec),
    resources: []
};


const $18d4ef78d8315a8f$export$66b32f6f30eb4b4 = [
    (0, $e431900aa6d2f9ec$export$4392f8efcc9c2eae),
    (0, $0e6ba4c1c5072955$export$2b274a81415272ba),
    (0, $4b0d2c34f0df68d2$export$c344a3deb8f83e2f)
];


const $e98237a5968290d6$export$86fbec116b87613f = ()=>{
    return /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $ddc1dbf2b1f7581e$export$55185c17a0fcbe46), {
        routes: (0, $18d4ef78d8315a8f$export$66b32f6f30eb4b4),
        history: (0, $c29d101a2cf08ade$export$719fc203c4e16dee)(),
        children: /*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $56c1ff970910c658$export$7903e4b73fc7d6c3), {})
    });
};


window.__hash__ = "t-aefa28d";
try {
    $72c0e238230eba33$export$2cd8252107eb640b({
        // From https://atlassian-2y.sentry.io/settings/projects/bifrost-cookies-ui/keys/
        dsn: 'https://630bbbf19730eb8559519d4b11f1364e@o55978.ingest.us.sentry.io/4507304393048064',
        integrations: [
            $390327a76f6922be$export$b4109253475213e9(),
            $ca970ce8cf2750a2$export$d7706faf7ab354bf()
        ],
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        release: "t-aefa28d" ?? 'unknown'
    });
} catch (e) {
    console.error(e);
}
const $bc019185b0e5ecba$var$mountNode = document.getElementById('app');
$7d59b24134129acf$exports.render(/*#__PURE__*/ (0, $faf30355a80342e4$exports.jsx)((0, $e98237a5968290d6$export$86fbec116b87613f), {}), $bc019185b0e5ecba$var$mountNode);


//# sourceMappingURL=index.c2a101e8.js.map
